/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _index = __webpack_require__(1);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(2);

	var _index4 = _interopRequireDefault(_index3);

	var _index5 = __webpack_require__(3);

	var _index6 = _interopRequireDefault(_index5);

	var _env = __webpack_require__(4);

	var _env2 = _interopRequireDefault(_env);

	var _auth = __webpack_require__(5);

	var _auth2 = _interopRequireDefault(_auth);

	var _components = __webpack_require__(11);

	var _components2 = _interopRequireDefault(_components);

	var _resources = __webpack_require__(20);

	var _resources2 = _interopRequireDefault(_resources);

	var _admin = __webpack_require__(42);

	var _admin2 = _interopRequireDefault(_admin);

	var _helper = __webpack_require__(129);

	var _helper2 = _interopRequireDefault(_helper);

	var _sentry = __webpack_require__(130);

	var _sentry2 = _interopRequireDefault(_sentry);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// Resources
	//import Users from './resources/users.resource';

	//import common from './common/common'

	// Services
	/* global moment:false, _:false */
	/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "[mod]" }] */

	angular.module('queue-manager', ['ngAnimate', 'ngCookies', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ngMaterial', 'toastr', 'pascalprecht.translate', 'ngStorage', 'ngWebSocket', 'chart.js', 'ngMaterialSidemenu', 'ngTable', 'ls.LiveSet', 'ls.ChangeStream', 'color.picker',
	// modules
	'mod.env', 'mod.auth', '720kb.datepicker', 'naif.base64', 'colorpicker.module',
	// Owner
	'mod.resources', 'mod.admin', _sentry2.default, _components2.default, 'ngSentry']).filter('trustUrl', ["$sce", function ($sce) {
	  return function (url) {
	    return $sce.trustAsResourceUrl(url);
	  };
	}]).constant('moment', moment).constant('_', _).config(_index2.default).config(_index4.default).config(["$provide", function ($provide) {
	  $provide.decorator('ColorPickerOptions', ["$delegate", function ($delegate) {
	    var options = angular.copy($delegate);
	    options.round = true;
	    options.alpha = false;
	    options.format = 'hexString';
	    return options;
	  }]);
	}]).config(["$mdDateLocaleProvider", function ($mdDateLocaleProvider) {
	  $mdDateLocaleProvider.formatDate = function (date) {
	    var lang = localStorage.qm_preferredLanguage ? localStorage.qm_preferredLanguage : 'en';
	    var m = moment(date);
	    m.locale(lang);
	    return m.format('DD-MMM-YYYY');
	  };
	}]).run(_index6.default)
	// .service('Users', Users)

	.service('HelperService', _helper2.default)

	//Hasta que se termine de migrar el nuevo front
	.config(["$sceDelegateProvider", function ($sceDelegateProvider) {
	  $sceDelegateProvider.resourceUrlWhitelist(['self', // Permite URLs del mismo origen
	  'http://localhost:3000/**', 'https://pre-frontend.bookthecity.app/**', 'https://frontend.bookthecity.app/**'
	  // Permite URLs específicas
	  ]);
	}]);

	// Modules

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	appConfig.$inject = ["$logProvider", "toastrConfig", "$translateProvider", "$mdThemingProvider", "$localStorageProvider", "config", "$compileProvider", "$mdDateLocaleProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appConfig;

	/** @ngInject */

	function appConfig($logProvider, toastrConfig, $translateProvider, $mdThemingProvider, $localStorageProvider, config, $compileProvider, $mdDateLocaleProvider) {
	  // Enable log
	  $logProvider.debugEnabled(config.DEBUG_ENABLED);

	  // $templateFactoryProvider.shouldUnsafelyUseHttp(true);
	  // $resourceProvider.defaults.stripTrailingSlashes = false;

	  // Storage config
	  $localStorageProvider.setKeyPrefix('qm_');

	  // Pretchel Translate
	  $translateProvider.useStaticFilesLoader({
	    prefix: 'assets/i18n/',
	    suffix: '.json'
	  });
	  $translateProvider.registerAvailableLanguageKeys(['es', 'en', 'fr'], {
	    'es': 'es',
	    'es-ES': 'es',
	    'en': 'en',
	    'en-*': 'en',
	    'fr': 'fr'
	  });
	  $translateProvider.preferredLanguage('es');
	  $translateProvider.useLocalStorage();
	  $translateProvider.usePostCompiling(true);
	  $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

	  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension):/);

	  // Set options third-party lib
	  toastrConfig.allowHtml = true;
	  toastrConfig.timeOut = 3000;
	  toastrConfig.maxOpened = 3;
	  toastrConfig.positionClass = 'toast-top-right';
	  toastrConfig.preventDuplicates = false;
	  toastrConfig.progressBar = true;
	  toastrConfig.closeButton = false;

	  // Example of a Spanish localization.
	  $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
	  $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
	  $mdDateLocaleProvider.days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
	  $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
	  // Can change week display to start on Monday.
	  $mdDateLocaleProvider.firstDayOfWeek = 1;

	  // material theming and colors
	  // red, pink, purple, deep-purple, indigo, blue, light-blue, cyan, teal, green, light-green, lime, yellow, amber, orange, deep-orange, brown, grey, blue-grey

	  $mdThemingProvider.theme('default').primaryPalette('green').accentPalette('orange').warnPalette('red');
	  //.backgroundPalette('green');
	}

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	routeConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routeConfig;

	/** @ngInject */

	function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
	  $locationProvider.html5Mode(true);
	  // .hashPrefix('!');

	  $urlRouterProvider.otherwise('/');

	  /**
	   * Se definen 4 rutas principales
	   * app: Inicio por defecto es la página de login
	   * queue: incluye counter(Pantallas) y request(totems)
	   * list
	   */
	  $stateProvider
	  // Dashboard component
	  .state('login', {
	    url: '/',
	    templateUrl: 'app/modules/auth/pages/login.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	    // resolve: {
	    //   skipIfLoggedIn: AuthService.skipIfLoggedIn
	    // }
	  }).state('login-e', {
	    url: '/login-e',
	    templateUrl: 'app/modules/auth/pages/login-e.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	    // resolve: {
	    //   skipIfLoggedIn: AuthService.skipIfLoggedIn
	    // }
	  }).state('app', {
	    abstract: true,
	    template: '<app class="full-height"></app>'
	  })

	  // Statistics comparative
	  .state('app.supervisor', {
	    url: '/supervisor',
	    template: '<supervisor></supervisor>'
	  })

	  // administrator
	  .state('app.administration', {
	    abstract: true,
	    template: '<administration layout flex></administration>'
	  }).state('app.administration.organizations', {
	    url: '/administration/organizations',
	    template: '<organizations></organizations>'
	  }).state('app.administration.establishments', {
	    url: '/administration/establishments',
	    template: '<establishments></establishments>'
	  }).state('app.administration.users', {
	    url: '/administration/users',
	    template: '<users></users>'
	  }).state('app.administration.validateUsers', {
	    url: '/administration/validateUsers',
	    template: '<validate_users></validate_users>'
	  }).state('app.administration.kiosks', {
	    url: '/administration/kiosks',
	    template: '<kiosks></kiosks>'
	  }).state('app.administration.consumers', {
	    url: '/administration/consumers',
	    template: '<consumers></consumers>'
	  }).state('app.administration.screens', {
	    url: '/administration/screens',
	    template: '<screens></screens>'
	  }).state('app.administration.profile', {
	    url: '/administration/profile',
	    template: '<profile></profile>'
	  }).state('app.administration.priorities', {
	    url: '/administration/priorities',
	    template: '<priorities></priorities>'
	  }).state('app.administration.waitingareas', {
	    url: '/administration/waitingareas',
	    template: '<waitingareas></waitingareas>'
	  }).state('app.administration.services', {
	    url: '/administration/services',
	    template: '<services></services>'
	  }).state('app.administration.support', {
	    url: '/administration/support',
	    template: '<support></support>'
	  }).state('app.administration.booking', {
	    url: '/administration/booking',
	    template: '<booking></booking>'
	  }).state('app.administration.campaignes', {
	    url: '/administration/campaignes',
	    template: '<campaignes></campaignes>'
	  }).state('app.administration.agendas', {
	    url: '/administration/agendas',
	    template: '<agendas></agendas>'
	  }).state('app.administration.journal', {
	    url: '/administration/new-agendas',
	    template: '<journal></journal>'
	  })

	  // Statistics
	  .state('app.statistics', {
	    abstract: true,
	    template: '<statistics></statistics>'
	  })
	  // Statistics center
	  .state('app.statistics.center', {
	    url: '/statistics/center',
	    template: '<center></center>'
	  })
	  // Statistics comparative
	  .state('app.statistics.comparative', {
	    url: '/statistics/comparative',
	    template: '<comparative></comparative>'
	  })

	  //Nuevas estadísticas con el nuevo front
	  .state('app.statistics.new', {
	    url: '/statistics/new-statistics',
	    template: '<new></new>'
	  })

	  // Statistics comparative
	  .state('app.panels', {
	    url: '/panels',
	    template: '<panels></panels>'
	  });
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	runBlock.$inject = ["$log", "$rootScope", "$state", "$auth"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = runBlock;

	/** @ngInject */

	function runBlock($log, $rootScope, $state, $auth) {
	  $log.info('Application is ready!');

	  $rootScope.$on('$stateChangeSuccess', function (event, toState) {
	    if (!$auth.isAuthenticated() && toState.name !== 'login' && toState.name.substr(0, 3) === 'app') {
	      event.preventDefault();
	      $state.go('login');
	    }
	    if (!$auth.isAuthenticated() && (toState.name === 'code' || toState.name === 'panels')) {
	      event.preventDefault();
	      window.location = '/';
	    }
	  });
	}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//Angular configuration generated based on env.config.yaml file
	exports.default = angular.module("mod.env", []).constant("config", {
	  "NEW_FRONT": "https://frontend.bookthecity.app",
	  "DEBUG_ENABLED": false,
	  "ADMIN_ROLES": ["ROOT", "SUPERADMIN", "ADMIN"],
	  "SHOW_NAME": ["ROOT", "SUPERADMIN", "ADMIN", "WORKER"],
	  "IS_PRE": false,
	  "SUPERVISOR_REFRESH": 10,
	  "SHOW_ADMIN": false,
	  "VERSION": "1.0.0",
	  "api": {
	    "BASE_URL": "https://api.bookthecity.app/api",
	    "BASE_NEW_URL": "https://api-gateway.boostworker.ai/api-bookthecity/v2/api",
	    "GENERATE_KONG_TOKEN": "https://api-gateway.boostworker.ai/api-bookthecity/v1",
	    "BASE_URL_KIOSK": "https://request.bookthecity.app",
	    "BASE_URL_KIOSK_ONLINE": "https://request-online.bookthecity.app",
	    "BASE_URL_WORKSTATION": "https://consumer.bookthecity.app",
	    "WEBSOCKET_URL": "https://api.bookthecity.app",
	    "BASE_URL_SCREEN": "https://counter.bookthecity.app",
	    "DSN": "https://c27d2ebd1938412d8a3389fdd8445af2@o227410.ingest.sentry.io/4504886980837376",
	    "URL_ONBOARDING": "https://onboarding.bookthecity.app"
	  },
	  "kong_token": {
	    "KONG_CLIENT_ID": "j8ud2Rd3m26zPXcPnz7P3yMSIpu5WLmN",
	    "KONG_CLIENT_SECRET": "xxzuwBJXhFyRwpgYT1L6dwll8qKNZhss",
	    "KONG_GRANT_TYPE": "client_credentials",
	    "KONG_SCOPE": "read"
	  }
	});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _auth = __webpack_require__(6);

	var _auth2 = _interopRequireDefault(_auth);

	var _auth3 = __webpack_require__(7);

	var _auth4 = _interopRequireDefault(_auth3);

	var _auth5 = __webpack_require__(8);

	var _auth6 = _interopRequireDefault(_auth5);

	var _auth7 = __webpack_require__(9);

	var _auth8 = _interopRequireDefault(_auth7);

	var _auth9 = __webpack_require__(10);

	var _auth10 = _interopRequireDefault(_auth9);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	angular.module('mod.auth', ['satellizer']).config(_auth2.default).config(_auth4.default).run(_auth6.default).controller('AuthController', _auth8.default).factory('AuthService', _auth10.default);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	appConfig.$inject = ["$authProvider", "config"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appConfig;

	/** @ngInject */

	function appConfig($authProvider, config) {

	  //$authProvider.withCredentials = false;
	  $authProvider.tokenPrefix = 'auth';
	  $authProvider.baseUrl = config.api.BASE_URL;
	  $authProvider.loginUrl = '/employees/login';
	  $authProvider.logoutUrl = '/employees/logout';
	  $authProvider.tokenType = '';
	  //$httpProvider.interceptors.push('ExpiredInterceptor');
	}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	routeConfig.$inject = ["$stateProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routeConfig;

	/** @ngInject */

	function routeConfig($stateProvider) {

	  $stateProvider.state('logout', {
	    url: '/logout',
	    templateUrl: 'app/modules/auth/pages/redirect.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	  }).state('expired', {
	    controller: 'AuthController',
	    controllerAs: 'vm'
	  }).state('unauthorized', {
	    templateUrl: 'app/modules/auth/pages/unauthorized.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	  }).state('notfound', {
	    templateUrl: 'app/modules/auth/pages/notfound.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	  }).state('panels', {
	    url: '/panels',
	    templateUrl: 'app/modules/auth/pages/panels.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	  }).state('code', {
	    url: '/code',
	    templateUrl: 'app/modules/auth/pages/code.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	  }).state('verify', {
	    url: '/verify',
	    templateUrl: 'app/modules/auth/pages/verify.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	  }).state('reset-password', {
	    url: '/reset-password',
	    templateUrl: 'app/modules/auth/pages/reset-password.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	  }).state('recover-password', {
	    url: '/recover-password',
	    templateUrl: 'app/modules/admin/recover-password/recover-password.html',
	    controller: 'AuthController',
	    controllerAs: 'vm'
	  });
	}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	runBlock.$inject = ["$log", "$auth", "AuthService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = runBlock;

	/* @ngInject */

	function runBlock($log, $auth, AuthService) {

	  $log.info('mod.auth is ready.');

	  if ($auth.isAuthenticated()) {
	    AuthService.loadCurrentData();
	  }
	}

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	AuthController.$inject = ["$rootScope", "$state", "$log", "toastr", "AuthService", "AdministrationService", "$translate", "$stateParams", "AuthResource", "$localStorage", "config", "ScreensResource", "$mdDialog", "EstablishmentsResource", "OrganizationsResource", "KiosksResource", "$scope", "CodeResource", "Users"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	exports.default = AuthController;

	/* @ngInject */

	function AuthController($rootScope, $state, $log, toastr, AuthService, AdministrationService, $translate, $stateParams, AuthResource, $localStorage, config, ScreensResource, $mdDialog, EstablishmentsResource, OrganizationsResource, KiosksResource, $scope, CodeResource, Users) {

	  var vm = this;
	  this.$translate = $translate;
	  this.$rootScope = $rootScope;
	  this.config = config;
	  this.window = window;
	  vm.AuthResource = AuthResource;
	  vm.ScreensResource = ScreensResource;
	  vm.version = 'v ' + this.config.VERSION;
	  vm.bkg = 'f6d1d1';
	  vm.bkgService = 'DB4849';
	  vm.tabs = [{ title: 'Widget Turnos', value: 'turnos' }, { title: 'Widget Citas', value: 'citas' }];
	  vm.activeTab = 0;
	  vm.previousTab = null;
	  vm.width = 100;
	  vm.height = 100;
	  vm.Users = Users;
	  vm.grecaptcha = this.window.grecaptcha;
	  vm.config = config;
	  // Variable version list consumer
	  vm.isList = 'false';
	  var savedIsListVar = $stateParams.isList == 'true' ? 'true' : $localStorage.isList;
	  vm.isList = $stateParams.isList == 'true' || $stateParams.isList != 'true' && savedIsListVar == 'true' ? 'true' : ' false';

	  vm.activeTab = vm.tabs[1].value;

	  this.$translate.use(this.window.navigator.language).then(function () {}).catch(function (error) {
	    console.log(error);
	    vm.$translate.use('es');
	  });

	  vm.credentials = {};
	  vm._showPass = _showPass;
	  vm._show = false;
	  vm.typeInput = 'password';
	  vm.backOffice = backOffice;
	  vm.Screen = Screen;
	  vm.WorkStation = WorkStation;
	  vm.logout = logout;
	  vm.loadCode = loadCode;
	  vm.changeColor = changeColor;
	  vm.copyCode = copyCode;
	  vm.BASE_URL_HOST = this.config.api.BASE_URL_SCREEN;
	  vm.BASE_URLS = this.config.api;
	  vm.$scope = $scope;
	  vm.EstablishmentsResource = EstablishmentsResource;
	  vm.OrganizationsResource = OrganizationsResource;
	  vm.CodeResource = CodeResource;
	  vm.KiosksResource = KiosksResource;
	  vm.establishments = [];
	  vm.kiosks = [];
	  vm.queuetypes = [];
	  vm.establishmentSelected = {};
	  vm.kioskSelected = {};
	  vm.userSelected = {};
	  vm.currentEstablishment = '';
	  vm.establishmentId = '';
	  vm.establishmentInUse = '';
	  vm.errPass = false;
	  vm.errMail = false;
	  vm.confirmPassword = false;
	  vm.linkPreviewData = {};
	  vm.turns = [];

	  var valores = window.location.search;
	  var urlParams = new URLSearchParams(valores);
	  vm.token = urlParams.get('access_token');
	  vm.userId = urlParams.get('userId');

	  activate();
	  vm.BASE_URL_SCREEN = config.api.BASE_URL_SCREEN;
	  vm.getKiosksByEstablishment = getKiosksByEstablishment;
	  vm.getQueueTypeByKiosk = getQueueTypeByKiosk;
	  vm.kioskChanged = kioskChanged;
	  vm._selectUser = _selectUser;

	  if (window.location.pathname.split('/')[1].includes('code')) {
	    loadEstablishments();
	  }

	  if ($localStorage.currentAllLocations && $localStorage.currentAllLocations.length > 0) {
	    vm.allLocations = $localStorage.currentAllLocations;
	  } else if ($localStorage.currentUser && $localStorage.currentUser.location) {
	    // En caso de usuarios antiguos con sólo un location
	    vm.allLocations = [{
	      id: $localStorage.currentUser.location.id,
	      name: $localStorage.currentUser.location.name,
	      organization: $localStorage.currentUser.location.organization
	    }];
	  }

	  function activate() {
	    if ('logout' === $state.current.name) {
	      logout();
	    }
	  }

	  function _showPass() {
	    vm.show = !vm.show;
	  }

	  function backOffice() {
	    toastr.success('Buscando Kiosco...', ' Loading');
	    var location = localStorage.getItem('qm_currentLocation');
	    var isFlag = JSON.parse(location).isFromRegister;
	    var urlParams = new URLSearchParams(window.location.search);
	    var id = urlParams.get('id');
	    var token = urlParams.get('auth_token');
	    var idLcation = JSON.parse(location).id;
	    vm.EstablishmentsResource.getDevicesByEstablishment({ 'id': idLcation, 'type': 'kiosks' }).$promise.then(function (result) {
	      var qm_kioskId = result[0].id;
	      if (isFlag) {
	        if (qm_kioskId !== null || qm_kioskId !== undefined) {
	          var auth_token = localStorage.getItem('auth_token');
	          window.open('https://pre-request-react.waima.es/kiosk/' + qm_kioskId + '?auth_token=' + auth_token + '&color=f6d1d1&colorService=DB4849&type=widget');
	          return;
	        }
	        return toastr.error('No se encontro kiosco asignado', 'Error');
	      } else {
	        window.open(config.api.BASE_URL_KIOSK + '/?id=' + id + '&auth_token=' + token, '_blank');
	      }
	    }).catch(function (error) {
	      console.log(error);
	      $translate('app.kiosks.ERROR_GETBYESTABLISHMENT').then(function (errorMsg) {
	        toastr.error(errorMsg, 'Error');
	      });
	    });
	  }

	  function WorkStation() {
	    var urlParams = new URLSearchParams(window.location.search);
	    var id = urlParams.get('id');
	    var token = urlParams.get('auth_token');
	    window.open(config.api.BASE_URL_WORKSTATION + '/?id=' + id + '&auth_token=' + token + '&preview=true', '_blank');
	  }

	  function registerNav() {
	    window.open(config.api.URL_ONBOARDING);
	  }

	  function Screen() {
	    var _this = this;

	    var urlParams = new URLSearchParams(window.location.search);
	    var id = urlParams.get('location');

	    ScreensResource.getScreensByEstablishment({ id: id }).$promise.then(function (result) {
	      console.log('result.getByLocation', result.getByLocation);
	      vm.kioskos = result.getByLocation;
	      if (vm.kioskos.length > 0) {
	        vm.kioskos.map(function (kiosko) {
	          ScreensResource.getTurns({ id: kiosko.id, columns: kiosko.rows }).$promise.then(function (result) {
	            console.log('result', result.getTurns);
	            var md_display_1 = document.getElementsByClassName('md-display-1');
	            console.log('md_display_1', md_display_1);
	            if (md_display_1 !== null && md_display_1.length > 0) {
	              md_display_1.style.fontSize = '1.5rem';
	            }
	            vm.turns = result.getTurns;
	            for (var i = 0; i < vm.turns.length; i++) {
	              vm.turns[i].color = kiosko.colors[i];
	            }
	          }).catch(function (error) {
	            console.log(error);
	          });
	        });
	      }
	      showModal();
	    }).catch(function (error) {
	      console.log(error);
	      _this.noScreens = true;
	    });
	  }

	  function copyText(id) {
	    var text = config.api.BASE_URL_SCREEN + '/counter/screen/' + id + '/column';
	    var elementoTemporal = document.createElement("textarea");
	    elementoTemporal.value = text;

	    document.body.appendChild(elementoTemporal);

	    elementoTemporal.select();

	    document.execCommand("copy");

	    document.body.removeChild(elementoTemporal);
	  }

	  function showModal(ev) {
	    var _this2 = this;

	    $mdDialog.show({
	      preserveScope: true, // do not forget this if use parent scope
	      hasBackdrop: true,
	      contentElement: '#myDialog',
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      controller: function controller() {
	        return _this2;
	      },
	      controllerAs: 'ctrl',
	      clickOutsideToClose: true
	    }).then(function () {
	      console.log('You resolve the dialog.');
	    }, function () {
	      console.log('You cancelled the dialog.');
	    });
	  }

	  function showModal2(ev) {
	    var _this3 = this;

	    $mdDialog.show({
	      preserveScope: true, // do not forget this if use parent scope
	      hasBackdrop: true,
	      contentElement: '#myDialog2',
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      controller: function controller() {
	        return _this3;
	      },
	      controllerAs: 'ctrl',
	      clickOutsideToClose: true
	    }).then(function () {
	      console.log('You resolve the dialog.');
	    }, function () {
	      console.log('You cancelled the dialog.');
	    });
	  }

	  function showModal3(ev) {
	    var _this4 = this;

	    $mdDialog.show({
	      preserveScope: true, // do not forget this if use parent scope
	      hasBackdrop: true,
	      contentElement: '#myDialog3',
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      controller: function controller() {
	        return _this4;
	      },
	      controllerAs: 'ctrl',
	      clickOutsideToClose: true
	    }).then(function () {
	      console.log('You resolve the dialog.');
	    }, function () {
	      console.log('You cancelled the dialog.');
	    });
	  }

	  function onSubmit() {
	    var _this5 = this;

	    var firstTime = localStorage.getItem('qm_firstTime');
	    /* Esta sección es hasta que se migre por completo a la nueva tecnología */

	    var kongData = {
	      client_id: config.kong_token.KONG_CLIENT_ID,
	      client_secret: config.kong_token.KONG_CLIENT_SECRET,
	      grant_type: config.kong_token.KONG_GRANT_TYPE,
	      scope: config.kong_token.KONG_SCOPE
	    };
	    var kongToken = '';
	    AuthService.obtainKongToken(kongData).then(function (res) {
	      kongToken = res;
	      return new Promise(function (resolve, reject) {
	        vm.grecaptcha.ready(function () {
	          return resolve();
	        });
	      });
	    }).then(function () {
	      return vm.grecaptcha.execute('6LeLdJ8lAAAAAFueiVZPpgH4kEJjJmOOqSC8BlLj', { action: 'homepage' });
	    }).then(function () {
	      return AuthService.login(vm.credentials);
	    }).then(function () {
	      var current_role = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' ? $localStorage.currentRole.toUpperCase() : undefined;
	      _this5.$rootScope.isAdmin = true;
	      $localStorage.isAdmin = _this5.$rootScope.isAdmin;

	      return AuthService.obtainingUser(vm.credentials, kongToken) // Esta llamada al servicio es hasta hacer toda la migración
	      .then(function () {
	        if (current_role === 'ADMIN' || current_role === 'ROOT' || current_role === 'SUPERADMIN') {
	          vm.prueba = $localStorage.currentUser.id;
	          vm.auth_token = localStorage.auth_token;
	          vm.location = $localStorage.currentLocation.id;
	          if (firstTime === null) {
	            $localStorage.firstTime = true;
	            return window.location = '/panels?id=' + vm.prueba + '&auth_token=' + vm.auth_token + '&location=' + vm.location;
	          }
	          window.location = '/administration/users';
	        }
	        if (current_role === 'STATISTICS') {
	          window.location = '/statistics/center';
	        }
	      });
	    }).catch(function (err) {
	      $translate('app.login.SIGNED_FAIL').then(function (msg) {
	        toastr.error(msg);
	      });

	      console.error('Login failed', err);
	    });
	  }

	  function setActiveTab(index) {
	    vm.activeTab = index;
	    this.getSliderPosition();
	  }

	  function getSliderPosition() {
	    var tabIndex = vm.tabs.findIndex(function (tab) {
	      return tab.value === vm.activeTab;
	    });
	    return tabIndex * 100 / vm.tabs.length + '%';
	  }

	  function _sendPass(form) {
	    if (!vm.errPass && !vm.confirmPassword && vm.reset.password && vm.reset.conf_password) {
	      var data = {
	        password: vm.reset.password,
	        userId: vm.userId
	      };

	      AuthService.ressPass(data).then(function () {
	        $translate('app.login.PASS_SUCCESS').then(function (msg) {
	          toastr.success(msg);
	        });
	        vm.reset = {};
	        setTimeout(function () {
	          window.location = '/';
	        }, 2000);
	      }).catch(function (err) {
	        $translate('app.login.PASS_ERROR').then(function (msg) {
	          toastr.error(msg);
	        });
	        throw new Error(JSON.stringify(err));
	      });
	    }
	  }

	  function logout() {
	    AuthService.logout().then(function () {
	      vm.$rootScope.isKiosk = false;
	      localStorage.removeItem('auth_token');
	      localStorage.removeItem('tokenBook');
	      localStorage.removeItem('currentUser');
	      localStorage.removeItem('currentRole');
	      localStorage.removeItem('currentLocation');
	      localStorage.removeItem('locationIds');
	      localStorage.removeItem('currentOrganization');
	      localStorage.removeItem('isAdmin');
	      localStorage.removeItem('newTokenInfo');
	      toastr.info('You have been logged out');
	      window.location = '/';
	    });
	  }

	  function loadCode(color, colorService) {
	    if ($localStorage.currentUser != undefined) {
	      if (color !== undefined) {
	        vm.bkg = color.split('#')[1];
	      }
	      if (colorService !== undefined) {
	        vm.bkgService = colorService.split('#')[1];
	      }
	      vm.width = vm.width && vm.width > 0 ? vm.width : 100;
	      vm.height = vm.height && vm.height > 0 ? vm.height : 100;
	      var style = '"width: ' + vm.width + '%; height: ' + vm.height + '%;"';
	      var paramColor = "&color=" + vm.bkg;
	      var paramColorService = "&colorService=" + vm.bkgService;

	      var kioskId = vm.currentId;
	      var parametersEncoded = btoa(kioskId + '|' + localStorage.auth_token);

	      var urlEncoded = config.api.BASE_URL_KIOSK_ONLINE + '?q=' + parametersEncoded + paramColor + paramColorService;
	      vm.script = '<div id="widgetQueue"></div><script>document.getElementById(\'widgetQueue\').innerHTML = \'<object data=' + urlEncoded + ' style=' + style + '>\'</script>';
	    }
	  }

	  function changeColor(color, colorService, width, height) {
	    if (color != undefined && color.split('#').length === 1) {
	      color = "#" + color;
	    }
	    if (colorService != undefined && colorService.split('#').length === 1) {
	      colorService = "#" + colorService;
	    }
	    vm.loadCode(color, colorService, width, height);
	  }

	  function copyCode() {
	    var codigoACopiar = document.getElementById('code');
	    var seleccion = document.createRange();
	    seleccion.selectNodeContents(codigoACopiar);
	    window.getSelection().removeAllRanges();
	    window.getSelection().addRange(seleccion);
	    document.execCommand('copy');
	    window.getSelection().removeRange(seleccion);
	  }
	  //#region Centros
	  function loadEstablishments() {
	    vm.noData = true;
	    vm.fail = false;
	    vm.isRoot = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'ROOT' ? true : false;
	    vm.last_establishment = $localStorage.last_establishment ? $localStorage.last_establishment : false;
	    vm.isSuperAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'SUPERADMIN' ? true : false;
	    vm.isAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'ADMIN' ? true : false;
	    vm.noDataUsers = true;
	    vm.failUsers = false;
	    vm.token = '';
	    vm.script = '<>';
	    if (vm.isRoot || vm.isSuperAdmin) {
	      if (vm.last_establishment) {
	        var currentEstablishment = _typeof(vm.last_establishment) != 'object' ? JSON.parse(vm.last_establishment) : vm.last_establishment;
	        vm.establishmentId = currentEstablishment.id;
	        vm.establishmentInUse = currentEstablishment.name;
	      }
	    } else {
	      vm.establishmentId = $localStorage.currentLocation.id;
	      vm.establishmentInUse = $localStorage.currentLocation.name;
	    }
	    var organizationId = $localStorage.currentOrganization ? $localStorage.currentOrganization.id : $localStorage.currentLocation.organizationId;
	    var user_role = $localStorage.currentRole;

	    if (user_role.toUpperCase() == 'ADMIN') {
	      vm.getKiosksByEstablishment(vm.establishmentId);
	    } else {
	      AdministrationService.getEstablishments(user_role, organizationId, 'locations').then(function (result) {
	        result.map(function (kiosk) {
	          if (kiosk.background) delete kiosk.background;
	        });
	        vm.establishments = result;
	      }).catch(function (error) {
	        console.log(error);
	        $translate('app.ERROR_GETESTABLISHMENT').then(function (errorMsg) {
	          toastr.error(errorMsg, 'Error');
	        });
	      });
	    }
	  }

	  vm.establishmentChanged = function () {
	    vm.script !== '<>' ? vm.script = '<>' : null;
	    $localStorage.last_establishment = vm.establishmentSelected;
	    var current_establishment = JSON.parse(vm.establishmentSelected);
	    vm.currentEstablishment = current_establishment;
	    vm.establishmentId = current_establishment.id;
	    vm.establishmentInUse = current_establishment.name;
	    vm.$scope.selectEstablishmentForm.$setPristine();
	    // Load all kiosks by establishment 
	    vm.getKiosksByEstablishment(vm.establishmentId);
	  };

	  function getKiosksByEstablishment(establishmentId) {
	    // Load all kiosks by establishment 
	    vm.EstablishmentsResource.getDevicesByEstablishment({ 'id': establishmentId, 'type': 'kiosks' }).$promise.then(function (result) {
	      vm.kiosks = result;
	      vm.fail = false;
	    }).catch(function (error) {
	      console.log(error);
	      $translate('app.kiosks.ERROR_GETBYESTABLISHMENT').then(function (errorMsg) {
	        toastr.error(errorMsg, 'Error');
	      });
	    });
	  }

	  function getQueueTypeByKiosk(kioskId) {
	    vm.KiosksResource.getQueueTypes({
	      'id': kioskId, 'type': 'queueTypes'
	    }).$promise.then(function (result) {
	      vm.queuetypes = result;
	    }).catch(function (error) {
	      console.log(error);
	    });
	  }

	  function kioskChanged() {
	    $localStorage.last_kiosk = vm.kioskSelected;
	    var current_kiosk = JSON.parse(vm.kioskSelected);
	    vm.currentKiosk = current_kiosk;
	    vm.currentId = current_kiosk.id;
	    vm.kioskInUse = current_kiosk.name;

	    vm.getQueueTypeByKiosk(vm.currentId);

	    vm.EstablishmentsResource.getEmployeesByEstablishment({ id: current_kiosk.locationId, type: 'employees', filter: { "where": { "role": "KIOSK_WIDGET" } } }).$promise.then(function (employees) {
	      vm.failUsers = false;
	      vm.userSelected = employees[0];
	      vm._selectUser(vm.userSelected);
	    }).catch(function (error) {
	      vm.failUsers = true;
	      console.log(error);
	      $translate('app.users.ERROR_GETBYESTABLISHMENT').then(function (errorMsg) {
	        toastr.error(errorMsg, 'Error');
	      });
	    });
	  }

	  function _resetPass() {
	    if (!vm.reset) {
	      toastr.error('El campo está vacío');
	    }
	    vm.Users.resetPassEmail({ email: vm.reset.email }).$promise.then(function () {
	      $translate('app.users.RESET_PASS_EMAIL').then(function (msg) {
	        toastr.success(msg + ': ' + vm.reset.email);
	      });
	      vm.reset.email = '';
	      setTimeout(function () {
	        window.location = '/login';
	      }, 2000);
	    }).catch(function (err) {
	      var msh = err.data.error.code;
	      $translate('app.users.' + msh).then(function (errorMsg) {
	        toastr.error(errorMsg);
	      });
	    });
	  }

	  function _selectUser(user) {
	    vm.CodeResource.getTokenAccess({ id: user.id }).$promise.then(function () {
	      vm.token = localStorage.getItem('auth_token');
	      vm.loadCode();
	    }).catch(function () {
	      $translate('app.users.ERROR_GETACCESSTOKEN').then(function (errorMsg) {
	        toastr.error(errorMsg, 'Error');
	      });
	    });
	  }

	  var _validateInputs = function _validateInputs() {
	    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var name = arguments[1];

	    var regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=])[A-Za-z\d!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=]{8,}$/;
	    var hasSpaces = /^\s+|\s+$|\s{2,}|^ $|^$/.test(value) || value.includes(' ');

	    if (name === 'password') {
	      if (hasSpaces) {
	        vm.errSpace = true;
	        vm.errPass = false;
	      } else {
	        vm.errSpace = false;
	        vm.errPass = !regexPassword.test(value);
	      }
	    }

	    if (name === 'resPassword') {
	      vm.confirmPassword = value !== vm.reset.password;
	    }
	  };

	  var setUrl = function setUrl(id) {
	    return vm.config.api.BASE_URL_SCREEN + '/counter/screen/' + id + '/column';
	  };

	  var setUrlBooking = function setUrlBooking() {
	    return vm.config.NEW_FRONT + '/administration/widget';
	  };

	  var _validateInputsEmail = function _validateInputsEmail(value, form) {
	    var regexEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

	    if (!regexEmail.test(value)) {
	      vm.errMail = true;
	      form.$invalid = true;
	    } else {
	      vm.errMail = false;
	      form.$invalid = false;
	    }
	  };

	  angular.extend(this, {
	    _validateInputs: _validateInputs,
	    _sendPass: _sendPass,
	    _resetPass: _resetPass,
	    _validateInputsEmail: _validateInputsEmail,
	    onSubmit: onSubmit,
	    copyText: copyText,
	    showModal2: showModal2,
	    showModal3: showModal3,
	    registerNav: registerNav,
	    setUrl: setUrl,
	    setActiveTab: setActiveTab,
	    getSliderPosition: getSliderPosition,
	    setUrlBooking: setUrlBooking

	  });
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";

	AuthService.$inject = ["$rootScope", "$auth", "$q", "$state", "_", "$localStorage", "Users", "$log", "Workstations", "toastr", "config", "AuthResource"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	exports.default = AuthService;

	/* @ngInject */

	function AuthService($rootScope, $auth, $q, $state, _, $localStorage, Users, $log, Workstations, toastr, config, AuthResource) {

	  var _currentEstablishment = void 0;
	  var _currentUser = void 0;
	  var _currentRole;
	  var _currentOrganization = void 0;
	  var _currentLocation = void 0;
	  var _currentProfile = void 0;
	  var adminRoles = config.ADMIN_ROLES;

	  var service = {
	    login: login,
	    logout: logout,
	    skipIfLoggedIn: skipIfLoggedIn,
	    loginRequired: loginRequired,
	    allowSelectRoles: allowSelectRoles,
	    allowShowRoles: allowShowRoles,
	    hasValidRole: hasValidRole,
	    // setCurrentData: setCurrentData,
	    loadCurrentData: loadCurrentData,
	    getCurrentUser: getCurrentUser,
	    getCurrentLocation: getCurrentLocation,
	    getCurrentRole: getCurrentRole,
	    getCurrentOrganization: getCurrentOrganization,
	    deleteCurrentUser: deleteCurrentUser,
	    getCurrentProfile: getCurrentProfile,
	    getCurrentEstablishment: getCurrentEstablishment,
	    ressPass: ressPass,
	    obtainingUser: obtainingUser,
	    obtainKongToken: obtainKongToken
	  };

	  return service;

	  function login(credentials) {

	    var deferred = $q.defer();
	    $auth.login(credentials).then(function (response) {
	      $auth.setToken(response.data.id);
	      return Users.me({ id: response.data.userId, filter: { include: [{ relation: "location", "scope": { "include": ["organization"] } }, { relation: "secondaryLocations" }] } }).$promise;
	    }).then(function (user) {
	      _setCurrentData(user);
	      deferred.resolve();
	    }).catch(function (err) {
	      // Handle errors here, such as displaying a notification for invalid email and/or password.
	      deferred.reject(err);
	      if ($auth.isAuthenticated()) {
	        $auth.logout();
	      }
	    });
	    return deferred.promise;
	  }

	  //Servciio que llama a api para conectar con el nuevo front
	  function obtainingUser(credentials, kongToken) {
	    var deferred = $q.defer();

	    Users.generateNewToken({
	      headers: {
	        'authorization-kong': "" + kongToken
	      }
	    }, credentials).$promise.then(function (response) {
	      localStorage.setItem('newTokenInfo', JSON.stringify(response));
	      deferred.resolve();
	    }).catch(function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }

	  function obtainKongToken(credentials) {
	    var deferred = $q.defer();
	    AuthResource.kongToken(credentials).$promise.then(function (res) {
	      console.log('genera el token de kong');
	      var kongToken = res.access_token;
	      localStorage.setItem('tokenKongInfo', JSON.stringify({ access_token: kongToken }));
	      deferred.resolve(kongToken);
	    }).catch(function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }

	  function ressPass(credentials) {
	    var deferred = $q.defer();
	    Users.restorePass(credentials).$promise.then(function () {
	      deferred.resolve();
	    }).catch(function (err) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }

	  function logout() {
	    var deferred = $q.defer();
	    if ($auth.isAuthenticated()) {
	      Users.logout().$promise.then(function () {
	        $localStorage.currentUser = _currentUser = $rootScope.currentUser = '';
	        $localStorage.currentRole = _currentRole = $rootScope.currentRole = '';
	        $auth.logout();
	      });
	    }
	    deferred.resolve();
	    return deferred.promise;
	  }

	  /**
	   * Helper auth functions
	   */
	  function skipIfLoggedIn() {
	    var deferred = $q.defer();
	    if ($auth.isAuthenticated()) {
	      deferred.reject();
	    } else {
	      deferred.resolve();
	    }
	    return deferred.promise;
	  }

	  function loginRequired() {
	    var deferred = $q.defer();
	    if ($auth.isAuthenticated()) {
	      deferred.resolve();
	    } else {
	      $state.go('login');
	    }
	    return deferred.promise;
	  }

	  /*
	   * Valida si el usuario esta autorizado
	   */
	  function hasValidRole(key) {

	    if (_currentUser.role === 'admin') {
	      return true;
	    }

	    var keys = _.split(key, '.');
	    var parent = keys[1];
	    var child = keys[2];
	    if (_currentProfile.roles[parent]) {
	      if (child) {
	        return _.includes(_currentProfile.roles[parent], child);
	      }
	      return true;
	    }
	    return false;
	  }

	  function _setCurrentData(user) {
	    $localStorage.currentUser = _currentUser = $rootScope.currentUser = user;
	    $localStorage.currentRole = _currentRole = $rootScope.currentRole = _.upperCase(_currentUser.role);
	    $localStorage.currentLocation = _currentLocation = $rootScope.currentLocation = user.location;
	    $localStorage.currentOrganization = _currentLocation.organization = $rootScope.currentOrganization = user.location.organization;

	    if (user.secondaryLocations && user.secondaryLocations.length > 0) {
	      var exists = user.secondaryLocations.some(function (loc) {
	        return loc.id === user.location.id;
	      });
	      var locations = exists ? user.secondaryLocations : [user.location].concat(_toConsumableArray(user.secondaryLocations));
	      $localStorage.currentAllLocations = locations.map(function (loc) {
	        return {
	          id: loc.id,
	          name: loc.name
	        };
	      });
	    } else if (user.locationId) {
	      $localStorage.currentAllLocations = [{
	        id: user.locationId,
	        name: user.location.name
	      }];
	    } else {
	      $localStorage.currentAllLocations = [];
	    }
	  }

	  /*
	   * Carga los datos cuando se refresca en el navegador
	   */
	  function loadCurrentData() {
	    _currentUser = $rootScope.currentUser = $localStorage.currentUser;
	    _currentRole = $rootScope.currentRole = $localStorage.currentRole;
	    _currentOrganization = $rootScope.currentOrganization = $localStorage.currentOrganization;
	    _currentLocation = $rootScope.currentLocation = $localStorage.currentLocation;

	    //_currentProfile = $rootScope.currentProfile = $localStorage.currentProfile;
	  }

	  function getCurrentUser() {
	    return _currentUser;
	  }

	  function deleteCurrentUser() {
	    //$localStorage.currentUser = _currentUser = $rootScope.currentUser = '';
	  }

	  function getCurrentProfile() {
	    return _currentProfile;
	  }

	  function getCurrentEstablishment() {
	    return _currentEstablishment;
	  }

	  function getCurrentRole() {
	    return _currentRole;
	  }

	  function getCurrentOrganization() {
	    return _currentOrganization;
	  }

	  function getCurrentLocation() {
	    return _currentLocation;
	  }

	  function allowSelectRoles(role_option) {
	    var role_order = void 0;
	    switch ($localStorage.currentRole) {
	      case "ROOT":
	        role_order = 1;
	        break;
	      case "SUPERADMIN":
	        role_order = 2;
	        break;
	      case "ADMIN":
	        role_order = 3;
	        break;
	      case "STATISTICS":
	        role_order = 4;
	        break;
	    }
	    return role_order < role_option ? true : false;
	  }

	  function allowShowRoles(userRole) {
	    var role_option = adminRoles.indexOf(userRole);
	    var role_order = adminRoles.indexOf($localStorage.currentRole);
	    return role_order > role_option && role_option != -1 ? false : true;
	  }
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _app = __webpack_require__(12);

	var _navbar = __webpack_require__(14);

	var _sidebar = __webpack_require__(16);

	var _footer = __webpack_require__(18);

	var componentsModule = angular.module('mod.components', []).component('app', _app.AppComponent).component('appNavbar', _navbar.NavbarComponent).component('appSidebar', _sidebar.SidebarComponent).component('appFooter', _footer.FooterComponent).name;

	exports.default = componentsModule;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppComponent = undefined;

	var _app = __webpack_require__(13);

	var _app2 = _interopRequireDefault(_app);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var AppComponent = exports.AppComponent = {
	  controller: _app2.default,
	  templateUrl: 'app/components/app/app.html'
	};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AppController =

	/** @ngInject */
	["$log", "$translate", "$mdSidenav", "moment", "$location", "$rootScope", "AuthService", "toastr", "$state", function AppController($log, $translate, $mdSidenav, moment, $location, $rootScope, AuthService, toastr, $state) {
	  _classCallCheck(this, AppController);

	  this.$log = $log;
	  this.$translate = $translate;
	  this.$mdSidenav = $mdSidenav;
	  this.$rootScope = $rootScope;

	  this.isSuperAdmin = this.$rootScope.currentUser && this.$rootScope.currentUser.isSuperAdmin ? this.$rootScope.currentUser.isSuperAdmin : false;
	  this.$state = $state;
	  this.AuthService = AuthService;
	  this.toastr = toastr;
	  this.relativeDate = moment(this.creationDate).fromNow();
	  this.proposedLanguage = $translate.proposedLanguage() || $translate.use();
	  this.preferredLanguage = $translate.preferredLanguage(); // we know we have set a preferred one in mod.config
	  this.isCollapsed = true;
	  this.isEmployee = true;
	  this.toggleLeft = buildToggler('left');
	  var url = $location.url().substring(1).toUpperCase();
	  // Control of navbar menu page
	  this.currentMainPage = currentPage(0);
	  //Remove sidemenu when it´s not necessary
	  this.hasSidemenu = this.currentMainPage === 'ADMINISTRATION';
	  this.hasTabsmenu = this.currentMainPage === 'ADMINISTRATION' || this.currentMainPage === 'STATISTICS';
	  this.isEmployee = this.currentMainPage !== 'REQUEST';
	  // Control of sidemenu page
	  this.currentPage = currentPage(1);

	  /**
	    * Extracts a specific segment from the current URL based on the provided index.
	    *
	    * @param {number} index - The index of the URL segment to retrieve.
	    * @returns {string} - The URL segment at the specified index.
	  */
	  function currentPage(index) {
	    var split_url = url.split('/');
	    // Return the URL segment at the specified index.
	    return split_url[index];
	  }
	  /**
	   * Builds a toggler function for a specified componentId, allowing toggling of visibility.
	   *
	   * @param {string} componentId - The ID of the component to toggle.
	   * @returns {function} - Toggler function.
	   */
	  function buildToggler(componentId) {
	    // Return a function that toggles the collapsed state and toggles the visibility of the specified component.
	    return function () {
	      this.isCollapsed = !this.isCollapsed;
	      $mdSidenav(componentId).toggle();
	    };
	  }
	}];

	exports.default = AppController;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;

	var _navbar = __webpack_require__(15);

	var _navbar2 = _interopRequireDefault(_navbar);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var NavbarComponent = exports.NavbarComponent = {
	  controller: _navbar2.default,
	  templateUrl: 'app/components/navbar/navbar.html'
	};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NavbarController = function () {

	  /** @ngInject */

	  NavbarController.$inject = ["$translate", "toastr", "AuthService", "$state", "$mdSidenav", "$location", "$rootScope", "$localStorage", "$stateParams", "config"];
	  function NavbarController($translate, toastr, AuthService, $state, $mdSidenav, $location, $rootScope, $localStorage, $stateParams, config) {
	    var _this = this;

	    _classCallCheck(this, NavbarController);

	    this.$rootScope = $rootScope;
	    this.$stateParams = $stateParams;
	    this.$stateParams.kioskId;
	    this.config = config;
	    var admin_roles = this.config.ADMIN_ROLES;
	    var show_name = this.config.SHOW_NAME;
	    this.$rootScope.isStatistic = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() == 'STATISTICS' ? true : false;
	    this.$rootScope.isAdmin = $localStorage.currentRole && admin_roles.indexOf($localStorage.currentRole.toUpperCase()) != -1 ? true : false;
	    this.$rootScope.showName = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && show_name.indexOf($localStorage.currentRole.toUpperCase()) != -1 ? true : false;
	    this.$rootScope.isRoot = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() == 'ROOT' ? true : false;

	    this.is_kiosk = this.$rootScope.is_kiosk = this.$stateParams.kioskId != undefined ? true : false;
	    this.$mdSidenav = $mdSidenav;
	    this.$state = $state;
	    this.toastr = toastr;
	    this.$translate = $translate;
	    this.AuthService = AuthService;
	    this.$localStorage = $localStorage;
	    this.showAdmin = true;

	    this.proposedLanguage = $translate.proposedLanguage() || $translate.use();
	    this.preferredLanguage = $translate.preferredLanguage(); // we know we have set a preferred one in mod.config
	    if (this.$localStorage.preferredLanguage) this.$translate.use(this.$localStorage.preferredLanguage);

	    // Control of sidemenu page
	    var url = $location.url().substring(1).toUpperCase();
	    this.currentMainPage = currentPage(0);

	    this.selectLocation = function (locationId) {
	      var selectedLocation = _this.allLocations.find(function (loc) {
	        return loc.id === locationId;
	      });

	      if (!selectedLocation) {
	        console.error("No se encontró la locación con ID:", locationId);
	        return;
	      }

	      _this.$localStorage.currentLocation = _this.$rootScope.currentLocation = angular.copy(selectedLocation);
	      _this.selectedLocationId = locationId;

	      var userId = $localStorage.currentUser ? $localStorage.currentUser.id : null;
	      var authToken = localStorage.auth_token || '';

	      if (!userId || !authToken) {
	        console.error("Error: Falta el usuario o el token de autenticación.");
	        return;
	      }
	      _this.$state.reload();
	    };

	    /**
	     * Extracts a specific segment from the current URL based on the provided index.
	     *
	     * @param {number} index - The index of the URL segment to retrieve.
	     * @returns {string} - The URL segment at the specified index.
	     */
	    function currentPage(index) {
	      var split_url = url.split('/');
	      return split_url[index];
	    }
	    /**
	    * Checks whether the current user is allowed to compare roles based on the provided role_option.
	    *
	    * @param {string} role_option - The role option to check for permission.
	    * @returns {boolean} - True if the current user is allowed to compare roles, false otherwise.
	    */
	    function allowCompare(role_option) {
	      return this.AuthService.allowSelectRoles(role_option);
	    }
	    /**
	     * Redirects the user to a panel page with query parameters based on user and location information.
	     */
	    function goPanel() {
	      var prueba = $localStorage.currentUser.id;
	      var auth_token = localStorage.auth_token;
	      var location = $localStorage.currentLocation.id;
	      window.location = '/panels?id=' + prueba + '&auth_token=' + auth_token + '&location=' + location;
	    }
	    angular.extend(this, {
	      allowCompare: allowCompare,
	      goPanel: goPanel
	    });
	  }

	  _createClass(NavbarController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.allLocations = this.$localStorage.currentAllLocations || [];
	      this.selectedLocationId = this.$localStorage.currentLocation ? this.$localStorage.currentLocation.id : null;
	      this.showAdmin = this.config.SHOW_ADMIN;
	    }
	    /**
	    * Opens a Material Design menu using the $mdOpenMenu service.
	    *
	    * @param {function} $mdOpenMenu - The $mdOpenMenu service provided by AngularJS Material Design.
	    * @param {object} ev - The event object (e.g., click event) that triggered the menu opening.
	    */

	  }, {
	    key: 'openMenu',
	    value: function openMenu($mdOpenMenu, ev) {
	      $mdOpenMenu(ev);
	    }
	    /**
	     * Sets the language for translation and updates the preferred language in local storage.
	     *
	     * @param {string} lang - The language code to set for translation.
	     */

	  }, {
	    key: 'selectLanguage',
	    value: function selectLanguage(lang) {
	      // Set the new idiom
	      this.$translate.use(lang);
	      // Update the preferred language in local storage for future sessions.
	      this.$localStorage.preferredLanguage = lang;
	    }
	    /**
	     * Logs the user out by removing authentication-related items from local storage
	     * and navigates to the 'logout' state.
	     */

	  }, {
	    key: 'logout',
	    value: function logout() {
	      // Remove authentication-related items from local storage.
	      localStorage.removeItem('auth_token');
	      localStorage.removeItem('tokenBook');
	      localStorage.removeItem('qm_currentUser');
	      localStorage.removeItem('qm_currentRole');
	      localStorage.removeItem('qm_currentLocation');
	      localStorage.removeItem('qm_currentOrganization');
	      localStorage.removeItem('qm_isAdmin');
	      localStorage.removeItem('newTokenInfo');
	      localStorage.removeItem('tokenInfo');
	      localStorage.removeItem('tokenKongInfo');
	      localStorage.removeItem('qm_locationIds');
	      // Navigate to the 'logout' state using the $state service.
	      this.$state.go('logout');
	    }

	    /* Navegar en el nuevo front */

	  }, {
	    key: 'goToStatistics',
	    value: function goToStatistics() {
	      var oldToken = localStorage.getItem('auth_token');
	      var employeeData = localStorage.getItem('qm_currentUser');
	      var employee = JSON.parse(employeeData);
	      var token = localStorage.getItem('newTokenInfo');
	      var shareData = {
	        token: token,
	        employee: {
	          id: employee.id,
	          locationId: employee.locationId,
	          role: employee.role,
	          username: employee.username
	        },
	        oldData: {
	          userId: employee.id,
	          id: oldToken
	        }
	      };

	      var data = JSON.stringify(shareData);

	      var dataTransformed = encodeURIComponent(data);
	      window.location = this.config.NEW_FRONT + '/statistics/organization?data=' + dataTransformed;
	    }
	  }]);

	  return NavbarController;
	}();

	exports.default = NavbarController;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SidebarComponent = undefined;

	var _sidebar = __webpack_require__(17);

	var _sidebar2 = _interopRequireDefault(_sidebar);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SidebarComponent = exports.SidebarComponent = {
	  templateUrl: 'app/components/sidebar/sidebar.html',
	  controller: _sidebar2.default
	};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SidebarController = function () {

	  /** @ngInject */
	  SidebarController.$inject = ["$rootScope", "$mdSidenav", "$location", "$localStorage"];
	  function SidebarController($rootScope, $mdSidenav, $location, $localStorage) {
	    _classCallCheck(this, SidebarController);

	    this.$rootScope = $rootScope;
	    this.$mdSidenav = $mdSidenav;
	    this.isCollapsed = true;
	    this.isSuperAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'SUPERADMIN' ? true : false;
	    this.isRoot = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'ROOT' ? true : false;
	    this.isAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'ADMIN' ? true : false;
	    this.toggleLeft = buildToggler('sidebarLeft');
	    this.isStatistic = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'STATISTICS' ? true : false;

	    function buildToggler(componentId) {
	      return function () {
	        this.isCollapsed = !this.isCollapsed;
	        $mdSidenav(componentId).toggle();
	        var sidebar = document.querySelector(".app-sidebar");
	        sidebar.classList.toggle("sidebar-toggle");
	      };
	    }
	  }

	  _createClass(SidebarController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }, {
	    key: 'toggleSidenav',
	    value: function toggleSidenav() {
	      this.$mdSidenav('sidebarLeft').toggle();
	    }
	  }]);

	  return SidebarController;
	}();

	exports.default = SidebarController;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FooterComponent = undefined;

	var _footer = __webpack_require__(19);

	var _footer2 = _interopRequireDefault(_footer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var FooterComponent = exports.FooterComponent = {
	    controller: _footer2.default,
	    templateUrl: 'app/components/footer/footer.html'
	};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var FooterController =

	/** @ngInject */

	["$translate", "toastr", "AuthService", "$state", "$mdSidenav", "$location", "$rootScope", "$localStorage", "$stateParams", "config", function FooterController($translate, toastr, AuthService, $state, $mdSidenav, $location, $rootScope, $localStorage, $stateParams, config) {
	  _classCallCheck(this, FooterController);

	  this.$rootScope = $rootScope;
	  this.$stateParams = $stateParams;
	  this.$stateParams.kioskId;
	  this.config = config;
	  var admin_roles = this.config.ADMIN_ROLES;
	  var show_name = this.config.SHOW_NAME;
	  this.$rootScope.isAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && admin_roles.indexOf($localStorage.currentRole.toUpperCase()) !== -1 ? true : false;
	  this.$rootScope.showName = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && show_name.indexOf($localStorage.currentRole.toUpperCase()) != -1 ? true : false;
	  this.$rootScope.isRoot = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() == 'ROOT' ? true : false;

	  this.is_kiosk = this.$rootScope.is_kiosk = this.$stateParams.kioskId != undefined ? true : false;
	  this.$mdSidenav = $mdSidenav;
	  this.$state = $state;
	  this.toastr = toastr;
	  this.$translate = $translate;
	  this.AuthService = AuthService;
	  this.$localStorage = $localStorage;
	  this.showAdmin = true;

	  this.proposedLanguage = $translate.proposedLanguage() || $translate.use();
	  this.preferredLanguage = $translate.preferredLanguage(); // we know we have set a preferred one in mod.config
	  if (this.$localStorage.preferredLanguage) this.$translate.use(this.$localStorage.preferredLanguage);
	}];

	exports.default = FooterController;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _auth = __webpack_require__(21);

	var _auth2 = _interopRequireDefault(_auth);

	var _establishments = __webpack_require__(22);

	var _establishments2 = _interopRequireDefault(_establishments);

	var _organizations = __webpack_require__(23);

	var _organizations2 = _interopRequireDefault(_organizations);

	var _statisticsResource = __webpack_require__(24);

	var _statisticsResource2 = _interopRequireDefault(_statisticsResource);

	var _kiosks = __webpack_require__(25);

	var _kiosks2 = _interopRequireDefault(_kiosks);

	var _consumers = __webpack_require__(26);

	var _consumers2 = _interopRequireDefault(_consumers);

	var _screens = __webpack_require__(27);

	var _screens2 = _interopRequireDefault(_screens);

	var _services = __webpack_require__(28);

	var _services2 = _interopRequireDefault(_services);

	var _users = __webpack_require__(29);

	var _users2 = _interopRequireDefault(_users);

	var _areas = __webpack_require__(30);

	var _areas2 = _interopRequireDefault(_areas);

	var _workstations = __webpack_require__(31);

	var _workstations2 = _interopRequireDefault(_workstations);

	var _statistics = __webpack_require__(32);

	var _statistics2 = _interopRequireDefault(_statistics);

	var _roles = __webpack_require__(33);

	var _roles2 = _interopRequireDefault(_roles);

	var _supervisor = __webpack_require__(34);

	var _supervisor2 = _interopRequireDefault(_supervisor);

	var _workstationsInUse = __webpack_require__(35);

	var _workstationsInUse2 = _interopRequireDefault(_workstationsInUse);

	var _code = __webpack_require__(36);

	var _code2 = _interopRequireDefault(_code);

	var _timeZones = __webpack_require__(37);

	var _timeZones2 = _interopRequireDefault(_timeZones);

	var _agendas = __webpack_require__(38);

	var _agendas2 = _interopRequireDefault(_agendas);

	var _queue = __webpack_require__(39);

	var _queue2 = _interopRequireDefault(_queue);

	var _category = __webpack_require__(40);

	var _category2 = _interopRequireDefault(_category);

	var _locations = __webpack_require__(41);

	var _locations2 = _interopRequireDefault(_locations);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = resources;
	// TODO: Para evitar romper crean los nuevos rescursos usando solo el plural

	var resources = angular.module('mod.resources', []).service('AuthResource', _auth2.default).service('OrganizationsResource', _organizations2.default).service('EstablishmentsResource', _establishments2.default).service('StatisticsResource', _statisticsResource2.default).service('KiosksResource', _kiosks2.default).service('ConsumersResource', _consumers2.default).service('ScreensResource', _screens2.default).service('ServicesResource', _services2.default).service('Users', _users2.default).service('Areas', _areas2.default).service('Workstations', _workstations2.default).service('Statistics', _statistics2.default).service('Supervisor', _supervisor2.default).service('RolesResource', _roles2.default).service('WorkstationsInUse', _workstationsInUse2.default).service('CodeResource', _code2.default).service('TimeZones', _timeZones2.default).service('AgendasResource', _agendas2.default).service('QueuesResource', _queue2.default).service('CategoryResource', _category2.default).service('LocationsResource', _locations2.default).name;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AuthResource =

	/** ngInject */
	function AuthResource(config, $resource) {
	  _classCallCheck(this, AuthResource);

	  var endpoint = config.api.BASE_URL + '/auth/login';
	  var kongEnpoint = config.api.GENERATE_KONG_TOKEN + '/oauth2/token';

	  var authResource = $resource(endpoint, {}, {
	    login: { method: 'POST', params: { username: '@username', password: '@userpassword' }
	    }
	  });

	  // Conexión con el nuevo front
	  var authKongToken = $resource(kongEnpoint, {}, {
	    kongToken: {
	      method: 'POST',
	      headers: {
	        'Content-Type': 'application/x-www-form-urlencoded'
	      },
	      transformRequest: function transformRequest(data) {
	        var str = [];
	        for (var p in data) {
	          if (data.hasOwnProperty(p)) {
	            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
	          }
	        }
	        return str.join("&");
	      }
	    }
	  });

	  return {
	    login: authResource.login,
	    kongToken: authKongToken.kongToken
	  };
	};

	AuthResource.$inject = ['config', '$resource'];

	exports.default = AuthResource;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EstablishmentsResource =

	/** ngInject */
	function EstablishmentsResource(config, $resource) {
	  _classCallCheck(this, EstablishmentsResource);

	  // Endpoint base para otros recursos
	  var endpoint = config.api.BASE_URL + '/locations/:id/:type';

	  var establishmentsResource = $resource(endpoint, {}, {
	    create: { method: 'POST' },
	    update: { method: 'PATCH' },
	    destroy: { method: 'DELETE' },

	    getEstablishmentData: {
	      method: 'GET',
	      params: { establishmentId: '@establishmentId' }
	    },

	    getDevicesByEstablishment: {
	      method: 'GET',
	      params: { id: '@establishmentId', type: '@type' },
	      isArray: true
	    },

	    getWorkstationsByEstablishment: {
	      method: 'GET',
	      params: { id: '@establishmentId', type: '@type' },
	      isArray: true
	    },

	    getEstablishments: {
	      method: 'GET',
	      isArray: true
	    },

	    getEmployeesByEstablishment: {
	      method: 'GET',
	      params: { id: '@id', filter: '@filter' },
	      isArray: false,
	      interceptor: {
	        request: function request(config) {
	          var filterObj = config.params.filter;
	          if (filterObj && Array.isArray(filterObj.include)) {
	            config.params.filter = JSON.stringify({
	              include: [{ relation: 'employees', scope: { include: filterObj.include } }, { relation: 'secondaryEmployees', scope: { include: filterObj.include } }]
	            });
	          }
	          return config;
	        },
	        response: function response(_response) {
	          var data = angular.fromJson(_response.data);
	          var primary = data.employees || [];
	          var secondary = data.secondaryEmployees || [];
	          return primary.concat(secondary);
	        }
	      }
	    }
	  });

	  return establishmentsResource;
	};

	EstablishmentsResource.$inject = ['config', '$resource'];

	exports.default = EstablishmentsResource;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var OrganizationsResource =

	/** ngInject */
	function OrganizationsResource(config, $resource) {
	  _classCallCheck(this, OrganizationsResource);

	  var endpoint = config.api.BASE_URL + '/organizations/:id/:type';

	  var organizationsResource = $resource(endpoint, {}, {
	    create: { method: 'POST' },

	    update: { method: 'PATCH' },

	    destroy: { method: 'DELETE' },

	    createEstablisment: { method: 'POST' },

	    getOrganizationData: { method: 'GET', params: { id: '@organizationId' } },

	    getOrganizations: { method: 'GET', isArray: true },

	    getEstablishments: { method: 'GET', isArray: true },

	    getServicesByOrganization: { method: 'GET', params: { id: '@organizationId', type: 'queues' }, isArray: true },

	    getBookingServicesByOrganization: { method: 'GET', params: { id: '@organizationId', type: 'queues', filter: '@filter' }, isArray: true },

	    getEstablismentByOrganization: { method: 'GET', params: { id: '@id', type: 'locations' }, isArray: true },

	    getEmployeesByOrganization: { method: 'GET', params: { id: '@organizationId', type: 'employees' }, isArray: true },

	    getOrganizationById: {
	      method: 'GET',
	      url: config.api.BASE_URL + '/organizations/:organizationId',
	      params: { organizationId: '@organizationId' }
	    }
	  });

	  return organizationsResource;
	};

	OrganizationsResource.$inject = ['config', '$resource'];

	exports.default = OrganizationsResource;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var StatisticsResource =

	/** ngInject */
	function StatisticsResource(config, $resource) {
	    _classCallCheck(this, StatisticsResource);

	    // This endpoint only works wene last version will be dveloped
	    //var endpoint = config.api.BASE_URL + '/locations/:establishmentId/statistics/:statisticsId';

	    var endpoint = 'https://pre-queuem-api.cloudappi.net/establishments/:establishmentId/statistics/:statisticsId';

	    //var mock = 'https://mocksvc.mulesoft.com/mocks/1be6a214-8c35-4e00-bec5-7afc69b58402';
	    //var endpoint = mock + '/establishments/:establishmentId/statistics/:statisticsId';
	    //var endpoint = config.api.BASE_URL + '/establishments/:establishmentId/statistics/:statisticsId';

	    var statisticsResource = $resource(endpoint, { statisticsId: '@statisticsId' }, {});

	    return statisticsResource;
	};

	StatisticsResource.$inject = ['config', '$resource'];

	exports.default = StatisticsResource;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var KiosksResource =

	/** ngInject */
	function KiosksResource(config, $resource) {
	  _classCallCheck(this, KiosksResource);

	  var endpoint = config.api.BASE_URL + '/kiosks/:id/:type/:option/:fk';
	  var endpoint2 = config.api.BASE_URL + '/queueTypeByKiosk';

	  var kiosksResource = $resource(endpoint, { establishmentId: '@establishmentId' },
	  ///kiosks/{id}/queues
	  {
	    create: { method: 'POST' },

	    update: { method: 'PATCH' },

	    destroy: { method: 'DELETE' },

	    getKioskData: { method: 'GET', params: { id: '@kioskId' } },

	    getKiosks: { method: 'GET', isArray: true },

	    getServices: { method: 'GET', params: { filter: '@filter' }, isArray: true },

	    getQueueTypes: { method: 'GET', params: { id: '@kioskId', type: 'queueTypes' }, isArray: true },

	    getTurns: { method: 'GET', params: { id: '@kioskId' } },
	    disassign: { method: 'DELETE' }
	  });

	  var usersResourceUsr = $resource(endpoint2, { establishmentId: '@establishmentId' }, {
	    asignServices: { method: 'POST' },
	    getRel: { method: 'GET', isArray: true }
	  });

	  return {
	    create: kiosksResource.create,
	    update: kiosksResource.update,
	    destroy: kiosksResource.destroy,
	    getKioskData: kiosksResource.getKioskData,
	    getKiosks: kiosksResource.getKiosks,
	    getServices: kiosksResource.getServices,
	    getQueueTypes: kiosksResource.getQueueTypes,
	    getTurns: kiosksResource.getTurns,
	    disassign: kiosksResource.disassign,
	    asignServices: usersResourceUsr.asignServices,
	    getRel: usersResourceUsr.getRel
	  };
	};

	KiosksResource.$inject = ['config', '$resource'];

	exports.default = KiosksResource;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ConsumersResource =

	/** ngInject */
	function ConsumersResource(config, $resource) {
	  _classCallCheck(this, ConsumersResource);

	  var endpoint = config.api.BASE_URL + '/workstations/:id/:type/:option/:fk';

	  var consumersResource = $resource(endpoint, {}, {
	    create: { method: 'POST' },

	    update: { method: 'PATCH', params: { id: '@consumerId' } },

	    destroy: { method: 'DELETE', params: { id: '@consumerId' } },

	    getConsumerData: { method: 'GET', params: { id: '@consumerId' } },

	    getConsumersByLocation: { method: 'GET', params: { id: '@establishmentId', type: 'getByLocation' } },

	    getServices: { method: 'GET', isArray: true },

	    // asignServices: {method: 'PUT', params: {id: '@consumerId', type: '@type', rel: 'rel', service: '@serviceId'}, hasBody: true},

	    asignServices: { method: 'PUT' },

	    disassign: { method: 'DELETE' }
	  });

	  return consumersResource;
	};

	ConsumersResource.$inject = ['config', '$resource'];

	exports.default = ConsumersResource;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ScreensResource =

	/** ngInject */
	function ScreensResource(config, $resource) {
	  _classCallCheck(this, ScreensResource);

	  var endpoint = config.api.BASE_URL + '/screens/:id/:resource/:columns';

	  var screensResource = $resource(endpoint, { establishmentId: '@establishmentId' }, {
	    create: { method: 'POST' },

	    update: { method: 'PATCH', params: { id: '@establishmentId' } },

	    destroy: { method: 'DELETE' },

	    getScreenData: { method: 'GET' },

	    getScreens: { method: 'GET', isArray: true },

	    getScreensByEstablishment: { method: 'GET', params: { id: '@establishmentId', resource: 'getByLocation' } },

	    getTurns: { method: 'GET', params: { id: '@establishmentId', resource: 'getTurns', columns: '@columns' } }
	  });

	  var serviceResource = $resource(config.api.BASE_URL + '/screens/:id/queueTypes/rel/:fk', {}, {
	    assignService: { method: 'PUT', params: { id: '@id', fk: '@fk' } },
	    disassignService: { method: 'DELETE', params: { id: '@id', fk: '@fk' } }
	  });

	  screensResource.assignService = serviceResource.assignService;
	  screensResource.disassignService = serviceResource.disassignService;

	  return screensResource;
	};

	ScreensResource.$inject = ['config', '$resource'];

	exports.default = ScreensResource;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ServicesResource =

	/** ngInject */
	function ServicesResource(config, $resource) {
	  _classCallCheck(this, ServicesResource);

	  var endpoint = config.api.BASE_URL + '/:type/:function/:id/:option';

	  var servicesResource = $resource(endpoint, { establishmentId: '@establishmentId' }, {
	    create: { method: 'POST' },

	    update: { method: 'PATCH' },

	    updateQueueType: { method: 'PATCH', params: { type: '@type', id: '@id' } },

	    delete: { method: 'DELETE', params: { id: '@id' } },

	    deleteQueueType: { method: 'DELETE', params: { type: '@type', id: '@id' } },

	    asignQueue: { method: 'POST' },

	    getServiceData: { method: 'GET', params: { id: '@id' } },

	    getServicesData: { method: 'GET', params: { id: '@id' }, isArray: true },

	    getServices: { method: 'GET', isArray: true },

	    getBookingServices: { method: 'GET', isArray: true, params: { filter: '@filter' } },

	    getEstablishments: { method: 'GET', isArray: true },

	    disassign: { method: 'DELETE', params: { locationId: '@locationId', queueId: '@queueId' } }
	  });

	  return servicesResource;
	};

	ServicesResource.$inject = ['config', '$resource'];

	exports.default = ServicesResource;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Users =

	/** ngInject */
	function Users(config, $resource) {
	  _classCallCheck(this, Users);

	  //var endpoint = config.api.BASE_URL + '/establishments/:establishmentId/employees';
	  var endpoint = config.api.BASE_URL + '/employees/:id/:type/:typeId';
	  var endpoint2 = config.api.BASE_URL + '/employees/:type/:typeId';
	  var endpointBook = config.api.BOOKED_BACK + '/users/generate-token/:id';
	  var endpointMain = config.api.BASE_URL + '/employees/verifyUsers';
	  var endpointNewMain = config.api.BASE_NEW_URL + '/login';

	  var usersResource = $resource(endpoint, { establishmentId: '@establishmentId', id: '@userId' }, {
	    login: { method: 'POST' },
	    logout: { method: 'POST', params: { id: 'logout' } },
	    me: { method: 'GET' },
	    getOrganization: { method: 'GET', params: { id: '@userId', type: 'organization' } },
	    getLocation: { method: 'GET', params: { id: '@userId', type: 'organizations' } },
	    getLocations: { method: 'GET', params: { id: '@userId', type: 'organizations' }, isArray: true },
	    create: { method: 'POST' },
	    update: { method: 'PATCH' },
	    resetPass: { method: 'PATCH' },
	    delete: { method: 'DELETE', params: { id: '@id' } },
	    getUserData: { method: 'GET', params: { userId: '@userId' } },
	    getUsers: { method: 'GET', isArray: true },
	    sendContact: { method: 'POST', params: { type: 'sendContactForm' }, headers: { 'authorization': undefined } }

	  });
	  var usersResourceUsr = $resource(endpoint2, { establishmentId: '@establishmentId' }, {
	    resetPassword: { method: 'POST', params: { type: 'notify', typeId: 'reset-password' } },
	    resetPassEmail: { method: 'POST', params: { type: 'reset' } },
	    restorePass: { method: 'POST', params: { type: 'reset-password' } }
	  });

	  var usersResourceBook = $resource(endpointBook, { id: '@id' }, {
	    generateToken: { method: 'GET' }
	  });

	  var usersResourceMain = $resource(endpointMain, {}, {
	    verifyAllUsers: { method: 'POST' }
	  });

	  /* Hasta que se termine de hacer la migración en el nuevo front */
	  var usersResourceNewMain = $resource(endpointNewMain, {}, {
	    generateToken: {
	      method: 'POST',
	      headers: {
	        'Content-Type': 'application/json',
	        'authorization-kong': function authorizationKong(data) {
	          var token = JSON.parse(localStorage.getItem('tokenKongInfo'));
	          return token['access_token'];
	        }
	      }
	    },
	    transformRequest: function transformRequest(data) {
	      return angular.toJson(data);
	    }
	  });

	  var secondaryRelEndpoint = config.api.BASE_URL + '/locationByEmployee';
	  var secondaryRelResource = $resource(secondaryRelEndpoint, {}, {
	    addSecondary: {
	      method: 'POST'
	    },
	    removeSecondary: {
	      method: 'DELETE',
	      url: config.api.BASE_URL + '/locationByEmployee/deleteByUserAndLocation',
	      params: { employeeId: '@employeeId', locationId: '@locationId' }
	    }
	  });

	  return {
	    login: usersResource.login,
	    logout: usersResource.logout,
	    me: usersResource.me,
	    getOrganization: usersResource.getOrganization,
	    getLocation: usersResource.getLocation,
	    getLocations: usersResource.getLocations,
	    create: usersResource.create,
	    update: usersResource.update,
	    resetPass: usersResource.resetPass,
	    delete: usersResource.delete,
	    getUserData: usersResource.getUserData,
	    getUsers: usersResource.getUsers,
	    resetPassword: usersResourceUsr.resetPassword,
	    resetPassEmail: usersResourceUsr.resetPassEmail,
	    restorePass: usersResourceUsr.restorePass,
	    sendContact: usersResource.sendContact,
	    generateToken: usersResourceBook.generateToken,
	    verifyAllUsers: usersResourceMain.verifyAllUsers,
	    generateNewToken: usersResourceNewMain.generateToken,
	    addSecondaryLocation: secondaryRelResource.addSecondary,
	    removeSecondaryLocation: secondaryRelResource.removeSecondary
	  };
	};

	Users.$inject = ['config', '$resource'];

	exports.default = Users;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Areas =

	/** ngInject */
	function Areas(config, $resource) {
	  _classCallCheck(this, Areas);

	  var endpoint = config.api.BASE_URL + '/areas/:id/:type';
	  //'/areas/:id/:resource/:resourceId'

	  var queuesResource = $resource(endpoint, {}, {

	    create: { method: 'POST' },

	    update: { method: 'PATCH' },

	    destroy: { method: 'DELETE' },
	    //destroy: { method: 'DELETE', params: { id: '@id' } },

	    getAreaData: { method: 'GET', params: { id: '@waitingareaId' } },

	    getQueues: { method: 'GET', params: { resource: 'queues' }, isArray: true },

	    getAreas: { method: 'GET', isArray: true },

	    getScreens: { method: 'GET', isArray: true },

	    getWorkstations: { method: 'GET', isArray: true }
	  });

	  return queuesResource;
	};

	Areas.$inject = ['config', '$resource'];

	exports.default = Areas;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Workstations =

	/** ngInject */
	function Workstations(config, $resource) {
	  _classCallCheck(this, Workstations);

	  var endpoint = config.api.BASE_URL + '/workstations/:id/:resource/:resourceId';

	  var workstations = $resource(endpoint, { id: '@id' }, {

	    getWorkstationsByEstablishment: { method: 'GET' },

	    getQueueTypesByWorkstations: { method: 'GET', isArray: true }

	  });

	  return workstations;
	};

	Workstations.$inject = ['config', '$resource'];

	exports.default = Workstations;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Statistics =

	/** ngInject */
	function Statistics(config, $resource) {
	  _classCallCheck(this, Statistics);

	  // This endpoint only works wene last version will be dveloped
	  var endpoint = config.api.BASE_URL + '/statistics/:type';

	  var nocache = function nocache(params) {
	    return Object.assign({}, params, { _: Date.now() });
	  };

	  var statisticsResource = $resource(endpoint, {}, {
	    getServiceTime: { method: 'GET', params: nocache({ type: 'serviceTime' }) },
	    getWaitingTime: { method: 'GET', params: nocache({ type: 'waitingTime' }) },
	    getTurnsByEmployee: { method: 'GET', params: nocache({ type: 'turnsByEmployee' }) },
	    getTurnsByQueue: { method: 'GET', params: nocache({ type: 'turnsByQueue' }) },
	    getTurnsAttendedByEmployee: { method: 'GET', params: nocache({ type: 'turnsAttendedByEmployee' }) },
	    getTurnsAttendedByQueue: { method: 'GET', params: nocache({ type: 'turnsAttendedByQueue' }) },
	    getTurnsByQueueByDate: { method: 'GET', params: nocache({ type: 'turnsByQueueByDate' }) },
	    getTurnsWaitingByQueue: { method: 'GET', params: nocache({ type: 'turnsWaitingByQueue' }) },
	    getTurnsAbsentByQueue: { method: 'GET', params: nocache({ type: 'turnsAbsentByQueue' }) },
	    getTurnsSpecialByQueue: { method: 'GET', params: nocache({ type: 'turnsSpecialByQueue' }) },
	    getTurnsResentByQueue: { method: 'GET', params: nocache({ type: 'turnsResentByQueue' }) }
	  });

	  return statisticsResource;
	};

	Statistics.$inject = ['config', '$resource'];

	exports.default = Statistics;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var RolesResource =

	/** ngInject */
	function RolesResource(config, $resource) {
	  _classCallCheck(this, RolesResource);

	  var endpoint = config.api.BASE_URL + '/roles';

	  var _RolesResource = $resource(endpoint, { establishmentId: '@establishmentId', id: '@userId' }, {
	    getRoles: { method: 'GET', isArray: true }
	  });

	  return _RolesResource;
	};

	RolesResource.$inject = ['config', '$resource'];

	exports.default = RolesResource;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Supervisor =

	/** ngInject */
	function Supervisor(config, $resource) {
	  _classCallCheck(this, Supervisor);

	  // This endpoint only works wene last version will be dveloped
	  var endpoint = config.api.BASE_URL + '/supervisors/:type';

	  var supervisorResource = $resource(endpoint, {}, {
	    getServiceTime: { method: 'GET', params: { type: 'serviceTime' } },
	    getWaitingTime: { method: 'GET', params: { type: 'waitingTime' } },
	    getTurnsByEmployee: { method: 'GET', params: { type: 'turnsByEmployee' } },
	    getTurnsByQueue: { method: 'GET', params: { type: 'turnsByQueue' } },
	    getTurnsAttendedByQueue: { method: 'GET', params: { type: 'turnsAttendedByQueue' } },
	    getTurnsWaitingByQueue: { method: 'GET', params: { type: 'turnsWaitingByQueue' } },
	    getTurnsByQueueByDate: { method: 'GET', params: { type: 'turnsByQueueByDate' } },
	    getTurnsAbsentByQueue: { method: 'GET', params: { type: 'turnsAbsentByQueue' } },
	    getTurnsSpecialByQueue: { method: 'GET', params: { type: 'turnsSpecialByQueue' } }
	  });

	  return supervisorResource;
	};

	Supervisor.$inject = ['config', '$resource'];

	exports.default = Supervisor;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var WorkstationsInUse =

	/** ngInject */
	function WorkstationsInUse(config, $resource) {
	  _classCallCheck(this, WorkstationsInUse);

	  var endpoint = config.api.BASE_URL + '/workstationsInUse/:locationId/:resource';

	  var workstationsInUse = $resource(endpoint, {}, {
	    getWorkstationInUse: { method: 'GET', isArray: true },
	    getWorkstationByLocation: { method: 'GET', params: { resource: 'getByLocation' }, isArray: true }
	  });

	  return workstationsInUse;
	};

	WorkstationsInUse.$inject = ['config', '$resource'];

	exports.default = WorkstationsInUse;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CodeResource =

	/** ngInject */
	function CodeResource(config, $resource) {
	  _classCallCheck(this, CodeResource);

	  var endpoint = config.api.BASE_URL + '/employees/:id/:type/';

	  var codeResource = $resource(endpoint, { id: '@id' }, {
	    getTokenAccess: { method: 'POST', params: { type: 'accessTokens' }, hasBody: false }
	  });

	  return codeResource;
	};

	CodeResource.$inject = ['config', '$resource'];

	exports.default = CodeResource;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TimeZones =

	/** ngInject */
	function TimeZones(config, $resource) {
	  _classCallCheck(this, TimeZones);

	  var endpoint = config.api.BASE_URL + '/TimeZones/:id';

	  var timeZonesResource = $resource(endpoint, {},
	  //   {establishmentId: '@establishmentId', id: '@userId'},
	  {
	    getTimeZones: { method: 'GET', isArray: true },

	    getTimeZoneById: { method: 'GET', params: { id: '@timeZonesId' } }
	  });

	  return timeZonesResource;
	};

	TimeZones.$inject = ['config', '$resource'];

	exports.default = TimeZones;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AgendasResource =

	/** ngInject */
	function AgendasResource(config, $resource) {
	  _classCallCheck(this, AgendasResource);

	  var endpoint = config.api.BASE_URL + '/bookitits/:id/:resource';

	  var agendasResource = $resource(endpoint, { organizationId: '@organizationId' }, {
	    create: { method: 'POST' },

	    update: { method: 'PATCH' },

	    destroy: { method: 'DELETE' },

	    delete: { method: 'DELETE', params: { id: '@id' } },

	    getAgendas: { method: 'GET', isArray: true },

	    getAgendasByOrganization: { method: 'GET', isArray: true },

	    getServicesByOrganization: { method: 'GET', params: { id: '@organizationId', resource: 'getServices' }, isArray: true },

	    getBokititById: { method: 'POST', params: { id: '@organizationId', resource: 'servicesNameById' }, body: '@serviceId', isArray: true }

	    //asignedServicesBokitit: {method: 'PATCH', params: { resource:'asignedServicesBokitit'}}

	  });

	  return agendasResource;
	};

	AgendasResource.$inject = ['config', '$resource'];

	exports.default = AgendasResource;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var QueuesResource =

	/** ngInject */
	function QueuesResource(config, $resource) {
	  _classCallCheck(this, QueuesResource);

	  var endpoint = config.api.BASE_URL + '/queues/:id/:resource/:idService';

	  var queuesResource = $resource(endpoint, { organizationId: '@organizationId' }, {

	    getQueues: { method: 'GET', isArray: true },

	    getQueuesById: { method: 'GET', params: { id: '@id' } },

	    asignedQueueServices: { method: 'PATCH', params: { id: '@id' } },

	    asignedServicesBokitit: { method: 'PATCH', params: { id: '@id', resource: 'asignedServicesBokitit' } },

	    deleteAsignedServicesBokitit: { method: 'PATCH', params: { id: '@id', resource: 'deleteAsignedServicesBokitit', idService: '@idService' } }

	  });

	  return queuesResource;
	};

	QueuesResource.$inject = ['config', '$resource'];

	exports.default = QueuesResource;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	//category resource

	var CategoryResource =
	/** ngInject */
	function CategoryResource(config, $resource) {
	  _classCallCheck(this, CategoryResource);

	  var endpoint = config.api.BASE_URL + "/categories/:id";

	  var categoryResource = $resource(endpoint, {}, {
	    getCategories: { method: "GET", isArray: true },

	    getCategoriesById: { method: "GET", params: { id: "@CategoryId" } }
	  });

	  return categoryResource;
	};

	CategoryResource.$inject = ["config", "$resource"];

	exports.default = CategoryResource;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var LocationsResource = function LocationsResource($resource) {
	  _classCallCheck(this, LocationsResource);

	  //const locationEndpoint = config.api.BASE_URL + '/locations';

	  var locationEndpoint = 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&langCode=EN&location=:lat,:lng';

	  var locationsResource = $resource(locationEndpoint, {
	    getExternalAddress: { method: 'GET', params: { lng: '@lng', lat: '@lat' } }
	  });

	  return locationsResource;
	};

	LocationsResource.$inject = ['$resource'];
	exports.default = LocationsResource;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _statistics = __webpack_require__(43);

	var _statistics2 = _interopRequireDefault(_statistics);

	var _administration = __webpack_require__(58);

	var _administration2 = _interopRequireDefault(_administration);

	var _supervisor = __webpack_require__(125);

	var _supervisor2 = _interopRequireDefault(_supervisor);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// TODO: eliminar
	//import { AdminComponent } from './admin.component';

	var admin = angular.module('mod.admin', [_statistics2.default, _administration2.default, _supervisor2.default])
	//.component('admin', AdminComponent)
	.name;

	exports.default = admin;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _center = __webpack_require__(44);

	var _center2 = _interopRequireDefault(_center);

	var _comparative = __webpack_require__(48);

	var _comparative2 = _interopRequireDefault(_comparative);

	var _newStatistics = __webpack_require__(52);

	var _newStatistics2 = _interopRequireDefault(_newStatistics);

	var _statistics = __webpack_require__(55);

	var _statistics2 = __webpack_require__(57);

	var _statistics3 = _interopRequireDefault(_statistics2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var statistics = angular.module('mod.admin.statistics', [_center2.default, _comparative2.default, _newStatistics2.default]).component('statistics', _statistics.StatisticsComponent).service('StatisticsService', _statistics3.default).name;

	exports.default = statistics;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _center = __webpack_require__(45);

	var _center2 = __webpack_require__(47);

	var _center3 = _interopRequireDefault(_center2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var statisticsCenter = angular.module('mod.admin.statistics.center', []).component('center', _center.StatisticsCenterComponent).service('StatisticsCenterService', _center3.default).name;

	exports.default = statisticsCenter;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StatisticsCenterComponent = undefined;

	var _center = __webpack_require__(46);

	var _center2 = _interopRequireDefault(_center);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var StatisticsCenterComponent = exports.StatisticsCenterComponent = {
	  controller: _center2.default,
	  templateUrl: 'app/modules/admin/statistics/center/center.html'
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var StatisticsCenterController = function () {
	  /** @ngInject */
	  StatisticsCenterController.$inject = ["StatisticsService", "StatisticsResource", "EstablishmentsResource", "$translate", "config", "$location", "$rootScope", "$scope", "$localStorage", "Statistics", "toastr", "AuthService", "AdministrationService"];
	  function StatisticsCenterController(StatisticsService, StatisticsResource, EstablishmentsResource, $translate, config, $location, $rootScope, $scope, $localStorage, Statistics, toastr, AuthService, AdministrationService) {
	    var _this = this;

	    _classCallCheck(this, StatisticsCenterController);

	    this.fromDate = null;
	    this.toDate = null;
	    this.rangeMaxDate = null;

	    this.updateDateRange = function () {
	      if (this.fromDate) {
	        var maxDate = new Date(this.fromDate);
	        maxDate.setDate(maxDate.getDate() + 30);
	        this.rangeMaxDate = maxDate;

	        if (this.toDate && this.toDate > maxDate) {
	          this.toDate = maxDate;
	        }
	      }
	    };

	    $scope.$watch(function () {
	      return _this.fromDate;
	    }, function (newValue, oldValue) {
	      if (newValue !== oldValue) {
	        _this.updateDateRange();
	      }
	    });

	    // private
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$localStorage = $localStorage;
	    this.toastr = toastr;
	    if ($localStorage.currentRole && typeof $localStorage.currentRole === "string" && ["ADMIN", "SUPERADMIN", "ROOT"].includes($localStorage.currentRole.toUpperCase())) {
	      var last_establishment = this.$localStorage.last_establishment ? this.$localStorage.last_establishment : false;
	      this.establishmentId = last_establishment ? last_establishment.id : false;
	      this.establishmentInUse = last_establishment ? last_establishment.name : false;
	    }
	    this.statisticsService = StatisticsService;
	    this.AdministrationService = AdministrationService;
	    this.statisticsResource = StatisticsResource;
	    this.Statistics = Statistics;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.AuthService = AuthService;
	    this.$translate = $translate;
	    this.isEmployee = true;
	    this.establishmentSelected = "";
	    this.currentRole = this.$localStorage.currentRole;

	    this.allTurns = 0;
	    this.attendedTurns = 0;
	    this.missingTurns = 0;
	    this.waitingTurns = 0;
	    this.manualTurns = 0;
	    this.resentTurns = 0;
	    this.allTurnsLP = 0;
	    this.attendedTurnsLP = 0;
	    this.missingTurnsLP = 0;
	    // this.waitingTurnsLP = 0;
	    this.manualTurnsLP = 0;
	    this.resentTurnsLP = 0;

	    this.isLoading = false;

	    var url = $location.url().substring(1).toUpperCase();
	    // Control of navbar menu page
	    this.$rootScope.currentMainPage = currentPage(0);
	    // Control of sidemenu page
	    this.currentPage = currentPage(1);
	    // Datepicker max date (yesterday)
	    var todayTimeStamp = new Date(); // Unix timestamp in milliseconds
	    var oneDayTimeStamp = 1000 * 60 * 60 * 24; // Milliseconds in a day
	    var diff = todayTimeStamp - oneDayTimeStamp;
	    this.maxDate = new Date(diff);
	    this.isModified = false;
	    this.template_date = "--/--/----";

	    this.lastTwoMonths = new Date();
	    this.lastTwoMonths.setMonth(this.lastTwoMonths.getMonth() - 2);
	    this.lastTwoMonths.setDate(1);
	    this.lastTwoMonths.setHours(0, 0, 0);
	    this.fromDate = this.lastTwoMonths;

	    this.rangeMaxDate = new Date();
	    this.rangeMaxDate.setDate(this.rangeMaxDate.getDate() - 1);
	    this.rangeMaxDate.setHours(23, 59, 59);
	    this.toDate = this.rangeMaxDate;

	    var statistics_options = ["waiting_time", "attending_time", "queues_user", "clients_attended_employee", "clients_attended_queue", "clients_waiting", "clients_absent", "clients_special", "clients_resent"];
	    this.statistics_xlx = [];
	    this.table = '<table id="datatableXLX">';
	    this._showMessageError = false;

	    function currentPage(index) {
	      var split_url = url.split("/");
	      return split_url[index];
	    }

	    function allowSelectRoles(role_option) {
	      this.is_allowed = this.AuthService.allowSelectRoles(role_option);
	      return this.is_allowed;
	    }

	    function initCharts() {
	      var _this2 = this;

	      var chartNames = ["waiting_time", "attending_time", "queues_user", "clients_attended_employee", "clients_attended_queue", "clients_waiting", "clients_absent", "clients_special", "clients_resent"];

	      chartNames.forEach(function (chart) {
	        _this2[chart] = {
	          activated: true,
	          no_data: false
	        };
	      });
	    }
	    // Chart colors
	    // this.colors = ['#97BBCD', '#5C626E', '#F7464A', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'];
	    // this.colors = {
	    //   data: ['#E6194B', '#3CB44B', '#FFE119', '#4363D8', '#F58231', '#911EB4', '#46F0F0', '#F032E6', '#BCF60C', '#FABEBE', '#008080', '#E6BEFF', '#9A6324', '#FFFAC8', '#800000', '#AAFFC3', '#808000', '#FFD8B1', '#000075', '#808080'],
	    //   total: '#97BBCD',
	    //   media: '#5C626E'
	    // }
	    this.time_options = {
	      legend: { display: true },
	      scales: {
	        yAxes: [{
	          type: "linear",
	          scaleLabel: {
	            display: true,
	            labelString: "tiempo (min)"
	          }
	        }]
	      }
	    };

	    this.number_options = {
	      legend: { display: true },
	      scales: {
	        yAxes: [{
	          scaleLabel: {
	            display: true,
	            labelString: "turnos"
	          },
	          ticks: { min: 0 }
	        }]
	      }
	    };
	    // public
	    var _waitingTimeStatistics = {};

	    function _createChart(_dataChart) {
	      this[_dataChart._type] = _dataChart;
	      var currentChart = {
	        data_type: _dataChart._type,
	        chart: this.$translate.instant("app.statistics." + _dataChart._type.toUpperCase()),
	        data: _dataChart
	      };
	      var index = statistics_options.indexOf(_dataChart._type);
	      this.statistics_xlx[index] = currentChart;
	      return this[_dataChart._type];
	    }

	    function _dateChanged() {
	      this.statistics_xlx = [];
	      this.table = '';
	      this.isModified = true;
	      var $this = this;
	      this["clients_hour"].activated = true;
	      var _noData = true;
	      // Get turns number by hour statistics
	      $this.Statistics.getTurnsByQueueByDate({
	        locationId: $this.establishmentId,
	        date: $this.date.toLocaleString()
	      }).$promise.then(function (response) {
	        if (response.queues.length > 0) _noData = false;
	        $this.turnsNumberStatistics = response;
	        $this._createChart("clients_hour", response, _noData);
	        $this.table = _createXLX({
	          statistics: $this.statistics_xlx,
	          kpis: {
	            TURNS: 0,
	            ATTENDED_TURNS: 0,
	            WAITING_TURNS: 0,
	            MISSING_TURNS: 0,
	            MANUAL_TURNS: 0,
	            RESENT_TURNS: 0
	          }
	        });
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR", "clients_hour");
	      });
	    }

	    function _calculateAmounts(response) {
	      var mediaIndex = response.series.indexOf("Media");
	      var totalIndex = response.series.indexOf("Total");

	      if (totalIndex !== -1 && Array.isArray(response.data[totalIndex])) {
	        var totalSeries = response.data[totalIndex];
	        return totalSeries.reduce(function (acc, v) {
	          return acc + (isNaN(v) ? 0 : v);
	        }, 0);
	      }

	      // Otherwise, remove the 'Media' series if present and sum the remaining series
	      if (mediaIndex !== -1) {
	        response.data.splice(mediaIndex, 1);
	      }
	      // Flatten one level (series -> values) and sum
	      var merged = response.data.flat(1);
	      return merged.reduce(function (accumulator, currentValue) {
	        return accumulator + (isNaN(currentValue) ? 0 : currentValue);
	      }, 0);
	    }

	    function _startAllStatistics(locationId) {
	      var _this3 = this;

	      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.fromDate;
	      var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.toDate;

	      this.isLoading = true;
	      this.cleanTurns();
	      to.setHours(23, 59, 59);
	      from.setHours(0, 0, 0);
	      this.statistics_xlx = [];
	      var $this = this;
	      var promises = [];

	      // Get waitting time statistics
	      promises.push($this.Statistics.getWaitingTime({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this._createChart(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_WAITING", "waiting");
	      }));

	      // Get atending time statistics
	      promises.push($this.Statistics.getServiceTime({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        // Tiempo de atención - debug log

	        $this._createChart(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_ATTENDING", "attending_time");
	      }));

	      // Get turns number statistics
	      promises.push($this.Statistics.getTurnsByQueue({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        // Prefer backend-provided total if available (reliable global count),
	        // otherwise compute from response.queues as before.
	        $this.allTurns = response.total != null ? response.total : _calculateAmounts(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_QUEUE", "clients_attended");
	      }));

	      promises.push($this.Statistics.getTurnsAttendedByEmployee({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this.employeeTurnsStatistics = response;
	        $this._createChart(response.employees);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_QUEUE", "clients_attended_employee");
	      }));

	      // Get turns number statistics
	      promises.push($this.Statistics.getTurnsAttendedByQueue({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this._createChart(response.queues);
	        $this.attendedTurns = _calculateAmounts(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_QUEUE", "clients_attended");
	      }));

	      // Get turns number statistics
	      promises.push($this.Statistics.getTurnsWaitingByQueue({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this.waitingTurns = _calculateAmounts(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_QUEUE", "clients_waiting");
	      }));

	      // Get turns clients absent
	      promises.push($this.Statistics.getTurnsAbsentByQueue({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this._createChart(response.queues);
	        $this.missingTurns = _calculateAmounts(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_ABSENT", "clients_absent");
	      }));

	      // Get turns clients special
	      promises.push($this.Statistics.getTurnsSpecialByQueue({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this._createChart(response.queues);
	        $this.manualTurns = _calculateAmounts(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_SPECIAL", "clients_special");
	      }));

	      // Get resent turns
	      promises.push($this.Statistics.getTurnsResentByQueue({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this._createChart(response.queues);
	        $this.resentTurns = _calculateAmounts(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_RESENT", "clients_resent");
	      }));

	      promises.push($this.Statistics.getTurnsByEmployee({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this.employeeTurnsStatistics = response;
	        $this[response.employees.clients._type] = response.employees.clients;
	        $this._createChart(response.employees.queues);
	        $this[response.employees.queues._type] = response.employees.queues;
	      }).catch(function () {
	        $this["clients_user"].activated = false;
	        $this["queues_user"].activated = false;
	        $this._handleCommonError("app.STATISTIC_ERROR_EMPLOYEE");
	      }));

	      Promise.allSettled(promises).then(function () {
	        // SIEMPRE calcular el total desde los breakdowns porque son más confiables
	        // que el valor que viene de getTurnsByQueue (que puede estar desactualizado o incompleto)
	        var computedTotal = ($this.attendedTurns || 0) + ($this.waitingTurns || 0) + ($this.missingTurns || 0) + ($this.manualTurns || 0) + ($this.resentTurns || 0);

	        // Usar el total del backend solo si existe Y es mayor que la suma de breakdowns
	        // (para casos donde hay turnos adicionales no clasificados)
	        if ($this.allTurns && $this.allTurns > computedTotal) {
	          // Mantener allTurns del backend
	        } else {
	          $this.allTurns = computedTotal;
	        }

	        var kpis = {
	          TURNS: $this.allTurns,
	          ATTENDED_TURNS: $this.attendedTurns,
	          WAITING_TURNS: $this.waitingTurns,
	          MISSING_TURNS: $this.missingTurns,
	          MANUAL_TURNS: $this.manualTurns,
	          RESENT_TURNS: $this.resentTurns
	        };

	        Promise.all(Object.entries(kpis).map(function (_ref) {
	          var _ref2 = _slicedToArray(_ref, 2),
	              key = _ref2[0],
	              value = _ref2[1];

	          return $this.$translate("app.statistics." + key).then(function (label) {
	            return [label, value];
	          });
	        })).then(function (translated) {
	          $this.table = _createXLX({
	            statistics: $this.statistics_xlx,
	            kpis: Object.fromEntries(translated)
	          });
	          _this3.isLoading = false;
	          $this.$scope.$applyAsync();
	        });
	      });
	    }

	    function _startAllStatisticsLP(locationId) {
	      var _this4 = this;

	      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.fromDate;
	      var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.toDate;

	      this.cleanTurns();
	      this.toDateLP = new Date(to);
	      this.fromDateLP = new Date(from);

	      to = new Date(this.toDateLP.setFullYear(this.toDateLP.getFullYear() - 1));
	      from = new Date(this.fromDateLP.setFullYear(this.fromDateLP.getFullYear() - 1));
	      this.statistics_xlx = [];
	      var $this = this;
	      // Get turns number statistics
	      $this.Statistics.getTurnsByQueue({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        _this4.allTurnsLP = _calculateAmounts(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_QUEUE", "clients_attended");
	      });

	      // Get turns clients absent
	      $this.Statistics.getTurnsAbsentByQueue({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        _this4.missingTurnsLP = _calculateAmounts(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_ABSENT", "clients_absent");
	      });

	      // Get turns clients special
	      $this.Statistics.getTurnsSpecialByQueue({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        _this4.manualTurnsLP = _calculateAmounts(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_SPECIAL", "clients_special");
	      });

	      // Get turns clients special
	      $this.Statistics.getTurnsResentByQueue({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        _this4.resentTurnsLP = _calculateAmounts(response.queues);
	      }).catch(function () {
	        $this._handleCommonError("app.STATISTIC_ERROR_RESENT", "clients_resent");
	      });

	      $this.Statistics.getTurnsByEmployee({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        _this4.attendedTurnsLP = _calculateAmounts(response.employees.clients);
	      }).catch(function () {
	        $this["clients_user"].activated = false;
	        $this["queues_user"].activated = false;
	        $this._handleCommonError("app.STATISTIC_ERROR_EMPLOYEE");
	      });
	    }

	    function _createXLX(_ref3) {
	      var statistics = _ref3.statistics,
	          kpis = _ref3.kpis;

	      var table = "<table id='datatableXLX'>";
	      var kpiKeys = Object.keys(kpis);
	      table += "<tr>";
	      kpiKeys.forEach(function (key) {
	        table += "<td><b>" + key + "</b></td>";
	      });
	      table += "</tr><tr>";
	      kpiKeys.forEach(function (key) {
	        table += "<td>" + kpis[key] + "</td>";
	      });
	      table += "</tr><tr></tr>";

	      angular.forEach(statistics, function (value) {
	        table += "<tr><td>" + value.chart + "</td></tr>";
	        table += "<tr><td></td>";
	        angular.forEach(value.data.labels, function (value_label) {
	          table += "<td>" + value_label + "</td>";
	        });
	        table += "</tr>";
	        angular.forEach(value.data.series, function (value_series, key) {
	          table += "<tr><td>" + value_series + "</td>";
	          for (var i = 0; i < value.data.excelData[key].length; i++) {
	            var default_value = 0;
	            if (value.data_type.indexOf("time") !== -1) default_value = hhmmss(0);
	            var value_data = !value.data.excelData[key][i] ? default_value : value.data.excelData[key][i];
	            table += "<td>" + value_data + "</td>";
	          }
	          table += "</tr>";
	        });
	        table += "<tr></tr>";
	      });
	      table += "</table>";
	      return table;
	    }

	    function cleanTurns() {
	      this.allTurns = 0;
	      this.attendedTurns = 0;
	      this.missingTurns = 0;
	      this.waitingTurns = 0;
	      this.manualTurns = 0;
	      this.resentTurns = 0;
	      this.allTurnsLP = 0;
	      this.attendedTurnsLP = 0;
	      this.missingTurnsLP = 0;
	      // this.waitingTurnsLP = 0;
	      this.manualTurnsLP = 0;
	      this.resentTurnsLP = 0;
	    }

	    function pad(num) {
	      return ("0" + num).slice(-2);
	    }

	    function hhmmss(secs) {
	      var minutes = Math.floor(secs / 60);
	      secs = secs % 60;
	      var hours = Math.floor(minutes / 60);
	      minutes = minutes % 60;
	      return pad(hours) + ":" + pad(minutes) + ":" + pad(secs);
	    }

	    function _handleCommonError(errorMessageKey) {
	      var choice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

	      var $this = this;
	      if (choice && $this[choice]) {
	        $this[choice].activated = false;
	      }
	      $this._showMessageError = true;
	      $this.$translate("" + errorMessageKey).then(function (errorMsg) {
	        $this.toastr.error(errorMsg, "Error");
	      });
	    }
	    // exports
	    angular.extend(this, {
	      initCharts: initCharts,
	      allowSelectRoles: allowSelectRoles,
	      cleanTurns: cleanTurns,
	      _startAllStatistics: _startAllStatistics,
	      _startAllStatisticsLP: _startAllStatisticsLP,
	      _waitingTimeStatistics: _waitingTimeStatistics,
	      _createChart: _createChart,
	      _dateChanged: _dateChanged,
	      _handleCommonError: _handleCommonError
	    });
	  }

	  _createClass(StatisticsCenterController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this5 = this;

	      var $this = this;
	      var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
	      var user_role = this.$localStorage.currentRole;
	      $this.initCharts();
	      // Load all establishments
	      $this.AdministrationService.getEstablishments(user_role, organizationId, "locations").then(function (result) {
	        _this5.establishments = result;
	      }).catch(function () {
	        $this._handleCommonError("app.API_ERROR");
	      });

	      $this.AdministrationService.getServices(user_role, organizationId, "queues").then(function (result) {
	        _this5.$localStorage.queues = result;
	      }).catch(function () {
	        _this5.fail = true;
	        $this._handleCommonError("app.services.ERROR_GETBYORGANIZATION");
	      });

	      if (!this.is_allowed && this.$localStorage.currentLocation) {
	        this.establishmentId = this.$localStorage.currentLocation.id;
	        this.establishmentInUse = this.$localStorage.currentLocation.name;
	      }
	      // Use user establishment or last establishment select by superadmin
	      if (this.establishmentId) {
	        this._startAllStatistics($this.establishmentId);
	        // this._startAllStatisticsLP($this.establishmentId);
	      }
	      $this.EstablishmentsResource.getDevicesByEstablishment({
	        id: this.establishmentId,
	        type: "kiosks"
	      }).$promise.then(function (result) {
	        _this5.$localStorage.kioskId = result[0].kioskId;
	      });
	    }
	  }, {
	    key: "selectLanguage",
	    value: function selectLanguage(lang) {
	      // Set the new idiom
	      this.$translate.use(lang);
	    }
	  }, {
	    key: "establishmentChanged",
	    value: function establishmentChanged() {
	      this.initCharts();
	      this.statistics_xlx = [];
	      this.$localStorage.last_establishment = this.establishmentSelected;
	      var current_establishment = JSON.parse(this.establishmentSelected);
	      this.establishmentId = current_establishment.id;
	      this.establishmentInUse = current_establishment.name;
	      // this._startAllStatistics(this.establishmentId);
	      this._startAllStatistics(this.establishmentId, this.fromDate, this.toDate);
	      // this._startAllStatisticsLP(this.establishmentId);
	    }
	  }, {
	    key: "establishmentChangeds",
	    value: function establishmentChangeds(establishment) {
	      var newObject = [];
	      establishment.forEach(function (element) {
	        var newElement = JSON.parse(element);
	        newObject.push(newElement);
	      });
	      this.initCharts();
	      this.statistics_xlx = [];

	      for (var index = 0; index < newObject.length; index++) {
	        var element = newObject[index];
	        this.$localStorage.last_establishment = element;
	        this.establishmentId = element.id;
	        this.establishmentInUse = element.name;
	        this._startAllStatistics(this.establishmentId);
	        // this._startAllStatisticsLP(this.establishmentId);
	      }
	    }
	  }, {
	    key: "search",
	    value: function search() {
	      if (this.isLoading) return;
	      this.isLoading = true;

	      this.allTurns = 0;
	      this.attendedTurns = 0;
	      this.missingTurns = 0;
	      this.waitingTurns = 0;
	      this.manualTurns = 0;
	      this.resentTurns = 0;
	      this.allTurnsLP = 0;
	      this.attendedTurnsLP = 0;
	      this.missingTurnsLP = 0;
	      // this.waitingTurnsLP = 0;
	      this.manualTurnsLP = 0;
	      this.resentTurnsLP = 0;
	      this.initCharts();
	      this._startAllStatistics(this.establishmentId, this.fromDate, this.toDate);
	    }
	  }]);

	  return StatisticsCenterController;
	}();

	StatisticsCenterController.$inject = ["StatisticsService", "StatisticsResource", "EstablishmentsResource", "$translate", "config", "$location", "$rootScope", "$scope", "$localStorage", "Statistics", "toastr", "AuthService", "AdministrationService"];

	exports.default = StatisticsCenterController;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var StatisticsCenterService =

	/** @ngInject */
	function StatisticsCenterService() {
	  _classCallCheck(this, StatisticsCenterService);
	};

	//StatisticsService.$inject = ['EmployeesResource'];

	exports.default = StatisticsCenterService;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _comparative = __webpack_require__(49);

	var _comparative2 = __webpack_require__(51);

	var _comparative3 = _interopRequireDefault(_comparative2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var comparative = angular.module('mod.admin.statistics.comparative', []).component('comparative', _comparative.ComparativeComponent).service('ComparativeService', _comparative3.default).name;

	exports.default = comparative;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ComparativeComponent = undefined;

	var _comparative = __webpack_require__(50);

	var _comparative2 = _interopRequireDefault(_comparative);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ComparativeComponent = exports.ComparativeComponent = {
	  controller: _comparative2.default,
	  templateUrl: 'app/modules/admin/statistics/comparative/comparative.html'
	};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ComparativeController = function () {

	  /** @ngInject */
	  ComparativeController.$inject = ["StatisticsService", "StatisticsResource", "AdministrationService", "$translate", "config", "$location", "$rootScope", "$scope", "$localStorage", "Statistics", "toastr", "AuthService"];
	  function ComparativeController(StatisticsService, StatisticsResource, AdministrationService, $translate, config, $location, $rootScope, $scope, $localStorage, Statistics, toastr, AuthService) {
	    _classCallCheck(this, ComparativeController);

	    // private
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$localStorage = $localStorage;
	    this.toastr = toastr;
	    // TODO: refactorizar
	    if ($localStorage.currentRole && typeof $localStorage.currentRole === 'string' && ['ADMIN', 'SUPERADMIN', 'ROOT', 'STATISTICS'].includes($localStorage.currentRole.toUpperCase())) {
	      var last_establishment = this.$localStorage.last_establishment ? this.$localStorage.last_establishment : false;
	      this.establishmentId = last_establishment ? last_establishment.id : false;
	      this.establishmentInUse = last_establishment ? last_establishment.name : false;
	    }
	    this.statisticsService = StatisticsService;
	    this.statisticsResource = StatisticsResource;
	    this.Statistics = Statistics;
	    this.AdministrationService = AdministrationService;
	    this.AuthService = AuthService;
	    this.$translate = $translate;
	    this.isEmployee = true;
	    var url = $location.url().substring(1).toUpperCase();
	    // Control of navbar menu page
	    this.$rootScope.currentMainPage = currentPage(0);
	    // Control of sidemenu page
	    this.currentPage = currentPage(1);
	    // Datepicker max date (yesterday)
	    var todayTimeStamp = new Date(); // Unix timestamp in milliseconds
	    var oneDayTimeStamp = 1000 * 60 * 60 * 24; // Milliseconds in a day
	    var diff = todayTimeStamp - oneDayTimeStamp;
	    this.maxDate = new Date(diff);
	    this.template_date = '--/--/----';
	    this.rangeMaxDate = new Date();
	    this.rangeMaxDate.setDate(this.rangeMaxDate.getDate() - 1);
	    this.lastTwoMonths = new Date();
	    this.lastTwoMonths.setMonth(this.lastTwoMonths.getMonth() - 2);
	    this.lastTwoMonths.setDate(1);
	    this.fromDate = this.lastTwoMonths;
	    this.toDate = this.rangeMaxDate;
	    this._showMessageError = false;

	    this.numOfComparatives = ['first', 'second'];
	    this.chartTypes = ['waiting', 'attending_time', 'clients_attended', 'clients_hour', 'clients_user', 'queues_user', 'clients_absent', 'clients_special'];
	    this.comparativesWithTypes = [];

	    function currentPage(index) {
	      var split_url = url.split('/');
	      return split_url[index];
	    }

	    function allowSelectRoles(role_option) {
	      this.is_allowed = this.AuthService.allowSelectRoles(role_option);
	      return this.is_allowed;
	    }

	    function initDataTypes() {
	      for (var i = 0; i < this.numOfComparatives.length; i++) {
	        this.comparativesWithTypes[this.numOfComparatives[i]] = [];
	        for (var j = 0; j < this.chartTypes.length; j++) {
	          this.comparativesWithTypes[this.numOfComparatives[i]][this.chartTypes[j]] = {
	            "activated": true,
	            "no_data": true
	          };
	        }
	      }
	    }

	    function initEstablishmentDataTypes(establishmentItem) {
	      for (var j = 0; j < this.chartTypes.length; j++) {
	        this.comparativesWithTypes[establishmentItem][this.chartTypes[j]] = {
	          "activated": true,
	          "no_data": true
	        };
	      }
	    }

	    function stopLoadingSpinner(type) {
	      for (var i = 0; i < this.numOfComparatives.length; i++) {
	        for (var j = 0; j < this.chartTypes.length; j++) {
	          if (this.numOfComparatives[i] === type) {
	            this.comparativesWithTypes[this.numOfComparatives[i]][this.chartTypes[j]] = {
	              "activated": false,
	              "no_data": true
	            };
	          }
	        }
	      }
	    }
	    // Chart colors
	    this.colors = ['#97BBCD', '#5C626E', '#F7464A', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'];
	    this.time_options = {
	      legend: { display: true },
	      scales: {
	        yAxes: [{
	          scaleLabel: {
	            display: true,
	            labelString: 'tiempo'
	          },
	          ticks: { min: 0 }
	        }]
	      }
	    };

	    this.number_options = {
	      legend: { display: true },
	      scales: {
	        yAxes: [{
	          scaleLabel: {
	            display: true,
	            labelString: 'turnos'
	          },
	          ticks: { min: 0 }
	        }]
	      }
	    };
	    // public
	    var _waitingTimeStatistics = {};

	    function _startAllStatistics(_establishmentOrder, locationId) {
	      var _this = this;

	      var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.fromDate;
	      var to = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.toDate;

	      var $this = this;
	      // Get waitting time statistics
	      $this.Statistics.getWaitingTime({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this.attendingTimeStatistics = response;
	        _this.comparativesWithTypes[_establishmentOrder][response.queues._type] = response.queues;
	      }).catch(function (err) {
	        console.log(err);
	        _this._showMessageError = true;
	        _this.comparativesWithTypes[_establishmentOrder]['waiting'].activated = false;
	        $this.$translate('app.STATISTIC_ERROR_WAITING').then(function (errorMsg) {
	          $this.toastr.error(errorMsg, 'Error');
	        });
	      });

	      // Get atending time statistics
	      $this.Statistics.getServiceTime({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this.attendingTimeStatistics = response;
	        _this.comparativesWithTypes[_establishmentOrder][response.queues._type] = response.queues;
	      }).catch(function (err) {
	        console.log(err);
	        _this._showMessageError = true;
	        _this.comparativesWithTypes[_establishmentOrder]['attending_time'].activated = false;
	        $this.$translate('app.STATISTIC_ERROR_ATTENDING').then(function (errorMsg) {
	          $this.toastr.error(errorMsg, 'Error');
	        });
	      });

	      // Get turns number statistics
	      $this.Statistics.getTurnsByQueue({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this.turnsNumberStatistics = response;
	        _this.comparativesWithTypes[_establishmentOrder][response.queues._type] = response.queues;
	      }).catch(function (err) {
	        console.log(err);
	        _this._showMessageError = true;
	        _this.comparativesWithTypes[_establishmentOrder]['clients_attended'].activated = false;
	        $this.$translate('app.STATISTIC_ERROR_QUEUE').then(function (errorMsg) {
	          $this.toastr.error(errorMsg, 'Error');
	        });
	      });

	      $this.Statistics.getTurnsAbsentByQueue({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this.turnsNumberStatistics = response;
	        _this.comparativesWithTypes[_establishmentOrder][response.queues._type] = response.queues;
	      }).catch(function (err) {
	        console.error(err);
	        _this._showMessageError = true;
	        _this.comparativesWithTypes[_establishmentOrder]['clients_absent'].activated = false;
	        $this.$translate('app.STATISTIC_ERROR_ABSENT').then(function (errorMsg) {
	          $this.toastr.error(errorMsg, 'Error');
	        });
	      });

	      // Get turns clients special
	      $this.Statistics.getTurnsSpecialByQueue({ locationId: locationId, from: from, to: to }).$promise.then(function (response) {
	        $this.turnsNumberStatistics = response;
	        _this.comparativesWithTypes[_establishmentOrder][response.queues._type] = response.queues;
	      }).catch(function (err) {
	        console.error(err);
	        _this._showMessageError = true;
	        _this.comparativesWithTypes[_establishmentOrder]['clients_special'].activated = false;
	        $this.$translate('app.STATISTIC_ERROR_SPECIAL').then(function (errorMsg) {
	          $this.toastr.error(errorMsg, 'Error');
	        });
	      });
	    }

	    // exports
	    angular.extend(this, {
	      allowSelectRoles: allowSelectRoles,
	      _startAllStatistics: _startAllStatistics,
	      _waitingTimeStatistics: _waitingTimeStatistics,
	      initDataTypes: initDataTypes,
	      initEstablishmentDataTypes: initEstablishmentDataTypes,
	      stopLoadingSpinner: stopLoadingSpinner
	    });
	  }

	  _createClass(ComparativeController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;

	      var $this = this;
	      var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
	      var user_role = this.$localStorage.currentRole;
	      $this.initDataTypes();
	      // Load all establishments
	      this.AdministrationService.getEstablishments(user_role, organizationId, 'locations').then(function (result) {
	        _this2.establishments = result;
	      }).catch(function (error) {
	        console.log(error);
	        _this2.$translate('app.API_ERROR').then(function (errorMsg) {
	          _this2.toastr.error(errorMsg, 'Error');
	        });
	      });

	      if (!this.is_allowed) {
	        this.establishmentId = this.$localStorage.currentLocation.id;
	      }
	      // Use user establishment or last establishment select by superadmin
	      if ($this.$localStorage.last_establishment) {
	        var last_establishment = $this.$localStorage.last_establishment;
	        if (_typeof($this.$localStorage.last_establishment) != 'object') {
	          last_establishment = JSON.parse($this.$localStorage.last_establishment);
	        }
	        var establishmentId = $this.firstEstablishment = last_establishment.id;
	        $this.establishmentInUse = last_establishment.name;
	        if (establishmentId) $this._startAllStatistics('first', establishmentId);
	      } else {
	        $this.stopLoadingSpinner('first');
	      }

	      if ($this.$localStorage.last_compare) {
	        var last_compare_establishment = $this.$localStorage.last_compare;
	        if (_typeof($this.$localStorage.last_compare) != 'object') {
	          last_compare_establishment = JSON.parse($this.$localStorage.last_compare);
	        }
	        var _establishmentId = $this.lastEstablishment = last_compare_establishment.id;
	        $this.establishmentInCompare = last_compare_establishment.name;
	        if (_establishmentId) $this._startAllStatistics('second', _establishmentId);
	      } else {
	        $this.stopLoadingSpinner('second');
	      }
	    }
	  }, {
	    key: 'selectLanguage',
	    value: function selectLanguage(lang) {
	      // Set the new idiom
	      this.$translate.use(lang);
	    }
	  }, {
	    key: 'establishmentChanged',
	    value: function establishmentChanged(selectedItem, establishmentItem) {
	      this.initEstablishmentDataTypes(establishmentItem);
	      var current_establishment = JSON.parse(selectedItem);
	      if (establishmentItem === 'first') {
	        this.establishmentSelected_first = '';
	        this.establishmentId = current_establishment.id;
	        this.establishmentInUse = current_establishment.name;
	        this.$localStorage.last_establishment = current_establishment;
	      } else {
	        this.establishmentSelected_second = '';
	        this.establishmentId = current_establishment.id;
	        this.establishmentInCompare = current_establishment.name;
	        this.$localStorage.last_compare = current_establishment;
	      }
	      this.establishmentSelected = undefined;
	      this._startAllStatistics(establishmentItem, this.establishmentId, this.fromDate, this.toDate);
	    }
	  }, {
	    key: 'search',
	    value: function search() {
	      this.initDataTypes();
	      this._startAllStatistics('first', this.$localStorage.last_establishment.id, this.fromDate, this.toDate);
	      this._startAllStatistics('second', this.$localStorage.last_compare.id, this.fromDate, this.toDate);
	    }
	  }]);

	  return ComparativeController;
	}();

	ComparativeController.$inject = ['StatisticsService', 'StatisticsResource', 'AdministrationService', '$translate', 'config', '$location', '$rootScope', '$scope', '$localStorage', 'Statistics', 'toastr', 'AuthService'];

	exports.default = ComparativeController;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ComparativeService =

	/** @ngInject */
	function ComparativeService() {
	  _classCallCheck(this, ComparativeService);
	};

	//ComparativeService.$inject = ['EmployeesResource'];

	exports.default = ComparativeService;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _newStatistics = __webpack_require__(53);

	var _newStatistics2 = __webpack_require__(54);

	var _newStatistics3 = _interopRequireDefault(_newStatistics2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var NewStatistics = angular.module('mod.admin.statistics.new', []).component('new', _newStatistics.NewStatisticsComponent).service('NewStatistics', _newStatistics3.default).name;

	exports.default = NewStatistics;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NewStatisticsComponent = undefined;

	var _newStatistics = __webpack_require__(54);

	var _newStatistics2 = _interopRequireDefault(_newStatistics);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var NewStatisticsComponent = exports.NewStatisticsComponent = {
	  controller: _newStatistics2.default,
	  templateUrl: 'app/modules/admin/statistics/new-statistics/new-statistics.html'
	};

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NewStatisticsController = function () {
	  /** @ngInject */
	  NewStatisticsController.$inject = ["config"];
	  function NewStatisticsController(config) {
	    _classCallCheck(this, NewStatisticsController);

	    this.dataTransformed = this.goToStatistics();
	    this.new_front = config.NEW_FRONT + '/statistics/organization?data=' + this.dataTransformed;
	  }

	  _createClass(NewStatisticsController, [{
	    key: 'goToStatistics',
	    value: function goToStatistics() {
	      var oldToken = localStorage.getItem('auth_token');
	      var employeeData = localStorage.getItem('qm_currentUser');
	      var employee = JSON.parse(employeeData);
	      var token = localStorage.getItem('newTokenInfo');
	      var kongToken = JSON.parse(localStorage.getItem('tokenKongInfo'));
	      var language = JSON.parse(localStorage.getItem('qm_preferredLanguage'));

	      var shareData = {
	        token: token,
	        language: language,
	        employee: {
	          id: employee.id,
	          locationId: employee.locationId,
	          role: employee.role,
	          username: employee.username,
	          organizationId: employee.organizationId
	        },
	        oldData: {
	          userId: employee.id,
	          id: oldToken
	        },
	        kongToken: {
	          access_token: kongToken.access_token,
	          expire_in: 8000,
	          token_type: 'bearer'
	        }
	      };

	      var data = JSON.stringify(shareData);

	      return encodeURIComponent(data);
	    }
	  }]);

	  return NewStatisticsController;
	}();

	NewStatisticsController.$inject = ['config'];

	exports.default = NewStatisticsController;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StatisticsComponent = undefined;

	var _statistics = __webpack_require__(56);

	var _statistics2 = _interopRequireDefault(_statistics);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var StatisticsComponent = exports.StatisticsComponent = {
	  controller: _statistics2.default,
	  templateUrl: 'app/modules/admin/statistics/statistics.html'
	};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var StatisticsController = function () {

	  /** @ngInject */
	  StatisticsController.$inject = ["StatisticsService", "StatisticsResource", "EstablishmentsResource", "$translate", "config", "$location", "$rootScope", "$scope", "$localStorage", "Statistics", "toastr", "AuthService"];
	  function StatisticsController(StatisticsService, StatisticsResource, EstablishmentsResource, $translate, config, $location, $rootScope, $scope, $localStorage, Statistics, toastr, AuthService) {
	    _classCallCheck(this, StatisticsController);

	    // private

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$localStorage = $localStorage;
	    this.toastr = toastr;
	    // TODO: refactorizar
	    if ($localStorage.currentRole && typeof $localStorage.currentRole === 'string' && ['ADMIN', 'SUPERADMIN', 'ROOT'].includes($localStorage.currentRole.toUpperCase())) {
	      var last_establishment = this.$localStorage.last_establishment ? this.$localStorage.last_establishment : false;
	      this.establishmentId = last_establishment ? last_establishment.id : false;
	      this.establishmentInUse = last_establishment ? last_establishment.name : false;
	    }
	    this.statisticsService = StatisticsService;
	    this.statisticsResource = StatisticsResource;
	    this.Statistics = Statistics;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.AuthService = AuthService;
	    this.$translate = $translate;
	    this.isEmployee = true;
	    var url = $location.url().substring(1).toUpperCase();
	    // Control of navbar menu page
	    this.$rootScope.currentMainPage = currentPage(0);
	    // Control of sidemenu page
	    this.currentPage = currentPage(1);

	    // Datepicker max date (yesterday)
	    var todayTimeStamp = +new Date(); // Unix timestamp in milliseconds
	    var oneDayTimeStamp = 1000 * 60 * 60 * 24; // Milliseconds in a day
	    var diff = todayTimeStamp - oneDayTimeStamp;
	    this.maxDate = new Date(diff);
	    this.isModified = false;
	    this.template_date = '--/--/----';

	    function currentPage(index) {
	      var split_url = url.split('/');
	      return split_url[index];
	    }
	  }

	  _createClass(StatisticsController, [{
	    key: 'selectLanguage',
	    value: function selectLanguage(lang) {
	      // Set the new idiom
	      this.$translate.use(lang);
	    }
	  }]);

	  return StatisticsController;
	}();

	StatisticsController.$inject = ['StatisticsService', 'StatisticsResource', 'EstablishmentsResource', '$translate', 'config', '$location', '$rootScope', '$scope', '$localStorage', 'Statistics', 'toastr', 'AuthService'];

	exports.default = StatisticsController;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var StatisticsService =

	/** @ngInject */
	function StatisticsService() {
	  _classCallCheck(this, StatisticsService);
	};

	//StatisticsService.$inject = ['EmployeesResource'];

	exports.default = StatisticsService;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _organizations = __webpack_require__(59);

	var _organizations2 = _interopRequireDefault(_organizations);

	var _establishments = __webpack_require__(63);

	var _establishments2 = _interopRequireDefault(_establishments);

	var _users = __webpack_require__(67);

	var _users2 = _interopRequireDefault(_users);

	var _validateUsers = __webpack_require__(71);

	var _validateUsers2 = _interopRequireDefault(_validateUsers);

	var _kiosks = __webpack_require__(75);

	var _kiosks2 = _interopRequireDefault(_kiosks);

	var _consumers = __webpack_require__(79);

	var _consumers2 = _interopRequireDefault(_consumers);

	var _screens = __webpack_require__(83);

	var _screens2 = _interopRequireDefault(_screens);

	var _services = __webpack_require__(87);

	var _services2 = _interopRequireDefault(_services);

	var _campaignes = __webpack_require__(91);

	var _campaignes2 = _interopRequireDefault(_campaignes);

	var _waitingareas = __webpack_require__(95);

	var _waitingareas2 = _interopRequireDefault(_waitingareas);

	var _priorities = __webpack_require__(99);

	var _priorities2 = _interopRequireDefault(_priorities);

	var _booking = __webpack_require__(103);

	var _booking2 = _interopRequireDefault(_booking);

	var _agendas = __webpack_require__(107);

	var _agendas2 = _interopRequireDefault(_agendas);

	var _newAgendas = __webpack_require__(111);

	var _newAgendas2 = _interopRequireDefault(_newAgendas);

	var _profile = __webpack_require__(114);

	var _profile2 = _interopRequireDefault(_profile);

	var _support = __webpack_require__(118);

	var _support2 = _interopRequireDefault(_support);

	var _administration = __webpack_require__(122);

	var _administration2 = __webpack_require__(124);

	var _administration3 = _interopRequireDefault(_administration2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var administration = angular.module('mod.admin.administration', [_organizations2.default, _establishments2.default, _validateUsers2.default, _users2.default, _kiosks2.default, _consumers2.default, _screens2.default, _services2.default, _campaignes2.default, _waitingareas2.default, _priorities2.default, _booking2.default, _agendas2.default, _profile2.default, _support2.default, _newAgendas2.default]).component('administration', _administration.AdministrationComponent).service('AdministrationService', _administration3.default).name;

	exports.default = administration;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _organizations = __webpack_require__(60);

	var _organizations2 = __webpack_require__(62);

	var _organizations3 = _interopRequireDefault(_organizations2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var organizations = angular.module('mod.admin.administration.organizations', []).component('organizations', _organizations.OrganizationsComponent).service('OrganizationsService', _organizations3.default).name;

	exports.default = organizations;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrganizationsComponent = undefined;

	var _organizations = __webpack_require__(61);

	var _organizations2 = _interopRequireDefault(_organizations);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var OrganizationsComponent = exports.OrganizationsComponent = {
	  controller: _organizations2.default,
	  templateUrl: 'app/modules/admin/administration/organizations/organizations.html'
	};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var OrganizationsController = function () {
	  /** @ngInject */
	  OrganizationsController.$inject = ["config", "$scope", "$rootScope", "OrganizationsResource", "EstablishmentsResource", "CategoryResource", "QueuesResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$location", "$http", "LocationsResource", "new_organization", "countryStatus", "pageSizeOptions", "organizationForms", "organizationEditForms"];
	  function OrganizationsController(config, $scope, $rootScope, OrganizationsResource, EstablishmentsResource, CategoryResource, QueuesResource, NgTableParams, $translate, toastr, $mdDialog, $location, $http, LocationsResource, new_organization, countryStatus, pageSizeOptions, organizationForms, organizationEditForms
	  //organization
	  ) {
	    var _this = this;

	    _classCallCheck(this, OrganizationsController);

	    // private
	    this.$rootScope = $rootScope;
	    this.$http = $http;
	    this.$scope = $scope;
	    this.isPre = config.IS_PRE;
	    this.OrganizationsResource = OrganizationsResource;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.CategoryResource = CategoryResource;
	    this.QueuesResource = QueuesResource;
	    this.selectedItemChange = selectedItemChange;
	    this.getOrganizations = getOrganizations;
	    this.config = config;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.$mdDialog = $mdDialog;
	    this.isAdding = false;
	    this.fail = false;
	    this.showActive = false;
	    this.isClickedEditing = false;
	    this.updatedImage = {};

	    this.cancel = cancel;
	    this.showDeleteConfirm = showDeleteConfirm;
	    this.del = del;
	    this.save = save;
	    this.add = add;
	    this.resetRow = resetRow;
	    // Control of sidemenu page
	    var url = $location.url().substring(1).toUpperCase();
	    this.$rootScope.currentPage = currentPage(1);
	    this.backgroundValid = true;
	    this.ticketLogoValid = true;
	    this.LocationsResource = LocationsResource;
	    this.coordinates = [];
	    this.latLong = [];
	    this.counter = 5;
	    this.new_organization = new_organization;
	    this.organizationForms = organizationForms;
	    this.organizationEditForms = organizationEditForms;
	    this.L = window.L;
	    // this.map = this.L.map("mapXD");
	    this.pageSizeOptions = pageSizeOptions;

	    this.organization = {};
	    this.rowFormOrgs = {};
	    this.typeInput = "";
	    this.countries = [];
	    this.countryStatus = countryStatus;
	    this.countryCodes = {
	      country: ""
	    };

	    this.pageSizeOptions = [3, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
	    this.editOrgs = false;
	    this.phoneCode = "";
	    this.previewImg = [];
	    this.phoneEmojiError = false;
	    this.addressEmojiError = false;
	    this.descriptionEmojiError = false;
	    var img_types = ["image/jpeg", "image/png", "image/jpg"];

	    // let map = this.L.map("map")

	    // Función para detectar emojis
	    var _containsEmojis = function _containsEmojis(text) {
	      var emojiRegex = /(?:\uD83D[\uDE00-\uDE4F])|(?:\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])|(?:\uD83D[\uDE80-\uDEFF])|[01EFu\{]\x2D(?:\uD83C\uDDFF)\]|[\u2600-\u26FF]|[027u\{]\x2D\u27BF\]/g;
	      return emojiRegex.test(text);
	    };

	    // Función para prevenir emojis en keydown
	    var _preventEmojis = function _preventEmojis(event) {
	      var char = String.fromCharCode(event.which);
	      if (_containsEmojis(char)) {
	        event.preventDefault();
	        return false;
	      }
	    };

	    // Función para manejar el pegado - corregida
	    var _handlePaste = function _handlePaste(event) {
	      setTimeout(function () {
	        var input = event.target;
	        var value = input.value;
	        if (_containsEmojis(value)) {
	          if (input.id === 'phone' || input.id === 'edit-phone') {
	            _this.phoneEmojiError = true;
	          } else if (input.id === 'address' || input.id === 'edit-address') {
	            _this.addressEmojiError = true;
	          } else if (input.id === 'description' || input.id === 'edit-description') {
	            _this.descriptionEmojiError = true;
	          }
	          input.value = value.replace(/(?:\uD83D[\uDE00-\uDE4F])|(?:\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])|(?:\uD83D[\uDE80-\uDEFF])|[01EFu\{]\x2D(?:\uD83C\uDDFF)\]|[\u2600-\u26FF]|[027u\{]\x2D\u27BF\]/g, '');
	          // Trigger ng-change manually
	          angular.element(input).triggerHandler('input');
	          _this.$scope.$apply();
	        } else {
	          if (input.id === 'phone' || input.id === 'edit-phone') {
	            _this.phoneEmojiError = false;
	          } else if (input.id === 'address' || input.id === 'edit-address') {
	            _this.addressEmojiError = false;
	          } else if (input.id === 'description' || input.id === 'edit-description') {
	            _this.descriptionEmojiError = false;
	          }
	          _this.$scope.$apply();
	        }
	      }, 0);
	    };

	    fetch('/assets/country_code.json').then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      _this.countries = json;
	      _this.countries.sort(function (a, b) {
	        return a.nombre.localeCompare(b.nombre);
	      });
	    }).catch(function (error) {
	      console.error(error);
	    });
	    /**
	     * Extracts the specified index from the URL path.
	     *
	     * @param {number} index - The index of the path segment to retrieve.
	     *
	     * @returns {string} - The path segment at the specified index in the URL.
	     */
	    function currentPage(index) {
	      var split_url = url.split("/");
	      return split_url[index];
	    }

	    /* only test mode */
	    config.DEBUG_ENABLED = false;
	    /* EOF test mode */

	    /**
	     * Updates the page size of the table and sets the counter to the new page size.
	     *
	     * @param {number} newPageSize - The new page size to set.
	     */
	    var pageSizeChanged = function pageSizeChanged(newPageSize) {
	      _this.tableParams.count(newPageSize);
	      _this.counter = newPageSize;
	    };
	    /**
	     * Creates a new NgTableParams instance using full options.
	     */
	    function _createUsingFullOptions() {
	      var initialParams = {
	        count: this.counter // initial page size
	      };
	      var initialSettings = {
	        // page size buttons (right set of buttons in demo)
	        counts: [],
	        // determines the pager buttons (left set of buttons in demo)
	        paginationMaxBlocks: 4,
	        paginationMinBlocks: 2,
	        dataset: this.data
	      };
	      this.tableParams = new NgTableParams(initialParams, initialSettings);
	      return this.tableParams;
	    }

	    /**
	    * Searches for and filters the organizations based on the provided query.
	    *
	    * @param {string} query - The search query.
	    * @returns {Array} - An array of filtered organizations.
	    */
	    function querySearchSelect(query) {
	      this.organizations.sort(function (a, b) {
	        if (a.name < b.name) {
	          return -1;
	        }
	        if (a.name > b.name) {
	          return 1;
	        }
	        return 0;
	      });
	      var results = query ? this.organizations.filter(createFilterFor(query)) : this.organizations;
	      return results;
	    }

	    /**
	     * Creates a filter function for the given query to match organization names.
	     *
	     * @param {string} query - The search query.
	     * @returns {function} - A filter function that matches organization names.
	     */
	    var createFilterFor = function createFilterFor(query) {
	      var lowercaseQuery = query.toLowerCase();
	      return function filterFn(item) {
	        var lowerCaseValue = item.name.toLowerCase();
	        return lowerCaseValue.indexOf(lowercaseQuery) === 0;
	      };
	    };

	    /**
	     * Adds a new template to the dataset and reloads the NgTableParams.
	     * @param {Object} new_template - The new template to be added.
	     */
	    function add(new_template) {
	      this.tableParams.settings().dataset.unshift(new_template);
	      this.tableParams.sorting({});
	      this.tableParams.page(1);
	      this.tableParams.reload();
	    }
	    /**
	     * Cancels the current operation and reinitializes the component.
	     */
	    function cancel() {
	      this.$onInit();
	    }
	    /**
	     * Deletes the specified row from the dataset, updates the original data, and reloads the table.
	     * @param {Object} row - The row to be deleted.
	     */
	    function del(row) {
	      var main_dataset = this.tableParams.settings().dataset;
	      var originalData = "";
	      angular.forEach(this.tableParams.settings().dataset, function (value, key) {
	        if (angular.equals(row, value)) {
	          main_dataset.splice(key, 1);
	          originalData = angular.copy(main_dataset);
	        }
	      });
	      this.originalData = originalData;
	      var this_param = this.tableParams;
	      this.tableParams.reload().then(function (data) {
	        if (data.length === 0 && this_param.total() > 0) {
	          this_param.page(this_param.page() - 1);
	          this_param.reload();
	        }
	      });
	      //this._deleteEstablishment(row);
	    }
	    /**
	     * Shows the zone form dialog. If an event is provided, it hides the element associated with the event, sets editOrgs to true, and shows the edit form. Otherwise, it initializes the address using coordinates, displays the dialog, and resets values on close.
	     * @param {Object} ev - The event triggering the function.
	     */
	    function _showZoneForm(ev) {
	      var _this2 = this;

	      var parent = this;
	      if (ev !== undefined) {
	        hideElement(ev.id);
	        this.editOrgs = true;
	        this._showZoneFormEdit(ev);
	      }
	      // _getAddress(parent.coordinates)
	      this.countryCodes.country = '+34';
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#myDialog",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this2;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        parent.editOrgs = false;
	        parent.previewImg = {};
	        // _getAddress(parent.coordinates);
	        parent._closeDialog();
	        parent.new_organization = {};
	        resetInputs();
	        parent.$onInit();
	      }, function () {
	        parent.editOrgs = false;
	        parent.previewImg = {};
	        // _getAddress(parent.coordinates);
	        parent._closeDialog();
	        parent.new_organization = {};
	        resetInputs();
	        parent.$onInit();
	      });
	    }

	    /**
	     * Shows the zone form dialog. If an event is provided, it hides the element associated with the event, sets editOrgs to true, and shows the edit form. Otherwise, it initializes the address using coordinates, displays the dialog, and resets values on close.
	     * @param {Object} ev - The event triggering the function.
	     */
	    function _editOrg(ev) {
	      var _this3 = this;

	      var parent = this;
	      hideElement(ev.id);
	      this.editOrgs = true;
	      // this._showZoneFormEdit(ev)
	      // _getAddress(parent.coordinates)
	      this.organization = angular.copy(ev);
	      this.organization.logo = ev.logo_link;
	      this.organization.background = ev.img_link;
	      this.countryCodes.country = this.organization.phone ? this.organization.phone.toString().slice(0, 3) : '+34';
	      this.organization.phone = this.organization.phone ? this.organization.phone.toString().slice(3) : null;
	      this.organizationEditForms.$error = {};
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#editDialog",
	        parent: angular.element(document.body),
	        targetEvent: this.organization,
	        controller: function controller() {
	          return _this3;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        parent.editOrgs = false;
	        parent.previewImg = {};
	        // _getAddress(parent.coordinates);
	        parent._closeDialog();
	        parent.organization = {};
	        delete parent.organizationSelected;
	        resetInputs();
	        parent.$onInit();
	      }, function () {
	        parent.editOrgs = false;
	        parent.previewImg = {};
	        // _getAddress(parent.coordinates);
	        parent._closeDialog();
	        parent.organization = {};
	        delete parent.organizationSelected;
	        resetInputs();
	        parent.$onInit();
	      });
	    }

	    /**
	     * Searches for the country code in the provided phone number. If the phone is a number, it converts it to a string. If the phone is undefined or null, the function returns without performing any action. It iterates through the list of countries to find the matching dial code, updates the phone code and country code, and updates the phone number without the dial code. If no match is found, it sets the country status to true.
	     * @param {string | number} phone - The phone number to search for the country code.
	     */
	    function _searchCountryCode(phone) {
	      var _this4 = this;

	      this.countryStatus = false;
	      if (typeof phone === "number") {
	        this.countryStatus = true;
	        phone = phone.toString();
	      } else if (phone === undefined || phone === null) {
	        return;
	      }

	      for (var i = 0; i < this.countries.length; i++) {
	        if (phone.indexOf(this.countries[i].dial_code) > -1) {
	          this.phoneCode = this.countries[i].dial_code;
	          break;
	        }
	      }
	      var countriesCode = this.countries.filter(function (country) {
	        return country.dial_code === _this4.phoneCode;
	      });

	      if (countriesCode.length > 0) {
	        this.countryCodes.country = countriesCode[0].dial_code;
	        phone = phone.replace(this.phoneCode, "");
	        this.new_organization.phone = phone;
	      } else {
	        this.countryStatus = true;
	      }
	    }
	    /**
	     * Shows the zone form for editing an organization. If the organization has a location, it retrieves the address and sets up a marker on the map. It copies the organization data for editing, including the logo and background links. The function also searches for the country code in the organization's phone number.
	     * @param {Object} org - The organization data to be edited.
	     */
	    function _showZoneFormEdit(org) {
	      // if (org.location !== undefined) {
	      //   _getAddress(org.location.coordinates);
	      //   let marker = this.L.marker(org.location.coordinates, {
	      //     title: "Resource Location",
	      //     alt: "Resource Location",
	      //     riseOnHover: true,
	      //   }).bindPopup("<input type='button' value='Delete this marker' class='marker-delete-button'/>");

	      //   marker.addTo(map);
	      //   map.setView(org.location.coordinates, 15);
	      //   this._getAddress(org.location.coordinates);
	      // }

	      this.organization = angular.copy(org);
	      this.organization.logo = org.logo_link;
	      this.organization.background = org.img_link;
	      this._searchCountryCode(org.phone);
	    }
	    /**
	     * Resets the error messages and styling for form inputs.
	     */
	    var resetInputs = function resetInputs() {
	      var errNameElement = document.getElementById("err_name");
	      if (errNameElement) {
	        errNameElement.style.display = "none";
	      }
	      document.getElementById("name").parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	      document.getElementById("err_phone").style.display = "none";
	      document.getElementById("phone").parentElement.parentElement.children[0].classList.remove("md-input-invalid");

	      document.getElementById("err_address").style.display = "none";
	      document.getElementById("address").parentElement.parentElement.children[0].classList.remove("md-input-invalid");

	      document.getElementById("err_description").style.display = "none";
	      document.getElementById("description").parentElement.parentElement.children[0].classList.remove("md-input-invalid");

	      document.getElementById("logo").parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	      document.getElementById("err_logo").style.display = "none";

	      document.getElementById("background").parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	      document.getElementById("err_background").style.display = "none";

	      // Reset emoji error flags
	      _this.phoneEmojiError = false;
	      _this.addressEmojiError = false;
	      _this.descriptionEmojiError = false;
	    };

	    /**
	     * Shows a delete dialog.
	     * @param {Object} ev - The event object.
	     */
	    function ShowDeleteDialog(ev) {
	      var _this5 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#deleteDialog",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this5;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      });
	    }
	    /**
	     * Shows a delete confirmation dialog.
	     * @param {Object} ev - The event object.
	     */
	    function showDeleteConfirm(ev) {
	      var current_scope = this;
	      hideElement(ev.id);
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.DELETE")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        current_scope._deleteEstablishment(ev);
	      });
	    }
	    /**
	     * Hides an HTML element by setting its display property to "none".
	     * @param {string} id - The ID of the HTML element to hide.
	     */
	    function hideElement(id) {
	      var menu = document.getElementById("" + id);
	      if (menu) {
	        menu.style.display = "none";
	      }
	    }
	    /**
	     * Updates specific properties of a row and triggers the save operation.
	     * @param {Object} row - The data row to be updated.
	     * @param {Object} rowForm - The form associated with the data row.
	     * @param {boolean} state - The new state to be set for the specified type.
	     * @param {string} type - The type of property to be updated.
	     *   Possible values: "hasBooking", "isActiveFromApp", "waitingPeople", "showInstrucciones".
	     * @returns {void}
	     */
	    function updateIcons(row, rowForm, state, type) {
	      if (type === "hasBooking") {
	        row.hasBooking = state;
	        this.disableAllBokititServicesByOrganization(row);
	      }
	      if (type === "isActiveFromApp") {
	        row.isActiveFromApp = state;
	      }
	      if (type === "waitingPeople") {
	        row.waitingPeople = state;
	      }
	      if (type === "showInstrucciones") {
	        row.showInstrucciones = state;
	      }
	      this.save(row, rowForm);
	    }
	    /**
	     * Disables all Bokitit services associated with the specified organization.
	     * @param {Object} value - The organization for which Bokitit services should be disabled.
	     * @returns {void}
	     */
	    function disableAllBokititServicesByOrganization(value) {
	      var ev = this;
	      ev.OrganizationsResource.getServicesByOrganization({ id: value.id }).$promise.then(function (result) {
	        if (value.hasBooking === false) {
	          result.map(function (disableBokitit) {
	            disableBokitit.establishments.map(function (getQueueID) {
	              ev.QueuesResource.asignedQueueServices({ id: getQueueID.queueId }, {
	                hasBokititServices: false
	              }).$promise.then(function () {}).catch(function (error) {
	                console.error(error);
	              });
	            });
	          });
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	    /**
	     * Saves the changes made to the organization, updating its properties and handling file uploads.
	     * @param {Object} row - The organization data to be saved.
	     * @param {Object} rowForm - The form associated with the organization data.
	     * @returns {void}
	     */
	    function save(row, rowForm) {
	      var normal_name = row.name.replace(new RegExp(" ", "g"), "_");

	      if (row.background && !row.background.base64) {
	        row.img_link = row.background;
	        delete row.background;
	      }
	      if (row.logo && !row.logo.base64) {
	        row.logo_link = row.logo;
	        delete row.logo;
	      }
	      if (row.style && !row.style.base64) {
	        row.style_link = row.style;
	        delete row.style;
	      } else if (row.style && row.style.base64) {
	        row.style.organizationName = normal_name;
	        row.style.type = row.style.filetype.split("/")[1];
	      }
	      var originalRow = this.resetRow(row, rowForm);
	      this.isAdding = false;

	      this._updateOrganization(originalRow, row);
	    }
	    /**
	     * Resets the state of a row, either by restoring its original values or removing a newly added row.
	     * @param {Object} row - The organization data to be reset.
	     * @param {Object} rowForm - The form associated with the organization data.
	     * @returns {Object} - The original values of the row before editing or an empty object for a new row.
	     */
	    function resetRow(row, rowForm) {
	      var row_isAdding = this.isAdding;
	      if (row_isAdding) {
	        this.originalData = angular.copy(this.tableParams.settings().dataset);
	      }
	      var return_value = "";
	      row.isEditing = false;
	      rowForm.$setPristine();
	      angular.forEach(this.originalData, function (value) {
	        if (!row_isAdding && row.id === value.id) {
	          return_value = value;
	        } else if (row_isAdding && value.id === "") {
	          return_value = value;
	        }
	      });
	      return return_value;
	    }

	    function getOrganizations() {
	      var _this6 = this;

	      // Load activate queues by employee
	      this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
	        result.reverse().map(function (organization) {
	          if (organization.background) delete organization.background;
	          if (organization.logo) delete organization.logo;
	          if (organization.style) delete organization.style;
	        });
	        _this6.fail = false;
	        _this6.data = result;

	        _this6.data.sort(function (a, b) {
	          if (a.name < b.name) {
	            return -1;
	          }
	          if (a.name > b.name) {
	            return 1;
	          }
	          return 0;
	        });

	        _this6.originalData = angular.copy(result);
	        _this6.organizations = result;
	        _this6._createUsingFullOptions();
	      }).catch(function (error) {
	        console.error(error);
	        _this6.fail = true;
	        _this6.$translate("app.ERROR_GETORGANIZATION").then(function (errorMsg) {
	          _this6.toastr.error(errorMsg, "Error");
	        });
	      });
	    }

	    /**
	     * Creates a new organization by sending a request to the server.
	     * @param {Object} organization - The organization data to be created.
	     */
	    function _createOrganization(organization) {
	      var _this7 = this;

	      var succesMsg = $translate.instant("app.SUCCESS");
	      var ev = this;
	      ev.OrganizationsResource.create({}, organization).$promise.then(function (result) {
	        ev.new_organization = {}; // this resets the model
	        ev.organizationForms.$setPristine(); // this resets the form itself
	        ev.organizationForms.$setUntouched(); // this resets the form itself
	        ev.add(result);
	        _this7.$translate("app.organizations.SUCCESS_CREATE").then(function (successMsg) {
	          _this7.toastr.success(successMsg, succesMsg);
	        });
	      }).catch(function (error) {
	        console.error(error);
	        _this7.fail = true;
	        _this7.$translate("app.organizations.ERROR_CREATE").then(function (errorMsg) {
	          _this7.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Updates an existing organization by sending a request to the server.
	     * @param {Object} originalRow - The original organization data before the update.
	     * @param {Object} row - The updated organization data.
	     */
	    function _updateOrganization(originalRow, row) {
	      var _this8 = this;

	      var succesMsg = $translate.instant("app.SUCCESS");
	      var current_organizationm_data = row;
	      row.organizationId = row.id;
	      var organizationId = row.organizationId;
	      this.OrganizationsResource.update({ id: organizationId }, current_organizationm_data).$promise.then(function (result) {
	        row.img_link = row.img_link != result.img_link ? result.img_link : row.img_link;
	        row.logo_link = row.logo_link != result.logo_link ? result.logo_link : row.logo_link;
	        row.phone = row.phone != result.phone ? result.phone : row.phone;
	        row.location = row.location != result.location ? result.location : row.location;
	        angular.extend(originalRow, row);
	        _this8._closeDialog();
	        _this8.$onInit();
	        _this8.$translate("app.organizations.SUCCESS_UPDATE").then(function (successMsg) {
	          _this8.toastr.success(successMsg, succesMsg);
	        });
	      }).catch(function (error) {
	        console.error(error);
	        _this8.fail = true;
	        _this8.$translate("app.organizations.ERROR_UPDATE").then(function (errorMsg) {
	          _this8.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Opens a file input dialog to choose a file by triggering a click event on the input element with the specified name.
	     * @param {string} name - The id attribute of the file input element to open.
	     */
	    function abrirArchivo(name) {
	      document.getElementById(name).click();
	    }
	    /**
	     * Deletes an establishment by making a request to the server using the OrganizationsResource service.
	     * @param {Object} organization - The organization object representing the establishment to be deleted.
	     */
	    function _deleteEstablishment(organization) {
	      var _this9 = this;

	      this.OrganizationsResource.destroy({ id: organization.id }).$promise.then(function () {
	        _this9.$translate("app.administration.DELETE_OK").then(function (msg) {
	          _this9.toastr.success(msg, $translate.instant("app.administration.DELETE_SUCCESS"));
	        });
	        _this9.del(organization);
	      }).catch(function (error) {
	        console.error(error);
	        _this9.fail = true;
	        _this9.$translate("app.organizations.ERROR_DELETE").then(function (errorMsg) {
	          _this9.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Displays detailed information about an organization by showing a dialog.
	     * @param {Object} organization - The organization object to display detailed information about.
	     */
	    function _detailOrganization(organization) {
	      if (organization.isEditing !== true) {
	        this.current_organization = organization;
	        this._showDetailDialog();
	      }
	    }

	    //   if (!this.editOrgs) {
	    //     if (navigator.geolocation) {
	    //       success()
	    //         .then((position) => {
	    //           this.coordinates = [position.coords.latitude, position.coords.longitude];
	    //           let marker = this.L.marker(this.coordinates, {
	    //             title: "Resource Location",
	    //             alt: "Resource Location",
	    //             riseOnHover: true,
	    //             // draggable: true,
	    //           }).bindPopup("<input type='button' value='Delete this marker' class='marker-delete-button'/>");
	    //           // marker.on('dragend', function (e) {
	    //           //   this.coordinates = [e.target._latlng.lat, e.target._latlng.lng];
	    //           // });
	    //           marker.addTo(map);
	    //           map.setView(this.coordinates, 15);
	    //         })
	    //         .catch(() => {
	    //           alert($translate.instant("app.organizations.ERROR_GEO"));
	    //         });
	    //     } else {
	    //       alert("puedes obtener la geo")
	    //     }

	    //   }
	    //   /**
	    //    * Returns a Promise that resolves with the current geolocation position.
	    //    * @returns {Promise} A Promise that resolves with the geolocation position.
	    //    * @throws {Error} If the geolocation information cannot be obtained.
	    //    */
	    //   function success() {
	    //     return new Promise((resolve, reject) =>
	    //       navigator.geolocation.getCurrentPosition(resolve, reject)
	    //     );
	    //   }

	    // this.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {}).addTo(
	    //   map
	    // );

	    // const searchbox = this.L.control.searchbox({
	    //   position: 'topright',
	    //   expand: 'left',
	    //   width: '450px',
	    //   autocompleteFeatures: ['setValueOnClick']
	    // }).addTo(map);
	    // searchbox.onInput("keyup", function () {
	    //   const value = searchbox.getValue();
	    //   const url = `https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?token=AAPKbb4bbdb7e9754aac876df0dde36ba369-6OEhb3AW63j2zYWh9JA7VqLetLSdQrpar8keVrL3y11iGJOWq6_Sbbf_7tO_V8U&f=pjson&singleLine=${value}`;
	    //   fetch(url, {
	    //     method: 'GET',
	    //     headers: {
	    //       'Content-Type': 'application/json',
	    //     },
	    //   })
	    //     .then((response) => response.json())
	    //     .then((data) => {
	    //       data.candidates
	    //       searchbox.setItems(data.candidates.map((item) => item.address));

	    //       data.candidates.map((item) => {
	    //         searchbox.onClickedItem(item.address, () => {
	    //           searchbox.hide();
	    //           const lat = item.location.y;
	    //           const lng = item.location.x;
	    //           this.coordinates = [lat, lng];
	    //           map.setView(this.coordinates, 15);
	    //           searchbox.setValue(item.address);
	    //           searchbox.clearItems();
	    //         })
	    //       })

	    //     })
	    //     .catch((error) => {
	    //       console.error('Error:', error);
	    //     });
	    // });

	    // searchbox.onButton("click", search);

	    // function search() {
	    //   setTimeout(function () {
	    //     searchbox.hide();
	    //     searchbox.clear();
	    //   }, 600);
	    // }

	    // const popup = this.L.popup();

	    // const onMapClick = (e) => {
	    //   const lat = e.latlng.lat;
	    //   const lng = e.latlng.lng;

	    //   this.coordinates = [lat, lng];
	    //   _getAddress(this.coordinates, e);
	    // }

	    // map.on("click", onMapClick);
	    /**
	     * Retrieves the address for the given coordinates using reverse geocoding.
	     * @function
	     * @name _getAddress
	     * @param {number[]} coordinates - The coordinates [longitude, latitude] for reverse geocoding.
	     * @param {Object} [e] - Event object, optional.
	     * @throws {Error} If there is an issue with fetching or processing the reverse geocoding data.
	     */
	    // const _getAddress = (coordinates, e) => {
	    //   const url = `https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&langCode=EN&location=${coordinates[1]},${coordinates[0]}&f=json&token=AAPKbb4bbdb7e9754aac876df0dde36ba369-6OEhb3AW63j2zYWh9JA7VqLetLSdQrpar8keVrL3y11iGJOWq6_Sbbf_7tO_V8U`
	    //   fetch(url, {
	    //     method: "GET",
	    //   })
	    //     .then((response) => response.json())
	    //     .then((data) => {
	    //       const address = data.address;
	    //       const longLabel = address.LongLabel;
	    //       const addressElement = document.querySelector("#address");
	    //       addressElement.value = longLabel;
	    //       addressElement.focus();

	    //       this.new_organization.address = longLabel
	    //       if (e !== undefined) {
	    //         popup
	    //           .setLatLng(e.latlng)
	    //           .setContent(`You address is: ${longLabel}`)
	    //           .openOn(map);
	    //       }
	    //     }
	    //     ).catch((error) => {
	    //       console.error(error);
	    //     });
	    // }
	    // /**
	    //  * Retrieves the address for the given coordinates using reverse geocoding and updates the address in a modal.
	    //  * @function
	    //  * @name _getAddressModal
	    //  * @param {number[]} coordinates - The coordinates [longitude, latitude] for reverse geocoding.
	    //  * @throws {Error} If there is an issue with fetching or processing the reverse geocoding data.
	    //  */
	    // const _getAddressModal = (coordinates) => {
	    //   this.latLong = coordinates;
	    //   const url = `https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&langCode=EN&location=${coordinates[1]},${coordinates[0]}&f=json&token=AAPKbb4bbdb7e9754aac876df0dde36ba369-6OEhb3AW63j2zYWh9JA7VqLetLSdQrpar8keVrL3y11iGJOWq6_Sbbf_7tO_V8U`
	    //   fetch(url, {
	    //     method: "GET",
	    //   })
	    //     .then((response) => response.json())
	    //     .then((data) => {
	    //       const address = data.address;
	    //       const longLabel = address.LongLabel;
	    //       const addressElement = document.querySelector("#address_modal");
	    //       addressElement.value = longLabel;
	    //       addressElement.focus();

	    //       this.new_organization.address = longLabel

	    //     }
	    //     ).catch((error) => {
	    //       console.error(error);
	    //     });
	    // }
	    // /**
	    //  * Displays the detailed address information for an organization on a map, allowing interaction such as dragging a marker to set the location.
	    //  * @function
	    //  * @name _detailAddress
	    //  * @param {Object} organization - The organization object for which the detailed address information is displayed.
	    //  * @param {Object} rowForm - The form object associated with the organization row.
	    //  * @throws {Error} If there are issues with fetching or processing geolocation or reverse geocoding data.
	    //  */
	    // const _detailAddress = (organization, rowForm) => {
	    //   rowForm.$invalid = false
	    //   $scope.disabled = false;

	    //   if (organization.location !== undefined) {
	    //     let marker = this.L.marker([organization.location.coordinates[0], organization.location.coordinates[1]]).addTo(this.map);
	    //     this.map.setView([organization.location.coordinates[0], organization.location.coordinates[1]], 15);
	    //     this.map.on('click', function (e) {
	    //       marker.setLatLng(e.latlng);
	    //       const coordinatesOrgs = [e.latlng.lat, e.latlng.lng];
	    //       _getAddressModal(coordinatesOrgs);
	    //     });
	    //     const coordinatesOrgs = [organization.location.coordinates[0], organization.location.coordinates[1]];
	    //     marker.bindPopup(`<b>Organization name: ${organization.name}</b><br>`).openPopup();
	    //     this._getAddress(coordinatesOrgs);
	    //     this.L.tileLayer('http://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {}).addTo(
	    //       this.map
	    //     );
	    //     return;
	    //   }

	    //   // if (navigator.geolocation) {
	    //   //   success()
	    //   //     .then((position) => {
	    //   //       let marker = this.L.marker([position.coords.latitude, position.coords.longitude], {
	    //   //         draggable: true,
	    //   //       }).addTo(this.map);
	    //   //       marker.on('dragend', function (e) {
	    //   //         _getAddress([e.target._latlng.lat, e.target._latlng.lng], organization);
	    //   //       });
	    //   //       this.map.setView([position.coords.latitude, position.coords.latitude,], 15);
	    //   //       this.coordinates = [position.coords.latitude, position.coords.longitude];
	    //   //       marker.bindPopup(`<b>This is your location</b><br>`).openPopup();
	    //   //       _getAddress(this.coordinates);
	    //   //     })
	    //   //     .catch(() => {
	    //   //       alert($translate.instant("app.organizations.ERROR_GEO"));
	    //   //     });
	    //   // }
	    //   // function success() {
	    //   //   return new Promise((resolve, reject) =>
	    //   //     navigator.geolocation.getCurrentPosition(resolve, reject)
	    //   //   );
	    //   // }
	    //   // this.L.tileLayer('http://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {}).addTo(
	    //   //   this.map
	    //   // );

	    //   // const popup = this.L.popup();

	    //   // const onMapClick = (e) => {
	    //   //   const lat = e.latlng.lat;
	    //   //   const lng = e.latlng.lng;

	    //   //   this.coordinates = [lat, lng];
	    //   //   this.latLong = [e.latlng.lat, e.latlng.lng];
	    //   //   _getAddress(this.coordinates, organization);
	    //   //   popup
	    //   //     .setLatLng(e.latlng)
	    //   //     .setContent("You map at " + e.latlng.toString())
	    //   //     .openOn(map);
	    //   // }

	    //   // this.map.on("click", onMapClick);

	    //   // const _getAddress = (coordinates, organization) => {
	    //   //   const url = `https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&langCode=EN&location=${coordinates[1]},${coordinates[0]}`
	    //   //   fetch(url, {
	    //   //     method: "GET",
	    //   //   })
	    //   //     .then((response) => response.json())
	    //   //     .then((data) => {
	    //   //       const address = data.address;
	    //   //       const longLabel = address.LongLabel;
	    //   //       this.new_organization.address = longLabel
	    //   //       const addressElement = document.querySelector("#address_modal");
	    //   //       addressElement.value = longLabel;
	    //   //       organization.address = longLabel
	    //   //       this.new_organization.address = longLabel

	    //   //       addressElement.focus();
	    //   //       this.data.map((row) => {
	    //   //         if (organization.name === row.name) {
	    //   //           row.address = longLabel
	    //   //           row.isEditing = true
	    //   //         }
	    //   //       })
	    //   //       organization.isEditing = true
	    //   //     }).catch((error) => {
	    //   //       console.error(error);
	    //   //     });
	    //   // }

	    // }

	    /**
	    * Handles the change of the selected item in the organization dropdown.
	    * 
	    * @param {Object} item - The selected organization item.
	    * 
	    * If a valid organization item is provided, this function updates various properties
	    * such as 'currentOrganization', 'organizationId', and 'organizationInUse' based on
	    * the selected organization. It then triggers the retrieval of establishments
	    * associated with the selected organization. If no item is provided, it resets the
	    * organization-related properties and retrieves establishments for the current user's
	    * organization.
	    */
	    function selectedItemChange(item) {
	      var _this10 = this;

	      if (item !== undefined) {
	        var Organization = JSON.parse(JSON.stringify(item));

	        var current_organization = Organization;
	        this.currentOrganization = current_organization;
	        this.organizationId = current_organization.id;
	        this.organizationInUse = current_organization.name;
	        this.OrganizationsResource.getOrganizationData({ id: this.organizationId }).$promise.then(function (result) {
	          _this10.fail = false;
	          _this10.data = [result];
	          _this10.originalData = [result];
	          _this10._createUsingFullOptions();
	        }).catch(function (error) {
	          console.error(error);
	          _this10.$translate("app.ERROR_GETORGANIZATION").then(function (errorMsg) {
	            _this10.toastr.error(errorMsg, "Error");
	          });
	        });
	        return;
	      } else {
	        this.getOrganizations();
	      }
	    }

	    // /**
	    //  * Displays a map dialog for the given organization, showing detailed address information and allowing interaction with the map.
	    //  * @function
	    //  * @name _showMapDialog
	    //  * @param {Object} org - The organization object for which the map dialog is displayed.
	    //  * @param {Object} rowForm - The form object associated with the organization row.
	    //  * @throws {Error} If there are issues with fetching or processing geolocation or reverse geocoding data.
	    //  */
	    // function _showMapDialog(org, rowForm) {
	    //   _detailAddress(org, rowForm)
	    //   $mdDialog
	    //     .show({
	    //       preserveScope: true, // do not forget this if use parent scope
	    //       hasBackdrop: true,
	    //       contentElement: "#showMapDialog",
	    //       parent: angular.element(document.body),
	    //       controller: () => this,
	    //       controllerAs: "ctrl",
	    //       clickOutsideToClose: true,
	    //     })
	    // }
	    /**
	     * Displays a detailed dialog for the organization.
	     * @function
	     * @name _showDetailDialog
	     * @param {Object} ev - The event object that triggered the opening of the detail dialog.
	     * @throws {Error} If there are issues with showing the detailed dialog.
	     */
	    function _showDetailDialog(ev) {
	      var _this11 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#dialog_detail_organization",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this11;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      });
	    }
	    /**
	     * Displays a dialog for changing images associated with the organization.
	     * @function
	     * @name _changeImageDialog
	     * @param {Object} org - The organization object for which the image dialog is displayed.
	     * @param {Object} rowForm - The form object associated with the organization row.
	     * @param {string} typeInput - The type of image input to be changed (e.g., 'logo' or 'background').
	     * @throws {Error} If there are issues with showing the image change dialog or processing the image change.
	     */
	    function _changeImageDialog(org, rowForm, typeInput) {
	      var _this12 = this;

	      this.typeInput = typeInput;
	      this.organization = org;
	      this.rowFormOrgs = rowForm;
	      // _detailAddress(org, rowForm)
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#changeImageDialog",
	        parent: angular.element(document.body),
	        controller: function controller() {
	          return _this12;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      });
	    }
	    /**
	     * Deletes the specified type of image link associated with the organization row and saves the changes.
	     * @function
	     * @name deleteImage
	     * @param {Object} row - The organization row for which the image link is deleted.
	     * @param {Object} rowForm - The form object associated with the organization row.
	     * @param {string} type - The type of image link to be deleted (e.g., 'img_link', 'logo_link', or 'style_link').
	     * @throws {Error} If there are issues with deleting the image link or saving the changes.
	     */
	    function deleteImage(row, rowForm, type) {
	      if (type === "img_link") {
	        row.img_link = "";
	      }
	      if (type === "logo_link") {
	        row.logo_link = "";
	      }
	      if (type === "style_link") {
	        row.style_link = "";
	      }
	      this.save(row, rowForm);
	    }
	    /**
	     * Updates the organization's images based on the specified type of image input.
	     * @function
	     * @name updateImages
	     * @param {string} img - The image link to be updated.
	     * @throws {Error} If there are issues with updating the organization's images.
	     */
	    function updateImages(img) {
	      if (this.typeInput === "img_link") {
	        this.organization.background = img;
	      }
	      if (this.typeInput === "logo_link") {
	        this.organization.logo = img;
	      }
	      if (this.typeInput === "style_link") {
	        this.organization.style = img;
	      }
	    }
	    /**
	     * Saves the updated image for the organization.
	     * @function
	     * @name saveUpdatedImage
	     * @throws {Error} If there are issues with saving the updated image for the organization.
	     */
	    function saveUpdatedImage() {
	      this.save(this.organization, this.rowFormOrgs);
	    }
	    /**
	     * Validates and displays error messages for numeric input fields, such as phone numbers.
	     * @function
	     * @name validateNumbers
	     * @param {string} value - The value to be validated.
	     * @param {string} id - The ID of the input field.
	     * @param {Object} rowForm - The form object associated with the row.
	     * @throws {Error} If there are issues with validating the numeric input field.
	     */
	    var validateNumbers = function validateNumbers(value, id, rowForm) {
	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);
	      var translate = $translate.instant("app.establishments.err_" + id);
	      var regex = /^[+0-9]+$/;
	      if (id === "phone") {
	        if (!regex.test(value)) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.style.display = "block";
	          errName.innerHTML = "" + translate;
	          errName.style.color = "rgba(219, 72, 73, 1)";
	          rowForm.$invalid = true;
	        } else if (name2.value.length < 9) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = $translate.instant("app.establishments.err_" + id + "_length");
	          errName.style.display = "block";
	          errName.style.color = "rgba(219, 72, 73, 1)";
	          rowForm.$invalid = true;
	        } else if (name2.value.length > 10) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = $translate.instant("app.establishments.err_" + id + "_length");
	          errName.style.display = "block";
	          errName.style.color = "rgba(219, 72, 73, 1)";
	          rowForm.$invalid = true;
	        } else if (name2.value.length === 0 || name2.value === "") {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = $translate.instant("app.establishments.err_" + id + "_length_no");
	          errName.style.display = "block";
	          errName.style.color = "rgba(219, 72, 73, 1)";
	          rowForm.$invalid = true;
	        } else {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errName.style.display = "none";
	          rowForm.$invalid = false;
	        }
	      }
	    };
	    /**
	     * Validates and displays error messages for description input fields.
	     * @function
	     * @name validateDescription
	     * @param {string} value - The value to be validated.
	     * @param {string} id - The ID of the input field.
	     * @param {Object} rowForm - The form object associated with the row.
	     * @throws {Error} If there are issues with validating the description input field.
	     */
	    var validateDescription = function validateDescription(value, id, rowForm) {
	      var re2 = /^(?!\s|.*\s$).*$/;
	      var nums = /^[+0-9]+$/;
	      var resAlphaNum = /^[a-zA-Z0-9À-ÿ\u00f1\u00d1]+(\s[a-zA-Z0-9À-ÿ\u00f1\u00d1]+)*$/;
	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);
	      var colorErro = 'rgba(219, 72, 73, 1)';

	      if (nums.test(value)) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-focused");
	        errName.style.display = "block";
	        errName.innerHTML = $translate.instant("app.establishments.err_" + id + "_nums");
	        errName.style.color = "rgba(219, 72, 73, 1)";
	        _this.errorInputs = true;
	        rowForm.$invalid = true;
	        _this.organizationForms[id].$error = true;
	      } else if (!resAlphaNum.test(value) || !re2.test(name2.value)) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-focused");
	        errName.style.display = "block";
	        errName.innerHTML = $translate.instant("app.establishments.err_" + id);
	        errName.style.color = "rgba(219, 72, 73, 1)";
	        _this.errorInputs = true;
	        rowForm.$invalid = true;
	        _this.organizationForms[id].$error = true;
	      } else if (value.length > 150 || value.length < 10) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.innerHTML = $translate.instant("app.establishments.err_" + id + "_length");
	        errName.style.display = "block";
	        errName.style.color = colorErro;
	        rowForm.$invalid = true;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        rowForm.$invalid = false;
	      }
	    };
	    /**
	     * Validates and displays error messages for image input fields.
	     * @function
	     * @name validateImage
	     * @param {File} value - The image file to be validated.
	     * @param {string} id - The ID of the input field.
	     * @param {Object} rowForm - The form object associated with the row.
	     * @throws {Error} If there are issues with validating the image input field.
	     */
	    var validateImage = function validateImage(value, id, rowForm) {
	      var size = value.size ? value.size : value.filesize;
	      var type = value.filetype;

	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);

	      if (img_types.indexOf(type) < 0) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.style.color = "rgba(219, 72, 73, 1)";
	        errName.innerHTML = $translate.instant("app.establishments.ERR_IMG_TYPE");
	        rowForm.$invalid = true;
	      } else if (size > 5000000) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.style.color = "rgba(219, 72, 73, 1)";
	        errName.innerHTML = $translate.instant("app.establishments.ERR_IMG_SIZE");
	        rowForm.$invalid = true;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        rowForm.$invalid = false;
	      }
	    };
	    /**
	     * Validates and displays error messages for file input fields with CSS file type.
	     * @function
	     * @name validateFile
	     * @param {File} value - The file to be validated.
	     * @param {string} id - The ID of the input field.
	     * @param {Object} rowForm - The form object associated with the row.
	     * @throws {Error} If there are issues with validating the file input field.
	     */
	    var validateFile = function validateFile(value, id, rowForm) {
	      var size = value.size ? value.size : value.filesize;
	      var type = value.filetype;

	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);
	      if (type !== "text/css") {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.style.color = "rgba(219, 72, 73, 1)";
	        errName.innerHTML = $translate.instant("app.establishments.ERR_CSS");
	        rowForm.$invalid = true;
	      } else if (size > 5000000) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.style.color = "rgba(219, 72, 73, 1)";
	        errName.innerHTML = $translate.instant("app.establishments.ERR_CSS");
	        rowForm.$invalid = true;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        rowForm.$invalid = false;
	      }
	    };
	    /**
	     * Validates and displays error messages for image input fields.
	     * @function
	     * @name validateImages
	     * @param {Object} value - The image data, including base64 content.
	     * @param {string} id - The ID of the input field.
	     * @param {Object} rowForm - The form object associated with the row.
	     * @throws {Error} If there are issues with validating the image input field.
	     */
	    var validateImages = function validateImages(value, id, rowForm) {
	      var file = value.base64;

	      if (id === "background") {
	        _this.previewImg.background = "data:image/jpeg;base64," + file;
	      }
	      if (id === "logo") {
	        _this.previewImg.logo = "data:image/jpeg;base64," + file;
	      }

	      validateImage(value, id, rowForm);
	    };
	    /**
	     * Validates and displays error messages for input fields to ensure they do not start or end with spaces.
	     * Additionally, it can specifically validate and display errors for phone number inputs.
	     * @function
	     * @name _validateSpaces
	     * @param {Object} event - The event object containing information about the triggering event.
	     * @param {Object} form - The form object associated with the input field.
	     * @param {string} type - The type of input field being validated (optional).
	     * @throws {Error} If there are issues with validating the input field for spaces or if the type is not recognized.
	     */
	    var _validateSpaces = function _validateSpaces(event, form, type) {
	      var re2 = /^(?!\s|.*\s$).*$/;
	      var resAlpha = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s[a-zA-ZÀ-ÿ\u00f1\u00d1]+)*$/;
	      var nums = /^[0-9\u00f1\u00d1]+(\s[0-9\u00f1\u00d1]+)*$/;
	      var item = document.getElementById("" + event.target.id);
	      var errApi = document.getElementById("err_" + event.target.id);
	      if (!resAlpha.test(item.value) || !re2.test(item.value)) {
	        item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errApi.style.display = "block";
	        errApi.innerHTML = $translate.instant("app.establishments.err_spaces");
	        errApi.style.color = "rgba(219, 72, 73, 1)";
	        form !== undefined ? form.$invalid = true : null;
	        _this.errorInputs = true;
	      } else {
	        form !== undefined ? form.$invalid = false : null;
	        item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errApi.style.display = "none";
	        _this.errorInputs = false;
	      }

	      if (type) {
	        if (type === 'phone') {
	          if (!nums.test(item.value) || !re2.test(item.value)) {
	            item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	            errApi.style.display = "block";
	            errApi.innerHTML = $translate.instant("app.establishments.err_spaces");
	            errApi.style.color = "rgba(219, 72, 73, 1)";
	            form !== undefined ? form.$invalid = true : null;
	            _this.errorInputs = true;
	          } else {
	            form !== undefined ? form.$invalid = false : null;
	            item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	            errApi.style.display = "none";
	            _this.errorInputs = false;
	          }
	        }
	      }
	    };
	    /**
	     * Validates and displays error messages for various input fields based on their IDs.
	     * It can validate phone and postal code inputs using the `validateNumbers` function,
	     * description inputs using the `validateDescription` function,
	     * image inputs using the `validateImages` function, and style inputs using the `validateFile` function.
	     * Additionally, it validates status inputs, ensuring they are not empty.
	     * @function
	     * @name _validateInputs
	     * @param {any} value - The value to be validated.
	     * @param {string} id - The ID of the input field to be validated.
	     * @param {Object} rowForm - The form object associated with the input field.
	     * @throws {Error} If there are issues with validating the input field based on its ID or if the ID is not recognized.
	     */

	    var _validateInputs = function _validateInputs(value, id, rowForm) {
	      var re2 = /^(?!\s|.*\s$).*$/;
	      var resAlpha = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s[a-zA-ZÀ-ÿ\u00f1\u00d1]+)*$/;
	      var nums = /^[0-9\u00f1\u00d1]+(\s[0-9\u00f1\u00d1]+)*$/;
	      var item = document.getElementById("" + id);
	      var errApi = document.getElementById("err_" + id);

	      // Obtener el nombre base del campo (sin el prefijo 'edit-')
	      var baseFieldName = id.replace('edit-', '');
	      // Para las traducciones, usar el id completo si es un campo de edición
	      var translationKey = id.startsWith('edit-') ? id : baseFieldName;

	      // Función para detectar emojis
	      var _containsEmojis = function _containsEmojis(text) {
	        var emojiRegex = /(?:\uD83D[\uDE00-\uDE4F])|(?:\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])|(?:\uD83D[\uDE80-\uDEFF])|[01EFu\{]\x2D(?:\uD83C\uDDFF)\]|[\u2600-\u26FF]|[027u\{]\x2D\u27BF\]/g;
	        return emojiRegex.test(text);
	      };

	      // Función para prevenir emojis en keydown
	      var _preventEmojis = function _preventEmojis(event) {
	        var char = String.fromCharCode(event.which);
	        if (_containsEmojis(char)) {
	          event.preventDefault();
	          return false;
	        }
	      };

	      // Función para manejar el pegado - corregida
	      var _handlePaste = function _handlePaste(event) {
	        setTimeout(function () {
	          var input = event.target;
	          var value = input.value;
	          if (_containsEmojis(value)) {
	            if (input.id === 'phone' || input.id === 'edit-phone') {
	              _this.phoneEmojiError = true;
	            } else if (input.id === 'address' || input.id === 'edit-address') {
	              _this.addressEmojiError = true;
	            } else if (input.id === 'description' || input.id === 'edit-description') {
	              _this.descriptionEmojiError = true;
	            }
	            input.value = value.replace(/(?:\uD83D[\uDE00-\uDE4F])|(?:\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])|(?:\uD83D[\uDE80-\uDEFF])|[01EFu\{]\x2D(?:\uD83C\uDDFF)\]|[\u2600-\u26FF]|[027u\{]\x2D\u27BF\]/g, '');
	            // Trigger ng-change manually
	            angular.element(input).triggerHandler('input');
	            _this.$scope.$apply();
	          } else {
	            if (input.id === 'phone' || input.id === 'edit-phone') {
	              _this.phoneEmojiError = false;
	            } else if (input.id === 'address' || input.id === 'edit-address') {
	              _this.addressEmojiError = false;
	            } else if (input.id === 'description' || input.id === 'edit-description') {
	              _this.descriptionEmojiError = false;
	            }
	            _this.$scope.$apply();
	          }
	        }, 0);
	      };

	      if (id === 'phone' || id === 'edit-phone') {
	        // Si el campo está vacío, no mostrar error y resetear validación
	        if (!value || value.length === 0) {
	          _this.phoneEmojiError = false;
	          item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errApi.style.display = "none";
	          rowForm.$invalid = false;
	          return;
	        }

	        if (_containsEmojis(value)) {
	          _this.phoneEmojiError = true;
	          item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errApi.style.display = "block";
	          errApi.innerHTML = 'El teléfono no puede contener emojis';
	          errApi.style.color = "rgba(219, 72, 73, 1)";
	          rowForm.$invalid = true;
	          return false;
	        } else {
	          _this.phoneEmojiError = false;
	        }
	      }

	      if (id === 'address' || id === 'edit-address') {
	        if (_containsEmojis(value)) {
	          _this.addressEmojiError = true;
	          item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errApi.style.display = "block";
	          errApi.style.color = "rgba(219, 72, 73, 1)";
	          rowForm.$invalid = true;
	          return false;
	        } else {
	          _this.addressEmojiError = false;
	        }
	      }

	      // Validación específica de emojis para campos de descripción
	      if (id === 'description' || id === 'edit-description') {
	        if (_containsEmojis(value)) {
	          _this.descriptionEmojiError = true;
	          item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errApi.style.display = "block";
	          errApi.innerHTML = 'La descripción no puede contener emojis';
	          errApi.style.color = "rgba(219, 72, 73, 1)";
	          rowForm.$invalid = true;
	          return false;
	        } else {
	          _this.descriptionEmojiError = false;
	        }

	        // Validación de longitud para descripción en editar
	        if (id === 'edit-description' && value) {
	          if (value.length < 10 || value.length > 150) {
	            item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	            errApi.style.display = "block";
	            errApi.innerHTML = 'El campo Descripción debe tener entre 10 y 150 caracteres';
	            errApi.style.color = "rgba(219, 72, 73, 1)";
	            rowForm.$invalid = true;
	            return false;
	          }
	        }
	      }

	      // Validación de emojis para campos de nombre
	      if (id === 'name' || id === 'edit-name') {
	        if (_containsEmojis(value)) {
	          item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errApi.style.display = "block";
	          errApi.innerHTML = 'El nombre no puede contener emojis';
	          errApi.style.color = "rgba(219, 72, 73, 1)";
	          rowForm.$invalid = true;
	          return false;
	        }
	      }

	      if (baseFieldName === "phone" || baseFieldName === "postCode") {
	        return validateNumbers(value, id, rowForm);
	      }

	      if (baseFieldName === "description") {
	        return validateDescription(value, id, rowForm);
	      }

	      if (baseFieldName === "logo" || baseFieldName === "background") {
	        return validateImages(value, id, rowForm);
	      }

	      if (baseFieldName === "style") {
	        return validateFile(value, id, rowForm);
	      }

	      if (baseFieldName === "status") {
	        if (value === undefined || value === '') {
	          item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          item.parentElement.parentElement.children[0].classList.remove("md-input-focused");
	          errApi.style.display = "block";
	          errApi.innerHTML = $translate.instant("app.establishments.err_status");
	          errApi.style.color = "rgba(219, 72, 73, 1)";
	          rowForm.$invalid = true;
	          _this.errorInputs = true;
	          if (_this.organizationForms[baseFieldName]) {
	            _this.organizationForms[baseFieldName].$setValidity('required', true);
	          }
	        } else {
	          item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errApi.style.display = "none";
	          _this.errorInputs = false;
	          rowForm.$invalid = false;
	          if (_this.organizationForms[baseFieldName]) {
	            _this.organizationForms[baseFieldName].$setValidity('required', false);
	          }
	        }
	      }

	      if (!re2.test(item.value)) {
	        item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        item.parentElement.parentElement.children[0].classList.remove("md-input-focused");
	        errApi.style.display = "block";
	        errApi.innerHTML = $translate.instant("app.establishments.err_" + translationKey);
	        errApi.style.color = "rgba(219, 72, 73, 1)";
	        rowForm.$invalid = true;
	        _this.errorInputs = true;
	      } else if (item.value.length === 0 || item.value === "") {
	        item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errApi.innerHTML = $translate.instant("app.establishments.err_" + translationKey);
	        errApi.style.display = "block";
	        errApi.style.color = "rgba(219, 72, 73, 1)";
	        _this.errorInputs = true;
	        rowForm.$invalid = true;
	        if (_this.organizationForms[baseFieldName]) {
	          _this.organizationForms[baseFieldName].$setValidity('required', true);
	        }
	      } else if (item.value.length < 3 || item.value.length > 45) {
	        item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errApi.innerHTML = $translate.instant("app.establishments.err_" + translationKey + "_length");
	        errApi.style.display = "block";
	        errApi.style.color = "rgba(219, 72, 73, 1)";
	        _this.errorInputs = true;
	        rowForm.$invalid = true;
	      } else {
	        item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errApi.style.display = "none";
	        _this.errorInputs = false;
	        rowForm.$invalid = false;
	      }
	    };
	    /**
	     * Validates varios input fields in the form, displaying error messages for invalid inputs.
	     * Specifically, it validates the "name" field for alphanumeric characters and length,
	     * the "phone" field for numeric characters and length,
	     * the "address" field for non-empty value,
	     * the "description" field for alphanumeric characters and length,
	     * the "background" and "logo" fields for non-empty values and JPEG file types (if not in edit mode).
	     * @function
	     * @name validateInputs
	     * @returns {boolean} - Returns true if all input fields pass validation, otherwise returns false.
	     */
	    var validateInputs = function validateInputs(formOrg) {
	      var name = formOrg.name;
	      var name2 = document.getElementById("name");
	      var errName = document.getElementById("err_name");

	      var background = formOrg.background;
	      var background2 = document.getElementById("background");
	      var errBackground = document.getElementById("err_background");
	      var background_format = true;

	      var logo = formOrg.logo;
	      var logo2 = document.getElementById("logo");
	      var errLogo = document.getElementById("err_logo");
	      var logo_format = true;

	      var phone = formOrg.phone;
	      var phone2 = document.getElementById("phone");
	      var errPhone = document.getElementById("err_phone");

	      var address = formOrg.address;
	      var address2 = document.getElementById("address");
	      var errAddress = document.getElementById("err_address");

	      var description = formOrg.description;
	      var description2 = document.getElementById("description");
	      var errDescription = document.getElementById("err_description");

	      // regex not allow space at the beginning or end and not allow more than one space between words
	      var re2 = /^(?!\s{2,}|.*\s$).*$/;
	      var rePhone = /^[+0-9]+$/;
	      var resAlphaNum = /^[a-zA-Z0-9.,-_áéíóúñÁÉÍÓÚÑ@() ]+$/;

	      if (!resAlphaNum.test(name) || !re2.test(name)) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.innerHTML = "El nombre no puede contener caracteres especiales";
	        errName.style.color = "rgba(219, 72, 73, 1)";
	      } else if (name.length > 45 || name.length < 3) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.innerHTML = "El campo nombre debe tener entre 3 y 45 caracteres";
	        errName.style.display = "block";
	        errName.style.color = "rgba(219, 72, 73, 1)";
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	      }

	      if (!rePhone.test(phone)) {
	        phone2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errPhone.innerHTML = "El teléfono solo puede contener números";
	        errPhone.style.display = "block";
	        errPhone.style.color = "rgba(219, 72, 73, 1)";
	      } else if (phone.length > 10 || phone.length < 9) {
	        phone2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errPhone.innerHTML = "El teléfono debe tener entre 9 y 10 dígitos";
	        errPhone.style.display = "block";
	        errPhone.style.color = "rgba(219, 72, 73, 1)";
	      } else {
	        phone2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errPhone.style.display = "none";
	      }

	      if (!address || address === "") {
	        address2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errAddress.innerHTML = "La dirección es obligatoria";
	        errAddress.style.display = "block";
	        errAddress.style.color = "rgba(219, 72, 73, 1)";
	      } else {
	        address2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errAddress.style.display = "none";
	      }

	      if (description && (!resAlphaNum.test(description) || !re2.test(description))) {
	        description2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errDescription.innerHTML = "La descripción contiene caracteres no válidos";
	        errDescription.style.display = "block";
	        errDescription.style.color = "rgba(219, 72, 73, 1)";
	      } else {
	        description2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errDescription.style.display = "none";
	      }

	      if (!_this.editOrgs) {
	        if (background && background.filetype && img_types.indexOf(background.filetype) < 0) {
	          background_format = false;
	          background2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errBackground.innerHTML = "Formato de imagen no válido";
	          errBackground.style.display = "block";
	          errBackground.style.color = "rgba(219, 72, 73, 1)";
	        } else {
	          background2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errBackground.style.display = "none";
	        }
	        if (logo && logo.filetype && img_types.indexOf(logo.filetype) < 0) {
	          logo_format = false;
	          logo2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errLogo.innerHTML = "Formato de imagen no válido";
	          errLogo.style.display = "block";
	          errLogo.style.color = "rgba(219, 72, 73, 1)";
	        } else {
	          logo2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errLogo.style.display = "none";
	        }
	      }

	      return resAlphaNum.test(name) && re2.test(name) && rePhone.test(phone) && name.length <= 45 && name.length >= 3 && address && address !== "" && background_format && logo_format && phone.length >= 9 && phone.length <= 10;
	    };
	    /**
	     * Updates the countryStatus based on the provided value.
	     * If the value is not "0", sets countryStatus to false; otherwise, sets it to true.
	     * @function
	     * @name ngSelect
	     * @param {string} value - The value used to determine the countryStatus.
	     */
	    function ngSelect(value) {
	      if (value !== "0") {
	        this.countryStatus = false;
	      } else {
	        this.countryStatus = true;
	      }
	    }
	    /**
	     * Handles the selection change in the ngSelectCat function, updating the appearance of the category input based on the selected value.
	     *
	     * @function
	     * @name ngSelectCat
	     * @param {string} value - The selected value.
	     */
	    function ngSelectCat(value) {
	      var category = document.getElementById("categoryId");
	      if (value !== '0') {
	        category.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	      }
	    }
	    /**
	     * Sends the organization data for processing and saving. Validates inputs and country status.
	     * If the country code is '0', sets countryStatus to true.
	      * If editing organizations or inputs are valid, proceeds to save the organization data.
	     * @function
	     * @name _sendOrganization
	     * @param {Object} formOrg - The form object containing organization data.
	     * @param {Object} organizationForms - The form object associated with organization details.
	     * @throws {Error} If there are issues with the organization data or validation fails.
	     */
	    function _sendOrganization(formOrg, organizationForms) {
	      var valid = validateInputs(formOrg);
	      if (this.countryCodes.country === '0') {
	        return this.countryStatus = true;
	      } else if (this.countryCodes.country !== '0') {
	        this.countryStatus = false;
	      }

	      if (this.editOrgs || valid) {
	        if (!this.countryStatus) {
	          if (organizationForms.$invalid) {
	            Object.values(organizationForms.$$controls).forEach(function (control) {
	              control.$touched = true;
	            });
	            return;
	          }
	          if (organizationForms.$invalid) {
	            Object.values(organizationForms.$$controls).forEach(function (control) {
	              control.$touched = true;
	            });
	            return;
	          }

	          if (formOrg.style) {
	            formOrg.style.organizationName = formOrg.name.replace(new RegExp(" ", "g"), "_");
	            formOrg.style.type = formOrg.style.filetype.split("/")[1];
	          }

	          formOrg.location = { type: "Point", coordinates: this.coordinates };

	          // formOrg.address = addressElement.value;
	          formOrg.phone = this.countryCodes.country + formOrg.phone;
	          this.editOrgs ? this.save(formOrg, organizationForms) : this._createOrganization(formOrg);
	          $mdDialog.cancel();
	        }
	      }
	    }
	    /**
	     * Closes the dialog and resets the organization form.
	     * Sets the form to untouched and pristine, and initializes a new organization object with default values.
	     * @function
	     * @name _closeDialog
	     */
	    function _closeDialog() {
	      this.organizationForms.$setUntouched(); // this resets the form itself
	      this.organizationForms.$setPristine();
	      this.new_organization = {
	        status: true
	      };
	      $mdDialog.hide();
	    }
	    /**
	     * Cancels the dialog, discarding any changes made.
	     * @function
	     * @name _cancelDialog
	     */
	    function _cancelDialog() {
	      $mdDialog.cancel();
	    }
	    /**
	     * Toggles the display of options for a button identified by its ID.
	     * @function
	     * @name _editOptionsButton
	     * @param {string} id - The ID of the button whose options are to be toggled.
	     */
	    function _editOptionsButton(id) {
	      var opc = document.getElementById(id);

	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Toggles the display of options for a button identified by its ID and a prefix.
	     * @function
	     * @name _activateOptionsButton
	     * @param {string} id - The ID of the button whose options are to be toggled.
	     * @param {string} prefix - The prefix used in conjunction with the ID for identifying the button.
	     */
	    function _activateOptionsButton(id, prefix) {
	      var opc = document.getElementById(id + prefix);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id + prefix);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Validates the file type of an input value and updates corresponding validation flags.
	     * @function
	     * @name _validFile
	     * @param {Object} valueInput - The input value object, typically obtained from a file input.
	     * @param {string} nameInput - The name or identifier of the input, used to determine which validation flag to update.
	     * @returns {boolean} - Returns true if the file type is "image/jpeg," otherwise returns false.
	     */
	    function _validFile(valueInput, nameInput) {
	      var valid = img_types.indexOf(valueInput.filetype) > -1;
	      switch (nameInput) {
	        case "logo":
	          this.ticketLogoValid = valid;
	          break;
	        case "background":
	          this.backgroundValid = valid;
	          break;
	      }
	      return valid;
	    }
	    /**
	     * Gets the name of a category based on its ID.
	     * @function
	     * @name getCategoryName
	     * @param {number} categoryId - The ID of the category for which the name is retrieved.
	     * @returns {string} - The name of the category with the specified ID. Returns an empty string if the ID is undefined.
	     */
	    function getCategoryName(categoryId) {
	      var categoryName = "";
	      if (categoryId !== undefined) {
	        this.categories.forEach(function (res) {
	          if (res.id === categoryId) {
	            categoryName = res.name;
	          }
	        });
	        return categoryName;
	      }
	    }
	    // exports
	    angular.extend(this, {
	      config: config,
	      updateIcons: updateIcons,
	      _createUsingFullOptions: _createUsingFullOptions,
	      _editOrg: _editOrg,
	      _showZoneForm: _showZoneForm,
	      _showZoneFormEdit: _showZoneFormEdit,
	      _sendOrganization: _sendOrganization,
	      _createOrganization: _createOrganization,
	      _updateOrganization: _updateOrganization,
	      _deleteEstablishment: _deleteEstablishment,
	      _closeDialog: _closeDialog,
	      _cancelDialog: _cancelDialog,
	      _editOptionsButton: _editOptionsButton,
	      _activateOptionsButton: _activateOptionsButton,
	      ShowDeleteDialog: ShowDeleteDialog,
	      _validFile: _validFile,
	      _detailOrganization: _detailOrganization,
	      _showDetailDialog: _showDetailDialog,
	      _validateInputs: _validateInputs,
	      _preventEmojis: _preventEmojis,
	      _handlePaste: _handlePaste,
	      _containsEmojis: _containsEmojis,
	      ngSelect: ngSelect,
	      ngSelectCat: ngSelectCat,
	      pageSizeChanged: pageSizeChanged,
	      disableAllBokititServicesByOrganization: disableAllBokititServicesByOrganization,
	      getCategoryName: getCategoryName,
	      // _getAddress: _getAddress,
	      // _showMapDialog: _showMapDialog,
	      // _detailAddress: _detailAddress,
	      _changeImageDialog: _changeImageDialog,
	      querySearchSelect: querySearchSelect,
	      deleteImage: deleteImage,
	      updateImages: updateImages,
	      saveUpdatedImage: saveUpdatedImage,
	      _searchCountryCode: _searchCountryCode,
	      abrirArchivo: abrirArchivo,
	      _validateSpaces: _validateSpaces
	    });
	  }

	  _createClass(OrganizationsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this13 = this;

	      var style = document.querySelectorAll('.custom-file-input');
	      style.forEach(function (element) {
	        element.dataset.styleType = _this13.$translate.instant('app.organizations.BTN_CHOOSE_FILE');
	      });

	      if (!this.config.DEBUG_ENABLED) {
	        this.getOrganizations();
	      }

	      this.CategoryResource.getCategories().$promise.then(function (result) {
	        _this13.categories = result.sort(function (a, b) {
	          if (a.name.toLowerCase() === 'otros') return 1;
	          if (b.name.toLowerCase() === 'otros') return -1;
	          return a.name.localeCompare(b.name);
	        });
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }]);

	  return OrganizationsController;
	}();

	OrganizationsController.$inject = ["config", "$scope", "$rootScope", "OrganizationsResource", "EstablishmentsResource", "CategoryResource", "QueuesResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$location", "$http", "LocationsResource"];
	exports.default = OrganizationsController;

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var OrganizationsService = function () {

	  /** @ngInject */
	  OrganizationsService.$inject = ["$http"];
	  function OrganizationsService($http) {
	    _classCallCheck(this, OrganizationsService);

	    this.$http = $http;

	    // exports
	    //angular.extend(this, {

	    //});

	    // Methods
	    this.uploadFileToUrl;
	  }

	  _createClass(OrganizationsService, [{
	    key: 'uploadFileToUrl',
	    value: function uploadFileToUrl(file, uploadUrl) {
	      var fd = new FormData();
	      fd.append('file', file);

	      this.$http.post(uploadUrl, fd, {
	        transformRequest: angular.identity,
	        headers: { 'Content-Type': undefined }
	      }).success(function (result) {
	        console.log(result);
	        return result;
	      }).error(function (error) {
	        console.log(error);
	        return error;
	      });
	    }
	  }]);

	  return OrganizationsService;
	}();

	OrganizationsService.$inject = ['$http'];

	exports.default = OrganizationsService;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _establishments = __webpack_require__(64);

	var _establishments2 = __webpack_require__(66);

	var _establishments3 = _interopRequireDefault(_establishments2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var establishments = angular.module('mod.admin.administration.establishments', []).component('establishments', _establishments.EstablishmentsComponent).service('EstablishmentsService', _establishments3.default).name;

	exports.default = establishments;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EstablishmentsComponent = undefined;

	var _establishments = __webpack_require__(65);

	var _establishments2 = _interopRequireDefault(_establishments);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var EstablishmentsComponent = exports.EstablishmentsComponent = {
	  controller: _establishments2.default,
	  templateUrl: 'app/modules/admin/administration/establishments/establishments.html'
	};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EstablishmentsController = function () {
	  /** @ngInject */
	  EstablishmentsController.$inject = ["config", "$scope", "$rootScope", "AdministrationService", "EstablishmentsResource", "OrganizationsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$location", "$localStorage", "TimeZones", "formEstablishment", "pageSizeOptions"];
	  function EstablishmentsController(config, $scope, $rootScope, AdministrationService, EstablishmentsResource, OrganizationsResource, NgTableParams, $translate, toastr, $mdDialog, $location, $localStorage, TimeZones, formEstablishment, pageSizeOptions) {
	    var _this = this;

	    _classCallCheck(this, EstablishmentsController);

	    // private
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$localStorage = $localStorage;
	    this.isPre = config.IS_PRE;
	    this.AdministrationService = AdministrationService;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.OrganizationsResource = OrganizationsResource;
	    // Add new TimeZones Resource
	    this.TimeZones = TimeZones;
	    this.config = config;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.$mdDialog = $mdDialog;
	    this.isAdding = false;
	    this.fail = false;
	    this.locationTimeZone = "";
	    this.selectedItemChange = selectedItemChange;
	    this.pageSizeOptions = pageSizeOptions;
	    this.count = 5;

	    this.showDeleteConfirm = showDeleteConfirm;
	    this.del = del;
	    this.save = save;
	    this.add = add;
	    this.resetRow = resetRow;
	    this.currentRole = this.$localStorage.currentRole;
	    this.countries = [];
	    this.editEstablishment = false;
	    this.phoneCode = "";
	    this.countryCodes = {
	      country: ""
	    };
	    // Default values
	    this.new_establishment = { smsLimit: 2500, turnLimit: 100, previousNotificationLimit: 1 };

	    this.isRoot = $localStorage.currentRole && typeof $localStorage.currentRole === "string" && $localStorage.currentRole.toUpperCase() === "ROOT" ? true : false;

	    this.pageSizeOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

	    fetch("/assets/country_code.json").then(function (response) {
	      return response.json();
	    }).then(function (json) {
	      _this.countries = json;
	      _this.countries.sort(function (a, b) {
	        return a.nombre.localeCompare(b.nombre);
	      });
	    }).catch(function (error) {
	      console.log(error);
	    });

	    // Control of sidemenu page
	    var url = $location.url().substring(1).toUpperCase();
	    this.$rootScope.currentPage = currentPage(1);

	    this.formEstablishment = formEstablishment;
	    /**
	     * Extracts the specified index from the current URL path.
	     *
	     * @param {number} index - The index of the path segment to retrieve.
	     * @returns {string} - The path segment at the specified index.
	     */
	    function currentPage(index) {
	      var split_url = url.split("/");
	      return split_url[index];
	    }
	    /**
	     * Handles the event when the page size is changed.
	     *
	     * @param {number} newPageSize - The new page size selected.
	     */
	    var pageSizeChanged = function pageSizeChanged(newPageSize) {
	      _this.tableParams.count(newPageSize);
	      _this.counter = newPageSize;
	    };

	    /* only test mode */
	    config.DEBUG_ENABLED = false;
	    /* EOF test mode */
	    /**
	     * Creates and initializes the NgTableParams with full options.
	     */
	    function _createUsingFullOptions() {
	      var initialParams = {
	        count: this.count // initial page size
	      };
	      var initialSettings = {
	        // page size buttons (right set of buttons in demo)
	        counts: [],
	        // determines the pager buttons (left set of buttons in demo)
	        paginationMaxBlocks: 4,
	        paginationMinBlocks: 2,
	        dataset: this.data
	      };
	      this.tableParams = new NgTableParams(initialParams, initialSettings);
	      return this.tableParams;
	    }
	    /**
	     * Creates and initializes the NgTableParams with full options using the provided services_data.
	     *
	     * @param {Array} services_data - The data to be used as the dataset in NgTableParams.
	     */
	    function _createUsingFullOptions1(services_data) {
	      var initialParams = {
	        count: this.count // initial page size
	      };
	      var initialSettings = {
	        // page size buttons (right set of buttons in demo)
	        counts: [],
	        // determines the pager buttons (left set of buttons in demo)
	        paginationMaxBlocks: 4,
	        paginationMinBlocks: 2,
	        dataset: services_data
	      };
	      this.tableParams = new NgTableParams(initialParams, initialSettings);
	      return this.tableParams;
	    }
	    /**
	     * Adds a new template to the NgTableParams dataset, resorts, resets sorting, and reloads the table.
	     *
	     * @param {object} new_template - The new template to be added to the dataset.
	     */
	    function add(new_template) {
	      this.tableParams.settings().dataset.unshift(new_template);
	      this.tableParams.sorting({});
	      this.tableParams.page(1);
	      this.tableParams.reload();
	    }
	    /**
	     * Deletes a row from the NgTableParams dataset, updates the originalData, and reloads the table.
	     *
	     * @param {object} row - The row to be deleted from the dataset.
	     */
	    function del(row) {
	      var main_dataset = this.tableParams.settings().dataset;
	      var originalData = "";
	      angular.forEach(this.tableParams.settings().dataset, function (value, key) {
	        if (angular.equals(row, value)) {
	          main_dataset.splice(key, 1);
	          originalData = angular.copy(main_dataset);
	        }
	      });
	      this.originalData = originalData;
	      var this_param = this.tableParams;
	      this.tableParams.reload().then(function (data) {
	        if (data.length === 0 && this_param.total() > 0) {
	          this_param.page(this_param.page() - 1);
	          this_param.reload();
	        }
	      });
	    }
	    /**
	     * Shows a confirmation dialog for deleting an establishment. If confirmed, triggers the deletion process.
	     *
	     * @param {object} ev - The event object to track the target event.
	     */
	    function showDeleteConfirm(ev) {
	      hideElement(ev.id);
	      var current_scope = this;
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        current_scope._deleteEstablishment(ev);
	      }, function () {});
	    }
	    /**
	     * Updates specific icons or states in the provided row based on the given type and state values.
	     * Saves the changes to the consumer data.
	     *
	     * @param {object} row - The consumer data row to be updated.
	     * @param {object} rowForm - The form associated with the consumer data row.
	     * @param {boolean|string} state - The new state or value to be set based on the type.
	     * @param {string} type - The type indicating which property or icon to update in the row.
	     */
	    function updateIcons(row, rowForm, state, type) {
	      if (type === "askingName") {
	        row.askingName = state;
	      }
	      if (type === "asking_phone") {
	        row.asking_phone = String(state);
	      }
	      if (type === "askingDNI") {
	        row.askingDNI = state;
	      }
	      if (type === "showInstrucciones") {
	        row.showInstrucciones = state;
	      }
	      if (type === "singleQueue") {
	        row.singleQueue = state;
	      }
	      this.save(row);
	    }
	    /**
	     * Saves the changes made to the consumer data row. Extends the original row with the updated values.
	     * Resets the row editing status and triggers an update for the establishment if debug mode is disabled.
	     *
	     * @param {object} row - The consumer data row to be saved.
	     */
	    function save(row) {
	      var originalRow = this.resetRow(row);
	      angular.extend(originalRow, row);
	      this.isAdding = false;
	      if (!config.DEBUG_ENABLED) this._updateEstablishment(row);
	    }
	    /**
	     * Resets the editing status of the consumer data row and returns the original data for the row.
	     * If the row is being added, it sets the original data to a copy of the dataset.
	     *
	     * @param {object} row - The consumer data row to be reset.
	     * @returns {object} - The original data for the row.
	     */
	    function resetRow(row) {
	      var row_isAdding = this.isAdding;
	      if (row_isAdding) {
	        this.originalData = angular.copy(this.tableParams.settings().dataset);
	      }
	      var return_value = "";
	      row.isEditing = false;
	      angular.forEach(this.originalData, function (value) {
	        if (!row_isAdding && row.id === value.id) {
	          return_value = value;
	        } else if (row_isAdding && value.id === "") {
	          return_value = value;
	        }
	      });
	      return return_value;
	    }
	    function getContextKey(context) {
	      var contextMap = {
	        Screen: "app.users.ROLE_SCREEN",
	        Employee: "app.users.ROLE_WORKER",
	        Kiosk: "app.users.ROLE_KIOSK",
	        Area: "app.administration.WAITING_AREA"
	      };
	      return contextMap[context] || context;
	    }
	    /**
	     * Creates a new establishment with the provided establishment data.
	     *
	     * @param {object} establishment - The establishment data to create.
	     */
	    function _createEstablishment(establishment) {
	      var _this2 = this;

	      var ev = this;
	      if (!establishment.organizationId || establishment.organizationId == "") {
	        establishment.organizationId = this.$localStorage.currentOrganization.id;
	      }
	      ev.EstablishmentsResource.create({}, establishment).$promise.then(function (result) {
	        var location = result.data;
	        var warnings = result.warnings || [];

	        ev.new_establishment = {};
	        ev.establishmentForm.$setPristine();
	        ev.establishmentForm.$setUntouched();
	        ev.add(location);

	        if (warnings.length) {
	          var contextKeys = warnings.map(function (w) {
	            return getContextKey(w.context);
	          }).filter(Boolean);
	          _this2.$translate(contextKeys).then(function (translations) {
	            var contextNames = contextKeys.map(function (key) {
	              return translations[key];
	            }).join(", ");

	            _this2.$translate("app.establishments.WARNING_CREATE").then(function (warningMsg) {
	              _this2.toastr.warning(contextNames + " " + warningMsg);
	            });
	          });
	        } else {
	          _this2.$translate("app.establishments.SUCCESS_CREATE").then(function (successMsg) {
	            _this2.$translate("app.SUCCESS").then(function (title) {
	              _this2.toastr.success(successMsg, title);
	            });
	          });
	        }
	      }).catch(function (error) {
	        console.log(error);
	        _this2.fail = true;
	        _this2.$translate("app.establishments.ERROR_CREATE").then(function (errorMsg) {
	          _this2.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Updates the establishment with the provided data.
	     *
	     * @param {object} row - The establishment data to update.
	     */
	    function _updateEstablishment(row) {
	      var _this3 = this;

	      var current_area_data = row;
	      row.locationId = row.id;
	      var locationId = row.locationId;
	      this.EstablishmentsResource.update({ id: locationId }, current_area_data).$promise.then(function () {
	        _this3.$translate("app.establishments.SUCCESS_UPDATE").then(function (msg) {
	          _this3.toastr.success(msg);
	        });
	        if (_this3.organizationId) {
	          _this3.getEstablismentByOrganization(_this3.$localStorage.currentRole, _this3.organizationId);
	        } else {
	          _this3.getEstablishments();
	        }
	      }).catch(function (error) {
	        console.log(error);
	        _this3.fail = true;
	        _this3.$translate("app.establishments.ERROR_UPDATE").then(function (errorMsg) {
	          _this3.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Deletes the establishment with the provided data.
	     *
	     * @param {object} establishment - The establishment data to delete.
	     */
	    function _deleteEstablishment(establishment) {
	      var _this4 = this;

	      this.EstablishmentsResource.destroy({ id: establishment.id }).$promise.then(function () {
	        _this4.$translate("app.administration.DELETE_OK").then(function (msg) {
	          _this4.toastr.success(msg, $translate.instant("app.administration.DELETE_SUCCESS"));
	        });
	        _this4.del(establishment);
	      }).catch(function (error) {
	        console.log(error);
	        _this4.fail = true;
	        _this4.$translate("app.establishments.ERROR_UPDATE").then(function (errorMsg) {
	          _this4.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Displays details for an establishment if it's not in edit mode.
	     *
	     * @param {object} establishment - The establishment for which details are to be displayed.
	     */
	    function _detailEstablishment(establishment) {
	      if (establishment.isEditing !== true) {
	        this.current_establishment = establishment;
	        this._showDetailDialog();
	      }
	    }
	    /**
	     * Displays a dialog for showing details of an establishment.
	     *
	     * @param {object} ev - The event triggering the dialog display.
	     */
	    function _showDetailDialog(ev) {
	      var _this5 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#dialog_detail_establishment",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this5;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        console.log("You resolve the dialog.");
	      }, function () {
	        console.log("You cancelled the dialog.");
	      });
	    }
	    /**
	     * Displays a dialog for showing or editing details of an establishment zone.
	     *
	     * @param {object} [ev={}] - The event triggering the dialog display.
	     */
	    function _showZoneForm() {
	      var ev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var parent = this;
	      parent.editEstablishment = (typeof ev === "undefined" ? "undefined" : _typeof(ev)) === "object" && Object.keys(ev).length > 0;

	      if (parent.editEstablishment) {
	        hideElement(ev.id);
	        parent._showZoneFormEdit(ev);
	      }

	      var fieldsToReset = ["name", "addressFirstLine", "city", "postCode", "phone", "stateRegion", "description", "delegation"];

	      fieldsToReset.forEach(function (field) {
	        var errElement = document.getElementById("err_" + field);
	        var inputElement = document.getElementById(field);

	        if (errElement) {
	          errElement.style.display = "none";
	        }

	        if (inputElement) {
	          inputElement.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        }
	      });

	      var dialogOptions = {
	        preserveScope: true,
	        hasBackdrop: true,
	        contentElement: "#myDialog",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return parent;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      };

	      $mdDialog.show(dialogOptions).then(function () {
	        parent._closeDialog();
	        parent.editEstablishment = false;
	      }, function () {
	        parent.editEstablishment = false;
	        parent._closeDialog();
	      });
	    }
	    /**
	     * Displays a form for editing details of an existing establishment zone.
	     *
	     * @param {object} est - The establishment zone to be edited.
	     */
	    function _showZoneFormEdit(est) {
	      this.new_establishment = angular.copy(est);
	      this._searchCountryCode(est.phone);
	    }
	    /**
	     * Hides the HTML element with the specified ID.
	     *
	     * @param {string} id - The ID of the HTML element to hide.
	     */
	    function hideElement(id) {
	      var menu = document.getElementById("" + id);
	      if (menu) {
	        menu.style.display = "none";
	      }
	    }
	    /**
	     * Searches for the country code in the provided phone number and updates the component's state.
	     *
	     * @param {number|string} phone - The phone number to search for.
	     */
	    function _searchCountryCode(phone) {
	      var _this6 = this;

	      this.countryStatus = false;
	      if (typeof phone === "number") {
	        this.countryStatus = true;
	        phone = phone.toString();
	      } else if (phone === undefined || phone === null) {
	        return;
	      }

	      for (var i = 0; i < this.countries.length; i++) {
	        if (phone.indexOf(this.countries[i].dial_code) > -1) {
	          this.phoneCode = this.countries[i].dial_code;
	          break;
	        }
	      }
	      var countriesCode = this.countries.filter(function (country) {
	        return country.dial_code === _this6.phoneCode;
	      });

	      if (countriesCode.length > 0) {
	        this.countryCodes.country = countriesCode[0].dial_code;
	        phone = phone.replace(this.phoneCode, "");
	        this.new_establishment.phone = phone;
	      } else {
	        this.countryStatus = true;
	        this.new_establishment.phone = phone;
	        this.countryCodes.country = "+34";
	      }
	    }
	    /**
	     * Validates numeric input for specific fields in the establishment form.
	     *
	     * @param {string} value - The input value to be validated.
	     * @param {string} id - The ID of the input field.
	     * @param {object} formPristine - The form's pristine state.
	     * @param {string} colorErro - The color for displaying error messages.
	     */
	    var validateNumbers = function validateNumbers(value, id, formPristine, colorErro) {
	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);
	      var translate = $translate.instant("app.establishments.err_" + id);
	      var translateLength = $translate.instant("app.establishments.err_" + id + "_length");

	      var regex = /^[0-9]+$/;
	      if (id === "phone") {
	        // Validar si el campo está vacío
	        if (!value || value.trim() === "") {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.style.display = "block";
	          errName.innerHTML = $translate.instant("app.establishments.err_phone_required");
	          errName.style.color = "red";
	          formPristine.$pristine = true;
	          _this.establishmentForm[id].$valid = false;
	        } else if (!regex.test(value)) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.style.display = "block";
	          errName.innerHTML = translate;
	          errName.style.color = "red";
	          formPristine.$pristine = true;
	          _this.establishmentForm[id].$valid = false;
	        } else if (name2.value.length < 9) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = translateLength;
	          errName.style.display = "block";
	          errName.style.color = "red";
	          formPristine.$pristine = true;
	          _this.establishmentForm[id].$valid = false;
	        } else {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errName.style.display = "none";
	          formPristine.$pristine = false;
	          _this.establishmentForm[id].$valid = true;
	        }
	      } else if (id === "postCode") {
	        if (!regex.test(value)) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.style.display = "block";
	          errName.innerHTML = translateLength;
	          errName.style.color = "red";
	          formPristine.$pristine = true;
	          _this.establishmentForm[id].$valid = false;
	        } else if (value.length > 10 || value.length < 3) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = $translate.instant("app.establishments.err_postCode_length_2");
	          errName.style.display = "block";
	          errName.style.color = colorErro;
	          formPristine.$pristine = true;
	          _this.establishmentForm[id].$valid = false;
	        } else {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errName.style.display = "none";
	          formPristine.$pristine = false;
	          _this.establishmentForm[id].$valid = true;
	        }
	      } else if (id === "previousNotificationLimit" || id === "turnLimit" || id === "smsLimit") {
	        if (!regex.test(value) || value <= 0) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.style.display = "block";
	          errName.innerHTML = translate;
	          errName.style.color = "red";
	          formPristine.$pristine = true;
	          _this.establishmentForm[id].$valid = false;
	        } else {
	          // Validación de rangos específicos
	          var maxValue = void 0;
	          if (id === "previousNotificationLimit") maxValue = 999;else if (id === "turnLimit") maxValue = 9999;else if (id === "smsLimit") maxValue = 99999;

	          if (value > maxValue) {
	            name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	            errName.innerHTML = translateLength;
	            errName.style.display = "block";
	            errName.style.color = "red";
	            formPristine.$pristine = true;
	            _this.establishmentForm[id].$valid = false;
	          } else {
	            name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	            errName.style.display = "none";
	            formPristine.$pristine = false;
	            _this.establishmentForm[id].$valid = true;
	          }
	        }
	      } else {
	        if (!regex.test(value)) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.style.display = "block";
	          errName.innerHTML = translateLength;
	          errName.style.color = "red";
	          formPristine.$pristine = true;
	          _this.establishmentForm[id].$valid = false;
	        } else {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errName.style.display = "none";
	          formPristine.$pristine = false;
	          _this.establishmentForm[id].$valid = true;
	        }
	      }
	    };
	    /**
	     * Validates input for specific fields in the establishment form.
	     *
	     * @param {string} value - The input value to be validated.
	     * @param {string} id - The ID of the input field.
	     * @param {object} formPristine - The form's pristine state.
	     */
	    function _validateInputs(value, id, formPristine) {
	      var re2 = /^(?!\s|.*\s$).*$/;
	      var resAlphaNum = /^[a-zA-ZáéíóúñÁÉÍÓÚÑ@() ]+$/;
	      var resAddress = /^[a-zA-ZáéíóúñÁÉÍÓÚÑ@()#0-9 ]+$/;
	      var regex1 = /^(?!\s|.*\s$).*$/;
	      var regex2 = /^([a-zA-Z.,-_áéíóúñÁÉÍÓÚÑ()]+[,.]?[ ]?|[a-zA-Z.,-_áéíóúñÁÉÍÓÚÑ()]+['-]?)+$/g;

	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);
	      var colorErro = "rgba(219, 72, 73, 1)";
	      var translate = $translate.instant("app.establishments.err_" + id);
	      var translateLengt = $translate.instant("app.establishments.err_" + id + "_length");

	      if (id === "phone" || id === "postCode" || id === "smsLimit" || id === "turnLimit" || id === "previousNotificationLimit") {
	        return validateNumbers(value, id, formPristine, colorErro);
	      } // Validación especial para stateRegion - mostrar error cuando esté vacío
	      if (id === "stateRegion") {
	        // Si está vacío, mostrar error de campo requerido
	        if (!value || value.trim() === "") {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.style.display = "block";
	          errName.innerHTML = $translate.instant("app.establishments.err_" + id + "_required");
	          errName.style.color = colorErro;
	          formPristine.$pristine = true;
	          this.establishmentForm[id].$valid = false;
	          return;
	        }

	        // Si tiene menos de 3 caracteres, mostrar error de longitud
	        if (value.length < 3) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = translateLengt;
	          errName.style.display = "block";
	          errName.style.color = colorErro;
	          formPristine.$pristine = true;
	          this.establishmentForm[id].$valid = false;
	          return;
	        }

	        // Si tiene más de 100 caracteres, mostrar error de longitud
	        if (value.length > 100) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = translateLengt;
	          errName.style.display = "block";
	          errName.style.color = colorErro;
	          formPristine.$pristine = true;
	          this.establishmentForm[id].$valid = false;
	          return;
	        }

	        // Si tiene contenido válido (3-100 caracteres), validar formato
	        if (!resAlphaNum.test(value) || !regex1.test(value) || !regex2.test(value) || !re2.test(value)) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.style.display = "block";
	          errName.innerHTML = translate;
	          errName.style.color = colorErro;
	          formPristine.$pristine = true;
	          this.establishmentForm[id].$valid = false;
	        } else {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errName.style.display = "none";
	          formPristine.$pristine = false;
	          this.establishmentForm[id].$valid = true;
	        }
	        return;
	      }

	      if (!resAlphaNum.test(value) || !regex1.test(value) || !regex2.test(value) || !re2.test(name2.value)) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.innerHTML = translate;errName.style.color = colorErro;
	        formPristine.$pristine = true;
	        this.establishmentForm[id].$valid = false;
	      } else if (id === "description" || id === "delegation") {
	        if (value.length > 150 || value.length < 10) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = translateLengt;
	          errName.style.display = "block";
	          errName.style.color = colorErro;
	          formPristine.$pristine = true;
	          this.establishmentForm[id].$valid = false;
	        } else {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errName.style.display = "none";
	          formPristine.$pristine = false;
	          this.establishmentForm[id].$valid = true;
	        }
	      } else if (name2.value.length > 45 || name2.value.length < 3) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.innerHTML = translateLengt;
	        errName.style.display = "block";
	        errName.style.color = colorErro;
	        formPristine.$pristine = true;
	        this.establishmentForm[id].$valid = false;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        formPristine.$pristine = false;
	        this.establishmentForm[id].$valid = true;
	      }
	    }

	    this.onInputBlur = function () {
	      var phoneValue = document.getElementById("phone").value;
	      var phone2 = document.getElementById("phone");
	      if (phoneValue === "" || this.establishmentForm.country.$viewValue === '') {
	        phone2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	      }
	    };
	    /**
	     * Sends the establishment data for validation and creates or updates the establishment accordingly.
	     *
	     * @param {object} result - The establishment data to be sent for validation.
	     */
	    function _sendEstablishment(result) {
	      var valid = Object.values(this.establishmentForm.$$controls).map(function (control) {
	        return control.$valid;
	      });

	      if (!this.new_establishment.phone || this.new_establishment.phone.length >= 11 || typeof this.new_establishment.phone === "number" || this.new_establishment.phone.search(/\+/) !== -1) {
	        var _phone = document.getElementById("phone");
	        _phone.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	      }

	      var phoneValue = document.getElementById("phone").value;
	      var phone2 = document.getElementById("phone");
	      if (phoneValue === "" || this.establishmentForm.country.$viewValue === '') {
	        phone2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	      }

	      if (this.establishmentForm.$invalid) {
	        Object.values(this.establishmentForm.$$controls).forEach(function (control) {
	          control.$touched = true;
	        });
	        return;
	      }
	      if (valid.includes(false)) {
	        return;
	      }
	      if (result.showInstrucciones === "true") {
	        result.showInstrucciones = true;
	      } else {
	        result.showInstrucciones = false;
	      }

	      result.phone = this.countryCodes.country + result.phone;
	      this.editEstablishment ? this.save(result) : this._createEstablishment(result);
	      $mdDialog.cancel();
	    }
	    /**
	     * Validates the input field to ensure it does not contain multiple consecutive spaces.
	     *
	     * @param {object} event - The event object containing information about the triggered event.
	     * @param {object} form - The form object to update the validity status.
	     * @param {string} type - The type of input field being validated (optional).
	     */
	    var _validateSpaces = function _validateSpaces(event, form, type) {
	      var re2 = /^(?!\s|.*\s$).*$/;
	      var resAlpha = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s[a-zA-ZÀ-ÿ\u00f1\u00d1]+)*$/;
	      var nums = /^[0-9\u00f1\u00d1]+(\s[0-9\u00f1\u00d1]+)*$/;
	      var item = document.getElementById("" + event.target.id);
	      var errApi = document.getElementById("err_" + event.target.id);
	      if (!resAlpha.test(item.value) || !re2.test(item.value)) {
	        item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errApi.style.display = "block";
	        errApi.innerHTML = $translate.instant("app.establishments.err_spaces");
	        errApi.style.color = "rgba(219, 72, 73, 1)";
	        form !== undefined ? form.$invalid = true : null;
	        _this.errorInputs = true;
	      } else {
	        form !== undefined ? form.$invalid = false : null;
	        item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errApi.style.display = "none";
	        _this.errorInputs = false;
	      }

	      if (type) {
	        if (type === "phone") {
	          if (!nums.test(item.value) || !re2.test(item.value)) {
	            item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	            errApi.style.display = "block";
	            errApi.innerHTML = $translate.instant("app.establishments.err_spaces");
	            errApi.style.color = "rgba(219, 72, 73, 1)";
	            form !== undefined ? form.$invalid = true : null;
	            _this.errorInputs = true;
	          } else {
	            form !== undefined ? form.$invalid = false : null;
	            item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	            errApi.style.display = "none";
	            _this.errorInputs = false;
	          }
	        }
	      }

	      if (item.value.length === 10) {
	        form !== undefined ? form.$invalid = false : null;
	        item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errApi.style.display = "none";
	        _this.errorInputs = false;
	      }
	    };
	    /**
	     * Closes the dialog, resetting the form and hiding the dialog.
	     * - Resets the `new_establishment` model to an empty object.
	     * - Resets the form associated with the establishment (`establishmentForm`) by marking it as untouched.
	     * - Hides the Material Design dialog (`$mdDialog.hide()`).
	     *
	     * This function is typically used to close a dialog for creating or updating establishments.
	     */
	    function _closeDialog() {
	      this.new_establishment = {};
	      this.establishmentForm.$setUntouched(); // this resets the form itself
	      $mdDialog.hide();
	    }
	    /**
	     * Cancels or dismisses the Material Design dialog.
	     *
	     * This function is typically called when the user cancels an operation or chooses to close the dialog.
	     * It utilizes `$mdDialog.cancel()` to dismiss the dialog without taking any further action.
	     */
	    function _cancelDialog() {
	      $mdDialog.cancel();
	    }
	    /**
	     * Displays a confirmation dialog for deleting an organization.
	     *
	     * @param {Event} ev - The event triggering the dialog.
	     *
	     * This function shows a Material Design confirmation dialog to confirm the deletion
	     * of an organization. It provides "Accept" and "Cancel" options for the user. If the user
	     * accepts, the `_deleteEstablishment` function is called; otherwise, a message is logged
	     * indicating the decision to keep the organization.
	     */
	    function confirmDeleteOrg(ev) {
	      var current_scope = this;
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        current_scope._deleteEstablishment(ev);
	      }, function () {
	        console.log("You decided to keep it.");
	      });
	    }
	    /**
	     * Toggles the display of options associated with a specific button.
	     *
	     * @param {string} id - The ID of the button or container element.
	     *
	     * This function shows or hides the options associated with a button or container element
	     * based on its current display state. If the options are hidden, they are displayed; otherwise,
	     * they are hidden. Additionally, it adds a mouseup event listener to the document, allowing
	     * the options to be hidden if the user clicks outside the container.
	     */
	    function _editOptionsButton(id) {
	      var opc = document.getElementById(id);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Handles the change event of an AngularJS `ng-select` element.
	     *
	     * @param {string} value - The selected value of the `ng-select` element.
	     *
	     * This function is typically used as an event handler for the change event
	     * of an AngularJS `ng-select` element. It removes the "md-input-invalid" class
	     * from the parent container's first child element if the selected value is not '0'.
	     */
	    function ngSelect(value) {
	      var phone2 = document.getElementById("phone");
	      if (value !== "0") {
	        phone2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	      }
	    }
	    /**
	     * Activates or deactivates options button with a given id and prefix.
	     *
	     * @param {string} id - The id of the options button.
	     * @param {string} prefix - The prefix used in conjunction with the id.
	     *
	     * This function toggles the display of the options button based on its current state.
	     * If the button is hidden, it will be displayed; if it's visible, it will be hidden.
	     * Additionally, it adds a mouseup event listener to the document. If a click occurs outside
	     * the options button container, the container's display will be set to 'none'.
	     */
	    function _activateOptionsButton(id, prefix) {
	      var opc = document.getElementById(id + prefix);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id + prefix);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Displays a list of establishments, initializing necessary properties.
	     *
	     * @param {Array} establishments - The array of establishments to be displayed.
	     *
	     * This function iterates through the provided establishments, setting the 'Selected'
	     * property of each to false. It then updates various properties such as 'noData',
	     * 'fail', 'originalData', and calls the '_createUsingFullOptions' function to handle
	     * the initialization of the display with the given establishments.
	     */
	    function showEstablishments(establishments) {
	      angular.forEach(establishments, function (value) {
	        value.Selected = false;
	      });

	      // Ordenar alfabéticamente por nombre
	      establishments.sort(function (a, b) {
	        if (a.name && b.name) {
	          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
	        }
	        return 0;
	      });

	      this.noData = establishments.length == 0 ? true : false;
	      this.fail = false;
	      this.originalData = angular.copy(establishments);
	      this._createUsingFullOptions(establishments);
	    }
	    /**
	     * Retrieves establishments based on the user role and organization ID.
	     *
	     * @param {string} user_role - The role of the user.
	     * @param {string} organizationId - The ID of the organization.
	     *
	     * This function makes a request to the OrganizationsResource to get establishments
	     * associated with the specified organization ID and type 'locations'. It then updates
	     * properties like 'noData', 'fail', 'originalData', and calls the '_createUsingFullOptions1'
	     * function to handle the initialization of the display with the retrieved establishments.
	     */
	    function getEstablismentByOrganization(user_role, organizationId) {
	      var _this7 = this;

	      this.OrganizationsResource.getEstablismentByOrganization({
	        id: organizationId,
	        type: "locations"
	      }).$promise.then(function (result) {
	        // Ordenar alfabéticamente por nombre
	        result.sort(function (a, b) {
	          if (a.name && b.name) {
	            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
	          }
	          return 0;
	        });

	        _this7.noData = result.length == 0 ? true : false;
	        _this7.fail = false;
	        _this7.originalData = angular.copy(result);
	        _this7._createUsingFullOptions1(result);
	      }).catch(function (error) {
	        console.log(error);
	        _this7.$translate("app.kiosks.ERROR_GETBYESTABLISHMENT").then(function (errorMsg) {
	          _this7.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Retrieves the name of a time zone based on its ID.
	     *
	     * @param {string} timeZonesId - The ID of the time zone.
	     * @returns {string} - The name of the time zone corresponding to the given ID, or an
	     * empty string if not found.
	     *
	     * This function searches through the available time zones to find the one with the
	     * specified ID and returns its name. If no matching time zone is found, it returns
	     * an empty string.
	     */
	    function getTimeZoneName(timeZonesId) {
	      if (this.timeZones && timeZonesId !== undefined) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;

	        try {
	          for (var _iterator = this.timeZones[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var timeZone = _step.value;

	            if (timeZone.id === timeZonesId) {
	              return timeZone.name;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      return "";
	    }
	    /**
	     * Handles the change of the selected item in the organization dropdown.
	     *
	     * @param {Object} item - The selected organization item.
	     *
	     * If a valid organization item is provided, this function updates various properties
	     * such as 'currentOrganization', 'organizationId', and 'organizationInUse' based on
	     * the selected organization. It then triggers the retrieval of establishments
	     * associated with the selected organization. If no item is provided, it resets the
	     * organization-related properties and retrieves establishments for the current user's
	     * organization.
	     */
	    function selectedItemChange(item) {
	      var _this8 = this;

	      if (item !== undefined) {
	        var Organization = JSON.parse(JSON.stringify(item));

	        var current_organization = Organization;
	        this.currentOrganization = current_organization;
	        this.organizationId = current_organization.id;
	        this.organizationInUse = current_organization.name;
	        this.getEstablismentByOrganization(this.$localStorage.currentRole, this.organizationId);
	        return;
	      }
	      this.organizationInUse = undefined;
	      var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
	      this.AdministrationService.getEstablishments(this.currentRole, organizationId, "locations").then(function (result) {
	        _this8.fail = false;
	        _this8.data = result;
	        _this8.data.sort(function (a, b) {
	          if (a.name < b.name) {
	            return -1;
	          }
	          if (a.name > b.name) {
	            return 1;
	          }
	          return 0;
	        });
	        _this8.originalData.sort(function (a, b) {
	          if (a.name < b.name) {
	            return -1;
	          }
	          if (a.name > b.name) {
	            return 1;
	          }
	          return 0;
	        });
	        _this8._createUsingFullOptions();
	      }).catch(function (error) {
	        console.log(error);
	        _this8.$translate("app.ERROR_GETESTABLISHMENT").then(function (errorMsg) {
	          _this8.toastr.error(errorMsg, "Error");
	        });
	      });
	      return;
	    }
	    /**
	     * Handles the search query for the organization selection.
	     *
	     * @param {string} query - The search query for filtering organizations.
	     * @returns {Array} - An array of organizations filtered based on the search query.
	     *
	     * This function sorts the organizations alphabetically and filters them based on
	     * the provided search query. If a query is present, it uses the 'createFilterFor'
	     * function to perform the filtering; otherwise, it returns the original list of
	     * organizations.
	     */
	    function querySearchSelect(query) {
	      this.organizations.sort(function (a, b) {
	        return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
	      });
	      var results = query ? this.organizations.filter(createFilterFor(query)) : this.organizations;
	      return results;
	    }
	    /**
	     * Creates a filter function for matching items based on a given query.
	     *
	     * @param {string} query - The search query to create a filter for.
	     * @returns {function} - A filter function that matches items based on the query.
	     *
	     * This function takes a search query, converts it to lowercase, and returns a
	     * filter function. The filter function compares the lowercase value of each item's
	     * name with the lowercase query, checking if the name starts with the query.
	     */
	    var createFilterFor = function createFilterFor(query) {
	      var lowercaseQuery = query.toLowerCase();
	      return function filterFn(item) {
	        var lowerCaseValue = item.name.toLowerCase();
	        return lowerCaseValue.indexOf(lowercaseQuery) === 0;
	      };
	    };

	    // exports
	    angular.extend(this, {
	      config: config,
	      updateIcons: updateIcons,
	      _createUsingFullOptions: _createUsingFullOptions,
	      _createUsingFullOptions1: _createUsingFullOptions1,
	      pageSizeChanged: pageSizeChanged,
	      _showZoneForm: _showZoneForm,
	      _showZoneFormEdit: _showZoneFormEdit,
	      _searchCountryCode: _searchCountryCode,
	      _sendEstablishment: _sendEstablishment,
	      _validateSpaces: _validateSpaces,
	      _validateInputs: _validateInputs,
	      _createEstablishment: _createEstablishment,
	      _updateEstablishment: _updateEstablishment,
	      _deleteEstablishment: _deleteEstablishment,
	      _closeDialog: _closeDialog,
	      _cancelDialog: _cancelDialog,
	      _editOptionsButton: _editOptionsButton,
	      _activateOptionsButton: _activateOptionsButton,
	      confirmDeleteOrg: confirmDeleteOrg,
	      showEstablishments: showEstablishments,
	      _detailEstablishment: _detailEstablishment,
	      getEstablismentByOrganization: getEstablismentByOrganization,
	      getTimeZoneName: getTimeZoneName,
	      _showDetailDialog: _showDetailDialog,
	      selectedItemChange: selectedItemChange,
	      querySearchSelect: querySearchSelect,
	      ngSelect: ngSelect
	    });
	  }

	  _createClass(EstablishmentsController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this9 = this;

	      /**
	       * Get all establishments
	       */
	      var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
	      this.AdministrationService.getEstablishments(this.currentRole, organizationId, "locations").then(function (result) {
	        _this9.fail = false;
	        _this9.data = result;

	        _this9.originalData = _this9.data;

	        // Ordenar alfabéticamente por nombre
	        _this9.originalData.sort(function (a, b) {
	          if (a.name && b.name) {
	            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
	          }
	          return 0;
	        });
	        _this9._createUsingFullOptions();
	      }).catch(function (error) {
	        console.log(error);
	        _this9.$translate("app.ERROR_GETESTABLISHMENT").then(function (errorMsg) {
	          _this9.toastr.error(errorMsg, "Error");
	        });
	      });

	      // Get all time zones from the server
	      this.TimeZones.getTimeZones().$promise.then(function (result) {
	        //Store the time zones to show in the UI
	        _this9.timeZones = result;
	      }).catch(function (error) {
	        console.log(error);
	        _this9.$translate("app.ERROR_GETTIMEZONES").then(function (errorMsg) {
	          _this9.toastr.error(errorMsg, "Error");
	        });
	      });

	      this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
	        _this9.organizations = result.reverse();
	      }).catch(function (error) {
	        console.log(error);
	        _this9.$translate("app.ERROR_GETORGANIZATION").then(function (errorMsg) {
	          _this9.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	  }, {
	    key: "organizationChanged",
	    value: function organizationChanged() {
	      this.$localStorage.last_organization = this.organizationSelected;
	      var current_organization = JSON.parse(this.organizationSelected);
	      this.currentOrganization = current_organization;
	      this.organizationId = current_organization.id;
	      this.organizationInUse = current_organization.name;
	      this.organizationSelected = undefined;
	      this.$scope.selectOrganizationForm.$setPristine();

	      // Load all services by organization
	      this.getEstablismentByOrganization(this.$localStorage.currentRole, this.organizationId);
	    }
	  }]);

	  return EstablishmentsController;
	}();

	EstablishmentsController.$inject = ["config", "$scope", "$rootScope", "AdministrationService", "EstablishmentsResource", "OrganizationsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$location", "$localStorage", "TimeZones"];

	exports.default = EstablishmentsController;

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var EstablishmentsService =

	/** @ngInject */
	function EstablishmentsService() {
	  _classCallCheck(this, EstablishmentsService);
	};

	//EstablishmentsService.$inject = ['EstablishmentsResource'];

	exports.default = EstablishmentsService;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _users = __webpack_require__(68);

	var _users2 = __webpack_require__(70);

	var _users3 = _interopRequireDefault(_users2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var users = angular.module('mod.admin.administration.users', []).component('users', _users.UsersComponent).service('UsersService', _users3.default).name;

	exports.default = users;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UsersComponent = undefined;

	var _users = __webpack_require__(69);

	var _users2 = _interopRequireDefault(_users);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var UsersComponent = exports.UsersComponent = {
	  controller: _users2.default,
	  templateUrl: 'app/modules/admin/administration/users/users.html'
	};

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersController = function () {
	  /** @ngInject */
	  UsersController.$inject = ["$rootScope", "$scope", "config", "Users", "OrganizationsResource", "EstablishmentsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "AuthService", "$filter", "RolesResource", "AdministrationService", "pageSizeOptions"];
	  function UsersController($rootScope, $scope, config, Users, OrganizationsResource, EstablishmentsResource, NgTableParams, $translate, toastr, $mdDialog, $localStorage, $location, AuthService, $filter, RolesResource, AdministrationService, pageSizeOptions) {
	    var _this = this;

	    _classCallCheck(this, UsersController);

	    // private
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$filter = $filter;
	    this.$localStorage = $localStorage;
	    this.currentRole = this.$localStorage.currentRole;
	    this.currentId = this.$localStorage.currentUser.id;
	    this.isPre = config.IS_PRE;
	    this.Users = Users;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.OrganizationsResource = OrganizationsResource;
	    this.RolesResource = RolesResource;
	    this.AuthService = AuthService;
	    this.AdministrationService = AdministrationService;
	    this.config = config;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.$mdDialog = $mdDialog;
	    this.isAdding = false;
	    this.fail = false;
	    this.selectedItemChange = selectedItemChange;
	    this.getEstablismentByOrganization = getEstablismentByOrganization;
	    this.preventSpaces = preventSpaces;
	    this.onOrganizationChange = onOrganizationChange;
	    this.handleMainCenterChange = handleMainCenterChange;
	    this.pageSizeOptions = pageSizeOptions;
	    this.count = 10;
	    this.searchTextOrganization = '';
	    this.searchText = '';

	    this.cancel = cancel;
	    this.showDeleteConfirm = showDeleteConfirm;
	    this.del = del;
	    this.save = save;
	    this.add = add;
	    this.resetRow = resetRow;
	    this.formErrors = [];
	    this.establishments = [];
	    // Control of sidemenu page
	    var url = $location.url().substring(1).toUpperCase();
	    this.$rootScope.currentPage = currentPage(1);

	    var role_order = 4;

	    this.role_order = role_order;

	    this.pageSizeOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
	    this.errPass = false;
	    this.confirmPassword = false;
	    this.usrData = {};
	    this.editUsr = false;
	    this.show = false;
	    this.show1 = false;
	    this.show2 = false;

	    this.roles = [{
	      name: "ROLE_ADMIN",
	      value: "ADMIN",
	      role_option: 3
	    }, {
	      name: "ROLE_STATISTICS",
	      value: "STATISTICS",
	      role_option: 2
	    }, {
	      name: "ROLE_KIOSK",
	      value: "KIOSK",
	      role_option: 2
	    }, {
	      name: "ROLE_KIOSK_ONLINE",
	      value: "KIOSK_ONLINE",
	      role_option: 2
	    }, {
	      name: "ROLE_KIOSK_WIDGET",
	      value: "KIOSK_WIDGET",
	      role_option: 2
	    }, {
	      name: "ROLE_SCREEN",
	      value: "SCREEN",
	      role_option: 2
	    }, {
	      name: "ROLE_SUPERADMIN",
	      value: "SUPERADMIN",
	      role_option: 2
	    }, {
	      name: "ROLE_WORKER",
	      value: "WORKER",
	      role_option: 4
	    }];

	    this.roles.sort(function (a, b) {
	      var aL = a.name.toLowerCase();
	      var bL = b.name.toLowerCase();
	      if (aL < bL) return -1;
	      if (aL > bL) return 1;
	      return 0;
	    });

	    this.new_user = {};

	    /**
	     * Retrieves the specified segment of the current URL based on the given index.
	     *
	     * @param {number} index - The index of the URL segment to retrieve.
	     * @returns {string} - The URL segment at the specified index.
	     */
	    function currentPage(index) {
	      var split_url = url.split("/");
	      return split_url[index];
	    }
	    /**
	     * Determines whether the current user is allowed to select the specified role option.
	     *
	     * @param {string} role_option - The role option to check for selection permission.
	     * @returns {boolean} - True if the user is allowed to select the role option, false otherwise.
	     */
	    function allowSelectRoles(role_option) {
	      return this.AuthService.allowSelectRoles(role_option);
	    }
	    /**
	     * Determines whether the current user is allowed to show the specified role option.
	     *
	     * @param {string} role_option - The role option to check for display permission.
	     * @returns {boolean} - True if the user is allowed to display the role option, false otherwise.
	     */
	    function allowShowRoles(role_option) {
	      return this.AuthService.allowShowRoles(role_option);
	    }
	    /**
	     * Handles the event when the page size is changed for a table.
	     *
	     * @param {number} newPageSize - The new page size selected.
	     */
	    var pageSizeChanged = function pageSizeChanged(newPageSize) {
	      _this.tableParams.count(newPageSize);
	      _this.counter = newPageSize;
	    };
	    /**
	     * Creates a table using full options with the provided user data.
	     *
	     * @param {Array} data_users - The array of user data to populate the table.
	     * @returns {Object} - The NgTableParams object representing the created table.
	     */
	    function _createUsingFullOptions(data_users) {
	      var _this2 = this;

	      var initialParams = {
	        count: this.count, // initial page size
	        filter: {}
	      };
	      var initialSettings = {
	        // page size buttons (right set of buttons in demo)
	        counts: [],
	        // determines the pager buttons (left set of buttons in demo)
	        paginationMaxBlocks: 4,
	        paginationMinBlocks: 2,
	        dataset: data_users,
	        filterOptions: {
	          filterDelay: 0
	        },
	        getData: function getData(params) {
	          var filteredData = params.filter() ? data_users.filter(function (user) {
	            // Filtro para rol traducido
	            if (params.filter().role) {
	              var search = params.filter().role.toLowerCase();
	              var translated = _this2.$translate.instant('app.users.ROLE_' + user.role).toLowerCase();
	              if (!translated.includes(search)) return false;
	            }
	            // Filtro para estado traducido
	            if (params.filter().status) {
	              var searchStatus = params.filter().status.toLowerCase();
	              var statusKey = user.status === true || user.status === 'true' ? 'STATUS_ENABLED' : 'STATUS_DISABLED';
	              var translatedStatus = _this2.$translate.instant('app.administration.' + statusKey).toLowerCase();
	              if (!translatedStatus.includes(searchStatus)) return false;
	            }
	            // Filtros estándar para otros campos
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;

	            try {
	              for (var _iterator = Object.keys(params.filter())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var key = _step.value;

	                if (key !== 'role' && key !== 'status' && params.filter()[key]) {
	                  if (!user[key] || !user[key].toString().toLowerCase().includes(params.filter()[key].toLowerCase())) {
	                    return false;
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }

	            return true;
	          }) : data_users;
	          params.total(filteredData.length);
	          var orderedData = params.sorting() ? _this2.$filter('orderBy')(filteredData, params.orderBy()) : filteredData;
	          var pageData = orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
	          return pageData;
	        }
	      };
	      this.tableParams = new NgTableParams(initialParams, initialSettings);
	      return this.tableParams;
	    }
	    /**
	     * Adds a new template with the provided data.
	     *
	     * @param {Object} new_template - The data for the new template.
	     */
	    function add(new_template) {
	      new_template.role = new_template.role.toUpperCase();
	      if (new_template.status) {
	        new_template.status = true;
	      } else {
	        new_template.status = false;
	      }
	      location.reload();
	    }
	    /**
	     * Cancels the changes made to a row and reverts it to its original state.
	     *
	     * @param {Object} row - The row to be canceled.
	     */
	    function cancel(row) {
	      var originalRow = this.resetRow(row);
	      angular.extend(row, originalRow);
	    }
	    /**
	     * Shows a confirmation dialog for deleting a user.
	     *
	     * @param {Object} ev - The event that triggered the dialog.
	     */
	    function showDeleteConfirm(ev) {
	      var current_scope = this;
	      hideElement(ev.id);
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        current_scope.deleteUser(ev);
	      });
	    }
	    /**
	     * Deletes a row from the dataset and reloads the table.
	     *
	     * @param {Object} row - The row to be deleted.
	     */
	    function del(row) {
	      var $this = this;
	      var main_dataset = this.tableParams.settings().dataset;
	      var originalData = "";
	      angular.forEach(this.tableParams.settings().dataset, function (value, key) {
	        if (angular.equals(row, value)) {
	          main_dataset.splice(key, 1);
	          originalData = angular.copy(main_dataset);
	        }
	      });
	      this.originalData = originalData;
	      this.tableParams.reload().then(function (data) {
	        if (data.length === 0 && $this.tableParams.total() > 0) {
	          $this.tableParams.page($this.tableParams.page() - 1);
	          $this.tableParams.reload();
	        }
	      });
	    }
	    /**
	     * Saves changes to a user role by updating the dataset and triggering the update function.
	     *
	     * @param {Object} row - The user data to be saved.
	     */
	    function save(row) {
	      row.role = row.role.replace("ROLE_", "");
	      this.isAdding = false;
	      this.updateUser(row);
	    }
	    /**
	     * Resets the row by copying the original dataset and updating the row's editing status.
	     * If the row is being added, it copies the original dataset.
	     *
	     * @param {Object} row - The row to be reset.
	     * @returns {Object} - The original data for the row.
	     */
	    function resetRow(row) {
	      var row_isAdding = this.isAdding;
	      if (row_isAdding) {
	        this.originalData = angular.copy(this.tableParams.settings().dataset);
	      }
	      var return_value = "";
	      row.isEditing = false;
	      angular.forEach(this.originalData, function (value) {
	        if (!row_isAdding && row.id === value.id) {
	          return_value = value;
	        } else if (row_isAdding && value.id === "") {
	          return_value = value;
	        }
	      });
	      return return_value;
	    }
	    /**
	     * Shows details of the user in a dialog if the user is not in edit mode.
	     *
	     * @param {Object} user - The user object.
	     */
	    function _detailUser(user) {
	      if (user.isEditing !== true) {
	        this.current_user = user;
	        if (!this.establishments || this.establishments.length === 0) {
	          this.getEstablismentByOrganization(this.currentOrganizationId);
	        }
	        this._showDetailDialog();
	      }
	    }
	    /**
	     * Shows the detail dialog for the user.
	     *
	     * @param {Object} [ev] - The event object.
	     */
	    function _showDetailDialog(ev) {
	      var _this3 = this;

	      var dialogOptions = {
	        preserveScope: true,
	        hasBackdrop: true,
	        contentElement: "#dialog_detail_user",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this3;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      };

	      $mdDialog.show(dialogOptions).then();
	    }
	    /**
	     * Hides the element with the specified ID.
	     *
	     * @param {string} id - The ID of the element to hide.
	     */
	    function hideElement(id) {
	      var menu = document.getElementById('' + id);
	      if (menu) {
	        menu.style.display = "none";
	      }
	    }
	    /**
	     * Shows the zone form dialog, allowing the user to add or edit a zone.
	     *
	     * @param {Object} [ev={}] - The event object.
	     */
	    function _showZoneForm() {
	      var _this4 = this;

	      var ev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var parent = this;
	      if (this.organizationSelected) {
	        this.currentOrganizationId = this.organizationSelected.id;
	      }
	      this.new_user.organizationId = this.currentOrganizationId;
	      this.getEstablismentByOrganization(this.currentOrganizationId);

	      parent.editUsr = (typeof ev === 'undefined' ? 'undefined' : _typeof(ev)) === 'object' && Object.keys(ev).length > 0;
	      if (parent.editUsr) {
	        hideElement(ev.id);
	        this._showZoneFormEdit(ev);
	        this._oldMain = this.new_user.locationId;
	        this._oldSecondaryLocations = (this.new_user.secondaryLocations || []).map(function (loc) {
	          return typeof loc === 'string' ? loc : loc.id;
	        });
	        this.new_user.secondaryLocations = [].concat(_toConsumableArray(this._oldSecondaryLocations));
	        this.getEstablismentByOrganization(this.currentOrganizationId);
	      }

	      var user_role = this.currentRole;
	      if (user_role == "ADMIN") {
	        this.allowed_location_ids = this.$localStorage.currentAllLocations.map(function (loc) {
	          return loc.id;
	        });
	      } else if (user_role == "SUPERADMIN" || user_role == "ROOT") {
	        this.allowed_location_ids = this.establishments.map(function (loc) {
	          return loc.id;
	        });
	      }

	      // --- LIMPIEZA DE ERRORES Y FORMULARIO ---
	      var fieldsToReset = ["username", "firstname", "lastname", "email", "password", "password2"];
	      fieldsToReset.forEach(function (field) {
	        var errElement = document.getElementById('err_' + field);
	        var inputElement = document.getElementById(field);
	        if (errElement) {
	          errElement.style.display = "none";
	        }
	        if (inputElement && inputElement.parentElement && inputElement.parentElement.parentElement) {
	          inputElement.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        }
	      });
	      if (this.userForm) {
	        this.userForm.$setPristine();
	        this.userForm.$setUntouched();
	      }
	      this.formErrors = [];
	      // --- FIN LIMPIEZA ---

	      var dialogOptions = {
	        preserveScope: true,
	        hasBackdrop: true,
	        contentElement: "#myDialog",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this4;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      };

	      $mdDialog.show(dialogOptions).then(function () {
	        parent._closeDialog();
	        parent.editUsr = false;
	      }, function () {
	        parent._closeDialog();
	        parent.editUsr = false;
	      });
	    }
	    /**
	     * Prepares the zone form for editing by copying the provided user data.
	     *
	     * @param {Object} usr - The user data to be edited.
	     */
	    function _showZoneFormEdit(usr) {
	      this.new_user = angular.copy(usr);
	    }
	    /**
	     * Resets the password for the specified user.
	     *
	     * If the user's role includes "kiosk," it shows the zone form for resetting the password.
	     * Otherwise, it sends a reset password email to the user.
	     *
	     * @param {Object} usr - The user for whom the password should be reset.
	     */
	    function resetPassword(usr) {
	      var _this5 = this;

	      if (usr.role.toLowerCase().includes("kiosk")) {
	        this._showZoneFormResPass(usr);
	      } else {
	        this.Users.resetPassEmail({ email: usr.email }).$promise.then(function () {
	          _this5.$translate("app.users.RESET_PASS_EMAIL").then(function (msg) {
	            _this5.toastr.success(msg + ': ' + usr.email);
	          });
	        }).catch(function (err) {
	          var errorMsgKey = err.data.error.message.replaceAll(" ", "_").toUpperCase();
	          _this5.handleErrorMessage('app.users.' + errorMsgKey);
	        });
	      }
	    }
	    /**
	     * Shows the zone form for resetting the password, using the provided user data.
	     *
	     * @param {Object} usr - The user data for whom the password should be reset.
	     */
	    function _showZoneFormResPass(usr) {
	      var _this6 = this;

	      this.usrData = usr;

	      var dialogOptions = {
	        preserveScope: true,
	        hasBackdrop: true,
	        contentElement: "#resetPassDialog",
	        parent: angular.element(document.body),
	        controller: function controller() {
	          return _this6;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      };

	      $mdDialog.show(dialogOptions).then();
	    }
	    /**
	     * Returns the translated name for a given input field.
	     *
	     * @param {string} name - The name of the input field.
	     * @returns {string} - The translated name.
	     */
	    var showNames = function showNames(name) {
	      switch (name) {
	        case "firstname":
	          return "Nombre";
	        case "lastname":
	          return "Apellido";
	        case "email":
	          return "Correo";
	        case "password":
	          return "Contraseña";
	        case "username":
	          return "Usuario";
	        default:
	          return "";
	      }
	    };
	    /**
	     * Adds an ID to the formErrors array if it's not already included.
	     *
	     * @param {string} id - The ID to be added to the formErrors array.
	     */
	    var addToFormError = function addToFormError(id) {
	      if (!_this.formErrors.includes(id)) {
	        _this.formErrors.push(id);
	      }
	    };
	    /**
	     * Removes an ID from the formErrors array.
	     *
	     * @param {string} id - The ID to be removed from the formErrors array.
	     */
	    var removeFromFormError = function removeFromFormError(id) {
	      var index = _this.formErrors.indexOf(id);
	      if (index > -1) {
	        _this.formErrors.splice(index, 1);
	      }
	    };
	    /**
	     * Toggles the visibility of the password input.
	     *
	     * @param {string} pass - The identifier for the password input to be toggled ("show1" or "show2").
	     */
	    function _showPass(pass) {
	      if (pass === "show1") {
	        this.show1 = !this.show1;
	      } else if (pass === "show2") {
	        this.show2 = !this.show2;
	      }
	      this.show = !this.show;
	    }
	    /**
	     * Validates the input value based on the specified criteria for the given field.
	     *
	     * @param {string} value - The input value to be validated.
	     * @param {string} id - The identifier of the input field.
	     * @param {object} rowForm - The AngularJS form object.
	     */
	    var _validateInputs = function _validateInputs(value, id, rowForm) {
	      if (value === undefined) {
	        return;
	      }
	      var name2 = document.getElementById('' + id);
	      var errName = document.getElementById('err_' + id);
	      var colorError = "rgba(219, 72, 73, 1)";

	      // Function to add the error class and message
	      var showError = function showError(errorMessage) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.innerHTML = errorMessage;
	        errName.style.display = "block";
	        errName.style.color = colorError;
	        rowForm.$pristine = true;
	        addToFormError(id);
	      };

	      // Function to clear the error class and message
	      var clearError = function clearError() {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        removeFromFormError(id);
	        rowForm.$pristine = false;
	      };

	      // Function to check if the value is within a specific length range
	      var checkLength = function checkLength(min, max) {
	        return value.length >= min && value.length <= max;
	      };var regEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
	      var regexPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=])[A-Za-z\d!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=]{8,}$/;
	      var noLeadingTrailingSpacesRegex = /^\s|\s$/;
	      var regexUsername = /^[a-zA-Z0-9_-]{3,50}$/;
	      var regexName = /^[a-zA-Z]+(\s[a-zA-Z]+)*$/;
	      // Mejorar la validación de emojis para emails
	      // Regex más robusto para emojis y caracteres no permitidos en emails
	      var emojiRegex = /[Eijmop\{\}\u200D\uFE0F]/g;
	      // También bloquea caracteres fuera del rango ASCII estándar para emails
	      var invalidEmailChars = /[\u0080-\uFFFF]/g;
	      // Regex para detectar cualquier caracter fuera del ASCII básico (emojis, acentos, símbolos, etc)
	      var nonAsciiRegex = /[^\x00-\x7F]/;

	      switch (id) {
	        case "username":
	          if (!checkLength(3, 50) || !regexUsername.test(value) || noLeadingTrailingSpacesRegex.test(value)) {
	            var errorMsg = 'El campo ' + showNames(id) + ' no cumple con los requisitos: ';
	            if (!checkLength(3, 50)) {
	              errorMsg += "Debe tener entre 3 y 50 caracteres. ";
	            }
	            if (!regexUsername.test(value)) {
	              errorMsg += "Solo se permiten letras, números y sin espacios. ";
	            }
	            if (noLeadingTrailingSpacesRegex.test(value)) {
	              errorMsg += "No puede comenzar o terminar con espacios y no puede tener espacios consecutivos.";
	            }
	            showError(errorMsg);
	            if (rowForm && rowForm[id]) rowForm[id].$setValidity('noSpaces', false);
	          } else {
	            clearError();
	            if (rowForm && rowForm[id]) rowForm[id].$setValidity('noSpaces', true);
	          }
	          break;
	        case "email":
	          // Detecta cualquier caracter fuera del ASCII estándar
	          var hasNonAscii = nonAsciiRegex.test(value);
	          if (!regEmail.test(value) || noLeadingTrailingSpacesRegex.test(value) || hasNonAscii) {
	            var _errorMsg = 'El campo ' + showNames(id) + ' no es un correo electr\xF3nico v\xE1lido. ';
	            if (noLeadingTrailingSpacesRegex.test(value)) {
	              _errorMsg += "No puede contener espacios en blanco. ";
	            }
	            if (hasNonAscii) {
	              _errorMsg += "No puede contener emojis ni caracteres especiales/acento.";
	            }
	            showError(_errorMsg);
	            if (rowForm && rowForm[id]) rowForm[id].$setValidity('noSpaces', false);
	          } else {
	            clearError();
	            if (rowForm && rowForm[id]) rowForm[id].$setValidity('noSpaces', true);
	          }
	          break;

	        case "firstname":
	        case "lastname":
	          // Validar espacios al inicio o final y solo letras
	          var hasSpaces = /^\s|\s$/.test(value);
	          if (!checkLength(3, 50) || !regexName.test(value.trim()) || hasSpaces) {
	            var _errorMsg2 = 'El campo ' + showNames(id) + ' no cumple con los requisitos: ';
	            if (!checkLength(3, 50)) {
	              _errorMsg2 += "Debe tener entre 3 y 50 caracteres. ";
	            }
	            if (!regexName.test(value.trim())) {
	              _errorMsg2 += "Solo se permiten letras. ";
	            }
	            if (hasSpaces) {
	              _errorMsg2 += "No se permiten espacios en blanco al principio o al final.";
	            }
	            if (rowForm && rowForm[id]) {
	              rowForm[id].$setValidity('noSpaces', false);
	            }
	            showError(_errorMsg2);
	          } else {
	            if (rowForm && rowForm[id]) {
	              rowForm[id].$setValidity('noSpaces', true);
	            }
	            clearError();
	          }
	          break;

	        case "password":
	          if (!regexPassword.test(value)) {
	            showError('El campo ' + showNames(id) + ' debe tener al menos 8 caracteres y contener al menos una letra y un d\xEDgito. Puede incluir caracteres especiales como !@#$%^&*()_+{}[]:;<>,.?~-/\\|=');
	          } else {
	            clearError();
	          }
	          break;

	        default:
	          break;
	      }
	    };
	    /**
	     * Validates the password based on the specified criteria.
	     *
	     * @param {string} value - The password value to be validated.
	     * @param {string} name - The name of the password field.
	     * @param {object} rowForm - The AngularJS form object.
	     */
	    var _validatePass = function _validatePass(value, name, rowForm) {
	      var regexPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=])[A-Za-z\d!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=]{8,}$/;
	      if (name !== "confirmPassword") {
	        if (!regexPassword.test(value)) {
	          _this.userResetPass.$invalid = true;
	          rowForm.$pristine = true;
	          _this.errPass = true;
	        } else {
	          _this.userResetPass.$invalid = false;
	          _this.errPass = false;
	        }
	      }
	      if (name === "confirmPassword") {
	        if (value !== _this.userResetPass.rePassword) {
	          _this.userResetPass.$invalid = true;
	          rowForm.$pristine = true;
	          _this.confirmPassword = true;
	        } else {
	          _this.userResetPass.$invalid = false;
	          _this.confirmPassword = false;
	        }
	      }
	    };
	    /**
	     * Validates the form inputs for user registration or update.
	     *
	     * @returns {boolean} - Returns true if the form inputs are valid, otherwise false.
	     */
	    var validationForm = function validationForm() {
	      var username = document.getElementById("username");
	      var err_username = document.getElementById("err_username");
	      var name = document.getElementById("firstname");
	      var err_firstname = document.getElementById("err_firstname");
	      var lastname = document.getElementById("lastname");
	      var err_lastname = document.getElementById("err_lastname");
	      var email = document.getElementById("email");
	      var err_email = document.getElementById("err_email");
	      var password = document.getElementById("password");
	      var err_password = document.getElementById("err_password");
	      var err_password2 = document.getElementById("err_password2");
	      var colorError = "rgba(219, 72, 73, 1)";

	      var regEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
	      var resLetter = /^[a-zA-Z]+(\s[a-zA-Z]+)*$/;
	      var resPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=])[A-Za-z\d!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=]{8,}$/;
	      var regexUsername = /^[a-zA-Z0-9_-]{3,50}$/;
	      var noLeadingTrailingSpacesRegex = /^\s|\s$/;

	      var showError = function showError(element, errorMessage) {
	        element.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        element.style.display = "block";
	        element.innerHTML = errorMessage;
	        element.style.color = colorError;
	        return false;
	      };

	      var clearError = function clearError(element) {
	        element.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        element.style.display = "none";
	        return true;
	      };

	      if (!regexUsername.test(username.value) || noLeadingTrailingSpacesRegex.test(username.value)) {
	        return showError(err_username, "Ingrese un nombre de usuario válido. Sólo se permiten letras, números y sin espacios.");
	      } else if (username.value.length > 50 || username.value.length < 3) {
	        return showError(err_username, "El nombre de usuario debe tener entre 3 y 50 caracteres.");
	      } else {
	        clearError(err_username);
	      }

	      if (!resLetter.test(name.value) || noLeadingTrailingSpacesRegex.test(name.value)) {
	        return showError(err_firstname, "Ingrese un nombre válido. Sólo se permiten letras, sin espacios en blanco al inicio ó final.");
	      } else if (name.value.length > 50 || name.value.length < 3) {
	        return showError(err_firstname, "El nombre debe tener entre 3 y 50 caracteres.");
	      } else {
	        clearError(err_firstname);
	      }

	      if (!resLetter.test(lastname.value) || noLeadingTrailingSpacesRegex.test(lastname.value)) {
	        return showError(err_lastname, "Ingrese un apellido válido. Sólo se permiten letras, sin espacios en blanco al inicio ó final");
	      } else if (lastname.value.length < 2 || lastname.value.length > 50) {
	        return showError(err_lastname, "El apellido debe tener entre 2 y 50 caracteres.");
	      } else {
	        clearError(err_lastname);
	      }

	      if (!regEmail.test(email.value) || noLeadingTrailingSpacesRegex.test(email.value)) {
	        return showError(err_email, "Ingrese un correo electrónico válido. No puede contener espacios en blanco");
	      } else {
	        clearError(err_email);
	      }

	      if (!_this.editUsr) {
	        if (password.value.length < 8) {
	          return showError(err_password, "La contraseña debe tener al menos 8 caracteres");
	        } else {
	          clearError(err_password);
	        }
	        if (!resPassword.test(password.value)) {
	          return showError(err_password2, "La contraseña debe contener al menos una letra y un dígito. Puede incluir caracteres especiales como !@#$%^&*()_+{}[]:;<>,.?~-/\\|=");
	        } else {
	          clearError(err_password2);
	        }
	      }

	      return true;
	    };
	    /**
	     * Sends the user data for registration or update after validating the form inputs.
	     *
	     * @param {Object} result - The user data to be sent.
	     */
	    function _sendUser(result) {
	      var validForm = validationForm();
	      if (validForm) {
	        if (this.userForm.$invalid) {
	          Object.values(this.userForm.$$controls).forEach(function (control) {
	            control.$touched = true;
	          });
	          return;
	        }
	        this.editUsr ? this.save(result) : this.createUser(result);
	      }
	      return;
	    }
	    /**
	     * Validates the input for spaces, ensuring there are no leading or trailing spaces.
	     *
	     * @param {Object} event - The event object triggered by the input.
	     * @param {Object} form - The form object to update if there are validation errors.
	     */
	    var _validateSpaces = function _validateSpaces(event, form) {
	      var reNoLeadingTrailingSpaces = /^\S(?:.*\S)?$/;
	      var reOnlyLettersAndSpaces = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s[a-zA-ZÀ-ÿ\u00f1\u00d1]+)*$/;

	      var item = document.getElementById(event.target.id);
	      var errApi = document.getElementById('err_' + event.target.id);

	      if (item.value.trim() === "") {
	        item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errApi.style.display = "none";
	        _this.errorInputs = false;
	        return;
	      }

	      if (!reOnlyLettersAndSpaces.test(item.value) || !reNoLeadingTrailingSpaces.test(item.value)) {
	        item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errApi.style.display = "block";
	        errApi.innerHTML = $translate.instant("app.establishments.err_spaces");
	        errApi.style.color = "rgba(219, 72, 73, 1)";
	        if (form !== undefined) {
	          form.$invalid = true;
	        }
	        _this.errorInputs = true;
	      } else {
	        if (form !== undefined) {
	          form.$invalid = false;
	        }
	        item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errApi.style.display = "none";
	        _this.errorInputs = false;
	      }
	    };
	    /**
	     * Prevent entering a space as the first character in inputs.
	     * Used by templates as ng-keypress="$ctrl.preventSpaces($event)".
	     */
	    function preventSpaces(event) {
	      try {
	        var key = event.key || String.fromCharCode(event.which || event.keyCode || 0);
	        if (key === ' ' || event.keyCode === 32) {
	          var input = event.target || event.srcElement;
	          if (!input) return true;
	          var pos = typeof input.selectionStart === 'number' ? input.selectionStart : null;
	          var isAtStart = pos === 0 || input.value === undefined || input.value.length === 0;
	          if (isAtStart) {
	            event.preventDefault();
	            return false;
	          }
	        }
	      } catch (e) {
	        // ignore and allow
	      }
	      return true;
	    }
	    /**
	     * Closes the dialog, resetting the user form and initializing necessary values.
	     */
	    function _closeDialog() {
	      this.new_user = {};
	      this._oldMain = "";
	      this._oldSecondaryLocations = [];
	      this.allowed_location_ids = [];
	      this.new_user.email = "";
	      this.new_user.organizationId = this.organizationSelected;
	      this.userForm.$setUntouched(); // this resets the form itself
	      this.$onInit();
	      $mdDialog.hide();
	    }
	    /**
	     * Cancels the dialog without taking any further action.
	     */
	    function _cancelDialog() {
	      $mdDialog.cancel();
	    }
	    /**
	     * Initiates the editing mode for a user, enabling changes to the user's information.
	     *
	     * @param {Object} user - The user object to be edited.
	     */
	    function startEditing(user) {
	      user.isEditing = true;
	      var organization_data = user.location && user.location.organizationId ? user.location.organizationId : user.organizationId;
	      this.getEstablismentByOrganization(organization_data);
	    }
	    /**
	     * Creates a new user with the provided information.
	     *
	     * @param {Object} user - The user object containing information for the new user.
	     */
	    function createUser(user) {
	      var _this7 = this;

	      var $this = this;
	      user.username = user.username;

	      if (!user.locationId || user.locationId == "") {
	        user.locationId = this.$localStorage.currentLocation.id;
	      }
	      user.role !== "CONSULT" ? user.plataforma = "DASHBOARD" : null;

	      this.Users.create({}, user).$promise.then(function (result) {
	        var employeeId = result.id;

	        (user.secondaryLocations || []).forEach(function (locId) {
	          _this7.Users.addSecondaryLocation({
	            employeeId: employeeId,
	            locationId: locId
	          }).$promise.catch(function (err) {
	            return console.error('Error agregando secondary location', locId, err);
	          });
	        });

	        $this.new_user = {}; // this resets the model
	        $this.userForm.$setPristine(); // this resets the form itself
	        $this.userForm.$setUntouched(); // this resets the form itself
	        $this.add(result);
	        $this._cancelDialog();
	      }).catch(function (error) {
	        if (error.data.error.message.indexOf("Email already exists") > -1) {
	          return _this7.handleErrorMessage("app.users.ERROR_CREAT_MAIL");
	        }
	        if (error.data.error.message.indexOf("User already exists") > -1) {
	          return _this7.handleErrorMessage("app.users.ERROR_CREAT_USER");
	        }
	        _this7.handleErrorMessage("app.users.ERROR_CREATE");
	      });
	    }
	    /**
	     * Updates the information of an existing user.
	     *
	     * @param {Object} row - The user object containing updated information.
	     */
	    function updateUser(row) {
	      var _this8 = this;

	      row.userId = row.id;
	      var userId = row.userId;
	      var oldSecs = (this._oldSecondaryLocations || []).map(function (loc) {
	        return typeof loc === 'string' ? loc : loc.id;
	      });

	      var newSecs = (row.secondaryLocations || []).map(function (loc) {
	        return typeof loc === 'string' ? loc : loc.id;
	      });

	      var payload = Object.assign({}, row);
	      delete payload.password;
	      if (payload.user) delete payload.user;
	      if (payload.location) delete payload.location;
	      if (payload.secondaryLocations) delete payload.secondaryLocations;

	      this.Users.update({ id: userId }, payload).$promise.then(function () {
	        var toRemove = oldSecs.filter(function (loc) {
	          return !newSecs.includes(loc);
	        });
	        var toAdd = newSecs.filter(function (loc) {
	          return !oldSecs.includes(loc);
	        });

	        var removePromises = toRemove.map(function (loc) {
	          return _this8.Users.removeSecondaryLocation({
	            employeeId: userId,
	            locationId: loc
	          }).$promise.catch(function (err) {
	            console.error('Error quitando secondary location', loc, err);
	          });
	        });

	        var addPromises = toAdd.map(function (loc) {
	          return _this8.Users.addSecondaryLocation({
	            employeeId: userId,
	            locationId: loc
	          }).$promise.catch(function (err) {
	            console.error('Error agregando secondary location', loc, err);
	          });
	        });
	        return Promise.all([].concat(_toConsumableArray(removePromises), _toConsumableArray(addPromises)));
	      }).then(function () {
	        if (_this8.establishmentId) {
	          _this8.getUsersByEstablishment(_this8.establishmentId);
	        } else {
	          _this8.getUsersByOrganization(_this8.currentOrganizationId);
	        }
	        _this8._cancelDialog();
	      }).catch(function () {
	        _this8.handleErrorMessage("app.users.ERROR_UPDATE");
	      });
	    }
	    /**
	     * Resets the password of a user to a default value.
	     *
	     * @param {Object} row - The user object for which the password will be reset.
	     */
	    function resetPass(row) {
	      var _this9 = this;

	      var current_user_data = row;
	      row.userId = row.id;
	      var userId = row.userId;
	      current_user_data.password = "123456";
	      if (current_user_data.user) delete current_user_data.user;
	      if (current_user_data.center) delete current_user_data.center;
	      this.Users.resetPass({ id: userId }, current_user_data).$promise.then(function () {
	        _this9.$translate("app.administration.RESET_OK").then(function (msg) {
	          _this9.toastr.success(msg, $translate.instant("app.administration.RESET_SUCCESS"));
	        });
	      }).catch(function () {
	        _this9.handleErrorMessage("app.users.ERROR_UPDATE");
	      });
	    }
	    /**
	     * Sends a request to reset the password of a user with the provided reset password data.
	     */
	    function sendResetPass() {
	      var _this10 = this;

	      var current_user_data = {
	        password: this.userResetPass.rePassword,
	        userId: this.usrData.id
	      };

	      this.Users.resetPassword({}, current_user_data).$promise.then(function () {
	        _this10.$translate("app.administration.RESET_OK").then(function (msg) {
	          _this10.toastr.success(msg, $translate.instant("app.administration.RESET_SUCCESS"));
	        });
	        _this10._closeDialog();
	      }).catch(function () {
	        _this10.handleErrorMessage("app.users.ERROR_UPDATE");
	      });
	    }
	    /**
	     * Deletes a user by making a request to the server with the user's ID.
	     */
	    function deleteUser(user) {
	      var _this11 = this;

	      this.Users.delete({ id: user.id }).$promise.then(function () {
	        _this11.$translate("app.administration.DELETE_OK").then(function (msg) {
	          _this11.toastr.success(msg, $translate.instant("app.administration.DELETE_SUCCESS"));
	        });
	        _this11.del(user);
	      }).catch(function () {
	        _this11.handleErrorMessage("app.users.ERROR_DELETE");
	      });
	    }
	    /**
	     * Retrieves establishments associated with the specified organization ID.
	     * If the user's role is SUPERADMIN or ROOT, makes a request to the server.
	     * Updates the component's 'establishments' property with the result.
	     * Sorts the establishments alphabetically by name.
	     * Handles errors by displaying an error message.
	     * @param {string} organizationId - The ID of the organization to retrieve establishments for.
	     */
	    function getEstablismentByOrganization(organization_id) {
	      var _this12 = this;

	      var organizationId = organization_id ? organization_id : this.organizationSelected.id;
	      if (!organizationId) {
	        this.searchText = '';
	        this.establishments = [];
	        return;
	      }
	      var user_role = this.currentRole;
	      if (user_role == "ADMIN" || user_role == "SUPERADMIN" || user_role == "ROOT") {
	        this.OrganizationsResource.getEstablismentByOrganization({
	          id: organizationId
	        }).$promise.then(function (result) {
	          console.log('result', result);
	          _this12.establishments = result;
	          _this12.establishments.sort(function (a, b) {
	            var aL = a.name.toLowerCase();
	            var bL = b.name.toLowerCase();
	            if (aL < bL) return -1;
	            if (aL > bL) return 1;
	            return 0;
	          });
	        }).catch(function () {
	          _this12.handleErrorMessage("app.ERROR_GETESTABLISHMENT");
	        });
	      }
	    }
	    /**
	     * Retrieves users associated with the specified organization ID.
	     * Makes a request to the server using OrganizationsResource.getEmployeesByOrganization.
	     * Includes location information in the result.
	     * If successful, updates the component's state using the 'manageUsers' method.
	     * If unsuccessful, sets 'fail' to true and displays an error message.
	     * @param {string} organizationId - The ID of the organization to retrieve users for.
	     */
	    function getUsersByOrganization(organization_id) {
	      var _this13 = this;

	      this.OrganizationsResource.getEmployeesByOrganization({
	        id: organization_id,
	        filter: { "include": "location" }
	      }).$promise.then(function (result) {
	        _this13.fail = false;
	        _this13.manageUsers(result);
	      }).catch(function () {
	        _this13.fail = true;
	        _this13.handleErrorMessage("app.users.ERROR_GETBYORGANIZATION");
	      });
	    }
	    /**
	     * Retrieves users associated with the specified establishment ID.
	     * Makes a request to the server using EstablishmentsResource.getEmployeesByEstablishment.
	     * Includes location information in the result.
	     * If successful, updates the component's state using the 'manageUsers' method.
	     * If unsuccessful, sets 'fail' to true, and displays an error message.
	     * @param {string} currentLocation - The ID of the establishment to retrieve users for.
	     */
	    function getUsersByEstablishment(currentLocation) {
	      var _this14 = this;

	      this.EstablishmentsResource.getEmployeesByEstablishment({
	        id: currentLocation,
	        filter: { include: ['location', 'secondaryLocations'] }
	      }).$promise.then(function (result) {
	        _this14.fail = false;
	        _this14.manageUsers(result.reverse());
	      }).catch(function () {
	        _this14.fail = true;
	        _this14.handleErrorMessage("app.users.ERROR_GETBYESTABLISHMENT");
	      });
	    }
	    /**
	     * Sorts the provided array of user objects by the 'firstname' property.
	     * Updates the component's 'data' and 'originalData' properties with the sorted array.
	     * Converts user roles to uppercase and updates 'status' properties based on truthiness.
	     * Calls the '_createUsingFullOptions' method to initialize or update the NgTableParams.
	     * @param {Array} users - The array of user objects to be managed.
	     */
	    function manageUsers(users) {
	      var _this15 = this;

	      users.sort(function (a, b) {
	        return a.firstname.localeCompare(b.firstname);
	      });

	      var visibleUsers = users.filter(function (user) {
	        return !(user.id === _this15.currentId || user.role === 'ROOT' || user.role === 'SCREEN' || user.role === 'KIOSK' || user.role === 'DEVICE' || _this15.allowShowRoles(user.role) === false) || _this15.currentRole === 'ROOT';
	      });

	      this.data = visibleUsers;
	      this.noData = visibleUsers.length === 0;
	      angular.forEach(this.data, function (value) {
	        value.status = !!value.status;
	      });
	      this.originalData = angular.copy(visibleUsers);
	      this._createUsingFullOptions(visibleUsers);
	    }
	    /**
	     * Toggles the display of the HTML element with the specified ID.
	     * If the element is currently hidden, it will be displayed; otherwise, it will be hidden.
	     * Adds a mouseup event listener to hide the element if a click occurs outside of it.
	     * @param {string} id - The ID of the HTML element to toggle.
	     */
	    function _editOptionsButton(id) {
	      var opc = document.getElementById(id);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Toggles the display of the HTML element with the specified ID and prefix.
	     * If the element is currently hidden, it will be displayed; otherwise, it will be hidden.
	     * Adds a mouseup event listener to hide the element if a click occurs outside of it.
	     * @param {string} id - The ID of the HTML element to toggle.
	     * @param {string} prefix - The prefix to append to the ID for target element identification.
	     */
	    function _activateOptionsButton(id, prefix) {
	      var opc = document.getElementById(id + prefix);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id + prefix);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Handles the change of the selected organization.
	     * - If an organization is selected, fetches its related establishments.
	     * - If no organization is selected, clears the selected establishment and resets the search text.
	     * @param {Object|null} org - The selected organization or null/undefined if cleared.
	     */
	    function onOrganizationChange(org) {
	      this.organizationSelected = org || null;
	      if (org && org.id) {
	        this.new_user.organizationId = org.id;
	        this.getEstablismentByOrganization(org.id);
	      } else {
	        this.new_user.organizationId = this.currentOrganizationId;
	        this.establishmentSelected = null;
	        this.establishments = null;
	        this.searchText = '';
	      }
	    }
	    /**
	     * Handles the change of the selected item. Updates the current establishment and related properties.
	     * If the item is defined, it deep copies it to 'current_establishment' and updates relevant properties.
	     * If the item is undefined, checks the user role and fetches users accordingly.
	     * @param {Object} item - The selected item.
	     */
	    function selectedItemChange(item) {
	      this.establishmentInUse = '';
	      this.establishmentSelected = item || null;
	      if (item) {
	        // Deep copy the 'item' to 'current_establishment'
	        var current_establishment = JSON.parse(JSON.stringify(item));

	        // Update properties
	        this.currentEstablishment = current_establishment;
	        this.establishmentId = current_establishment.id;
	        this.establishmentInUse = current_establishment.name;

	        // Get users by establishment
	        this.getUsersByEstablishment(this.establishmentId);
	      } else {
	        var user_role = this.$localStorage.currentRole.toUpperCase();

	        if (user_role === "ADMIN") {
	          // When the user is an ADMIN, get users by location
	          this.getUsersByEstablishment(this.$localStorage.currentLocation.id);
	        }

	        if (this.currentRole === "ROOT" || this.currentRole === "SUPERADMIN") {
	          this.manageUsers([]);
	        }
	      }
	    }
	    /**
	     * Fetches establishments based on the given organization ID and user role.
	     * Updates the 'establishments' property with the retrieved data.
	     * @param {string} organizationId - The ID of the organization for which establishments are fetched.
	     */
	    function fetchEstablishments(organizationId) {
	      var _this16 = this;

	      this.AdministrationService.getEstablishments(this.$localStorage.currentRole, organizationId, "locations").then(function (result) {
	        _this16.noData = result.length == 0 ? true : false;
	        _this16.establishments = result.reverse();
	      }).catch(function () {
	        _this16.handleErrorMessage("app.ERROR_GETESTABLISHMENT");
	      });
	    }
	    /**
	     * Fetches users with additional location information.
	     * Updates 'fail' propertie based on the result.
	     * Calls the 'manageUsers' method to process the retrieved user data.
	     */
	    function fetchAndManageUsers() {
	      var _this17 = this;

	      this.Users.getUsers({ filter: { include: "location" } }).$promise.then(function (result) {
	        _this17.fail = false;
	        _this17.manageUsers(result.reverse());
	      }).catch(function () {
	        _this17.fail = true;
	        _this17.handleErrorMessage("app.users.ERROR_GETUSERS");
	      });
	    }
	    /**
	     * Performs a search on establishments based on the provided query.
	     * Sorts the establishments alphabetically.
	     * If no establishments are available, returns an empty array.
	     * @param {string} query - The search query.
	     * @returns {Array} - An array of establishments matching the query or an empty array if no establishments are available.
	     */
	    function querySearchSelect(query) {
	      if (this.establishments) {
	        this.establishments.sort(function (a, b) {
	          if (a.name < b.name) {
	            return -1;
	          }
	          if (a.name > b.name) {
	            return 1;
	          }
	          return 0;
	        });

	        var results = query ? this.establishments.filter(createFilterFor(query)) : this.establishments;

	        return results;
	      } else {
	        return [];
	      }
	    }
	    /**
	     * Performs a search on organizations based on the provided query.
	     * Sorts the organizations alphabetically.
	     * If no organizations are available, returns an empty array.
	     * @param {string} query - The search query.
	     * @returns {Array} - An array of organizations matching the query or an empty array if no organizations are available.
	     */
	    function querySearchSelectOrganizations(query) {
	      this.organizations.sort(function (a, b) {
	        if (a.name < b.name) {
	          return -1;
	        }
	        if (a.name > b.name) {
	          return 1;
	        }
	        return 0;
	      });
	      var results = query ? this.organizations.filter(createFilterFor(query)) : this.organizations;
	      return results;
	    }
	    /**
	     * Creates a filter function for the provided query.
	     * Converts the query to lowercase for case-insensitive comparison.
	     * @param {string} query - The search query.
	     * @returns {Function} - A filter function that checks if the item's name starts with the lowercase query.
	     */
	    var createFilterFor = function createFilterFor(query) {
	      var lowercaseQuery = query.toLowerCase();
	      return function filterFn(item) {
	        var lowerCaseValue = item.name.toLowerCase();
	        return lowerCaseValue.indexOf(lowercaseQuery) === 0;
	      };
	    };
	    /**
	     * Handles error messages by translating the provided message key and displaying an error toastr notification.
	     * @param {string} messageKey - The key used for translating the error message.
	     */
	    function handleErrorMessage(messageKey) {
	      var _this18 = this;

	      this.$translate(messageKey).then(function (errorMsg) {
	        _this18.toastr.error(errorMsg, "Error");
	      });
	    }
	    /**
	     * Handles changes to the user's secondary location.
	     * If the previously selected main location is no longer the current main, it is added to the secondary locations.
	     * Also ensures the new main location is removed from the list of secondaries to avoid duplication.
	     */
	    function handleMainCenterChange() {
	      var main = this.new_user.locationId;
	      var secondaries = this.new_user.secondaryLocations || [];
	      var oldMain = this._oldMain;
	      if (oldMain && !this.new_user.secondaryLocations.includes(oldMain)) {
	        this.new_user.secondaryLocations.push(oldMain);
	      }
	      this.new_user.secondaryLocations = secondaries.filter(function (id) {
	        return id !== main;
	      });
	    }

	    // exports
	    angular.extend(this, {
	      config: config,
	      createUser: createUser,
	      updateUser: updateUser,
	      deleteUser: deleteUser,
	      allowSelectRoles: allowSelectRoles,
	      allowShowRoles: allowShowRoles,
	      startEditing: startEditing,
	      _createUsingFullOptions: _createUsingFullOptions,
	      pageSizeChanged: pageSizeChanged,
	      _showZoneForm: _showZoneForm,
	      _showZoneFormEdit: _showZoneFormEdit,
	      _showZoneFormResPass: _showZoneFormResPass,
	      _closeDialog: _closeDialog,
	      _cancelDialog: _cancelDialog,
	      _sendUser: _sendUser,
	      _validateInputs: _validateInputs,
	      _validatePass: _validatePass,
	      _detailUser: _detailUser,
	      _showDetailDialog: _showDetailDialog,
	      _editOptionsButton: _editOptionsButton,
	      _activateOptionsButton: _activateOptionsButton,
	      getEstablismentByOrganization: getEstablismentByOrganization,
	      manageUsers: manageUsers,
	      getUsersByEstablishment: getUsersByEstablishment,
	      getUsersByOrganization: getUsersByOrganization,
	      resetPass: resetPass,
	      sendResetPass: sendResetPass,
	      selectedItemChange: selectedItemChange,
	      onOrganizationChange: onOrganizationChange,
	      handleMainCenterChange: handleMainCenterChange,
	      querySearchSelect: querySearchSelect,
	      querySearchSelectOrganizations: querySearchSelectOrganizations,
	      resetPassword: resetPassword,
	      _validateSpaces: _validateSpaces,
	      _showPass: _showPass,
	      fetchEstablishments: fetchEstablishments,
	      fetchAndManageUsers: fetchAndManageUsers,
	      handleErrorMessage: handleErrorMessage
	    });
	  }

	  _createClass(UsersController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this19 = this;

	      /**
	       * Cargamos todos los empleados, en el caso de que se haya hecho login
	       * como administrador, se muestra solo los empleados asignados a su centro
	       * Los usuarios ROOT, KIOSK y SCREEN solo son accesibles desde ROOT
	       */
	      var user_role = this.$localStorage.currentRole;
	      var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;

	      if (user_role.toUpperCase() == "ADMIN") {
	        this.establishmentId = this.$localStorage.currentLocation.id;
	        this.getUsersByEstablishment(this.establishmentId);
	      }

	      /**
	       * Cargamos todos las organizaciones, en caso de que se haya hecho login
	       * sin ser root, se muestra solo su organización, ya que no puede crear usuarios para otras organizaciones
	       */
	      // this.currentOrganizationId = this.new_user.organizationId =
	      //   this.$localStorage.currentOrganization.id;
	      this.currentOrganizationId = organizationId;
	      this.new_user.organizationId = this.organizationSelected ? this.organizationSelected.id : this.currentOrganizationId;

	      if (this.currentRole == "ROOT") {
	        this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
	          _this19.organizations = result;
	          _this19.organizations.sort(function (a, b) {
	            if (a.name.toLowerCase() < b.name.toLowerCase()) {
	              return -1;
	            }
	            if (a.name.toLowerCase() > b.name.toLowerCase()) {
	              return 1;
	            }
	            return 0;
	          });
	        }).catch(function () {
	          _this19.handleErrorMessage("app.ERROR_GETORGANIZATION");
	        });
	      }

	      if (this.currentRole == "SUPERADMIN") {
	        this.AdministrationService.getEstablishments(user_role, organizationId, "locations").then(function (result) {
	          _this19.establishments = result.reverse();
	        }).catch(function (error) {
	          console.log(error);
	          _this19.handleErrorMessage("app.ERROR_GETESTABLISHMENT");
	        });
	      }
	    }
	  }, {
	    key: 'establishmentChanged',
	    value: function establishmentChanged() {
	      this.$localStorage.last_establishment = this.establishmentSelected;
	      var current_establishment = JSON.parse(this.establishmentSelected);
	      this.currentEstablishment = current_establishment;
	      this.establishmentId = current_establishment.id;
	      this.establishmentInUse = current_establishment.name;
	      this.establishmentSelected = undefined;
	      this.$scope.selectEstablishmentForm.$setPristine();
	      // Load all kiosks by establishment
	      this.getUsersByEstablishment(this.establishmentId);
	    }
	  }]);

	  return UsersController;
	}();

	UsersController.$inject = ["$rootScope", "$scope", "config", "Users", "OrganizationsResource", "EstablishmentsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "AuthService", "$filter", "RolesResource", "AdministrationService"];

	exports.default = UsersController;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersService =

	/** @ngInject */
	function UsersService() {
	  _classCallCheck(this, UsersService);
	};

	//UsersService.$inject = ['UsersResource'];

	exports.default = UsersService;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _users = __webpack_require__(72);

	var _users2 = __webpack_require__(74);

	var _users3 = _interopRequireDefault(_users2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var validateUsers = angular.module('mod.admin.administration.validateUsers', []).component('validateUsers', _users.UsersComponent).service('UsersService', _users3.default).name;

	exports.default = validateUsers;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UsersComponent = undefined;

	var _users = __webpack_require__(73);

	var _users2 = _interopRequireDefault(_users);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var UsersComponent = exports.UsersComponent = {
	  controller: _users2.default,
	  templateUrl: 'app/modules/admin/administration/validateUsers/users.html'
	};

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersController = function () {
	  /** @ngInject */
	  UsersController.$inject = ["$rootScope", "$scope", "config", "Users", "OrganizationsResource", "EstablishmentsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "AuthService", "$filter", "RolesResource", "AdministrationService", "pageSizeOptions"];
	  function UsersController($rootScope, $scope, config, Users, OrganizationsResource, EstablishmentsResource, NgTableParams, $translate, toastr, $mdDialog, $localStorage, $location, AuthService, $filter, RolesResource, AdministrationService, pageSizeOptions) {
	    var _this = this;

	    _classCallCheck(this, UsersController);

	    // private
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$filter = $filter;
	    this.$localStorage = $localStorage;
	    this.currentRole = this.$localStorage.currentRole;
	    this.currentId = this.$localStorage.currentUser.id;
	    this.isPre = config.IS_PRE;
	    this.Users = Users;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.OrganizationsResource = OrganizationsResource;
	    this.RolesResource = RolesResource;
	    this.AuthService = AuthService;
	    this.AdministrationService = AdministrationService;
	    this.config = config;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.$mdDialog = $mdDialog;
	    this.isAdding = false;
	    this.fail = false;
	    this.selectedItemChange = selectedItemChange;
	    this.pageSizeOptions = pageSizeOptions;
	    this.count = 5;

	    this.showVerifyConfirm = showVerifyConfirm;
	    this.save = save;
	    this.resetRow = resetRow;
	    this.formErrors = [];
	    this.establishments = [];
	    // Control of sidemenu page
	    var url = $location.url().substring(1).toUpperCase();
	    this.$rootScope.currentPage = currentPage(1);

	    var role_order = 4;

	    this.role_order = role_order;

	    this.pageSizeOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
	    this.errPass = false;
	    this.confirmPassword = false;
	    this.usrData = {};
	    this.editUsr = false;
	    this.show = false;
	    this.show1 = false;
	    this.show2 = false;

	    /**
	    * Retrieves the specified segment from the current URL based on the provided index.
	    * @param {number} index - The index of the URL segment to retrieve.
	    * @returns {string} - The URL segment at the specified index.
	    */
	    function currentPage(index) {
	      var split_url = url.split("/");
	      return split_url[index];
	    }
	    /**
	     * Updates the page size of the table and sets the counter accordingly.
	     * @param {number} newPageSize - The new page size to be set for the table.
	     */
	    var pageSizeChanged = function pageSizeChanged(newPageSize) {
	      _this.tableParams.count(newPageSize);
	      _this.counter = newPageSize;
	    };
	    /**
	     * Creates an instance of NgTableParams using full options, including initial parameters and settings.
	     * @param {Array} data_users - The dataset to be used for the NgTableParams.
	     * @returns {Object} - The NgTableParams instance.
	     */
	    function _createUsingFullOptions(data_users) {
	      var initialParams = {
	        count: this.count // initial page size
	      };
	      var initialSettings = {
	        // page size buttons (right set of buttons in demo)
	        counts: [],
	        // determines the pager buttons (left set of buttons in demo)
	        paginationMaxBlocks: 4,
	        paginationMinBlocks: 2,
	        dataset: data_users
	      };
	      this.tableParams = new NgTableParams(initialParams, initialSettings);
	      return this.tableParams;
	    }
	    /**
	     * Displays a confirmation dialog for verifying all users. If the user accepts, it verifies all users.
	     * @param {Object} ev - The event that triggered the dialog.
	     */
	    function showVerifyConfirm(ev) {
	      var current_scope = this;
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_VERIFY")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        current_scope.Users.verifyAllUsers().$promise.then(function () {
	          current_scope.$translate("app.administration.VERIFIED_OK").then(function (msg) {
	            current_scope.toastr.success(msg, $translate.instant("app.administration.RESET_SUCCESS"));
	            var filter = { "include": ["location", "secondaryLocations"], "where": { "emailVerified": false } };
	            current_scope.fetchAndManageUsers(filter);
	          });
	        }).catch(function (error) {
	          console.log(error);
	          current_scope.handleErrorMessage("app.users.ERROR_UPDATE");
	        });
	      }, function () {
	        console.log("You decided to keep it.");
	      });
	    }
	    /**
	     * Saves changes made to a user. It updates the user role and calls the updateUser function.
	     * @param {Object} row - The user data to be saved.
	     */
	    function save(row) {
	      row.role = row.role.replace("ROLE_", "");
	      this.isAdding = false;
	      this.updateUser(row);
	    }
	    /**
	     * Resets the changes made to a row in the user table. It reverts the row to its original state.
	     * @param {Object} row - The row data to be reset.
	     * @returns {Object} - The original data of the row.
	     */
	    function resetRow(row) {
	      var row_isAdding = this.isAdding;
	      if (row_isAdding) {
	        this.originalData = angular.copy(this.tableParams.settings().dataset);
	      }
	      var return_value = "";
	      row.isEditing = false;
	      angular.forEach(this.originalData, function (value) {
	        if (!row_isAdding && row.id === value.id) {
	          return_value = value;
	        } else if (row_isAdding && value.id === "") {
	          return_value = value;
	        }
	      });
	      return return_value;
	    }
	    /**
	     * Translates a field name into its corresponding display name.
	     * @param {string} name - The field name to be translated.
	     * @returns {string} - The translated display name.
	     */
	    var showNames = function showNames(name) {
	      switch (name) {
	        case "firstname":
	          return "Nombre";
	        case "lastname":
	          return "Apellido";
	        case "email":
	          return "Correo";
	        case "password":
	          return "Contraseña";
	        case "username":
	          return "Usuario";
	        default:
	          return "";
	      }
	    };
	    /**
	     * Adds an error identifier to the formErrors array if it's not already present.
	     * @param {string} id - The error identifier to be added.
	     */
	    var addToFormError = function addToFormError(id) {
	      if (!_this.formErrors.includes(id)) {
	        _this.formErrors.push(id);
	      }
	    };
	    /**
	     * Removes an error identifier from the formErrors array.
	     * @param {string} id - The error identifier to be removed.
	     */
	    var removeFromFormError = function removeFromFormError(id) {
	      var index = _this.formErrors.indexOf(id);
	      if (index > -1) {
	        _this.formErrors.splice(index, 1);
	      }
	    };
	    /**
	     * Validates the input value based on the specified rules and updates the form's error status.
	     * @param {string} value - The input value to be validated.
	     * @param {string} id - The identifier of the input field.
	     * @param {object} rowForm - The form object associated with the input field.
	     */
	    var _validateInputs = function _validateInputs(value, id, rowForm) {
	      if (value === undefined) {
	        return;
	      }
	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);
	      var colorError = "rgba(219, 72, 73, 1)";

	      // Function to add the error class and message
	      var showError = function showError(errorMessage) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.innerHTML = errorMessage;
	        errName.style.display = "block";
	        errName.style.color = colorError;
	        rowForm.$pristine = true;
	        addToFormError(id);
	      };

	      // Function to clear the error class and message
	      var clearError = function clearError() {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        removeFromFormError(id);
	        rowForm.$pristine = false;
	      };

	      // Function to check if the value is within a specific length range
	      var checkLength = function checkLength(min, max) {
	        return value.length >= min && value.length <= max;
	      };

	      var regEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
	      var regexPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=])[A-Za-z\d!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=]{8,}$/;
	      var noLeadingTrailingSpacesRegex = /^\s|\s$/;
	      var regexUsername = /^[a-zA-Z0-9_-]{3,50}$/;
	      var regexName = /^[a-zA-Z]+(\s[a-zA-Z]+)*$/;

	      switch (id) {
	        case "username":
	          if (!checkLength(3, 50) || !regexUsername.test(value) || noLeadingTrailingSpacesRegex.test(value)) {
	            var errorMsg = "El campo " + showNames(id) + " no cumple con los requisitos: ";
	            if (!checkLength(3, 50)) {
	              errorMsg += "Debe tener entre 3 y 50 caracteres. ";
	            }
	            if (!regexUsername.test(value)) {
	              errorMsg += "Solo se permiten letras, números y sin espacios. ";
	            }
	            if (noLeadingTrailingSpacesRegex.test(value)) {
	              errorMsg += "No puede comenzar o terminar con espacios y no puede tener espacios consecutivos.";
	            }
	            showError(errorMsg);
	          } else {
	            clearError();
	          }
	          break;

	        case "email":
	          if (!regEmail.test(value) || noLeadingTrailingSpacesRegex.test(value)) {
	            var _errorMsg = "El campo " + showNames(id) + " no es un correo electr\xF3nico v\xE1lido. ";
	            if (noLeadingTrailingSpacesRegex.test(value)) {
	              _errorMsg += "No puede contener espacios en blanco";
	            }
	            showError(_errorMsg);
	          } else {
	            clearError();
	          }
	          break;

	        case "firstname":
	        case "lastname":
	          if (!checkLength(3, 50) || !regexName.test(value) || noLeadingTrailingSpacesRegex.test(value)) {
	            var _errorMsg2 = "El campo " + showNames(id) + " no cumple con los requisitos: ";
	            if (!checkLength(3, 50)) {
	              _errorMsg2 += "Debe tener entre 3 y 50 caracteres. ";
	            }
	            if (!regexName.test(value)) {
	              _errorMsg2 += "Solo se permiten letras. ";
	            }
	            if (noLeadingTrailingSpacesRegex.test(value)) {
	              _errorMsg2 += "No puede comenzar o terminar con espacios.";
	            }
	            showError(_errorMsg2);
	          } else {
	            clearError();
	          }
	          break;

	        case "password":
	          if (!regexPassword.test(value)) {
	            showError("El campo " + showNames(id) + " debe tener al menos 8 caracteres y contener al menos una letra y un d\xEDgito. Puede incluir caracteres especiales como !@#$%^&*()_+{}[]:;<>,.?~-/\\|=");
	          } else {
	            clearError();
	          }
	          break;

	        default:
	          break;
	      }
	    };
	    /**
	     * Validates the password input based on the specified rules and updates the form's error status.
	     * @param {string} value - The password input value to be validated.
	     * @param {string} name - The name of the password input field.
	     * @param {object} rowForm - The form object associated with the password input field.
	     */
	    var _validatePass = function _validatePass(value, name, rowForm) {
	      var regexPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=])[A-Za-z\d!@#$%^&*()_+{}\[\]:;<>,.?~\-\/\\|=]{8,}$/;
	      if (name !== "confirmPassword") {
	        if (!regexPassword.test(value)) {
	          _this.userResetPass.$invalid = true;
	          rowForm.$pristine = true;
	          _this.errPass = true;
	        } else {
	          _this.userResetPass.$invalid = false;
	          _this.errPass = false;
	        }
	      }
	      if (name === "confirmPassword") {
	        if (value !== _this.userResetPass.rePassword) {
	          _this.userResetPass.$invalid = true;
	          rowForm.$pristine = true;
	          _this.confirmPassword = true;
	        } else {
	          _this.userResetPass.$invalid = false;
	          _this.confirmPassword = false;
	        }
	      }
	    };
	    /**
	     * Closes the dialog, resets the form, and triggers the initialization function.
	     */
	    function _closeDialog() {
	      this.userForm.$setUntouched(); // this resets the form itself
	      this.$onInit();
	      $mdDialog.hide();
	    }
	    /**
	     * Cancels the dialog using Angular Material's $mdDialog service.
	     */
	    function _cancelDialog() {
	      $mdDialog.cancel();
	    }
	    /**
	     * Updates user data using the provided row object.
	     * Cancels the dialog after updating the user.
	     *
	     * @param {Object} row - The row object representing user data.
	     */
	    function updateUser(row) {
	      var _this2 = this;

	      var current_user_data = row;
	      row.userId = row.id;
	      var userId = row.userId;
	      delete current_user_data.password;
	      if (current_user_data.user) delete current_user_data.user;
	      if (current_user_data.center) delete current_user_data.center;
	      this._cancelDialog();
	      this.Users.update({ id: userId }, current_user_data).$promise.then(function (result) {
	        console.log(result);
	      }).catch(function (error) {
	        console.log(error);
	        _this2.handleErrorMessage("app.users.ERROR_UPDATE");
	      });
	    }
	    /**
	     * Resets the password of a user to a default value ("123456").
	     * The user data is updated, and a success message is displayed.
	     *
	     * @param {Object} row - The row object representing user data.
	     */
	    function resetPass(row) {
	      var _this3 = this;

	      var current_user_data = row;
	      row.userId = row.id;
	      var userId = row.userId;
	      current_user_data.password = "123456";
	      if (current_user_data.user) delete current_user_data.user;
	      if (current_user_data.center) delete current_user_data.center;
	      console.log("current_user_data", current_user_data);
	      this.Users.resetPass({ id: userId }, current_user_data).$promise.then(function (result) {
	        console.log(result);
	        _this3.$translate("app.administration.RESET_OK").then(function (msg) {
	          _this3.toastr.success(msg, $translate.instant("app.administration.RESET_SUCCESS"));
	        });
	      }).catch(function (error) {
	        console.log(error);
	        _this3.handleErrorMessage("app.users.ERROR_UPDATE");
	      });
	    }
	    /**
	     * Retrieves and populates establishments based on the provided organization ID.
	     * It fetches establishments for users with roles SUPERADMIN or ROOT.
	     *
	     * @param {string} organization_id - The ID of the organization to retrieve establishments for.
	     */
	    function getEstablismentByOrganization(organization_id) {
	      var _this4 = this;

	      var organizationId = organization_id;
	      if (this.currentRole == "SUPERADMIN" || this.currentRole == "ROOT") {
	        this.OrganizationsResource.getEstablismentByOrganization({
	          id: organizationId
	        }).$promise.then(function (result) {
	          _this4.establishments = result;
	          _this4.establishments.sort(function (a, b) {
	            var aL = a.name.toLowerCase();
	            var bL = b.name.toLowerCase();
	            if (aL < bL) return -1;
	            if (aL > bL) return 1;
	            return 0;
	          });
	        }).catch(function (error) {
	          console.log(error);
	          _this4.handleErrorMessage("app.ERROR_GETESTABLISHMENT");
	        });
	      }
	    }
	    /**
	     * Retrieves users associated with the specified organization, filtering by those who have not verified their email.
	     *
	     * @param {string} organization_id - The ID of the organization to retrieve users for.
	     */
	    function getUsersByOrganization(organization_id) {
	      var _this5 = this;

	      this.OrganizationsResource.getEmployeesByOrganization({
	        id: organization_id,
	        emailVerified: false,
	        filter: { include: "location" }
	      }).$promise.then(function (result) {
	        _this5.fail = false;
	        _this5.manageUsers(result);
	      }).catch(function (error) {
	        _this5.fail = true;
	        console.log(error);
	        _this5.handleErrorMessage("app.users.ERROR_GETBYORGANIZATION");
	      });
	    }
	    /**
	     * Retrieves users associated with the specified establishment, ordering the result in reverse chronological order.
	     *
	     * @param {string} currentLocation - The ID of the establishment to retrieve users for.
	     */
	    function getUsersByEstablishment(currentLocation) {
	      var _this6 = this;

	      this.EstablishmentsResource.getEmployeesByEstablishment({
	        id: currentLocation,
	        type: "employees",
	        filter: { include: ["location", "secondaryLocations"] }
	      }).$promise.then(function (result) {
	        _this6.noData = result.length == 0 ? true : false;
	        _this6.fail = false;
	        _this6.manageUsers(result.reverse());
	      }).catch(function (error) {
	        _this6.fail = true;
	        console.log(error);
	        _this6.handleErrorMessage("app.users.ERROR_GETBYESTABLISHMENT");
	      });
	    }
	    /**
	     * Manages the provided array of users by sorting them based on their first names in ascending order, updating the 'data' and 'originalData' properties, and creating a new NgTableParams instance using the full options.
	     *
	     * @param {Array} users - The array of users to be managed.
	     */
	    function manageUsers(users) {
	      users.sort(function (a, b) {
	        if (a.firstname < b.firstname) {
	          return -1;
	        }
	        if (a.firstname > b.firstname) {
	          return 1;
	        }
	        return 0;
	      });
	      this.data = users;
	      angular.forEach(this.data, function (value) {
	        // value.role = value.role.toUpperCase();
	        if (value.status) {
	          value.status = true;
	        } else {
	          value.status = false;
	        }
	      });
	      this.originalData = angular.copy(users);
	      this._createUsingFullOptions(users);
	    }
	    /**
	     * Activates or deactivates options button based on the provided 'id' and 'prefix'. If the button is currently hidden, it will be displayed; otherwise, it will be hidden. Additionally, it adds an event listener to hide the options when clicking outside the button's container.
	     *
	     * @param {string} id - The ID of the options button.
	     * @param {string} prefix - The prefix used in conjunction with the ID.
	     */
	    function _activateOptionsButton(id, prefix) {
	      var opc = document.getElementById(id + prefix);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id + prefix);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Handles the change of the selected item. If a valid 'item' is provided, it deep copies its properties to 'current_establishment', updates relevant properties, and retrieves users by establishment. If 'item' is undefined, it updates the establishment-related properties based on the user's role and fetches establishments or manages users accordingly.
	     *
	     * @param {Object} item - The selected item.
	     */
	    function selectedItemChange(item) {
	      if (item) {
	        // Deep copy the 'item' to 'current_establishment'
	        var current_establishment = JSON.parse(JSON.stringify(item));
	        // Update properties
	        this.currentEstablishment = current_establishment;
	        this.establishmentId = current_establishment.id;
	        this.establishmentInUse = current_establishment.name;

	        // Get users by establishment
	        this.getUsersByEstablishment(this.establishmentId);
	      } else {
	        this.establishmentInUse = undefined;
	        var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
	        var user_role = this.$localStorage.currentRole.toUpperCase();

	        if (user_role === "ADMIN") {
	          // When the user is an ADMIN, get users by location
	          this.getUsersByEstablishment(this.$localStorage.currentLocation.id);
	        } else {
	          // For non-ADMIN users, get a list of establishments
	          this.fetchEstablishments(organizationId);
	        }

	        // If the user has the role "ROOT," fetch and manage users
	        if (this.currentRole === "ROOT") {
	          var filter = { "include": ["location", "secondaryLocations"], "where": { "emailVerified": false } };
	          this.fetchAndManageUsers(filter);
	        }
	      }
	    }
	    /**
	     * Fetches establishments based on the provided 'organizationId'. It uses the 'AdministrationService' to retrieve establishments, updating 'noData' and 'establishments' properties accordingly. If an error occurs during the fetch, it logs the error and handles the error message.
	     *
	     * @param {string} organizationId - The ID of the organization for which establishments are fetched.
	     */
	    function fetchEstablishments(organizationId) {
	      var _this7 = this;

	      this.AdministrationService.getEstablishments(this.$localStorage.currentRole, organizationId, "locations").then(function (result) {
	        _this7.noData = result.length == 0 ? true : false;
	        _this7.establishments = result.reverse();
	      }).catch(function (error) {
	        console.log(error);
	        _this7.handleErrorMessage("app.ERROR_GETESTABLISHMENT");
	      });
	    }
	    /**
	     * Fetches and manages users based on the provided 'filter'. It uses the 'Users' service to retrieve users, updating 'noData', 'fail', and 'data' properties accordingly. If an error occurs during the fetch, it logs the error and handles the error message.
	     *
	     * @param {Object} filter - The filter object to apply to the user retrieval.
	     */
	    function fetchAndManageUsers(filter) {
	      var _this8 = this;

	      this.Users.getUsers({ filter: filter }).$promise.then(function (result) {
	        _this8.noData = result.length == 0 ? true : false;
	        _this8.fail = false;
	        _this8.manageUsers(result.reverse());
	      }).catch(function (error) {
	        _this8.fail = true;
	        console.log(error);
	        _this8.handleErrorMessage("app.users.ERROR_GETUSERS");
	      });
	    }
	    /**
	     * Handles error messages by translating the given 'messageKey' and displaying an error notification using 'toastr'.
	     *
	     * @param {string} messageKey - The key used to retrieve the translated error message.
	     */
	    function handleErrorMessage(messageKey) {
	      var _this9 = this;

	      this.$translate(messageKey).then(function (errorMsg) {
	        _this9.toastr.error(errorMsg, "Error");
	      });
	    }
	    // exports
	    angular.extend(this, {
	      config: config,
	      updateUser: updateUser,
	      _createUsingFullOptions: _createUsingFullOptions,
	      pageSizeChanged: pageSizeChanged,
	      _closeDialog: _closeDialog,
	      _cancelDialog: _cancelDialog,
	      _validateInputs: _validateInputs,
	      _validatePass: _validatePass,
	      _activateOptionsButton: _activateOptionsButton,
	      getEstablismentByOrganization: getEstablismentByOrganization,
	      manageUsers: manageUsers,
	      getUsersByEstablishment: getUsersByEstablishment,
	      getUsersByOrganization: getUsersByOrganization,
	      resetPass: resetPass,
	      selectedItemChange: selectedItemChange,
	      fetchEstablishments: fetchEstablishments,
	      fetchAndManageUsers: fetchAndManageUsers,
	      handleErrorMessage: handleErrorMessage
	    });
	  }

	  _createClass(UsersController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this10 = this;

	      /**
	       * Cargamos todos los empleados, en el caso de que se haya hecho login
	       * como administrador, se muestra solo los empleados asignados a su centro
	       * Los usuarios ROOT, KIOSK y SCREEN solo son accesibles desde ROOT
	       */
	      var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
	      var user_role = this.$localStorage.currentRole;
	      if (user_role.toUpperCase() == "ADMIN") {
	        this.getUsersByEstablishment(this.$localStorage.currentLocation.id);
	      } else {
	        /**
	         * Get all establishments to prepare combo
	         */
	        this.AdministrationService.getEstablishments(user_role, organizationId, "locations").then(function (result) {
	          _this10.establishments = result.reverse();
	        }).catch(function (error) {
	          console.log(error);
	          _this10.handleErrorMessage("app.ERROR_GETESTABLISHMENT");
	        });

	        if (this.currentRole == "ROOT") {
	          var filter = { "include": ["location", "secondaryLocations"], "where": { "emailVerified": false } };
	          this.fetchAndManageUsers(filter);
	        }
	      }

	      /**
	       * Cargamos todos las organizaciones, en caso de que se haya hecho login
	       * sin ser root, se muestra solo su organización, ya que no puede crear usuarios para otras organizaciones
	       */

	      if (this.currentRole == "ROOT") {
	        this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
	          _this10.organizations = result;
	          _this10.organizations.sort(function (a, b) {
	            if (a.name.toLowerCase() < b.name.toLowerCase()) {
	              return -1;
	            }
	            if (a.name.toLowerCase() > b.name.toLowerCase()) {
	              return 1;
	            }
	            return 0;
	          });
	        }).catch(function (error) {
	          console.log(error);
	          _this10.handleErrorMessage("app.ERROR_GETORGANIZATION");
	        });
	      }
	    }
	  }, {
	    key: "establishmentChanged",
	    value: function establishmentChanged() {
	      this.$localStorage.last_establishment = this.establishmentSelected;
	      var current_establishment = JSON.parse(this.establishmentSelected);
	      this.currentEstablishment = current_establishment;
	      this.establishmentId = current_establishment.id;
	      this.establishmentInUse = current_establishment.name;
	      this.establishmentSelected = undefined;
	      this.$scope.selectEstablishmentForm.$setPristine();
	      // Load all kiosks by establishment
	      this.getUsersByEstablishment(this.establishmentId);
	    }
	  }]);

	  return UsersController;
	}();

	UsersController.$inject = ["$rootScope", "$scope", "config", "Users", "OrganizationsResource", "EstablishmentsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "AuthService", "$filter", "RolesResource", "AdministrationService"];

	exports.default = UsersController;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersService =

	/** @ngInject */
	function UsersService() {
	  _classCallCheck(this, UsersService);
	};

	//UsersService.$inject = ['UsersResource'];

	exports.default = UsersService;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _kiosks = __webpack_require__(76);

	var _kiosks2 = __webpack_require__(78);

	var _kiosks3 = _interopRequireDefault(_kiosks2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var kiosks = angular.module('mod.admin.administration.kiosks', []).component('kiosks', _kiosks.KiosksComponent).service('KiosksService', _kiosks3.default).name;

	exports.default = kiosks;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.KiosksComponent = undefined;

	var _kiosks = __webpack_require__(77);

	var _kiosks2 = _interopRequireDefault(_kiosks);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var KiosksComponent = exports.KiosksComponent = {
	  controller: _kiosks2.default,
	  templateUrl: 'app/modules/admin/administration/kiosks/kiosks.html'
	};

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var KiosksController = function () {
	  /** @ngInject */
	  KiosksController.$inject = ["$scope", "$rootScope", "config", "KiosksResource", "OrganizationsResource", "EstablishmentsResource", "AdministrationService", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "pageSizeOptions", "instructions"];
	  function KiosksController($scope, $rootScope, config, KiosksResource, OrganizationsResource, EstablishmentsResource, AdministrationService, NgTableParams, $translate, toastr, $mdDialog, $localStorage, $location, pageSizeOptions, instructions) {
	    var _this = this;

	    _classCallCheck(this, KiosksController);

	    // private
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.isSuperAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && this.$localStorage.currentRole.toUpperCase() === "SUPERADMIN" ? true : false;
	    this.isRoot = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && this.$localStorage.currentRole.toUpperCase() === "ROOT" ? true : false;
	    this.isAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && this.$localStorage.currentRole.toUpperCase() === "ADMIN" ? true : false;
	    this.noData = true;
	    this.establishmentInUse = '';

	    var last_establishment = this.$localStorage.last_establishment ? $localStorage.last_establishment : false;
	    if (this.isRoot || this.isSuperAdmin) {
	      if (last_establishment) {
	        this.currentEstablishment = (typeof last_establishment === 'undefined' ? 'undefined' : _typeof(last_establishment)) != "object" ? JSON.parse(last_establishment) : last_establishment;
	        this.establishmentId = this.currentEstablishment.id;
	      }
	    } else {
	      this.establishmentId = $localStorage.currentLocation.id;
	    }
	    this.currentRole = this.$localStorage.currentRole;
	    this.isPre = config.IS_PRE;
	    this.OrganizationsResource = OrganizationsResource;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.KiosksResource = KiosksResource;
	    this.AdministrationService = AdministrationService;
	    this.config = config;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.$mdDialog = $mdDialog;
	    this.isAdding = false;
	    this.fail = false;
	    this.kiosksSelected = [];
	    this.haskiosksSelected = false;
	    this.organizations = [];
	    this.establishments = [];

	    this.kiosk = {};
	    this.rowFormKiosk = {};
	    this.typeInput = "";

	    this.cancel = cancel;
	    this.showDeleteConfirm = showDeleteConfirm;
	    this.showDisassignConfirm = showDisassignConfirm;
	    this.del = del;
	    this.save = save;
	    this.updateIcons = updateIcons;
	    this.add = add;
	    this.resetRow = resetRow;
	    this.count = 10;
	    this.pageSizeOptions = pageSizeOptions;
	    this.arrIns = [];
	    this.loadCenter = false;
	    this.instructions = instructions;
	    this.loadInstructions = false;
	    this.showInstructions = false;
	    this.kioskSelec = {};
	    this.searchTextOrganization = '';
	    this.searchText = '';

	    this.pageSizeOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

	    // Control of sidemenu page
	    var url = $location.url().substring(1).toUpperCase();
	    this.$rootScope.currentPage = currentPage(1);
	    /**
	     * Retrieves the value at a specified index from the URL's path segments.
	     * 
	     * @param {number} index - The index of the path segment to retrieve.
	     * @returns {string} - The value at the specified index in the URL's path segments.
	     * 
	     * This function splits the URL into path segments using "/", and returns the value
	     * at the given index in the resulting array. It helps extract specific parts of the
	     * URL based on the provided index.
	     */
	    function currentPage(index) {
	      var split_url = url.split("/");
	      return split_url[index];
	    }
	    /**
	     * Updates the page size for a table and sets the counter to the new page size.
	     * 
	     * @param {number} newPageSize - The new page size to be set for the table.
	     * 
	     * This function takes a new page size as a parameter, updates the table's page size
	     * using the NgTableParams 'count' method, and sets the counter to the new page size.
	     */
	    var pageSizeChanged = function pageSizeChanged(newPageSize) {
	      _this.tableParams.count(newPageSize);
	      _this.counter = newPageSize;
	    };
	    /**
	     * Creates and initializes a NgTableParams instance using full options for handling kiosk data.
	     * 
	     * @param {Array} data_kiosks - The array of kiosk data to be used for initializing the NgTableParams.
	     * @returns {NgTableParams} - The NgTableParams instance created and initialized with the provided options.
	     * 
	     * This function takes an array of kiosk data as a parameter and uses it to create and initialize
	     * an NgTableParams instance with full options, including initial page size, counts, and dataset.
	     * The initialized NgTableParams instance is then returned.
	     */
	    function _createUsingFullOptions(data_kiosks) {
	      var initialParams = {
	        count: this.count // initial page size
	      };

	      var initialSettings = {
	        counts: [],
	        paginationMaxBlocks: 4,
	        paginationMinBlocks: 2,
	        dataset: data_kiosks
	      };
	      this.tableParams = new NgTableParams(initialParams, initialSettings);
	      return this.tableParams;
	    }
	    /**
	     * Adds a new template to the NgTableParams dataset, sorts, and reloads the table.
	     * 
	     * @param {Object} new_template - The new template to be added to the NgTableParams dataset.
	     * 
	     * This function adds the provided new template to the beginning of the NgTableParams dataset,
	     * resets sorting, sets the page to 1, and then reloads the table to reflect the changes.
	     */
	    function add(new_template) {
	      this.tableParams.settings().dataset.unshift(new_template);
	      this.tableParams.sorting({});
	      this.tableParams.page(1);
	      this.tableParams.reload();
	    }
	    /**
	     * Cancels the editing of a row by restoring the original row data.
	     * 
	     * @param {Object} row - The row being edited.
	     * @param {Object} rowForm - The form associated with the row.
	     * 
	     * This function retrieves the original row data using the 'resetRow' function and then
	     * extends the 'row' object with the original data, effectively canceling the edits made.
	     */
	    function cancel(row, rowForm) {
	      var originalRow = this.resetRow(row, rowForm);
	      angular.extend(row, originalRow);
	    }
	    /**
	     * Hides the HTML element with the specified ID.
	     * 
	     * @param {string} id - The ID of the HTML element to be hidden.
	     * 
	     * This function sets the 'display' property of the HTML element with the specified ID to 'none',
	     * effectively hiding the element.
	     */
	    function hideElement(id) {
	      var menu = document.getElementById('' + id);
	      if (menu) {
	        menu.style.display = "none";
	      }
	    }
	    /**
	     * Displays a confirmation dialog for deleting a kiosk.
	     * 
	     * @param {Object} ev - The event object that triggered the function.
	     * 
	     * This function hides the HTML element with the specified ID, then displays a confirmation dialog
	     * for deleting a kiosk. The confirmation dialog includes 'Accept' and 'Cancel' options. If the user
	     * clicks 'Accept', the 'deleteKiosk' function is called.
	     */
	    function showDeleteConfirm(ev) {
	      var current_scope = this;
	      hideElement(ev.id);
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        current_scope.deleteKiosk(ev);
	      }).catch(function () {});
	    }
	    /**
	     * Displays a confirmation dialog for disassigning a service from a kiosk.
	     * 
	     * @param {Object} service - The service object to be disassigned.
	     * @param {Object} ev - The event object that triggered the function.
	     * 
	     * This function displays a confirmation dialog for disassigning a service from a kiosk. The dialog
	     * includes 'Accept' and 'Cancel' options. If the user clicks 'Accept', the 'disassignService' function
	     * is called with the ID of the current kiosk and the ID of the service to be disassigned.
	     */
	    function showDisassignConfirm(service, ev) {
	      var current_scope = this;
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        current_scope.disassignService(current_scope.current_kiosk.id, service.id);
	      }).catch(function () {});
	    }
	    /**
	     * Deletes a row from the dataset and updates the table.
	     * 
	     * @param {Object} row - The row to be deleted from the dataset.
	     * 
	     * This function removes the specified row from the dataset and updates the table. It first finds
	     * the index of the row in the dataset, removes it, and then updates the originalData property with
	     * the modified dataset. Finally, it reloads the table and adjusts the page if necessary.
	     */
	    function del(row) {
	      var $this = this;
	      var main_dataset = this.tableParams.settings().dataset;
	      var originalData = "";
	      angular.forEach(this.tableParams.settings().dataset, function (value, key) {
	        if (angular.equals(row, value)) {
	          main_dataset.splice(key, 1);
	          originalData = angular.copy(main_dataset);
	        }
	      });
	      this.originalData = originalData;
	      this.tableParams.reload().then(function (data) {
	        if (data.length === 0 && $this.tableParams.total() > 0) {
	          $this.tableParams.page($this.tableParams.page() - 1);
	          $this.tableParams.reload();
	        }
	      });
	    }
	    /**
	     * Updates icons in a row based on the provided state and type.
	     * 
	     * @param {Object} row - The row to be updated.
	     * @param {Object} rowForm - The form associated with the row.
	     * @param {boolean} state - The new state for the icon.
	     * @param {string} type - The type of icon to be updated ("asigned" or another type).
	     * 
	     * This function updates icons in the specified row based on the provided state and type.
	     * If the type is "asigned," it updates the "asigned" property; otherwise, it updates the "isVisible" property.
	     * Finally, it calls the 'save' function to persist the changes.
	     */
	    function updateIcons(row, rowForm, state, type) {
	      if (type === "asigned") {
	        row.asigned = state;
	      } else {
	        row.isVisible = state;
	      }
	      this.save(row, rowForm);
	    }
	    /**
	     * Saves changes made to a row, updating the associated organization name in the background property.
	     * 
	     * @param {Object} row - The row containing the changes to be saved.
	     * @param {Object} rowForm - The form associated with the row.
	     * 
	     * This function sets the organization name in the background property of the row based on the current organization.
	     * It then calls the 'resetRow' function to get the original row, extends it with the modified row, and updates the row.
	     * Finally, it calls the 'updateKiosk' function to persist the changes.
	     */
	    function save(row, rowForm) {
	      var organization_name = this.organizationSelected && this.organizationSelected.name || this.$localStorage.currentOrganization.name;
	      var normal_name = organization_name.replace(new RegExp(" ", "g"), "_");
	      if (row.background) {
	        row.background.organizationName = normal_name;
	        row.background.type = row.background.filetype.split("/")[1];
	      }
	      var originalRow = this.resetRow(row, rowForm);
	      angular.extend(originalRow, row);
	      this.isAdding = false;
	      this.updateKiosk(originalRow, row);
	    }
	    /**
	     * Resets the provided row, setting isEditing to false and updating the original data.
	     * 
	     * @param {Object} row - The row to be reset.
	     * @param {Object} rowForm - The form associated with the row.
	     * @returns {Object} - The original value of the row.
	     * 
	     * This function checks if a new row is being added and copies the current dataset as original data.
	     * It sets isEditing to false and uses the original data to find and return the original value of the row.
	     */

	    function resetRow(row, rowForm) {
	      var row_isAdding = this.isAdding;
	      if (row_isAdding) {
	        this.originalData = angular.copy(this.tableParams.settings().dataset);
	      }
	      var return_value = "";
	      row.isEditing = false;
	      rowForm.$setPristine();
	      angular.forEach(this.originalData, function (value) {
	        if (!row_isAdding && row.id === value.id) {
	          return_value = value;
	        } else if (row_isAdding && value.id === "") {
	          return_value = value;
	        }
	      });
	      return return_value;
	    }
	    /**
	     * Retrieves instructions for the specified kioskId and stores them in local storage.
	     * 
	     * @param {string} kioskId - The identifier of the kiosk to retrieve instructions for.
	     * 
	     * This function sets the 'loadInstructions' flag to true before making a request to get
	     * instructions based on the provided kioskId. If successful, it stores the instructions
	     * in local storage with the key 'instructions' and sets 'loadInstructions' to false. 
	     * If there's an error, it displays an error message using toastr.
	     */
	    var getInstructions = function getInstructions(kioskId) {
	      _this.loadInstructions = true;
	      var filter = '{"where":{"kioskId": "' + kioskId + '"}}';
	      _this.KiosksResource.getRel({ filter: filter }).$promise.then(function (result) {
	        _this.arrIns = result;
	        localStorage.setItem("instructions", JSON.stringify(result));
	        _this.loadInstructions = false;
	      }).catch(function () {
	        _this.$translate("app.kiosks.ERROR_DETAILKIOSK").then(function (errorMsg) {
	          _this.toastr.error(errorMsg, "Error");
	        });
	      });
	    };
	    /**
	     * Displays detailed information about the specified kiosk, including instructions and services.
	     * 
	     * @param {Object} kiosk - The kiosk object for which to display detailed information.
	     * 
	     * This function sets the 'loadInstructions' flag to true and retrieves instructions and
	     * services related to the provided kiosk. If successful, it stores the instructions in local
	     * storage with the key 'instructions', sets 'loadInstructions' to false, and shows a detailed
	     * dialog with the information. If there's an error during the retrieval, it logs the error and
	     * displays an error message using toastr.
	     */
	    function _detailKiosk(kiosk) {
	      var _this2 = this;

	      this.loadInstructions = true;
	      if (kiosk.isEditing !== true) {
	        this.current_kiosk = kiosk;
	        var filter = '{"where":{"kioskId": "' + kiosk.id + '"}}';
	        this.KiosksResource.getRel({ filter: filter }).$promise.then(function (result) {
	          localStorage.setItem("instructions", JSON.stringify(result));
	          _this2.loadInstructions = false;
	        }).catch(function (error) {
	          console.error(error);
	          _this2.$translate("app.kiosks.ERROR_DETAILKIOSK").then(function (errorMsg) {
	            _this2.toastr.error(errorMsg, "Error");
	          });
	        });
	        this.KiosksResource.getServices({ id: kiosk.id, type: "queueTypes" }).$promise.then(function (result) {
	          kiosk.services = result;
	        }).catch(function (error) {
	          console.error(error);
	          _this2.$translate("app.kiosks.ERROR_DETAILKIOSK").then(function (errorMsg) {
	            _this2.toastr.error(errorMsg, "Error");
	          });
	        });
	        this._showDetailDialog();
	      }
	    }
	    /**
	     * Displays a dialog to show detailed information about a kiosk.
	     * 
	     * @param {Event} ev - The event that triggered the dialog.
	     * 
	     * This function uses Angular Material's $mdDialog service to create and show a dialog. The
	     * dialog is associated with the content element with the ID 'dialog_detail_kiosk' and is
	     * positioned relative to the specified target event ('ev'). The dialog is configured with
	     * options such as preserving the scope, having a backdrop, and closing when clicking outside.
	     * The function also handles any cleanup or specific actions when the dialog is closed.
	     * In this case, it hides error messages and resets input styles related to the kiosk details.
	     */
	    function _showDetailDialog(ev) {
	      var _this3 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#dialog_detail_kiosk",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this3;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        document.getElementById("err_identifier").style.display = "none";
	        document.getElementById("identifier").parentElement.parentElement.children[0].classList.remove("md-input-invalid");

	        document.getElementById("err_place").style.display = "none";
	        document.getElementById("place").parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	      }).catch(function () {});;
	    }
	    /**
	     * Displays a form dialog for managing kiosk details.
	     * 
	     * @param {Event} ev - The event that triggered the dialog.
	     * 
	     * This function utilizes Angular Material's $mdDialog service to create and show a form
	     * dialog. The dialog is associated with the content element with the ID 'myDialog' and is
	     * positioned relative to the specified target event ('ev'). The dialog is configured with
	     * options such as preserving the scope, having a backdrop, and closing when clicking outside.
	     * The function also handles any cleanup or specific actions when the dialog is closed, such
	     * as hiding error messages and resetting input styles related to kiosk details.
	     */
	    function _showKioskForm(ev) {
	      var _this4 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#myDialog",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this4;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        document.getElementById("err_identifier").style.display = "none";
	        document.getElementById("err_identifier_2").style.display = "none";
	        document.getElementById("identifier").parentElement.parentElement.children[0].classList.remove("md-input-invalid");

	        document.getElementById("err_place").style.display = "none";
	        document.getElementById("err_place_2").style.display = "none";
	        document.getElementById("place").parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	      }).catch(function () {});
	    }
	    /**
	     * Displays a dialog for changing the image associated with a kiosk.
	     * 
	     * @param {Object} ser - The kiosk service object.
	     * @param {Object} rowForm - The form object associated with the kiosk row.
	     * @param {string} typeInput - The type of input for which the image is being changed.
	     * 
	     * This function utilizes Angular Material's $mdDialog service to create and show a dialog
	     * for changing the image of a kiosk. The dialog is associated with the content element with
	     * the ID 'changeImageDialog'. It also preserves the scope, has a backdrop, and closes when
	     * clicking outside. The function sets the type of input ('typeInput') and the kiosk details
	     * ('kiosk' and 'rowFormKiosk') to handle the image change.
	     */
	    function _changeImageDialog(ser, rowForm, typeInput) {
	      var _this5 = this;

	      this.typeInput = typeInput;
	      this.kiosk = ser;
	      this.rowFormKiosk = rowForm;
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#changeImageDialog",
	        parent: angular.element(document.body),
	        controller: function controller() {
	          return _this5;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).catch(function () {});
	    }
	    /**
	     * Deletes the image associated with a kiosk based on the specified type.
	     * 
	     * @param {Object} row - The kiosk object.
	     * @param {Object} rowForm - The form object associated with the kiosk row.
	     * @param {string} type - The type of image to be deleted ('img_link' in this case).
	     * 
	     * This function deletes the image associated with a kiosk based on the specified type. If
	     * the type is 'img_link', it sets the 'img_link' property of the kiosk object to an empty string.
	     * Finally, it calls the 'save' function to update the changes.
	     */
	    function deleteImage(row, rowForm, type) {
	      if (type === "img_link") {
	        row.img_link = "";
	      }
	      this.save(row, rowForm);
	    }
	    /**
	     * Updates the images of a kiosk based on the specified type.
	     * 
	     * @param {string} img - The image to be updated.
	     * 
	     * This function updates the images of a kiosk based on the specified type. If the type is 'img_link',
	     * it sets the 'background' property of the kiosk object to the provided image.
	     */
	    function updateImages(img) {
	      if (this.typeInput === "img_link") {
	        this.kiosk.background = img;
	      }
	    }
	    /**
	     * Saves the updated image information for the current kiosk.
	     * 
	     * This function triggers the save operation for the current kiosk and its associated form.
	     */
	    function saveUpdatedImage() {
	      this.save(this.kiosk, this.rowFormKiosk);
	    }
	    /**
	     * Displays detailed information about the assigned services for the current kiosk.
	     * 
	     * This function retrieves instructions from local storage and maps them to the assigned services of the current kiosk.
	     * It then opens a dialog to display detailed information about the assigned services, including any associated instructions.
	     * 
	     * @param {Object} ev - The event object that triggered the function.
	     */
	    function _detailAsignedService(ev) {
	      var _this6 = this;

	      var result = JSON.parse(localStorage.getItem('instructions'));
	      this.current_kiosk.services.map(function (service) {
	        var instruction = result.find(function (inst) {
	          return inst.queueTypeId === service.id;
	        });
	        if (instruction) {
	          _this6.showInstructions = true;
	          service.instruction = instruction.instructions;
	        } else {
	          service.instruction = null;
	        }
	      });

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#dialog_detail_asigned_services",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this6;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).catch(function () {});
	    }
	    /**
	     * Displays a form to assign services to a kiosk.
	     * 
	     * This function initializes properties, retrieves services for the establishment, and opens a dialog to assign
	     * services to a kiosk. It resets certain properties when the dialog is closed.
	     * 
	     * @param {Object} ev - The event object that triggered the function.
	     */
	    function _showAsignServiceForm(ev) {
	      var _this7 = this;

	      this.kioskSelec.Selected = false;
	      var $this = this;
	      this.getServicesByEstablishment();
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#asignDialog",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this7;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        $this.arrIns = [];
	        $this.new_service = {};
	        $this.hasKiosksSelected = false;
	        $this.kiosksSelected = [];
	      }, function () {
	        $this.arrIns = [];
	        $this.new_service = {};
	        $this.hasKiosksSelected = false;
	        $this.kiosksSelected = [];
	      }).catch(function () {});
	    }
	    /**
	     * Adds instructions for a service.
	     * 
	     * This function extracts information from the provided service, such as the queue name and instructions,
	     * and adds this information to the 'arrIns' array. It also clears the 'new_service' object and removes
	     * the selected service from the 'services' array.
	     * 
	     * @param {Object} serv - The service object for which instructions are being added.
	     */
	    function _addInstructions(serv) {
	      var queue = JSON.parse(serv.queue);
	      var arrIns = {
	        queue: queue.name,
	        instructions: serv.instrucciones,
	        queueId: queue.id
	      };
	      if (serv) {
	        this.arrIns.push(arrIns);
	      }

	      this.new_service = {};

	      var index = this.services.findIndex(function (item) {
	        return item.id === queue.id;
	      });
	      this.services.splice(index, 1);
	    }
	    /**
	     * Deletes a service and its associated instructions.
	     * 
	     * This function checks if the provided service has a 'rel' property. If it does not, it means the service
	     * is not assigned, and it removes the corresponding instructions from the 'arrIns' array. If the service is
	     * assigned, it first disassigns the service using the 'disassignService' method and then removes the
	     * instructions from the 'arrIns' array.
	     * 
	     * @param {Object} service - The service object to be deleted.
	     */
	    function _deleteServ(service) {
	      this.loadCenter = true;
	      if (!service.rel) {
	        var index = this.arrIns.findIndex(function (item) {
	          return item.queueId === service.queueId;
	        });
	        this.arrIns.splice(index, 1);
	        this.getServicesByEstablishment();
	        return;
	      }
	      if (service.rel) {
	        this.disassignService(this.kioskSelec.kioskId, service.queueTypeId);
	        var _index = this.arrIns.findIndex(function (item) {
	          return item.queueId === service.queueId;
	        });
	        this.arrIns.splice(_index, 1);
	      }
	    }
	    /**
	     * Assigns selected services to the chosen kiosks.
	     * 
	     * This function iterates over the selected kiosks and assigned services, creating new 'rel' objects for each
	     * assignment. It then calls the 'asignServices' method from 'KiosksResource' to perform the assignment. After
	     * a successful assignment, it updates the kiosk properties, shows a success toastr message, and resets form states.
	     */
	    function _asignService() {
	      var successMsg = $translate.instant('app.kiosks.SUCCESS_ASIGNSERVICE');
	      var errorMsg = $translate.instant('app.kiosks.ERROR_ASIGNSERVICE');
	      var $this = this;
	      this.hasKiosksSelected = false;
	      angular.forEach($this.kiosksSelected, function (value) {
	        $this.arrIns.map(function (item) {
	          var new_rel = {
	            kioskId: value.id,
	            queueTypeId: item.queueId,
	            instructions: item.instructions
	          };

	          $this.KiosksResource.asignServices({ id: value.id, type: "queueTypes", option: "rel", fk: item.queueId }, new_rel).$promise.then(function () {
	            value.asigned = true;
	            value.Selected = false;
	            $this.updateKiosk("", value);
	            $this.toastr.success(successMsg);
	            $this.new_service = {};
	            $this.asignServiceForm.$setPristine();
	            $this.asignServiceForm.$setUntouched();
	          }).catch(function (error) {
	            console.error(error);
	            $this.toastr.error(errorMsg, "Error");
	          });
	        });
	      });
	      $this.kiosksSelected = [];
	      $mdDialog.cancel();
	    }
	    /**
	     * Displays detailed information about the services assigned to the specified kiosk.
	     * 
	     * This function checks if the kiosk is not in the editing state. If not, it sets the specified kiosk as the current_kiosk.
	     * It then uses 'KiosksResource' to fetch services of type 'queueTypes' for the given kiosk (identified by its 'id').
	     * The fetched services are assigned to the 'establishments' property of the current_kiosk. 
	     * If there is an error during the fetch operation, an error message is logged, and a toastr error message is displayed.
	     * Finally, the function calls '_showDetailDialog' to display the detailed information in a dialog.
	     */
	    function _detailService(kiosk) {
	      var _this8 = this;

	      if (kiosk.isEditing !== true) {
	        this.current_kiosk = kiosk;
	        this.KiosksResource.getServices({ id: kiosk.id, type: "queueTypes" }).$promise.then(function (result) {
	          kiosk.establishments = result;
	        }).catch(function (error) {
	          console.error(error);
	          _this8.$translate("app.kiosks.ERROR_DETAILKIOSK").then(function (errorMsg) {
	            _this8.toastr.error(errorMsg, "Error");
	          });
	        });
	        this._showDetailDialog();
	      }
	    }
	    /**
	     * Selects or deselects a kiosk and updates the list of selected kiosks.
	     * 
	     * @param {Object} result - The selected kiosk object.
	     * 
	     * This function sets the 'kioskSelec' property to the provided 'result' object. It then retrieves instructions for the selected kiosk
	     * using the 'getInstructions' function. The function checks if the selected kiosk is already in the 'kiosksSelected' array. 
	     * If yes, it removes the kiosk from the array; otherwise, it adds the kiosk to the array. 
	     * The 'hasKiosksSelected' property is updated to indicate whether any kiosks are selected.
	     */
	    function _selectKiosk(result) {
	      this.kioskSelec = result;
	      getInstructions(result.kioskId);
	      var elem_pos = this.kiosksSelected.indexOf(result);
	      if (elem_pos !== -1) {
	        this.kiosksSelected.splice(elem_pos, 1);
	      } else {
	        this.kiosksSelected.push(result);
	      }
	      this.hasKiosksSelected = false;
	      if (this.kiosksSelected.length > 0) {
	        this.hasKiosksSelected = true;
	      }
	    }
	    /**
	     * Validates the input value based on alphanumeric regex and length constraints.
	     * 
	     * @param {string} value - The input value to be validated.
	     * @param {string} id - The ID of the HTML element associated with the input.
	     * @param {object} formPristine - The form object used to check and set the pristine state.
	     * 
	     * This function uses a regular expression (alphanumericRegex) to check if the input value contains only alphanumeric characters,
	     * spaces, underscores, hyphens, at symbols, and parentheses. If the value fails the alphanumeric check, the associated HTML element
	     * is marked as invalid, and an error message is displayed. If the length of the value is outside the range of 3 to 100 characters,
	     * another error message is displayed. If the value passes both checks, the HTML element is marked as valid.
	     */
	    function _validateInputs(value, id, formPristine) {
	      var alphanumericRegex = /^([a-zA-ZáéíóúñÁÉÍÓÚÑ0-9_\-@() ])+$/;

	      var name2 = document.getElementById('' + id);
	      var errName = document.getElementById('err_' + id);
	      var colorErro = 'rgba(219, 72, 73, 1)';
	      var err = ('err_' + id).toUpperCase();
	      var translate = $translate.instant('app.establishments.' + err);
	      var errLength = ('err_' + id + '_length').toUpperCase();
	      var translateLenght = $translate.instant('app.establishments.' + errLength);

	      if (!alphanumericRegex.test(value)) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.innerHTML = translate;
	        errName.style.color = colorErro;
	        formPristine !== undefined ? formPristine.$pristine = true : null;
	      } else if (name2.value.length > 100 || name2.value.length < 3) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.innerHTML = translateLenght;
	        errName.style.display = "block";
	        errName.style.color = colorErro;
	        formPristine !== undefined ? formPristine.$pristine = true : null;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        formPristine !== undefined ? formPristine.$pristine = false : null;
	      }
	    }
	    /**
	     * Sends the kiosk data for creation and performs validation checks.
	     * 
	     * @param {object} result - The kiosk data to be sent for creation.
	     * 
	     * This function validates the kiosk form controls using AngularJS form validation. If the form is invalid, it marks the controls as touched.
	     * If any individual control is invalid, the function returns early without proceeding with the kiosk creation. Otherwise, it sets necessary
	     * properties in the kiosk data, such as organization name and background type, before calling the 'createKiosk' function to create the kiosk.
	     * The dialog is then canceled.
	     */
	    function _sendKiosk(result) {
	      var valid = Object.values(this.kioskForms.$$controls).map(function (control) {
	        return control.$valid;
	      });

	      if (this.kioskForms.$invalid) {
	        Object.values(this.kioskForms.$$controls).forEach(function (control) {
	          control.$touched = true;
	        });
	        return;
	      }
	      if (valid.includes(false)) {
	        return;
	      }
	      var organization_name = this.$localStorage.currentOrganization.name;
	      var normal_name = organization_name.replace(new RegExp(" ", "g"), "_");
	      if (result.background) {
	        result.background.organizationName = normal_name;
	        result.background.type = result.background.filetype.split("/")[1];
	      }
	      result.asigned = false;
	      this.createKiosk(result);
	      $mdDialog.cancel();
	    }
	    /**
	     * Closes the dialog and resets the kiosk form.
	     * 
	     * This function clears the 'new_kiosk' object, ensuring that any entered data is discarded. It then uses AngularJS form methods to set the
	     * kiosk form ('kioskForms') to the untouched state, effectively resetting the form to its initial state. Finally, it hides the dialog.
	     */
	    function _closeDialog() {
	      this.new_kiosk = {};
	      this.kioskForms.$setUntouched(); // this resets the form itself
	      $mdDialog.hide();
	    }
	    /**
	     * Cancels and closes the dialog without taking any further action.
	     * 
	     * This function cancels and closes the dialog using the Angular Material Dialog service without performing any additional operations.
	     */
	    function _cancelDialog() {
	      $mdDialog.cancel();
	    }
	    /**
	     * Creates a new kiosk by making a request to the server and handles the result.
	     * 
	     * @param {Object} kiosk - The kiosk object to be created.
	     * 
	     * This function sets the 'locationId' property of the kiosk based on the 'establishmentId' from the current scope.
	     * It then uses the 'KiosksResource' service to make a request to create the kiosk on the server.
	     * If the creation is successful, it resets the 'new_kiosk' object, and the kiosk form's pristine and untouched states.
	     * Finally, it adds the created kiosk to the dataset using the 'add' function.
	     */
	    function createKiosk(kiosk) {
	      var _this9 = this;

	      var ev = this;
	      kiosk.locationId = ev.establishmentId;
	      ev.KiosksResource.create({}, kiosk).$promise.then(function (result) {
	        ev.new_kiosk = {};
	        ev.kioskForm.$setPristine();
	        ev.kioskForm.$setUntouched();
	        ev.add(result);
	      }).catch(function () {
	        _this9.$translate("app.kiosks.ERROR_CREATE").then(function (errorMsg) {
	          _this9.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Updates a kiosk's data by making a request to the server and handles the result.
	     * 
	     * @param {Object} originalRow - The original data of the kiosk before the update.
	     * @param {Object} row - The updated data of the kiosk.
	     * 
	     * This function prepares the data for updating by setting the 'kioskId' property based on the 'id' of the kiosk.
	     * It also handles scenarios where 'open' or 'close' properties are not provided, or if 'open' is greater than 'close'.
	     * It then uses the 'KiosksResource' service to make a request to update the kiosk on the server.
	     * If the update is successful, it updates the 'img_link' property of the row if it has changed.
	     * If 'originalRow' is provided, it extends the 'originalRow' with the updated 'row', closes the dialog, and triggers the 'selectedItemChange' function.
	     */
	    function updateKiosk(originalRow, row) {
	      var _this10 = this;

	      var current_kiosk_data = row;
	      row.kioskId = row.id;
	      var kioskId = row.kioskId;

	      if (!current_kiosk_data.open || !current_kiosk_data.close) {
	        //Si se elimina por lo menos una se pone null las horas
	        current_kiosk_data.open = null;
	        current_kiosk_data.close = null;
	      }

	      if (new Date(current_kiosk_data.open) > new Date(current_kiosk_data.close)) {
	        //Si el open es mayor que el close  no guarda la hora
	        current_kiosk_data.open = null;
	        current_kiosk_data.close = null;
	      }

	      this.KiosksResource.update({ id: kioskId }, current_kiosk_data).$promise.then(function (result) {
	        row.img_link = row.img_link != result.img_link ? result.img_link : row.img_link;
	        if (originalRow != "") {
	          angular.extend(originalRow, row);
	          _this10._closeDialog();
	          _this10.selectedItemChange(_this10.currentEstablishment);
	        }
	      }).catch(function (error) {
	        console.error(error);
	        _this10.$translate("app.kiosks.ERROR_UPDATE").then(function (errorMsg) {
	          _this10.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Deletes a kiosk by making a request to the server and handles the result.
	     * 
	     * @param {Object} kiosk - The kiosk object to be deleted.
	     * 
	     * This function uses the 'KiosksResource' service to make a request to delete the specified kiosk on the server.
	     * If the deletion is successful, it shows a success message using Toastr and then triggers the 'del' function to remove the kiosk from the displayed list.
	     * If there is an error during deletion, it logs the error and displays an error message using Toastr.
	     */
	    function deleteKiosk(kiosk) {
	      var _this11 = this;

	      this.KiosksResource.destroy({ id: kiosk.id }).$promise.then(function () {
	        _this11.$translate("app.administration.DELETE_OK").then(function (msg) {
	          _this11.toastr.success(msg, $translate.instant("app.administration.DELETE_SUCCESS"));
	        });
	        _this11.del(kiosk);
	      }).catch(function (error) {
	        console.error(error);
	        _this11.$translate("app.kiosks.ERROR_DELETE").then(function (errorMsg) {
	          _this11.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Disassigns a service from a kiosk, triggering a request to the server and handling the result.
	     * 
	     * @param {string} kioskId - The ID of the kiosk from which the service is to be disassigned.
	     * @param {string} serviceId - The ID of the service to be disassigned from the kiosk.
	     * 
	     * This function uses the 'KiosksResource' service to make a request to disassign the specified service from the given kiosk on the server.
	     * If the disassignment is successful, it shows a success message using Toastr, and then updates the list of kiosks and services using the 'getKiosksByEstablishment' and 'getServicesByEstablishment' functions respectively.
	     * If there is an error during disassignment, it logs the error and displays an error message using Toastr.
	     */
	    function disassignService(kioskId, serviceId) {
	      var $this = this;
	      this.KiosksResource.disassign({
	        type: "queueTypes",
	        id: kioskId,
	        option: "rel",
	        fk: serviceId
	      }).$promise.then(function () {
	        $this.$translate("app.administration.DELETE_OK").then(function (msg) {
	          $this.toastr.success(msg, $translate.instant("app.administration.DELETE_SUCCESS"));
	          $this.getKiosksByEstablishment($this.establishmentId);
	        });
	        $this.getServicesByEstablishment();
	      }).catch(function (error) {
	        console.error(error);
	        $this.$translate("app.kiosks.ERROR_DISASIGNSERVICE").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, $translate.instant("app.administration.DELETE_ERROR_MSG"));
	        });
	      });
	    }
	    /**
	     * Retrieves and loads all kiosks associated with a specific establishment.
	     * 
	     * @param {string} establishmentId - The ID of the establishment for which kiosks are to be retrieved.
	     * 
	     * This function uses the 'EstablishmentsResource' service to make a request to the server to get all kiosks associated with the specified establishment.
	     * If the request is successful, it updates various properties such as 'noData', 'fail', 'originalData', and then calls the '_createUsingFullOptions' function to handle the initialization of the display with the retrieved kiosks.
	     * If there is an error during the request, it logs the error and displays an error message using Toastr.
	     */
	    function getKiosksByEstablishment(establishmentId) {
	      var _this12 = this;

	      // Load all kiosks by establishment
	      this.EstablishmentsResource.getDevicesByEstablishment({
	        id: establishmentId,
	        type: "kiosks"
	      }).$promise.then(function (result) {
	        _this12.noData = result.length == 0 ? true : false;
	        _this12.fail = false;
	        angular.forEach(result, function (item) {
	          if (item.open) {
	            item.open = new Date(item.open);
	          }
	          if (item.close) {
	            item.close = new Date(item.close);
	          }
	        });

	        _this12.originalData = angular.copy(result);
	        _this12._createUsingFullOptions(result);
	      }).catch(function (error) {
	        console.error(error);
	        _this12.$translate("app.kiosks.ERROR_GETBYESTABLISHMENT").then(function (errorMsg) {
	          _this12.toastr.error(errorMsg, "Error");
	        });
	      });
	    }

	    function getServicesByEstablishment() {
	      var _this13 = this;

	      this.services = [];
	      var kiosksId = [];
	      var servicesId = [];
	      var isAssigned = false;
	      var establishmentId = this.establishmentId;
	      this.kiosksSelected.forEach(function (value) {
	        kiosksId.push(value.id);
	      });
	      var filter = '{"where": {"status": true}, "include": {"relation": "kiosks"}}';

	      this.EstablishmentsResource.getDevicesByEstablishment({
	        id: establishmentId,
	        type: "queueTypes",
	        filter: filter
	      }).$promise.then(function (result) {
	        result.map(function (service) {
	          _this13.arrIns.map(function (queue) {
	            if (service.id === queue.queueTypeId) {
	              queue.queue = service.name;
	              queue.rel = true;
	            }
	          });
	        });
	        result.map(function (service) {
	          _this13.loadCenter = false;
	          if (service.status) {
	            if (service.kiosks.length == 0) {
	              if (servicesId.indexOf(service.id) < 0) {
	                delete service.kiosks;
	                _this13.services.push(service);
	                servicesId.push(service.id);
	              }
	            } else {
	              angular.forEach(service.kiosks, function (value) {
	                if (kiosksId.indexOf(value.id) >= 0) {
	                  isAssigned = true;
	                }
	              });

	              if (!isAssigned) {
	                delete service.kiosks;
	                _this13.services.push(service);
	              }
	              isAssigned = false;
	            }
	          }
	          _this13.arrIns.map(function (item) {
	            _this13.services.map(function (service) {
	              if (service.id === item.queueId) {
	                _this13.services.splice(_this13.services.indexOf(service), 1);
	              }
	            });
	          });
	        });
	      }).catch(function (error) {
	        console.error(error);
	        _this13.loadCenter = false;
	        _this13.$translate("app.kiosks.ERROR_GETBYESTABLISHMENT").then(function (errorMsg) {
	          _this13.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Retrieves and loads all services associated with a specific establishment.
	     * 
	     * This function initializes an empty array 'servicesId' to keep track of unique service IDs.
	     * It also initializes 'isAssigned' to false, which helps determine if a service is already assigned to a kiosk.
	     * 
	     * Using the 'EstablishmentsResource' service, the function makes a request to the server to get all services ('queueTypes') associated with the specified establishment.
	     * If the request is successful, it iterates through the result and adds services to the 'services' array based on certain conditions.
	     * It also checks if a service is already assigned to a kiosk and excludes it from the 'services' array if assigned.
	     * The function then removes services that are already present in the 'arrIns' array from the 'services' array.
	     * 
	     * If there is an error during the request, it logs the error and displays an error message using Toastr.
	     */
	    function getEstablishmentName(establishmentId) {
	      var establishment_name = "";
	      angular.forEach(this.establishments, function (value) {
	        if (value.id === establishmentId) establishment_name = value.name;
	      });
	      return establishment_name;
	    }
	    /**
	     * Toggles the display of options associated with a button identified by its ID.
	     * 
	     * @param {string} id - The ID of the button whose options need to be toggled.
	     * 
	     * This function retrieves the element with the specified ID ('opc') and toggles its display style.
	     * If the current display style is 'none', it changes it to 'block', and vice versa.
	     * 
	     * Additionally, it adds an event listener to the document to handle the scenario where the user clicks outside
	     * the options container. If a click occurs outside the container, it sets the display style of the container to 'none'.
	     */
	    function _editOptionsButton(id) {
	      var opc = document.getElementById(id);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Toggles the display of options associated with a button identified by its ID and a prefix.
	     * 
	     * @param {string} id - The ID of the button whose options need to be toggled.
	     * @param {string} prefix - The prefix used in combination with the ID to identify the options container.
	     * 
	     * This function retrieves the element with the specified ID and prefix ('opc') and toggles its display style.
	     * If the current display style is 'none', it changes it to 'block', and vice versa.
	     * 
	     * Additionally, it adds an event listener to the document to handle the scenario where the user clicks outside
	     * the options container. If a click occurs outside the container, it sets the display style of the container to 'none'.
	     */
	    function _activateOptionsButton(id, prefix) {
	      var opc = document.getElementById(id + prefix);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id + prefix);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Handles the change of the selected item in the establishment dropdown.
	     * 
	     * @param {Object} item - The selected item from the dropdown.
	     * 
	     * If a valid item is selected, it updates the current establishment details,
	     * retrieves the kiosks associated with the establishment, and sets the establishment in use.
	     * If no item is selected, and the user is a root or super admin, it resets the original data and updates the view.
	     */
	    function selectedItemChange(item) {
	      this.establishmentInUse = '';
	      if (item !== undefined) {
	        var Center = JSON.parse(JSON.stringify(item));

	        var current_establishment = Center;
	        this.currentEstablishment = current_establishment;
	        this.establishmentId = current_establishment.id;
	        this.establishmentInUse = current_establishment.name;
	        this.getKiosksByEstablishment(this.establishmentId);
	        return;
	      } else {
	        if (this.isRoot || this.isSuperAdmin) {
	          this.originalData = [];
	          this._createUsingFullOptions([]);
	        }
	      }
	    }
	    /**
	     * Performs a search in the establishment dropdown based on the provided query.
	     * 
	     * @param {string} query - The search query entered by the user.
	     * @returns {Array} - An array of establishments matching the search query.
	     * 
	     * Sets the 'Selected' property of 'kioskSelec' to false, indicating that no establishment is selected.
	     * Sorts the establishments alphabetically.
	     * Filters the establishments based on the search query using the 'createFilterFor' function.
	     * Returns the filtered establishments.
	     */
	    function querySearchSelect(query) {
	      this.kioskSelec.Selected = false;
	      this.hasKiosksSelected = false;
	      this.kioskSelec.Selected = false;
	      this.establishments.sort(function (a, b) {
	        if (a.name < b.name) {
	          return -1;
	        }
	        if (a.name > b.name) {
	          return 1;
	        }
	        return 0;
	      });
	      var results = query ? this.establishments.filter(createFilterFor(query)) : this.establishments;
	      return results;
	    }
	    /**
	     * Creates a filter function for case-insensitive searching based on the provided query.
	     * 
	     * @param {string} query - The search query entered by the user.
	     * @returns {Function} - A filter function that matches items whose names start with the query.
	     * 
	     * Converts the search query to lowercase for case-insensitive comparison.
	     * Returns a filter function that checks if an item's name starts with the lowercase query.
	     */
	    var createFilterFor = function createFilterFor(query) {
	      var lowercaseQuery = query.toLowerCase();
	      return function filterFn(item) {
	        var lowerCaseValue = item.name.toLowerCase();
	        return lowerCaseValue.indexOf(lowercaseQuery) === 0;
	      };
	    };
	    /**
	     * Retrieves establishments associated with a specific organization.
	     *
	     * @param {string} organization_id - The ID of the organization for which establishments are to be retrieved.
	     * If the organization ID is not provided, resets the searchText and establishments array.
	     *
	     * If the user is a root or admin, calls the OrganizationsResource to get establishments by organization ID.
	     * Sorts the establishments alphabetically by name.
	     * Handles errors and displays a toastr error message if the retrieval fails.
	     */
	    function getEstablismentByOrganization(organization_id) {
	      var _this14 = this;

	      if (!organization_id) {
	        this.searchText = '';
	        this.establishments = [];
	        return;
	      }
	      if (this.isRoot || this.isAdmin) {
	        this.OrganizationsResource.getEstablismentByOrganization({
	          id: organization_id
	        }).$promise.then(function (result) {
	          _this14.establishments = result;
	          _this14.establishments.sort(function (a, b) {
	            var aL = a.name.toLowerCase();
	            var bL = b.name.toLowerCase();
	            if (aL < bL) return -1;
	            if (aL > bL) return 1;
	            return 0;
	          });
	        }).catch(function () {
	          _this14.$translate("app.ERROR_GETESTABLISHMENT").then(function (errorMsg) {
	            _this14.toastr.error(errorMsg, "Error");
	          });
	        });
	      }
	    }
	    /**
	     * Performs a search for organizations based on the provided query.
	     *
	     * Sorts the establishments alphabetically by name.
	     * If a query is provided, filters the organizations using the createFilterFor function.
	     *
	     * @param {string} query - The search query to filter organizations.
	     * If no query is provided, returns all organizations without filtering.
	     *
	     * @returns {Array} - An array of organizations that match the search query or all organizations if no query is provided.
	     */
	    function querySearchSelectOrganizations(query) {
	      this.organizations.sort(function (a, b) {
	        if (a.name < b.name) {
	          return -1;
	        }
	        if (a.name > b.name) {
	          return 1;
	        }
	        return 0;
	      });
	      var results = query ? this.organizations.filter(createFilterFor(query)) : this.organizations;
	      return results;
	    }
	    // exports
	    angular.extend(this, {
	      config: config,
	      createKiosk: createKiosk,
	      deleteKiosk: deleteKiosk,
	      updateKiosk: updateKiosk,
	      updateIcons: updateIcons,
	      getKiosksByEstablishment: getKiosksByEstablishment,
	      getServicesByEstablishment: getServicesByEstablishment,
	      _createUsingFullOptions: _createUsingFullOptions,
	      pageSizeChanged: pageSizeChanged,
	      _showKioskForm: _showKioskForm,
	      _closeDialog: _closeDialog,
	      _cancelDialog: _cancelDialog,
	      _editOptionsButton: _editOptionsButton,
	      _sendKiosk: _sendKiosk,
	      _detailKiosk: _detailKiosk,
	      _showDetailDialog: _showDetailDialog,
	      _activateOptionsButton: _activateOptionsButton,
	      _asignService: _asignService,
	      _selectKiosk: _selectKiosk,
	      _detailService: _detailService,
	      _detailAsignedService: _detailAsignedService,
	      _showAsignServiceForm: _showAsignServiceForm,
	      getEstablishmentName: getEstablishmentName,
	      disassignService: disassignService,
	      selectedItemChange: selectedItemChange,
	      querySearchSelect: querySearchSelect,
	      _changeImageDialog: _changeImageDialog,
	      deleteImage: deleteImage,
	      updateImages: updateImages,
	      saveUpdatedImage: saveUpdatedImage,
	      _validateInputs: _validateInputs,
	      _addInstructions: _addInstructions,
	      _deleteServ: _deleteServ,
	      getEstablismentByOrganization: getEstablismentByOrganization,
	      querySearchSelectOrganizations: querySearchSelectOrganizations
	    });
	  }

	  _createClass(KiosksController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this15 = this;

	      var user_role = this.$localStorage.currentRole;
	      var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;

	      if (user_role.toUpperCase() == "ADMIN") {
	        this.getKiosksByEstablishment(this.establishmentId);
	      }

	      if (this.isRoot) {
	        this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
	          _this15.organizations = result;
	          _this15.organizations.sort(function (a, b) {
	            if (a.name.toLowerCase() < b.name.toLowerCase()) {
	              return -1;
	            }
	            if (a.name.toLowerCase() > b.name.toLowerCase()) {
	              return 1;
	            }
	            return 0;
	          });
	        }).catch(function () {
	          _this15.$translate("app.ERROR_GETORGANIZATION").then(function (errorMsg) {
	            _this15.toastr.error(errorMsg, "Error");
	          });
	        });
	      }

	      if (this.isSuperAdmin) {
	        this.AdministrationService.getEstablishments(user_role, organizationId, "locations").then(function (result) {
	          _this15.establishments = result.reverse();
	        }).catch(function (error) {
	          console.error(error);
	          _this15.handleErrorMessage("app.ERROR_GETESTABLISHMENT");
	        });
	      }
	    }
	  }, {
	    key: 'establishmentChanged',
	    value: function establishmentChanged() {
	      this.$localStorage.last_establishment = this.establishmentSelected;
	      var current_establishment = JSON.parse(this.establishmentSelected);
	      this.currentEstablishment = current_establishment;
	      this.establishmentId = current_establishment.id;
	      this.establishmentInUse = current_establishment.name;
	      this.establishmentSelected = undefined;
	      this.$scope.selectEstablishmentForm.$setPristine();
	      // Load all kiosks by establishment
	      this.getKiosksByEstablishment(this.establishmentId);
	    }
	  }]);

	  return KiosksController;
	}();

	KiosksController.$inject = ["$scope", "$rootScope", "config", "KiosksResource", "OrganizationsResource", "EstablishmentsResource", "AdministrationService", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location"];

	exports.default = KiosksController;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var KiosksService =
	/** @ngInject */
	function KiosksService() {
	  _classCallCheck(this, KiosksService);
	};

	//AdministrationService.$inject = ['EmployeesResource'];

	exports.default = KiosksService;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _consumers = __webpack_require__(80);

	var _consumers2 = __webpack_require__(82);

	var _consumers3 = _interopRequireDefault(_consumers2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var consumers = angular.module('mod.admin.administration.consumers', []).component('consumers', _consumers.ConsumersComponent).service('ConsumersService', _consumers3.default).name;

	exports.default = consumers;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConsumersComponent = undefined;

	var _consumers = __webpack_require__(81);

	var _consumers2 = _interopRequireDefault(_consumers);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ConsumersComponent = exports.ConsumersComponent = {
	  controller: _consumers2.default,
	  templateUrl: 'app/modules/admin/administration/consumers/consumers.html'
	};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ConsumersController = function () {
	  /** @ngInject */
	  ConsumersController.$inject = ["$scope", "$rootScope", "config", "ConsumersResource", "OrganizationsResource", "EstablishmentsResource", "AdministrationService", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "KiosksResource", "pageSizeOptions"];
	  function ConsumersController($scope, $rootScope, config, ConsumersResource, OrganizationsResource, EstablishmentsResource, AdministrationService, NgTableParams, $translate, toastr, $mdDialog, $localStorage, $location, KiosksResource, pageSizeOptions) {
	    var _this = this;

	    _classCallCheck(this, ConsumersController);

	    // private
	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.noData = true;
	    //this.establishmentId = config.ESTABLISHMENT_ID;
	    this.isSuperAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === "SUPERADMIN" ? true : false;
	    this.isRoot = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === "ROOT" ? true : false;
	    this.isAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === "ADMIN" ? true : false;
	    this.establishmentInUse = '';

	    var last_establishment = $localStorage.last_establishment ? $localStorage.last_establishment : false;
	    if (this.isRoot || this.isSuperAdmin) {
	      if (last_establishment) {
	        this.currentEstablishment = (typeof last_establishment === 'undefined' ? 'undefined' : _typeof(last_establishment)) != "object" ? JSON.parse(last_establishment) : last_establishment;
	        this.establishmentId = this.currentEstablishment.id;
	      }
	    } else {
	      this.establishmentId = $localStorage.currentLocation.id;
	    }
	    this.isPre = config.IS_PRE;
	    this.OrganizationsResource = OrganizationsResource;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.KiosksResource = KiosksResource;
	    this.ConsumersResource = ConsumersResource;
	    this.AdministrationService = AdministrationService;
	    this.config = config;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.$mdDialog = $mdDialog;
	    this.consumersSelected = [];
	    this.hasConsumersSelected = false;
	    this.isAdding = false;
	    this.fail = false;
	    this.organizations = [];
	    this.establishments = [];
	    this.searchTextOrganization = '';
	    this.searchText = '';

	    this.cancel = cancel;
	    this.showDeleteConfirm = showDeleteConfirm;
	    this.showDisassignConfirm = showDisassignConfirm;
	    this.deleteServiceDirectly = deleteServiceDirectly;
	    this.del = del;
	    this.save = save;
	    this.add = add;
	    this.resetRow = resetRow;
	    this.count = 10;
	    this.pageSizeOptions = pageSizeOptions;
	    this.editConsumer = false;
	    this.pageSizeOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

	    // Control of sidemenu page
	    var url = $location.url().substring(1).toUpperCase();
	    this.$rootScope.currentPage = currentPage(1);
	    /**
	     * Extracts a specific segment from the current URL based on the provided index.
	     *
	     * @param {number} index - The index of the URL segment to retrieve.
	     * @returns {string} - The URL segment at the specified index.
	     */
	    function currentPage(index) {
	      var split_url = url.split("/");
	      return split_url[index];
	    }
	    /**
	     * Handles the change of page size in a table and updates the table parameters.
	     *
	     * @param {number} newPageSize - The new page size selected.
	     */
	    var pageSizeChanged = function pageSizeChanged(newPageSize) {
	      _this.tableParams.count(newPageSize);
	      _this.count = newPageSize;
	    };
	    /**
	     * Creates a new NgTableParams instance using full options and initializes it with the provided consumer data.
	     *
	     * @param {Array} consumer_data - The data to be used for initializing the table.
	     * @returns {object} - The created NgTableParams instance.
	     */
	    function _createUsingFullOptions(consumer_data) {
	      var initialParams = {
	        count: this.count // initial page size
	      };
	      var initialSettings = {
	        // page size buttons (right set of buttons in demo)
	        counts: [],
	        // determines the pager buttons (left set of buttons in demo)
	        paginationMaxBlocks: 4,
	        paginationMinBlocks: 2,
	        dataset: consumer_data
	      };
	      this.tableParams = new NgTableParams(initialParams, initialSettings);
	      return this.tableParams;
	    }
	    /**
	     * Adds a new template to the NgTableParams instance, creating the instance if it doesn't exist.
	     *
	     * @param {object} new_template - The new template to be added.
	     */
	    function add(new_template) {
	      if (this.tableParams == undefined) {
	        var emptyData = [];
	        this._createUsingFullOptions(emptyData);
	      }
	      this.tableParams.settings().dataset.unshift(new_template);
	      this.tableParams.sorting({});
	      this.tableParams.page(1);
	      this.tableParams.reload();
	    }
	    /**
	     * Cancels the changes made to a row by resetting it to its original state.
	     *
	     * @param {object} row - The row whose changes need to be canceled.
	     */
	    function cancel(row) {
	      var originalRow = this.resetRow(row);
	      angular.extend(row, originalRow);
	    }
	    /**
	     * Displays a delete confirmation dialog and executes the delete action if confirmed.
	     *
	     * @param {object} ev - The event object that triggered the delete confirmation.
	     */
	    function showDeleteConfirm(ev) {
	      var current_scope = this;
	      hideElement(ev.id);
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        current_scope.deleteConsumer(ev);
	      }, function () {
	        console.log("You decided to keep it.");
	      });
	    }
	    /**
	     * Displays a confirmation dialog for disassociating a service and executes the disassociation action if confirmed.
	     *
	     * @param {object} service - The service to be disassociated.
	     * @param {object} ev - The event object that triggered the disassociation confirmation.
	     */
	    function showDisassignConfirm(service, ev) {
	      var current_scope = this;
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        current_scope.disassignService(current_scope.current_consumer.id, service.id);
	      }, function () {
	        console.log("You decided to keep it.");
	      });
	    }
	    /**
	     * Deletes a row from the table dataset and reloads the table.
	     *
	     * @param {object} row - The row to be deleted.
	     */
	    function del(row) {
	      var $this = this;
	      var main_dataset = this.tableParams.settings().dataset;
	      var originalData = "";
	      angular.forEach(this.tableParams.settings().dataset, function (value, key) {
	        if (angular.equals(row, value)) {
	          main_dataset.splice(key, 1);
	          originalData = angular.copy(main_dataset);
	        }
	      });
	      this.originalData = originalData;
	      this.tableParams.reload().then(function (data) {
	        if (data.length === 0 && $this.tableParams.total() > 0) {
	          $this.tableParams.page($this.tableParams.page() - 1);
	          $this.tableParams.reload();
	        }
	      });
	      //this.deleteConsumer(row.id);
	    }
	    /**
	     * Updates icons in a row based on the specified state and type, then triggers a save operation.
	     *
	     * @param {object} row - The row containing icons to be updated.
	     * @param {object} rowForm - The form associated with the row.
	     * @param {boolean} state - The new state for the icons.
	     * @param {string} type - The type of icons to be updated ("asigned" or "statusButtons").
	     */
	    function updateIcons(row, rowForm, state, type) {
	      if (type === "asigned") {
	        row.asigned = state;
	      } else {
	        row.statusButtons = state;
	      }
	      this.save(row, rowForm);
	    }
	    /**
	     * Saves changes made to a row, resets the row, and updates the consumer.
	     *
	     * @param {object} row - The row containing changes to be saved.
	     * @param {object} rowForm - The form associated with the row.
	     */
	    function save(row, rowForm) {
	      var originalRow = this.resetRow(row, rowForm);
	      angular.extend(originalRow, row);
	      this.isAdding = false;
	      this.updateConsumer(row);
	    }
	    /**
	     * Resets a row to its original state.
	     *
	     * @param {object} row - The row to be reset.
	     * @returns {object} - The original state of the row.
	     */
	    function resetRow(row) {
	      var row_isAdding = this.isAdding;
	      if (row_isAdding) {
	        this.originalData = angular.copy(this.tableParams.settings().dataset);
	      }
	      var return_value = "";
	      row.isEditing = false;
	      angular.forEach(this.originalData, function (value) {
	        if (!row_isAdding && row.id === value.id) {
	          return_value = value;
	        } else if (row_isAdding && value.id === "") {
	          return_value = value;
	        }
	      });
	      return return_value;
	    }
	    /**
	     * Displays details for a consumer.
	     *
	     * @param {object} consumer - The consumer for which details are to be displayed.
	     */
	    function _detailConsumer(consumer) {
	      var _this2 = this;

	      if (consumer.isEditing !== true) {
	        this.current_consumer = consumer;
	        this.ConsumersResource.getServices({
	          id: consumer.id,
	          type: "queueTypes"
	        }).$promise.then(function (result) {
	          consumer.services = result;
	        }).catch(function (error) {
	          console.log(error);
	          _this2.$translate("app.consumers.ERROR_GETSERVICES").then(function (errorMsg) {
	            _this2.toastr.error(errorMsg, "Error");
	          });
	        });
	        this._showDetailDialog();
	      }
	    }
	    /**
	     * Displays a detail dialog for a consumer.
	     *
	     * @param {object} ev - The event object that triggered the dialog.
	     */
	    function _showDetailDialog(ev) {
	      var _this3 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#dialog_detail_consumer",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this3;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        console.log("You resolve the dialog.");
	      }, function () {
	        console.log("You cancelled the dialog.");
	      });
	    }
	    /**
	     * Displays a consumer form dialog for adding or editing a consumer.
	     *
	     * @param {object} ev - The event object that triggered the dialog.
	     */
	    function _showConsumerForm() {
	      var ev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var parent = this;
	      parent.editConsumer = (typeof ev === 'undefined' ? 'undefined' : _typeof(ev)) === 'object' && Object.keys(ev).length > 0;

	      if (parent.editConsumer) {
	        hideElement(ev.id);
	        parent._showConsumerEdit(ev);
	      }

	      var fieldsToReset = ["name", "place"];

	      fieldsToReset.forEach(function (field) {
	        var errElement = document.getElementById('err_' + field);
	        var inputElement = document.getElementById(field);

	        if (errElement) {
	          errElement.style.display = "none";
	        }

	        if (inputElement) {
	          inputElement.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        }
	      });

	      var dialogOptions = {
	        preserveScope: true,
	        hasBackdrop: true,
	        contentElement: "#myDialog",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return parent;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      };

	      $mdDialog.show(dialogOptions).then(function () {
	        parent._closeDialog();
	        parent.editConsumer = false;
	      }, function () {
	        parent.editConsumer = false;
	        parent._closeDialog();
	      });
	    }
	    /**
	     * Prepares the consumer edit form by copying the consumer data.
	     *
	     * @param {object} consumer - The consumer to be edited.
	     */
	    function _showConsumerEdit(consumer) {
	      this.new_consumer = angular.copy(consumer);
	    }
	    /**
	     * Hides the HTML element with the specified ID by setting its display property to "none".
	     *
	     * @param {string} id - The ID of the HTML element to be hidden.
	     */

	    function hideElement(id) {
	      var menu = document.getElementById('' + id);
	      if (menu) {
	        menu.style.display = "none";
	      }
	    }
	    /**
	     * Validates a description value based on alphanumeric characters and length constraints.
	     *
	     * @param {string} value - The description value to be validated.
	     * @param {string} id - The ID of the HTML element associated with the description.
	     * @param {object} rowForm - The form associated with the row (optional).
	     */
	    function _validateDescription(value, id, rowForm) {
	      var alphanumericRegex = /^([a-zA-ZáéíóúñÁÉÍÓÚÑ0-9_\-@() ])+$/;

	      var name2 = document.getElementById('' + id);
	      var errName = document.getElementById('err_' + id);
	      var colorErro = 'rgba(219, 72, 73, 1)';
	      var translate = $translate.instant('app.consumers.err_' + id);
	      var translateLengt = $translate.instant('app.consumers.err_' + id + '_length');

	      if (!alphanumericRegex.test(value)) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.innerHTML = translate;
	        errName.style.color = colorErro;
	        this.consumerForm[id].$valid = false;
	        rowForm !== undefined ? rowForm.$pristine = true : null;
	      } else if (name2.value.length > 15 || name2.value.length < 3) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.innerHTML = translateLengt;
	        errName.style.display = "block";
	        errName.style.color = colorErro;
	        this.consumerForm[id].$valid = false;
	        rowForm !== undefined ? rowForm.$pristine = true : null;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        this.consumerForm[id].$valid = true;
	        rowForm !== undefined ? rowForm.$pristine = false : null;
	      }
	    }
	    /**
	     * Handles the submission of consumer data by validating the form and either saving or creating a consumer.
	     *
	     * @param {object} result - The result or data from the consumer form.
	     * @param {object} form - The consumer form object.
	     */
	    function _sendConsumer(result, form) {
	      var valid = Object.values(this.consumerForm.$$controls).map(function (control) {
	        return control.$valid;
	      });
	      if (this.consumerForm.$invalid) {
	        Object.values(this.consumerForm.$$controls).forEach(function (control) {
	          control.$touched = true;
	        });
	        return;
	      }
	      if (valid.includes(false)) {
	        return;
	      }
	      this.editConsumer ? this.save(result, form) : this.createConsumer(result);
	      $mdDialog.cancel();
	    }
	    /**
	     * Assigns selected services to consumers by creating relationships between consumers and queue types.
	     *
	     * @param {object} services - The services to be assigned, including a queue property with queue IDs.
	     */
	    function _asignService(services) {
	      var $this = this;
	      this.hasConsumersSelected = false;
	      angular.forEach(services.queue, function (queueId) {
	        angular.forEach($this.consumersSelected, function (value) {
	          var _this4 = this;

	          var new_rel = {
	            consumerId: value.id,
	            queueTypeId: queueId
	          };
	          $this.ConsumersResource.asignServices({ id: value.id, type: "queueTypes", option: "rel", fk: queueId }, new_rel).$promise.then(function (result) {
	            console.log("RESULT _asignService:", result);
	            $this.new_service = {};
	            $this.asignServiceForm.$setPristine();
	            $this.asignServiceForm.$setUntouched();
	            value.asigned = true;
	            value.Selected = false;
	            $this.updateConsumer(value);
	          }).catch(function (error) {
	            console.log(error);
	            _this4.$translate("app.consumers.ERROR_ASIGNSERVICE").then(function (errorMsg) {
	              _this4.toastr.error(errorMsg, "Error");
	            });
	          });
	        });
	      });
	      $this.consumersSelected = [];
	      $mdDialog.cancel();
	    }
	    /**
	     * Handles the selection or deselection of a consumer in the list.
	     *
	     * @param {object} result - The consumer to be selected or deselected.
	     */
	    function _selectConsumer(result) {
	      var elem_pos = this.consumersSelected.indexOf(result);
	      if (elem_pos !== -1) {
	        this.consumersSelected.splice(elem_pos, 1);
	      } else {
	        this.consumersSelected.push(result);
	      }
	      this.hasConsumersSelected = false;
	      if (this.consumersSelected.length > 0) {
	        this.hasConsumersSelected = true;
	      }
	    }
	    /**
	     * Displays a detail dialog for assigned services.
	     *
	     * @param {object} ev - The event object that triggered the dialog.
	     */
	    function _detailAsignedService(ev) {
	      var _this5 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#dialog_detail_asigned_services",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this5;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        console.log("You resolve the dialog.");
	      }, function () {
	        console.log("You cancelled the dialog.");
	      });
	    }
	    /**
	     * Displays a form for assigning services to consumers.
	     *
	     * @param {object} ev - The event object that triggered the dialog.
	     */
	    function _showAsignServiceForm(ev) {
	      var _this6 = this;

	      this.getServicesByEstablishment();
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#asignDialog",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this6;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        console.log("You resolve the dialog.");
	      }, function () {
	        console.log("You cancelled the dialog.");
	      });
	    }
	    /**
	     * Retrieves services available for assignment based on the selected establishment and consumers.
	     */
	    function getServicesByEstablishment() {
	      var _this7 = this;

	      var $this = this;
	      this.services = [];
	      var consumersId = [];
	      var servicesId = [];
	      var isAssigned = false;
	      var establishmentId = this.establishmentId;
	      this.consumersSelected.forEach(function (value) {
	        consumersId.push(value.id);
	      });
	      var filter = '{"include":[{"relation":"workstations"}],"where":{"status":true}}';
	      // Load all workstation by establishment
	      this.EstablishmentsResource.getDevicesByEstablishment({
	        id: establishmentId,
	        type: "queueTypes",
	        filter: filter
	      }).$promise.then(function (result) {
	        result.map(function (service) {
	          if (service.workstations.length == 0) {
	            if (servicesId.indexOf(service.id) < 0) {
	              delete service.workstations;
	              $this.services.push(service);
	              $this.services.sort(function (a, b) {
	                if (a.name < b.name) {
	                  return -1;
	                }
	                if (a.name > b.name) {
	                  return 1;
	                }
	                return 0;
	              });
	              servicesId.push(service.id);
	            }
	          } else {
	            angular.forEach(service.workstations, function (value) {
	              if (consumersId.indexOf(value.id) >= 0) {
	                isAssigned = true;
	              }
	            });

	            if (!isAssigned) {
	              delete service.workstations;
	              $this.services.push(service);
	              $this.services.sort(function (a, b) {
	                if (a.name < b.name) {
	                  return -1;
	                }
	                if (a.name > b.name) {
	                  return 1;
	                }
	                return 0;
	              });
	            }
	            isAssigned = false;
	          }
	        });
	      }).catch(function (error) {
	        console.log(error);
	        _this7.$translate("app.consumers.ERROR_GETBYESTABLISHMENT").then(function (errorMsg) {
	          _this7.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Closes the currently open dialog, resetting the new_consumer object and untouching the form.
	     */
	    function _closeDialog() {
	      this.new_consumer = {};
	      this.consumerForm.$setUntouched(); // this resets the form itself
	      $mdDialog.hide();
	    }
	    /**
	     * Cancels the currently open dialog.
	     */
	    function _cancelDialog() {
	      $mdDialog.cancel();
	    }
	    /**
	     * Creates a new consumer by making a request to the server.
	     *
	     * @param {object} consumer - The consumer data to be created.
	     */
	    function createConsumer(consumer) {
	      var _this8 = this;

	      var ev = this;
	      consumer.locationId = ev.establishmentId;
	      ev.ConsumersResource.create({}, consumer).$promise.then(function (result) {
	        ev.new_consumer = {};
	        ev.consumerForm.$setPristine();
	        ev.consumerForm.$setUntouched();
	        ev.add(result);
	        ev.getConsumersByEstablishment(ev.establishmentId);
	        ev.getAreasByEstablishment(ev.establishmentId);
	      }).catch(function (error) {
	        console.log(error);
	        _this8.$translate("app.consumers.ERROR_CREATE").then(function (errorMsg) {
	          _this8.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Updates consumer data by making a request to the server.
	     *
	     * @param {object} row - The consumer data to be updated.
	     */
	    function updateConsumer(row) {
	      var _this9 = this;

	      var $this = this;
	      var current_consumer_data = row;
	      row.consumerId = row.id;
	      var consumerId = row.consumerId;
	      this.ConsumersResource.update({ id: consumerId }, current_consumer_data).$promise.then(function (result) {
	        console.log(result);
	        _this9.$translate("app.consumers.SUCCESS_UPDATE").then(function (msg) {
	          _this9.toastr.success(msg);
	        });
	        $this.getConsumersByEstablishment($this.establishmentId);
	        $this.getAreasByEstablishment($this.establishmentId);
	      }).catch(function (error) {
	        console.log(error);
	        _this9.$translate("app.consumers.ERROR_UPDATE_SERVICE").then(function (errorMsg) {
	          _this9.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Deletes a consumer by making a request to the server.
	     *
	     * @param {object} consumer - The consumer data to be deleted.
	     */
	    function deleteConsumer(consumer) {
	      var _this10 = this;

	      this.ConsumersResource.delete({ id: consumer.id }).$promise.then(function (result) {
	        console.log(result);
	        _this10.$translate("app.administration.DELETE_OK").then(function (msg) {
	          _this10.toastr.success(msg, $translate.instant("app.administration.DELETE_SUCCESS"));
	        });
	        _this10.del(consumer);
	      }).catch(function (error) {
	        console.log(error);
	        _this10.$translate("app.consumers.ERROR_DELETE").then(function (errorMsg) {
	          _this10.toastr.error(errorMsg, "Error");
	        });
	      });
	    }

	    function deleteServiceDirectly(service) {
	      var $this = this;
	      var index = $this.current_consumer.services.indexOf(service);

	      if (index !== -1) {

	        $this.ConsumersResource.disassign({
	          type: "queueTypes",
	          id: $this.current_consumer.id,
	          option: "rel",
	          fk: service.id
	        }).$promise.then(function () {

	          $this.current_consumer.services.splice(index, 1);
	          $this.toastr.success($this.$translate.instant("app.administration.DELETE_OK"), $this.$translate.instant("app.administration.DELETE_SUCCESS"));
	        }).catch(function (error) {
	          console.error(error);
	          $this.toastr.error($this.$translate.instant("app.consumers.ERROR_DISASIGNSERVICE"), "Error");
	        });
	      }
	    }

	    /**
	     * Disassociates a service from a workstation for a consumer.
	     *
	     * @param {string} workstationId - The ID of the workstation.
	     * @param {string} serviceId - The ID of the service to be disassociated.
	     */
	    function disassignService(workstationId, serviceId) {
	      var $this = this;
	      this.ConsumersResource.disassign({
	        type: "queueTypes",
	        id: workstationId,
	        option: "rel",
	        fk: serviceId
	      }).$promise.then(function (result) {
	        console.log("disassign", result);
	        $this.$translate("app.administration.DELETE_OK").then(function (msg) {
	          $this.toastr.success(msg, $translate.instant("app.administration.DELETE_SUCCESS"));
	          $this.getConsumersByEstablishment($this.establishmentId);
	        });
	      }).catch(function (error) {
	        console.log(error);
	        $this.$translate("app.consumers.ERROR_DISASIGNSERVICE").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, $translate.instant("app.administration.DELETE_ERROR_MSG"));
	        });
	      });
	    }
	    /**
	     * Retrieves consumers associated with a specific establishment.
	     *
	     * @param {string} establishmentId - The ID of the establishment for which consumers are retrieved.
	     */
	    function getConsumersByEstablishment(establishmentId) {
	      var _this11 = this;

	      // Load all kiosks by establishment
	      this.ConsumersResource.getConsumersByLocation({ id: establishmentId }).$promise.then(function (result) {
	        _this11.noData = result.getByLocation.length > 0 ? false : true;
	        _this11.fail = false;
	        _this11.originalData = angular.copy(result.getByLocation);
	        _this11._createUsingFullOptions(result.getByLocation);
	      }).catch(function (error) {
	        console.log(error);
	        _this11.$translate("app.consumers.ERROR_DISASIGNSERVICE").then(function (errorMsg) {
	          _this11.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Retrieves areas associated with a specific establishment.
	     *
	     * @param {string} establishmentId - The ID of the establishment for which areas are retrieved.
	     */
	    function getAreasByEstablishment(establishmentId) {
	      var _this12 = this;

	      // Load all kiosks by establishment
	      this.EstablishmentsResource.getDevicesByEstablishment({
	        id: establishmentId,
	        type: "areas"
	      }).$promise.then(function (result) {
	        _this12.noAreas = result.length > 0 ? false : true;
	        _this12.areas = result;
	        _this12.areas.sort(function (a, b) {
	          return a.name.toLowerCase().localeCompare(b.name.toLowerCase(), 'es', { sensitivity: 'base' });
	        });
	      }).catch(function (error) {
	        console.log(error);
	        _this12.$translate("app.consumers.ERROR_GETBYESTABLISHMENT").then(function (errorMsg) {
	          _this12.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Retrieves the name of an area based on its ID.
	     *
	     * @param {string} areaId - The ID of the area for which the name is retrieved.
	     * @returns {string} - The name of the specified area.
	     */
	    function getAreaName(areaId) {
	      var area_name = "";
	      angular.forEach(this.areas, function (value) {
	        if (value.id === areaId) area_name = value.name;
	      });
	      return area_name;
	    }
	    /**
	     * Retrieves the name of an establishment based on its ID.
	     *
	     * @param {string} establishmentId - The ID of the establishment for which the name is retrieved.
	     * @returns {string} - The name of the specified establishment.
	     */
	    function getEstablishmentName(establishmentId) {
	      var establishment_name = "";
	      angular.forEach(this.establishments, function (value) {
	        if (value.id === establishmentId) establishment_name = value.name; /*+ ' ' + value.description;*/
	      });
	      return establishment_name;
	    }
	    /**
	     * Toggles the display of options based on the provided ID.
	     *
	     * @param {string} id - The ID of the element containing the options to be toggled.
	     * @returns {void}
	     */
	    function _editOptionsButton(id) {
	      var opc = document.getElementById(id);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Activates or deactivates options based on the provided ID and prefix.
	     *
	     * @param {string} id - The ID of the element containing the options to be toggled.
	     * @param {string} prefix - The prefix used in conjunction with the ID for identifying the options.
	     * @returns {void}
	     */
	    function _activateOptionsButton(id, prefix) {
	      var opc = document.getElementById(id + prefix);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id + prefix);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Handles the change of the selected item and updates relevant information, such as the current establishment,
	     * establishment ID, and retrieves consumers and areas based on the selected establishment.
	     *
	     * @param {object} item - The selected item representing the establishment.
	     * @returns {void}
	     */
	    function selectedItemChange(item) {
	      this.establishmentInUse = '';
	      if (item !== undefined) {
	        var Center = JSON.parse(JSON.stringify(item));

	        var current_establishment = Center;
	        this.currentEstablishment = current_establishment;
	        this.establishmentId = current_establishment.id;
	        this.establishmentInUse = current_establishment.name;
	        this.getConsumersByEstablishment(this.establishmentId);
	        this.getAreasByEstablishment(this.establishmentId);
	        return;
	      } else {
	        if (this.isRoot || this.isSuperAdmin) {
	          this.originalData = [];
	          this._createUsingFullOptions([]);
	        }
	      }
	    }
	    /**
	     * Performs a search query on the establishments and returns the matching results.
	     *
	     * @param {string} query - The search query to filter establishments.
	     * @returns {Array} - An array of establishments that match the search query.
	     */
	    function querySearchSelect(query) {
	      this.establishments.sort(function (a, b) {
	        if (a.name.toLowerCase() < b.name.toLowerCase()) {
	          return -1;
	        }
	        if (a.name.toLowerCase() > b.name.toLowerCase()) {
	          return 1;
	        }
	        return 0;
	      });
	      var results = query ? this.establishments.filter(createFilterFor(query)) : this.establishments;
	      return results;
	    }
	    /**
	     * Creates a filter function to be used in the search query for establishments.
	     *
	     * @param {string} query - The search query to filter establishments.
	     * @returns {function} - A filter function that matches establishments based on the query.
	     */
	    var createFilterFor = function createFilterFor(query) {
	      var lowercaseQuery = query.toLowerCase();
	      return function filterFn(item) {
	        var lowerCaseValue = item.name.toLowerCase();
	        return lowerCaseValue.indexOf(lowercaseQuery) === 0;
	      };
	    };
	    /**
	     * Retrieves establishments by organization ID.
	     *
	     * @param {string} organization_id - The ID of the organization to get establishments for.
	     * If falsy, it resets the searchText and establishments.
	     */
	    function getEstablismentByOrganization(organization_id) {
	      var _this13 = this;

	      if (!organization_id) {
	        this.searchText = '';
	        this.establishments = [];
	        return;
	      }
	      if (this.isRoot || this.isAdmin) {
	        this.OrganizationsResource.getEstablismentByOrganization({
	          id: organization_id
	        }).$promise.then(function (result) {
	          _this13.establishments = result;
	          _this13.establishments.sort(function (a, b) {
	            var aL = a.name.toLowerCase();
	            var bL = b.name.toLowerCase();
	            if (aL < bL) return -1;
	            if (aL > bL) return 1;
	            return 0;
	          });
	        }).catch(function () {
	          _this13.$translate("app.ERROR_GETESTABLISHMENT").then(function (errorMsg) {
	            _this13.toastr.error(errorMsg, "Error");
	          });
	        });
	      }
	    }
	    /**
	     * Searches and filters organizations based on the given query.
	     *
	     * @param {string} query - The search query to filter organizations.
	     * @returns {Array} - An array of filtered organizations based on the query.
	     */
	    function querySearchSelectOrganizations(query) {
	      this.organizations.sort(function (a, b) {
	        if (a.name < b.name) {
	          return -1;
	        }
	        if (a.name > b.name) {
	          return 1;
	        }
	        return 0;
	      });
	      var results = query ? this.organizations.filter(createFilterFor(query)) : this.organizations;
	      return results;
	    }

	    // exports
	    angular.extend(this, {
	      config: config,
	      createConsumer: createConsumer,
	      updateConsumer: updateConsumer,
	      deleteConsumer: deleteConsumer,
	      updateIcons: updateIcons,
	      getConsumersByEstablishment: getConsumersByEstablishment,
	      getAreasByEstablishment: getAreasByEstablishment,
	      getAreaName: getAreaName,
	      getEstablishmentName: getEstablishmentName,
	      _createUsingFullOptions: _createUsingFullOptions,
	      pageSizeChanged: pageSizeChanged,
	      _showConsumerForm: _showConsumerForm,
	      _closeDialog: _closeDialog,
	      _cancelDialog: _cancelDialog,
	      _sendConsumer: _sendConsumer,
	      _editOptionsButton: _editOptionsButton,
	      _activateOptionsButton: _activateOptionsButton,
	      _detailConsumer: _detailConsumer,
	      _detailAsignedService: _detailAsignedService,
	      _showDetailDialog: _showDetailDialog,
	      _selectConsumer: _selectConsumer,
	      _asignService: _asignService,
	      _showAsignServiceForm: _showAsignServiceForm,
	      getServicesByEstablishment: getServicesByEstablishment,
	      disassignService: disassignService,
	      selectedItemChange: selectedItemChange,
	      querySearchSelect: querySearchSelect,
	      _validateDescription: _validateDescription,
	      _showConsumerEdit: _showConsumerEdit,
	      getEstablismentByOrganization: getEstablismentByOrganization,
	      querySearchSelectOrganizations: querySearchSelectOrganizations
	    });
	  }

	  _createClass(ConsumersController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this14 = this;

	      var user_role = this.$localStorage.currentRole;
	      var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;

	      if (user_role.toUpperCase() == "ADMIN") {
	        this.getConsumersByEstablishment(this.establishmentId);
	        this.getAreasByEstablishment(this.establishmentId);
	      }

	      if (this.isRoot) {
	        this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
	          _this14.organizations = result;
	          _this14.organizations.sort(function (a, b) {
	            if (a.name.toLowerCase() < b.name.toLowerCase()) {
	              return -1;
	            }
	            if (a.name.toLowerCase() > b.name.toLowerCase()) {
	              return 1;
	            }
	            return 0;
	          });
	        }).catch(function () {
	          _this14.$translate("app.ERROR_GETORGANIZATION").then(function (errorMsg) {
	            _this14.toastr.error(errorMsg, "Error");
	          });
	        });
	      }

	      if (this.isSuperAdmin) {
	        this.AdministrationService.getEstablishments(user_role, organizationId, "locations").then(function (result) {
	          _this14.establishments = result.reverse();
	        }).catch(function (error) {
	          console.log(error);
	          _this14.handleErrorMessage("app.ERROR_GETESTABLISHMENT");
	        });
	      }
	    }
	  }, {
	    key: 'establishmentChanged',
	    value: function establishmentChanged() {
	      this.consumersSelected = [];
	      this.hasConsumersSelected = false;
	      this.$localStorage.last_establishment = this.establishmentSelected;
	      var current_establishment = JSON.parse(this.establishmentSelected);
	      this.currentEstablishment = current_establishment;
	      this.establishmentId = current_establishment.id;
	      this.establishmentInUse = current_establishment.name;
	      this.establishmentSelected = undefined;
	      this.$scope.selectEstablishmentForm.$setPristine();
	      // Load all kiosks by establishment
	      this.getConsumersByEstablishment(this.establishmentId);
	      this.getAreasByEstablishment(this.establishmentId);
	    }
	  }]);

	  return ConsumersController;
	}();

	ConsumersController.$inject = ["$scope", "$rootScope", "config", "ConsumersResource", "OrganizationsResource", "EstablishmentsResource", "AdministrationService", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "KiosksResource"];

	exports.default = ConsumersController;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ConsumersService =

	/** @ngInject */
	function ConsumersService() {
	  _classCallCheck(this, ConsumersService);
	};

	//ConsumersService.$inject = ['EmployeesResource'];

	exports.default = ConsumersService;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _screens = __webpack_require__(84);

	var _screens2 = __webpack_require__(86);

	var _screens3 = _interopRequireDefault(_screens2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var screens = angular.module('mod.admin.administration.screens', []).component('screens', _screens.ScreensComponent).service('ScreensService', _screens3.default).name;

	exports.default = screens;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScreensComponent = undefined;

	var _screens = __webpack_require__(85);

	var _screens2 = _interopRequireDefault(_screens);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ScreensComponent = exports.ScreensComponent = {
	  controller: _screens2.default,
	  templateUrl: 'app/modules/admin/administration/screens/screens.html'
	};

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ScreensController = function () {

		/** @ngInject */
		ScreensController.$inject = ["$scope", "$rootScope", "config", "ScreensResource", "OrganizationsResource", "EstablishmentsResource", "AdministrationService", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "pageSizeOptions"];
		function ScreensController($scope, $rootScope, config, ScreensResource, OrganizationsResource, EstablishmentsResource, AdministrationService, NgTableParams, $translate, toastr, $mdDialog, $localStorage, $location, pageSizeOptions) {
			var _this = this;

			_classCallCheck(this, ScreensController);

			// private
			this.$localStorage = $localStorage;
			this.$scope = $scope;
			this.$rootScope = $rootScope;
			this.noData = true;
			this.establishmentInUse = '';
			//this.establishmentId = config.ESTABLISHMENT_ID;
			this.isSuperAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'SUPERADMIN' ? true : false;
			this.isRoot = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'ROOT' ? true : false;
			this.isAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'ADMIN' ? true : false;
			var last_establishment = $localStorage.last_establishment ? $localStorage.last_establishment : false;
			if (this.isRoot || this.isSuperAdmin) {
				if (last_establishment) {
					this.currentEstablishment = (typeof last_establishment === 'undefined' ? 'undefined' : _typeof(last_establishment)) != 'object' ? JSON.parse(last_establishment) : last_establishment;
					this.establishmentId = this.currentEstablishment.id;
				}
			} else {
				this.establishmentId = $localStorage.currentLocation.id;
			}
			this.isPre = config.IS_PRE;
			this.OrganizationsResource = OrganizationsResource;
			this.EstablishmentsResource = EstablishmentsResource;
			this.ScreensResource = ScreensResource;
			this.AdministrationService = AdministrationService;
			this.config = config;
			this.$translate = $translate;
			this.toastr = toastr;
			this.$mdDialog = $mdDialog;
			this.screensSelected = [];
			this.hasScreensSelected = false;
			this.isAdding = false;
			this.fail = false;
			this.organizations = [];
			this.establishments = [];
			this.searchTextOrganization = '';
			this.searchText = '';
			this.list_ready = [];
			this.cancel = cancel;
			this.showDeleteConfirm = showDeleteConfirm;
			this.del = del;
			this.save = save;
			this.add = add;
			this.resetRow = resetRow;
			this.screen = {};
			this.screen.fields_selected = {};
			this.count = 10;
			this.pageSizeOptions = pageSizeOptions;
			this.errosInput = {
				name: false,
				center: false
			};

			this.pageSizeOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

			// Control of sidemenu page
			var url = $location.url().substring(1).toUpperCase();
			this.$rootScope.currentPage = currentPage(1);
			/**
	   * Extracts the specified index from the URL path segments.
	   *
	   * @function
	   * @name currentPage
	   * @param {number} index - The index of the path segment to retrieve.
	   * @returns {string} The path segment at the specified index in the URL.
	   */
			function currentPage(index) {
				var split_url = url.split('/');
				return split_url[index];
			}
			/**
	   * Handles the change in page size for the NgTable.
	   *
	   * @function
	   * @name pageSizeChanged
	   * @param {number} newPageSize - The new page size to be set.
	   */
			var pageSizeChanged = function pageSizeChanged(newPageSize) {
				_this.tableParams.count(newPageSize);
				_this.count = newPageSize;
			};
			/**
	   * Creates an instance of NgTable with full options.
	   *
	   * @function
	   * @name _createUsingFullOptions
	   * @param {Array} screens_data - The array of data to be used as the dataset.
	   * @returns {NgTableParams} - The created NgTableParams instance.
	   */
			function _createUsingFullOptions(screens_data) {
				var initialParams = {
					count: this.count // initial page size
				};
				var initialSettings = {
					// page size buttons (right set of buttons in demo)
					counts: [],
					// determines the pager buttons (left set of buttons in demo)
					paginationMaxBlocks: 4,
					paginationMinBlocks: 2,
					dataset: screens_data
				};
				this.tableParams = new NgTableParams(initialParams, initialSettings);
				return this.tableParams;
			}
			/**
	   * Adds a new template to the NgTable dataset and reloads the table.
	   *
	   * @function
	   * @name add
	   * @param {Object} new_template - The new template to be added to the dataset.
	   */
			function add(new_template) {
				this.tableParams.settings().dataset.unshift(new_template);
				this.tableParams.sorting({});
				this.tableParams.page(1);
				this.tableParams.reload();
			}
			/**
	   * Cancels the editing operation for a row and reverts the changes made to the row.
	   *
	   * @function
	   * @name cancel
	   * @param {Object} row - The row that is being edited.
	   * @param {Object} rowForm - The form associated with the row.
	   */
			function cancel(row, rowForm) {
				var originalRow = this.resetRow(row, rowForm);
				angular.extend(row, originalRow);
			}
			/**
	   * Hides the HTML element with the specified ID.
	   *
	   * @function
	   * @name hideElement
	   * @param {string} id - The ID of the HTML element to hide.
	   */
			function hideElement(id) {
				var menu = document.getElementById('' + id);
				if (menu) {
					menu.style.display = "none";
				}
			}
			/**
	   * Displays a confirmation dialog for deleting a screen.
	   *
	   * @function
	   * @name showDeleteConfirm
	   * @param {Object} ev - The event object.
	   * @param {string} ev.id - The ID of the HTML element.
	   */
			function showDeleteConfirm(ev) {
				var current_scope = this;
				hideElement(ev.id);
				// Appending dialog to document.body to cover sidenav in docs app
				var confirm = $mdDialog.confirm().title($translate.instant('app.administration.CONFIRM_DELETE')).targetEvent(ev).ok($translate.instant('app.common.ACCEPT')).cancel($translate.instant('app.common.CANCEL'));

				$mdDialog.show(confirm).then(function () {
					current_scope.deleteScreen(ev);
				}, function () {});
			}
			/**
	   * Deletes a row from the table.
	   *
	   * @function
	   * @name del
	   * @param {Object} row - The row to be deleted.
	   */
			function del(row) {
				var $this = this;
				var main_dataset = this.tableParams.settings().dataset;
				var originalData = '';
				angular.forEach(this.tableParams.settings().dataset, function (value, key) {
					if (angular.equals(row, value)) {
						main_dataset.splice(key, 1);
						originalData = angular.copy(main_dataset);
					}
				});
				this.originalData = originalData;
				this.tableParams.reload().then(function (data) {
					if (data.length === 0 && $this.tableParams.total() > 0) {
						$this.tableParams.page($this.tableParams.page() - 1);
						$this.tableParams.reload();
					}
				});
				//this.deleteScreen(row.id);
			}
			/**
	   * Saves the changes made to a row in the table.
	   *
	   * @function
	   * @name save
	   * @param {Object} row - The row to be saved.
	   * @param {Object} rowForm - The form associated with the row.
	   */
			function save(row, rowForm) {
				var originalRow = this.resetRow(row, rowForm);
				this.isAdding = false;
				this.hasScreensSelected = false;
				this.screensSelected = [];
				this.updateScreen(row);
				angular.extend(originalRow, row);
			}
			/**
	   * Resets a row, either when it is being added or when editing is canceled.
	   *
	   * @function
	   * @name resetRow
	   * @param {Object} row - The row to be reset.
	   * @param {Object} rowForm - The form associated with the row.
	   * @returns {Object} - The original data of the row.
	   */
			function resetRow(row, rowForm) {
				var row_isAdding = this.isAdding;
				if (row_isAdding) {
					this.originalData = angular.copy(this.tableParams.settings().dataset);
				}
				var return_value = '';
				row.isEditing = false;
				rowForm.$setPristine();
				angular.forEach(this.originalData, function (value) {
					if (!row_isAdding && row.id === value.id) {
						return_value = value;
					} else if (row_isAdding && value.id === '') {
						return_value = value;
					}
				});
				return return_value;
			}
			/**
	   * Displays the detail dialog for a screen.
	   *
	   * @function
	   * @name _detailScreen
	   * @param {Object} screen - The screen for which to display the detail dialog.
	   */
			function _detailScreen(screen) {
				var _this2 = this;

				if (screen.isEditing !== true) {
					this.current_screen = screen;
					this.ScreensResource.getScreens({
						id: screen.id,
						resource: "queueTypes"
					}).$promise.then(function (result) {
						screen.services = result;
					}).catch(function (error) {
						console.log(error);
						_this2.$translate("app.screens.ERROR_GETSERVICES").then(function (errorMsg) {
							_this2.toastr.error(errorMsg, "Error");
						});
					});
					this._showDetailDialog();
				}
			}

			/**
	   * Displays the detail dialog for a screen.
	   *
	   * @function
	   * @name _showDetailDialog
	   * @param {Event} ev - The event that triggered the dialog.
	   */
			function _showDetailDialog(ev) {
				var _this3 = this;

				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#dialog_detail_screen',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this3;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				});
			}
			/**
	   * Displays the form for creating a new screen.
	   *
	   * @function
	   * @name _showNewScreenForm
	   * @param {Event} ev - The event that triggered the dialog.
	   */
			function _showNewScreenForm(ev) {
				var _this4 = this;

				var parent = this;
				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#myDialog',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this4;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				}).then(function () {
					var errNameElement = document.getElementById("err_name");
					if (errNameElement) {
						errNameElement.style.display = "none";
					}
					document.getElementById("name").parentElement.parentElement.children[0].classList.remove("md-input-invalid");
					document.getElementById("err_center").style.display = "none";
					document.getElementById("center").parentElement.parentElement.children[0].classList.remove("md-input-invalid");
				}, function () {
					parent._closeDialog();
				});
			}
			/**
	   * Validates the inputs for creating a new screen.
	   *
	   * @function
	   * @name validationsInputs
	   * @returns {boolean} - Returns `true` if the inputs are valid, otherwise `false`.
	   */
			function validationsInputs() {
				var name = document.getElementById("name").value;
				var name2 = document.getElementById("name");
				var errName = document.getElementById("err_name");
				var center = document.getElementById("center").value;
				var re2 = /^(?!\s{2,}|.*\s$).*$/;
				var re = /^[a-zA-Z ]+$/;
				var rePhone = /^[0-9]+$/;
				var resAlphaNum = /^[a-zA-Z0-9.,-_áéíóúñÁÉÍÓÚÑ@() ]+$/;

				if (!resAlphaNum.test(name) || !re2.test(name)) {
					name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
					errName.style.display = "block";
					errName.innerHTML = "Ingresa un nombre válido";
					errName.style.color = "red";
				} else if (name.length > 15 || name.length < 1) {
					name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
					errName.innerHTML = "El nombre debe tener entre 3 y 15 caracteres";
					errName.style.display = "block";
					errName.style.color = "red";
				} else {
					name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
					errName !== null ? errName.style.display = "none" : null;
				}
				return re.test(name) && rePhone.test(center) && name.length >= 1 && name.length <= 15;
			}
			/**
	   * Validates the inputs based on the provided rules.
	   *
	   * @function
	   * @name _validateInputs
	   * @param {string} value - The input value to be validated.
	   * @param {string} id - The identifier for the input field.
	   * @param {object} rowForm - The form object associated with the input.
	   */
			var _validateInputs = function _validateInputs(value, id, rowForm) {
				var rePhone = /^[0-9]+$/;
				var resAlphaNum = /^[a-zA-Z]+$/;

				if (rePhone.test(value) || !resAlphaNum.test(value)) {
					_this.errosInput[id] = true;
					rowForm[id].$setValidity('required', false);
				} else if (value.length > 15 || value.length < 3) {
					_this.errosInput[id] = true;
					rowForm[id].$setValidity('required', false);
				} else {
					_this.errosInput[id] = false;
					rowForm[id].$setValidity('required', true);
				}

				if (id === 'center') {
					if (!rePhone.test(value) || resAlphaNum.test(value)) {
						_this.errosInput[id] = true;
						rowForm[id].$setValidity('required', false);
					} else {
						_this.errosInput[id] = false;
						rowForm[id].$setValidity('required', true);
					}
					if (value > 100 || value < 1) {
						_this.errosInput[id] = true;
						rowForm[id].$setValidity('required', false);
					} else {
						_this.errosInput[id] = false;
						rowForm[id].$setValidity('required', true);
					}
				}
			};
			/**
	   * Sends the screen data after validating the inputs and handling form controls.
	   *
	   * @function
	   * @name _sendScreen
	   * @param {object} result - The screen data to be sent.
	   */
			function _sendScreen(result) {
				var valid = validationsInputs();
				if (valid) {
					if (this.screenForm.$invalid) {
						Object.values(this.screenForm.$$controls).forEach(function (control) {
							control.$touched = true;
						});
						return;
					}
					if (result.fields_selected) {
						result.fields_selected.map(function (item) {
							if (item.value == 'name' || item == 'name') {
								result.show_name = true;
							} else if (item.value == 'tts' || item == 'tts') {
								result.has_tts = true;
							} else {
								result.show_workstation = true;
							}
							return true;
						});
					} else {
						result.show_name = false;
						result.show_workstation = false;
						result.has_tts = false;
					}
					// Default values
					delete result.fields_selected;
					this.createScreen(result);
					$mdDialog.cancel();
				}
			}

			/**
	   * Assigns selected services to screens by creating relationships between screens and queue types.
	   *
	   * @param {object} services - The services to be assigned, including a queue property with queue IDs.
	   */
			function _assignService(services) {
				var $this = this;

				angular.forEach(services.queue, function (queueId) {
					angular.forEach($this.screensSelected, function (value) {

						var new_rel = {
							screenId: value.id,
							queueTypeId: queueId
						};

						value.assigned = true;
						delete value.Selected;

						$this.ScreensResource.assignService({ id: value.id, fk: queueId }, new_rel).$promise.then(function (result) {
							$this.new_service = {};
							$this.assignServiceForm.$setPristine();
							$this.assignServiceForm.$setUntouched();

							$this.$translate("app.screens.SUCCESS_ASIGNSERVICE").then(function (msg) {
								$this.toastr.success(msg);
							});
						}).catch(function (error) {
							console.log(error);
							$this.$translate("app.screens.ERROR_ASSIGNSERVICE").then(function (errorMsg) {
								$this.toastr.error(errorMsg, "Error");
							});
						});
					});
				});

				$this.hasScreensSelected = false;
				$this.screensSelected = [];
				$mdDialog.cancel();
			}

			/**
	   * Handles the selection or deselection of a screen in the list.
	   *
	   * @param {object} result - The screen to be selected or deselected.
	   */
			function _selectScreen(result) {
				var elem_pos = this.screensSelected.indexOf(result);
				if (elem_pos !== -1) {
					this.screensSelected.splice(elem_pos, 1);
				} else {
					this.screensSelected.push(result);
				}
				this.hasScreensSelected = false;
				if (this.screensSelected.length > 0) {
					this.hasScreensSelected = true;
				}
			}

			/**
	   * Closes the dialog, resets the new_screen object, new_screen_check object, and untouches the screenForm.
	   *
	   * @function
	   * @name _closeDialog
	   */
			function _closeDialog() {
				this.new_screen = {};
				this.new_screen_check = {};
				this.screenForm.$setUntouched(); // this resets the form itself
				$mdDialog.hide();
			}
			/**
	   * Cancels the dialog.
	   *
	   * @function
	   * @name _cancelDialog
	   */
			function _cancelDialog() {
				$mdDialog.cancel();
			}

			/**
	   * Displays a detail dialog for assigned services.
	   *
	   * @param {object} ev - The event object that triggered the dialog.
	   */
			function _detailAsignedService(ev) {
				var _this5 = this;

				$mdDialog.show({
					preserveScope: true,
					hasBackdrop: true,
					contentElement: "#dialog_detail_asigned_services",
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this5;
					},
					controllerAs: "ctrl",
					clickOutsideToClose: true
				}).then(function () {
					console.log("You resolve the dialog.");
				}, function () {
					console.log("You cancelled the dialog.");
				});
			}

			/**
	   * Displays a form for assigning services to screens.
	   *
	   * @function
	   * @name _showAssignServiceForm
	   * @param {object} ev - The event object that triggered the dialog.
	   */
			function _showAssignServiceForm(ev) {
				var _this6 = this;

				this.getServicesByEstablishment();
				$mdDialog.show({
					preserveScope: true,
					hasBackdrop: true,
					contentElement: "#assignDialog",
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this6;
					},
					controllerAs: "ctrl",
					clickOutsideToClose: true
				}).then(function () {
					console.log("You resolve the dialog.");
				}, function () {
					console.log("You cancelled the dialog.");
				});
			}

			/**
	   * Creates a new screen associated with an establishment.
	   *
	   * @param {Object} screen - Object containing the information of the screen to create.
	   * @property {string} screen.locationId - Identifier of the establishment to which the screen will be associated.
	   * @property {Object} ScreensResource - Resource used to perform the screen creation.
	   *
	   * @throws {Error} - Throws an error if the screen creation is not successful.
	   *
	   * @returns {void}
	   */
			function createScreen(screen) {
				var _this7 = this;

				var ev = this;
				screen.locationId = ev.establishmentId;

				ev.ScreensResource.create({}, screen).$promise.then(function (result) {
					ev.new_screen = {};
					ev.screenForm.$setPristine();
					ev.screenForm.$setUntouched();
					ev.add(result);
					_this7.getScreensByEstablishment(_this7.establishmentId);
					_this7.getAreasByEstablishment(_this7.establishmentId);
					_this7.$translate('app.screens.SUCCESS_CREATE').then(function (msg) {
						_this7.toastr.success(msg, $translate.instant("app.SUCCESS"));
					});
				}).catch(function (error) {

					if (error.status === 500) {

						_this7.toastr.warning("app.screens.EMPTY_CSS_FILE", "Advertencia");
					} else {
						_this7.$translate('app.screens.ERROR_CREATE').then(function (errorMsg) {
							_this7.toastr.error(errorMsg, 'Error');
						});
					}
				});
			}
			/**
	   * Updates the information of an existing screen.
	   *
	   * @param {Object} row - Object containing the data of the screen to be updated.
	   * @property {string} row.screenId - Identifier of the screen to be updated.
	   * @property {string} row.id - Identifier of the screen (may be redundant, depending on the application).
	   * @property {boolean} row.show_name - Indicates whether to display the screen name.
	   * @property {boolean} row.show_workstation - Indicates whether to display the workstation information on the screen.
	   * @property {boolean} row.has_tts - Indicates whether the screen has text-to-speech capability.
	   *
	   * @throws {Error} - Throws an error if the screen update is not successful.
	   *
	   * @returns {void}
	   */
			function updateScreen(row) {
				var _this8 = this;

				var $this = this;
				var current_screen_data = row;

				delete current_screen_data.Selected;
				delete current_screen_data.assigned;

				row.screenId = row.id;
				var screenId = row.screenId;
				row.show_name = row.show_name ? row.show_name : false;
				row.show_workstation = row.show_workstation ? row.show_workstation : false;
				row.has_tts = row.has_tts ? row.has_tts : false;

				this.ScreensResource.update({ id: screenId }, current_screen_data).$promise.then(function () {
					$this.getScreensByEstablishment(_this8.establishmentId);
					$this.getAreasByEstablishment(_this8.establishmentId);
					_this8.$translate('app.screens.SUCCESS_UPDATE').then(function (msg) {
						_this8.toastr.success(msg, $translate.instant("app.SUCCESS"));
					});
				}).catch(function (error) {

					if (error.status === 500) {

						_this8.toastr.warning("app.screens.EMPTY_CSS_FILE", "Advertencia");
					} else {
						$this.$translate('app.screens.ERROR_UPDATE').then(function (errorMsg) {
							$this.toastr.error(errorMsg, 'Error');
						});
					}
				});
			}
			/**
	   * Deletes a screen based on the provided screen object.
	   *
	   * @param {Object} screen - Object containing information about the screen to be deleted.
	   * @property {string} screen.id - Identifier of the screen to be deleted.
	   *
	   * @throws {Error} - Throws an error if the screen deletion is not successful.
	   *
	   * @returns {void}
	   */
			function deleteScreen(screen) {
				var _this9 = this;

				var $this = this;
				this.ScreensResource.delete({ id: screen.id }).$promise.then(function () {
					_this9.$translate('app.administration.DELETE_OK').then(function (msg) {
						_this9.toastr.success(msg, $translate.instant('app.administration.DELETE_SUCCESS'));
					});
					_this9.del(screen);
				}).catch(function (error) {
					console.log(error);
					$this.$translate('app.screens.ERROR_DELETE').then(function (errorMsg) {
						$this.toastr.error(errorMsg, 'Error');
					});
				});
			}

			function deleteServiceDirectly(service) {
				var $this = this;
				var index = $this.current_screen.services.indexOf(service);

				delete $this.current_screen.Selected;

				if (index !== -1) {
					$this.ScreensResource.disassignService({ id: $this.current_screen.id, fk: service.id }).$promise.then(function () {
						$this.current_screen.services.splice(index, 1);
						$this.current_screen.assigned = $this.current_screen.services.length > 0;
						$this.current_screen.Selected = false;
						$this.toastr.success($this.$translate.instant("app.administration.DELETE_OK"), $this.$translate.instant("app.administration.DELETE_SUCCESS"));
					}).catch(function (error) {
						console.error(error);
						$this.toastr.error($this.$translate.instant("app.screen.ERROR_DISASSIGNSERVICE"), "Error");
					});

					$this.hasScreensSelected = false;
					$this.screensSelected = [];
				}
			}

			/**
	   * Retrieves screens associated with a specified establishment.
	   *
	   * @param {string} establishmentId - Identifier of the establishment for which screens are to be retrieved.
	   *
	   * @throws {Error} - Throws an error if the retrieval of screens by establishment is not successful.
	   *
	   * @returns {void}
	   */
			function getScreensByEstablishment(establishmentId) {
				var _this10 = this;

				// Load all kiosks by establishment 
				this.ScreensResource.getScreensByEstablishment({ id: establishmentId }).$promise.then(function (result) {
					_this10.noData = result.getByLocation.length == 0 ? true : false;
					_this10.fail = false;
					_this10.hasScreensSelected = false;
					_this10.screensSelected = [];

					result.getByLocation.forEach(function (screen) {
						screen.services = screen.queueTypes || [];
						screen.assigned = screen.services.length > 0;
						delete screen.queueTypes;
					});

					_this10.originalData = angular.copy(result.getByLocation);
					_this10._createUsingFullOptions(result.getByLocation);
				}).catch(function (error) {
					console.log(error);
					_this10.noScreens = true;
					_this10.$translate('app.app.services.ERROR_GETBYESTABLISHMENT').then(function (errorMsg) {
						_this10.toastr.error(errorMsg, 'Error');
					});
				});
			}

			/**
	   * Retrieves services available for assignment based on the selected establishment and screens.
	   */
			function getServicesByEstablishment() {
				var _this11 = this;

				var $this = this;
				this.services = [];
				var screensId = [];
				var servicesId = [];
				var isAssigned = false;
				var establishmentId = this.establishmentId;
				this.screensSelected.forEach(function (value) {
					screensId.push(value.id);
				});
				var filter = '{"include":[{"relation":"screens"}],"where":{"status":true}}';
				this.EstablishmentsResource.getDevicesByEstablishment({
					id: establishmentId,
					type: "queueTypes",
					filter: filter
				}).$promise.then(function (result) {
					result.map(function (service) {
						if (service.screens.length == 0) {
							if (servicesId.indexOf(service.id) < 0) {
								delete service.screens;
								$this.services.push(service);
								$this.services.sort(function (a, b) {
									return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
								});
								servicesId.push(service.id);
							}
						} else {
							angular.forEach(service.screens, function (value) {
								if (screensId.indexOf(value.id) >= 0) {
									isAssigned = true;
								}
							});

							if (!isAssigned) {
								delete service.screens;
								$this.services.push(service);
								$this.services.sort(function (a, b) {
									return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
								});
							}
							isAssigned = false;
						}
					});
				}).catch(function (error) {
					console.log(error);
					_this11.$translate("app.screens.ERROR_GETBYESTABLISHMENT").then(function (errorMsg) {
						_this11.toastr.error(errorMsg, "Error");
					});
				});
			}

			/**
	   * Retrieves areas associated with a specified establishment.
	   *
	   * @param {string} establishmentId - Identifier of the establishment for which areas are to be retrieved.
	   *
	   * @throws {Error} - Throws an error if the retrieval of areas by establishment is not successful.
	   *
	   * @returns {void}
	   */
			function getAreasByEstablishment(establishmentId) {
				var _this12 = this;

				// Load all kiosks by establishment 
				this.EstablishmentsResource.getDevicesByEstablishment({ 'id': establishmentId, 'type': 'areas' }).$promise.then(function (result) {
					_this12.noAreas = result.length > 0 ? false : true;
					_this12.areas = result;
				}).catch(function (error) {
					console.log(error);
					_this12.$translate('app.services.ERROR_GETBYESTABLISHMENT').then(function (errorMsg) {
						_this12.toastr.error(errorMsg, 'Error');
					});
				});
			}
			/**
	   * Retrieves the name of an area based on its identifier.
	   *
	   * @param {string} areaId - Identifier of the area for which the name is to be retrieved.
	   *
	   * @returns {string} - The name of the area corresponding to the provided identifier.
	   */
			function getAreaName(areaId) {
				var area_name = '';
				angular.forEach(this.areas, function (value) {
					if (value.id === areaId) area_name = value.name;
				});
				return area_name;
			}
			/**
	   * Retrieves the name of an establishment based on its identifier.
	   *
	   * @param {string} establishmentId - Identifier of the establishment for which the name is to be retrieved.
	   *
	   * @returns {string} - The name of the establishment corresponding to the provided identifier.
	   */
			function getEstablishmentName(establishmentId) {
				var establishment_name = '';
				angular.forEach(this.establishments, function (value) {
					if (value.id === establishmentId) establishment_name = value.name; /*+ ' ' + value.description;*/
				});
				return establishment_name;
			}

			this.items = [{
				value: 'workstation',
				text: 'app.screens.SHOW_WORKSTATION'
			}, {
				value: 'name',
				text: 'app.screens.SHOW_NAME'
			}, {
				value: 'tts',
				text: 'app.screens.VOICE_SERVICE'
			}];
			this.selected = [];

			this.toggle = function (item, list) {
				var idx = list.indexOf(item);
				if (idx > -1) {
					list.splice(idx, 1);
				} else {
					list.push(item);
				}
				this.new_screen.fields_selected = list;
			};

			this.is_selected = function (item, screen) {
				if (item === 'tts') return screen['has_' + item];else return screen['show_' + item];
			};

			this.create_model = function (item) {
				return 'screen.show_' + item;
			};

			/**
	   * Updates icons in a row based on the specified state and type, then triggers a save operation.
	   *
	   * @param {object} row - The row containing icons to be updated.
	   * @param {object} rowForm - The form associated with the row.
	   * @param {boolean} state - The new state for the icons.
	   * @param {string} type - The type of icons to be updated ("assigned" or "statusButtons").
	   */
			function updateIcons(row, rowForm, state, type) {
				if (type === "assigned") {
					row.assigned = state;
				} else {
					row.statusButtons = state;
				}
				this.save(row, rowForm);
			}

			/**
	   * Toggles the visibility of options associated with a button identified by its ID.
	   *
	   * @param {string} id - Identifier of the button for which options visibility will be toggled.
	   *
	   * @returns {void}
	   */
			function _editOptionsButton(id) {
				var opc = document.getElementById(id);
				if (opc.style.display === "none") {
					opc.style.display = "block";
				} else {
					opc.style.display = "none";
				}
				document.addEventListener('mouseup', function (e) {
					var container = document.getElementById(id);
					if (container && !container.contains(e.target)) {
						container.style.display = 'none';
					}
				}.bind(this));
			}
			/**
	   * Toggles the visibility of options associated with a button identified by its ID and a specified prefix.
	   *
	   * @param {string} id - Identifier of the button for which options visibility will be toggled.
	   * @param {string} prefix - Prefix to be appended to the ID for more precise identification.
	   *
	   * @returns {void}
	   */
			function _activateOptionsButton(id, prefix) {
				var opc = document.getElementById(id + prefix);
				if (opc.style.display === "none") {
					opc.style.display = "block";
				} else {
					opc.style.display = "none";
				}
				document.addEventListener('mouseup', function (e) {
					var container = document.getElementById(id + prefix);
					if (container && !container.contains(e.target)) {
						container.style.display = 'none';
					}
				}.bind(this));
			}
			/**
	   * Handles the change of the selected item and updates relevant data accordingly.
	   *
	   * @param {Object} item - The selected item triggering the change.
	   *
	   * @returns {void}
	   */
			function selectedItemChange(item) {
				this.establishmentInUse = '';
				if (item !== undefined) {
					var Center = JSON.parse(JSON.stringify(item));
					var current_establishment = Center;
					this.currentEstablishment = current_establishment;
					this.establishmentId = current_establishment.id;
					this.establishmentInUse = current_establishment.name;
					this.getScreensByEstablishment(this.establishmentId);
					this.getAreasByEstablishment(this.establishmentId);
					return;
				} else {
					if (this.isRoot || this.isSuperAdmin) {
						this.originalData = [];
						this._createUsingFullOptions([]);
					}
				}
			}
			/**
	   * Performs a search query on the list of establishments for a given input.
	   *
	   * @param {string} query - The search query to filter establishments.
	   *
	   * @returns {Array} - An array of establishments matching the search query.
	   */
			function querySearchSelect(query) {
				var results = query ? this.establishments.filter(createFilterFor(query)) : this.establishments;
				return results;
			}
			/**
	   * Creates a filter function for searching establishments based on a given query.
	   *
	   * @param {string} query - The search query to filter establishments.
	   *
	   * @returns {Function} - A filter function for establishments.
	   */
			var createFilterFor = function createFilterFor(query) {
				var lowercaseQuery = query.toLowerCase();
				return function filterFn(item) {
					var lowerCaseValue = item.name.toLowerCase();
					return lowerCaseValue.indexOf(lowercaseQuery) === 0;
				};
			};
			/**
	   * Retrieves establishments associated with a specified organization.
	   *
	   * @param {string} organization_id - Identifier of the organization for which establishments are to be retrieved.
	   *
	   * @returns {void}
	   */
			function getEstablismentByOrganization(organization_id) {
				var _this13 = this;

				if (!organization_id) {
					this.searchText = '';
					this.establishments = [];
					return;
				}
				if (this.isRoot || this.isAdmin) {
					this.OrganizationsResource.getEstablismentByOrganization({
						id: organization_id
					}).$promise.then(function (result) {
						_this13.establishments = result;
						_this13.establishments.sort(function (a, b) {
							var aL = a.name.toLowerCase();
							var bL = b.name.toLowerCase();
							if (aL < bL) return -1;
							if (aL > bL) return 1;
							return 0;
						});
					}).catch(function () {
						_this13.$translate("app.ERROR_GETESTABLISHMENT").then(function (errorMsg) {
							_this13.toastr.error(errorMsg, "Error");
						});
					});
				}
			}
			/**
	   * Performs a search query on the list of organizations for a given input.
	   *
	   * @param {string} query - The search query to filter organizations.
	   *
	   * @returns {Array} - An array of organizations matching the search query.
	   */
			function querySearchSelectOrganizations(query) {
				this.organizations.sort(function (a, b) {
					if (a.name < b.name) {
						return -1;
					}
					if (a.name > b.name) {
						return 1;
					}
					return 0;
				});
				var results = query ? this.organizations.filter(createFilterFor(query)) : this.organizations;
				return results;
			}

			angular.extend(this, {
				config: config,
				updateIcons: updateIcons,
				createScreen: createScreen,
				updateScreen: updateScreen,
				deleteScreen: deleteScreen,
				deleteServiceDirectly: deleteServiceDirectly,
				getScreensByEstablishment: getScreensByEstablishment,
				getAreasByEstablishment: getAreasByEstablishment,
				_createUsingFullOptions: _createUsingFullOptions,
				pageSizeChanged: pageSizeChanged,
				_showNewScreenForm: _showNewScreenForm,
				_detailAsignedService: _detailAsignedService,
				_showAssignServiceForm: _showAssignServiceForm,
				getServicesByEstablishment: getServicesByEstablishment,
				_closeDialog: _closeDialog,
				_cancelDialog: _cancelDialog,
				_sendScreen: _sendScreen,
				_assignService: _assignService,
				_selectScreen: _selectScreen,
				_editOptionsButton: _editOptionsButton,
				_activateOptionsButton: _activateOptionsButton,
				_detailScreen: _detailScreen,
				_showDetailDialog: _showDetailDialog,
				_validateInputs: _validateInputs,
				getAreaName: getAreaName,
				getEstablishmentName: getEstablishmentName,
				selectedItemChange: selectedItemChange,
				querySearchSelect: querySearchSelect,
				getEstablismentByOrganization: getEstablismentByOrganization,
				querySearchSelectOrganizations: querySearchSelectOrganizations
			});
		}

		_createClass(ScreensController, [{
			key: '$onInit',
			value: function $onInit() {
				var _this14 = this;

				var user_role = this.$localStorage.currentRole;
				var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
				this.screensSelected = [];
				this.hasScreensSelected = false;

				if (user_role.toUpperCase() == 'ADMIN') {
					this.getScreensByEstablishment(this.establishmentId);
					this.getAreasByEstablishment(this.establishmentId);
				}

				if (this.isRoot) {
					this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
						_this14.organizations = result;
						_this14.organizations.sort(function (a, b) {
							if (a.name.toLowerCase() < b.name.toLowerCase()) {
								return -1;
							}
							if (a.name.toLowerCase() > b.name.toLowerCase()) {
								return 1;
							}
							return 0;
						});
					}).catch(function () {
						_this14.$translate("app.ERROR_GETORGANIZATION").then(function (errorMsg) {
							_this14.toastr.error(errorMsg, "Error");
						});
					});
				}

				if (this.isSuperAdmin) {
					this.AdministrationService.getEstablishments(user_role, organizationId, "locations").then(function (result) {
						_this14.establishments = result.reverse();
					}).catch(function (error) {
						console.log(error);
						_this14.handleErrorMessage("app.ERROR_GETESTABLISHMENT");
					});
				}
			}
		}, {
			key: 'establishmentChanged',
			value: function establishmentChanged() {
				this.$localStorage.last_establishment = this.establishmentSelected;
				var current_establishment = JSON.parse(this.establishmentSelected);
				this.screensSelected = [];
				this.hasScreensSelected = false;
				this.currentEstablishment = current_establishment;
				this.establishmentId = current_establishment.id;
				this.establishmentInUse = current_establishment.name;
				this.establishmentSelected = undefined;
				this.$scope.selectEstablishmentForm.$setPristine();
				this.getScreensByEstablishment(this.establishmentId);
				this.getAreasByEstablishment(this.establishmentId);
			}
		}]);

		return ScreensController;
	}();

	ScreensController.$inject = ['$scope', '$rootScope', 'config', 'ScreensResource', 'OrganizationsResource', 'EstablishmentsResource', 'AdministrationService', 'NgTableParams', '$translate', 'toastr', '$mdDialog', '$localStorage', '$location'];

	exports.default = ScreensController;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ScreensService =

	/** @ngInject */
	function ScreensService() {
	  _classCallCheck(this, ScreensService);
	};

	//ScreensService.$inject = ['EmployeesResource'];

	exports.default = ScreensService;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _services = __webpack_require__(88);

	var _services2 = __webpack_require__(90);

	var _services3 = _interopRequireDefault(_services2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var services = angular.module('mod.admin.administration.services', []).component('services', _services.ServicesComponent).service('ServicesService', _services3.default).name;

	exports.default = services;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ServicesComponent = undefined;

	var _services = __webpack_require__(89);

	var _services2 = _interopRequireDefault(_services);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ServicesComponent = exports.ServicesComponent = {
	  controller: _services2.default,
	  templateUrl: 'app/modules/admin/administration/services/services.html'
	};

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ServicesController = function () {
	  /** @ngInject */
	  ServicesController.$inject = ["$rootScope", "$scope", "config", "AdministrationService", "ServicesResource", "OrganizationsResource", "EstablishmentsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "AgendasResource", "QueuesResource", "pageSizeOptions"];
	  function ServicesController($rootScope, $scope, config, AdministrationService, ServicesResource, OrganizationsResource, EstablishmentsResource, NgTableParams, $translate, toastr, $mdDialog, $localStorage, $location, AgendasResource, QueuesResource, pageSizeOptions) {
	    var _this = this;

	    _classCallCheck(this, ServicesController);

	    // private
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$localStorage = $localStorage;
	    this.isSuperAdmin = this.$localStorage.currentUser.role !== "superadmin" ? true : false;
	    this.currentRole = this.$localStorage.currentRole;
	    this.establishmentId = config.ESTABLISHMENT_ID;
	    this.isPre = config.IS_PRE;
	    this.ServicesResource = ServicesResource;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.OrganizationsResource = OrganizationsResource;
	    this.AdministrationService = AdministrationService;

	    this.AgendasResource = AgendasResource;
	    this.QueuesResource = QueuesResource;

	    this.config = config;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.$mdDialog = $mdDialog;
	    this.isAdding = false;
	    this.fail = false;
	    this.servicesSelected = [];
	    this.hasServicesSelected = false;
	    this.current_service = {
	      identifier: "",
	      _id: "",
	      description: "",
	      display: "",
	      pattern: "",
	      asigned: ""
	    };
	    this.bokititServicebyId = {};
	    this.bokititServicesArray = [];

	    this.service = {};
	    this.rowFormServ = {};
	    this.typeInput = "";

	    this.cancel = cancel;
	    this.showDeleteConfirm = showDeleteConfirm;
	    this.showDisassignConfirm = showDisassignConfirm;
	    this.del = del;
	    this.deletePromotion = deletePromotion;
	    this.save = save;
	    this.updateIcons = updateIcons;
	    this.add = add;
	    this.resetRow = resetRow;
	    this._preventMinus = _preventMinus;
	    this.count = 5;
	    this.pageSizeOptions = pageSizeOptions;

	    this.pageSizeOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
	    this.arrIns = [];
	    this.arrInsService = [];
	    this.loadCenter = false;
	    this.editServ = false;
	    this.previewImg = {};
	    this.new_service = {
	      turnos: false,
	      citas: false,
	      promo: {}
	    };
	    this.errImage = {
	      btn_img: false,
	      promo_image: false
	    };
	    var img_types = ["image/jpeg", "image/png", "image/jpg"];
	    // Default values
	    this.showCitas = false;
	    this.showTurnos = true;
	    this.showParking = false;
	    this.new_service.turnos = true;
	    this.servicesSelection = [];
	    this.service_selection = [];
	    this.servicesList = [];
	    this.ChildsIdsArr = [];

	    // Control of sidemenu page
	    var url = $location.url().substring(1).toUpperCase();
	    this.$rootScope.currentPage = currentPage(1);
	    /**
	     * Retrieves the value of the specified index from the current URL.
	     *
	     * @param {number} index - The index of the URL segment to retrieve.
	     *
	     * @returns {string} - The value of the URL segment at the specified index.
	     */
	    function currentPage(index) {
	      var split_url = url.split("/");
	      return split_url[index];
	    }
	    /**
	     * Handles the change in page size and updates the table parameters accordingly.
	     *
	     * @param {number} newPageSize - The new page size to be set.
	     *
	     * @returns {void}
	     */
	    var pageSizeChanged = function pageSizeChanged(newPageSize) {
	      _this.tableParams.count(newPageSize);
	      _this.count = newPageSize;
	    };
	    /**
	     * Creates a new NgTableParams instance using the provided services data.
	     *
	     * @param {Array} services_data - Data used to initialize the NgTableParams instance.
	     *
	     * @returns {Object} - The NgTableParams instance created.
	     */
	    function _createUsingFullOptions(services_data) {
	      var initialParams = {
	        count: this.count
	      };
	      var self = this;
	      var initialSettings = {
	        counts: [],
	        paginationMaxBlocks: 4,
	        paginationMinBlocks: 2,
	        dataset: services_data,

	        filterOptions: {
	          filterComparator: function filterComparator(actual, expected) {
	            if (expected === undefined || expected === null || expected === '') return true;
	            var exp = String(expected).trim().toLowerCase();
	            var act = String(actual).trim().toLowerCase();
	            if (exp === 'true' || exp === 'false') return act === exp;
	            try {
	              var enabledLabel = (self._statusEnabledLabel || 'activo').toLowerCase();
	              var disabledLabel = (self._statusDisabledLabel || 'no activo').toLowerCase();
	              if (exp === enabledLabel) return act === 'true';
	              if (exp === disabledLabel) return act === 'false';
	            } catch (e) {
	              console.log('Error in filter comparator', e);
	            }
	            return act.indexOf(exp) !== -1;
	          }
	        }
	      };
	      this.tableParams = new NgTableParams(initialParams, initialSettings);
	      return this.tableParams;
	    }
	    /**
	     * Creates a new NgTableParams instance using the provided data (arrIns).
	     *
	     * @returns {Object} - The NgTableParams instance created.
	     */
	    function _createUsing() {
	      var initialParams = {
	        count: 2 // initial page size
	      };
	      var initialSettings = {
	        // page size buttons (right set of buttons in demo)
	        counts: [],
	        // determines the pager buttons (left set of buttons in demo)
	        dataset: this.arrIns
	      };
	      this.tableParam = new NgTableParams(initialParams, initialSettings);
	      return this.tableParam;
	    }
	    /**
	     * Adds a new template to the NgTableParams dataset, resetting sorting and pagination.
	     *
	     * @param {Object} new_template - The new template to be added.
	     *
	     * @returns {void}
	     */
	    function add(new_template) {
	      this.tableParams.settings().dataset.unshift(new_template);
	      this.tableParams.sorting({});
	      this.tableParams.page(1);
	      this.tableParams.reload();
	    }
	    /**
	     * Cancels the changes made to a row by resetting it to its original state.
	     *
	     * @param {Object} row - The row whose changes need to be canceled.
	     *
	     * @returns {void}
	     */
	    function cancel(row) {
	      var originalRow = this.resetRow(row);
	      angular.extend(row, originalRow);
	    }
	    /**
	     * Shows a delete confirmation dialog and calls the deleteService function if accepted.
	     *
	     * @param {Object} ev - The event triggering the delete confirmation.
	     *
	     * @returns {void}
	     */
	    function showDeleteConfirm(ev) {
	      var current_scope = this;
	      hideElement(ev.id);
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        current_scope.deleteService(ev);
	      }, function () {
	        console.log("You decided to keep it.");
	      });
	    }
	    /**
	     * Shows a disassign confirmation dialog and calls the disassignService function if accepted.
	     *
	     * @param {Object} location - The location for which disassign confirmation is requested.
	     * @param {Object} ev - The event triggering the disassign confirmation.
	     *
	     * @returns {void}
	     */
	    function showDisassignConfirm(location, ev) {
	      var current_scope = this;
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        var queueTypeId = "";
	        current_scope.current_service.establishments.map(function (queueType) {
	          if (queueType.locationId == location.id) queueTypeId = queueType.id;
	        });
	        current_scope.disassignService(queueTypeId);
	      }, function () {
	        console.log("You decided to keep it.");
	      });
	    }

	    function deletePromotion(row) {
	      var $this = this;
	      var index = $this.new_service.promo_links.indexOf(row);
	      if (index > -1) {
	        $this.new_service.promo_links.splice(index, 1);
	        this.promoTableParams.reload();
	      }
	    }
	    /**
	     * Deletes a row from the NgTableParams dataset and reloads the table, handling pagination.
	     *
	     * @param {Object} row - The row to be deleted.
	     *
	     * @returns {void}
	     */
	    function del(row) {
	      var $this = this;
	      var main_dataset = this.tableParams.settings().dataset;
	      var originalData = "";
	      angular.forEach(this.tableParams.settings().dataset, function (value, key) {
	        if (angular.equals(row, value)) {
	          main_dataset.splice(key, 1);
	          originalData = angular.copy(main_dataset);
	        }
	      });
	      this.originalData = originalData;
	      this.tableParams.reload().then(function (data) {
	        if (data.length === 0 && $this.tableParams.total() > 0) {
	          $this.tableParams.page($this.tableParams.page() - 1);
	          $this.tableParams.reload();
	        }
	      });
	    }
	    /**
	     * Updates icons for a specified row based on the provided state and type.
	     *
	     * @param {Object} row - The row for which icons are to be updated.
	     * @param {Object} rowForm - The form associated with the row.
	     * @param {boolean} state - The new state for the icons.
	     * @param {string} type - The type of icons to be updated ("asigned" or other).
	     *
	     * @returns {void}
	     */
	    function updateIcons(row, rowForm, state, type) {
	      if (type === "asigned") {
	        row.asigned = state;
	      } else {
	        row.isVisible = state;
	      }
	      this.save(row, rowForm);
	    }
	    /**
	     * Saves changes made to a row, updating service information.
	     *
	     * @param {Object} row - The row containing the changes to be saved.
	     *
	     * @returns {void}
	     */
	    function save(row) {
	      // const organizationName = this.$localStorage.currentOrganization.name;
	      var organizationName = this.$localStorage.selectedOrganization.name;
	      console.log("Row on save", row);

	      if (organizationName) {
	        var normal_name = organizationName.replace(new RegExp(" ", "g"), "_");

	        if (row.btn_img && row.btn_img.filetype) {
	          row.btn_img.organizationName = normal_name;
	          row.btn_img.type = row.btn_img.filetype.split("/")[1];
	        }
	        if (row.promo && _typeof(row.promo) === 'object' && 'organizationName' in row.promo) {
	          row.promo.organizationName = normal_name;
	        }
	      }

	      var originalRow = this.resetRow(row);

	      angular.extend(originalRow, row);
	      this.isAdding = false;
	      this.updateService(originalRow, row);
	    }
	    /**
	     * Resets a row to its original state, cancelling any changes made.
	     *
	     * @param {Object} row - The row to be reset.
	     *
	     * @returns {Object} - The original state of the row.
	     */
	    function resetRow(row) {
	      var return_value = row;
	      angular.forEach(this.originalData, function (value) {
	        if (row.id === value.id) {
	          return_value = angular.copy(value);
	        }
	      });
	      row.isEditing = false;
	      return return_value;
	    }
	    /**
	     * Prepares the service form for editing by copying the provided service data.
	     *
	     * @param {Object} serv - The service data to be edited.
	     *
	     * @returns {void}
	     */
	    var _showServiceFormEdit = function _showServiceFormEdit(serv) {
	      _this.new_service = angular.copy(serv);
	      var type = ["citas", "turnos", "parking"].find(function (t) {
	        return _this.new_service[t];
	      });
	      if (type) {
	        _this._checkCitas(_this.new_service[type], type);
	      }

	      if (serv.btn_img_link) {
	        _this.new_service.btn_img = serv.btn_img_link;
	        _this.new_service.btn_img_link = serv.btn_img_link;
	      } else if (serv.btn_img && serv.btn_img.base64) {
	        _this.new_service.btn_img = "data:image/jpeg;base64," + serv.btn_img.base64 + ";";
	      }

	      _this.new_service.pattern = serv.pattern || '';

	      if (serv.promo_links) {
	        _this.new_service.promo = {
	          namePromo: "",
	          descriptionPromo: "",
	          formUrl: "",
	          rediUrl: ""
	        };
	        _this.new_service.promo_link = serv.promo_link;
	        _this.showPromotions(_this.new_service.promo_links || []);
	      } else {
	        _this.showPromotions([]);
	      }

	      return true;
	    };
	    /**
	     * Displays the service form dialog, optionally for editing an existing service.
	     *
	     * @param {Object} ev - The event triggering the dialog display, used for positioning.
	     *
	     * @returns {void}
	     */
	    function _showServiceForm() {
	      var _this2 = this;

	      var ev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var parent = this;
	      parent.editServ = (typeof ev === "undefined" ? "undefined" : _typeof(ev)) === 'object' && Object.keys(ev).length > 0;
	      console.log(ev);
	      console.log(parent);

	      if (parent.editServ) {
	        hideElement(ev.id);
	        parent._showServiceFormEdit(ev);
	      }
	      if (!ev.citas && !ev.turnos && !ev.parking) {
	        var autoclick = setInterval(function () {
	          if (document.getElementById('selectTurnos')) {
	            document.getElementById('selectTurnos').click();
	            window.clearInterval(autoclick);
	          }
	        }, 200);
	      }
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#newService",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this2;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        parent.editServ = false;
	        parent.previewImg = {};
	        parent.errImage = {
	          btn_img: false,
	          promo_image: false
	        };
	        var errNameElement = document.getElementById("err_name");
	        if (errNameElement) {
	          errNameElement.style.display = "none";
	        }
	        errNameElement.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        if (document.getElementById("err_display")) document.getElementById("err_display").style.display = "none";
	        if (document.getElementById("err_advice_number")) document.getElementById("err_advice_number").style.display = "none";
	        if (document.getElementById("err_pattern")) document.getElementById("err_pattern").style.display = "none";
	        if (document.getElementById("err_description")) document.getElementById("err_description").style.display = "none";
	        parent._closeDialog();
	      }, function () {
	        parent.previewImg = {};
	        parent.errImage = {
	          btn_img: false,
	          promo_image: false
	        };
	        parent.editServ = false;
	        parent._closeDialog();
	      });
	    }
	    /**
	     * The function `_showDetailDialog` is used to display a dialog box in an AngularJS application.
	     * @param ev - The `ev` parameter is the event object that triggered the function. It is typically
	     * passed as an argument when calling the function from an event handler. The event object contains
	     * information about the event, such as the target element, mouse coordinates, and other
	     * event-specific details. In this case, it is
	     */
	    function _showDetailDialog(ev) {
	      var _this3 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#dialog_detail_service",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this3;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        console.log("You resolve the dialog.");
	      }, function () {
	        console.log("You cancelled the dialog.");
	      });
	    }

	    /**
	     * The above code is a JavaScript function that shows and handles dialog boxes for assigning
	     * services and displaying service details, as well as validating and previewing image files.
	     * @param name - The parameter "name" is a string that represents the name of a field or property.
	     * @returns The code snippet does not have a return statement. It consists of several functions and
	     * a constant.
	     */
	    function _detailAsignedService(ev) {
	      var _this4 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#dialog_detail_asigned_service",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this4;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        console.log("You resolve the dialog.");
	      }, function () {
	        console.log("You cancelled the dialog.");
	      });
	    }
	    /**
	     * Displays the detailed information of an assigned Bokitit service in a dialog.
	     *
	     * @param {Object} ev - The event triggering the dialog display, used for positioning.
	     *
	     * @returns {void}
	     */
	    function _detailAsignedBokititService(ev) {
	      var _this5 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#dialog_bokitit_asigned_service",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this5;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        console.log("You resolve the dialog.");
	      }, function () {
	        console.log("You cancelled the dialog.");
	      });
	    }
	    /**
	     * Displays the assign service form dialog, fetching establishments by organization before display.
	     *
	     * @param {Object} ev - The event triggering the dialog display, used for positioning.
	     *
	     * @returns {void}
	     */
	    function _showAsignServiceForm(ev) {
	      var _this6 = this;

	      this.getEstablismentByOrganization();
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#asignDialog",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this6;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        console.log("You resolve the dialog.");
	      }, function () {
	        console.log("You cancelled the dialog.");
	      });
	    }
	    /**
	     * Displays the assign Bokitit service form dialog, fetching Bokitit services by organization before display.
	     *
	     * @param {Object} ev - The event triggering the dialog display, used for positioning.
	     *
	     * @returns {void}
	     */
	    function _showAsignServiceBokititForm(ev) {
	      var _this7 = this;

	      console.log("evev", ev);
	      this.getServicesBokititByOrganization();

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#asignDialogBokitit",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this7;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        console.log("You resolve the dialog.");
	      }, function () {
	        console.log("You cancelled the dialog.");
	      });
	    }

	    /**
	    * Displays the assign service to asign the service into other service form dialog, fetching establishments by organization before display.
	    *
	    * @param {Object} ev - The event triggering the dialog display, used for positioning.
	    *
	    * @returns {void}
	    */
	    function _showAsignServiceToService(ev) {
	      var _this8 = this;

	      // this.getEstablismentByOrganization();
	      this.showingServiciesIfServiceSelection();

	      var $this = this;
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#asignServiceToService",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this8;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        console.log("You resolve the dialog.");
	        $this.arrInsService = [];
	        $this.assigned_service = {};
	        $this.servicesSelected = [];
	        $this.hasKiosksSelected = false;
	        $this.kiosksSelected = [];
	        $this.ChildsIdsArr = [];
	      }, function () {
	        console.log("You cancelled the dialog.");
	        $this.arrInsService = [];
	        $this.ChildsIdsArr = [];
	        $this.servicesSelected = [];
	        $this.assigned_service = {};
	        $this.hasKiosksSelected = false;
	        $this.kiosksSelected = [];
	      });
	    }

	    function showingServiciesIfServiceSelection() {
	      var _this9 = this;

	      var fatherServiceId = this.servicesSelected[0].id;
	      var childQueueIds = (this.servicesSelected[0].queueId || []).map(function (q) {
	        return q.queueId;
	      });

	      this.servicesSelection = this.servicesList.filter(function (service) {
	        return !childQueueIds.includes(service.id) && service.id !== fatherServiceId;
	      });

	      var serviceChilds = this.servicesList.filter(function (service) {
	        return childQueueIds.includes(service.id);
	      });

	      serviceChilds.map(function (sl) {
	        _this9.arrInsService.push({
	          name: sl.name,
	          queueId: sl.id

	        });
	      });
	    }

	    /**
	     * Maps internal attribute names to user-friendly display names.
	     *
	     * @param {string} name - The internal attribute name.
	     *
	     * @returns {string} - The corresponding user-friendly display name.
	     */
	    var showNames = function showNames(name) {
	      switch (name) {
	        case "name":
	          return 'Nombre';
	        case "display":
	          return 'Nombre a mostrar';
	        case "advice_number":
	          return 'Clientes de preaviso';
	        case "pattern":
	          return 'Letra de turno';
	        case "description":
	          return 'Descripción';
	        default:
	          return "";
	      }
	    };
	    /**
	     * Validates the image attributes, checking size and type, and updates the form validation state.
	     *
	     * @param {Object} value - The image file attributes, including filesize and filetype.
	     * @param {string} id - The identifier of the image input element.
	     * @param {Object} rowForm - The form associated with the row.
	     *
	     * @returns {void}
	     */
	    function _validateImage(value, id, rowForm) {
	      var size = value.filesize;
	      var type = value.filetype;

	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);

	      if (size > 5000000) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display.block;
	        errName.style.color = "rgba(219, 72, 73, 1)";
	        errName.innerHTML = $translate.instant("app.establishments.ERR_IMG_SIZE");
	        rowForm.$invalid = true;
	      } else if (img_types.indexOf(type) < 0) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.style.color = "rgba(219, 72, 73, 1)";
	        errName.innerHTML = $translate.instant("app.establishments.ERR_IMG_TYPE");
	        rowForm.$invalid = true;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        rowForm.$invalid = false;
	        previewImageFile(value, id);
	      }
	    }
	    /**
	     * Validates the image attributes, updates the form validation state, and previews the image.
	     *
	     * @param {Object} value - The image file attributes, including filesize and filetype.
	     * @param {string} id - The identifier of the image input element.
	     * @param {Object} form - The form associated with the row.
	     *
	     * @returns {void}
	     */
	    var previewImageFile = function previewImageFile(value, id) {
	      var file = value.base64;

	      if (id === "btn_img") {
	        _this.previewImg.btn_img = 'data:image/jpg;base64,' + file;
	      }
	    };
	    /**
	     * Opens the file input dialog associated with the specified element by triggering a click event.
	     *
	     * @param {string} name - The identifier of the file input element.
	     *
	     * @returns {void}
	     */
	    function abrirArchivo(name) {
	      document.getElementById(name).click();
	    }

	    /**
	     * Prevent '-' keypress in numeric inputs.
	     * @param {Event} evt
	     */
	    function _preventMinus(evt) {
	      try {
	        var key = evt.key || String.fromCharCode(evt.which || evt.keyCode);
	        if (key === '-' || key === 'Subtract') {
	          evt.preventDefault && evt.preventDefault();
	          return false;
	        }
	      } catch (e) {
	        console.error(e);
	      }
	    }
	    /**
	     * Validates a numeric input, checking for non-negative numbers and a limit of 99.
	     *
	     * @param {string} value - The numeric value to be validated.
	     * @param {string} id - The identifier of the input element.
	     * @param {Object} rowForm - The form associated with the row.
	     *
	     * @returns {void}
	     */
	    var validateNumbers = function validateNumbers(value, id, rowForm) {
	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);
	      var name = showNames(id);

	      var regex = /^[0-9]+$/;
	      if (value === undefined || value === null || typeof value === 'string' && value.trim() === '') {
	        try {
	          if (name2 && name2.parentElement && name2.parentElement.parentElement) {
	            name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          }
	        } catch (e) {}
	        if (errName) {
	          errName.style.display = "block";
	          errName.style.color = "red";
	          errName.innerHTML = 'Debe ser mayor a 0';
	        }
	        if (rowForm !== undefined) rowForm.$invalid = true;
	        try {
	          if (_this.newServiceForms && _this.newServiceForms[id]) _this.newServiceForms[id].$valid = false;
	        } catch (e) {}
	        return;
	      }
	      if (!regex.test(value)) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.innerHTML = "El campo " + name + " no puede contener n\xFAmero negativos";
	        errName.style.color = "red";
	        rowForm.$pristine = true;
	        _this.newServiceForms[id].$valid = false;
	      } else if (value > 99) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.innerHTML = "El campo " + name + " debe ser menor a 100";
	        errName.style.display = "block";
	        errName.style.color = "red";
	        rowForm.$pristine = true;
	        _this.newServiceForms[id].$valid = false;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        rowForm.$pristine = false;
	        _this.newServiceForms[id].$valid = true;
	      }
	    };
	    /**
	     * Validates a pattern input, checking for alphanumeric characters and a specific length range.
	     *
	     * @param {string} value - The pattern value to be validated.
	     * @param {string} id - The identifier of the input element.
	     * @param {Object} rowForm - The form associated with the row.
	     *
	     * @returns {void}
	     */
	    var validatePatterns = function validatePatterns(value, id, rowForm) {
	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);

	      if (value !== undefined) value = _this.new_service.pattern.toUpperCase();
	      try {
	        var cleaned = (value || '').toString().replace(/[^A-Z]/g, '');
	        if (cleaned !== (value || '')) {

	          if (name2) name2.value = cleaned;
	          _this.new_service.pattern = cleaned;
	          value = cleaned;
	        }
	      } catch (e) {
	        console.error(e);
	      }

	      var resAlphaNum = /^[A-Z]+$/;

	      if (!resAlphaNum.test(value)) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.style.color = "red";
	        errName.innerHTML = $translate.instant("app.services.PATTERN_ALPHANUM");
	        rowForm.$pristine = true;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        rowForm.$pristine = false;
	      }
	      if (value !== undefined) {
	        if (value.length > 3 || value.length < 1) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = $translate.instant("app.services.PATTERN_LENGTH");
	          errName.style.display = "block";
	          errName.style.color = "red";
	          rowForm.$pristine = true;
	          _this.newServiceForms[id].$valid = false;
	        } else {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errName.style.display = "none";
	          rowForm.$pristine = false;
	          _this.newServiceForms[id].$valid = true;
	        }
	      } else {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.innerHTML = $translate.instant("app.services.PATTERN_LENGTH");
	        errName.style.display = "block";
	        errName.style.color = "red";
	        rowForm.$pristine = true;
	      }
	    };
	    /**
	     * Validates a description input, checking for valid characters, length, and additional validations
	     * based on the specific input field (e.g., advice_number or pattern).
	     *
	     * @param {string} value - The description value to be validated.
	     * @param {string} id - The identifier of the input element.
	     * @param {Object} rowForm - The form associated with the row.
	     *
	     * @returns {void}
	     */
	    function _validateDescription(value, id, rowForm) {
	      var re2 = /^(?!\s{2,}|.*\s$).*$/;
	      var resAlphaNum = /^[a-zA-ZáéíóúñÁÉÍÓÚÑ@() ]+$/;
	      var regex1 = /^(?!\s|.*\s$).*$/;
	      var regex2 = /^([a-zA-Z.,-_áéíóúñÁÉÍÓÚÑ()]+[,.]?[ ]?|[a-zA-Z.,-_áéíóúñÁÉÍÓÚÑ()]+['-]?)+$/g;

	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);
	      if (id === 'advice_number') {
	        validateNumbers(value, id, rowForm);
	        return;
	      }
	      if (!name2 || name2.value === undefined || name2.value.trim() === '') {
	        if (id === 'advice_number') {
	          if (name2 && name2.parentElement && name2.parentElement.parentElement) {
	            name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          }
	          if (errName) {
	            errName.style.display = "block";
	            errName.style.color = "red";
	            errName.innerHTML = 'Debe ser mayor a 0';
	          }
	          try {
	            if (this.newServiceForms && this.newServiceForms[id]) this.newServiceForms[id].$valid = false;
	          } catch (e) {
	            console.error(e);
	          }
	          if (rowForm !== undefined) rowForm.$invalid = true;
	          return;
	        }

	        if (name2 && name2.parentElement && name2.parentElement.parentElement) {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        }
	        if (errName) {
	          errName.style.display = "none";
	        }
	        try {
	          if (this.newServiceForms && this.newServiceForms[id]) this.newServiceForms[id].$valid = true;
	        } catch (e) {
	          console.error(e);
	        }
	        if (rowForm !== undefined) rowForm.$invalid = false;
	        return;
	      }
	      var colorErro = 'rgba(219, 72, 73, 1)';
	      var name = showNames(id);

	      if (!resAlphaNum.test(value) || !regex1.test(value) || !regex2.test(value) || !re2.test(name2.value)) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.innerHTML = "El campo " + name + " no puede contener caracteres especiales";
	        errName.style.color = colorErro;
	        rowForm.$pristine = true;
	        this.newServiceForms[id].$valid = false;
	      } else if (id === "descriptionPromo") {
	        if (value.length > 150 || value.length < 10) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = "El campo " + name + " debe tener entre 10 y 150 caracteres";
	          errName.style.display = "block";
	          errName.style.color = colorErro;
	          rowForm.$pristine = true;
	          this.newServiceForms[id].$valid = false;
	        } else {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errName.style.display = "none";
	          rowForm.$pristine = false;
	          this.newServiceForms[id].$valid = true;
	        }
	      } else if (id === "description") {
	        if (value.length > 150 || value.length < 3) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = "El campo " + name + " debe tener entre 3 y 150 caracteres";
	          errName.style.display = "block";
	          errName.style.color = colorErro;
	          rowForm.$pristine = true;
	          this.newServiceForms[id].$valid = false;
	        } else {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errName.style.display = "none";
	          rowForm.$pristine = false;
	          this.newServiceForms[id].$valid = true;
	        }
	      } else if (id === "display") {
	        if (name2.value.length > 0 && (name2.value.length < 3 || name2.value.length > 100)) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = "El campo " + name + " debe tener entre 3 y 100 caracteres";
	          errName.style.display = "block";
	          errName.style.color = colorErro;
	          rowForm.$pristine = true;
	          if (this.newServiceForms && this.newServiceForms[id]) this.newServiceForms[id].$valid = false;
	        } else {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errName.style.display = "none";
	          rowForm.$pristine = false;
	          if (this.newServiceForms && this.newServiceForms[id]) this.newServiceForms[id].$valid = true;
	        }
	      } else if (name2.value.length > 50 || name2.value.length < 3) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.innerHTML = "El campo " + name + " debe tener entre 3 y 50 caracteres";
	        errName.style.display = "block";
	        errName.style.color = colorErro;
	        rowForm.$pristine = true;
	        this.newServiceForms[id].$valid = false;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        rowForm.$pristine = false;
	        this.newServiceForms[id].$valid = true;
	      }

	      if (id === "advice_number") {
	        return validateNumbers(value, id, rowForm);
	      }

	      if (id === "pattern") {
	        return validatePatterns(value, id, rowForm);
	      }
	    }
	    /**
	     * Sends the service data for creation or update based on form validation.
	     *
	     * @param {Object} result - The service data to be sent.
	     * @param {Object} rowForm - The form associated with the row.
	     *
	     * @returns {void}
	     */
	    function _sendService(result, rowForm) {
	      var valid = Object.values(this.newServiceForms.$$controls).map(function (control) {
	        return control.$valid;
	      });

	      if (this.newServiceForms.$invalid) {
	        Object.values(this.newServiceForms.$$controls).forEach(function (control) {
	          control.$touched = true;
	        });
	        return;
	      }
	      if (valid.includes(false)) {
	        return;
	      }
	      this.organizationInUse = this.$localStorage.selectedOrganization.name;
	      result.organizationName = this.organizationInUse.replace(new RegExp(" ", "g"), "_");
	      // Default values
	      result.asigned = false;
	      // if (result.btn_img) {
	      //   result.btn_img.organizationName = this.organizationInUse.replace(
	      //     new RegExp(" ", "g"),
	      //     "_"
	      //   );
	      //   result.btn_img.type = result.btn_img.filetype.split("/")[1];
	      // }
	      // if (result.promo) {
	      //   result.promo.organizationName = this.organizationInUse.replace(
	      //     new RegExp(" ", "g"),
	      //     "_"
	      //   );
	      //   result.promo.type = result.promo.filetype.split("/")[1];
	      // }
	      this.editServ ? this.save(result, rowForm) : this.createService(result);
	      $mdDialog.cancel();
	    }
	    /**
	     * Validates input to ensure it does not contain leading, trailing, or consecutive spaces.
	     *
	     * @param {Object} event - The event object containing information about the triggered event.
	     * @param {Object} form - The form associated with the input.
	     *
	     * @returns {void}
	     */
	    var _validateSpaces = function _validateSpaces(event, form) {
	      var id = event && event.target && event.target.id;
	      setTimeout(function () {
	        var re2 = /^(?!\s|.*\s$).*$/;
	        var resAlpha = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s[a-zA-ZÀ-ÿ\u00f1\u00d1]+)*$/;
	        var item = id ? document.getElementById(id) : null;
	        var errApi = id ? document.getElementById("err_" + id) : null;
	        if (!item || item.value === undefined || item.value.trim() === '') {

	          try {
	            if (item && item.classList && item.classList.contains('md-input-invalid')) {
	              item.classList.remove('md-input-invalid');
	            }
	          } catch (e) {}
	          try {
	            if (item && item.parentElement) {
	              item.parentElement.classList && item.parentElement.classList.remove('md-input-invalid');
	              if (item.parentElement.parentElement) {
	                item.parentElement.parentElement.classList && item.parentElement.parentElement.classList.remove('md-input-invalid');
	                if (item.parentElement.parentElement.children && item.parentElement.parentElement.children[0]) {
	                  item.parentElement.parentElement.children[0].classList && item.parentElement.parentElement.children[0].classList.remove('md-input-invalid');
	                }
	              }
	            }
	          } catch (e) {}
	          if (errApi) {
	            errApi.style.display = "none";
	          }
	          if (form !== undefined) form.$invalid = false;
	          _this.errorInputs = false;
	          return;
	        }

	        if (!resAlpha.test(item.value) || !re2.test(item.value)) {
	          try {
	            item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          } catch (e) {}
	          if (errApi) {
	            errApi.style.display = "block";
	            errApi.innerHTML = $translate.instant("app.establishments.err_spaces");
	            errApi.style.color = "rgba(219, 72, 73, 1)";
	          }
	          form !== undefined ? form.$invalid = true : null;
	          _this.errorInputs = true;
	        } else {
	          if (form !== undefined) form.$invalid = false;
	          try {
	            item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          } catch (e) {}
	          if (errApi) errApi.style.display = "none";
	          _this.errorInputs = false;
	        }
	      }, 0);
	    };
	    /**
	     * Assigns selected services to specified establishments.
	     *
	     * @param {Object} establishments - Object containing information about the establishments.
	     *
	     * @returns {void}
	     */
	    function _asignService(establishments) {
	      var $this = this;
	      this.hasServicesSelected = false;
	      angular.forEach(establishments.center, function (centerId) {
	        angular.forEach($this.servicesSelected, function (value) {
	          console.log('value', value);
	          // Creamos el objeto limpio de variables innecesarias
	          var clean_queue_object = {};
	          angular.forEach(value, function () {
	            clean_queue_object.name = value.name;
	            clean_queue_object.display = value.display;
	            clean_queue_object.description = value.description;
	            clean_queue_object.queueId = value.id;
	            clean_queue_object.previousNotificationLimit = value.advice_number > 0 ? value.advice_number : null;
	            clean_queue_object.availableTurnsLimit = null;
	            clean_queue_object.locationId = centerId;
	            clean_queue_object.isVisible = value.isVisible;
	            if (value.serviceType) {
	              clean_queue_object.serviceType = value.serviceType;
	            }
	            if (value.btn_img_link) clean_queue_object.btn_img_link = value.btn_img_link;
	            if (value.promo_link) clean_queue_object.promo_link = value.promo_link;
	          });
	          console.log('clean_queue_object', clean_queue_object);
	          $this.ServicesResource.asignQueue({ type: "queueTypes" }, clean_queue_object).$promise.then(function () {
	            $this.new_service = {};
	            $this.asignServiceForm.$setPristine();
	            $this.asignServiceForm.$setUntouched();
	            value.asigned = true;
	            value.Selected = false;
	            $this.ServicesResource.update({ type: "queues", id: value.id }, value).$promise.then(function () {
	              $this.$translate("app.services.SUCCESS_UPDATESERVICE").then(function (successMsg) {
	                $this.toastr.success(successMsg);
	              });
	            }).catch(function (error) {
	              console.log(error);
	              $this.$translate("app.services.ERROR_UPDATESERVICE").then(function (errorMsg) {
	                $this.toastr.error(errorMsg, "Error---------1");
	              });
	            });
	            $this.servicesSelected = [];
	          }).catch(function (error) {
	            console.log(error);
	            $this.$translate("app.services.ERROR_ASIGNSERVICE").then(function (errorMsg) {
	              $this.toastr.error(errorMsg, "Error-------2");
	            });
	          });
	        });
	      });
	      $mdDialog.cancel();
	    }
	    function _asignServiceToService() {
	      var _this10 = this;

	      var $this = this;
	      this.hasServicesSelected = false;

	      var fatherIdSelected = $this.servicesSelected[0].id;

	      $this.ServicesResource.update({ type: "queues", id: fatherIdSelected }, { id: fatherIdSelected, queueId: this.arrInsService }).$promise.then(function (res) {
	        _this10.ChildsIdsArr = [];
	        _this10.getServicesByOrganization(_this10.$localStorage.currentRole, _this10.organizationId);
	        $this.$translate("app.services.SUCCESS_UPDATESERVICE").then(function (successMsg) {
	          $this.toastr.success(successMsg);
	        });
	      }).catch(function (error) {
	        console.log(error);
	        $this.$translate("app.services.ERROR_UPDATESERVICE").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, "Error---------1");
	        });
	      });
	      $this.servicesSelected[0].Selected = false;
	      $this.servicesSelected = [];
	      $this.asignServiceToService.$setPristine();
	      $this.asignServiceToService.$setUntouched();
	      $mdDialog.cancel();
	    }
	    /**
	     * Assigns selected Bokitit services to specified establishments.
	     *
	     * @param {Array} selects - Array containing the selected services.
	     *
	     * @returns {void}
	     */
	    function _asignServiceBokitit(selects) {
	      var $this = this;
	      this.hasServicesSelected = false;

	      var cont = 0;

	      angular.forEach($this.servicesSelected, function (value) {
	        $this.QueuesResource.asignedServicesBokitit({ id: value.id }, {
	          services: selects
	        }).$promise.then(function () {
	          if ($this.servicesSelected.length == cont) {
	            $this.toastr.info("Services of bokitit asigned!", "Info");
	          }

	          $this.servicesSelected = [];
	          $this.servicesBokititSelect = [];
	          value.Selected = false; // Quuit all checkeds
	          value.hasBokititServices = true; // Is asigned service of bokitit
	        }).catch(function (error) {
	          console.log(error);
	          $this.toastr.error("Services of bokitit not asigned" + value.name + "!", "Error");
	        });

	        cont++;
	      });

	      $this.asignServiceFormB.$setPristine();
	      $this.asignServiceFormB.$setUntouched();
	      $mdDialog.cancel();
	    }
	    /**
	     * Displays a confirmation dialog to disassign a Bokitit service.
	     *
	     * @param {string} idService - The ID of the Bokitit service to disassign.
	     * @param {Event} ev - The event that triggered the dialog.
	     *
	     * @returns {void}
	     */
	    function _showDisassignBookititServiceDialog(idService, ev) {
	      var current_scope = this;
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        var queueId = "";
	        queueId = current_scope.current_service.id;
	        current_scope.disassignBokititService(idService, queueId);
	      }, function () {
	        console.log("You decided to keep it.");
	      }, console.log('funciona confirmar'));
	    }
	    /**
	     * Disassigns a Bokitit service from a queue.
	     *
	     * @param {string} service - The ID of the Bokitit service to disassign.
	     * @param {string} queue - The ID of the queue from which to disassign the service.
	     *
	     * @returns {void}
	     */
	    function disassignBokititService(service, queue) {
	      var $this = this;
	      //{type: 'queues'}, service
	      this.QueuesResource.deleteAsignedServicesBokitit({ idService: service, id: queue }).$promise.then(function () {
	        $this.$translate("app.administration.DELETE_OK").then(function (msg) {
	          $this.toastr.success(msg, $translate.instant("app.administration.DELETE_SUCCESS"));
	        });
	        $this.updateHasBokititServices();
	      }).catch(function (error) {
	        console.log(error);
	        $this.$translate("app.services.ERROR_DISASIGNSERVICE").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, $translate.instant("app.administration.DELETE_ERROR_MSG"));
	        });
	      });
	    }
	    /**
	     * Updates the status of having Bokitit services for the associated queue.
	     *
	     * @returns {void}
	     */
	    function updateHasBokititServices() {
	      var _this11 = this;

	      var ev = this;
	      this.QueuesResource.getQueuesById({
	        id: this.bokititServicebyId.establishments[0].queueId
	      }).$promise.then(function (result) {
	        if (result.bokititServices.length === 0) {
	          ev.QueuesResource.asignedQueueServices({ id: result.establishments[0].queueId }, {
	            hasBokititServices: false
	          }).$promise.then(function (result) {
	            console.log("RESULT disassignBokititService:", result);
	          }).catch(function (error) {
	            console.log(error);
	          });
	          return;
	        }
	      }).catch(function (error) {
	        console.log(error);
	        _this11.toastr.info("Api Keys not configured!", "Info");
	      });
	    }
	    /**
	     * Displays the detailed information of a service.
	     *
	     * @param {Object} service - The service object.
	     * @returns {void}
	     */
	    function _detailService(service) {
	      var _this12 = this;

	      this.getServicesBokititById(service.id);

	      if (service.isEditing !== true) {
	        this.current_service = service;
	        this.ServicesResource.getEstablishments({
	          id: service.id,
	          type: "queues",
	          option: "queueTypes",
	          filter: { include: "location" }
	        }).$promise.then(function (result) {
	          service.establishments = result;
	        }).catch(function (error) {
	          console.log(error);
	          _this12.$translate("app.services.ERROR_GETSERVICESBYESTABLISHMENT").then(function (errorMsg) {
	            _this12.toastr.error(errorMsg, "Error");
	          });
	        });
	        this._showDetailDialog();
	      }
	    }
	    /**
	     * Selects or deselects a service.
	     *
	     * @param {Object} result - The service object.
	     * @returns {void}
	     */
	    function _selectService(result) {
	      var elem_pos = this.servicesSelected.indexOf(result);
	      if (elem_pos !== -1) {
	        this.servicesSelected.splice(elem_pos, 1);
	      } else {
	        this.servicesSelected.push(result);
	      }
	      this.hasServicesSelected = false;
	      if (this.servicesSelected.length > 0) {
	        this.hasServicesSelected = true;
	      }
	    }
	    /**
	     * Closes the current dialog and resets the new_service object and form.
	     *
	     * @returns {void}
	     */
	    function _closeDialog() {
	      this.new_service = {};
	      this.newServiceForms.$setUntouched(); // this resets the form itself
	      $mdDialog.hide();
	    }
	    /**
	     * Cancels and closes the current dialog.
	     *
	     * @returns {void}
	     */
	    function _cancelDialog() {
	      $mdDialog.cancel();
	    }
	    /**
	     * Creates a new service.
	     *
	     * @param {Object} service - The service data to be created.
	     * @returns {void}
	     */
	    function createService(service) {
	      var _this13 = this;

	      var ev = this;
	      service.organizationId = this.organizationId;
	      ev.ServicesResource.create({ type: "queues" }, service).$promise.then(function (result) {
	        //great, now reset the form
	        ev.new_service = {}; // this resets the model
	        ev.newServiceForm.$setPristine(); // this resets the form itself
	        ev.newServiceForm.$setUntouched(); // this resets the form itself
	        ev.add(result);
	        _this13.$translate("app.services.SUCCESS_CREATE").then(function (successMsg) {
	          _this13.toastr.success(successMsg, _this13.$translate("app.SUCCESS"));
	        });
	        // window.location.reload();
	      }).catch(function (error) {
	        console.log(error);
	        _this13.$translate("app.services.ERROR_CREATESERVICE").then(function (errorMsg) {
	          _this13.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Updates an existing service with the provided data.
	     *
	     * @param {Object} originalRow - The original service data before the update.
	     * @param {Object} row - The updated service data.
	     * @returns {void}
	     */
	    function updateService(originalRow, row) {
	      var _this14 = this;

	      var current_service_data = row;
	      console.log(row);
	      row.serviceId = row.id;
	      var serviceId = row.serviceId;
	      this.ServicesResource.getServicesData({ type: "queues", id: serviceId, option: "queueTypes" }).$promise.then(function (result) {
	        result.forEach(function (queue) {
	          _this14.ServicesResource.update({ type: "queueTypes", id: queue.id }, { description: row.description }).$promise.then(function (result) {
	            // console.log('ServicesResource.update', result)
	            return;
	          }).catch(function (error) {
	            console.error('ServicesResource.update', error);
	            _this14.$translate("app.services.ERROR_UPDATESERVICE").then(function (errorMsg) {
	              _this14.toastr.error(errorMsg, "Error");
	            });
	          });
	        });
	      }).catch(function (error) {
	        console.log(error);
	      });

	      this.ServicesResource.update({ type: "queues", id: serviceId }, current_service_data).$promise.then(function (result) {
	        row.promo_link = row.promo_link != result.promo_link ? result.promo_link : row.promo_link;
	        row.btn_img = row.btn_img != result.btn_img ? result.btn_img : row.btn_img;
	        angular.extend(originalRow, row);
	        _this14.$translate("app.services.SUCCESS_UPDATESERVICE").then(function (msg) {
	          _this14.toastr.success(msg);
	        });
	        _this14._closeDialog();
	        // this.$onInit();
	        _this14.selectedItemChange(_this14.$localStorage.selectedOrganization);
	      }).catch(function (error) {
	        console.error(error);
	        _this14.$translate("app.services.ERROR_UPDATESERVICE").then(function (errorMsg) {
	          _this14.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Deletes the specified service.
	     *
	     * @param {Object} service - The service to be deleted.
	     * @returns {void}
	     */
	    function deleteService(service) {
	      var _this15 = this;

	      var $this = this;
	      this.ServicesResource.delete({ type: "queues", id: service.id }).$promise.then(function (result) {
	        console.log(result);
	        _this15.$translate("app.administration.DELETE_OK").then(function (msg) {
	          _this15.toastr.success(msg, $translate.instant("app.administration.DELETE_SUCCESS"));
	        });
	        $this.del(service);
	      }).catch(function (error) {
	        console.log(error);
	        _this15.$translate("app.services.ERROR_DELETESERVICE").then(function (errorMsg) {
	          _this15.toastr.error(errorMsg, $translate.instant("app.administration.DELETE_ERROR_MSG"));
	        });
	      });
	    }
	    /**
	     * Disassigns the specified service.
	     *
	     * @param {string} service - The ID of the service to be disassigned.
	     * @returns {void}
	     */
	    function disassignService(service) {
	      var $this = this;
	      //{type: 'queues'}, service
	      this.ServicesResource.delete({ type: "queueTypes", id: service }).$promise.then(function () {
	        $this.$translate("app.administration.DELETE_OK").then(function (msg) {
	          $this.toastr.success(msg, $translate.instant("app.administration.DELETE_SUCCESS"));
	        });
	      }).catch(function (error) {
	        console.log(error);
	        $this.$translate("app.services.ERROR_DISASIGNSERVICE").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, $translate.instant("app.administration.DELETE_ERROR_MSG"));
	        });
	      });
	    }
	    /**
	     * Toggles the display of options for the specified button based on its ID.
	     *
	     * @param {string} id - The ID of the button.
	     * @returns {void}
	     */
	    function _editOptionsButton(id) {
	      var opc = document.getElementById(id);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Opens a dialog to change the image for a service.
	     *
	     * @param {Object} ser - The service object.
	     * @param {Object} rowForm - The form object associated with the row.
	     * @param {string} typeInput - The type of input (e.g., "btn_img" or "promo").
	     * @returns {void}
	     */
	    function _changeImageDialog(ser, rowForm, typeInput) {
	      var _this16 = this;

	      this.typeInput = typeInput;
	      this.service = ser;
	      this.rowFormServ = rowForm;
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#changeImageDialog",
	        parent: angular.element(document.body),
	        controller: function controller() {
	          return _this16;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        console.log('You resolve the dialog.');
	      }, function () {
	        console.log('You cancelled the dialog.');
	      });
	    }
	    /**
	     * Adds instructions for a service and removes it from the services list.
	     *
	     * @param {Object} serv - The service object.
	     * @returns {void}
	     */
	    function _addInstructions(serv) {
	      var queue = JSON.parse(serv.queue);
	      var arrIns = {
	        name: queue.name,
	        queueId: queue.id
	      };
	      if (serv) {
	        this.arrInsService.push(arrIns);
	      }

	      this.assigned_service = {};

	      var index = this.servicesSelection.findIndex(function (item) {
	        return item.id === queue.id;
	      });
	      this.servicesSelection.splice(index, 1);
	    }
	    /**
	     * Deletes a service based on its queueId, updates the arrIns array, and refreshes the establishment list.
	     *
	     * @param {string} id - The queueId of the service to be deleted.
	     * @returns {void}
	     */
	    function _deleteServ(id) {
	      this.loadCenter = true;
	      var index = this.arrIns.findIndex(function (item) {
	        return item.queueId === id;
	      });
	      this.arrIns.splice(index, 1);
	      this.getEstablismentByOrganization();
	    }

	    function _deleteServChild(id) {

	      var $this = this;
	      this.loadCenter = true;
	      var index = this.arrInsService.findIndex(function (item) {
	        return item.queueId === id;
	      });
	      this.arrInsService.splice(index, 1);
	    }
	    /**
	     * Deletes an image link from the specified row, updates the row, and triggers the save operation.
	     *
	     * @param {object} row - The row from which to delete the image link.
	     * @param {object} rowForm - The form associated with the row.
	     * @param {string} type - The type of image link to delete (e.g., "promo_link").
	     * @returns {void}
	     */
	    function deleteImage(row, rowForm, type) {
	      if (type === "promo_link") {
	        row.promo_link = "";
	      }
	      this.save(row, rowForm);
	    }
	    /**
	     * Updates the images in the service based on the specified image object.
	     *
	     * @param {object} img - The image object containing updated image information.
	     * @returns {void}
	     */
	    function updateImages(img) {
	      if (this.typeInput === "promo_link") {
	        this.service.promo = img;
	      }
	    }
	    /**
	     * Saves the updated image for the current service.
	     *
	     * @returns {void}
	     */
	    function saveUpdatedImage() {
	      this.save(this.service, this.rowFormServ);
	    }
	    /**
	     * Activates or deactivates the options button with the specified ID and prefix.
	     *
	     * @param {string} id - The ID of the options button.
	     * @param {string} prefix - The prefix for the ID of the options button.
	     * @returns {void}
	     */
	    function _activateOptionsButton(id, prefix) {
	      var opc = document.getElementById(id + prefix);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id + prefix);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    function showPromotions(promos) {
	      angular.forEach(promos, function (value) {
	        value.Selected = false;
	      });
	      this.noData = promos.length == 0 ? true : false;
	      this.fail = false;
	      this.originalDataPromotions = angular.copy(promos);
	      this._createUsingFullOptionsPromotions(promos);
	    }

	    function _createUsingFullOptionsPromotions(promos) {
	      var initialParams = {
	        count: this.count
	      };
	      var initialSettings = {
	        counts: [],
	        paginationMaxBlocks: 4,
	        paginationMinBlocks: 2,
	        dataset: promos
	      };
	      this.promoTableParams = new NgTableParams(initialParams, initialSettings);
	      return this.promoTableParams;
	    }
	    /**
	     * Updates the view to display the provided list of services.
	     *
	     * @param {Array} services - The list of services to display.
	     * @returns {void}
	     */
	    function showServices(services) {
	      var noPromoText = 'no promo';
	      var enabledText = 'activo';
	      var disabledText = 'no activo';
	      try {
	        if (this.$translate && this.$translate.instant) {
	          noPromoText = this.$translate.instant('app.services.NO_PROMO');
	          enabledText = this.$translate.instant('app.administration.STATUS_ENABLED');
	          disabledText = this.$translate.instant('app.administration.STATUS_DISABLED');
	        }
	      } catch (e) {
	        console.log('Translation error', e);
	      }
	      noPromoText = (noPromoText || 'no promo').toLowerCase();
	      enabledText = (enabledText || 'activo').toLowerCase();
	      disabledText = (disabledText || 'no activo').toLowerCase();

	      try {
	        this._statusEnabledLabel = enabledText;
	        this._statusDisabledLabel = disabledText;
	      } catch (e) {
	        console.log('Error setting status labels', e);
	      }

	      angular.forEach(services, function (value) {
	        value.Selected = false;
	        // promo_text: concatenated promo names/descriptions for text filtering
	        var promos = value.promo_links || [];
	        value.promo_count = promos.length;
	        if (promos.length === 0) {
	          value.promo_text = noPromoText;
	        } else {
	          // create a searchable string in lowercase to improve filtering
	          value.promo_text = promos.map(function (p) {
	            return ((p.name || "") + " " + (p.description || "")).trim();
	          }).join(" ").toLowerCase();
	        }
	        // combined search field: includes promo text and count so numeric filters (e.g. "1") match
	        try {
	          value.promo_search = (String(value.promo_text || '') + ' ' + String(value.promo_count || 0)).toLowerCase();
	        } catch (e) {
	          value.promo_search = String(value.promo_text || '') + ' ' + String(value.promo_count || 0);
	        }
	        // status search: keep boolean string 'true'/'false' so mapping to those avoids substring matches
	        try {
	          value.status_search = value.status === true || value.status === 'true' ? 'true' : 'false';
	        } catch (e) {
	          value.status_search = String(value.status) === 'true' ? 'true' : 'false';
	        }
	        return value;
	      });

	      // create select options for status filter using translated labels
	      try {
	        this.statusFilterOptions = [{ id: 'true', title: enabledText }, { id: 'false', title: disabledText }];
	      } catch (e) {
	        this.statusFilterOptions = [{ id: 'true', title: 'Activo' }, { id: 'false', title: 'No activo' }];
	      }

	      // filter mapping is handled by the custom comparator in table params; no watcher required

	      this.noData = services.length == 0 ? true : false;
	      this.fail = false;
	      this.originalData = angular.copy(services);
	      this.servicesList = angular.copy(services);
	      this._createUsingFullOptions(services);
	      // ensure the ng-table dataset is the updated services with promo_text and force a reload
	      try {
	        if (this.tableParams && this.tableParams.settings) {
	          this.tableParams.settings({ dataset: this.servicesList });
	          this.tableParams.reload();
	        }
	      } catch (e) {
	        console.error('Error reloading tableParams after showServices', e);
	      }
	    }
	    /**
	     * Hides the HTML element with the specified ID.
	     *
	     * @param {string} id - The ID of the HTML element to hide.
	     * @returns {void}
	     */
	    function hideElement(id) {
	      var menu = document.getElementById("" + id);
	      if (menu) {
	        menu.style.display = "none";
	      }
	    }
	    /**
	     * Retrieves services based on the user's role and organization ID.
	     *
	     * @param {string} user_role - The role of the user.
	     * @param {string} organizationId - The ID of the organization.
	     * @returns {void}
	     */
	    function getServicesByOrganization(user_role, organizationId) {
	      var _this17 = this;

	      var $this = this;
	      this.servicesList = [];
	      this.AdministrationService.getServices(user_role, organizationId, "queues").then(function (result) {
	        $this.showServices(result.reverse());
	        _this17.servicesSelected = [];
	        _this17.hasServicesSelected = false;
	      }).catch(function (error) {
	        _this17.fail = true;
	        console.log(error);
	        _this17.$translate("app.services.ERROR_GETBYORGANIZATION").then(function (errorMsg) {
	          _this17.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Retrieves establishments based on the organization ID and updates the component's state.
	     * Also filters and excludes establishments that are already assigned to selected services.
	     *
	     * @returns {void}
	     */
	    function getEstablismentByOrganization() {
	      var _this18 = this;

	      this.loadCenter = true;
	      this.services = [];
	      var servicesId = [];
	      var isAssigned = false;
	      var organizationId = this.organizationId;
	      this.servicesSelected.forEach(function (value) {
	        servicesId.push(value.id);
	      });
	      var filter = '{"include":{"relation":"queueTypes"}}';
	      // Load all queueTypes by establishment
	      this.OrganizationsResource.getEstablismentByOrganization({
	        id: organizationId,
	        type: "locations",
	        filter: filter
	      }).$promise.then(function (result) {
	        result.map(function (service) {
	          if (service.queueTypes.length == 0) {
	            if (servicesId.indexOf(service.id) < 0) {
	              delete service.queueTypes;
	              _this18.services.push(service);
	              servicesId.push(service.id);
	            }
	          } else {
	            angular.forEach(service.queueTypes, function (value) {
	              if (servicesId.indexOf(value.queueId) >= 0) {
	                isAssigned = true;
	              }
	            });

	            if (!isAssigned) {
	              delete service.queueTypes;
	              _this18.services.push(service);
	            }
	            isAssigned = false;
	          }
	        });
	        _this18.loadCenter = false;
	        _this18.arrIns.map(function (item) {
	          _this18.services.map(function (service) {
	            if (service.id == item.centerId) {
	              _this18.services.splice(_this18.services.indexOf(service), 1);
	            }
	          });
	        });
	        _this18.services.sort(function (a, b) {
	          return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
	        });
	        console.log("this.services", _this18.services);
	      }).catch(function (error) {
	        console.log(error);
	        _this18.$translate("app.services.ERROR_GETBYORGANIZATION").then(function (errorMsg) {
	          _this18.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Retrieves Bokitit services based on the selected organization and updates the component's state.
	     * Shows a notification if the organization is not selected or if there is an issue fetching the services.
	     *
	     * @returns {void}
	     */
	    function getServicesBokititByOrganization() {
	      var _this19 = this;

	      this.servicesBokitit = [];

	      if (!this.organizationSelectedBokitit) {
	        // No se está seteando organizationSelectedBokitit en ningún otro lugar, así que voy a recoger
	        // El id de la organización de los servicios seleccionados
	        var organizationIds = [].concat(_toConsumableArray(new Set(this.servicesSelected.map(function (service) {
	          return service.organizationId;
	        }))));
	        if (organizationIds.length != 1) {
	          this.toastr.info("Organization not selected!", "Info");
	          return;
	        } else {
	          this.organizationSelectedBokitit = {
	            id: organizationIds[0]
	          };
	        }
	      }

	      this.AgendasResource.getServicesByOrganization({
	        id: this.organizationSelectedBokitit.id
	      }).$promise.then(function (result) {
	        _this19.servicesBokitit = result;
	      }).catch(function (error) {
	        console.log(error);
	        _this19.toastr.info("Api Keys not configured!", "Info");
	      });
	    }
	    /**
	     * Retrieves Bokitit services by their unique identifier (serviceId) and updates the component's state.
	     * Also calls a method to extract and store Bokitit services' names.
	     * Shows a notification if there is an issue fetching the services.
	     *
	     * @param {string} serviceId - The unique identifier of the Bokitit service.
	     * @returns {void}
	     */
	    function getServicesBokititById(serviceId) {
	      var _this20 = this;

	      this.QueuesResource.getQueuesById({
	        id: serviceId
	      }).$promise.then(function (result) {
	        _this20.bokititServicebyId = result;
	        _this20.getBokititServicesName(_this20.bokititServicebyId);
	      }).catch(function (error) {
	        console.log(error);
	        _this20.toastr.info("Api Keys not configured!", "Info");
	      });
	    }
	    /**
	     * Retrieves and stores the names of Bokitit services based on the provided payload, which contains organizationId and an array of serviceIds.
	     * Shows a notification if there is an issue fetching the services.
	     *
	     * @param {Object} payload - The payload containing organizationId and an array of serviceIds.
	     * @returns {void}
	     */
	    function getBokititServicesName(payload) {
	      var _this21 = this;

	      this.AgendasResource.getBokititById({
	        organizationId: this.organizationSelectedBokitit.id,
	        serviceId: payload.bokititServices
	      }).$promise.then(function (result) {
	        _this21.bokititServicesArray = result;
	      }).catch(function (error) {
	        console.log(error);
	        _this21.toastr.info("Api Keys not configured!", "Info");
	      });
	    }
	    /**
	     * Handles the change event when an item is selected in the organization dropdown.
	     * If a valid item is selected, updates the current organization and retrieves services for the selected organization.
	     * If no item is selected, sets the organization to undefined and retrieves services for the root organization (if the user is a ROOT user).
	     *
	     * @param {Object} item - The selected item from the organization dropdown.
	     * @returns {void}
	     */
	    // function selectedItemChange(item) {
	    //   if (item !== undefined) {
	    //     const Organization = JSON.parse(JSON.stringify(item))

	    //     var current_organization = Organization
	    //     this.currentOrganization = current_organization;
	    //     this.organizationId = current_organization.id;
	    //     this.organizationInUse = current_organization.name;
	    //     this.getServicesByOrganization(
	    //       this.$localStorage.currentRole,
	    //       this.organizationId
	    //     );
	    //     return
	    //   }
	    //   this.organizationInUse = undefined;
	    //   const organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
	    //   this.organizationId = organizationId;
	    //   const user_role = this.$localStorage.currentRole;

	    //   if (user_role == "ROOT") {
	    //     this.OrganizationsResource.getOrganizations()
	    //       .$promise.then((result) => {
	    //         this.organizations = result.reverse();
	    //       })
	    //       .catch((error) => {
	    //         console.log(error);
	    //         this.fail = true;
	    //         this.$translate("app.ERROR_GETORGANIZATION").then((errorMsg) => {
	    //           this.toastr.error(errorMsg, "Error");
	    //         });
	    //       });

	    //     this.getServicesByOrganization(user_role, "");
	    //   } else {
	    //     this.getServicesByOrganization(
	    //       user_role,
	    //       this.$localStorage.currentOrganization.id
	    //     );
	    //   }
	    //   return
	    // }
	    function selectedItemChange(item) {
	      var user_role = this.$localStorage.currentRole;
	      if (item !== undefined) {
	        var Organization = JSON.parse(JSON.stringify(item));

	        var current_organization = Organization;
	        this.currentOrganization = current_organization;
	        this.organizationId = current_organization.id;
	        this.organizationInUse = current_organization.name;
	        this.$localStorage.selectedOrganization = current_organization;
	        this.getServicesByOrganization(this.$localStorage.currentRole, this.organizationId);
	        return;
	      }
	      if (user_role != "ROOT") {
	        this.organizationInUse = undefined;
	        var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
	        this.organizationId = organizationId;

	        this.getServicesByOrganization(user_role, this.$localStorage.currentOrganization.id);
	        return;
	      }
	      console.log('this.tableParams.settings()', this.tableParams.settings());
	      this.tableParams.settings().dataset = [];
	      this.tableParams.reload();
	    }
	    /**
	     * Searches for and filters the organizations based on the provided query.
	     *
	     * @param {string} query - The search query.
	     * @returns {Array} - An array of filtered organizations.
	     */
	    function querySearchSelect(query) {
	      this.organizations.sort(function (a, b) {
	        if (a.name < b.name) {
	          return -1;
	        }
	        if (a.name > b.name) {
	          return 1;
	        }
	        return 0;
	      });
	      var results = query ? this.organizations.filter(createFilterFor(query)) : this.organizations;
	      return results;
	    }
	    /**
	     * Creates a filter function for the given query to match organization names.
	     *
	     * @param {string} query - The search query.
	     * @returns {function} - A filter function that matches organization names.
	     */
	    var createFilterFor = function createFilterFor(query) {
	      var lowercaseQuery = query.toLowerCase();
	      return function filterFn(item) {
	        var lowerCaseValue = item.name.toLowerCase();
	        return lowerCaseValue.indexOf(lowercaseQuery) === 0;
	      };
	    };
	    /**
	     * Checks the given data and updates the visibility status for citas or turnos.
	     *
	     * @param {boolean} data - The data to check.
	     * @param {string} name - The identifier for citas or turnos.
	     */
	    function _checkCitas(data, name) {
	      switch (name) {
	        case "citas":
	          this.showCitas = data ? 'true' : 'false';
	          this.new_service.turnos = this.showTurnos = this.new_service.parking = this.showParking = !this.showCitas;
	          if (this.showCitas) this.new_service.serviceType = "booking";
	          break;
	        case "turnos":
	          this.showTurnos = data ? 'true' : 'false';
	          this.new_service.citas = this.showCitas = this.new_service.parking = this.showParking = !this.showTurnos;
	          if (this.showTurnos) this.new_service.serviceType = "turn";
	          break;
	        case "parking":
	          this.showParking = data ? 'true' : 'false';
	          this.new_service.citas = this.showCitas = this.new_service.turnos = this.showTurnos = !this.showParking;
	          if (this.showParking) this.new_service.serviceType = "parking";
	          break;
	        default:
	          break;
	      }
	    }
	    // exports
	    angular.extend(this, {
	      config: config,
	      createService: createService,
	      updateService: updateService,
	      deleteService: deleteService,
	      updateIcons: updateIcons,
	      _createUsingFullOptions: _createUsingFullOptions,
	      _createUsingFullOptionsPromotions: _createUsingFullOptionsPromotions,
	      _createUsing: _createUsing,
	      pageSizeChanged: pageSizeChanged,
	      _sendService: _sendService,
	      _validateDescription: _validateDescription,
	      _asignService: _asignService,
	      _selectService: _selectService,
	      _detailService: _detailService,
	      _showAsignServiceForm: _showAsignServiceForm,
	      _showServiceForm: _showServiceForm,
	      _showDetailDialog: _showDetailDialog,
	      _showServiceFormEdit: _showServiceFormEdit,
	      _detailAsignedService: _detailAsignedService,
	      _closeDialog: _closeDialog,
	      _cancelDialog: _cancelDialog,
	      _editOptionsButton: _editOptionsButton,
	      _activateOptionsButton: _activateOptionsButton,
	      showServices: showServices,
	      showPromotions: showPromotions,
	      getServicesByOrganization: getServicesByOrganization,
	      disassignService: disassignService,
	      getEstablismentByOrganization: getEstablismentByOrganization,
	      //bokitit
	      disassignBokititService: disassignBokititService,
	      getServicesBokititById: getServicesBokititById,
	      getBokititServicesName: getBokititServicesName,
	      getServicesBokititByOrganization: getServicesBokititByOrganization,
	      _detailAsignedBokititService: _detailAsignedBokititService,
	      _showAsignServiceBokititForm: _showAsignServiceBokititForm,
	      _asignServiceBokitit: _asignServiceBokitit,
	      _addInstructions: _addInstructions,
	      _deleteServ: _deleteServ,
	      _showDisassignBookititServiceDialog: _showDisassignBookititServiceDialog,
	      updateHasBokititServices: updateHasBokititServices,
	      selectedItemChange: selectedItemChange,
	      querySearchSelect: querySearchSelect,
	      updateImages: updateImages,
	      _changeImageDialog: _changeImageDialog,
	      saveUpdatedImage: saveUpdatedImage,
	      deleteImage: deleteImage,
	      abrirArchivo: abrirArchivo,
	      previewImageFile: previewImageFile,
	      _validateSpaces: _validateSpaces,
	      _validateImage: _validateImage,
	      _checkCitas: _checkCitas,
	      _showAsignServiceToService: _showAsignServiceToService,
	      _asignServiceToService: _asignServiceToService,
	      showingServiciesIfServiceSelection: showingServiciesIfServiceSelection,
	      _deleteServChild: _deleteServChild
	      //
	    });
	  }

	  _createClass(ServicesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this22 = this;

	      var style = document.querySelectorAll('.custom-file-input');
	      style.forEach(function (element) {
	        element.dataset.styleType = _this22.$translate.instant('app.organizations.BTN_CHOOSE_FILE');
	      });

	      var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
	      // this.organizationInUse = this.$localStorage.currentOrganization.name; // Se retiro para mostrar correctamente  el titulo de la tabla
	      this.organizationId = organizationId;
	      var user_role = this.$localStorage.currentRole;

	      if (user_role == "ROOT") {
	        this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
	          _this22.organizations = result.reverse();
	        }).catch(function (error) {
	          console.log(error);
	          _this22.fail = true;
	          _this22.$translate("app.ERROR_GETORGANIZATION").then(function (errorMsg) {
	            _this22.toastr.error(errorMsg, "Error");
	          });
	        });

	        // this.getServicesByOrganization(user_role, "");
	      } else {
	        this.$localStorage.selectedOrganization = this.$localStorage.currentOrganization;
	        this.getServicesByOrganization(user_role, this.$localStorage.currentOrganization.id);
	      }

	      this.AdministrationService.getEstablishments(user_role, organizationId, "locations").then(function (result) {
	        _this22.establishments = result;
	      }).catch(function (error) {
	        console.log(error);
	        _this22.$translate("app.services.ERROR_GETBYORGANIZATION").then(function (errorMsg) {
	          _this22.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	  }, {
	    key: "organizationChanged",
	    value: function organizationChanged() {
	      this.$localStorage.last_organization = this.organizationSelected;
	      //bokitit
	      this.organizationSelectedBokitit = JSON.parse(this.organizationSelected);
	      //
	      var current_organization = JSON.parse(this.organizationSelected);
	      this.currentOrganization = current_organization;
	      this.organizationId = current_organization.id;
	      this.organizationInUse = current_organization.name;
	      this.organizationSelected = undefined;
	      this.$scope.selectOrganizationForm.$setPristine();
	      // Load all services by organization
	      this.getServicesByOrganization(this.$localStorage.currentRole, this.organizationId);
	    }
	  }]);

	  return ServicesController;
	}();

	ServicesController.$inject = ["$rootScope", "$scope", "config", "AdministrationService", "ServicesResource", "OrganizationsResource", "EstablishmentsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "AgendasResource", "QueuesResource"];

	exports.default = ServicesController;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ServicesService =

	/** @ngInject */
	function ServicesService() {
	  _classCallCheck(this, ServicesService);
	};

	//ServicesService.$inject = ['EmployeesResource'];

	exports.default = ServicesService;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _campaignes = __webpack_require__(92);

	var _campaignes2 = __webpack_require__(94);

	var _campaignes3 = _interopRequireDefault(_campaignes2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var campaignes = angular.module('mod.admin.administration.campaignes', []).component('campaignes', _campaignes.CampaignesComponent).service('CampaignesService', _campaignes3.default).name;

	exports.default = campaignes;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CampaignesComponent = undefined;

	var _campaignes = __webpack_require__(93);

	var _campaignes2 = _interopRequireDefault(_campaignes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var CampaignesComponent = exports.CampaignesComponent = {
	  controller: _campaignes2.default,
	  templateUrl: 'app/modules/admin/administration/campaignes/campaignes.html'
	};

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CampaignesController = function () {

		/** @ngInject */
		CampaignesController.$inject = ["$rootScope", "config", "ServicesResource", "EstablishmentsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location"];
		function CampaignesController($rootScope, config, ServicesResource, EstablishmentsResource, NgTableParams, $translate, toastr, $mdDialog, $localStorage, $location) {
			_classCallCheck(this, CampaignesController);

			// private
			this.$rootScope = $rootScope;
			this.isSuperAdmin = $localStorage.currentUser.role === 'superadmin' ? true : false;
			this.establishmentId = config.ESTABLISHMENT_ID;
			this.isPre = config.IS_PRE;
			this.ServicesResource = ServicesResource;
			this.EstablishmentsResource = EstablishmentsResource;
			this.config = config;
			this.$translate = $translate;
			this.toastr = toastr;
			this.$mdDialog = $mdDialog;
			this.isAdding = false;
			this.fail = false;
			this.campaignesSelected = [];
			this.hasCampaignesSelected = false;
			this.current_campaign = {
				"identifier": "",
				"_id": "",
				"description": "",
				"url": "",
				"typesection": "",
				"status": "",
				"device": "",
				"asigned": "",
				"establishments": []
			};

			this.cancel = cancel;
			this.del = del;
			this.showDeleteConfirm = showDeleteConfirm;
			this.save = save;
			this.add = add;
			this.resetRow = resetRow;

			// Control of sidemenu page
			var url = $location.url().substring(1).toUpperCase();
			this.$rootScope.currentPage = currentPage(1);

			function currentPage(index) {
				var split_url = url.split('/');
				return split_url[index];
			}

			var data = [{
				"identifier": "Vodafone",
				"_id": "587c9bf7a3569104c9c1fc20",
				"description": "Servicios de internet",
				"url": "https://www.youtube.com/v/vlpIhM3iszA&list=PLD6EB1EB204048E8F",
				"typesection": "YOUTUBE",
				"status": "STATUS_ENABLED",
				"asigned": "ASIGNED_ENABLED",
				"device": "MOBILE",
				"establishments": [{
					"addressFirstLine": "Av. Rey Don Jaime, 78 1ª Planta",
					"description": "Oficina BBVA 2327 Castellon - Rey Don Jaime",
					"name": "Oficina 2327",
					"_id": "52f602d787945c344bb4bda5"
				}]
			}, {
				"identifier": "Internet",
				"_id": "587c9bf7a3569104c9c1fc21",
				"description": "Internet fijo y móvil",
				"url": "https://www.youtube.com/v/vlpIhM3iszA&list=PLD6EB1EB204048E8F",
				"typesection": "YOUTUBE",
				"status": "STATUS_DISABLED",
				"asigned": "ASIGNED_DISABLED",
				"device": "SCREEN",
				"establishments": []
			}, {
				"identifier": "Televisión",
				"_id": "587c9bf7a3569104c9c1fc22",
				"description": "Televisión por internet",
				"url": "https://www.youtube.com/v/vlpIhM3iszA&list=PLD6EB1EB204048E8F",
				"typesection": "YOUTUBE",
				"status": "STATUS_ENABLED",
				"asigned": "ASIGNED_ENABLED",
				"device": "MOBILE",
				"establishments": [{
					"addressFirstLine": "Av. Rey Don Jaime, 78 1ª Planta",
					"description": "Oficina BBVA 2327 Castellon - Rey Don Jaime",
					"name": "Oficina 2327",
					"_id": "52f602d787945c344bb4bda5"
				}, {
					"addressFirstLine": "C. Arturo Soria, 7",
					"description": "Oficina BBVA 1543 Madrid - Arturo Soria",
					"name": "Oficina 1543",
					"_id": "52f602d787945c344bb4cjh2"
				}]
			}, {
				"identifier": "Tienda",
				"_id": "587c9bf7a3569104c9c1fc23",
				"description": "Venta de terminales",
				"url": "https://www.youtube.com/v/vlpIhM3iszA&list=PLD6EB1EB204048E8F",
				"typesection": "YOUTUBE",
				"status": "STATUS_DISABLED",
				"asigned": "ASIGNED_DISABLED",
				"device": "MOBILE",
				"establishments": []
			}];

			/* only test mode  REMOVE WITH ENDPOINTS */
			this._createUsingFullOptions = _createUsingFullOptions;
			config.DEBUG_ENABLED = false;
			this.originalData = angular.copy(data);
			this._createUsingFullOptions();
			/* EOF test mode */

			function _createUsingFullOptions() {
				var initialParams = {
					count: 10 // initial page size
				};
				var initialSettings = {
					// page size buttons (right set of buttons in demo)
					counts: [],
					// determines the pager buttons (left set of buttons in demo)
					paginationMaxBlocks: 13,
					paginationMinBlocks: 2,
					dataset: data
				};
				this.tableParams = new NgTableParams(initialParams, initialSettings);
				return this.tableParams;
			}
			// TODO create fields with a form

			function add(new_template) {
				this.tableParams.settings().dataset.unshift(new_template);
				this.tableParams.sorting({});
				this.tableParams.page(1);
				this.tableParams.reload();
			}

			function cancel(row, rowForm) {
				var originalRow = this.resetRow(row, rowForm);
				angular.extend(row, originalRow);
			}

			function showDeleteConfirm(ev) {
				var current_scope = this;
				// Appending dialog to document.body to cover sidenav in docs app
				var confirm = $mdDialog.confirm().title($translate.instant('app.administration.CONFIRM_DELETE')).targetEvent(ev).ok($translate.instant('app.common.ACCEPT')).cancel($translate.instant('app.common.CANCEL'));

				$mdDialog.show(confirm).then(function () {
					current_scope.del(ev);
				}, function () {
					console.log('You decided to keep it.');
				});
			}

			function del(row) {
				var main_dataset = this.tableParams.settings().dataset;
				var originalData = '';
				angular.forEach(this.tableParams.settings().dataset, function (value, key) {
					if (angular.equals(row, value)) {
						main_dataset.splice(key, 1);
						originalData = angular.copy(main_dataset);
					}
				});
				this.originalData = originalData;
				this.tableParams.reload().then(function (data) {
					if (data.length === 0 && this.tableParams.total() > 0) {
						this.tableParams.page(this.tableParams.page() - 1);
						this.tableParams.reload();
					}
				});
			}

			// TODO save value en DB
			function save(row, rowForm) {
				var originalRow = this.resetRow(row, rowForm);
				angular.extend(originalRow, row);
				this.isAdding = false;
				/*
	   if(!config.DEBUG_ENABLED)
	   	createCenter(JSON.stringify(row));
	   */
			}

			function resetRow(row, rowForm) {
				var row_isAdding = this.isAdding;
				if (row_isAdding) {
					this.originalData = angular.copy(this.tableParams.settings().dataset);
				}
				var return_value = '';
				row.isEditing = false;
				rowForm.$setPristine();
				angular.forEach(this.originalData, function (value) {
					if (!row_isAdding && row.id === value.id) {
						return_value = value;
					} else if (row_isAdding && value.id === '') {
						return_value = value;
					}
				});
				return return_value;
			}

			function _showCampaignForm(ev) {
				var _this = this;

				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#myDialog',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				}).then(function () {
					console.log('You resolve the dialog.');
				}, function () {
					console.log('You cancelled the dialog.');
				});
			}

			function _showDetailDialog(ev) {
				var _this2 = this;

				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#dialog_detail_campaign',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this2;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				}).then(function () {
					console.log('You resolve the dialog.');
				}, function () {
					console.log('You cancelled the dialog.');
				});
			}

			function _detailAsignedCampaign(ev) {
				var _this3 = this;

				if (ev.asigned == 'ASIGNED_ENABLED') {
					$mdDialog.show({
						preserveScope: true, // do not forget this if use parent scope
						hasBackdrop: true,
						contentElement: '#dialog_detail_asigned_campaign',
						parent: angular.element(document.body),
						targetEvent: ev,
						controller: function controller() {
							return _this3;
						},
						controllerAs: 'ctrl',
						clickOutsideToClose: true
					}).then(function () {
						console.log('You resolve the dialog.');
					}, function () {
						console.log('You cancelled the dialog.');
					});
				}
			}

			function _showAsignCampaignForm(ev) {
				var _this4 = this;

				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#asignDialog',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this4;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				}).then(function () {
					console.log('You resolve the dialog.');
				}, function () {
					console.log('You cancelled the dialog.');
				});
			}

			function _sendCampaign(result) {
				// Default values
				//result.asigned = 'ASIGNED_DISABLED'; 
				this.add(result);
				$mdDialog.cancel();
			}

			function _asignCampaign(result) {
				console.log(result);
				this.hasCampaignesSelected = false;
				angular.forEach(this.data, function (item) {
					item.Selected = false;
				});
				$mdDialog.cancel();
			}

			function _detailCampaign(campaign) {
				if (campaign.isEditing !== true) {
					this.current_campaign = campaign;
					this._showDetailDialog();
				}
			}

			function _selectCampaign(result) {
				var elem_pos = this.campaignesSelected.indexOf(result);
				if (elem_pos !== -1) {
					this.campaignesSelected.splice(elem_pos, 1);
				} else {
					this.campaignesSelected.push(result);
				}
				this.hasCampaignesSelected = false;
				if (this.campaignesSelected.length > 0) {
					this.hasCampaignesSelected = true;
				}
			}

			function _closeDialog() {
				$mdDialog.hide();
			}

			function _cancelDialog() {
				$mdDialog.cancel();
			}

			// exports
			angular.extend(this, {
				data: data,
				config: config,
				_createUsingFullOptions: _createUsingFullOptions,
				_sendCampaign: _sendCampaign,
				_asignCampaign: _asignCampaign,
				_selectCampaign: _selectCampaign,
				_detailCampaign: _detailCampaign,
				_showAsignCampaignForm: _showAsignCampaignForm,
				_showCampaignForm: _showCampaignForm,
				_showDetailDialog: _showDetailDialog,
				_detailAsignedCampaign: _detailAsignedCampaign,
				_closeDialog: _closeDialog,
				_cancelDialog: _cancelDialog
			});
		}

		_createClass(CampaignesController, [{
			key: "$onInit",
			value: function $onInit() {
				var _this5 = this;

				this.currentPage = 'unbo';
				if (!this.config.DEBUG_ENABLED) {
					// Load activate queues by employee
					/*
	    this.ServicesResource.getServices({establishmentId: this.establishmentId}).$promise
	    .then(result => {
	    	this.fail = false;
	    	this.data = result;
	    	this.originalData = angular.copy(result);
	    	this._createUsingFullOptions();
	    }).catch(error => {
	    	this.fail = true;
	    	console.log(error);
	    	this.$translate('app.API_ERROR').then((errorMsg) => {
	    		this.toastr.error(errorMsg, 'Error');
	    	});
	    });
	    */

					// Load all establishments
					this.EstablishmentsResource.getEstablishments().$promise.then(function (result) {
						_this5.establishments = result;
					}).catch(function (error) {
						console.log(error);
						_this5.$translate('app.API_ERROR').then(function (errorMsg) {
							_this5.toastr.error(errorMsg, 'Error');
						});
					});
				}
			}
		}]);

		return CampaignesController;
	}();

	CampaignesController.$inject = ['$rootScope', 'config', 'ServicesResource', 'EstablishmentsResource', 'NgTableParams', '$translate', 'toastr', '$mdDialog', '$localStorage', '$location'];

	exports.default = CampaignesController;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CampaignesService =

	/** @ngInject */
	function CampaignesService() {
	  _classCallCheck(this, CampaignesService);
	};

	//CampaignesService.$inject = ['EmployeesResource'];

	exports.default = CampaignesService;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _waitingareas = __webpack_require__(96);

	var _waitingareas2 = __webpack_require__(98);

	var _waitingareas3 = _interopRequireDefault(_waitingareas2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var waitingareas = angular.module('mod.admin.administration.waitingareas', []).component('waitingareas', _waitingareas.WaitingareasComponent).service('WaitingareasService', _waitingareas3.default).name;

	exports.default = waitingareas;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WaitingareasComponent = undefined;

	var _waitingareas = __webpack_require__(97);

	var _waitingareas2 = _interopRequireDefault(_waitingareas);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var WaitingareasComponent = exports.WaitingareasComponent = {
	  controller: _waitingareas2.default,
	  templateUrl: 'app/modules/admin/administration/waitingareas/waitingareas.html'
	};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var WaitingareasController = function () {

		/** @ngInject */
		WaitingareasController.$inject = ["$scope", "$rootScope", "config", "Areas", "EstablishmentsResource", "OrganizationsResource", "AdministrationService", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "pageSizeOptions"];
		function WaitingareasController($scope, $rootScope, config, Areas, EstablishmentsResource, OrganizationsResource, AdministrationService, NgTableParams, $translate, toastr, $mdDialog, $localStorage, $location, pageSizeOptions) {
			var _this = this;

			_classCallCheck(this, WaitingareasController);

			// private
			this.$localStorage = $localStorage;
			this.$scope = $scope;
			this.$rootScope = $rootScope;
			this.noData = true;
			this.establishmentInUse = '';

			this.isSuperAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'SUPERADMIN' ? true : false;
			this.isRoot = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'ROOT' ? true : false;
			this.isAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === 'string' && $localStorage.currentRole.toUpperCase() === 'ADMIN' ? true : false;
			var last_establishment = $localStorage.last_establishment ? $localStorage.last_establishment : false;
			if (this.isRoot || this.isSuperAdmin) {
				if (last_establishment) {
					this.currentEstablishment = (typeof last_establishment === 'undefined' ? 'undefined' : _typeof(last_establishment)) != 'object' ? JSON.parse(last_establishment) : last_establishment;
					this.establishmentId = this.currentEstablishment.id;
				}
			} else {
				this.establishmentId = $localStorage.currentLocation.id;
			}
			this.isPre = config.IS_PRE;
			this.EstablishmentsResource = EstablishmentsResource;
			this.AdministrationService = AdministrationService;
			this.OrganizationsResource = OrganizationsResource;
			this.Areas = Areas;
			this.config = config;
			this.$translate = $translate;
			this.toastr = toastr;
			this.$mdDialog = $mdDialog;
			this.isAdding = false;
			this.fail = false;
			this.placesSelected = [];
			this.hasPlacesSelected = false;
			this.organizations = [];
			this.establishments = [];

			this.cancel = cancel;
			this.showDeleteConfirm = showDeleteConfirm;
			this.del = del;
			this.save = save;
			this.add = add;
			this.resetRow = resetRow;
			this.count = 10;
			this.pageSizeOptions = pageSizeOptions;
			this.editArea = false;
			this.new_waitingarea = {};
			this.pageSizeOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
			// Control of sidemenu page
			var url = $location.url().substring(1).toUpperCase();
			this.$rootScope.currentPage = currentPage(1);
			/**
	   * Retrieves the current page from the URL based on the specified index.
	   *
	   * @param {number} index - The index indicating the position of the page in the URL.
	   * @returns {string} - The current page extracted from the URL.
	   */
			function currentPage(index) {
				var split_url = url.split('/');
				return split_url[index];
			}
			/**
	   * Updates the table page size and counter based on the new page size.
	   *
	   * @param {number} newPageSize - The new page size to set for the table.
	   */
			var pageSizeChanged = function pageSizeChanged(newPageSize) {
				_this.tableParams.count(newPageSize);
				_this.counter = newPageSize;
			};
			/**
	   * Creates and initializes a new NgTableParams instance using full options.
	   *
	   * @param {Array} waitingareas_data - The array of waiting areas data.
	   * @returns {NgTableParams} - The initialized NgTableParams instance.
	   */
			function _createUsingFullOptions(waitingareas_data) {
				angular.forEach(waitingareas_data, function (value) {
					value.asigned = value.asigned ? value.asigned : "ASIGNED_DISABLED";
					value.status = value.status ? value.status : "STATUS_DISABLED";
				});
				var initialParams = {
					count: this.count // initial page size: ;
				};
				var initialSettings = {
					// page size buttons (right set of buttons in demo)
					counts: [],
					// determines the pager buttons (left set of buttons in demo)
					paginationMaxBlocks: 4,
					paginationMinBlocks: 2,
					dataset: waitingareas_data
				};
				this.tableParams = new NgTableParams(initialParams, initialSettings);
				return this.tableParams;
			}
			/**
	   * Adds a new template to the NgTableParams instance.
	   *
	   * @param {Object} new_template - The new template to be added.
	   */
			function add(new_template) {
				this.tableParams.settings().dataset.unshift(new_template);
				this.tableParams.sorting({});
				this.tableParams.page(1);
				this.tableParams.reload();
			}
			/**
	   * Cancels the modifications made to a row and restores its original state.
	   *
	   * @param {Object} row - The row to be canceled.
	   */
			function cancel(row) {
				var originalRow = this.resetRow(row);
				angular.extend(row, originalRow);
			}
			/**
	   * Displays a confirmation dialog for deleting a waiting area.
	   *
	   * @param {Object} ev - The event object.
	   */
			function showDeleteConfirm(ev) {
				var current_scope = this;
				hideElement(ev.id);
				// Appending dialog to document.body to cover sidenav in docs app
				var confirm = $mdDialog.confirm().title($translate.instant('app.administration.CONFIRM_DELETE')).targetEvent(ev).ok($translate.instant('app.common.ACCEPT')).cancel($translate.instant('app.common.CANCEL'));

				$mdDialog.show(confirm).then(function () {
					current_scope.deleteWaitingarea(ev);
				}, function () {});
			}
			/**
	   * Deletes a waiting area from the dataset and reloads the table.
	   *
	   * @param {Object} row - The waiting area object to be deleted.
	   */
			function del(row) {
				var $this = this;
				var main_dataset = this.tableParams.settings().dataset;
				var originalData = '';
				angular.forEach(this.tableParams.settings().dataset, function (value, key) {
					if (angular.equals(row, value)) {
						main_dataset.splice(key, 1);
						originalData = angular.copy(main_dataset);
					}
				});
				this.originalData = originalData;
				this.tableParams.reload().then(function (data) {
					if (data.length === 0 && $this.tableParams.total() > 0) {
						$this.tableParams.page($this.tableParams.page() - 1);
						$this.tableParams.reload();
					}
				});
			}
			/**
	   * Saves the changes made to a waiting area, updates the dataset, and sets the 'isAdding' flag to false.
	   *
	   * @param {Object} row - The waiting area object with changes.
	   */
			function save(row) {
				var originalRow = this.resetRow(row);
				angular.extend(originalRow, row);
				this.isAdding = false;
				this.updateWaitingarea(row);
			}
			/**
	   * Resets the row to its original state, either by restoring the original data if editing an existing waiting area or removing the added waiting area if it was in 'adding' mode.
	   *
	   * @param {Object} row - The waiting area object to reset.
	   * @returns {Object} - The original data of the row.
	   */
			function resetRow(row) {
				var row_isAdding = this.isAdding;
				if (row_isAdding) {
					this.originalData = angular.copy(this.tableParams.settings().dataset);
				}
				var return_value = '';
				row.isEditing = false;
				angular.forEach(this.originalData, function (value) {
					if (!row_isAdding && row.id === value.id) {
						return_value = value;
					} else if (row_isAdding && value.id === '') {
						return_value = value;
					}
				});
				return return_value;
			}
			/**
	   * Shows the waiting area form dialog, either for creating a new waiting area or editing an existing one.
	   *
	   * @param {Object} ev - The event object, typically the click event that triggered the dialog.
	   */
			function _showWaitingareaForm() {
				var _this2 = this;

				var ev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

				var parent = this;
				parent.editArea = (typeof ev === 'undefined' ? 'undefined' : _typeof(ev)) === 'object' && Object.keys(ev).length > 0;

				if (parent.editArea) {
					hideElement(ev.id);
					this._showWaitingareaEdit(ev);
				}
				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#myDialog',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this2;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				}).then(function () {
					parent.editArea = false;
					document.getElementById("name").parentElement.parentElement.children[0].classList.remove("md-input-invalid");
					var errNameElement = document.getElementById("err_name");
					if (errNameElement) {
						errNameElement.style.display = "none";
					}
					document.getElementById("place").parentElement.parentElement.children[0].classList.remove("md-input-invalid");
					document.getElementById("err_place").style.display = "none";
				}, function () {
					parent.editArea = false;
					parent._closeDialog();
				});
			}
			/**
	   * Prepares the waiting area form for editing by initializing the form with the provided waiting area data.
	   *
	   * @param {Object} area - The waiting area data to be edited.
	   */
			function _showWaitingareaEdit(area) {
				this.new_waitingarea = angular.copy(area);
			}
			/**
	   * Hides the HTML element with the specified ID.
	   *
	   * @param {string} id - The ID of the HTML element to hide.
	   */
			function hideElement(id) {
				var menu = document.getElementById('' + id);
				if (menu) {
					menu.style.display = "none";
				}
			}
			/**
	   * Displays an assignment dialog.
	   *
	   * @param {Event} ev - The event that triggered the dialog.
	   */
			function _asignDialog(ev) {
				var _this3 = this;

				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#asignDialog',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this3;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				});
			}
			/**
	   * Displays details of a waiting area, including workstations information.
	   *
	   * @param {Object} waitingarea - The waiting area object to display details for.
	   */
			function _detailWaitingarea(waitingarea) {
				var _this4 = this;

				if (waitingarea.isEditing !== true) {
					this.current_waitingarea = waitingarea;
					this.Areas.getWorkstations({ id: waitingarea.id, type: 'workstations' }).$promise.then(function (result) {
						if (result.length > 0) {
							_this4.current_waitingarea.asigned = true;
						} else {
							_this4.current_waitingarea.asigned = false;
						}
						waitingarea.workstations = result;
					}).catch(function (error) {
						console.log(error);
						_this4.$translate('app.consumers.ERROR_GETBYAREA').then(function (errorMsg) {
							_this4.toastr.error(errorMsg, 'Error');
						});
					});
					this._showDetailDialog();
				}
			}
			/**
	   * Shows a detailed dialog for a waiting area, including workstations information.
	   *
	   * @param {Object} ev - The event object that triggered the detail dialog.
	   */
			function _showDetailDialog(ev) {
				var _this5 = this;

				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#dialog_detail_waitingarea',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this5;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				});
			}
			/**
	   * Shows a detailed dialog for an assigned waiting area.
	   *
	   * @param {Object} ev - The event object that triggered the detail dialog.
	   */
			function _detailAsignedWaitingarea(ev) {
				var _this6 = this;

				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#dialog_detail_asigned_waitingarea',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this6;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				});
			}
			/**
	   * Returns the corresponding display name for a given field name.
	   *
	   * @param {string} name - The field name.
	   * @returns {string} - The display name for the field.
	   */
			var showNames = function showNames(name) {
				switch (name) {
					case "place":
						return "Lugar";
					case "name":
						return "Nombre";
					default:
						return "";
				}
			};
			/**
	   * Validates the input value based on specific criteria.
	   *
	   * @param {string} value - The input value to be validated.
	   * @param {string} id - The ID of the input element.
	   * @param {Object} formPristine - The form's $pristine object (optional).
	   */
			var _validateInputs = function _validateInputs(value, id, formPristine) {
				// regex only alphanumeric
				var resAlphaNum = /^[a-zA-Z0-9.,-_áéíóúñÁÉÍÓÚÑ() ]+$/;
				var nums = /^[0-9]+$/;

				var name2 = document.getElementById('' + id);
				var errName = document.getElementById('err_' + id);
				var colorErro = 'rgba(219, 72, 73, 1)';
				var name = showNames(id);

				if (!resAlphaNum.test(value) || nums.test(value)) {
					name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
					errName.style.display = "block";
					errName.innerHTML = $translate.instant('app.waiting_areas.' + name + '_INVALID');
					errName.style.color = colorErro;
					formPristine !== undefined ? formPristine.$pristine = true : null;
					formPristine !== undefined ? formPristine.$invalid = true : null;
				} else if (name2.value.length > 15 || name2.value.length < 3) {
					name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
					errName.innerHTML = $translate.instant('app.waiting_areas.' + name + '_INVALID_LENGTH');
					errName.style.display = "block";
					errName.style.color = colorErro;
					formPristine !== undefined ? formPristine.$pristine = true : null;
					formPristine !== undefined ? formPristine.$invalid = true : null;
				} else {
					name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
					errName.style.display = "none";
					formPristine !== undefined ? formPristine.$pristine = false : null;
					formPristine !== undefined ? formPristine.$invalid = false : null;
				}
			};
			/**
	   * Validates the input values for the waiting area form.
	   * 
	   * @returns {boolean} True if the input values are valid, false otherwise.
	   */
			function validationsInputs() {
				var name = document.getElementById("name").value;
				var name2 = document.getElementById("name");
				var errName = document.getElementById("err_name");

				var place = document.getElementById("place").value;
				var place2 = document.getElementById("place");
				var errPlace = document.getElementById("err_place");

				var re = /^[a-zA-Z0-9.,-_áéíóúñÁÉÍÓÚÑ() ]+$/;

				if (!re.test(name) || name.length < 3 || name.length > 15) {
					name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
					errName.style.display = "block";
					errName.style.color = "red";
				} else {
					name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
					errName.style.display = "none";
				}
				if (!re.test(place)) {
					place2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
					errPlace.style.display = "block";
					errPlace.style.color = "red";
				} else if (place.length < 3 || place.length > 15) {
					place2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
					errPlace.style.innerHTML = "El lugar debe tener entre 3 y 15 caracteres";
					errPlace.style.display = "block";
					errPlace.style.color = "red";
				} else {
					place2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
					errPlace.style.display = "none";
				}
				return re.test(name) && re.test(place) && name.length >= 3 && name.length <= 15 && place.length >= 3 && place.length <= 15;
			}
			/**
	   * Sends the waiting area data for either creating a new waiting area or updating an existing one.
	   * Validates the input values before sending.
	   * 
	   * @param {Object} result - The waiting area data.
	   */
			function _sendWaitingarea(result) {
				var validations = validationsInputs();
				if (validations) {
					document.getElementById("name").parentElement.parentElement.children[0].classList.remove("md-input-invalid");
					document.getElementById("place").parentElement.parentElement.children[0].classList.remove("md-input-invalid");
					if (this.waitingareaForm.$invalid) {
						Object.values(this.waitingareaForm.$$controls).forEach(function (control) {
							control.$touched = true;
						});
						return;
					}
					this.editArea ? this.save(result) : this.createWaitingarea(result);
					$mdDialog.cancel();
				}
			}
			/**
	   * Selects or deselects a place and updates the list of selected places.
	   * 
	   * @param {Object} result - The place to be selected or deselected.
	   */
			function _selectPlace(result) {
				var elem_pos = this.placesSelected.indexOf(result);
				if (elem_pos !== -1) {
					this.placesSelected.splice(elem_pos, 1);
				} else {
					this.placesSelected.push(result);
				}
				this.hasPlacesSelected = false;
				if (this.placesSelected.length > 0) {
					this.hasPlacesSelected = true;
				}
			}
			/**
	   * Closes the dialog, resets the waiting area model and untouches the waiting area form.
	   */
			function _closeDialog() {
				this.new_waitingarea = {};
				this.waitingareaForm.$setUntouched(); // this resets the form itself
				$mdDialog.hide();
			}
			/**
	   * Cancels the dialog.
	   */
			function _cancelDialog() {
				$mdDialog.cancel();
			}
			/**
	   * Creates a new waiting area.
	   *
	   * @param {Object} waitingarea - The waiting area data.
	   */
			function createWaitingarea(waitingarea) {
				var _this7 = this;

				var ev = this;
				waitingarea.locationId = ev.establishmentId;
				ev.Areas.create({}, waitingarea).$promise.then(function (result) {
					ev.new_waitingarea = {};
					ev.waitingareaForm.$setPristine();
					ev.waitingareaForm.$setUntouched();
					ev.add(result);
					_this7.$translate('app.waiting_areas.SUCCESS_CREATE').then(function (msg) {
						_this7.toastr.success(msg);
					});
				}).catch(function () {
					_this7.$translate('app.waiting_areas.ERROR_CREATE').then(function (errorMsg) {
						_this7.toastr.error(errorMsg, 'Error');
					});
				});
			}
			/**
	   * Updates the information of a waiting area.
	   *
	   * @param {Object} row - The data of the waiting area to be updated.
	   */
			function updateWaitingarea(row) {
				var _this8 = this;

				var parent = this;
				var current_area_data = row;
				row.areaId = row.id;
				var areaId = row.areaId;
				this.Areas.update({ id: areaId }, current_area_data).$promise.then(function () {
					parent.getWaitingareasByEstablishment(parent.establishmentId);
					_this8.$translate('app.waiting_areas.SUCCESS_UPDATE').then(function (msg) {
						_this8.toastr.success(msg);
					});
				}).catch(function () {
					_this8.$translate('app.waiting_areas.ERROR_UPDATE').then(function (errorMsg) {
						_this8.toastr.error(errorMsg, 'Error');
					});
				});
			}
			/**
	   * Deletes a waiting area.
	   *
	   * @param {Object} waitingarea - The waiting area to be deleted.
	   */
			function deleteWaitingarea(waitingarea) {
				var _this9 = this;

				this.Areas.delete({ id: waitingarea.id }).$promise.then(function () {
					_this9.$translate('app.administration.DELETE_OK').then(function (msg) {
						_this9.toastr.success(msg, $translate.instant('app.administration.DELETE_SUCCESS'));
					});
					_this9.del(waitingarea);
				}).catch(function () {
					_this9.$translate('app.waiting_areas.ERROR_DELETE').then(function (errorMsg) {
						_this9.toastr.error(errorMsg, 'Error');
					});
				});
			}
			/**
	   * Retrieves waiting areas associated with a specific establishment.
	   *
	   * @param {string} establishmentId - The ID of the establishment to retrieve waiting areas for.
	   */
			function getWaitingareasByEstablishment(establishmentId) {
				var _this10 = this;

				// Load all waitingareas by establishment 
				this.EstablishmentsResource.getDevicesByEstablishment({ 'id': establishmentId, 'type': 'areas' }).$promise.then(function (result) {
					_this10.noData = result.length == 0 ? true : false;
					_this10.fail = false;
					_this10.originalData = angular.copy(result.reverse());
					_this10._createUsingFullOptions(result);
				}).catch(function (error) {
					console.log(error);
					_this10.$translate('app.consumers.ERROR_GETBYESTABLISHMENT').then(function (errorMsg) {
						_this10.toastr.error(errorMsg, 'Error');
					});
				});
			}
			/**
	   * Retrieves screens associated with a specific establishment.
	   *
	   * @param {string} establishmentId - The ID of the establishment to retrieve screens for.
	   */
			function getScreensByEstablishment(establishmentId) {
				var _this11 = this;

				// Load all waitingareas by establishment 
				this.EstablishmentsResource.getDevicesByEstablishment({ 'id': establishmentId, 'type': 'screens' }).$promise.then(function (result) {
					_this11.screens = result;
				}).catch(function (error) {
					console.log(error);
					_this11.$translate('app.consumers.ERROR_GETBYESTABLISHMENT').then(function (errorMsg) {
						_this11.toastr.error(errorMsg, 'Error');
					});
				});
			}
			/**
	   * Toggles the display of options identified by the given ID.
	   *
	   * @param {string} id - The ID of the options to toggle.
	   */
			function getEstablismentByOrganization(organization_id) {
				var _this12 = this;

				if (!organization_id) {
					this.searchText = '';
					this.establishments = [];
					return;
				}
				if (this.isRoot || this.isAdmin) {
					this.OrganizationsResource.getEstablismentByOrganization({
						id: organization_id
					}).$promise.then(function (result) {
						_this12.establishments = result;
						_this12.establishments.sort(function (a, b) {
							var aL = a.name.toLowerCase();
							var bL = b.name.toLowerCase();
							if (aL < bL) return -1;
							if (aL > bL) return 1;
							return 0;
						});
					}).catch(function () {
						_this12.$translate("app.ERROR_GETESTABLISHMENT").then(function (errorMsg) {
							_this12.toastr.error(errorMsg, "Error");
						});
					});
				}
			}
			/**
	   * Toggles the display of options identified by the given ID.
	   *
	   * @param {string} id - The ID of the options to toggle.
	   */
			function _editOptionsButton(id) {
				var opc = document.getElementById(id);
				if (opc.style.display === "none") {
					opc.style.display = "block";
				} else {
					opc.style.display = "none";
				}
				document.addEventListener('mouseup', function (e) {
					var container = document.getElementById(id);
					if (container && !container.contains(e.target)) {
						container.style.display = 'none';
					}
				}.bind(this));
			}
			/**
	   * Toggles the display of options identified by the combination of the given ID and prefix.
	   *
	   * @param {string} id - The ID of the options to toggle.
	   * @param {string} prefix - The prefix used in combination with the ID.
	   */
			function _activateOptionsButton(id, prefix) {
				var opc = document.getElementById(id + prefix);
				if (opc.style.display === "none") {
					opc.style.display = "block";
				} else {
					opc.style.display = "none";
				}
				document.addEventListener('mouseup', function (e) {
					var container = document.getElementById(id + prefix);
					if (container && !container.contains(e.target)) {
						container.style.display = 'none';
					}
				}.bind(this));
			}
			/**
	   * Handles the change of the selected item. Updates the current establishment and triggers the retrieval
	   * of waiting areas associated with the selected establishment.
	   *
	   * @param {Object} item - The selected item representing an establishment.
	   */
			function selectedItemChange(item) {
				this.establishmentInUse = '';

				if (item !== undefined) {
					var Center = JSON.parse(JSON.stringify(item));

					var current_establishment = Center;
					this.currentEstablishment = current_establishment;
					this.establishmentId = current_establishment.id;
					this.establishmentInUse = current_establishment.name;
					this.getWaitingareasByEstablishment(this.establishmentId);
					return;
				} else {
					if (this.isRoot || this.isSuperAdmin) {
						this.originalData = [];
						this._createUsingFullOptions([]);
					}
				}
			}
			/**
	   * Searches for establishments based on the provided query. The search is case-insensitive and
	   * returns results that match the query.
	   *
	   * @param {string} query - The search query.
	   * @returns {Array} - An array of establishments matching the search query.
	   */
			function querySearchSelect(query) {
				this.establishments.sort(function (a, b) {
					if (a.name < b.name) {
						return -1;
					}
					if (a.name > b.name) {
						return 1;
					}
					return 0;
				});
				var results = query ? this.establishments.filter(createFilterFor(query)) : this.establishments;
				return results;
			}
			/**
	   * Creates a filter function for searching establishments based on a query.
	   *
	   * @param {string} query - The search query.
	   * @returns {Function} - A filter function to be used in the search.
	   */
			var createFilterFor = function createFilterFor(query) {
				var lowercaseQuery = query.toLowerCase();
				return function filterFn(item) {
					var lowerCaseValue = item.name.toLowerCase();
					return lowerCaseValue.indexOf(lowercaseQuery) === 0;
				};
			};
			/**
	   * Performs a search for organizations based on the given query.
	   *
	   * @param {string} query - The search query.
	   * @returns {Array} - An array of organizations matching the query.
	   */
			function querySearchSelectOrganizations(query) {
				this.establishments.sort(function (a, b) {
					if (a.name < b.name) {
						return -1;
					}
					if (a.name > b.name) {
						return 1;
					}
					return 0;
				});
				var results = query ? this.organizations.filter(createFilterFor(query)) : this.organizations;
				return results;
			}
			// exports
			angular.extend(this, {
				config: config,
				createWaitingarea: createWaitingarea,
				updateWaitingarea: updateWaitingarea,
				deleteWaitingarea: deleteWaitingarea,
				getWaitingareasByEstablishment: getWaitingareasByEstablishment,
				getScreensByEstablishment: getScreensByEstablishment,
				_createUsingFullOptions: _createUsingFullOptions,
				pageSizeChanged: pageSizeChanged,
				_asignDialog: _asignDialog,
				_closeDialog: _closeDialog,
				_cancelDialog: _cancelDialog,
				_showWaitingareaForm: _showWaitingareaForm,
				_showWaitingareaEdit: _showWaitingareaEdit,
				_sendWaitingarea: _sendWaitingarea,
				_validateInputs: _validateInputs,
				_editOptionsButton: _editOptionsButton,
				_activateOptionsButton: _activateOptionsButton,
				_selectPlace: _selectPlace,
				_detailWaitingarea: _detailWaitingarea,
				_showDetailDialog: _showDetailDialog,
				_detailAsignedWaitingarea: _detailAsignedWaitingarea,
				selectedItemChange: selectedItemChange,
				querySearchSelect: querySearchSelect,
				getEstablismentByOrganization: getEstablismentByOrganization,
				querySearchSelectOrganizations: querySearchSelectOrganizations

			});
		}

		_createClass(WaitingareasController, [{
			key: '$onInit',
			value: function $onInit() {
				var _this13 = this;

				var user_role = this.$localStorage.currentRole;
				var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;

				if (this.isAdmin) {
					this.getWaitingareasByEstablishment(this.establishmentId);
				}
				if (this.isRoot) {
					this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
						_this13.organizations = result;
						_this13.organizations.sort(function (a, b) {
							if (a.name.toLowerCase() < b.name.toLowerCase()) {
								return -1;
							}
							if (a.name.toLowerCase() > b.name.toLowerCase()) {
								return 1;
							}
							return 0;
						});
					}).catch(function () {
						_this13.$translate("app.ERROR_GETORGANIZATION").then(function (errorMsg) {
							_this13.toastr.error(errorMsg, "Error");
						});
					});
				}

				if (this.isSuperAdmin) {
					this.AdministrationService.getEstablishments(user_role, organizationId, "locations").then(function (result) {
						_this13.establishments = result.reverse();
					}).catch(function (error) {
						console.log(error);
						_this13.handleErrorMessage("app.ERROR_GETESTABLISHMENT");
					});
				}
			}
		}, {
			key: 'establishmentChanged',
			value: function establishmentChanged() {
				this.$localStorage.last_establishment = this.establishmentSelected;
				var current_establishment = JSON.parse(this.establishmentSelected);
				this.currentEstablishment = current_establishment;
				this.establishmentId = current_establishment.id;
				this.establishmentInUse = current_establishment.name;
				this.establishmentSelected = undefined;
				this.$scope.selectEstablishmentForm.$setPristine();
				this.getWaitingareasByEstablishment(this.establishmentId);
			}
		}]);

		return WaitingareasController;
	}();

	WaitingareasController.$inject = ['$scope', '$rootScope', 'config', 'Areas', 'EstablishmentsResource', 'OrganizationsResource', 'AdministrationService', 'NgTableParams', '$translate', 'toastr', '$mdDialog', '$localStorage', '$location'];

	exports.default = WaitingareasController;

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var WaitingareasService =

	/** @ngInject */
	function WaitingareasService() {
	  _classCallCheck(this, WaitingareasService);
	};

	//WaitingareasService.$inject = ['EmployeesResource'];

	exports.default = WaitingareasService;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _priorities = __webpack_require__(100);

	var _priorities2 = __webpack_require__(102);

	var _priorities3 = _interopRequireDefault(_priorities2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var priorities = angular.module('mod.admin.administration.priorities', []).component('priorities', _priorities.PrioritiesComponent).service('PrioritiesService', _priorities3.default).name;

	exports.default = priorities;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrioritiesComponent = undefined;

	var _priorities = __webpack_require__(101);

	var _priorities2 = _interopRequireDefault(_priorities);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var PrioritiesComponent = exports.PrioritiesComponent = {
	  controller: _priorities2.default,
	  templateUrl: 'app/modules/admin/administration/priorities/priorities.html'
	};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var PrioritiesController = function () {
	  /** @ngInject */
	  PrioritiesController.$inject = ["$scope", "$rootScope", "config", "OrganizationsResource", "EstablishmentsResource", "ServicesResource", "AdministrationService", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "pageSizeOptions"];
	  function PrioritiesController($scope, $rootScope, config, OrganizationsResource, EstablishmentsResource, ServicesResource, AdministrationService, NgTableParams, $translate, toastr, $mdDialog, $localStorage, $location, pageSizeOptions) {
	    var _this = this;

	    _classCallCheck(this, PrioritiesController);

	    this.$localStorage = $localStorage;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.isSuperAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === "string" && this.$localStorage.currentRole.toUpperCase() === "SUPERADMIN" ? true : false;
	    this.isRoot = $localStorage.currentRole && typeof $localStorage.currentRole === "string" && this.$localStorage.currentRole.toUpperCase() === "ROOT" ? true : false;
	    this.isAdmin = $localStorage.currentRole && typeof $localStorage.currentRole === "string" && this.$localStorage.currentRole.toUpperCase() === "ADMIN" ? true : false;
	    this.establishmentInUse = "";
	    var last_establishment = $localStorage.last_establishment ? $localStorage.last_establishment : false;
	    if (this.isRoot || this.isSuperAdmin) {
	      if (last_establishment) {
	        this.currentEstablishment = (typeof last_establishment === "undefined" ? "undefined" : _typeof(last_establishment)) != "object" ? JSON.parse(last_establishment) : last_establishment;
	        this.establishmentId = this.currentEstablishment.id;
	      }
	    } else {
	      this.establishmentId = this.$localStorage.currentLocation.id;
	    }
	    this.isPre = config.IS_PRE;
	    this.OrganizationsResource = OrganizationsResource;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.ServicesResource = ServicesResource;
	    this.AdministrationService = AdministrationService;
	    this.config = config;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.$mdDialog = $mdDialog;
	    this.isAdding = false;
	    this.fail = false;
	    this.organizations = [];
	    this.establishments = [];
	    this.searchTextOrganization = "";
	    this.searchText = "";
	    this.current_service = {
	      identifier: "",
	      _id: "",
	      description: "",
	      display: "",
	      pattern: "",
	      asigned: ""
	    };

	    this.isValidDate = true; // has default values
	    this.isValidTime = false; // no default values
	    this.service = {};
	    this.rowFormServ = {};
	    this.typeInput = "";
	    this.count = 10;
	    this.pageSizeOptions = pageSizeOptions;
	    this.pageSizeOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

	    // Control of sidemenu page
	    var url = $location.url().substring(1).toUpperCase();
	    this.$rootScope.currentPage = currentPage(1);
	    /**
	     * Gets the current page based on the index in the URL path.
	     * @function
	     * @name currentPage
	     * @param {number} index - The index in the URL path to retrieve the current page.
	     * @returns {string} - The name of the current page at the specified index in the URL path.
	     */
	    function currentPage(index) {
	      var split_url = url.split("/");
	      return split_url[index];
	    }
	    /**
	     * Handles the change of page size for a table.
	     * @function
	     * @name pageSizeChanged
	     * @param {number} newPageSize - The new page size to be set for the table.
	     */
	    var pageSizeChanged = function pageSizeChanged(newPageSize) {
	      _this.tableParams.count(newPageSize);
	      _this.count = newPageSize;
	    };
	    /**
	     * Creates a new NgTableParams instance using full options, initializing it with the provided data_services.
	     * @function
	     * @name _createUsingFullOptions
	     * @param {Array} data_services - The dataset to be used for initializing the NgTableParams instance.
	     * @returns {NgTableParams} The newly created NgTableParams instance.
	     */
	    function _createUsingFullOptions(data_services) {
	      var initialParams = {
	        count: this.count // initial page size
	      };
	      var initialSettings = {
	        // page size buttons (right set of buttons in demo)
	        counts: [],
	        // determines the pager buttons (left set of buttons in demo)
	        paginationMaxBlocks: 13,
	        paginationMinBlocks: 2,
	        dataset: data_services
	      };
	      this.tableParams = new NgTableParams(initialParams, initialSettings);
	      return this.tableParams;
	    }
	    /**
	     * Adds a new template to the NgTable dataset, unshifting it to the beginning, and reloads the table.
	     * @function
	     * @name add
	     * @param {Object} new_template - The new template to be added to the dataset.
	     */
	    function add(new_template) {
	      this.tableParams.settings().dataset.unshift(new_template);
	      this.tableParams.sorting({});
	      this.tableParams.page(1);
	      this.tableParams.reload();
	    }
	    /**
	     * Retrieves services by establishment, applying a filter to exclude services with the type "booking."
	     * Loads the data and initializes the NgTable with the result.
	     * @function
	     * @name getServicesByEstablishment
	     * @param {string} establishmentId - The ID of the establishment for which services are retrieved.
	     */
	    function getServicesByEstablishment(establishmentId) {
	      var _this2 = this;

	      // Load all services by establishment
	      var filter = '{"where": {"serviceType": {"neq" : "booking"}},"order":"order ASC"}';
	      this.EstablishmentsResource.getDevicesByEstablishment({
	        id: establishmentId,
	        type: "queueTypes",
	        filter: filter
	      }).$promise.then(function (result) {
	        _this2.noData = result.length == 0 ? true : false;
	        _this2.fail = false;
	        _this2.originalData = angular.copy(result);
	        angular.forEach(result, function (item) {
	          if (item.open) {
	            item.open = new Date(item.open);
	          }
	          if (item.close) {
	            item.close = new Date(item.close);
	          }
	        });
	        _this2._createUsingFullOptions(result);
	      }).catch(function (error) {
	        console.error("ERROR getServicesByEstablishment", error);
	        _this2.$translate("app.services.ERROR_GETSERVICESBYESTABLISHMENT").then(function (errorMsg) {
	          _this2.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Hides the HTML element with the specified ID.
	     * @function
	     * @name hideElement
	     * @param {string} id - The ID of the HTML element to hide.
	     */
	    function hideElement(id) {
	      var menu = document.getElementById("" + id);
	      if (menu) {
	        menu.style.display = "none";
	      }
	    }
	    /**
	     * Displays a detail dialog for a service using Angular Material's $mdDialog service.
	     * @function
	     * @name _showDetailDialog
	     * @param {Event} ev - The event that triggered the opening of the dialog.
	     * @throws {Error} If there are issues with displaying the dialog or resolving it.
	     */
	    function _showDetailDialog(ev) {
	      var _this3 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#dialog_detail_service",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this3;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      }).then(function () {
	        _showProgrammingDialog(ev);
	      });
	    }
	    /**
	     * Displays a programming dialog for a service using Angular Material's $mdDialog service.
	     * @function
	     * @name _showProgrammingDialog
	     * @param {Event} ev - The event that triggered the opening of the dialog.
	     * @throws {Error} If there are issues with displaying the dialog or resolving it.
	     */
	    function _showProgrammingDialog(ev) {
	      var _this4 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#dialog_programming_service",
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this4;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      });
	    }
	    /**
	     * Sends programming information for a service.
	     * @function
	     * @name _sendProgrammingService
	     * @param {Object} service - The service object containing programming information.
	     */
	    function _sendProgrammingService(service) {
	      console.log("_sendProgrammingService", service);
	    }
	    /**
	     * Retrieves data for a service from the server.
	     * @function
	     * @name _dataService
	     * @param {Object} service - The service object for which data is retrieved.
	     */
	    function _dataService(service) {
	      var _this5 = this;

	      this.ServicesResource.getServiceData({
	        type: "queues",
	        id: service.queueId
	      }).$promise.then(function (result) {
	        _this5.current_service = result;
	        _this5.current_service.programmingType = result.programmingType ? result.programmingType : "isDateSelected";
	      }).catch(function (error) {
	        console.error(error);
	        _this5.$translate("app.API_ERROR").then(function (errorMsg) {
	          _this5.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Displays detailed information for a service, retrieves data if not in editing mode, and shows the detail dialog.
	     * @function
	     * @name _detailService
	     * @param {Object} service - The service object for which detailed information is displayed.
	     */
	    function _detailService(service) {
	      if (service.isEditing !== true) {
	        this._dataService(service);
	        this._showDetailDialog();
	      }
	    }
	    /**
	     * Initiates programming for a service, setting default date values and displaying the programming dialog if not in editing mode.
	     * @function
	     * @name _programmingService
	     * @param {Object} service - The service object for which programming is initiated.
	     */
	    function _programmingService(service) {
	      if (service.isEditing !== true) {
	        this.minDateFrom = new Date();
	        this.minDateTo = new Date();
	        this.minDateTo.setDate(this.minDateTo.getDate() + 1);
	        this.current_service.dateStart = this.current_service.dateStart ? this.current_service.dateStart : this.minDateFrom;
	        this.current_service.dateEnd = this.current_service.dateEnd ? this.current_service.dateEnd : this.minDateTo;
	        this._showProgrammingDialog();
	      }
	    }
	    /**
	     * Displays a dialog for changing images associated with a service, allowing interaction with the images and updating the service accordingly.
	     * @function
	     * @name _changeImageDialog
	     * @param {Object} ser - The service object for which the image dialog is displayed.
	     * @param {Object} rowForm - The form object associated with the service row.
	     * @param {string} typeInput - The type of input (e.g., "background" or "logo").
	     */
	    function _changeImageDialog(ser, rowForm, typeInput) {
	      var _this6 = this;

	      this.typeInput = typeInput;
	      this.service = ser;
	      this.rowFormServ = rowForm;
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: "#changeImageDialog",
	        parent: angular.element(document.body),
	        controller: function controller() {
	          return _this6;
	        },
	        controllerAs: "ctrl",
	        clickOutsideToClose: true
	      });
	    }
	    /**
	     * Deletes the image link associated with a specific type in the given row, updating and saving the changes.
	     * @function
	     * @name deleteImage
	     * @param {Object} row - The row object containing the image link to be deleted.
	     * @param {Object} rowForm - The form object associated with the row.
	     * @param {string} type - The type of image link to be deleted (e.g., "local_promo_link").
	     */
	    function deleteImage(row, rowForm, type) {
	      if (type === "local_promo_link") {
	        row.local_promo_link = "";
	      }
	      this.save(row, rowForm);
	    }
	    /**
	     * Updates the image link based on the provided image for a specific type ("local_promo_link").
	     * @function
	     * @name updateImages
	     * @param {string} img - The new image link to be assigned.
	     */
	    function updateImages(img) {
	      if (this.typeInput === "local_promo_link") {
	        this.service.local_promo = img;
	      }
	    }
	    /**
	     * Saves the updated image for the current service using the specified form.
	     * @function
	     * @name saveUpdatedImage
	     */
	    function saveUpdatedImage() {
	      this.save(this.service, this.rowFormServ);
	    }
	    /**
	     * Displays a confirmation dialog for deleting a service and invokes the unassignService function if accepted.
	     * @function
	     * @name showDeleteConfirm
	     * @param {Object} ev - The event object.
	     */
	    function showDeleteConfirm(ev) {
	      var current_scope = this;
	      hideElement(ev.id);
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant("app.administration.CONFIRM_DELETE")).targetEvent(ev).ok($translate.instant("app.common.ACCEPT")).cancel($translate.instant("app.common.CANCEL"));

	      $mdDialog.show(confirm).then(function () {
	        current_scope.unassignService(ev);
	      });
	    }
	    /**
	     * Unassigns a service by deleting it and then calls the del function.
	     * @function
	     * @name unassignService
	     * @param {Object} service - The service to be unassigned.
	     */
	    function unassignService(service) {
	      var _this7 = this;

	      this.current_service = service;
	      this.ServicesResource.deleteQueueType({
	        type: "queueTypes",
	        id: this.current_service.id
	      }).$promise.then(function () {
	        _this7.del(service);
	      }).catch(function (error) {
	        console.error(error);
	        _this7.$translate("app.API_ERROR").then(function (errorMsg) {
	          _this7.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Deletes a row from the dataset and reloads the table.
	     * @function
	     * @name del
	     * @param {Object} row - The row to be deleted.
	     */
	    function del(row) {
	      var $this = this;
	      var main_dataset = this.tableParams.settings().dataset;
	      var originalData = "";
	      angular.forEach(this.tableParams.settings().dataset, function (value, key) {
	        if (angular.equals(row, value)) {
	          main_dataset.splice(key, 1);
	          originalData = angular.copy(main_dataset);
	        }
	      });
	      this.originalData = originalData;
	      this.tableParams.reload().then(function (data) {
	        if (data.length === 0 && $this.tableParams.total() > 0) {
	          $this.tableParams.page($this.tableParams.page() - 1);
	          $this.tableParams.reload();
	        }
	      });
	    }
	    /**
	     * Validates numeric input based on the provided rules and displays error messages accordingly.
	     * @function
	     * @name _validateInputs
	     * @param {number} value - The input value to be validated.
	     * @param {string} id - The identifier associated with the input.
	     * @param {Object} rowForm - The form object associated with the row.
	     */
	    var _validateInputs = function _validateInputs(value, id, rowForm) {
	      var errName = document.getElementById("err_" + id);
	      var colorErro = "rgba(219, 72, 73, 1)";
	      var idErr = (id + "_err").toUpperCase();
	      var idErrLength = (id + "_err_length_priority").toUpperCase();
	      var idErrLengthT = (id + "_err_length_timeAlert").toUpperCase();

	      var regex = /^[0-9]+$/;
	      if (!regex.test(value)) {
	        errName.style.display = "block";
	        errName.innerHTML = $translate.instant("app.common." + idErr);
	        errName.style.color = colorErro;
	        rowForm !== undefined ? rowForm.$invalid = true : null;
	      } else if (id === "priority") {
	        if (value <= 0 || value > 10) {
	          errName.innerHTML = $translate.instant("app.common." + idErrLength);
	          errName.style.display = "block";
	          errName.style.color = colorErro;
	          rowForm !== undefined ? rowForm.$invalid = true : null;
	        } else {
	          errName.style.display = "none";
	          rowForm !== undefined ? rowForm.$invalid = false : null;
	        }
	      } else if (id === "timeAlert") {
	        if (value <= 0 || value > 60) {
	          errName.innerHTML = $translate.instant("app.common." + idErrLengthT);
	          errName.style.display = "block";
	          errName.style.color = colorErro;
	          rowForm !== undefined ? rowForm.$invalid = true : null;
	        } else {
	          errName.style.display = "none";
	          rowForm !== undefined ? rowForm.$invalid = false : null;
	        }
	      } else {
	        errName.style.display = "none";
	        rowForm !== undefined ? rowForm.$invalid = false : null;
	      }
	    };
	    /**
	     * Validates the uniqueness of the order value among the original dataset and displays an error message if duplicated.
	     * @function
	     * @name _validateOrder
	     * @param {number} value - The order value to be validated.
	     * @param {string} id - The identifier associated with the input.
	     */
	    var _validateOrder = function _validateOrder(value, id, rowForm) {
	      var sameOrder = _this.originalData.some(function (item) {
	        return item.order === value;
	      });
	      var errName = document.getElementById("err_" + id);
	      var colorErr = "rgba(219, 72, 73, 1)";

	      if (sameOrder) {
	        errName.style.display = "block";
	        errName.innerHTML = "No se puede asignar el mismo orden a más de un servicio";
	        errName.style.color = colorErr;
	        rowForm !== undefined ? rowForm.$invalid = true : null;
	      } else {
	        errName.style.display = "none";
	        rowForm !== undefined ? rowForm.$invalid = false : null;
	      }
	    };
	    /**
	     * Saves the changes made to a row, updating the original data and resetting the row form.
	     * Displays error messages related to priority and previousNotificationLimit fields.
	     * @function
	     * @name save
	     * @param {object} row - The row containing the changes to be saved.
	     * @param {object} rowForm - The form associated with the row.
	     */
	    function save(row, rowForm) {
	      var organization_name = this.organizationSelected && this.organizationSelected.name || this.$localStorage.currentOrganization.name;
	      var normal_name = organization_name.replace(new RegExp(" ", "g"), "_");

	      if (row.local_promo) {
	        row.local_promo.organizationName = normal_name;
	        row.local_promo.type = row.local_promo.filetype.split("/")[1];
	      }

	      var originalRow = this.resetRow(row, rowForm);

	      angular.extend(originalRow, row);

	      this.isAdding = false;

	      this.updateService(originalRow, row);

	      document.getElementById("err_priority").style.display = "none";

	      document.getElementById("err_previousNotificationLimit").style.display = "none";
	    }
	    /**
	     * Resets the specified row, updating the original data and resetting the row form.
	     * If the row is in the process of being added, the original data is updated with the new row.
	     * @function
	     * @name resetRow
	     * @param {object} row - The row to be reset.
	     * @param {object} rowForm - The form associated with the row.
	     * @returns {object} - The original data corresponding to the reset row.
	     */
	    function resetRow(row, rowForm) {
	      var row_isAdding = this.isAdding;
	      if (row_isAdding) {
	        this.originalData = angular.copy(this.tableParams.settings().dataset);
	      }
	      var return_value = "";
	      row.isEditing = false;
	      rowForm.$setPristine();
	      angular.forEach(this.originalData, function (value) {
	        if (!row_isAdding && row.id === value.id) {
	          return_value = value;
	        } else if (row_isAdding && value.id === "") {
	          return_value = value;
	        }
	      });
	      return return_value;
	    }
	    /**
	     * Updates the service with the provided data.
	     * It logs the updated row, sets the serviceId in the row, and calls the API to update the service.
	     * @function
	     * @name updateService
	     * @param {object} originalRow - The original data of the service before any updates.
	     * @param {object} row - The updated data of the service.
	     */
	    function updateService(originalRow, row) {
	      var _this8 = this;

	      var current_service_data = row;
	      row.serviceId = row.id;
	      var serviceId = row.serviceId;
	      this.ServicesResource.updateQueueType({ type: "queueTypes", id: serviceId }, current_service_data).$promise.then(function (result) {
	        row.local_promo_link = row.local_promo_link != result.local_promo_link ? result.local_promo_link : row.local_promo_link;
	        angular.extend(originalRow, row);
	        _this8._closeDialog();
	        _this8.selectedItemChange(_this8.currentEstablishment);
	      }).catch(function (error) {
	        console.error("updateService", error);
	        _this8.$translate("app.API_ERROR").then(function (errorMsg) {
	          _this8.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Cancels the changes made to the service row.
	     * It resets the row to its original state and updates the row with the original data.
	     * @function
	     * @name cancel
	     * @param {object} row - The current state of the service data.
	     * @param {object} rowForm - The form associated with the service row.
	     */
	    function cancel(row, rowForm) {
	      var originalRow = this.resetRow(row, rowForm);
	      angular.extend(row, originalRow);
	    }
	    /**
	     * Validates the start and end dates of a service.
	     * Checks if both dates are provided and if the start date is before the end date.
	     * @function
	     * @name _validateDates
	     * @param {object} service - The service data to validate.
	     * @returns {boolean} isValidDate - Indicates whether the dates are valid.
	     */
	    function _validateDates(service) {
	      if (!service.dateStart || service.dateStart == "" || !service.dateEnd || service.dateEnd == "") {
	        this.isValidDate = false;
	      } else if (service.dateStart >= service.dateEnd) {
	        this.isValidDate = false;
	      } else {
	        this.isValidDate = true;
	      }
	      return this.isValidDate;
	    }
	    /**
	     * Validates the start and end times of a service.
	     * Checks if both times are provided and if the start time is before the end time.
	     * @function
	     * @name _validateTime
	     * @param {string} from - The origin of the time validation (used for debugging or tracking).
	     * @param {object} service - The service data to validate.
	     * @returns {boolean} isValidTime - Indicates whether the times are valid.
	     */
	    function _validateTime(from, service) {
	      if (!service.timeStart || service.timeStart == "" || !service.timeEnd || service.timeEnd == "") {
	        this.isValidTime = false;
	      } else if (service.timeStart >= service.timeEnd) {
	        this.isValidTime = false;
	      } else {
	        this.isValidTime = true;
	      }
	      return this.isValidTime;
	    }
	    /**
	     * Closes the current dialog.
	     * @function
	     * @name _closeDialog
	     */
	    function _closeDialog() {
	      $mdDialog.hide();
	    }
	    /**
	     * Toggles the display of options button with the specified ID.
	     * Hides the button if it's visible, shows it if it's hidden.
	     * Also, adds an event listener to close the options when clicking outside the container.
	     *
	     * @function
	     * @name _editOptionsButton
	     * @param {string} id - The ID of the options button to be toggled.
	     */
	    function _editOptionsButton(id) {
	      var opc = document.getElementById(id);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Toggles the display of options button with the specified ID and prefix.
	     * Hides the button if it's visible, shows it if it's hidden.
	     * Also, adds an event listener to close the options when clicking outside the container.
	     *
	     * @function
	     * @name _activateOptionsButton
	     * @param {string} id - The ID of the options button to be toggled.
	     * @param {string} prefix - The prefix to be appended to the ID.
	     */
	    function _activateOptionsButton(id, prefix) {
	      var opc = document.getElementById(id + prefix);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id + prefix);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }
	    /**
	     * Handles the change event when a new item is selected in the establishment dropdown.
	     * Updates the current establishment, establishment ID, and triggers fetching services for the selected establishment.
	     * If no item is selected, it resets the data for super admin or root user.
	     *
	     * @function
	     * @name selectedItemChange
	     * @param {Object} item - The selected item from the establishment dropdown.
	     */
	    function selectedItemChange(item) {
	      this.establishmentInUse = "";
	      if (item !== undefined) {
	        var Center = JSON.parse(JSON.stringify(item));
	        var current_establishment = Center;
	        this.currentEstablishment = current_establishment;
	        this.establishmentId = current_establishment.id;
	        this.establishmentInUse = current_establishment.name;
	        this.getServicesByEstablishment(this.establishmentId);
	        return;
	      } else {
	        if (this.isRoot || this.isSuperAdmin) {
	          this.originalData = [];
	          this._createUsingFullOptions([]);
	        }
	      }
	    }
	    /**
	     * Performs a search query on the list of establishments.
	     * Filters the establishments based on the provided query.
	     *
	     * @function
	     * @name querySearchSelect
	     * @param {string} query - The search query to filter establishments.
	     * @returns {Array} - An array of establishments that match the search query.
	     */
	    function querySearchSelect(query) {
	      var results = query ? this.establishments.filter(createFilterFor(query)) : this.establishments;
	      return results;
	    }
	    /**
	     * Creates a filter function for searching establishments.
	     * Compares the lowercase name of each establishment with the lowercase query.
	     *
	     * @function
	     * @name createFilterFor
	     * @param {string} query - The search query to filter establishments.
	     * @returns {Function} - A filter function that matches establishments with the query.
	     */
	    var createFilterFor = function createFilterFor(query) {
	      var lowercaseQuery = query.toLowerCase();
	      return function filterFn(item) {
	        var lowerCaseValue = item.name.toLowerCase();
	        return lowerCaseValue.indexOf(lowercaseQuery) === 0;
	      };
	    };
	    /**
	     * Retrieves establishments by organization ID and updates the component's state accordingly.
	     * If organization ID is falsy, sets the searchText to an empty string and clears the establishments array.
	     * If the user is a root or admin, makes a request to get establishments by organization ID, sorts the result by name, and updates the establishments array.
	     *
	     * @function
	     * @name getEstablismentByOrganization
	     * @param {string} organization_id - The ID of the organization to retrieve establishments for.
	     * @returns {void}
	     */
	    function getEstablismentByOrganization(organization_id) {
	      var _this9 = this;

	      if (!organization_id) {
	        this.searchText = "";
	        this.establishments = [];
	        return;
	      }
	      if (this.isRoot || this.isAdmin) {
	        this.OrganizationsResource.getEstablismentByOrganization({
	          id: organization_id
	        }).$promise.then(function (result) {
	          _this9.establishments = result;
	          _this9.establishments.sort(function (a, b) {
	            var aL = a.name.toLowerCase();
	            var bL = b.name.toLowerCase();
	            if (aL < bL) return -1;
	            if (aL > bL) return 1;
	            return 0;
	          });
	        }).catch(function () {
	          _this9.$translate("app.ERROR_GETESTABLISHMENT").then(function (errorMsg) {
	            _this9.toastr.error(errorMsg, "Error");
	          });
	        });
	      }
	    }
	    /**
	     * Queries the organizations based on the input query and returns the filtered results.
	     * Sorts the establishments array by name.
	     *
	     * @function
	     * @name querySearchSelectOrganizations
	     * @param {string} query - The input query to filter organizations.
	     * @returns {Array} - An array of filtered organizations.
	     */
	    function querySearchSelectOrganizations(query) {
	      this.organizations.sort(function (a, b) {
	        if (a.name < b.name) {
	          return -1;
	        }
	        if (a.name > b.name) {
	          return 1;
	        }
	        return 0;
	      });
	      var results = query ? this.organizations.filter(createFilterFor(query)) : this.organizations;
	      return results;
	    }
	    // exports
	    angular.extend(this, {
	      config: config,
	      _createUsingFullOptions: _createUsingFullOptions,
	      _showDetailDialog: _showDetailDialog,
	      _showProgrammingDialog: _showProgrammingDialog,
	      _programmingService: _programmingService,
	      _sendProgrammingService: _sendProgrammingService,
	      _validateDates: _validateDates,
	      _validateTime: _validateTime,
	      pageSizeChanged: pageSizeChanged,
	      _closeDialog: _closeDialog,
	      _detailService: _detailService,
	      _editOptionsButton: _editOptionsButton,
	      _activateOptionsButton: _activateOptionsButton,
	      getServicesByEstablishment: getServicesByEstablishment,
	      showDeleteConfirm: showDeleteConfirm,
	      unassignService: unassignService,
	      _dataService: _dataService,
	      add: add,
	      del: del,
	      save: save,
	      _validateInputs: _validateInputs,
	      cancel: cancel,
	      resetRow: resetRow,
	      updateService: updateService,
	      selectedItemChange: selectedItemChange,
	      querySearchSelect: querySearchSelect,
	      _changeImageDialog: _changeImageDialog,
	      deleteImage: deleteImage,
	      updateImages: updateImages,
	      saveUpdatedImage: saveUpdatedImage,
	      _validateOrder: _validateOrder,
	      getEstablismentByOrganization: getEstablismentByOrganization,
	      querySearchSelectOrganizations: querySearchSelectOrganizations
	    });
	  }

	  _createClass(PrioritiesController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this10 = this;

	      var user_role = this.$localStorage.currentRole;
	      var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;

	      if (this.$localStorage.currentLocation && this.$localStorage.currentLocation.id) {
	        this.establishmentId = this.$localStorage.currentLocation.id;
	        this.getServicesByEstablishment(this.establishmentId);
	      }

	      if (this.isRoot) {
	        this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
	          _this10.organizations = result;
	          _this10.organizations.sort(function (a, b) {
	            if (a.name.toLowerCase() < b.name.toLowerCase()) {
	              return -1;
	            }
	            if (a.name.toLowerCase() > b.name.toLowerCase()) {
	              return 1;
	            }
	            return 0;
	          });
	        }).catch(function () {
	          _this10.$translate("app.ERROR_GETORGANIZATION").then(function (errorMsg) {
	            _this10.toastr.error(errorMsg, "Error");
	          });
	        });
	      }

	      if (this.isSuperAdmin) {
	        this.AdministrationService.getEstablishments(user_role, organizationId, "locations").then(function (result) {
	          _this10.establishments = result.reverse();
	        }).catch(function (error) {
	          console.error(error);
	          _this10.handleErrorMessage("app.ERROR_GETESTABLISHMENT");
	        });
	      }
	    }
	  }, {
	    key: "establishmentChanged",
	    value: function establishmentChanged() {
	      this.$localStorage.last_establishment = this.establishmentSelected;
	      var current_establishment = JSON.parse(this.establishmentSelected);
	      this.currentEstablishment = current_establishment;
	      this.establishmentId = current_establishment.id;
	      this.establishmentInUse = current_establishment.name;
	      this.establishmentSelected = undefined;
	      this.$scope.selectEstablishmentForm.$setPristine();
	      // Load all services by establishment
	      this.getServicesByEstablishment(this.establishmentId);
	    }
	  }]);

	  return PrioritiesController;
	}();

	PrioritiesController.$inject = ["$scope", "$rootScope", "config", "OrganizationsResource", "EstablishmentsResource", "ServicesResource", "AdministrationService", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location"];

	exports.default = PrioritiesController;

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var PrioritiesService =

	/** @ngInject */
	function PrioritiesService() {
	  _classCallCheck(this, PrioritiesService);
	};

	exports.default = PrioritiesService;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _booking = __webpack_require__(104);

	var _booking2 = __webpack_require__(106);

	var _booking3 = _interopRequireDefault(_booking2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var booking = angular.module('mod.admin.administration.booking', []).component('booking', _booking.BookingComponent).service('BookingService', _booking3.default).name;

	exports.default = booking;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BookingComponent = undefined;

	var _booking = __webpack_require__(105);

	var _booking2 = _interopRequireDefault(_booking);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var BookingComponent = exports.BookingComponent = {
	  controller: _booking2.default,
	  templateUrl: 'app/modules/admin/administration/booking/booking.html'
	};

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var BookingController = function () {

		/** @ngInject */
		BookingController.$inject = ["$rootScope", "$scope", "config", "AdministrationService", "ServicesResource", "OrganizationsResource", "EstablishmentsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location"];
		function BookingController($rootScope, $scope, config, AdministrationService, ServicesResource, OrganizationsResource, EstablishmentsResource, NgTableParams, $translate, toastr, $mdDialog, $localStorage, $location) {
			_classCallCheck(this, BookingController);

			// private
			this.$rootScope = $rootScope;
			this.$scope = $scope;
			this.$localStorage = $localStorage;
			this.isSuperAdmin = this.$localStorage.currentUser.role !== 'superadmin' ? true : false;
			this.currentRole = this.$localStorage.currentRole;
			this.establishmentId = config.ESTABLISHMENT_ID;
			this.isPre = config.IS_PRE;
			this.ServicesResource = ServicesResource;
			this.EstablishmentsResource = EstablishmentsResource;
			this.OrganizationsResource = OrganizationsResource;
			this.AdministrationService = AdministrationService;
			this.config = config;
			this.$translate = $translate;
			this.toastr = toastr;
			this.$mdDialog = $mdDialog;
			this.isAdding = false;
			this.fail = false;
			this.servicesSelected = [];
			this.hasServicesSelected = false;
			this.current_service = {
				"identifier": "",
				"_id": "",
				"description": "",
				"display": "",
				"pattern": "",
				"asigned": ""
			};

			this.showDisassignConfirm = showDisassignConfirm;
			this.save = save;
			this.add = add;
			// Control of sidemenu page
			var url = $location.url().substring(1).toUpperCase();
			this.$rootScope.currentPage = currentPage(1);
			var last_establishment = $localStorage.last_establishment ? $localStorage.last_establishment : false;
			if (this.isRoot || this.isSuperAdmin) {
				if (last_establishment) {
					this.currentEstablishment = (typeof last_establishment === "undefined" ? "undefined" : _typeof(last_establishment)) != 'object' ? JSON.parse(last_establishment) : last_establishment;
					this.establishmentId = this.currentEstablishment.id;
					this.establishmentInUse = this.currentEstablishment.name;
				}
			} else {
				this.establishmentId = $localStorage.currentLocation.id;
				this.establishmentInUse = $localStorage.currentLocation.name;
			}

			/**
	   * The function `currentPage` takes an index parameter and returns the corresponding segment of the
	   * URL.
	   * @param index - The index parameter is the position of the element in the split_url array that you
	   * want to retrieve.
	   * @returns the element at the specified index in the split_url array.
	   */
			function currentPage(index) {
				var split_url = url.split('/');
				return split_url[index];
			}

			/**
	   * The function adds a new template to a dataset, resets the sorting and paging settings, and reloads
	   * the table.
	   * @param new_template - The parameter `new_template` is the new item that you want to add to the
	   * dataset.
	   */
			function add(new_template) {
				this.tableParams.settings().dataset.unshift(new_template);
				this.tableParams.sorting({});
				this.tableParams.page(1);
				this.tableParams.reload();
			}

			/**
	   * The function `showDisassignConfirm` displays a confirmation dialog and then calls the
	   * `disassignService` function with a specific parameter if the user accepts the confirmation.
	   * @param location - The location parameter is an object that represents a specific location. It
	   * likely has properties such as id, name, address, etc.
	   * @param ev - The `ev` parameter is the event object that triggered the function. It is typically
	   * used to determine the target element or to pass additional information about the event.
	   */
			function showDisassignConfirm(location, ev) {
				var current_scope = this;
				// Appending dialog to document.body to cover sidenav in docs app
				var confirm = $mdDialog.confirm().title($translate.instant('app.administration.CONFIRM_DELETE')).targetEvent(ev).ok($translate.instant('app.common.ACCEPT')).cancel($translate.instant('app.common.CANCEL'));

				$mdDialog.show(confirm).then(function () {
					var queueTypeId = '';
					current_scope.current_service.establishments.map(function (queueType) {
						if (queueType.locationId == location.id) queueTypeId = queueType.id;
					});
					current_scope.disassignService(queueTypeId);
				}, function () {});
			}

			/**
	   * The function saves a row of data by updating the service and modifying the promo object if it
	   * exists.
	   * @param row - The `row` parameter is an object that contains data for saving. It likely has
	   * properties such as `promo`, `organizationName`, and `filetype`.
	   */
			function save(row) {
				var normal_name = this.$localStorage.currentOrganization.name.replace(new RegExp(' ', 'g'), '_');
				if (row.promo) {
					row.promo.organizationName = normal_name;
					row.promo.type = row.promo.filetype.split('/')[1];
				}
				this.updateService(row);
			}

			/**
	   * The function _showServiceForm is used to display a dialog box in AngularJS.
	   * @param ev - The event object that triggered the function. It is used to determine the position of
	   * the dialog box.
	   */
			function _showServiceForm(ev) {
				var _this = this;

				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#myDialog',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				});
			}

			/**
	   * The function `_showDetailDialog` is used to display a dialog box with detailed information about a
	   * service.
	   * @param ev - The event that triggered the dialog to be shown. This is typically passed in as the
	   *  parameter in the function that calls _showDetailDialog.
	   */
			function _showDetailDialog(ev) {
				var _this2 = this;

				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#dialog_detail_service',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this2;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				});
			}

			/**
	   * The function `_detailAsignedService` shows a dialog box with detailed information about an
	   * assigned service.
	   * @param ev - The event object that triggered the function. It is typically passed as an argument
	   * when calling the function and contains information about the event that occurred (e.g., mouse
	   * click, key press).
	   */
			function _detailAsignedService(ev) {
				var _this3 = this;

				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#dialog_detail_asigned_service',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this3;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				});
			}

			/**
	   * The function `_showAsignServiceForm` displays a dialog box for assigning a service.
	   * @param ev - The event object that triggered the function. It is typically passed as an argument
	   * when calling the function and contains information about the event that occurred (e.g., mouse
	   * click, key press).
	   */
			function _showAsignServiceForm(ev) {
				var _this4 = this;

				this.getEstablismentByOrganization();
				$mdDialog.show({
					preserveScope: true, // do not forget this if use parent scope
					hasBackdrop: true,
					contentElement: '#asignDialog',
					parent: angular.element(document.body),
					targetEvent: ev,
					controller: function controller() {
						return _this4;
					},
					controllerAs: 'ctrl',
					clickOutsideToClose: true
				});
			}

			/**
	   * The function `_sendService` sets default values for `result.asigned` and `result.status`, modifies
	   * `result.promo` by adding `organizationName` and `type` properties, calls the `createService`
	   * function, and cancels the ``.
	   * @param result - The `result` parameter is an object that contains various properties. It is used
	   * as an argument for the `_sendService` function.
	   */
			function _sendService(result) {
				// Default values
				result.asigned = false;
				result.status = false;
				if (result.promo) {
					result.promo.organizationName = this.organizationInUse.replace(new RegExp(' ', 'g'), '_');
					result.promo.type = result.promo.filetype.split('/')[1];
				}
				this.createService(result);
				$mdDialog.cancel();
			}

			/**
	   * The function `_asignService` assigns selected services to establishments.
	   * @param establishments - An object containing information about the establishments and their
	   * centers.
	   */
			function _asignService(establishments) {
				var $this = this;
				this.hasServicesSelected = false;
				angular.forEach(establishments.center, function (centerId) {
					angular.forEach($this.servicesSelected, function (value) {
						// Creamos el objeto limpio de letiables innecesarias
						var clean_queue_object = {};
						angular.forEach(value, function () {
							clean_queue_object.name = value.name;
							clean_queue_object.display = value.display;
							clean_queue_object.description = value.description;
							clean_queue_object.queueId = value.id;
							clean_queue_object.previousNotificationLimit = value.advice_number > 0 ? value.advice_number : null;
							clean_queue_object.availableTurnsLimit = null;
							clean_queue_object.locationId = centerId;
						});
						$this.ServicesResource.asignQueue({ type: 'queueTypes' }, clean_queue_object).$promise.then(function () {
							$this.new_service = {};
							$this.asignServiceForm.$setPristine();
							$this.asignServiceForm.$setUntouched();
							value.asigned = true;
							value.Selected = false;
							$this.ServicesResource.update({ type: 'queues', id: value.id }, value).$promise.then(function () {}).catch(function (error) {
								console.log(error);
								$this.$translate('app.services.ERROR_UPDATESERVICE').then(function (errorMsg) {
									$this.toastr.error(errorMsg, 'Error');
								});
							});
							$this.servicesSelected = [];
						}).catch(function (error) {
							console.log(error);
							$this.$translate('app.services.ERROR_ASIGNSERVICE').then(function (errorMsg) {
								$this.toastr.error(errorMsg, 'Error');
							});
						});
					});
				});
				$mdDialog.cancel();
			}

			/**
	   * The function `_detailService` retrieves establishment details for a given service and displays
	   * them in a dialog if the service is not currently being edited.
	   * @param service - The `service` parameter is an object that represents a service. It contains
	   * properties such as `isEditing`, `id`, and `establishments`.
	   */
			function _detailService(service) {
				var _this5 = this;

				if (service.isEditing !== true) {
					this.current_service = service;
					this.ServicesResource.getEstablishments({ id: service.id, type: 'queues', option: 'queueTypes', filter: { include: "location" } }).$promise.then(function (result) {
						service.establishments = result;
					}).catch(function (error) {
						console.log(error);
						_this5.$translate('app.services.ERROR_DETAILSERVICE_ESTABLISHMENT').then(function (errorMsg) {
							_this5.toastr.error(errorMsg, 'Error');
						});
					});
					this._showDetailDialog();
				}
			}

			/**
	   * The function `_selectService` toggles the selection of a service in an array and updates a boolean
	   * flag based on whether any services are selected.
	   * @param result - The `result` parameter is the service that is being selected or deselected.
	   */
			function _selectService(result) {
				var elem_pos = this.servicesSelected.indexOf(result);
				if (elem_pos !== -1) {
					this.servicesSelected.splice(elem_pos, 1);
				} else {
					this.servicesSelected.push(result);
				}
				this.hasServicesSelected = false;
				if (this.servicesSelected.length > 0) {
					this.hasServicesSelected = true;
				}
			}

			/**
	   * The _closeDialog function hides the current dialog.
	   */
			function _closeDialog() {
				$mdDialog.hide();
			}

			/**
	   * The function _cancelDialog() cancels a dialog box.
	   */
			function _cancelDialog() {
				$mdDialog.cancel();
			}

			/**
	   * The function creates a new service by making an API call and then resets the form.
	   * @param service - The `service` parameter is an object that represents the service to be created.
	   * It should have the following properties:
	   */
			function createService(service) {
				var _this6 = this;

				var ev = this;
				service.organizationId = this.organizationId;
				ev.ServicesResource.create({ type: 'queues' }, service).$promise.then(function (result) {
					//great, now reset the form
					ev.new_service = {}; // this resets the model
					ev.newServiceForm.$setPristine(); // this resets the form itself
					ev.newServiceForm.$setUntouched(); // this resets the form itself
					ev.add(result);
				}).catch(function (error) {
					console.log(error);
					_this6.$translate('app.services.ERROR_CREATESERVICE').then(function (errorMsg) {
						_this6.toastr.error(errorMsg, 'Error');
					});
				});
			}

			/**
	   * The function `updateService` updates a service's queue type and local promo link, and handles any
	   * errors that occur during the update process.
	   * @param row - The parameter "row" is an object that represents a service. It contains various
	   * properties such as "id", "serviceId", "local_promo_link", etc.
	   */
			function updateService(row) {
				var _this7 = this;

				console.log(row);
				var current_service_data = row;
				row.serviceId = row.id;
				var serviceId = row.serviceId;
				console.log(current_service_data);
				this.ServicesResource.updateQueueType({ type: 'queueTypes', id: serviceId }, current_service_data).$promise.then(function (result) {
					console.log(result);
					row.local_promo_link = row.local_promo_link != result.local_promo_link ? result.local_promo_link : row.local_promo_link;
				}).catch(function (error) {
					console.log(error);
					_this7.$translate('app.services.ERROR_UPDATESERVICE').then(function (errorMsg) {
						_this7.toastr.error(errorMsg, 'Error');
					});
				});
			}

			/**
	   * The function disassignService is used to delete a service and display success or error messages
	   * accordingly.
	   * @param service - The parameter "service" is the ID of the service that needs to be disassigned.
	   */
			function disassignService(service) {
				var $this = this;
				//{type: 'queues'}, service
				this.ServicesResource.delete({ type: 'queueTypes', id: service }).$promise.then(function (result) {
					console.log('RESULT disassignService:', result);
					$this.$translate('app.administration.DELETE_OK').then(function (msg) {
						$this.toastr.success(msg, $translate.instant('app.administration.DELETE_SUCCESS'));
					});
				}).catch(function (error) {
					console.log(error);
					$this.$translate('app.services.ERROR_DELETESERVICE').then(function (errorMsg) {
						$this.toastr.error(errorMsg, $translate.instant('app.administration.DELETE_ERROR_MSG'));
					});
				});
			}

			/**
	   * The function "showServices" sets the "Selected" property of each service in the "services" array
	   * to false and sets the "fail" property to false.
	   * @param services - An array of objects representing different services.
	   */
			function showServices(services) {
				angular.forEach(services, function (value) {
					value.Selected = false;
				});
				this.fail = false;
			}

			/**
	   * The function `getServicesByEstablishment` retrieves services of a specific type for a given
	   * establishment.
	   * @param establishmentId - The establishmentId parameter is the unique identifier of the
	   * establishment for which you want to retrieve the services.
	   */
			function getServicesByEstablishment(establishmentId) {
				var _this8 = this;

				var $this = this;
				var filter = '{"where":{"serviceType" : "booking"}}';
				this.EstablishmentsResource.getDevicesByEstablishment({ 'id': establishmentId, 'type': 'queueTypes', filter: filter }).$promise.then(function (result) {
					$this.noData = result.length > 0 ? false : true;
					$this.services = result;
				}).catch(function (error) {
					console.log(error);
					_this8.$translate('app.services.ERROR_GETSERVICESBYESTABLISHMENT').then(function (errorMsg) {
						_this8.toastr.error(errorMsg, 'Error');
					});
				});
			}

			/**
	   * The function `getEstablismentByOrganization` retrieves a list of establishments based on the
	   * organization ID and filters out establishments that have already been assigned to a service.
	   */
			function getEstablismentByOrganization() {
				var _this9 = this;

				this.services = [];
				var servicesId = [];
				var isAssigned = false;
				var organizationId = this.organizationId;
				console.log('servicesSelected', this.servicesSelected);
				this.servicesSelected.forEach(function (value) {
					servicesId.push(value.id);
				});
				var filter = '{"include":{"relation":"queueTypes"}}';
				// Load all queueTypes by establishment 
				this.OrganizationsResource.getEstablismentByOrganization({ 'id': organizationId, 'type': 'locations', filter: filter }).$promise.then(function (result) {
					result.map(function (service) {
						console.log('service', service);
						if (service.queueTypes.length == 0) {
							if (servicesId.indexOf(service.id) < 0) {
								delete service.queueTypes;
								_this9.services.push(service);
								servicesId.push(service.id);
							}
						} else {
							angular.forEach(service.queueTypes, function (value) {
								console.log('value', value);
								console.log('servicesId', servicesId);
								if (servicesId.indexOf(value.queueId) >= 0) {
									isAssigned = true;
								}
							});

							if (!isAssigned) {
								delete service.queueTypes;
								_this9.services.push(service);
							}
							isAssigned = false;
						}
					});
					console.log('this.services', _this9.services);
				}).catch(function (error) {
					console.log(error);
					_this9.$translate('app.ERROR_GETESTABLISHMENT').then(function (errorMsg) {
						_this9.toastr.error(errorMsg, 'Error');
					});
				});
			}

			// exports
			angular.extend(this, {
				config: config,
				createService: createService,
				updateService: updateService,
				_sendService: _sendService,
				_asignService: _asignService,
				_selectService: _selectService,
				_detailService: _detailService,
				_showAsignServiceForm: _showAsignServiceForm,
				_showServiceForm: _showServiceForm,
				_showDetailDialog: _showDetailDialog,
				_detailAsignedService: _detailAsignedService,
				_closeDialog: _closeDialog,
				_cancelDialog: _cancelDialog,
				showServices: showServices,
				getServicesByEstablishment: getServicesByEstablishment,
				disassignService: disassignService,
				getEstablismentByOrganization: getEstablismentByOrganization
			});
		}

		_createClass(BookingController, [{
			key: "$onInit",
			value: function $onInit() {
				var _this10 = this;

				var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
				this.organizationInUse = this.$localStorage.currentOrganization.name;
				this.organizationId = organizationId;
				var user_role = this.$localStorage.currentRole;

				if (this.isAdmin) {
					this.establishmentId = this.$localStorage.currentLocation.id;
				}

				if (this.establishmentId) {
					this.getServicesByEstablishment(this.establishmentId);
				}

				this.AdministrationService.getEstablishments(user_role, organizationId, 'locations').then(function (result) {
					_this10.establishments = result;
				}).catch(function (error) {
					console.log(error);
					_this10.$translate('app.ERROR_GETESTABLISHMENT').then(function (errorMsg) {
						_this10.toastr.error(errorMsg, 'Error');
					});
				});
			}
		}, {
			key: "establishmentChanged",
			value: function establishmentChanged() {
				this.$localStorage.last_establishment = this.establishmentSelected;
				var current_establishment = JSON.parse(this.establishmentSelected);
				this.currentEstablishment = current_establishment;
				this.establishmentId = current_establishment.id;
				this.establishmentInUse = current_establishment.name;
				this.establishmentSelected = undefined;
				this.$scope.selectEstablishmentForm.$setPristine();
				// Load all services by establishment 
				this.getServicesByEstablishment(this.establishmentId);
			}
		}]);

		return BookingController;
	}();

	BookingController.$inject = ['$rootScope', '$scope', 'config', 'AdministrationService', 'ServicesResource', 'OrganizationsResource', 'EstablishmentsResource', 'NgTableParams', '$translate', 'toastr', '$mdDialog', '$localStorage', '$location'];

	exports.default = BookingController;

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var BookingService =

	/** @ngInject */
	function BookingService() {
	  _classCallCheck(this, BookingService);
	};

	//BookingService.$inject = ['EmployeesResource'];

	exports.default = BookingService;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _agendas = __webpack_require__(108);

	var _agendas2 = __webpack_require__(110);

	var _agendas3 = _interopRequireDefault(_agendas2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var agendas = angular.module('mod.admin.administration.agendas', []).component('agendas', _agendas.AgendasComponent).service('AgendasService', _agendas3.default).name;

	exports.default = agendas;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AgendasComponent = undefined;

	var _agendas = __webpack_require__(109);

	var _agendas2 = _interopRequireDefault(_agendas);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var AgendasComponent = exports.AgendasComponent = {
	  controller: _agendas2.default,
	  templateUrl: 'app/modules/admin/administration/agendas/agendas.html'
	};

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AgendasController = function () {

	  /** @ngInject */
	  AgendasController.$inject = ["config", "$scope", "$rootScope", "AdministrationService", "EstablishmentsResource", "OrganizationsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$location", "$localStorage", "AgendasResource", "pageSizeOptions", "moment"];
	  function AgendasController(config, $scope, $rootScope, AdministrationService, EstablishmentsResource, OrganizationsResource, NgTableParams, $translate, toastr, $mdDialog, $location, $localStorage, AgendasResource, pageSizeOptions, moment) {
	    var _this = this;

	    _classCallCheck(this, AgendasController);

	    // private
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$localStorage = $localStorage;
	    this.isPre = config.IS_PRE;
	    this.AdministrationService = AdministrationService;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.OrganizationsResource = OrganizationsResource;

	    this.AgendasResource = AgendasResource;
	    this.config = config;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.$mdDialog = $mdDialog;
	    this.isAdding = false;
	    this.fail = false;
	    this.errorInputs = false;
	    this.pageSizeOptions = pageSizeOptions;
	    this.count = 5;

	    this.cancel = cancel;
	    this.showDeleteConfirm = showDeleteConfirm;
	    this.del = del;
	    this.save = save;
	    this.add = add;
	    this.resetRow = resetRow;
	    this.currentRole = this.$localStorage.currentRole;
	    this.mensaje = '';
	    this.editAgenda = false;

	    this.pageSizeOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
	    this.showInterna = false;
	    this.showExterna = false;
	    this.moment = moment;
	    this.BOOKED = this.config.api.BOOKED;
	    this.idBooked = null;

	    // Control of sidemenu page
	    var url = $location.url().substring(1).toUpperCase();
	    this.$rootScope.currentPage = currentPage(1);

	    /**
	     * The function `currentPage` takes an index parameter and returns the corresponding segment of the
	     * URL.
	     * @param index - The index parameter is the position of the desired element in the split_url
	     * array. It determines which part of the URL you want to retrieve.
	     * @returns the element at the specified index in the split_url array.
	     */
	    function currentPage(index) {
	      var split_url = url.split('/');
	      return split_url[index];
	    }

	    /**
	     * The function `pageSizeChanged` updates the count of a table based on a new page size value.
	     * @param newPageSize - The newPageSize parameter is the new number of items to be displayed per
	     * page in a table.
	     */
	    var pageSizeChanged = function pageSizeChanged(newPageSize) {
	      _this.tableParams.count(newPageSize);
	      _this.counter = newPageSize;
	    };

	    /* only test mode */
	    config.DEBUG_ENABLED = false;
	    /* EOF test mode */

	    /**
	     * The function creates a new NgTableParams object with initial parameters and settings.
	     * @returns an instance of the NgTableParams class.
	     */
	    function _createUsingFullOptions() {
	      var initialParams = {
	        count: this.count // initial page size
	      };
	      var initialSettings = {
	        // page size buttons (right set of buttons in demo)
	        counts: [],
	        // determines the pager buttons (left set of buttons in demo)
	        paginationMaxBlocks: 4,
	        paginationMinBlocks: 2,
	        dataset: this.data
	      };
	      this.tableParams = new NgTableParams(initialParams, initialSettings);
	      return this.tableParams;
	    }

	    /**
	     * The function creates a NgTableParams object using the provided services_data and returns it.
	     * @param services_data - The `services_data` parameter is the dataset that will be used to
	     * populate the table. It should be an array of objects, where each object represents a row in the
	     * table.
	     * @returns the `tableParams` object.
	     */
	    function _createUsingFullOptions1(services_data) {
	      var initialParams = {
	        count: this.count // initial page size
	      };
	      var initialSettings = {
	        // page size buttons (right set of buttons in demo)
	        counts: [],
	        // determines the pager buttons (left set of buttons in demo)
	        paginationMaxBlocks: 13,
	        paginationMinBlocks: 2,
	        dataset: services_data
	      };
	      this.tableParams = new NgTableParams(initialParams, initialSettings);
	      return this.tableParams;
	    }

	    /**
	     * The function adds a new template to a dataset, resets the sorting and paging settings, and
	     * reloads the table.
	     * @param new_template - The `new_template` parameter is the new item that you want to add to the
	     * dataset. It represents the data for the new item that you want to insert into the table.
	     */
	    function add(new_template) {
	      this.tableParams.settings().dataset.unshift(new_template);
	      this.tableParams.sorting({});
	      this.tableParams.page(1);
	      this.tableParams.reload();
	    }

	    /**
	     * The cancel function resets a row to its original values.
	     * @param row - The "row" parameter is the object that you want to cancel or reset.
	     */
	    function cancel(row) {
	      var originalRow = this.resetRow(row);
	      angular.extend(row, originalRow);
	    }

	    /**
	     * The function `del` is used to delete a row from a dataset and update the table parameters
	     * accordingly.
	     * @param row - The `row` parameter represents the row that needs to be deleted from the dataset.
	     */
	    function del(row) {
	      var main_dataset = this.tableParams.settings().dataset;
	      var originalData = '';
	      angular.forEach(this.tableParams.settings().dataset, function (value, key) {
	        if (angular.equals(row, value)) {
	          main_dataset.splice(key, 1);
	          originalData = angular.copy(main_dataset);
	        }
	      });
	      this.originalData = originalData;
	      var this_param = this.tableParams;
	      this.tableParams.reload().then(function (data) {
	        if (data.length === 0 && this_param.total() > 0) {
	          this_param.page(this_param.page() - 1);
	          this_param.reload();
	        }
	      });
	    }

	    /**
	     * The function `hideElement` takes an element ID as a parameter and hides the element with that ID
	     * by setting its display property to "none".
	     * @param id - The id parameter is a string that represents the id attribute of the HTML element
	     * you want to hide.
	     */
	    function hideElement(id) {
	      var menu = document.getElementById('' + id);
	      if (menu) {
	        menu.style.display = "none";
	      }
	    }

	    /**
	     * The function "showDeleteConfirm" is used to display a confirmation dialog and delete an
	     * integration in a web application.
	     * @param ev - The parameter `ev` is an event object that is passed to the `showDeleteConfirm`
	     * function. It is typically an event that triggers the function, such as a button click event.
	     */
	    function showDeleteConfirm(ev) {
	      var current_scope = this;
	      hideElement(ev.id);
	      // Appending dialog to document.body to cover sidenav in docs app
	      var confirm = $mdDialog.confirm().title($translate.instant('app.administration.CONFIRM_DELETE')).targetEvent(ev).ok($translate.instant('app.common.ACCEPT')).cancel($translate.instant('app.common.CANCEL'));

	      $mdDialog.show(confirm).then(function () {
	        current_scope._deleteIntegrationBookitit(ev);
	      }, function () {});
	    }

	    /**
	     * The save function updates the original row with the new row data, sets the isAdding flag to
	     * false, and updates the integration bookitit if debug mode is not enabled.
	     * @param row - The "row" parameter is an object that represents a row of data.
	     */
	    function save(row) {
	      var originalRow = this.resetRow(row);
	      angular.extend(originalRow, row);
	      this.isAdding = false;
	      if (!config.DEBUG_ENABLED) this._updateIntegrationBookitit(row);
	    }

	    /**
	     * The function resets a row in a table by setting its isEditing property to false and returning
	     * the original data for that row.
	     * @param row - The `row` parameter is an object representing a row in a table. It contains
	     * properties such as `id`, `isEditing`, and others.
	     * @returns the value of `return_value`.
	     */
	    function resetRow(row) {
	      var row_isAdding = this.isAdding;
	      if (row_isAdding) {
	        this.originalData = angular.copy(this.tableParams.settings().dataset);
	      }
	      var return_value = '';
	      row.isEditing = false;

	      angular.forEach(this.originalData, function (value) {
	        if (!row_isAdding && row.id === value.id) {
	          return_value = value;
	        } else if (row_isAdding && value.id === '') {
	          return_value = value;
	        }
	      });
	      return return_value;
	    }

	    /**
	     * The function `_createIntegrationBookitit` creates a new establishment in the Bookitit
	     * integration and handles any errors that occur.
	     * @param establishment - The establishment parameter is an object that contains information about
	     * the establishment being created. It may have properties such as organizationId, which is the ID
	     * of the organization the establishment belongs to.
	     */
	    function _createIntegrationBookitit(establishment) {
	      var _this2 = this;

	      var ev = this;
	      if (!establishment.organizationId || establishment.organizationId == '') {
	        establishment.organizationId = this.$localStorage.currentOrganization.id;
	      }
	      ev.AgendasResource.create({}, establishment).$promise.then(function (result) {
	        ev.new_establishment = {}; // this resets the model
	        ev.establishmentForm.$setPristine(); // this resets the form itself
	        ev.establishmentForm.$setUntouched(); // this resets the form itself
	        ev.add(result);
	      }).catch(function (error) {
	        console.log(error);
	        _this2.fail = true;
	        _this2.$translate('app.establishments.ERROR_CREATE').then(function (errorMsg) {
	          _this2.toastr.error(errorMsg, 'Error');
	        });
	      });
	    }

	    /**
	     * The function `_updateIntegrationBookitit` updates an agenda item in a resource using the
	     * provided row data.
	     * @param row - The `row` parameter is an object that represents a data row. It contains properties
	     * such as `id`, `agendaId`, and `current_area_data`.
	     */
	    function _updateIntegrationBookitit(row) {
	      var _this3 = this;

	      var current_area_data = row;
	      row.agendaId = row.id;
	      var agendaId = row.agendaId;
	      this.AgendasResource.update({
	        id: agendaId
	      }, current_area_data).$promise.then(function () {}).catch(function (error) {
	        console.log(error);
	        _this3.fail = true;
	        _this3.$translate('app.establishments.ERROR_UPDATE').then(function (errorMsg) {
	          _this3.toastr.error(errorMsg, 'Error');
	        });
	      });
	    }

	    /**
	     * The function `_deleteIntegrationBookitit` is used to delete an establishment from the
	     * AgendasResource and display success or error messages accordingly.
	     * @param establishment - The `establishment` parameter is an object that represents an
	     * establishment. It likely has properties such as `id`, which is used in the code to identify the
	     * establishment to be deleted.
	     */
	    function _deleteIntegrationBookitit(establishment) {
	      var _this4 = this;

	      this.AgendasResource.destroy({
	        id: establishment.id
	      }).$promise.then(function () {
	        _this4.$translate('app.administration.DELETE_OK').then(function (msg) {
	          _this4.toastr.success(msg, $translate.instant('app.administration.DELETE_SUCCESS'));
	        });
	        _this4.del(establishment);
	      }).catch(function (error) {
	        console.log(error);
	        _this4.fail = true;
	        _this4.$translate('app.establishments.ERROR_UPDATE').then(function (errorMsg) {
	          _this4.toastr.error(errorMsg, 'Error');
	        });
	      });
	    }

	    /**
	     * The function toggles the display of an element with the given id and hides it when the user
	     * clicks outside of it.
	     * @param id - The id parameter is the id of the HTML element that you want to show or hide.
	     */
	    function _editOptionsButton(id) {
	      this.originalData = angular.copy(this.tableParams.settings().dataset);
	      var opc = document.getElementById(id);
	      if (opc.style.display === "none") {
	        opc.style.display = "block";
	      } else {
	        opc.style.display = "none";
	      }
	      document.addEventListener("mouseup", function (e) {
	        var container = document.getElementById(id);
	        if (container && !container.contains(e.target)) {
	          container.style.display = "none";
	        }
	      }.bind(this));
	    }

	    /**
	     * The function `_detailIntegrationBookitit` shows a detail dialog for an establishment if it is
	     * not currently being edited.
	     * @param establishment - The establishment object that contains information about a particular
	     * establishment.
	     */
	    function _detailIntegrationBookitit(establishment) {
	      if (establishment.isEditing !== true) {
	        this.current_establishment = establishment;
	        this._showDetailDialog();
	      }
	    }

	    /**
	     * The function `_showDetailDialog` is used to display a dialog box with detailed information about
	     * an establishment.
	     * @param ev - The event that triggered the dialog to be shown. This is typically passed as an
	     * argument when calling the function.
	     */
	    function _showDetailDialog(ev) {
	      var _this5 = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#dialog_detail_establishment',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this5;
	        },
	        controllerAs: 'ctrl',
	        clickOutsideToClose: true
	      });
	    }

	    /**
	     * The function `_showZoneForm` is used to display a form in a dialog box, with the option to edit
	     * an existing agenda item.
	     * @param [ev] - ev is an optional parameter that represents the event object. It is used to pass
	     * information about the event that triggered the function. If ev is an object and it has at least
	     * one key, it means that the function is being called to edit an existing agenda. Otherwise, it
	     * means that the function is
	     */
	    function _showZoneForm() {
	      var _this6 = this;

	      var ev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var parent = this;
	      parent.editAgenda = (typeof ev === 'undefined' ? 'undefined' : _typeof(ev)) === 'object' && Object.keys(ev).length > 0;

	      if (parent.editAgenda) {
	        hideElement(ev.id);
	        this._showZoneFormEdit(ev);
	      }
	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#myDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this6;
	        },
	        controllerAs: 'ctrl',
	        clickOutsideToClose: true
	      }).then(function () {
	        parent.editAgenda = false;
	        document.getElementById('err_apiPublicKey');
	        document.getElementById('err_apiPublicKey').style.display = "none";
	        document.getElementById('err_apiPrivateKey');
	        document.getElementById('err_apiPrivateKey').style.display = "none";
	        document.getElementById('apiPublicKey').parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        document.getElementById('apiPrivateKey').parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	      }, function () {
	        parent.editAgenda = false;
	        parent._closeDialog();
	      });
	    }

	    /**
	     * The function `showConfig` opens a dialog box and sets some properties based on the event passed
	     * as an argument.
	     * @param ev - ev is an event object that is passed to the function when it is called. It is used
	     * to get information about the event that triggered the function, such as the target element or
	     * the event type.
	     */
	    function showConfig(ev) {
	      var _this7 = this;

	      this.idBooked = ev.id;
	      var parent = this;

	      $mdDialog.show({
	        preserveScope: true, // do not forget this if use parent scope
	        hasBackdrop: true,
	        contentElement: '#configDialog',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        controller: function controller() {
	          return _this7;
	        },
	        controllerAs: 'ctrl',
	        clickOutsideToClose: true
	      }).then(function () {
	        parent.editAgenda = false;
	        document.getElementById('err_apiPublicKey').style.display = "none";
	        document.getElementById('err_apiPrivateKey').style.display = "none";
	        document.getElementById('apiPublicKey').parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        document.getElementById('apiPrivateKey').parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	      }, function () {
	        parent.editAgenda = false;
	        parent._closeDialog();
	      });
	    }

	    /**
	     * The function _showZoneFormEdit creates a copy of the agenda object.
	     * @param agenda - The parameter "agenda" is an object that represents an agenda or a list of
	     * items.
	     */
	    function _showZoneFormEdit(agenda) {
	      this.new_establishment = angular.copy(agenda);
	    }

	    /**
	     * The function `_validateInputs` is used to validate input values based on specific conditions and
	     * update the error state accordingly.
	     * @param value - The value of the input field that needs to be validated.
	     * @param id - The id parameter is a string that represents the id of an HTML element.
	     * @param formPristine - The `formPristine` parameter is an optional parameter that represents the
	     * pristine state of the form. It is an object that contains properties like `` and
	     * `` which indicate whether the form is pristine (i.e., no user interaction yet) and
	     * whether it is invalid, respectively
	     */
	    var _validateInputs = function _validateInputs(value, id, formPristine) {
	      var num = /^[0-9]+$/;
	      var resAlphaNum = /^[a-zA-Z0-9]+$/;
	      var resABC = /^[a-zA-Z]+$/;
	      var item = document.getElementById('' + id);
	      var errApi = document.getElementById('err_' + id);

	      if (!resAlphaNum.test(value) || num.test(item.value) || resABC.test(item.value)) {
	        item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        item.parentElement.parentElement.children[0].classList.remove("md-input-focused");
	        errApi.style.display = "block";
	        errApi.innerHTML = $translate.instant('app.kiosks.ERROR_INPUT_' + id.toUpperCase());
	        errApi.style.color = "rgba(219, 72, 73, 1)";
	        _this.errorInputs = true;
	        _this.establishmentForm[id].$error = true;
	        formPristine !== undefined ? formPristine.$pristine = true : null;
	        formPristine !== undefined ? formPristine.$invalid = true : null;
	      } else if (value.length > 40 || value.length < 3) {
	        item.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errApi.innerHTML = $translate.instant('app.kiosks.ERROR_INPUT_' + id.toUpperCase() + '_LENGTH');
	        errApi.style.display = "block";
	        errApi.style.color = "rgba(219, 72, 73, 1)";
	        _this.errorInputs = true;
	        _this.establishmentForm[id].$error = true;
	        formPristine !== undefined ? formPristine.$pristine = true : null;
	        formPristine !== undefined ? formPristine.$invalid = true : null;
	      } else {
	        item.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errApi.style.display = "none";
	        _this.errorInputs = false;
	        _this.establishmentForm[id].$error = false;
	        formPristine !== undefined ? formPristine.$pristine = false : null;
	        formPristine !== undefined ? formPristine.$invalid = false : null;
	      }
	    };

	    /**
	     * The function checks if an object is empty or not.
	     * @param obj - The parameter `obj` is the object that we want to check if it is empty or not.
	     * @returns a boolean value indicating whether the given object is empty or not.
	     */
	    function isEmptyObject(obj) {
	      var anyError = false;
	      if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
	        anyError = Object.keys(obj).length !== 0;
	      }
	      return anyError;
	    }

	    /**
	     * The function `_sendEstablishment` is used to validate form inputs and send data to create or
	     * edit an establishment.
	     * @param result - The `result` parameter is an object that contains the data from the form inputs.
	     * It is used to retrieve the values entered by the user in the form.
	     * @returns In this code, the function `_sendEstablishment` returns nothing (`undefined`) in most
	     * cases. However, there is a `return` statement inside the `if (!error)` block that will return
	     * early if the condition is true.
	     */
	    function _sendEstablishment(result) {
	      var isAnyControlError = this.establishmentForm.$$controls[0].$invalid || this.establishmentForm.$$controls[1].$invalid;
	      var isAnyErrorObject = isEmptyObject(this.establishmentForm.$$controls[0].$error) || isEmptyObject(this.establishmentForm.$$controls[1].$error);
	      var error = _typeof(this.establishmentForm.$$controls[0].$error) === 'object' && _typeof(this.establishmentForm.$$controls[1].$error) === 'object' ? isAnyErrorObject : isAnyControlError;
	      if (!error) {
	        if (result === undefined) {
	          _validateInputs(result, 'apiPublicKey');
	          _validateInputs(result, 'apiPrivateKey');
	          return;
	        }

	        if (this.establishmentForm.$invalid) {
	          Object.values(this.establishmentForm.$$controls).forEach(function (control) {
	            control.$touched = true;
	          });
	          return;
	        }

	        if (!this.editAgenda) {
	          var jsonparse = JSON.parse(result.organizationId);
	          var orgName = jsonparse.name;
	          var orgId = jsonparse.organizationId || jsonparse.id;

	          if (this.showExterna === 'true') {
	            var dataSend = {
	              name: result.name,
	              externa: result.externa,
	              description: result.description,
	              organization_name: orgName,
	              organizationId: orgId,
	              apiPrivateKey: result.apiPrivateKey,
	              apiPublicKey: result.apiPublicKey,
	              urlWidget: result.urlWidget,
	              status: result.status,
	              interna: result.interna
	            };
	            this._createIntegrationBookitit(dataSend);
	          } else {
	            var _dataSend = {
	              name: result.name,
	              description: result.description,
	              organization_name: orgName,
	              organizationId: orgId,
	              urlWidget: result.urlWidget,
	              status: result.status,
	              interna: result.interna ? result.interna = 'true' : result.interna = 'false'
	            };
	            this._createIntegrationBookitit(_dataSend);
	          }
	        } else if (this.editAgenda) {
	          this.save(result);
	        }

	        $mdDialog.cancel();
	      } else {
	        return;
	      }
	    }

	    /**
	     * The _closeDialog function resets a form and hides a dialog box.
	     */
	    function _closeDialog() {
	      this.new_establishment = {};
	      this.establishmentForm.$setUntouched(); // this resets the form itself
	      $mdDialog.hide();
	    }

	    /**
	     * The function _cancelDialog() cancels a Material Design dialog.
	     */
	    function _cancelDialog() {
	      $mdDialog.cancel();
	    }

	    /**
	     * The function "showEstablishments" sets the "Selected" property of each establishment in the
	     * given array to false, updates some flags based on the length of the array, creates a copy of the
	     * array, and then calls another function "_createUsingFullOptions" with the original array as an
	     * argument.
	     * @param establishments - An array of objects representing establishments. Each object should have
	     * a "Selected" property that is initially set to false.
	     */
	    function showEstablishments(establishments) {
	      angular.forEach(establishments, function (value) {
	        value.Selected = false;
	      });
	      this.noData = establishments.length == 0 ? true : false;
	      this.fail = false;
	      this.originalData = angular.copy(establishments);
	      this._createUsingFullOptions(establishments);
	    }

	    /**
	     * The function `getEstablismentByOrganization` retrieves agendas by organization ID and handles
	     * error cases.
	     * @param role - The role parameter is used to specify the role of the user in the organization. It
	     * is used to filter the establishments based on the user's role.
	     * @param organizationId - The organizationId is the unique identifier of the organization for
	     * which you want to retrieve establishments.
	     */
	    function getEstablismentByOrganization(role, organizationId) {
	      var _this8 = this;

	      var filter = { "where": { "organizationId": organizationId } };
	      this.AgendasResource.getAgendasByOrganization({
	        filter: filter
	      }).$promise.then(function (result) {
	        _this8.noData = result.length == 0 ? true : false;
	        _this8.fail = false;
	        _this8.originalData = angular.copy(result);
	        _this8._createUsingFullOptions1(result);
	      }).catch(function (error) {
	        console.log(error);
	        _this8.$translate('app.kiosks.ERROR_GETBYESTABLISHMENT').then(function (errorMsg) {
	          _this8.toastr.error(errorMsg, 'Error');
	        });
	      });
	    }

	    /**
	     * The function `selectedItemChange` is used to handle the change event of a selected item and
	     * perform various operations based on the selected item.
	     * @param item - The `item` parameter is an object that represents the selected item. It is used to
	     * retrieve information about the selected organization.
	     * @returns The function does not explicitly return anything.
	     */
	    function selectedItemChange(item) {
	      var _this9 = this;

	      if (item !== undefined) {
	        var Organization = JSON.parse(JSON.stringify(item));

	        var current_organization = Organization;
	        this.currentOrganization = current_organization;
	        this.organizationId = current_organization.id;
	        this.organizationInUse = current_organization.name;
	        this.getEstablismentByOrganization(this.$localStorage.currentRole, this.organizationId);
	        return;
	      }
	      this.organizationInUse = undefined;
	      if (this.currentRole === 'ROOT' || this.currentRole === 'SUPERADMIN') {
	        this.AgendasResource.getAgendas().$promise.then(function (result) {
	          _this9.fail = false;
	          _this9.data = result;
	          _this9.originalData = angular.copy(result.reverse());
	          _this9._createUsingFullOptions();
	        }).catch(function (error) {
	          console.log(error);
	          _this9.$translate('app.ERROR_GETTIMEZONES').then(function (errorMsg) {
	            _this9.toastr.error(errorMsg, 'Error');
	          });
	        });
	        this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
	          _this9.organizations = result;
	          _this9.organizations.sort(function (a, b) {
	            var aL = a.name.toLowerCase();
	            var bL = b.name.toLowerCase();
	            if (aL < bL) {
	              return -1;
	            }
	            if (aL > bL) {
	              return 1;
	            }
	            return 0;
	          });
	        }).catch(function (error) {
	          console.log(error);
	          _this9.$translate('app.ERROR_GETORGANIZATION').then(function (errorMsg) {
	            _this9.toastr.error(errorMsg, 'Error');
	          });
	        });
	      } else {
	        var filter = { "where": { "organizationId": this.$localStorage.currentOrganization.id } };
	        this.AgendasResource.getAgendas({ filter: filter }).$promise.then(function (result) {
	          _this9.fail = false;
	          _this9.data = result;
	          _this9.originalData = angular.copy(result.reverse());
	          _this9._createUsingFullOptions();
	        }).catch(function (error) {
	          console.log(error);
	          _this9.$translate('app.ERROR_GETTIMEZONES').then(function (errorMsg) {
	            _this9.toastr.error(errorMsg, 'Error');
	          });
	        });
	      }
	      return;
	    }

	    /**
	     * The function `querySearchSelect` filters an array of organizations based on a given query.
	     * @param query - The query parameter is a string that represents the search query entered by the
	     * user.
	     * @returns the filtered results based on the query. If the query is not provided or is empty, it
	     * will return all organizations. Otherwise, it will return the organizations that match the query.
	     */
	    function querySearchSelect(query) {
	      var results = query ? this.organizations.filter(createFilterFor(query)) : this.organizations;
	      return results;
	    }

	    /**
	     * The function creates a filter function that checks if the lowercase value of an item's name
	     * starts with a given lowercase query.
	     * @param query - The `query` parameter is a string that represents the search query.
	     * @returns The function `createFilterFor` returns a new function called `filterFn`.
	     */
	    var createFilterFor = function createFilterFor(query) {
	      var lowercaseQuery = query.toLowerCase();
	      return function filterFn(item) {
	        var lowerCaseValue = item.name.toLowerCase();
	        return lowerCaseValue.indexOf(lowercaseQuery) === 0;
	      };
	    };

	    /**
	     * The function `_checkCitas` updates the values of `showInterna` and `showExterna` based on the
	     * `data` and `name` parameters.
	     * @param data - The `data` parameter is a boolean value that indicates whether a certain condition
	     * is true or false.
	     * @param name - The name parameter is a string that specifies the type of cita (appointment) being
	     * checked. It can have two possible values: "interna" or "externa".
	     */
	    function _checkCitas(data, name) {
	      if (name === 'interna') {
	        this.showInterna = data ? 'true' : 'false';
	      } else if (name === 'externa') {
	        this.showExterna = data ? 'true' : 'false';
	      }
	    }

	    /**
	     * The function `setUrl` returns a URL string based on the `config` and `idBooked` variables.
	     * @returns The function `setUrl` is returning a string that is constructed using the values of
	     * `this.config.api.BOOKED`, `this.idBooked`, and the string `"queue=bookitit"`.
	     */
	    var setUrl = function setUrl() {
	      return _this.config.api.BOOKED + '/calendario/' + _this.idBooked + '?queue=bookitit';
	    };

	    // exports
	    angular.extend(this, {
	      config: config,
	      _createUsingFullOptions: _createUsingFullOptions,
	      _createUsingFullOptions1: _createUsingFullOptions1,
	      pageSizeChanged: pageSizeChanged,
	      _showZoneForm: _showZoneForm,
	      _sendEstablishment: _sendEstablishment,
	      _createIntegrationBookitit: _createIntegrationBookitit,
	      _updateIntegrationBookitit: _updateIntegrationBookitit,
	      _deleteIntegrationBookitit: _deleteIntegrationBookitit,
	      _closeDialog: _closeDialog,
	      _cancelDialog: _cancelDialog,
	      showEstablishments: showEstablishments,
	      _detailIntegrationBookitit: _detailIntegrationBookitit,
	      getEstablismentByOrganization: getEstablismentByOrganization,
	      _editOptionsButton: _editOptionsButton,
	      _showDetailDialog: _showDetailDialog,
	      selectedItemChange: selectedItemChange,
	      querySearchSelect: querySearchSelect,
	      _validateInputs: _validateInputs,
	      _showZoneFormEdit: _showZoneFormEdit,
	      _checkCitas: _checkCitas,
	      showConfig: showConfig,
	      setUrl: setUrl
	    });
	  }

	  _createClass(AgendasController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this10 = this;

	      // Get all agendas de bokkit api public and secret
	      if (this.currentRole === 'ROOT' || this.currentRole === 'SUPERADMIN') {
	        this.AgendasResource.getAgendas().$promise.then(function (result) {
	          _this10.fail = false;
	          _this10.data = result;
	          _this10.originalData = angular.copy(result.reverse());
	          _this10._createUsingFullOptions();
	        }).catch(function (error) {
	          console.log(error);
	          _this10.$translate('app.ERROR_GETTIMEZONES').then(function (errorMsg) {
	            _this10.toastr.error(errorMsg, 'Error');
	          });
	        });

	        this.OrganizationsResource.getOrganizations().$promise.then(function (result) {
	          _this10.organizations = result;
	          _this10.organizations.sort(function (a, b) {
	            var aL = a.name.toLowerCase();
	            var bL = b.name.toLowerCase();
	            if (aL < bL) {
	              return -1;
	            }
	            if (aL > bL) {
	              return 1;
	            }
	            return 0;
	          });
	        }).catch(function (error) {
	          console.log(error);
	          _this10.$translate('app.ERROR_GETORGANIZATION').then(function (errorMsg) {
	            _this10.toastr.error(errorMsg, 'Error');
	          });
	        });
	      } else {
	        var filter = { "where": { "organizationId": this.$localStorage.currentOrganization.id } };
	        this.AgendasResource.getAgendas({ filter: filter }).$promise.then(function (result) {
	          _this10.fail = false;
	          _this10.data = result;
	          _this10.originalData = angular.copy(result.reverse());
	          _this10._createUsingFullOptions();
	        }).catch(function (error) {
	          console.log(error);
	          _this10.$translate('app.ERROR_GETTIMEZONES').then(function (errorMsg) {
	            _this10.toastr.error(errorMsg, 'Error');
	          });
	        });
	      }
	    }
	  }, {
	    key: 'organizationChanged',
	    value: function organizationChanged() {
	      this.$localStorage.last_organization = this.organizationSelected;
	      var current_organization = JSON.parse(this.organizationSelected);
	      this.currentOrganization = current_organization;
	      this.organizationId = current_organization.id;
	      this.organizationInUse = current_organization.name;
	      this.organizationSelected = undefined;
	      // Load all services by organization
	      this.getEstablismentByOrganization(this.$localStorage.currentRole, this.organizationId);
	    }
	  }]);

	  return AgendasController;
	}();

	AgendasController.$inject = ['config', '$scope', '$rootScope', 'AdministrationService', 'EstablishmentsResource', 'OrganizationsResource', 'NgTableParams', '$translate', 'toastr', '$mdDialog', '$location', '$localStorage', 'AgendasResource'];

	exports.default = AgendasController;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AgendasService =

	/** @ngInject */
	function AgendasService() {
	  _classCallCheck(this, AgendasService);
	};

	exports.default = AgendasService;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _newAgendas = __webpack_require__(112);

	var _newAgendas2 = __webpack_require__(113);

	var _newAgendas3 = _interopRequireDefault(_newAgendas2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var NewAgenda = angular.module('mod.admin.administration.journal', []).component('journal', _newAgendas.NewAgendaComponent).service('NewAgendas', _newAgendas3.default).name;

	exports.default = NewAgenda;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NewAgendaComponent = undefined;

	var _newAgendas = __webpack_require__(113);

	var _newAgendas2 = _interopRequireDefault(_newAgendas);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var NewAgendaComponent = exports.NewAgendaComponent = {
	  controller: _newAgendas2.default,
	  templateUrl: 'app/modules/admin/administration/new-agendas/new-agendas.html'
	};

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var NewAgendaController = function () {
	  /** @ngInject */
	  NewAgendaController.$inject = ["config", "$rootScope", "$location"];
	  function NewAgendaController(config, $rootScope, $location) {
	    _classCallCheck(this, NewAgendaController);

	    this.$rootScope = $rootScope;
	    this.dataTransformed = this.goToAgenda();
	    this.new_front = config.NEW_FRONT + '/administration/agenda?data=' + this.dataTransformed;

	    var url = $location.url().substring(1).toUpperCase();
	    this.$rootScope.currentPage = currentPage(1);

	    function currentPage(index) {
	      var split_url = url.split('/');
	      return split_url[index];
	    }
	  }

	  _createClass(NewAgendaController, [{
	    key: 'goToAgenda',
	    value: function goToAgenda() {
	      var oldToken = localStorage.getItem('auth_token');
	      var employeeData = localStorage.getItem('qm_currentUser');
	      var employee = JSON.parse(employeeData);
	      var token = localStorage.getItem('newTokenInfo');
	      var kongToken = JSON.parse(localStorage.getItem('tokenKongInfo'));

	      var shareData = {
	        token: token,
	        employee: {
	          id: employee.id,
	          locationId: employee.locationId,
	          role: employee.role,
	          username: employee.username,
	          organizationId: employee.organizationId
	        },
	        oldData: {
	          userId: employee.id,
	          id: oldToken
	        },
	        kongToken: {
	          access_token: kongToken.access_token,
	          expire_in: 8000,
	          token_type: 'bearer'
	        }
	      };

	      var data = JSON.stringify(shareData);

	      return encodeURIComponent(data);
	    }
	  }]);

	  return NewAgendaController;
	}();

	NewAgendaController.$inject = ['config', '$rootScope', '$location'];

	exports.default = NewAgendaController;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _profile = __webpack_require__(115);

	var _profile2 = __webpack_require__(117);

	var _profile3 = _interopRequireDefault(_profile2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var agendas = angular.module('mod.admin.administration.profile', []).component('profile', _profile.ProfileComponent).service('ProfileService', _profile3.default).name;

	exports.default = agendas;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProfileComponent = undefined;

	var _profile = __webpack_require__(116);

	var _profile2 = _interopRequireDefault(_profile);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ProfileComponent = exports.ProfileComponent = {
	  controller: _profile2.default,
	  templateUrl: 'app/modules/admin/administration/profile/profile.html'
	};

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ProfileController = function () {

	  /** @ngInject */
	  ProfileController.$inject = ["config", "$scope", "$rootScope", "AdministrationService", "EstablishmentsResource", "OrganizationsResource", "NgTableParams", "$translate", "toastr", "CategoryResource", "Users", "$mdDialog", "$location", "$localStorage", "profileData"];
	  function ProfileController(config, $scope, $rootScope, AdministrationService, EstablishmentsResource, OrganizationsResource, NgTableParams, $translate, toastr, CategoryResource, Users, $mdDialog, $location, $localStorage, profileData) {
	    var _this4 = this;

	    _classCallCheck(this, ProfileController);

	    // private
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$localStorage = $localStorage;
	    this.isPre = config.IS_PRE;
	    this.AdministrationService = AdministrationService;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.OrganizationsResource = OrganizationsResource;
	    this.profileData = profileData;
	    this.previewImg = [];
	    this.errPass = false;
	    this.confirmPassword = false;
	    this.Users = Users;
	    this.phoneCode = "";
	    this.countryStatus = false;
	    this.countries = [];
	    this.countryCodes = {
	      country: ""
	    };
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.CategoryResource = CategoryResource;
	    this.categories = [];
	    /**
	     * Sends the updated profile data to the server.
	     * Uses the current values from the profileData object to update the user information.
	     * Shows success or error messages using toastr.
	     *
	     * @function
	     * @name _sendProfileData
	     */
	    function _sendProfileData() {
	      var _this2 = this;

	      var currentUsr = {
	        firstname: this.profileData.name,
	        lastname: this.profileData.lastName,
	        email: this.profileData.email,
	        secondlastname: this.profileData.secondLastName,
	        username: this.profileData.username,
	        role: this.$localStorage.currentRole
	      };

	      this.Users.update({ id: this.profileData.userId }, currentUsr).$promise.then(function () {
	        var storedUser = JSON.parse(localStorage.getItem('qm_currentUser') || '{}');
	        var updatedFields = {
	          firstname: _this2.profileData.name,
	          lastname: _this2.profileData.lastName,
	          email: _this2.profileData.email,
	          secondlastname: _this2.profileData.secondLastName
	        };
	        var mergedUser = Object.assign({}, storedUser, updatedFields);
	        localStorage.setItem('qm_currentUser', JSON.stringify(mergedUser));
	        _this2.$translate('app.users.SUCCESS_UPDATE').then(function (successMsg) {
	          _this2.toastr.success(successMsg, 'Success');
	        });
	      }).catch(function (error) {
	        console.log(error);
	        _this2.$translate('app.users.ERROR_UPDATE').then(function (errorMsg) {
	          _this2.toastr.error(errorMsg, 'Error');
	        });
	      });
	    }
	    /**
	     * Sends the updated user profile data to the server.
	     * Uses the current values from the profileData object to update the user information.
	     * Formats the phone number with the country code before sending.
	     * Shows success or error messages using toastr.
	     *
	     * @function
	     * @name _sendProfileDataUsr
	     */
	    function _sendProfileDataUsr() {
	      var _this3 = this;

	      var phone = this.countryCodes.country + this.profileData.phone;
	      var succesMsg = $translate.instant("app.SUCCESS");
	      var currentOrg = {
	        name: this.profileData.commerceName,
	        phone: phone,
	        description: this.profileData.description,
	        logo: this.profileData.avatar,
	        category: this.profileData.category
	      };
	      this.OrganizationsResource.update({ id: this.profileData.organizationId }, currentOrg).$promise.then(function (result) {
	        localStorage.setItem('qm_currentOrganization', JSON.stringify(result));

	        _this3.$translate("app.organizations.SUCCESS_UPDATE").then(function (successMsg) {
	          _this3.toastr.success(successMsg, succesMsg);
	        });
	      }).catch(function (error) {
	        console.log(error);
	        _this3.$translate("app.organizations.ERROR_UPDATE").then(function (errorMsg) {
	          _this3.toastr.error(errorMsg, "Error");
	        });
	      });
	    }
	    /**
	     * Sends the updated user profile data to the server, including password reset if provided.
	     * Updates the user's username and, if provided, resets the password.
	     * Shows success or error messages using toastr.
	     *
	     * @function
	     * @name _sendProfileUsr
	     */
	    function _sendProfileUsr() {
	      var _this = this;
	      var succesMsg = $translate.instant("app.SUCCESS");

	      if (this.profileData.password && this.profileData.confirmPassword) {
	        var current_user_data = {
	          password: this.profileData.password,
	          userId: this.profileData.userId
	        };
	        this.Users.resetPassword({ id: this.profileData.userId }, current_user_data).$promise.then(function () {
	          _this.$translate('app.administration.RESET_OK').then(function (msg) {
	            _this.toastr.success(msg, $translate.instant('app.administration.RESET_SUCCESS'));
	          });
	        }).catch(function (error) {
	          console.log(error);
	          _this.$translate('app.users.ERROR_UPDATE').then(function (errorMsg) {
	            _this.toastr.error(errorMsg, 'Error');
	          });
	          _this.$translate("app.SUCCESS").then(function (successMsg) {
	            _this.toastr.error(successMsg);
	          });
	        });
	      }

	      var currentUsr = {
	        username: this.profileData.username
	      };

	      this.Users.update({ id: this.profileData.userId }, currentUsr).$promise.then(function () {
	        _this.$translate("app.organizations.SUCCESS_UPDATE").then(function (successMsg) {
	          _this.toastr.success(successMsg, succesMsg);
	        });
	      }).catch(function (error) {
	        if (error.data.error.message.toLowerCase().includes("user already exists")) {
	          _this.$translate("app.users.ERROR_CREAT_USER").then(function (successMsg) {
	            _this.toastr.error(successMsg);
	          });
	        }
	      });
	    }
	    /**
	     * Validates a numeric input, displaying error messages for invalid input.
	     * Uses regular expressions to check if the value consists only of digits.
	     * If the input is for a phone number, it also checks the length.
	     *
	     * @function
	     * @name validateNumbers
	     * @param {string} value - The input value to validate.
	     * @param {string} id - The ID of the input element.
	     */
	    var validateNumbers = function validateNumbers(value, id) {
	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);
	      var translate = $translate.instant("app.establishments.err_" + id);

	      var regex = /^[0-9]+$/;
	      if (id === "phone") {
	        if (!regex.test(value)) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.style.display = "block";
	          errName.innerHTML = "" + translate;
	          errName.style.color = "red";
	        } else if (value.length < 9) {
	          name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	          errName.innerHTML = $translate.instant("app.establishments.err_" + id + "_length");
	          errName.style.display = "block";
	          errName.style.color = "red";
	        } else {
	          name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	          errName.style.display = "none";
	        }
	      }
	    };
	    /**
	     * Validates various types of inputs, displaying error messages for invalid input.
	     * Uses specific validation logic based on the input ID.
	     *
	     * @function
	     * @name _validateInputs
	     * @param {string} value - The input value to validate.
	     * @param {string} id - The ID of the input element.
	     */
	    var _validateInputs = function _validateInputs(value, id) {
	      var name2 = document.getElementById("" + id);
	      var regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&?&*-])[a-zA-Z\d!@#$%^&?&*-]{8,}$/;

	      if (id === "phone") {
	        validateNumbers(value, id);
	      }

	      if (id === "password" && !regexPassword.test(value)) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        _this4.errPass = true;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        _this4.errPass = false;
	      }

	      if (id === 'confirmPassword') {
	        if (value !== _this4.profileData.password) {
	          _this4.confirmPassword = true;
	        } else {
	          _this4.confirmPassword = false;
	        }
	      }
	    };
	    /**
	     * Validates an image file based on its size and type, displaying error messages for invalid images.
	     *
	     * @function
	     * @name validateImage
	     * @param {File} value - The image file to validate.
	     * @param {string} id - The ID of the input element.
	     * @param {Object} rowForm - The form object associated with the input.
	     */
	    var validateImage = function validateImage(value, id, rowForm) {
	      var size = value.size;
	      var type = value.filetype;

	      var name2 = document.getElementById("" + id);
	      var errName = document.getElementById("err_" + id);

	      if (type !== "image/jpeg" && type !== "image/png" && type !== "image/jpg") {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.style.color = "rgba(219, 72, 73, 1)";
	        errName.innerHTML = $translate.instant("app.establishments.ERR_IMG_TYPE");
	        rowForm.$invalid = true;
	      } else if (size > 5000000) {
	        name2.parentElement.parentElement.children[0].classList.add("md-input-invalid");
	        errName.style.display = "block";
	        errName.style.color = "rgba(219, 72, 73, 1)";
	        errName.innerHTML = $translate.instant("app.establishments.ERR_IMG_SIZE");
	        rowForm.$invalid = true;
	      } else {
	        name2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	        errName.style.display = "none";
	        rowForm.$invalid = false;
	      }
	    };
	    /**
	     * Validates an image file, updates the preview image, and displays error messages for invalid images.
	     *
	     * @function
	     * @name _validateImages
	     * @param {Object} value - The image file to validate, including its base64 representation.
	     * @param {string} id - The ID of the input element.
	     * @param {Object} rowForm - The form object associated with the input.
	     */
	    var _validateImages = function _validateImages(value, id, rowForm) {
	      var file = value.base64;

	      _this4.previewImg.logo = "data:image/jpeg;base64," + file;

	      validateImage(value, id, rowForm);
	    };
	    /**
	     * Handles the selection change in the ngSelect function, updating the appearance of the phone input based on the selected value.
	     *
	     * @function
	     * @name ngSelect
	     * @param {string} value - The selected value.
	     */
	    function ngSelect(value) {
	      var phone2 = document.getElementById("phone");
	      if (value !== '0') {
	        phone2.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	      }
	    }
	    /**
	     * Handles the selection change in the ngSelectCat function, updating the appearance of the category input based on the selected value.
	     *
	     * @function
	     * @name ngSelectCat
	     * @param {string} value - The selected value.
	     */
	    function ngSelectCat(value) {
	      var category = document.getElementById("category");
	      if (value !== '0') {
	        category.parentElement.parentElement.children[0].classList.remove("md-input-invalid");
	      }
	    }
	    /**
	     * Searches for the country code in the provided phone number and updates the relevant properties.
	     *
	     * @function
	     * @name _searchCountryCode
	     * @param {string|number} phone - The phone number to search for the country code.
	     */
	    function _searchCountryCode(phone) {
	      var _this5 = this;

	      this.countryStatus = false;
	      if (typeof phone === "number") {
	        this.countryStatus = true;
	        phone = phone.toString();
	      } else if (phone === undefined || phone === null) {
	        return;
	      }

	      for (var i = 0; i < this.countries.length; i++) {
	        if (phone.indexOf(this.countries[i].dial_code) > -1) {
	          this.phoneCode = this.countries[i].dial_code;
	          break;
	        }
	      }

	      var countriesCode = this.countries.filter(function (country) {
	        return country.dial_code === _this5.phoneCode;
	      });

	      if (countriesCode.length > 0) {
	        this.countryCodes.country = countriesCode[0].dial_code;
	        phone = phone.replace(this.phoneCode, "");
	        this.profileData.phone = phone;
	      } else {
	        this.countryStatus = true;
	        this.profileData.phone = phone;
	        this.countryCodes.country = "+34";
	      }
	    }
	    // exports
	    angular.extend(this, {
	      config: config,
	      _sendProfileData: _sendProfileData,
	      _sendProfileUsr: _sendProfileUsr,
	      _validateImages: _validateImages,
	      _validateInputs: _validateInputs,
	      ngSelect: ngSelect,
	      ngSelectCat: ngSelectCat,
	      _searchCountryCode: _searchCountryCode,
	      _sendProfileDataUsr: _sendProfileDataUsr
	    });
	  }

	  _createClass(ProfileController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this6 = this;

	      var currentLocation = JSON.parse(localStorage.getItem('qm_currentLocation'));
	      var currentUser = JSON.parse(localStorage.getItem('qm_currentUser'));
	      var qm_currentOrganization = JSON.parse(localStorage.getItem('qm_currentOrganization'));

	      this.profileData = {
	        commerceName: currentLocation.name,
	        organizationName: qm_currentOrganization.name,
	        description: qm_currentOrganization.description,
	        address: qm_currentOrganization.address,
	        organizationId: qm_currentOrganization.id,
	        avatar: qm_currentOrganization.logo_link,
	        name: currentUser.firstname,
	        lastName: currentUser.lastname,
	        secondLastName: currentUser.secondlastname || '',
	        email: currentUser.email,
	        username: currentUser.username,
	        phone: qm_currentOrganization.phone,
	        userId: currentUser.id
	      };

	      this.CategoryResource.getCategories().$promise.then(function (result) {
	        _this6.categories = result;
	        _this6.categories.sort(function (a, b) {
	          return a.name.localeCompare(b.name);
	        });
	        _this6.categories.map(function (category) {
	          if (category.id === qm_currentOrganization.categoryId) {
	            _this6.profileData.category = category.id;
	          }
	        });
	      }).catch(function (error) {
	        console.log(error);
	      });
	      fetch('/assets/country_code.json').then(function (response) {
	        return response.json();
	      }).then(function (json) {
	        _this6.countries = json;
	        _this6.countries.sort(function (a, b) {
	          return a.nombre.localeCompare(b.nombre);
	        });
	        _this6._searchCountryCode(_this6.profileData.phone);
	      }).catch(function (error) {
	        console.log(error);
	      });
	    }
	  }]);

	  return ProfileController;
	}();

	ProfileController.$inject = ['config', '$scope', '$rootScope', 'AdministrationService', 'EstablishmentsResource', 'OrganizationsResource', 'NgTableParams', '$translate', 'toastr', 'CategoryResource', 'Users', '$mdDialog', '$location', '$localStorage', 'AgendasResource'];

	exports.default = ProfileController;

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ProfileService =

	/** @ngInject */
	function ProfileService() {
	  _classCallCheck(this, ProfileService);
	};

	exports.default = ProfileService;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _support = __webpack_require__(119);

	var _support2 = __webpack_require__(121);

	var _support3 = _interopRequireDefault(_support2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var users = angular.module('mod.admin.administration.support', []).component('support', _support.SupportComponent).service('SupportService', _support3.default).name;

	exports.default = users;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SupportComponent = undefined;

	var _support = __webpack_require__(120);

	var _support2 = _interopRequireDefault(_support);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SupportComponent = exports.SupportComponent = {
	  controller: _support2.default,
	  templateUrl: 'app/modules/admin/administration/support/support.html'
	};

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SupportController = function () {

	  /** @ngInject */
	  SupportController.$inject = ["$rootScope", "$scope", "config", "Users", "OrganizationsResource", "EstablishmentsResource", "NgTableParams", "$translate", "toastr", "$mdDialog", "$localStorage", "$location", "AuthService", "$filter", "RolesResource", "AdministrationService"];
	  function SupportController($rootScope, $scope, config, Users, OrganizationsResource, EstablishmentsResource, NgTableParams, $translate, toastr, $mdDialog, $localStorage, $location, AuthService, $filter, RolesResource, AdministrationService) {
	    _classCallCheck(this, SupportController);

	    // private
	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$filter = $filter;
	    this.$localStorage = $localStorage;
	    this.currentRole = this.$localStorage.currentRole;
	    this.currentId = this.$localStorage.currentUser.id;
	    //this.establishmentId = config.ESTABLISHMENT_ID;
	    this.isPre = config.IS_PRE;
	    this.Users = Users;
	    this.EstablishmentsResource = EstablishmentsResource;
	    this.OrganizationsResource = OrganizationsResource;
	    this.RolesResource = RolesResource;
	    this.AuthService = AuthService;
	    this.AdministrationService = AdministrationService;
	    this.config = config;
	    this.$translate = $translate;
	    this.toastr = toastr;
	    this.$mdDialog = $mdDialog;
	    this.isAdding = false;
	    this.fail = false;
	    this.contact = {};

	    /**
	     * Sends contact information.
	     *
	     * @param {Object} data - The data object.
	     * @property {string} data.name - The name from the contact information.
	     * @property {string} data.email - The email from the contact information.
	     * @property {string} data.message - The message from the contact information.
	     */
	    function sendContact(data) {
	      var _this = this;

	      var newData = {
	        name: this.contact.name,
	        email: this.contact.email,
	        message: this.contact.message
	      };

	      this.Users.sendContact(newData).$promise.then(function () {
	        _this.$translate("app.SUCCESS").then(function (successMsg) {
	          _this.toastr.success(successMsg);
	        });
	      }).catch(function () {
	        _this.$translate("app.ERROR").then(function (errorMsg) {
	          _this.toastr.error(errorMsg);
	        });
	      }).finally(function () {
	        _this.contact = {};
	        data.$submitted = false;
	        data.name.$touched = false;
	        data.email.$touched = false;
	        data.message.$touched = false;
	      });
	    }

	    angular.extend(this, {
	      config: config,
	      sendContact: sendContact
	    });
	  }

	  _createClass(SupportController, [{
	    key: "$onInit",
	    value: function $onInit() {

	      var acc = document.getElementsByClassName("accordion-header");

	      for (var i = 0; i < acc.length; i++) {
	        acc[i].addEventListener("click", function () {
	          var active = document.querySelector(".accordion-item.active");
	          var active_s = document.querySelector(".md-toggle-icon-s.active-s");
	          if (active && active != this.parentElement) {
	            active.classList.remove("active");
	            active_s.classList.remove("active-s");
	            active.querySelector(".accordion-content").style.maxHeight = 0;
	          }
	          this.parentElement.classList.toggle("active");
	          this.querySelector(".md-toggle-icon-s").classList.toggle("active-s");
	          var panel = this.nextElementSibling;
	          if (panel.style.maxHeight) {
	            panel.style.maxHeight = null;
	          } else {
	            panel.style.maxHeight = panel.scrollHeight + "px";
	          }
	        });
	      }
	    }
	  }]);

	  return SupportController;
	}();

	SupportController.$inject = ['$rootScope', '$scope', 'config', 'Users', 'OrganizationsResource', 'EstablishmentsResource', 'NgTableParams', '$translate', 'toastr', '$mdDialog', '$localStorage', '$location', 'AuthService', '$filter', 'RolesResource', 'AdministrationService'];

	exports.default = SupportController;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SupportService =

	/** @ngInject */
	function SupportService() {
	  _classCallCheck(this, SupportService);
	};

	exports.default = SupportService;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdministrationComponent = undefined;

	var _administration = __webpack_require__(123);

	var _administration2 = _interopRequireDefault(_administration);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var AdministrationComponent = exports.AdministrationComponent = {
	  controller: _administration2.default,
	  templateUrl: 'app/modules/admin/administration/administration.html'
	  //template: '<div ui-view id="administration-container"></div>'
	};

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AdministrationController = function () {

	  /** @ngInject */
	  AdministrationController.$inject = ["$rootScope", "$translate", "config", "$location"];
	  function AdministrationController($rootScope, $translate, config, $location) {
	    _classCallCheck(this, AdministrationController);

	    // private
	    this.$rootScope = $rootScope;
	    this.establishmentId = config.ESTABLISHMENT_ID;
	    this.$translate = $translate;
	    this.isEmployee = true;

	    var url = $location.url().substring(1).toUpperCase();
	    // Control of navbar menu page
	    this.$rootScope.currentMainPage = currentPage(0);

	    function currentPage(index) {
	      var split_url = url.split('/');
	      return split_url[index];
	    }
	  }

	  _createClass(AdministrationController, [{
	    key: 'selectLanguage',
	    value: function selectLanguage(lang) {
	      // Set the new idiom
	      this.$translate.use(lang);
	    }
	  }]);

	  return AdministrationController;
	}();

	AdministrationController.$inject = ['$rootScope', '$translate', 'config', '$location'];

	exports.default = AdministrationController;

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AdministrationService = function () {

	  /** @ngInject */
	  AdministrationService.$inject = ["EstablishmentsResource", "OrganizationsResource", "ServicesResource"];
	  function AdministrationService(EstablishmentsResource, OrganizationsResource, ServicesResource) {
	    _classCallCheck(this, AdministrationService);

	    this.EstablishmentsResource = EstablishmentsResource;
	    this.OrganizationsResource = OrganizationsResource;
	    this.ServicesResource = ServicesResource;

	    // exports
	    //angular.extend(this, {

	    //});

	    // Methods
	    this.getEstablishments;
	    this.getEstablishments1;
	    this.getServices;
	    this.getBookingServices;
	  }

	  _createClass(AdministrationService, [{
	    key: 'getEstablishments',
	    value: function getEstablishments(role, id, type) {
	      if (role === 'ROOT') {
	        return this.EstablishmentsResource.getEstablishments().$promise;
	      } else {
	        return this.OrganizationsResource.getServicesByOrganization({ type: type, id: id }).$promise;
	      }
	    }
	  }, {
	    key: 'getEstablishments1',
	    value: function getEstablishments1(role, id, type) {
	      return this.OrganizationsResource.getEstablismentByOrganization({ type: type, id: id }).$promise;
	    }
	  }, {
	    key: 'getServices',
	    value: function getServices(role, id, type) {
	      if (role === 'ROOT' && id === '') {
	        return this.ServicesResource.getServices({ type: type }).$promise;
	      } else {
	        return this.OrganizationsResource.getServicesByOrganization({ type: type, id: id }).$promise;
	      }
	    }
	  }, {
	    key: 'getBookingServices',
	    value: function getBookingServices(role, id, type, filter) {
	      if (role === 'ROOT' && id === '') {
	        return this.ServicesResource.getBookingServices({ type: type, filter: filter }).$promise;
	      } else {
	        return this.OrganizationsResource.getBookingServicesByOrganization({ type: type, id: id, filter: filter }).$promise;
	      }
	    }
	  }]);

	  return AdministrationService;
	}();

	AdministrationService.$inject = ['EstablishmentsResource', 'OrganizationsResource', 'ServicesResource'];

	exports.default = AdministrationService;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _supervisor = __webpack_require__(126);

	var _supervisor2 = __webpack_require__(128);

	var _supervisor3 = _interopRequireDefault(_supervisor2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var supervisor = angular.module('mod.admin.supervisor', []).component('supervisor', _supervisor.SupervisorComponent).service('SupervisorService', _supervisor3.default).name;

	exports.default = supervisor;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SupervisorComponent = undefined;

	var _supervisor = __webpack_require__(127);

	var _supervisor2 = _interopRequireDefault(_supervisor);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SupervisorComponent = exports.SupervisorComponent = {
	  controller: _supervisor2.default,
	  templateUrl: 'app/modules/admin/supervisor/supervisor.html'
	};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SupervisorController = function () {
	  /** @ngInject */
	  SupervisorController.$inject = ["AdministrationService", "$translate", "config", "$location", "$rootScope", "$scope", "$localStorage", "Supervisor", "Statistics", "toastr", "AuthService", "WorkstationsInUse", "$timeout"];
	  function SupervisorController(AdministrationService, $translate, config, $location, $rootScope, $scope, $localStorage, Supervisor, Statistics, toastr, AuthService, WorkstationsInUse, $timeout) {
	    _classCallCheck(this, SupervisorController);

	    // private

	    this.$rootScope = $rootScope;
	    this.$scope = $scope;
	    this.$localStorage = $localStorage;
	    this.toastr = toastr;
	    this.config = config;
	    this.$timeout = $timeout;
	    // TODO: refactorizar
	    if ($localStorage.currentRole && typeof $localStorage.currentRole === "string" && ["ADMIN", "SUPERADMIN", "ROOT"].includes($localStorage.currentRole.toUpperCase())) {
	      var last_establishment = this.$localStorage.last_establishment ? this.$localStorage.last_establishment : false;
	      this.establishmentId = last_establishment ? last_establishment.id : false;
	      this.establishmentInUse = last_establishment ? last_establishment.name : false;
	    }
	    this.Supervisor = Supervisor;
	    this.Statistics = Statistics;
	    this.AdministrationService = AdministrationService;
	    this.AuthService = AuthService;
	    this.WorkstationsInUse = WorkstationsInUse;
	    this.$translate = $translate;
	    this.isEmployee = true;
	    this.workstationsInUse = [];
	    /**
	     * turns supervisor
	     */
	    this.allTurns = 0;
	    this.attendedTurns = 0;
	    this.missingTurns = 0;
	    this.waitingTurns = 0;
	    this.manualTurns = 0;
	    this.allTurnsLW = 0;
	    this.attendedTurnsLW = 0;
	    this.missingTurnsLW = 0;
	    this.waitingTurnsLW = 0;
	    this.manualTurnsLW = 0;

	    var url = $location.url().substring(1).toUpperCase();
	    // Control of navbar menu page
	    this.$rootScope.currentMainPage = currentPage(0);
	    // Control of sidemenu page
	    this.currentPage = currentPage(1);

	    // Datepicker max date (yesterday)
	    var todayTimeStamp = +new Date(); // Unix timestamp in milliseconds
	    var oneDayTimeStamp = 1000 * 60 * 60 * 24; // Milliseconds in a day
	    var diff = todayTimeStamp - oneDayTimeStamp;
	    this.maxDate = new Date(diff);
	    this.isModified = false;
	    this.template_date = "--/--/----";

	    function currentPage(index) {
	      var split_url = url.split("/");
	      return split_url[index];
	    }

	    function allowSelectRoles(role_option) {
	      this.is_allowed = this.AuthService.allowSelectRoles(role_option);
	      return this.is_allowed;
	    }

	    this.waitingTurnsSupervisor = true;
	    this.attending_time = {
	      activated: true,
	      no_data: false
	    };
	    this.clients_hour = {
	      activated: true,
	      no_data: false
	    };
	    this.clients_user = {
	      activated: true,
	      no_data: false
	    };
	    this.queues_user = {
	      activated: true,
	      no_data: false
	    };
	    this.clients_attended = {
	      activated: true,
	      no_data: false
	    };
	    this.clients_waiting = {
	      activated: true,
	      no_data: false
	    };
	    this.clients_absent = {
	      activated: true,
	      no_data: false
	    };
	    this.clients_special = {
	      activated: true,
	      no_data: false
	    };
	    // Chart colors
	    this.colors = ["#97BBCD", "#5C626E", "#F7464A", "#46BFBD", "#FDB45C", "#949FB1", "#4D5360"];
	    this.time_options = {
	      legend: { display: true },
	      scales: {
	        yAxes: [{
	          scaleLabel: {
	            display: true,
	            labelString: "tiempo (min)"
	          },
	          ticks: { min: 0 }
	        }]
	      }
	    };

	    this.number_options = {
	      legend: { display: true },
	      scales: {
	        yAxes: [{
	          scaleLabel: {
	            display: true,
	            labelString: "turnos"
	          },
	          ticks: { min: 0 }
	        }]
	      }
	    };

	    // public
	    var _waitingTimeStatistics = {};

	    function _calculateAmounts(response) {
	      var mediaIndex = response.series.indexOf("Media");
	      var totalIndex = response.series.indexOf("Total");
	      if (mediaIndex != -1 && totalIndex != -1) {
	        if (mediaIndex > totalIndex) {
	          response.data.splice(mediaIndex, 1);
	          response.data.splice(totalIndex, 1);
	        } else {
	          response.data.splice(totalIndex, 1);
	          response.data.splice(mediaIndex, 1);
	        }
	      } else {
	        if (mediaIndex > -1) {
	          response.data.splice(mediaIndex, 1);
	        } else if (totalIndex > -1) {
	          response.data.splice(totalIndex, 1);
	        }
	      }
	      var merged = response.data.flat(1);
	      var result = merged.reduce(function (accumulator, currentValue) {
	        return accumulator + currentValue;
	      }, 0);
	      return result;
	    }

	    function _startAllStatistics(locationId) {
	      var _this = this;

	      var $this = this;
	      var to = new Date();
	      var from = new Date();
	      // /**
	      //  * DELETE THIS, ONLY FOR TESTING IN LOCAL ENVIRONMENT
	      //  */
	      // const to = new Date()
	      // const from = new Date(to)

	      // from.setDate(from.getDate() - 1);
	      from.setHours(0, 0, 0);

	      // /**
	      //  * EOF DELETE THIS, ONLY FOR TESTING IN LOCAL ENVIRONMENT
	      //  */

	      // const toLW = new Date()
	      // const fromLW = new Date()
	      // fromLW.setDate(from.getDate() - 7)
	      // toLW.setDate(from.getDate() - 7)
	      // fromLW.setHours(0,0,0);

	      this.allTurns = 0;
	      this.attendedTurns = 0;
	      this.missingTurns = 0;
	      this.waitingTurns = 0;
	      this.manualTurns = 0;
	      this.allTurnsLW = 0;
	      this.attendedTurnsLW = 0;
	      this.missingTurnsLW = 0;
	      this.waitingTurnsLW = 0;
	      this.manualTurnsLW = 0;
	      // Get waitting time statistics
	      $this.Supervisor.getWaitingTime({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        $this.attendingTimeStatistics = response;
	        _this[response.queues._type] = response.queues;
	      }).catch(function (err) {
	        console.error(err);
	        $this["waiting"].activated = false;
	        _this._showMessageError = true;
	        $this.$translate("app.STATISTIC_ERROR_WAITING").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, "Error");
	        });
	      });

	      // Get atending time statistics
	      $this.Supervisor.getServiceTime({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        $this.attendingTimeStatistics = response;
	        _this[response.queues._type] = response.queues;
	      }).catch(function (err) {
	        console.error(err);
	        $this["attending_time"].activated = false;
	        _this._showMessageError = true;
	        $this.$translate("app.STATISTIC_ERROR_ATTENDING").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, "Error");
	        });
	      });

	      // Get turns number statistics
	      $this.Supervisor.getTurnsByQueue({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        $this.turnsNumberStatistics = response;
	        _this[response.queues._type] = response.queues;
	        _this.allTurns = _calculateAmounts(response.queues);
	      }).catch(function (err) {
	        console.error(err);
	        $this["clients_attended"].activated = false;
	        _this._showMessageError = true;
	        $this.$translate("app.STATISTIC_ERROR_QUEUE").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, "Error");
	        });
	      });

	      // // Get turns number statistics last week
	      // $this.Statistics.getTurnsByQueue({ locationId: locationId, from: fromLW, to: toLW }).$promise
	      //   .then(response => {
	      //     this.allTurnsLW =  _calculateAmounts(response.queues);
	      //     this.waitingTurnsLW = this.allTurnsLW - this.attendedTurnsLW - this.missingTurnsLW;
	      //   })
	      //   .catch(err => {
	      //     console.error(err);
	      //     this._showMessageError = true;
	      //     $this.$translate('app.STATISTIC_ERROR_QUEUE').then((errorMsg) => {
	      //       $this.toastr.error(errorMsg, 'Error');
	      //     });
	      //   })

	      // Get turns number statistics
	      $this.Supervisor.getTurnsAttendedByQueue({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        $this.turnsNumberStatistics = response;
	        _this[response.queues._type] = response.queues;
	        _this.attendedTurns = _calculateAmounts(response.queues);
	      }).catch(function (err) {
	        console.error(err);
	        $this["clients_attended"].activated = false;
	        _this._showMessageError = true;
	        $this.$translate("app.STATISTIC_ERROR_QUEUE").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, "Error");
	        });
	      });

	      // // Get turns number statistics last week
	      // $this.Statistics.getTurnsByQueue({ locationId: locationId, from: fromLW, to: toLW }).$promise
	      //   .then(response => {
	      //     this.allTurnsLW =  _calculateAmounts(response.queues);
	      //     this.waitingTurnsLW = this.allTurnsLW - this.attendedTurnsLW - this.missingTurnsLW;
	      //   })
	      //   .catch(err => {
	      //     console.error(err);
	      //     this._showMessageError = true;
	      //     $this.$translate('app.STATISTIC_ERROR_QUEUE').then((errorMsg) => {
	      //       $this.toastr.error(errorMsg, 'Error');
	      //     });
	      //   })
	      // Get turns number statistics
	      $this.Supervisor.getTurnsWaitingByQueue({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        $this.turnsNumberStatistics = response;
	        _this[response.queues._type] = response.queues;
	        _this.waitingTurns = _calculateAmounts(response.queues);
	      }).catch(function (err) {
	        console.error(err);
	        $this["clients_waiting"].activated = false;
	        _this._showMessageError = true;
	        $this.$translate("app.STATISTIC_ERROR_QUEUE").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, "Error");
	        });
	      });

	      $this.Supervisor.getTurnsSpecialByQueue({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        $this.turnsNumberStatistics = response;
	        _this[response.queues._type] = response.queues;
	        _this.manualTurns = _calculateAmounts(response.queues);
	      }).catch(function (err) {
	        console.error(err);
	        $this["clients_special"].activated = false;
	        _this._showMessageError = true;
	        $this.$translate("app.STATISTIC_ERROR_SPECIAL").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, "Error");
	        });
	      });

	      // // Get turns number statistics last week
	      // $this.Statistics.getTurnsSpecialByQueue({ locationId: locationId, from: fromLW, to: toLW }).$promise
	      //   .then(response => {
	      //     this.manualTurnLW =  _calculateAmounts(response.queues);
	      //   })
	      //   .catch(err => {
	      //     console.error(err);
	      //     this._showMessageError = true;
	      //     $this.$translate('app.STATISTIC_ERROR_QUEUE').then((errorMsg) => {
	      //       $this.toastr.error(errorMsg, 'Error');
	      //     });
	      //   })

	      // Get turns clients absent
	      $this.Supervisor.getTurnsAbsentByQueue({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        $this.turnsNumberStatistics = response;
	        _this[response.queues._type] = response.queues;
	        _this.missingTurns = _calculateAmounts(response.queues);
	      }).catch(function (err) {
	        console.error(err);
	        $this["clients_absent"].activated = false;
	        _this._showMessageError = true;
	        $this.$translate("app.STATISTIC_ERROR_ABSENT").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, "Error");
	        });
	      });

	      // // Get turns clients absent  last week
	      // $this.Statistics.getTurnsAbsentByQueue({ locationId: locationId, from: fromLW, to: toLW }).$promise
	      //   .then(response => {
	      //     this.missingTurnsLW =  _calculateAmounts(response.queues);
	      //     this.waitingTurnsLW = this.allTurnsLW - this.attendedTurnsLW - this.missingTurnsLW;
	      //   })
	      //   .catch(err => {
	      //     console.error(err);
	      //     this._showMessageError = true;
	      //     $this.$translate('app.STATISTIC_ERROR_ABSENT').then((errorMsg) => {
	      //       $this.toastr.error(errorMsg, 'Error');
	      //     });
	      //   })

	      // Get employee turns statistics
	      $this.Supervisor.getTurnsByEmployee({
	        locationId: locationId,
	        from: from,
	        to: to
	      }).$promise.then(function (response) {
	        $this.employeeTurnsStatistics = response;
	        $this[response.employees.clients._type] = response.employees.clients;
	        $this[response.employees.queues._type] = response.employees.queues;
	        $this["queues_user"].no_data = false;
	        // $this.attendedTurns = _calculateAmounts(response.employees.clients);
	      }).catch(function (err) {
	        console.error(err);
	        $this["clients_user"].activated = false;
	        $this["queues_user"].activated = false;
	        $this.$translate("app.STATISTIC_ERROR_EMPLOYEE").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, "Error");
	        });
	      });

	      //   // Get employee turns statistics  last week
	      // $this.Statistics.getTurnsByEmployee({ locationId: locationId, from: fromLW, to: toLW }).$promise
	      // .then(response => {
	      //   this.attendedTurnsLW =  _calculateAmounts(response.employees.queues);
	      //   this.waitingTurnsLW = this.allTurnsLW - this.attendedTurnsLW - this.missingTurnsLW;
	      // })
	      // .catch(err => {
	      //   console.log(err)
	      //   $this.$translate('app.STATISTIC_ERROR_EMPLOYEE').then((errorMsg) => {
	      //     $this.toastr.error(errorMsg, 'Error');
	      //   });
	      // })

	      var filter = {
	        where: {
	          locationId: locationId,
	          startedAt: {
	            between: [from, to]
	          }
	        }
	      };

	      $this.WorkstationsInUse.getWorkstationInUse({ filter: filter }).$promise.then(function (response) {
	        if (response.length > 0) {
	          angular.forEach(response, function (value) {
	            value.index = value.workstationName.split(" ")[1];
	            value.loginAt = new Date(value.startedAt);
	          });
	          $this.workstationsInUse = response;
	        } else {
	          $this.workstationsInUse = false;
	        }
	      }).catch(function (err) {
	        console.log(err);
	        $this.$translate("app.STATISTIC_ERROR").then(function (errorMsg) {
	          $this.toastr.error(errorMsg, "Error");
	        });
	      }).finally(function () {
	        _this.waitingTurnsSupervisor = false;
	      });

	      $this.refreshTimer = $this.$timeout(function () {
	        $this._startAllStatistics($this.establishmentId);
	      }, $this.config.SUPERVISOR_REFRESH * 60000);
	    }

	    // exports
	    angular.extend(this, {
	      allowSelectRoles: allowSelectRoles,
	      _startAllStatistics: _startAllStatistics,
	      _waitingTimeStatistics: _waitingTimeStatistics
	    });
	  }

	  //////


	  _createClass(SupervisorController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      var _this2 = this;

	      var $this = this;
	      var organizationId = this.$localStorage.currentOrganization ? this.$localStorage.currentOrganization.id : this.$localStorage.currentLocation.organizationId;
	      var user_role = this.$localStorage.currentRole;
	      if (user_role.toUpperCase() != "ADMIN") {
	        // Load all establishments
	        this.AdministrationService.getEstablishments(user_role, organizationId, "locations").then(function (result) {
	          _this2.establishments = result;
	          _this2.establishmentSelected = result && _this2.establishmentId !== undefined ? JSON.stringify(result.find(function (objeto) {
	            return objeto.id === _this2.establishmentId;
	          })) : "";
	        }).catch(function (error) {
	          console.log(error);
	          _this2.$translate("app.API_ERROR").then(function (errorMsg) {
	            _this2.toastr.error(errorMsg, "Error");
	          });
	        });
	      }

	      if (!this.is_allowed) {
	        this.establishmentId = this.$localStorage.currentLocation.id;
	        this.establishmentInUse = this.$localStorage.currentLocation.name;
	      }
	      $this._startAllStatistics($this.establishmentId);
	    }
	  }, {
	    key: "selectLanguage",
	    value: function selectLanguage(lang) {
	      // Set the new idiom
	      this.$translate.use(lang);
	    }
	  }, {
	    key: "establishmentChanged",
	    value: function establishmentChanged() {
	      this.$localStorage.last_establishment = this.establishmentSelected;
	      var current_establishment = JSON.parse(this.establishmentSelected);
	      this.establishmentId = current_establishment.id;
	      this.establishmentInUse = current_establishment.name;
	      // this.establishmentSelected = undefined;
	      this._startAllStatistics(this.establishmentId);
	    }
	  }]);

	  return SupervisorController;
	}();

	SupervisorController.$inject = ["AdministrationService", "$translate", "config", "$location", "$rootScope", "$scope", "$localStorage", "Supervisor", "Statistics", "toastr", "AuthService", "WorkstationsInUse", "$timeout"];

	exports.default = SupervisorController;

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SupervisorService =

	/** @ngInject */
	function SupervisorService() {
	  _classCallCheck(this, SupervisorService);
	};

	//SupervisorService.$inject = ['EmployeesResource'];

	exports.default = SupervisorService;

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	'use strict';

	HelperService.$inject = ["$window", "$location", "_", "$log", "moment"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HelperService;

	/* @ngInject */

	function HelperService($window, $location, _, $log, moment) {
	  var service = {
	    validateInput: validateInput,
	    getIdFromUri: getIdFromUri,
	    parseDateFromYYYYMMMM: parseDateFromYYYYMMMM,
	    parseDateToYYYYMMMM: parseDateToYYYYMMMM,
	    parseDateFromYYYYMMDD: parseDateFromYYYYMMDD,
	    parseDateToYYYYMMDD: parseDateToYYYYMMDD,
	    mapKeysToObject: mapKeysToObject,
	    getValidDate: getValidDate,
	    getErrorMessage: getErrorMessage,
	    openWindow: openWindow,
	    getOffset: getOffset,
	    parseRoles: parseRoles
	  };

	  return service;

	  ////////////////


	  /**
	   * Valida los campos de los formularios
	   * @param form
	   * @param field
	   * @returns {*}
	   */
	  function validateInput(form, name) {
	    var input = form[name];
	    return (input.$dirty || form.$submitted) && input.$invalid;
	  }

	  function getIdFromUri(uri) {
	    var index = uri.lastIndexOf('/');
	    return uri.substr(index + 1);
	  }

	  function parseDateFromYYYYMMMM(year, month) {
	    try {
	      if (_.isEmpty(year) || _.isEmpty(month)) {
	        return false;
	      }
	      var m = moment([year, month], 'YYYY MMMM');
	      return m.isValid() ? m.format('YYYY-MM-DDT01:01:01') : false;
	    } catch (e) {
	      return false;
	    }
	  }

	  function parseDateToYYYYMMMM(date) {
	    try {
	      if (_.isEmpty(date)) {
	        return false;
	      }
	      var m = moment(date, moment.ISO_8601);
	      return m.isValid() ? {
	        year: m.format('YYYY'),
	        month: m.format('MMMM')
	      } : false;
	    } catch (e) {
	      return false;
	    }
	  }

	  function parseDateFromYYYYMMDD(year, month, day) {
	    try {
	      if (_.isEmpty(year) || _.isEmpty(month) || _.isEmpty(day)) {
	        return false;
	      }
	      var m = moment([year, month, day], 'YYYY MM DD');
	      return m.isValid() ? m.format('YYYY-MM-DDT01:01:01') : false;
	    } catch (e) {
	      return false;
	    }
	  }

	  function parseDateToYYYYMMDD(date) {
	    try {
	      if (_.isEmpty(date)) {
	        return false;
	      }
	      var m = moment(date, moment.ISO_8601);
	      return m.isValid() ? {
	        year: m.format('YYYY'),
	        month: m.format('MM'),
	        day: m.format('DD')
	      } : false;
	    } catch (e) {
	      return false;
	    }
	  }

	  function mapKeysToObject(source, props) {
	    var o = {};
	    if (_.isUndefined(source)) {
	      source = {};
	    }

	    props.forEach(function (prop) {
	      o[prop] = source[prop];
	    });
	    return o;
	  }

	  // TODO make test
	  /**
	   * Valida las fechas
	   * @param form
	   * @param name
	   * @param scope
	   * @returns {*}
	   */
	  function getValidDate(form, name, scope) {
	    var field = form[name];
	    if (!_.isEmpty(scope[name].year) || !_.isEmpty(scope[name].month) || !_.isEmpty(scope[name].day)) {
	      field.$setDirty();
	      var date = parseDateFromYYYYMMDD(scope[name].year, scope[name].month, scope[name].day);
	      if (date) {
	        field.$setValidity('date', true);
	        return date;
	      } else {
	        field.$setValidity('date', false);
	        return '';
	      }
	    } else {
	      field.$setValidity('date', true);
	      return '';
	    }
	  }

	  function getErrorMessage(error) {
	    if (error.data) {
	      if (!_.isEmpty(error.data.results)) {
	        return error.data.results[0].error_message;
	      }
	      return error.data.message;
	    }
	    return error.statusText ? error.statusText : 'ISolver, we have a problem!';
	  }

	  function openWindow(url, target) {
	    if (url.indexOf('http') >= 0) {
	      $window.open(url, target);
	    } else {
	      $location.path(url);
	    }
	  }

	  function getOffset(limit, current) {
	    return limit * (current - 1);
	  }

	  function parseRoles(roles) {
	    if (_.isString(roles)) {
	      try {
	        return JSON.parse(roles);
	      } catch (err) {
	        $log.error(err);
	        return {};
	      }
	    }
	  }
	}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	sentryServ.$inject = ["config"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _browser = __webpack_require__(131);

	var Sentry = _interopRequireWildcard(_browser);

	var _tracing = __webpack_require__(212);

	var _integrations = __webpack_require__(242);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function sentryServ(config) {
	    Sentry.init({
	        dsn: config.api.DSN,
	        integrations: [new _integrations.Angular(), new _tracing.BrowserTracing({
	            tracePropagationTargets: ["localhost", config.api.BASE_URL]
	        })],
	        tracesSampleRate: 1.0
	    });
	}

	exports.default = angular.module('sentry', []).config(sentryServ).name;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	tslib_1.__exportStar(__webpack_require__(133), exports);
	var core_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(140);
	var BrowserIntegrations = __webpack_require__(203);
	var Transports = __webpack_require__(194);
	exports.Transports = Transports;
	var windowIntegrations = {};
	// This block is needed to add compatibility with the integrations packages when used with a CDN
	var _window = utils_1.getGlobalObject();
	if (_window.Sentry && _window.Sentry.Integrations) {
	    windowIntegrations = _window.Sentry.Integrations;
	}
	var INTEGRATIONS = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, windowIntegrations), core_1.Integrations), BrowserIntegrations);
	exports.Integrations = INTEGRATIONS;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */

	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };

	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };

	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };

	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };

	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };

	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };

	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };

	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };

	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };

	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };

	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };

	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };

	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };

	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };

	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };

	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };

	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };

	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };

	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };

	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };

	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };

	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };

	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };

	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(134);
	exports.Severity = types_1.Severity;
	var core_1 = __webpack_require__(136);
	exports.addGlobalEventProcessor = core_1.addGlobalEventProcessor;
	exports.addBreadcrumb = core_1.addBreadcrumb;
	exports.captureException = core_1.captureException;
	exports.captureEvent = core_1.captureEvent;
	exports.captureMessage = core_1.captureMessage;
	exports.configureScope = core_1.configureScope;
	exports.getHubFromCarrier = core_1.getHubFromCarrier;
	exports.getCurrentHub = core_1.getCurrentHub;
	exports.Hub = core_1.Hub;
	exports.makeMain = core_1.makeMain;
	exports.Scope = core_1.Scope;
	exports.Session = core_1.Session;
	exports.startTransaction = core_1.startTransaction;
	exports.SDK_VERSION = core_1.SDK_VERSION;
	exports.setContext = core_1.setContext;
	exports.setExtra = core_1.setExtra;
	exports.setExtras = core_1.setExtras;
	exports.setTag = core_1.setTag;
	exports.setTags = core_1.setTags;
	exports.setUser = core_1.setUser;
	exports.withScope = core_1.withScope;
	var client_1 = __webpack_require__(190);
	exports.BrowserClient = client_1.BrowserClient;
	var helpers_1 = __webpack_require__(202);
	exports.injectReportDialog = helpers_1.injectReportDialog;
	var eventbuilder_1 = __webpack_require__(192);
	exports.eventFromException = eventbuilder_1.eventFromException;
	exports.eventFromMessage = eventbuilder_1.eventFromMessage;
	var sdk_1 = __webpack_require__(210);
	exports.defaultIntegrations = sdk_1.defaultIntegrations;
	exports.forceLoad = sdk_1.forceLoad;
	exports.init = sdk_1.init;
	exports.lastEventId = sdk_1.lastEventId;
	exports.onLoad = sdk_1.onLoad;
	exports.showReportDialog = sdk_1.showReportDialog;
	exports.flush = sdk_1.flush;
	exports.close = sdk_1.close;
	exports.wrap = sdk_1.wrap;
	var version_1 = __webpack_require__(211);
	exports.SDK_NAME = version_1.SDK_NAME;
	//# sourceMappingURL=exports.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var severity_1 = __webpack_require__(135);
	exports.Severity = severity_1.Severity;
	var severity_2 = __webpack_require__(135);
	exports.SeverityLevels = severity_2.SeverityLevels;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * TODO(v7): Remove this enum and replace with SeverityLevel
	 */
	var Severity;
	(function (Severity) {
	    /** JSDoc */
	    Severity["Fatal"] = "fatal";
	    /** JSDoc */
	    Severity["Error"] = "error";
	    /** JSDoc */
	    Severity["Warning"] = "warning";
	    /** JSDoc */
	    Severity["Log"] = "log";
	    /** JSDoc */
	    Severity["Info"] = "info";
	    /** JSDoc */
	    Severity["Debug"] = "debug";
	    /** JSDoc */
	    Severity["Critical"] = "critical";
	})(Severity = exports.Severity || (exports.Severity = {}));
	// TODO: in v7, these can disappear, because they now also exist in `@sentry/utils`. (Having them there rather than here
	// is nice because then it enforces the idea that only types are exported from `@sentry/types`.)
	exports.SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
	//# sourceMappingURL=severity.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var minimal_1 = __webpack_require__(137);
	exports.addBreadcrumb = minimal_1.addBreadcrumb;
	exports.captureException = minimal_1.captureException;
	exports.captureEvent = minimal_1.captureEvent;
	exports.captureMessage = minimal_1.captureMessage;
	exports.configureScope = minimal_1.configureScope;
	exports.startTransaction = minimal_1.startTransaction;
	exports.setContext = minimal_1.setContext;
	exports.setExtra = minimal_1.setExtra;
	exports.setExtras = minimal_1.setExtras;
	exports.setTag = minimal_1.setTag;
	exports.setTags = minimal_1.setTags;
	exports.setUser = minimal_1.setUser;
	exports.withScope = minimal_1.withScope;
	var hub_1 = __webpack_require__(138);
	exports.addGlobalEventProcessor = hub_1.addGlobalEventProcessor;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.Scope = hub_1.Scope;
	exports.Session = hub_1.Session;
	var api_1 = __webpack_require__(177);
	// eslint-disable-next-line deprecation/deprecation
	exports.API = api_1.API;
	exports.getEnvelopeEndpointWithUrlEncodedAuth = api_1.getEnvelopeEndpointWithUrlEncodedAuth;
	exports.getStoreEndpointWithUrlEncodedAuth = api_1.getStoreEndpointWithUrlEncodedAuth;
	exports.getRequestHeaders = api_1.getRequestHeaders;
	exports.initAPIDetails = api_1.initAPIDetails;
	exports.getReportDialogEndpoint = api_1.getReportDialogEndpoint;
	var baseclient_1 = __webpack_require__(178);
	exports.BaseClient = baseclient_1.BaseClient;
	var basebackend_1 = __webpack_require__(181);
	exports.BaseBackend = basebackend_1.BaseBackend;
	var request_1 = __webpack_require__(182);
	exports.eventToSentryRequest = request_1.eventToSentryRequest;
	exports.sessionToSentryRequest = request_1.sessionToSentryRequest;
	var sdk_1 = __webpack_require__(184);
	exports.initAndBind = sdk_1.initAndBind;
	var noop_1 = __webpack_require__(183);
	exports.NoopTransport = noop_1.NoopTransport;
	var base_1 = __webpack_require__(185);
	exports.createTransport = base_1.createTransport;
	var version_1 = __webpack_require__(186);
	exports.SDK_VERSION = version_1.SDK_VERSION;
	var Integrations = __webpack_require__(187);
	exports.Integrations = Integrations;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var hub_1 = __webpack_require__(138);
	/**
	 * This calls a function on the current hub.
	 * @param method function to call on hub.
	 * @param args to pass to function.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function callOnHub(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    var hub = hub_1.getCurrentHub();
	    if (hub && hub[method]) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return hub[method].apply(hub, tslib_1.__spread(args));
	    }
	    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
	}
	/**
	 * Captures an exception event and sends it to Sentry.
	 *
	 * @param exception An exception-like object.
	 * @returns The generated eventId.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function captureException(exception, captureContext) {
	    var syntheticException = new Error('Sentry syntheticException');
	    return callOnHub('captureException', exception, {
	        captureContext: captureContext,
	        originalException: exception,
	        syntheticException: syntheticException,
	    });
	}
	exports.captureException = captureException;
	/**
	 * Captures a message event and sends it to Sentry.
	 *
	 * @param message The message to send to Sentry.
	 * @param Severity Define the level of the message.
	 * @returns The generated eventId.
	 */
	function captureMessage(message, captureContext) {
	    var syntheticException = new Error(message);
	    // This is necessary to provide explicit scopes upgrade, without changing the original
	    // arity of the `captureMessage(message, level)` method.
	    var level = typeof captureContext === 'string' ? captureContext : undefined;
	    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
	    return callOnHub('captureMessage', message, level, tslib_1.__assign({ originalException: message, syntheticException: syntheticException }, context));
	}
	exports.captureMessage = captureMessage;
	/**
	 * Captures a manually created event and sends it to Sentry.
	 *
	 * @param event The event to send to Sentry.
	 * @returns The generated eventId.
	 */
	function captureEvent(event) {
	    return callOnHub('captureEvent', event);
	}
	exports.captureEvent = captureEvent;
	/**
	 * Callback to set context information onto the scope.
	 * @param callback Callback function that receives Scope.
	 */
	function configureScope(callback) {
	    callOnHub('configureScope', callback);
	}
	exports.configureScope = configureScope;
	/**
	 * Records a new breadcrumb which will be attached to future events.
	 *
	 * Breadcrumbs will be added to subsequent events to provide more context on
	 * user's actions prior to an error or crash.
	 *
	 * @param breadcrumb The breadcrumb to record.
	 */
	function addBreadcrumb(breadcrumb) {
	    callOnHub('addBreadcrumb', breadcrumb);
	}
	exports.addBreadcrumb = addBreadcrumb;
	/**
	 * Sets context data with the given name.
	 * @param name of the context
	 * @param context Any kind of data. This data will be normalized.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function setContext(name, context) {
	    callOnHub('setContext', name, context);
	}
	exports.setContext = setContext;
	/**
	 * Set an object that will be merged sent as extra data with the event.
	 * @param extras Extras object to merge into current context.
	 */
	function setExtras(extras) {
	    callOnHub('setExtras', extras);
	}
	exports.setExtras = setExtras;
	/**
	 * Set an object that will be merged sent as tags data with the event.
	 * @param tags Tags context object to merge into current context.
	 */
	function setTags(tags) {
	    callOnHub('setTags', tags);
	}
	exports.setTags = setTags;
	/**
	 * Set key:value that will be sent as extra data with the event.
	 * @param key String of extra
	 * @param extra Any kind of data. This data will be normalized.
	 */
	function setExtra(key, extra) {
	    callOnHub('setExtra', key, extra);
	}
	exports.setExtra = setExtra;
	/**
	 * Set key:value that will be sent as tags data with the event.
	 *
	 * Can also be used to unset a tag, by passing `undefined`.
	 *
	 * @param key String key of tag
	 * @param value Value of tag
	 */
	function setTag(key, value) {
	    callOnHub('setTag', key, value);
	}
	exports.setTag = setTag;
	/**
	 * Updates user context information for future events.
	 *
	 * @param user User context object to be set in the current context. Pass `null` to unset the user.
	 */
	function setUser(user) {
	    callOnHub('setUser', user);
	}
	exports.setUser = setUser;
	/**
	 * Creates a new scope with and executes the given operation within.
	 * The scope is automatically removed once the operation
	 * finishes or throws.
	 *
	 * This is essentially a convenience function for:
	 *
	 *     pushScope();
	 *     callback();
	 *     popScope();
	 *
	 * @param callback that will be enclosed into push/popScope.
	 */
	function withScope(callback) {
	    callOnHub('withScope', callback);
	}
	exports.withScope = withScope;
	/**
	 * Calls a function on the latest client. Use this with caution, it's meant as
	 * in "internal" helper so we don't need to expose every possible function in
	 * the shim. It is not guaranteed that the client actually implements the
	 * function.
	 *
	 * @param method The method to call on the client/client.
	 * @param args Arguments to pass to the client/fontend.
	 * @hidden
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _callOnClient(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    callOnHub.apply(void 0, tslib_1.__spread(['_invokeClient', method], args));
	}
	exports._callOnClient = _callOnClient;
	/**
	 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
	 *
	 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
	 * new child span within the transaction or any span, call the respective `.startChild()` method.
	 *
	 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
	 *
	 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
	 * finished child spans will be sent to Sentry.
	 *
	 * @param context Properties of the new `Transaction`.
	 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
	 * default values). See {@link Options.tracesSampler}.
	 *
	 * @returns The transaction which was just started
	 */
	function startTransaction(context, customSamplingContext) {
	    return callOnHub('startTransaction', tslib_1.__assign({}, context), customSamplingContext);
	}
	exports.startTransaction = startTransaction;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var scope_1 = __webpack_require__(139);
	exports.addGlobalEventProcessor = scope_1.addGlobalEventProcessor;
	exports.Scope = scope_1.Scope;
	var session_1 = __webpack_require__(173);
	exports.Session = session_1.Session;
	var sessionflusher_1 = __webpack_require__(174);
	exports.SessionFlusher = sessionflusher_1.SessionFlusher;
	var hub_1 = __webpack_require__(176);
	// eslint-disable-next-line deprecation/deprecation
	exports.getActiveDomain = hub_1.getActiveDomain;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.getMainCarrier = hub_1.getMainCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.setHubOnCarrier = hub_1.setHubOnCarrier;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	/**
	 * Absolute maximum number of breadcrumbs added to an event.
	 * The `maxBreadcrumbs` option cannot be higher than this value.
	 */
	var MAX_BREADCRUMBS = 100;
	/**
	 * Holds additional event information. {@link Scope.applyToEvent} will be
	 * called by the client before an event will be sent.
	 */
	var Scope = /** @class */ (function () {
	    function Scope() {
	        /** Flag if notifying is happening. */
	        this._notifyingListeners = false;
	        /** Callback for client to receive scope changes. */
	        this._scopeListeners = [];
	        /** Callback list that will be called after {@link applyToEvent}. */
	        this._eventProcessors = [];
	        /** Array of breadcrumbs. */
	        this._breadcrumbs = [];
	        /** User */
	        this._user = {};
	        /** Tags */
	        this._tags = {};
	        /** Extra */
	        this._extra = {};
	        /** Contexts */
	        this._contexts = {};
	        /**
	         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
	         * sent to Sentry
	         */
	        this._sdkProcessingMetadata = {};
	    }
	    /**
	     * Inherit values from the parent scope.
	     * @param scope to clone.
	     */
	    Scope.clone = function (scope) {
	        var newScope = new Scope();
	        if (scope) {
	            newScope._breadcrumbs = tslib_1.__spread(scope._breadcrumbs);
	            newScope._tags = tslib_1.__assign({}, scope._tags);
	            newScope._extra = tslib_1.__assign({}, scope._extra);
	            newScope._contexts = tslib_1.__assign({}, scope._contexts);
	            newScope._user = scope._user;
	            newScope._level = scope._level;
	            newScope._span = scope._span;
	            newScope._session = scope._session;
	            newScope._transactionName = scope._transactionName;
	            newScope._fingerprint = scope._fingerprint;
	            newScope._eventProcessors = tslib_1.__spread(scope._eventProcessors);
	            newScope._requestSession = scope._requestSession;
	        }
	        return newScope;
	    };
	    /**
	     * Add internal on change listener. Used for sub SDKs that need to store the scope.
	     * @hidden
	     */
	    Scope.prototype.addScopeListener = function (callback) {
	        this._scopeListeners.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addEventProcessor = function (callback) {
	        this._eventProcessors.push(callback);
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setUser = function (user) {
	        this._user = user || {};
	        if (this._session) {
	            this._session.update({ user: user });
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getUser = function () {
	        return this._user;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getRequestSession = function () {
	        return this._requestSession;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setRequestSession = function (requestSession) {
	        this._requestSession = requestSession;
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTags = function (tags) {
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), tags);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTag = function (key, value) {
	        var _a;
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), (_a = {}, _a[key] = value, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtras = function (extras) {
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), extras);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtra = function (key, extra) {
	        var _a;
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), (_a = {}, _a[key] = extra, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setFingerprint = function (fingerprint) {
	        this._fingerprint = fingerprint;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setLevel = function (level) {
	        this._level = level;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTransactionName = function (name) {
	        this._transactionName = name;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Can be removed in major version.
	     * @deprecated in favor of {@link this.setTransactionName}
	     */
	    Scope.prototype.setTransaction = function (name) {
	        return this.setTransactionName(name);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setContext = function (key, context) {
	        var _a;
	        if (context === null) {
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this._contexts[key];
	        }
	        else {
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), (_a = {}, _a[key] = context, _a));
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSpan = function (span) {
	        this._span = span;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSpan = function () {
	        return this._span;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getTransaction = function () {
	        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
	        // have a pointer to the currently-active transaction.
	        var span = this.getSpan();
	        return span && span.transaction;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSession = function (session) {
	        if (!session) {
	            delete this._session;
	        }
	        else {
	            this._session = session;
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSession = function () {
	        return this._session;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.update = function (captureContext) {
	        if (!captureContext) {
	            return this;
	        }
	        if (typeof captureContext === 'function') {
	            var updatedScope = captureContext(this);
	            return updatedScope instanceof Scope ? updatedScope : this;
	        }
	        if (captureContext instanceof Scope) {
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext._tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext._extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext._contexts);
	            if (captureContext._user && Object.keys(captureContext._user).length) {
	                this._user = captureContext._user;
	            }
	            if (captureContext._level) {
	                this._level = captureContext._level;
	            }
	            if (captureContext._fingerprint) {
	                this._fingerprint = captureContext._fingerprint;
	            }
	            if (captureContext._requestSession) {
	                this._requestSession = captureContext._requestSession;
	            }
	        }
	        else if (utils_1.isPlainObject(captureContext)) {
	            // eslint-disable-next-line no-param-reassign
	            captureContext = captureContext;
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext.tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext.extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext.contexts);
	            if (captureContext.user) {
	                this._user = captureContext.user;
	            }
	            if (captureContext.level) {
	                this._level = captureContext.level;
	            }
	            if (captureContext.fingerprint) {
	                this._fingerprint = captureContext.fingerprint;
	            }
	            if (captureContext.requestSession) {
	                this._requestSession = captureContext.requestSession;
	            }
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clear = function () {
	        this._breadcrumbs = [];
	        this._tags = {};
	        this._extra = {};
	        this._user = {};
	        this._contexts = {};
	        this._level = undefined;
	        this._transactionName = undefined;
	        this._fingerprint = undefined;
	        this._requestSession = undefined;
	        this._span = undefined;
	        this._session = undefined;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
	        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
	        // No data has been changed, so don't notify scope listeners
	        if (maxCrumbs <= 0) {
	            return this;
	        }
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: utils_1.dateTimestampInSeconds() }, breadcrumb);
	        this._breadcrumbs = tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clearBreadcrumbs = function () {
	        this._breadcrumbs = [];
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Applies the current context and fingerprint to the event.
	     * Note that breadcrumbs will be added by the client.
	     * Also if the event has already breadcrumbs on it, we do not merge them.
	     * @param event Event
	     * @param hint May contain additional information about the original exception.
	     * @hidden
	     */
	    Scope.prototype.applyToEvent = function (event, hint) {
	        if (this._extra && Object.keys(this._extra).length) {
	            event.extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), event.extra);
	        }
	        if (this._tags && Object.keys(this._tags).length) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), event.tags);
	        }
	        if (this._user && Object.keys(this._user).length) {
	            event.user = tslib_1.__assign(tslib_1.__assign({}, this._user), event.user);
	        }
	        if (this._contexts && Object.keys(this._contexts).length) {
	            event.contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), event.contexts);
	        }
	        if (this._level) {
	            event.level = this._level;
	        }
	        if (this._transactionName) {
	            event.transaction = this._transactionName;
	        }
	        // We want to set the trace context for normal events only if there isn't already
	        // a trace context on the event. There is a product feature in place where we link
	        // errors with transaction and it relies on that.
	        if (this._span) {
	            event.contexts = tslib_1.__assign({ trace: this._span.getTraceContext() }, event.contexts);
	            var transactionName = this._span.transaction && this._span.transaction.name;
	            if (transactionName) {
	                event.tags = tslib_1.__assign({ transaction: transactionName }, event.tags);
	            }
	        }
	        this._applyFingerprint(event);
	        event.breadcrumbs = tslib_1.__spread((event.breadcrumbs || []), this._breadcrumbs);
	        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
	        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
	        return this._notifyEventProcessors(tslib_1.__spread(getGlobalEventProcessors(), this._eventProcessors), event, hint);
	    };
	    /**
	     * Add data which will be accessible during event processing but won't get sent to Sentry
	     */
	    Scope.prototype.setSDKProcessingMetadata = function (newData) {
	        this._sdkProcessingMetadata = tslib_1.__assign(tslib_1.__assign({}, this._sdkProcessingMetadata), newData);
	        return this;
	    };
	    /**
	     * This will be called after {@link applyToEvent} is finished.
	     */
	    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
	        var _this = this;
	        if (index === void 0) { index = 0; }
	        return new utils_1.SyncPromise(function (resolve, reject) {
	            var processor = processors[index];
	            if (event === null || typeof processor !== 'function') {
	                resolve(event);
	            }
	            else {
	                var result = processor(tslib_1.__assign({}, event), hint);
	                if (utils_1.isThenable(result)) {
	                    void result
	                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
	                        .then(null, reject);
	                }
	                else {
	                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
	                        .then(resolve)
	                        .then(null, reject);
	                }
	            }
	        });
	    };
	    /**
	     * This will be called on every set call.
	     */
	    Scope.prototype._notifyScopeListeners = function () {
	        var _this = this;
	        // We need this check for this._notifyingListeners to be able to work on scope during updates
	        // If this check is not here we'll produce endless recursion when something is done with the scope
	        // during the callback.
	        if (!this._notifyingListeners) {
	            this._notifyingListeners = true;
	            this._scopeListeners.forEach(function (callback) {
	                callback(_this);
	            });
	            this._notifyingListeners = false;
	        }
	    };
	    /**
	     * Applies fingerprint from the scope to the event if there's one,
	     * uses message if there's one instead or get rid of empty fingerprint
	     */
	    Scope.prototype._applyFingerprint = function (event) {
	        // Make sure it's an array first and we actually have something in place
	        event.fingerprint = event.fingerprint
	            ? Array.isArray(event.fingerprint)
	                ? event.fingerprint
	                : [event.fingerprint]
	            : [];
	        // If we have something on the scope, then merge it with event
	        if (this._fingerprint) {
	            event.fingerprint = event.fingerprint.concat(this._fingerprint);
	        }
	        // If we have no data at all, remove empty array default
	        if (event.fingerprint && !event.fingerprint.length) {
	            delete event.fingerprint;
	        }
	    };
	    return Scope;
	}());
	exports.Scope = Scope;
	/**
	 * Returns the global event processors.
	 */
	function getGlobalEventProcessors() {
	    return utils_1.getGlobalSingleton('globalEventProcessors', function () { return []; });
	}
	/**
	 * Add a EventProcessor to be kept globally.
	 * @param callback EventProcessor to add
	 */
	function addGlobalEventProcessor(callback) {
	    getGlobalEventProcessors().push(callback);
	}
	exports.addGlobalEventProcessor = addGlobalEventProcessor;
	//# sourceMappingURL=scope.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	tslib_1.__exportStar(__webpack_require__(141), exports);
	tslib_1.__exportStar(__webpack_require__(142), exports);
	tslib_1.__exportStar(__webpack_require__(149), exports);
	tslib_1.__exportStar(__webpack_require__(153), exports);
	tslib_1.__exportStar(__webpack_require__(150), exports);
	tslib_1.__exportStar(__webpack_require__(143), exports);
	tslib_1.__exportStar(__webpack_require__(154), exports);
	tslib_1.__exportStar(__webpack_require__(148), exports);
	tslib_1.__exportStar(__webpack_require__(155), exports);
	tslib_1.__exportStar(__webpack_require__(160), exports);
	tslib_1.__exportStar(__webpack_require__(161), exports);
	tslib_1.__exportStar(__webpack_require__(144), exports);
	tslib_1.__exportStar(__webpack_require__(162), exports);
	tslib_1.__exportStar(__webpack_require__(156), exports);
	tslib_1.__exportStar(__webpack_require__(163), exports);
	tslib_1.__exportStar(__webpack_require__(164), exports);
	tslib_1.__exportStar(__webpack_require__(166), exports);
	tslib_1.__exportStar(__webpack_require__(158), exports);
	tslib_1.__exportStar(__webpack_require__(167), exports);
	tslib_1.__exportStar(__webpack_require__(157), exports);
	tslib_1.__exportStar(__webpack_require__(159), exports);
	tslib_1.__exportStar(__webpack_require__(165), exports);
	tslib_1.__exportStar(__webpack_require__(168), exports);
	tslib_1.__exportStar(__webpack_require__(169), exports);
	tslib_1.__exportStar(__webpack_require__(147), exports);
	tslib_1.__exportStar(__webpack_require__(170), exports);
	tslib_1.__exportStar(__webpack_require__(171), exports);
	tslib_1.__exportStar(__webpack_require__(172), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Consumes the promise and logs the error when it rejects.
	 * @param promise A promise to forget.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function forget(promise) {
	    void promise.then(null, function (e) {
	        // TODO: Use a better logging mechanism
	        // eslint-disable-next-line no-console
	        console.error(e);
	    });
	}
	exports.forget = forget;
	//# sourceMappingURL=async.js.map

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var global_1 = __webpack_require__(143);
	var is_1 = __webpack_require__(148);
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function htmlTreeAsString(elem, keyAttrs) {
	    // try/catch both:
	    // - accessing event.target (see getsentry/raven-js#838, #768)
	    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	    // - can throw an exception in some circumstances.
	    try {
	        var currentElem = elem;
	        var MAX_TRAVERSE_HEIGHT = 5;
	        var MAX_OUTPUT_LEN = 80;
	        var out = [];
	        var height = 0;
	        var len = 0;
	        var separator = ' > ';
	        var sepLength = separator.length;
	        var nextStr = void 0;
	        // eslint-disable-next-line no-plusplus
	        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
	            nextStr = _htmlElementAsString(currentElem, keyAttrs);
	            // bail out if
	            // - nextStr is the 'html' element
	            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	            //   (ignore this limit if we are on the first iteration)
	            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
	                break;
	            }
	            out.push(nextStr);
	            len += nextStr.length;
	            currentElem = currentElem.parentNode;
	        }
	        return out.reverse().join(separator);
	    }
	    catch (_oO) {
	        return '<unknown>';
	    }
	}
	exports.htmlTreeAsString = htmlTreeAsString;
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function _htmlElementAsString(el, keyAttrs) {
	    var elem = el;
	    var out = [];
	    var className;
	    var classes;
	    var key;
	    var attr;
	    var i;
	    if (!elem || !elem.tagName) {
	        return '';
	    }
	    out.push(elem.tagName.toLowerCase());
	    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
	    var keyAttrPairs = keyAttrs && keyAttrs.length
	        ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
	        : null;
	    if (keyAttrPairs && keyAttrPairs.length) {
	        keyAttrPairs.forEach(function (keyAttrPair) {
	            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
	        });
	    }
	    else {
	        if (elem.id) {
	            out.push("#" + elem.id);
	        }
	        // eslint-disable-next-line prefer-const
	        className = elem.className;
	        if (className && is_1.isString(className)) {
	            classes = className.split(/\s+/);
	            for (i = 0; i < classes.length; i++) {
	                out.push("." + classes[i]);
	            }
	        }
	    }
	    var allowedAttrs = ['type', 'name', 'title', 'alt'];
	    for (i = 0; i < allowedAttrs.length; i++) {
	        key = allowedAttrs[i];
	        attr = elem.getAttribute(key);
	        if (attr) {
	            out.push("[" + key + "=\"" + attr + "\"]");
	        }
	    }
	    return out.join('');
	}
	/**
	 * A safe form of location.href
	 */
	function getLocationHref() {
	    var global = global_1.getGlobalObject();
	    try {
	        return global.document.location.href;
	    }
	    catch (oO) {
	        return '';
	    }
	}
	exports.getLocationHref = getLocationHref;
	//# sourceMappingURL=browser.js.map

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
	 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var node_1 = __webpack_require__(144);
	var fallbackGlobalObject = {};
	/**
	 * Safely get global scope object
	 *
	 * @returns Global scope object
	 */
	function getGlobalObject() {
	    return (node_1.isNodeEnv()
	        ? global
	        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
	            ? window // eslint-disable-line no-restricted-globals
	            : typeof self !== 'undefined'
	                ? self
	                : fallbackGlobalObject);
	}
	exports.getGlobalObject = getGlobalObject;
	/**
	 * Returns a global singleton contained in the global `__SENTRY__` object.
	 *
	 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
	 * function and added to the `__SENTRY__` object.
	 *
	 * @param name name of the global singleton on __SENTRY__
	 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
	 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
	 * @returns the singleton
	 */
	function getGlobalSingleton(name, creator, obj) {
	    var global = (obj || getGlobalObject());
	    var __SENTRY__ = (global.__SENTRY__ = global.__SENTRY__ || {});
	    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
	    return singleton;
	}
	exports.getGlobalSingleton = getGlobalSingleton;
	//# sourceMappingURL=global.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {/**
	 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
	 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var env_1 = __webpack_require__(147);
	/**
	 * Checks whether we're in the Node.js or Browser environment
	 *
	 * @returns Answer to given question
	 */
	function isNodeEnv() {
	    // explicitly check for browser bundles as those can be optimized statically
	    // by terser/rollup.
	    return (!env_1.isBrowserBundle() &&
	        Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]');
	}
	exports.isNodeEnv = isNodeEnv;
	/**
	 * Requires a module which is protected against bundler minification.
	 *
	 * @param request The module path to resolve
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
	function dynamicRequire(mod, request) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return mod.require(request);
	}
	exports.dynamicRequire = dynamicRequire;
	/**
	 * Helper for dynamically loading module that should work with linked dependencies.
	 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
	 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
	 * build time. `require.resolve` is also not available in any other way, so we cannot create,
	 * a fake helper like we do with `dynamicRequire`.
	 *
	 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
	 * That is to mimic the behavior of `require.resolve` exactly.
	 *
	 * @param moduleName module name to require
	 * @returns possibly required module
	 */
	function loadModule(moduleName) {
	    var mod;
	    try {
	        mod = dynamicRequire(module, moduleName);
	    }
	    catch (e) {
	        // no-empty
	    }
	    try {
	        var cwd = dynamicRequire(module, 'process').cwd;
	        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
	    }
	    catch (e) {
	        // no-empty
	    }
	    return mod;
	}
	exports.loadModule = loadModule;
	//# sourceMappingURL=node.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(145), __webpack_require__(146)(module)))

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	/*
	 * This module exists for optimizations in the build process through rollup and terser.  We define some global
	 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
	 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
	 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
	 * `logger` and preventing node-related code from appearing in browser bundles.
	 *
	 * Attention:
	 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
	 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
	 * having issues tree-shaking these constants across package boundaries.
	 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
	 * users to be able to shake away expressions that it guards.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Figures out if we're building a browser bundle.
	 *
	 * @returns true if this is a browser bundle build.
	 */
	function isBrowserBundle() {
	    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
	}
	exports.isBrowserBundle = isBrowserBundle;
	//# sourceMappingURL=env.js.map

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	Object.defineProperty(exports, "__esModule", { value: true });
	// eslint-disable-next-line @typescript-eslint/unbound-method
	var objectToString = Object.prototype.toString;
	/**
	 * Checks whether given value's type is one of a few Error or Error-like
	 * {@link isError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isError(wat) {
	    switch (objectToString.call(wat)) {
	        case '[object Error]':
	        case '[object Exception]':
	        case '[object DOMException]':
	            return true;
	        default:
	            return isInstanceOf(wat, Error);
	    }
	}
	exports.isError = isError;
	function isBuiltin(wat, ty) {
	    return objectToString.call(wat) === "[object " + ty + "]";
	}
	/**
	 * Checks whether given value's type is ErrorEvent
	 * {@link isErrorEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isErrorEvent(wat) {
	    return isBuiltin(wat, 'ErrorEvent');
	}
	exports.isErrorEvent = isErrorEvent;
	/**
	 * Checks whether given value's type is DOMError
	 * {@link isDOMError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMError(wat) {
	    return isBuiltin(wat, 'DOMError');
	}
	exports.isDOMError = isDOMError;
	/**
	 * Checks whether given value's type is DOMException
	 * {@link isDOMException}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMException(wat) {
	    return isBuiltin(wat, 'DOMException');
	}
	exports.isDOMException = isDOMException;
	/**
	 * Checks whether given value's type is a string
	 * {@link isString}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isString(wat) {
	    return isBuiltin(wat, 'String');
	}
	exports.isString = isString;
	/**
	 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
	 * {@link isPrimitive}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPrimitive(wat) {
	    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
	}
	exports.isPrimitive = isPrimitive;
	/**
	 * Checks whether given value's type is an object literal
	 * {@link isPlainObject}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPlainObject(wat) {
	    return isBuiltin(wat, 'Object');
	}
	exports.isPlainObject = isPlainObject;
	/**
	 * Checks whether given value's type is an Event instance
	 * {@link isEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isEvent(wat) {
	    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
	}
	exports.isEvent = isEvent;
	/**
	 * Checks whether given value's type is an Element instance
	 * {@link isElement}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isElement(wat) {
	    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
	}
	exports.isElement = isElement;
	/**
	 * Checks whether given value's type is an regexp
	 * {@link isRegExp}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isRegExp(wat) {
	    return isBuiltin(wat, 'RegExp');
	}
	exports.isRegExp = isRegExp;
	/**
	 * Checks whether given value has a then function.
	 * @param wat A value to be checked.
	 */
	function isThenable(wat) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return Boolean(wat && wat.then && typeof wat.then === 'function');
	}
	exports.isThenable = isThenable;
	/**
	 * Checks whether given value's type is a SyntheticEvent
	 * {@link isSyntheticEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isSyntheticEvent(wat) {
	    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
	}
	exports.isSyntheticEvent = isSyntheticEvent;
	/**
	 * Checks whether given value is NaN
	 * {@link isNaN}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isNaN(wat) {
	    return typeof wat === 'number' && wat !== wat;
	}
	exports.isNaN = isNaN;
	/**
	 * Checks whether given value's type is an instance of provided constructor.
	 * {@link isInstanceOf}.
	 *
	 * @param wat A value to be checked.
	 * @param base A constructor to be used in a check.
	 * @returns A boolean representing the result.
	 */
	function isInstanceOf(wat, base) {
	    try {
	        return wat instanceof base;
	    }
	    catch (_e) {
	        return false;
	    }
	}
	exports.isInstanceOf = isInstanceOf;
	//# sourceMappingURL=is.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var error_1 = __webpack_require__(150);
	var flags_1 = __webpack_require__(152);
	/** Regular expression used to parse a Dsn. */
	var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
	function isValidProtocol(protocol) {
	    return protocol === 'http' || protocol === 'https';
	}
	/**
	 * Renders the string representation of this Dsn.
	 *
	 * By default, this will render the public representation without the password
	 * component. To get the deprecated private representation, set `withPassword`
	 * to true.
	 *
	 * @param withPassword When set to true, the password will be included.
	 */
	function dsnToString(dsn, withPassword) {
	    if (withPassword === void 0) { withPassword = false; }
	    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
	    return (protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') +
	        ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
	}
	exports.dsnToString = dsnToString;
	function dsnFromString(str) {
	    var match = DSN_REGEX.exec(str);
	    if (!match) {
	        throw new error_1.SentryError("Invalid Sentry Dsn: " + str);
	    }
	    var _a = tslib_1.__read(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
	    var path = '';
	    var projectId = lastPath;
	    var split = projectId.split('/');
	    if (split.length > 1) {
	        path = split.slice(0, -1).join('/');
	        projectId = split.pop();
	    }
	    if (projectId) {
	        var projectMatch = projectId.match(/^\d+/);
	        if (projectMatch) {
	            projectId = projectMatch[0];
	        }
	    }
	    return dsnFromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, publicKey: publicKey });
	}
	function dsnFromComponents(components) {
	    // TODO this is for backwards compatibility, and can be removed in a future version
	    if ('user' in components && !('publicKey' in components)) {
	        components.publicKey = components.user;
	    }
	    return {
	        user: components.publicKey || '',
	        protocol: components.protocol,
	        publicKey: components.publicKey || '',
	        pass: components.pass || '',
	        host: components.host,
	        port: components.port || '',
	        path: components.path || '',
	        projectId: components.projectId,
	    };
	}
	function validateDsn(dsn) {
	    if (!flags_1.IS_DEBUG_BUILD) {
	        return;
	    }
	    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
	    var requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
	    requiredComponents.forEach(function (component) {
	        if (!dsn[component]) {
	            throw new error_1.SentryError("Invalid Sentry Dsn: " + component + " missing");
	        }
	    });
	    if (!projectId.match(/^\d+$/)) {
	        throw new error_1.SentryError("Invalid Sentry Dsn: Invalid projectId " + projectId);
	    }
	    if (!isValidProtocol(protocol)) {
	        throw new error_1.SentryError("Invalid Sentry Dsn: Invalid protocol " + protocol);
	    }
	    if (port && isNaN(parseInt(port, 10))) {
	        throw new error_1.SentryError("Invalid Sentry Dsn: Invalid port " + port);
	    }
	    return true;
	}
	/** The Sentry Dsn, identifying a Sentry instance and project. */
	function makeDsn(from) {
	    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
	    validateDsn(components);
	    return components;
	}
	exports.makeDsn = makeDsn;
	//# sourceMappingURL=dsn.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var polyfill_1 = __webpack_require__(151);
	/** An error emitted by Sentry SDKs and related utilities. */
	var SentryError = /** @class */ (function (_super) {
	    tslib_1.__extends(SentryError, _super);
	    function SentryError(message) {
	        var _newTarget = this.constructor;
	        var _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _newTarget.prototype.constructor.name;
	        polyfill_1.setPrototypeOf(_this, _newTarget.prototype);
	        return _this;
	    }
	    return SentryError;
	}(Error));
	exports.SentryError = SentryError;
	//# sourceMappingURL=error.js.map

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
	/**
	 * setPrototypeOf polyfill using __proto__
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function setProtoOf(obj, proto) {
	    // @ts-ignore __proto__ does not exist on obj
	    obj.__proto__ = proto;
	    return obj;
	}
	/**
	 * setPrototypeOf polyfill using mixin
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function mixinProperties(obj, proto) {
	    for (var prop in proto) {
	        if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
	            // @ts-ignore typescript complains about indexing so we remove
	            obj[prop] = proto[prop];
	        }
	    }
	    return obj;
	}
	//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
	//# sourceMappingURL=enums.js.map

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var flags_1 = __webpack_require__(152);
	var global_1 = __webpack_require__(143);
	var is_1 = __webpack_require__(148);
	var logger_1 = __webpack_require__(155);
	var object_1 = __webpack_require__(156);
	var stacktrace_1 = __webpack_require__(158);
	var supports_1 = __webpack_require__(159);
	var global = global_1.getGlobalObject();
	/**
	 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
	 *  - Console API
	 *  - Fetch API
	 *  - XHR API
	 *  - History API
	 *  - DOM API (click/typing)
	 *  - Error API
	 *  - UnhandledRejection API
	 */
	var handlers = {};
	var instrumented = {};
	/** Instruments given API */
	function instrument(type) {
	    if (instrumented[type]) {
	        return;
	    }
	    instrumented[type] = true;
	    switch (type) {
	        case 'console':
	            instrumentConsole();
	            break;
	        case 'dom':
	            instrumentDOM();
	            break;
	        case 'xhr':
	            instrumentXHR();
	            break;
	        case 'fetch':
	            instrumentFetch();
	            break;
	        case 'history':
	            instrumentHistory();
	            break;
	        case 'error':
	            instrumentError();
	            break;
	        case 'unhandledrejection':
	            instrumentUnhandledRejection();
	            break;
	        default:
	            flags_1.IS_DEBUG_BUILD && logger_1.logger.warn('unknown instrumentation type:', type);
	            return;
	    }
	}
	/**
	 * Add handler that will be called when given type of instrumentation triggers.
	 * Use at your own risk, this might break without changelog notice, only used internally.
	 * @hidden
	 */
	function addInstrumentationHandler(type, callback) {
	    handlers[type] = handlers[type] || [];
	    handlers[type].push(callback);
	    instrument(type);
	}
	exports.addInstrumentationHandler = addInstrumentationHandler;
	/** JSDoc */
	function triggerHandlers(type, data) {
	    var e_1, _a;
	    if (!type || !handlers[type]) {
	        return;
	    }
	    try {
	        for (var _b = tslib_1.__values(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var handler = _c.value;
	            try {
	                handler(data);
	            }
	            catch (e) {
	                flags_1.IS_DEBUG_BUILD &&
	                    logger_1.logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + stacktrace_1.getFunctionName(handler) + "\nError:", e);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	/** JSDoc */
	function instrumentConsole() {
	    if (!('console' in global)) {
	        return;
	    }
	    logger_1.CONSOLE_LEVELS.forEach(function (level) {
	        if (!(level in global.console)) {
	            return;
	        }
	        object_1.fill(global.console, level, function (originalConsoleMethod) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                triggerHandlers('console', { args: args, level: level });
	                // this fails for some browsers. :(
	                if (originalConsoleMethod) {
	                    originalConsoleMethod.apply(global.console, args);
	                }
	            };
	        });
	    });
	}
	/** JSDoc */
	function instrumentFetch() {
	    if (!supports_1.supportsNativeFetch()) {
	        return;
	    }
	    object_1.fill(global, 'fetch', function (originalFetch) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var handlerData = {
	                args: args,
	                fetchData: {
	                    method: getFetchMethod(args),
	                    url: getFetchUrl(args),
	                },
	                startTimestamp: Date.now(),
	            };
	            triggerHandlers('fetch', tslib_1.__assign({}, handlerData));
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return originalFetch.apply(global, args).then(function (response) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), response: response }));
	                return response;
	            }, function (error) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), error: error }));
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
	                //       it means the sentry.javascript SDK caught an error invoking your application code.
	                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
	                throw error;
	            });
	        };
	    });
	}
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/** Extract `method` from fetch call arguments */
	function getFetchMethod(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
	        return String(fetchArgs[0].method).toUpperCase();
	    }
	    if (fetchArgs[1] && fetchArgs[1].method) {
	        return String(fetchArgs[1].method).toUpperCase();
	    }
	    return 'GET';
	}
	/** Extract `url` from fetch call arguments */
	function getFetchUrl(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if (typeof fetchArgs[0] === 'string') {
	        return fetchArgs[0];
	    }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request)) {
	        return fetchArgs[0].url;
	    }
	    return String(fetchArgs[0]);
	}
	/* eslint-enable @typescript-eslint/no-unsafe-member-access */
	/** JSDoc */
	function instrumentXHR() {
	    if (!('XMLHttpRequest' in global)) {
	        return;
	    }
	    var xhrproto = XMLHttpRequest.prototype;
	    object_1.fill(xhrproto, 'open', function (originalOpen) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var url = args[1];
	            var xhrInfo = (xhr.__sentry_xhr__ = {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                method: is_1.isString(args[0]) ? args[0].toUpperCase() : args[0],
	                url: args[1],
	            });
	            // if Sentry key appears in URL, don't capture it as a request
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (is_1.isString(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
	                xhr.__sentry_own_request__ = true;
	            }
	            var onreadystatechangeHandler = function () {
	                if (xhr.readyState === 4) {
	                    try {
	                        // touching statusCode in some platforms throws
	                        // an exception
	                        xhrInfo.status_code = xhr.status;
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    triggerHandlers('xhr', {
	                        args: args,
	                        endTimestamp: Date.now(),
	                        startTimestamp: Date.now(),
	                        xhr: xhr,
	                    });
	                }
	            };
	            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
	                object_1.fill(xhr, 'onreadystatechange', function (original) {
	                    return function () {
	                        var readyStateArgs = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            readyStateArgs[_i] = arguments[_i];
	                        }
	                        onreadystatechangeHandler();
	                        return original.apply(xhr, readyStateArgs);
	                    };
	                });
	            }
	            else {
	                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
	            }
	            return originalOpen.apply(xhr, args);
	        };
	    });
	    object_1.fill(xhrproto, 'send', function (originalSend) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            if (this.__sentry_xhr__ && args[0] !== undefined) {
	                this.__sentry_xhr__.body = args[0];
	            }
	            triggerHandlers('xhr', {
	                args: args,
	                startTimestamp: Date.now(),
	                xhr: this,
	            });
	            return originalSend.apply(this, args);
	        };
	    });
	}
	var lastHref;
	/** JSDoc */
	function instrumentHistory() {
	    if (!supports_1.supportsHistory()) {
	        return;
	    }
	    var oldOnPopState = global.onpopstate;
	    global.onpopstate = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var to = global.location.href;
	        // keep track of the current URL state, as we always receive only the updated state
	        var from = lastHref;
	        lastHref = to;
	        triggerHandlers('history', {
	            from: from,
	            to: to,
	        });
	        if (oldOnPopState) {
	            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
	            // https://github.com/getsentry/sentry-javascript/issues/3344
	            // https://github.com/bugsnag/bugsnag-js/issues/469
	            try {
	                return oldOnPopState.apply(this, args);
	            }
	            catch (_oO) {
	                // no-empty
	            }
	        }
	    };
	    /** @hidden */
	    function historyReplacementFunction(originalHistoryFunction) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var url = args.length > 2 ? args[2] : undefined;
	            if (url) {
	                // coerce to string (this is what pushState does)
	                var from = lastHref;
	                var to = String(url);
	                // keep track of the current URL state, as we always receive only the updated state
	                lastHref = to;
	                triggerHandlers('history', {
	                    from: from,
	                    to: to,
	                });
	            }
	            return originalHistoryFunction.apply(this, args);
	        };
	    }
	    object_1.fill(global.history, 'pushState', historyReplacementFunction);
	    object_1.fill(global.history, 'replaceState', historyReplacementFunction);
	}
	var debounceDuration = 1000;
	var debounceTimerID;
	var lastCapturedEvent;
	/**
	 * Decide whether the current event should finish the debounce of previously captured one.
	 * @param previous previously captured event
	 * @param current event to be captured
	 */
	function shouldShortcircuitPreviousDebounce(previous, current) {
	    // If there was no previous event, it should always be swapped for the new one.
	    if (!previous) {
	        return true;
	    }
	    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
	    if (previous.type !== current.type) {
	        return true;
	    }
	    try {
	        // If both events have the same type, it's still possible that actions were performed on different targets.
	        // e.g. 2 clicks on different buttons.
	        if (previous.target !== current.target) {
	            return true;
	        }
	    }
	    catch (e) {
	        // just accessing `target` property can throw an exception in some rare circumstances
	        // see: https://github.com/getsentry/sentry-javascript/issues/838
	    }
	    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
	    // to which an event listener was attached), we treat them as the same action, as we want to capture
	    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
	    return false;
	}
	/**
	 * Decide whether an event should be captured.
	 * @param event event to be captured
	 */
	function shouldSkipDOMEvent(event) {
	    // We are only interested in filtering `keypress` events for now.
	    if (event.type !== 'keypress') {
	        return false;
	    }
	    try {
	        var target = event.target;
	        if (!target || !target.tagName) {
	            return true;
	        }
	        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
	        // e.g.tabbing through elements, hotkeys, etc.
	        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
	            return false;
	        }
	    }
	    catch (e) {
	        // just accessing `target` property can throw an exception in some rare circumstances
	        // see: https://github.com/getsentry/sentry-javascript/issues/838
	    }
	    return true;
	}
	/**
	 * Wraps addEventListener to capture UI breadcrumbs
	 * @param handler function that will be triggered
	 * @param globalListener indicates whether event was captured by the global event listener
	 * @returns wrapped breadcrumb events handler
	 * @hidden
	 */
	function makeDOMEventHandler(handler, globalListener) {
	    if (globalListener === void 0) { globalListener = false; }
	    return function (event) {
	        // It's possible this handler might trigger multiple times for the same
	        // event (e.g. event propagation through node ancestors).
	        // Ignore if we've already captured that event.
	        if (!event || lastCapturedEvent === event) {
	            return;
	        }
	        // We always want to skip _some_ events.
	        if (shouldSkipDOMEvent(event)) {
	            return;
	        }
	        var name = event.type === 'keypress' ? 'input' : event.type;
	        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
	        if (debounceTimerID === undefined) {
	            handler({
	                event: event,
	                name: name,
	                global: globalListener,
	            });
	            lastCapturedEvent = event;
	        }
	        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
	        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
	        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
	            handler({
	                event: event,
	                name: name,
	                global: globalListener,
	            });
	            lastCapturedEvent = event;
	        }
	        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
	        clearTimeout(debounceTimerID);
	        debounceTimerID = global.setTimeout(function () {
	            debounceTimerID = undefined;
	        }, debounceDuration);
	    };
	}
	/** JSDoc */
	function instrumentDOM() {
	    if (!('document' in global)) {
	        return;
	    }
	    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
	    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
	    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
	    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
	    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
	    global.document.addEventListener('click', globalDOMEventHandler, false);
	    global.document.addEventListener('keypress', globalDOMEventHandler, false);
	    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
	    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
	    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
	    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
	    // guaranteed to fire at least once.)
	    ['EventTarget', 'Node'].forEach(function (target) {
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        object_1.fill(proto, 'addEventListener', function (originalAddEventListener) {
	            return function (type, listener, options) {
	                if (type === 'click' || type == 'keypress') {
	                    try {
	                        var el = this;
	                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
	                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
	                        if (!handlerForType.handler) {
	                            var handler = makeDOMEventHandler(triggerDOMHandler);
	                            handlerForType.handler = handler;
	                            originalAddEventListener.call(this, type, handler, options);
	                        }
	                        handlerForType.refCount += 1;
	                    }
	                    catch (e) {
	                        // Accessing dom properties is always fragile.
	                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
	                    }
	                }
	                return originalAddEventListener.call(this, type, listener, options);
	            };
	        });
	        object_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
	            return function (type, listener, options) {
	                if (type === 'click' || type == 'keypress') {
	                    try {
	                        var el = this;
	                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
	                        var handlerForType = handlers_2[type];
	                        if (handlerForType) {
	                            handlerForType.refCount -= 1;
	                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
	                            if (handlerForType.refCount <= 0) {
	                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
	                                handlerForType.handler = undefined;
	                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
	                            }
	                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
	                            if (Object.keys(handlers_2).length === 0) {
	                                delete el.__sentry_instrumentation_handlers__;
	                            }
	                        }
	                    }
	                    catch (e) {
	                        // Accessing dom properties is always fragile.
	                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
	                    }
	                }
	                return originalRemoveEventListener.call(this, type, listener, options);
	            };
	        });
	    });
	}
	var _oldOnErrorHandler = null;
	/** JSDoc */
	function instrumentError() {
	    _oldOnErrorHandler = global.onerror;
	    global.onerror = function (msg, url, line, column, error) {
	        triggerHandlers('error', {
	            column: column,
	            error: error,
	            line: line,
	            msg: msg,
	            url: url,
	        });
	        if (_oldOnErrorHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnErrorHandler.apply(this, arguments);
	        }
	        return false;
	    };
	}
	var _oldOnUnhandledRejectionHandler = null;
	/** JSDoc */
	function instrumentUnhandledRejection() {
	    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
	    global.onunhandledrejection = function (e) {
	        triggerHandlers('unhandledrejection', e);
	        if (_oldOnUnhandledRejectionHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
	        }
	        return true;
	    };
	}
	//# sourceMappingURL=instrument.js.map

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var flags_1 = __webpack_require__(152);
	var global_1 = __webpack_require__(143);
	// TODO: Implement different loggers for different environments
	var global = global_1.getGlobalObject();
	/** Prefix for logging strings */
	var PREFIX = 'Sentry Logger ';
	exports.CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
	/**
	 * Temporarily disable sentry console instrumentations.
	 *
	 * @param callback The function to run against the original `console` messages
	 * @returns The results of the callback
	 */
	function consoleSandbox(callback) {
	    var global = global_1.getGlobalObject();
	    if (!('console' in global)) {
	        return callback();
	    }
	    var originalConsole = global.console;
	    var wrappedLevels = {};
	    // Restore all wrapped console methods
	    exports.CONSOLE_LEVELS.forEach(function (level) {
	        // TODO(v7): Remove this check as it's only needed for Node 6
	        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
	        if (level in global.console && originalWrappedFunc) {
	            wrappedLevels[level] = originalConsole[level];
	            originalConsole[level] = originalWrappedFunc;
	        }
	    });
	    try {
	        return callback();
	    }
	    finally {
	        // Revert restoration to wrapped state
	        Object.keys(wrappedLevels).forEach(function (level) {
	            originalConsole[level] = wrappedLevels[level];
	        });
	    }
	}
	exports.consoleSandbox = consoleSandbox;
	function makeLogger() {
	    var enabled = false;
	    var logger = {
	        enable: function () {
	            enabled = true;
	        },
	        disable: function () {
	            enabled = false;
	        },
	    };
	    if (flags_1.IS_DEBUG_BUILD) {
	        exports.CONSOLE_LEVELS.forEach(function (name) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            logger[name] = function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                if (enabled) {
	                    consoleSandbox(function () {
	                        var _a;
	                        (_a = global.console)[name].apply(_a, tslib_1.__spread([PREFIX + "[" + name + "]:"], args));
	                    });
	                }
	            };
	        });
	    }
	    else {
	        exports.CONSOLE_LEVELS.forEach(function (name) {
	            logger[name] = function () { return undefined; };
	        });
	    }
	    return logger;
	}
	// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
	var logger;
	exports.logger = logger;
	if (flags_1.IS_DEBUG_BUILD) {
	    exports.logger = logger = global_1.getGlobalSingleton('logger', makeLogger);
	}
	else {
	    exports.logger = logger = makeLogger();
	}
	//# sourceMappingURL=logger.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var browser_1 = __webpack_require__(142);
	var is_1 = __webpack_require__(148);
	var string_1 = __webpack_require__(157);
	/**
	 * Replace a method in an object with a wrapped version of itself.
	 *
	 * @param source An object that contains a method to be wrapped.
	 * @param name The name of the method to be wrapped.
	 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
	 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
	 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
	 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
	 * @returns void
	 */
	function fill(source, name, replacementFactory) {
	    if (!(name in source)) {
	        return;
	    }
	    var original = source[name];
	    var wrapped = replacementFactory(original);
	    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
	    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
	    if (typeof wrapped === 'function') {
	        try {
	            markFunctionWrapped(wrapped, original);
	        }
	        catch (_Oo) {
	            // This can throw if multiple fill happens on a global object like XMLHttpRequest
	            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
	        }
	    }
	    source[name] = wrapped;
	}
	exports.fill = fill;
	/**
	 * Defines a non-enumerable property on the given object.
	 *
	 * @param obj The object on which to set the property
	 * @param name The name of the property to be set
	 * @param value The value to which to set the property
	 */
	function addNonEnumerableProperty(obj, name, value) {
	    Object.defineProperty(obj, name, {
	        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
	        value: value,
	        writable: true,
	        configurable: true,
	    });
	}
	exports.addNonEnumerableProperty = addNonEnumerableProperty;
	/**
	 * Remembers the original function on the wrapped function and
	 * patches up the prototype.
	 *
	 * @param wrapped the wrapper function
	 * @param original the original function that gets wrapped
	 */
	function markFunctionWrapped(wrapped, original) {
	    var proto = original.prototype || {};
	    wrapped.prototype = original.prototype = proto;
	    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
	}
	exports.markFunctionWrapped = markFunctionWrapped;
	/**
	 * This extracts the original function if available.  See
	 * `markFunctionWrapped` for more information.
	 *
	 * @param func the function to unwrap
	 * @returns the unwrapped version of the function if available.
	 */
	function getOriginalFunction(func) {
	    return func.__sentry_original__;
	}
	exports.getOriginalFunction = getOriginalFunction;
	/**
	 * Encodes given object into url-friendly format
	 *
	 * @param object An object that contains serializable values
	 * @returns string Encoded
	 */
	function urlEncode(object) {
	    return Object.keys(object)
	        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
	        .join('&');
	}
	exports.urlEncode = urlEncode;
	/**
	 * Transforms any object into an object literal with all its attributes
	 * attached to it.
	 *
	 * @param value Initial source that we have to transform in order for it to be usable by the serializer
	 */
	function convertToPlainObject(value) {
	    var newObj = value;
	    if (is_1.isError(value)) {
	        newObj = tslib_1.__assign({ message: value.message, name: value.name, stack: value.stack }, getOwnProperties(value));
	    }
	    else if (is_1.isEvent(value)) {
	        var event_1 = value;
	        newObj = tslib_1.__assign({ type: event_1.type, target: serializeEventTarget(event_1.target), currentTarget: serializeEventTarget(event_1.currentTarget) }, getOwnProperties(event_1));
	        if (typeof CustomEvent !== 'undefined' && is_1.isInstanceOf(value, CustomEvent)) {
	            newObj.detail = event_1.detail;
	        }
	    }
	    return newObj;
	}
	exports.convertToPlainObject = convertToPlainObject;
	/** Creates a string representation of the target of an `Event` object */
	function serializeEventTarget(target) {
	    try {
	        return is_1.isElement(target) ? browser_1.htmlTreeAsString(target) : Object.prototype.toString.call(target);
	    }
	    catch (_oO) {
	        return '<unknown>';
	    }
	}
	/** Filters out all but an object's own properties */
	function getOwnProperties(obj) {
	    var extractedProps = {};
	    for (var property in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, property)) {
	            extractedProps[property] = obj[property];
	        }
	    }
	    return extractedProps;
	}
	/**
	 * Given any captured exception, extract its keys and create a sorted
	 * and truncated list that will be used inside the event message.
	 * eg. `Non-error exception captured with keys: foo, bar, baz`
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function extractExceptionKeysForMessage(exception, maxLength) {
	    if (maxLength === void 0) { maxLength = 40; }
	    var keys = Object.keys(convertToPlainObject(exception));
	    keys.sort();
	    if (!keys.length) {
	        return '[object has no keys]';
	    }
	    if (keys[0].length >= maxLength) {
	        return string_1.truncate(keys[0], maxLength);
	    }
	    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
	        var serialized = keys.slice(0, includedKeys).join(', ');
	        if (serialized.length > maxLength) {
	            continue;
	        }
	        if (includedKeys === keys.length) {
	            return serialized;
	        }
	        return string_1.truncate(serialized, maxLength);
	    }
	    return '';
	}
	exports.extractExceptionKeysForMessage = extractExceptionKeysForMessage;
	/**
	 * Given any object, return the new object with removed keys that value was `undefined`.
	 * Works recursively on objects and arrays.
	 */
	function dropUndefinedKeys(val) {
	    var e_1, _a;
	    if (is_1.isPlainObject(val)) {
	        var rv = {};
	        try {
	            for (var _b = tslib_1.__values(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var key = _c.value;
	                if (typeof val[key] !== 'undefined') {
	                    rv[key] = dropUndefinedKeys(val[key]);
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return rv;
	    }
	    if (Array.isArray(val)) {
	        return val.map(dropUndefinedKeys);
	    }
	    return val;
	}
	exports.dropUndefinedKeys = dropUndefinedKeys;
	/**
	 * Ensure that something is an object.
	 *
	 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
	 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
	 *
	 * @param wat The subject of the objectification
	 * @returns A version of `wat` which can safely be used with `Object` class methods
	 */
	function objectify(wat) {
	    var objectified;
	    switch (true) {
	        case wat === undefined || wat === null:
	            objectified = new String(wat);
	            break;
	        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
	        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
	        // an object in order to wrap it.
	        case typeof wat === 'symbol' || typeof wat === 'bigint':
	            objectified = Object(wat);
	            break;
	        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
	        case is_1.isPrimitive(wat):
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            objectified = new wat.constructor(wat);
	            break;
	        // by process of elimination, at this point we know that `wat` must already be an object
	        default:
	            objectified = wat;
	            break;
	    }
	    return objectified;
	}
	exports.objectify = objectify;
	//# sourceMappingURL=object.js.map

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(148);
	/**
	 * Truncates given string to the maximum characters count
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string (0 = unlimited)
	 * @returns string Encoded
	 */
	function truncate(str, max) {
	    if (max === void 0) { max = 0; }
	    if (typeof str !== 'string' || max === 0) {
	        return str;
	    }
	    return str.length <= max ? str : str.substr(0, max) + "...";
	}
	exports.truncate = truncate;
	/**
	 * This is basically just `trim_line` from
	 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string
	 * @returns string Encoded
	 */
	function snipLine(line, colno) {
	    var newLine = line;
	    var lineLength = newLine.length;
	    if (lineLength <= 150) {
	        return newLine;
	    }
	    if (colno > lineLength) {
	        // eslint-disable-next-line no-param-reassign
	        colno = lineLength;
	    }
	    var start = Math.max(colno - 60, 0);
	    if (start < 5) {
	        start = 0;
	    }
	    var end = Math.min(start + 140, lineLength);
	    if (end > lineLength - 5) {
	        end = lineLength;
	    }
	    if (end === lineLength) {
	        start = Math.max(end - 140, 0);
	    }
	    newLine = newLine.slice(start, end);
	    if (start > 0) {
	        newLine = "'{snip} " + newLine;
	    }
	    if (end < lineLength) {
	        newLine += ' {snip}';
	    }
	    return newLine;
	}
	exports.snipLine = snipLine;
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns Joined values
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function safeJoin(input, delimiter) {
	    if (!Array.isArray(input)) {
	        return '';
	    }
	    var output = [];
	    // eslint-disable-next-line @typescript-eslint/prefer-for-of
	    for (var i = 0; i < input.length; i++) {
	        var value = input[i];
	        try {
	            output.push(String(value));
	        }
	        catch (e) {
	            output.push('[value cannot be serialized]');
	        }
	    }
	    return output.join(delimiter);
	}
	exports.safeJoin = safeJoin;
	/**
	 * Checks if the value matches a regex or includes the string
	 * @param value The string value to be checked against
	 * @param pattern Either a regex or a string that must be contained in value
	 */
	function isMatchingPattern(value, pattern) {
	    if (!is_1.isString(value)) {
	        return false;
	    }
	    if (is_1.isRegExp(pattern)) {
	        return pattern.test(value);
	    }
	    if (typeof pattern === 'string') {
	        return value.indexOf(pattern) !== -1;
	    }
	    return false;
	}
	exports.isMatchingPattern = isMatchingPattern;
	/**
	 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
	 * `new RegExp()`.
	 *
	 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
	 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
	 * 12+).
	 *
	 * @param regexString The string to escape
	 * @returns An version of the string with all special regex characters escaped
	 */
	function escapeStringForRegex(regexString) {
	    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
	    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
	    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
	}
	exports.escapeStringForRegex = escapeStringForRegex;
	//# sourceMappingURL=string.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var STACKTRACE_LIMIT = 50;
	/**
	 * Creates a stack parser with the supplied line parsers
	 *
	 * StackFrames are returned in the correct order for Sentry Exception
	 * frames and with Sentry SDK internal frames removed from the top and bottom
	 *
	 */
	function createStackParser() {
	    var parsers = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        parsers[_i] = arguments[_i];
	    }
	    var sortedParsers = parsers.sort(function (a, b) { return a[0] - b[0]; }).map(function (p) { return p[1]; });
	    return function (stack, skipFirst) {
	        var e_1, _a, e_2, _b;
	        if (skipFirst === void 0) { skipFirst = 0; }
	        var frames = [];
	        try {
	            for (var _c = tslib_1.__values(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var line = _d.value;
	                try {
	                    for (var sortedParsers_1 = (e_2 = void 0, tslib_1.__values(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()) {
	                        var parser = sortedParsers_1_1.value;
	                        var frame = parser(line);
	                        if (frame) {
	                            frames.push(frame);
	                            break;
	                        }
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return stripSentryFramesAndReverse(frames);
	    };
	}
	exports.createStackParser = createStackParser;
	/**
	 * @hidden
	 */
	function stripSentryFramesAndReverse(stack) {
	    if (!stack.length) {
	        return [];
	    }
	    var localStack = stack;
	    var firstFrameFunction = localStack[0].function || '';
	    var lastFrameFunction = localStack[localStack.length - 1].function || '';
	    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
	    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
	        localStack = localStack.slice(1);
	    }
	    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
	    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
	        localStack = localStack.slice(0, -1);
	    }
	    // The frame where the crash happened, should be the last entry in the array
	    return localStack
	        .slice(0, STACKTRACE_LIMIT)
	        .map(function (frame) { return (tslib_1.__assign(tslib_1.__assign({}, frame), { filename: frame.filename || localStack[0].filename, function: frame.function || '?' })); })
	        .reverse();
	}
	exports.stripSentryFramesAndReverse = stripSentryFramesAndReverse;
	var defaultFunctionName = '<anonymous>';
	/**
	 * Safely extract function name from itself
	 */
	function getFunctionName(fn) {
	    try {
	        if (!fn || typeof fn !== 'function') {
	            return defaultFunctionName;
	        }
	        return fn.name || defaultFunctionName;
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        return defaultFunctionName;
	    }
	}
	exports.getFunctionName = getFunctionName;
	//# sourceMappingURL=stacktrace.js.map

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var flags_1 = __webpack_require__(152);
	var global_1 = __webpack_require__(143);
	var logger_1 = __webpack_require__(155);
	/**
	 * Tells whether current environment supports ErrorEvent objects
	 * {@link supportsErrorEvent}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsErrorEvent() {
	    try {
	        new ErrorEvent('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsErrorEvent = supportsErrorEvent;
	/**
	 * Tells whether current environment supports DOMError objects
	 * {@link supportsDOMError}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMError() {
	    try {
	        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
	        // 1 argument required, but only 0 present.
	        // @ts-ignore It really needs 1 argument, not 0.
	        new DOMError('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMError = supportsDOMError;
	/**
	 * Tells whether current environment supports DOMException objects
	 * {@link supportsDOMException}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMException() {
	    try {
	        new DOMException('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMException = supportsDOMException;
	/**
	 * Tells whether current environment supports Fetch API
	 * {@link supportsFetch}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsFetch() {
	    if (!('fetch' in global_1.getGlobalObject())) {
	        return false;
	    }
	    try {
	        new Headers();
	        new Request('');
	        new Response();
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsFetch = supportsFetch;
	/**
	 * isNativeFetch checks if the given function is a native implementation of fetch()
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function isNativeFetch(func) {
	    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
	}
	exports.isNativeFetch = isNativeFetch;
	/**
	 * Tells whether current environment supports Fetch API natively
	 * {@link supportsNativeFetch}.
	 *
	 * @returns true if `window.fetch` is natively implemented, false otherwise
	 */
	function supportsNativeFetch() {
	    if (!supportsFetch()) {
	        return false;
	    }
	    var global = global_1.getGlobalObject();
	    // Fast path to avoid DOM I/O
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    if (isNativeFetch(global.fetch)) {
	        return true;
	    }
	    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
	    // so create a "pure" iframe to see if that has native fetch
	    var result = false;
	    var doc = global.document;
	    // eslint-disable-next-line deprecation/deprecation
	    if (doc && typeof doc.createElement === 'function') {
	        try {
	            var sandbox = doc.createElement('iframe');
	            sandbox.hidden = true;
	            doc.head.appendChild(sandbox);
	            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
	                // eslint-disable-next-line @typescript-eslint/unbound-method
	                result = isNativeFetch(sandbox.contentWindow.fetch);
	            }
	            doc.head.removeChild(sandbox);
	        }
	        catch (err) {
	            flags_1.IS_DEBUG_BUILD &&
	                logger_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
	        }
	    }
	    return result;
	}
	exports.supportsNativeFetch = supportsNativeFetch;
	/**
	 * Tells whether current environment supports ReportingObserver API
	 * {@link supportsReportingObserver}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReportingObserver() {
	    return 'ReportingObserver' in global_1.getGlobalObject();
	}
	exports.supportsReportingObserver = supportsReportingObserver;
	/**
	 * Tells whether current environment supports Referrer Policy API
	 * {@link supportsReferrerPolicy}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReferrerPolicy() {
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
	    // (see https://caniuse.com/#feat=referrer-policy),
	    // it doesn't. And it throws an exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    if (!supportsFetch()) {
	        return false;
	    }
	    try {
	        new Request('_', {
	            referrerPolicy: 'origin',
	        });
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsReferrerPolicy = supportsReferrerPolicy;
	/**
	 * Tells whether current environment supports History API
	 * {@link supportsHistory}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsHistory() {
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var global = global_1.getGlobalObject();
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var chrome = global.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
	    return !isChromePackagedApp && hasHistoryApi;
	}
	exports.supportsHistory = supportsHistory;
	//# sourceMappingURL=supports.js.map

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Helper to decycle json objects
	 */
	function memoBuilder() {
	    var hasWeakSet = typeof WeakSet === 'function';
	    var inner = hasWeakSet ? new WeakSet() : [];
	    function memoize(obj) {
	        if (hasWeakSet) {
	            if (inner.has(obj)) {
	                return true;
	            }
	            inner.add(obj);
	            return false;
	        }
	        // eslint-disable-next-line @typescript-eslint/prefer-for-of
	        for (var i = 0; i < inner.length; i++) {
	            var value = inner[i];
	            if (value === obj) {
	                return true;
	            }
	        }
	        inner.push(obj);
	        return false;
	    }
	    function unmemoize(obj) {
	        if (hasWeakSet) {
	            inner.delete(obj);
	        }
	        else {
	            for (var i = 0; i < inner.length; i++) {
	                if (inner[i] === obj) {
	                    inner.splice(i, 1);
	                    break;
	                }
	            }
	        }
	    }
	    return [memoize, unmemoize];
	}
	exports.memoBuilder = memoBuilder;
	//# sourceMappingURL=memo.js.map

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var global_1 = __webpack_require__(143);
	var object_1 = __webpack_require__(156);
	var string_1 = __webpack_require__(157);
	/**
	 * UUID4 generator
	 *
	 * @returns string Generated UUID4.
	 */
	function uuid4() {
	    var global = global_1.getGlobalObject();
	    var crypto = global.crypto || global.msCrypto;
	    if (!(crypto === void 0) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	        // set 4 in byte 7
	        // eslint-disable-next-line no-bitwise
	        arr[3] = (arr[3] & 0xfff) | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        // eslint-disable-next-line no-bitwise
	        arr[4] = (arr[4] & 0x3fff) | 0x8000;
	        var pad = function (num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = "0" + v;
	            }
	            return v;
	        };
	        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
	    }
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        // eslint-disable-next-line no-bitwise
	        var r = (Math.random() * 16) | 0;
	        // eslint-disable-next-line no-bitwise
	        var v = c === 'x' ? r : (r & 0x3) | 0x8;
	        return v.toString(16);
	    });
	}
	exports.uuid4 = uuid4;
	/**
	 * Parses string form of URL into an object
	 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	 * // intentionally using regex and not <a/> href parsing trick because React Native and other
	 * // environments where DOM might not be available
	 * @returns parsed URL object
	 */
	function parseUrl(url) {
	    if (!url) {
	        return {};
	    }
	    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	    if (!match) {
	        return {};
	    }
	    // coerce to undefined values to empty string so we don't get 'undefined'
	    var query = match[6] || '';
	    var fragment = match[8] || '';
	    return {
	        host: match[4],
	        path: match[5],
	        protocol: match[2],
	        relative: match[5] + query + fragment,
	    };
	}
	exports.parseUrl = parseUrl;
	function getFirstException(event) {
	    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
	}
	/**
	 * Extracts either message or type+value from an event that can be used for user-facing logs
	 * @returns event's description
	 */
	function getEventDescription(event) {
	    var message = event.message, eventId = event.event_id;
	    if (message) {
	        return message;
	    }
	    var firstException = getFirstException(event);
	    if (firstException) {
	        if (firstException.type && firstException.value) {
	            return firstException.type + ": " + firstException.value;
	        }
	        return firstException.type || firstException.value || eventId || '<unknown>';
	    }
	    return eventId || '<unknown>';
	}
	exports.getEventDescription = getEventDescription;
	/**
	 * Adds exception values, type and value to an synthetic Exception.
	 * @param event The event to modify.
	 * @param value Value of the exception.
	 * @param type Type of the exception.
	 * @hidden
	 */
	function addExceptionTypeValue(event, value, type) {
	    var exception = (event.exception = event.exception || {});
	    var values = (exception.values = exception.values || []);
	    var firstException = (values[0] = values[0] || {});
	    if (!firstException.value) {
	        firstException.value = value || '';
	    }
	    if (!firstException.type) {
	        firstException.type = type || 'Error';
	    }
	}
	exports.addExceptionTypeValue = addExceptionTypeValue;
	/**
	 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
	 *
	 * @param event The event to modify.
	 * @param newMechanism Mechanism data to add to the event.
	 * @hidden
	 */
	function addExceptionMechanism(event, newMechanism) {
	    var firstException = getFirstException(event);
	    if (!firstException) {
	        return;
	    }
	    var defaultMechanism = { type: 'generic', handled: true };
	    var currentMechanism = firstException.mechanism;
	    firstException.mechanism = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, defaultMechanism), currentMechanism), newMechanism);
	    if (newMechanism && 'data' in newMechanism) {
	        var mergedData = tslib_1.__assign(tslib_1.__assign({}, (currentMechanism && currentMechanism.data)), newMechanism.data);
	        firstException.mechanism.data = mergedData;
	    }
	}
	exports.addExceptionMechanism = addExceptionMechanism;
	// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
	var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
	/**
	 * Parses input into a SemVer interface
	 * @param input string representation of a semver version
	 */
	function parseSemver(input) {
	    var match = input.match(SEMVER_REGEXP) || [];
	    var major = parseInt(match[1], 10);
	    var minor = parseInt(match[2], 10);
	    var patch = parseInt(match[3], 10);
	    return {
	        buildmetadata: match[5],
	        major: isNaN(major) ? undefined : major,
	        minor: isNaN(minor) ? undefined : minor,
	        patch: isNaN(patch) ? undefined : patch,
	        prerelease: match[4],
	    };
	}
	exports.parseSemver = parseSemver;
	/**
	 * This function adds context (pre/post/line) lines to the provided frame
	 *
	 * @param lines string[] containing all lines
	 * @param frame StackFrame that will be mutated
	 * @param linesOfContext number of context lines we want to add pre/post
	 */
	function addContextToFrame(lines, frame, linesOfContext) {
	    if (linesOfContext === void 0) { linesOfContext = 5; }
	    var lineno = frame.lineno || 0;
	    var maxLines = lines.length;
	    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
	    frame.pre_context = lines
	        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	    frame.context_line = string_1.snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
	    frame.post_context = lines
	        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	}
	exports.addContextToFrame = addContextToFrame;
	/**
	 * Strip the query string and fragment off of a given URL or path (if present)
	 *
	 * @param urlPath Full URL or path, including possible query string and/or fragment
	 * @returns URL or path without query string or fragment
	 */
	function stripUrlQueryAndFragment(urlPath) {
	    // eslint-disable-next-line no-useless-escape
	    return urlPath.split(/[\?#]/, 1)[0];
	}
	exports.stripUrlQueryAndFragment = stripUrlQueryAndFragment;
	/**
	 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
	 * in question), and marks it captured if not.
	 *
	 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
	 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
	 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
	 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
	 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
	 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
	 * see it.
	 *
	 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
	 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
	 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
	 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
	 * must be done before the exception captured.
	 *
	 * @param A thrown exception to check or flag as having been seen
	 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
	 */
	function checkOrSetAlreadyCaught(exception) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    if (exception && exception.__sentry_captured__) {
	        return true;
	    }
	    try {
	        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
	        // `ExtraErrorData` integration
	        object_1.addNonEnumerableProperty(exception, '__sentry_captured__', true);
	    }
	    catch (err) {
	        // `exception` is a primitive, so we can't mark it seen
	    }
	    return false;
	}
	exports.checkOrSetAlreadyCaught = checkOrSetAlreadyCaught;
	//# sourceMappingURL=misc.js.map

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var is_1 = __webpack_require__(148);
	var memo_1 = __webpack_require__(160);
	var object_1 = __webpack_require__(156);
	var stacktrace_1 = __webpack_require__(158);
	/**
	 * Recursively normalizes the given object.
	 *
	 * - Creates a copy to prevent original input mutation
	 * - Skips non-enumerable properties
	 * - When stringifying, calls `toJSON` if implemented
	 * - Removes circular references
	 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
	 * - Translates known global objects/classes to a string representations
	 * - Takes care of `Error` object serialization
	 * - Optionally limits depth of final output
	 * - Optionally limits number of properties/elements included in any single object/array
	 *
	 * @param input The object to be normalized.
	 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
	 * @param maxProperties The max number of elements or properties to be included in any single array or
	 * object in the normallized output..
	 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
	 */
	function normalize(input, depth, maxProperties) {
	    if (depth === void 0) { depth = +Infinity; }
	    if (maxProperties === void 0) { maxProperties = +Infinity; }
	    try {
	        // since we're at the outermost level, there is no key
	        return visit('', input, depth, maxProperties);
	    }
	    catch (err) {
	        return { ERROR: "**non-serializable** (" + err + ")" };
	    }
	}
	exports.normalize = normalize;
	/** JSDoc */
	function normalizeToSize(object, 
	// Default Node.js REPL depth
	depth, 
	// 100kB, as 200kB is max payload size, so half sounds reasonable
	maxSize) {
	    if (depth === void 0) { depth = 3; }
	    if (maxSize === void 0) { maxSize = 100 * 1024; }
	    var normalized = normalize(object, depth);
	    if (jsonSize(normalized) > maxSize) {
	        return normalizeToSize(object, depth - 1, maxSize);
	    }
	    return normalized;
	}
	exports.normalizeToSize = normalizeToSize;
	/**
	 * Visits a node to perform normalization on it
	 *
	 * @param key The key corresponding to the given node
	 * @param value The node to be visited
	 * @param depth Optional number indicating the maximum recursion depth
	 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
	 * @param memo Optional Memo class handling decycling
	 */
	function visit(key, value, depth, maxProperties, memo) {
	    if (depth === void 0) { depth = +Infinity; }
	    if (maxProperties === void 0) { maxProperties = +Infinity; }
	    if (memo === void 0) { memo = memo_1.memoBuilder(); }
	    var _a = tslib_1.__read(memo, 2), memoize = _a[0], unmemoize = _a[1];
	    // If the value has a `toJSON` method, see if we can bail and let it do the work
	    var valueWithToJSON = value;
	    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
	        try {
	            return valueWithToJSON.toJSON();
	        }
	        catch (err) {
	            // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
	        }
	    }
	    // Get the simple cases out of the way first
	    if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !is_1.isNaN(value))) {
	        return value;
	    }
	    var stringified = stringifyValue(key, value);
	    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
	    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
	    if (!stringified.startsWith('[object ')) {
	        return stringified;
	    }
	    // We're also done if we've reached the max depth
	    if (depth === 0) {
	        // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
	        return stringified.replace('object ', '');
	    }
	    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
	    if (memoize(value)) {
	        return '[Circular ~]';
	    }
	    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
	    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
	    // property/entry, and keep track of the number of items we add to it.
	    var normalized = (Array.isArray(value) ? [] : {});
	    var numAdded = 0;
	    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
	    // properties are non-enumerable and otherwise would get missed.
	    var visitable = (is_1.isError(value) || is_1.isEvent(value) ? object_1.convertToPlainObject(value) : value);
	    for (var visitKey in visitable) {
	        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
	        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
	            continue;
	        }
	        if (numAdded >= maxProperties) {
	            normalized[visitKey] = '[MaxProperties ~]';
	            break;
	        }
	        // Recursively visit all the child nodes
	        var visitValue = visitable[visitKey];
	        normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);
	        numAdded += 1;
	    }
	    // Once we've visited all the branches, remove the parent from memo storage
	    unmemoize(value);
	    // Return accumulated values
	    return normalized;
	}
	exports.walk = visit;
	/**
	 * Stringify the given value. Handles various known special values and types.
	 *
	 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
	 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
	 *
	 * @param value The value to stringify
	 * @returns A stringified representation of the given value
	 */
	function stringifyValue(key, 
	// this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
	// our internal use, it'll do
	value) {
	    try {
	        if (key === 'domain' && value && typeof value === 'object' && value._events) {
	            return '[Domain]';
	        }
	        if (key === 'domainEmitter') {
	            return '[DomainEmitter]';
	        }
	        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
	        // which won't throw if they are not present.
	        if (typeof global !== 'undefined' && value === global) {
	            return '[Global]';
	        }
	        // eslint-disable-next-line no-restricted-globals
	        if (typeof window !== 'undefined' && value === window) {
	            return '[Window]';
	        }
	        // eslint-disable-next-line no-restricted-globals
	        if (typeof document !== 'undefined' && value === document) {
	            return '[Document]';
	        }
	        // React's SyntheticEvent thingy
	        if (is_1.isSyntheticEvent(value)) {
	            return '[SyntheticEvent]';
	        }
	        if (typeof value === 'number' && value !== value) {
	            return '[NaN]';
	        }
	        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
	        if (value === void 0) {
	            return '[undefined]';
	        }
	        if (typeof value === 'function') {
	            return "[Function: " + stacktrace_1.getFunctionName(value) + "]";
	        }
	        if (typeof value === 'symbol') {
	            return "[" + String(value) + "]";
	        }
	        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
	        if (typeof value === 'bigint') {
	            return "[BigInt: " + String(value) + "]";
	        }
	        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
	        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
	        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
	        // we can make sure that only plain objects come out that way.
	        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
	    }
	    catch (err) {
	        return "**non-serializable** (" + err + ")";
	    }
	}
	/** Calculates bytes size of input string */
	function utf8Length(value) {
	    // eslint-disable-next-line no-bitwise
	    return ~-encodeURI(value).split(/%..|./).length;
	}
	/** Calculates bytes size of input object */
	function jsonSize(value) {
	    return utf8Length(JSON.stringify(value));
	}
	//# sourceMappingURL=normalize.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
	// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	function normalizeArray(parts, allowAboveRoot) {
	    // if the path tries to go above the root, `up` ends up > 0
	    var up = 0;
	    for (var i = parts.length - 1; i >= 0; i--) {
	        var last = parts[i];
	        if (last === '.') {
	            parts.splice(i, 1);
	        }
	        else if (last === '..') {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up++;
	        }
	        else if (up) {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up--;
	        }
	    }
	    // if the path is allowed to go above the root, restore leading ..s
	    if (allowAboveRoot) {
	        // eslint-disable-next-line no-plusplus
	        for (; up--; up) {
	            parts.unshift('..');
	        }
	    }
	    return parts;
	}
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
	/** JSDoc */
	function splitPath(filename) {
	    var parts = splitPathRe.exec(filename);
	    return parts ? parts.slice(1) : [];
	}
	// path.resolve([from ...], to)
	// posix version
	/** JSDoc */
	function resolve() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resolvedPath = '';
	    var resolvedAbsolute = false;
	    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	        var path = i >= 0 ? args[i] : '/';
	        // Skip empty entries
	        if (!path) {
	            continue;
	        }
	        resolvedPath = path + "/" + resolvedPath;
	        resolvedAbsolute = path.charAt(0) === '/';
	    }
	    // At this point the path should be resolved to a full absolute path, but
	    // handle relative paths to be safe (might happen when process.cwd() fails)
	    // Normalize the path
	    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
	    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
	}
	exports.resolve = resolve;
	/** JSDoc */
	function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	        if (arr[start] !== '') {
	            break;
	        }
	    }
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	        if (arr[end] !== '') {
	            break;
	        }
	    }
	    if (start > end) {
	        return [];
	    }
	    return arr.slice(start, end - start + 1);
	}
	// path.relative(from, to)
	// posix version
	/** JSDoc */
	function relative(from, to) {
	    /* eslint-disable no-param-reassign */
	    from = resolve(from).substr(1);
	    to = resolve(to).substr(1);
	    /* eslint-enable no-param-reassign */
	    var fromParts = trim(from.split('/'));
	    var toParts = trim(to.split('/'));
	    var length = Math.min(fromParts.length, toParts.length);
	    var samePartsLength = length;
	    for (var i = 0; i < length; i++) {
	        if (fromParts[i] !== toParts[i]) {
	            samePartsLength = i;
	            break;
	        }
	    }
	    var outputParts = [];
	    for (var i = samePartsLength; i < fromParts.length; i++) {
	        outputParts.push('..');
	    }
	    outputParts = outputParts.concat(toParts.slice(samePartsLength));
	    return outputParts.join('/');
	}
	exports.relative = relative;
	// path.normalize(path)
	// posix version
	/** JSDoc */
	function normalizePath(path) {
	    var isPathAbsolute = isAbsolute(path);
	    var trailingSlash = path.substr(-1) === '/';
	    // Normalize the path
	    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
	    if (!normalizedPath && !isPathAbsolute) {
	        normalizedPath = '.';
	    }
	    if (normalizedPath && trailingSlash) {
	        normalizedPath += '/';
	    }
	    return (isPathAbsolute ? '/' : '') + normalizedPath;
	}
	exports.normalizePath = normalizePath;
	// posix version
	/** JSDoc */
	function isAbsolute(path) {
	    return path.charAt(0) === '/';
	}
	exports.isAbsolute = isAbsolute;
	// posix version
	/** JSDoc */
	function join() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return normalizePath(args.join('/'));
	}
	exports.join = join;
	/** JSDoc */
	function dirname(path) {
	    var result = splitPath(path);
	    var root = result[0];
	    var dir = result[1];
	    if (!root && !dir) {
	        // No dirname whatsoever
	        return '.';
	    }
	    if (dir) {
	        // It has a dirname, strip trailing slash
	        dir = dir.substr(0, dir.length - 1);
	    }
	    return root + dir;
	}
	exports.dirname = dirname;
	/** JSDoc */
	function basename(path, ext) {
	    var f = splitPath(path)[2];
	    if (ext && f.substr(ext.length * -1) === ext) {
	        f = f.substr(0, f.length - ext.length);
	    }
	    return f;
	}
	exports.basename = basename;
	//# sourceMappingURL=path.js.map

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(150);
	var syncpromise_1 = __webpack_require__(165);
	/**
	 * Creates an new PromiseBuffer object with the specified limit
	 * @param limit max number of promises that can be stored in the buffer
	 */
	function makePromiseBuffer(limit) {
	    var buffer = [];
	    function isReady() {
	        return limit === undefined || buffer.length < limit;
	    }
	    /**
	     * Remove a promise from the queue.
	     *
	     * @param task Can be any PromiseLike<T>
	     * @returns Removed promise.
	     */
	    function remove(task) {
	        return buffer.splice(buffer.indexOf(task), 1)[0];
	    }
	    /**
	     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
	     *
	     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
	     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
	     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
	     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
	     *        limit check.
	     * @returns The original promise.
	     */
	    function add(taskProducer) {
	        if (!isReady()) {
	            return syncpromise_1.rejectedSyncPromise(new error_1.SentryError('Not adding Promise due to buffer limit reached.'));
	        }
	        // start the task and add its promise to the queue
	        var task = taskProducer();
	        if (buffer.indexOf(task) === -1) {
	            buffer.push(task);
	        }
	        void task
	            .then(function () { return remove(task); })
	            // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
	            // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
	            // have promises, so TS has to polyfill when down-compiling.)
	            .then(null, function () {
	            return remove(task).then(null, function () {
	                // We have to add another catch here because `remove()` starts a new promise chain.
	            });
	        });
	        return task;
	    }
	    /**
	     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
	     *
	     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
	     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
	     * `true`.
	     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
	     * `false` otherwise
	     */
	    function drain(timeout) {
	        return new syncpromise_1.SyncPromise(function (resolve, reject) {
	            var counter = buffer.length;
	            if (!counter) {
	                return resolve(true);
	            }
	            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
	            var capturedSetTimeout = setTimeout(function () {
	                if (timeout && timeout > 0) {
	                    resolve(false);
	                }
	            }, timeout);
	            // if all promises resolve in time, cancel the timer and resolve to `true`
	            buffer.forEach(function (item) {
	                void syncpromise_1.resolvedSyncPromise(item).then(function () {
	                    // eslint-disable-next-line no-plusplus
	                    if (!--counter) {
	                        clearTimeout(capturedSetTimeout);
	                        resolve(true);
	                    }
	                }, reject);
	            });
	        });
	    }
	    return {
	        $: buffer,
	        add: add,
	        drain: drain,
	    };
	}
	exports.makePromiseBuffer = makePromiseBuffer;
	//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
	/* eslint-disable @typescript-eslint/typedef */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var is_1 = __webpack_require__(148);
	/**
	 * Creates a resolved sync promise.
	 *
	 * @param value the value to resolve the promise with
	 * @returns the resolved sync promise
	 */
	function resolvedSyncPromise(value) {
	    return new SyncPromise(function (resolve) {
	        resolve(value);
	    });
	}
	exports.resolvedSyncPromise = resolvedSyncPromise;
	/**
	 * Creates a rejected sync promise.
	 *
	 * @param value the value to reject the promise with
	 * @returns the rejected sync promise
	 */
	function rejectedSyncPromise(reason) {
	    return new SyncPromise(function (_, reject) {
	        reject(reason);
	    });
	}
	exports.rejectedSyncPromise = rejectedSyncPromise;
	/**
	 * Thenable class that behaves like a Promise and follows it's interface
	 * but is not async internally
	 */
	var SyncPromise = /** @class */ (function () {
	    function SyncPromise(executor) {
	        var _this = this;
	        this._state = 0 /* PENDING */;
	        this._handlers = [];
	        /** JSDoc */
	        this._resolve = function (value) {
	            _this._setResult(1 /* RESOLVED */, value);
	        };
	        /** JSDoc */
	        this._reject = function (reason) {
	            _this._setResult(2 /* REJECTED */, reason);
	        };
	        /** JSDoc */
	        this._setResult = function (state, value) {
	            if (_this._state !== 0 /* PENDING */) {
	                return;
	            }
	            if (is_1.isThenable(value)) {
	                void value.then(_this._resolve, _this._reject);
	                return;
	            }
	            _this._state = state;
	            _this._value = value;
	            _this._executeHandlers();
	        };
	        /** JSDoc */
	        this._executeHandlers = function () {
	            if (_this._state === 0 /* PENDING */) {
	                return;
	            }
	            var cachedHandlers = _this._handlers.slice();
	            _this._handlers = [];
	            cachedHandlers.forEach(function (handler) {
	                if (handler[0]) {
	                    return;
	                }
	                if (_this._state === 1 /* RESOLVED */) {
	                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
	                    handler[1](_this._value);
	                }
	                if (_this._state === 2 /* REJECTED */) {
	                    handler[2](_this._value);
	                }
	                handler[0] = true;
	            });
	        };
	        try {
	            executor(this._resolve, this._reject);
	        }
	        catch (e) {
	            this._reject(e);
	        }
	    }
	    /** JSDoc */
	    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            _this._handlers.push([
	                false,
	                function (result) {
	                    if (!onfulfilled) {
	                        // TODO: ¯\_(ツ)_/¯
	                        // TODO: FIXME
	                        resolve(result);
	                    }
	                    else {
	                        try {
	                            resolve(onfulfilled(result));
	                        }
	                        catch (e) {
	                            reject(e);
	                        }
	                    }
	                },
	                function (reason) {
	                    if (!onrejected) {
	                        reject(reason);
	                    }
	                    else {
	                        try {
	                            resolve(onrejected(reason));
	                        }
	                        catch (e) {
	                            reject(e);
	                        }
	                    }
	                },
	            ]);
	            _this._executeHandlers();
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.catch = function (onrejected) {
	        return this.then(function (val) { return val; }, onrejected);
	    };
	    /** JSDoc */
	    SyncPromise.prototype.finally = function (onfinally) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            var val;
	            var isRejected;
	            return _this.then(function (value) {
	                isRejected = false;
	                val = value;
	                if (onfinally) {
	                    onfinally();
	                }
	            }, function (reason) {
	                isRejected = true;
	                val = reason;
	                if (onfinally) {
	                    onfinally();
	                }
	            }).then(function () {
	                if (isRejected) {
	                    reject(val);
	                    return;
	                }
	                resolve(val);
	            });
	        });
	    };
	    return SyncPromise;
	}());
	exports.SyncPromise = SyncPromise;
	//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(134);
	var enums_1 = __webpack_require__(153);
	function isSupportedSeverity(level) {
	    return enums_1.SeverityLevels.indexOf(level) !== -1;
	}
	/**
	 * Converts a string-based level into a {@link Severity}.
	 *
	 * @param level string representation of Severity
	 * @returns Severity
	 */
	function severityFromString(level) {
	    if (level === 'warn')
	        return types_1.Severity.Warning;
	    if (isSupportedSeverity(level)) {
	        return level;
	    }
	    return types_1.Severity.Log;
	}
	exports.severityFromString = severityFromString;
	//# sourceMappingURL=severity.js.map

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Converts an HTTP status code to sentry status {@link EventStatus}.
	 *
	 * @param code number HTTP status code
	 * @returns EventStatus
	 */
	function eventStatusFromHttpCode(code) {
	    if (code >= 200 && code < 300) {
	        return 'success';
	    }
	    if (code === 429) {
	        return 'rate_limit';
	    }
	    if (code >= 400 && code < 500) {
	        return 'invalid';
	    }
	    if (code >= 500) {
	        return 'failed';
	    }
	    return 'unknown';
	}
	exports.eventStatusFromHttpCode = eventStatusFromHttpCode;
	//# sourceMappingURL=status.js.map

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var global_1 = __webpack_require__(143);
	var node_1 = __webpack_require__(144);
	/**
	 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
	 *
	 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
	 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
	 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
	 */
	var dateTimestampSource = {
	    nowSeconds: function () { return Date.now() / 1000; },
	};
	/**
	 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
	 * support the API.
	 *
	 * Wrapping the native API works around differences in behavior from different browsers.
	 */
	function getBrowserPerformance() {
	    var performance = global_1.getGlobalObject().performance;
	    if (!performance || !performance.now) {
	        return undefined;
	    }
	    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
	    //
	    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
	    // performance.now() gives a date arbitrarily in the past.
	    //
	    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
	    // undefined.
	    //
	    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
	    // interact with data coming out of performance entries.
	    //
	    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
	    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
	    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
	    // observed skews that can be as long as days, weeks or months.
	    //
	    // See https://github.com/getsentry/sentry-javascript/issues/2590.
	    //
	    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
	    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
	    // transactions of long-lived web pages.
	    var timeOrigin = Date.now() - performance.now();
	    return {
	        now: function () { return performance.now(); },
	        timeOrigin: timeOrigin,
	    };
	}
	/**
	 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
	 * implement the API.
	 */
	function getNodePerformance() {
	    try {
	        var perfHooks = node_1.dynamicRequire(module, 'perf_hooks');
	        return perfHooks.performance;
	    }
	    catch (_) {
	        return undefined;
	    }
	}
	/**
	 * The Performance API implementation for the current platform, if available.
	 */
	var platformPerformance = node_1.isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
	var timestampSource = platformPerformance === undefined
	    ? dateTimestampSource
	    : {
	        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
	    };
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
	 */
	exports.dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
	 * availability of the Performance API.
	 *
	 * See `usingPerformanceAPI` to test whether the Performance API is used.
	 *
	 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
	 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
	 * skew can grow to arbitrary amounts like days, weeks or months.
	 * See https://github.com/getsentry/sentry-javascript/issues/2590.
	 */
	exports.timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
	// Re-exported with an old name for backwards-compatibility.
	exports.timestampWithMs = exports.timestampInSeconds;
	/**
	 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
	 */
	exports.usingPerformanceAPI = platformPerformance !== undefined;
	/**
	 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
	 * performance API is available.
	 */
	exports.browserPerformanceTimeOrigin = (function () {
	    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
	    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
	    // data as reliable if they are within a reasonable threshold of the current time.
	    var performance = global_1.getGlobalObject().performance;
	    if (!performance || !performance.now) {
	        exports._browserPerformanceTimeOriginMode = 'none';
	        return undefined;
	    }
	    var threshold = 3600 * 1000;
	    var performanceNow = performance.now();
	    var dateNow = Date.now();
	    // if timeOrigin isn't available set delta to threshold so it isn't used
	    var timeOriginDelta = performance.timeOrigin
	        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
	        : threshold;
	    var timeOriginIsReliable = timeOriginDelta < threshold;
	    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
	    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
	    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
	    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
	    // Date API.
	    // eslint-disable-next-line deprecation/deprecation
	    var navigationStart = performance.timing && performance.timing.navigationStart;
	    var hasNavigationStart = typeof navigationStart === 'number';
	    // if navigationStart isn't available set delta to threshold so it isn't used
	    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
	    var navigationStartIsReliable = navigationStartDelta < threshold;
	    if (timeOriginIsReliable || navigationStartIsReliable) {
	        // Use the more reliable time origin
	        if (timeOriginDelta <= navigationStartDelta) {
	            exports._browserPerformanceTimeOriginMode = 'timeOrigin';
	            return performance.timeOrigin;
	        }
	        else {
	            exports._browserPerformanceTimeOriginMode = 'navigationStart';
	            return navigationStart;
	        }
	    }
	    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
	    exports._browserPerformanceTimeOriginMode = 'dateNow';
	    return dateNow;
	})();
	//# sourceMappingURL=time.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
	    '([0-9a-f]{32})?' + // trace_id
	    '-?([0-9a-f]{16})?' + // span_id
	    '-?([01])?' + // sampled
	    '[ \\t]*$');
	/**
	 * Extract transaction context data from a `sentry-trace` header.
	 *
	 * @param traceparent Traceparent string
	 *
	 * @returns Object containing data from the header, or undefined if traceparent string is malformed
	 */
	function extractTraceparentData(traceparent) {
	    var matches = traceparent.match(exports.TRACEPARENT_REGEXP);
	    if (matches) {
	        var parentSampled = void 0;
	        if (matches[3] === '1') {
	            parentSampled = true;
	        }
	        else if (matches[3] === '0') {
	            parentSampled = false;
	        }
	        return {
	            traceId: matches[1],
	            parentSampled: parentSampled,
	            parentSpanId: matches[2],
	        };
	    }
	    return undefined;
	}
	exports.extractTraceparentData = extractTraceparentData;
	//# sourceMappingURL=tracing.js.map

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var is_1 = __webpack_require__(148);
	/**
	 * Creates an envelope.
	 * Make sure to always explicitly provide the generic to this function
	 * so that the envelope types resolve correctly.
	 */
	function createEnvelope(headers, items) {
	    if (items === void 0) { items = []; }
	    return [headers, items];
	}
	exports.createEnvelope = createEnvelope;
	/**
	 * Add an item to an envelope.
	 * Make sure to always explicitly provide the generic to this function
	 * so that the envelope types resolve correctly.
	 */
	function addItemToEnvelope(envelope, newItem) {
	    var _a = tslib_1.__read(envelope, 2), headers = _a[0], items = _a[1];
	    return [headers, tslib_1.__spread(items, [newItem])];
	}
	exports.addItemToEnvelope = addItemToEnvelope;
	/**
	 * Get the type of the envelope. Grabs the type from the first envelope item.
	 */
	function getEnvelopeType(envelope) {
	    var _a = tslib_1.__read(envelope, 2), _b = tslib_1.__read(_a[1], 1), _c = tslib_1.__read(_b[0], 1), firstItemHeader = _c[0];
	    return firstItemHeader.type;
	}
	exports.getEnvelopeType = getEnvelopeType;
	/**
	 * Serializes an envelope into a string.
	 */
	function serializeEnvelope(envelope) {
	    var _a = tslib_1.__read(envelope, 2), headers = _a[0], items = _a[1];
	    var serializedHeaders = JSON.stringify(headers);
	    // Have to cast items to any here since Envelope is a union type
	    // Fixed in Typescript 4.2
	    // TODO: Remove any[] cast when we upgrade to TS 4.2
	    // https://github.com/microsoft/TypeScript/issues/36390
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return items.reduce(function (acc, item) {
	        var _a = tslib_1.__read(item, 2), itemHeaders = _a[0], payload = _a[1];
	        // We do not serialize payloads that are primitives
	        var serializedPayload = is_1.isPrimitive(payload) ? String(payload) : JSON.stringify(payload);
	        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
	    }, serializedHeaders);
	}
	exports.serializeEnvelope = serializeEnvelope;
	//# sourceMappingURL=envelope.js.map

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var envelope_1 = __webpack_require__(170);
	var time_1 = __webpack_require__(168);
	/**
	 * Creates client report envelope
	 * @param discarded_events An array of discard events
	 * @param dsn A DSN that can be set on the header. Optional.
	 */
	function createClientReportEnvelope(discarded_events, dsn, timestamp) {
	    var clientReportItem = [
	        { type: 'client_report' },
	        {
	            timestamp: timestamp || time_1.dateTimestampInSeconds(),
	            discarded_events: discarded_events,
	        },
	    ];
	    return envelope_1.createEnvelope(dsn ? { dsn: dsn } : {}, [clientReportItem]);
	}
	exports.createClientReportEnvelope = createClientReportEnvelope;
	//# sourceMappingURL=clientreport.js.map

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	exports.DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds
	/**
	 * Extracts Retry-After value from the request header or returns default value
	 * @param header string representation of 'Retry-After' header
	 * @param now current unix timestamp
	 *
	 */
	function parseRetryAfterHeader(header, now) {
	    if (now === void 0) { now = Date.now(); }
	    var headerDelay = parseInt("" + header, 10);
	    if (!isNaN(headerDelay)) {
	        return headerDelay * 1000;
	    }
	    var headerDate = Date.parse("" + header);
	    if (!isNaN(headerDate)) {
	        return headerDate - now;
	    }
	    return exports.DEFAULT_RETRY_AFTER;
	}
	exports.parseRetryAfterHeader = parseRetryAfterHeader;
	/**
	 * Gets the time that given category is disabled until for rate limiting
	 */
	function disabledUntil(limits, category) {
	    return limits[category] || limits.all || 0;
	}
	exports.disabledUntil = disabledUntil;
	/**
	 * Checks if a category is rate limited
	 */
	function isRateLimited(limits, category, now) {
	    if (now === void 0) { now = Date.now(); }
	    return disabledUntil(limits, category) > now;
	}
	exports.isRateLimited = isRateLimited;
	/**
	 * Update ratelimits from incoming headers.
	 * Returns true if headers contains a non-empty rate limiting header.
	 */
	function updateRateLimits(limits, headers, now) {
	    var e_1, _a, e_2, _b;
	    if (now === void 0) { now = Date.now(); }
	    var updatedRateLimits = tslib_1.__assign({}, limits);
	    // "The name is case-insensitive."
	    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
	    var rateLimitHeader = headers['x-sentry-rate-limits'];
	    var retryAfterHeader = headers['retry-after'];
	    if (rateLimitHeader) {
	        try {
	            /**
	             * rate limit headers are of the form
	             *     <header>,<header>,..
	             * where each <header> is of the form
	             *     <retry_after>: <categories>: <scope>: <reason_code>
	             * where
	             *     <retry_after> is a delay in seconds
	             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
	             *         <category>;<category>;...
	             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
	             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
	             */
	            for (var _c = tslib_1.__values(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var limit = _d.value;
	                var parameters = limit.split(':', 2);
	                var headerDelay = parseInt(parameters[0], 10);
	                var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
	                if (!parameters[1]) {
	                    updatedRateLimits.all = now + delay;
	                }
	                else {
	                    try {
	                        for (var _e = (e_2 = void 0, tslib_1.__values(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                            var category = _f.value;
	                            updatedRateLimits[category] = now + delay;
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    }
	    else if (retryAfterHeader) {
	        updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
	    }
	    return updatedRateLimits;
	}
	exports.updateRateLimits = updateRateLimits;
	//# sourceMappingURL=ratelimit.js.map

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	/**
	 * @inheritdoc
	 */
	var Session = /** @class */ (function () {
	    function Session(context) {
	        this.errors = 0;
	        this.sid = utils_1.uuid4();
	        this.duration = 0;
	        this.status = 'ok';
	        this.init = true;
	        this.ignoreDuration = false;
	        // Both timestamp and started are in seconds since the UNIX epoch.
	        var startingTime = utils_1.timestampInSeconds();
	        this.timestamp = startingTime;
	        this.started = startingTime;
	        if (context) {
	            this.update(context);
	        }
	    }
	    /** JSDoc */
	    // eslint-disable-next-line complexity
	    Session.prototype.update = function (context) {
	        if (context === void 0) { context = {}; }
	        if (context.user) {
	            if (!this.ipAddress && context.user.ip_address) {
	                this.ipAddress = context.user.ip_address;
	            }
	            if (!this.did && !context.did) {
	                this.did = context.user.id || context.user.email || context.user.username;
	            }
	        }
	        this.timestamp = context.timestamp || utils_1.timestampInSeconds();
	        if (context.ignoreDuration) {
	            this.ignoreDuration = context.ignoreDuration;
	        }
	        if (context.sid) {
	            // Good enough uuid validation. — Kamil
	            this.sid = context.sid.length === 32 ? context.sid : utils_1.uuid4();
	        }
	        if (context.init !== undefined) {
	            this.init = context.init;
	        }
	        if (!this.did && context.did) {
	            this.did = "" + context.did;
	        }
	        if (typeof context.started === 'number') {
	            this.started = context.started;
	        }
	        if (this.ignoreDuration) {
	            this.duration = undefined;
	        }
	        else if (typeof context.duration === 'number') {
	            this.duration = context.duration;
	        }
	        else {
	            var duration = this.timestamp - this.started;
	            this.duration = duration >= 0 ? duration : 0;
	        }
	        if (context.release) {
	            this.release = context.release;
	        }
	        if (context.environment) {
	            this.environment = context.environment;
	        }
	        if (!this.ipAddress && context.ipAddress) {
	            this.ipAddress = context.ipAddress;
	        }
	        if (!this.userAgent && context.userAgent) {
	            this.userAgent = context.userAgent;
	        }
	        if (typeof context.errors === 'number') {
	            this.errors = context.errors;
	        }
	        if (context.status) {
	            this.status = context.status;
	        }
	    };
	    /** JSDoc */
	    Session.prototype.close = function (status) {
	        if (status) {
	            this.update({ status: status });
	        }
	        else if (this.status === 'ok') {
	            this.update({ status: 'exited' });
	        }
	        else {
	            this.update();
	        }
	    };
	    /** JSDoc */
	    Session.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            sid: "" + this.sid,
	            init: this.init,
	            // Make sure that sec is converted to ms for date constructor
	            started: new Date(this.started * 1000).toISOString(),
	            timestamp: new Date(this.timestamp * 1000).toISOString(),
	            status: this.status,
	            errors: this.errors,
	            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
	            duration: this.duration,
	            attrs: {
	                release: this.release,
	                environment: this.environment,
	                ip_address: this.ipAddress,
	                user_agent: this.userAgent,
	            },
	        });
	    };
	    return Session;
	}());
	exports.Session = Session;
	//# sourceMappingURL=session.js.map

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(175);
	var hub_1 = __webpack_require__(176);
	/**
	 * @inheritdoc
	 */
	var SessionFlusher = /** @class */ (function () {
	    function SessionFlusher(transport, attrs) {
	        var _this = this;
	        this.flushTimeout = 60;
	        this._pendingAggregates = {};
	        this._isEnabled = true;
	        this._transport = transport;
	        // Call to setInterval, so that flush is called every 60 seconds
	        this._intervalId = setInterval(function () { return _this.flush(); }, this.flushTimeout * 1000);
	        this._sessionAttrs = attrs;
	    }
	    /** Sends session aggregates to Transport */
	    SessionFlusher.prototype.sendSessionAggregates = function (sessionAggregates) {
	        if (!this._transport.sendSession) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
	            return;
	        }
	        void this._transport.sendSession(sessionAggregates).then(null, function (reason) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Error while sending session:', reason);
	        });
	    };
	    /** Checks if `pendingAggregates` has entries, and if it does flushes them by calling `sendSessions` */
	    SessionFlusher.prototype.flush = function () {
	        var sessionAggregates = this.getSessionAggregates();
	        if (sessionAggregates.aggregates.length === 0) {
	            return;
	        }
	        this._pendingAggregates = {};
	        this.sendSessionAggregates(sessionAggregates);
	    };
	    /** Massages the entries in `pendingAggregates` and returns aggregated sessions */
	    SessionFlusher.prototype.getSessionAggregates = function () {
	        var _this = this;
	        var aggregates = Object.keys(this._pendingAggregates).map(function (key) {
	            return _this._pendingAggregates[parseInt(key)];
	        });
	        var sessionAggregates = {
	            attrs: this._sessionAttrs,
	            aggregates: aggregates,
	        };
	        return utils_1.dropUndefinedKeys(sessionAggregates);
	    };
	    /** JSDoc */
	    SessionFlusher.prototype.close = function () {
	        clearInterval(this._intervalId);
	        this._isEnabled = false;
	        this.flush();
	    };
	    /**
	     * Wrapper function for _incrementSessionStatusCount that checks if the instance of SessionFlusher is enabled then
	     * fetches the session status of the request from `Scope.getRequestSession().status` on the scope and passes them to
	     * `_incrementSessionStatusCount` along with the start date
	     */
	    SessionFlusher.prototype.incrementSessionStatusCount = function () {
	        if (!this._isEnabled) {
	            return;
	        }
	        var scope = hub_1.getCurrentHub().getScope();
	        var requestSession = scope && scope.getRequestSession();
	        if (requestSession && requestSession.status) {
	            this._incrementSessionStatusCount(requestSession.status, new Date());
	            // This is not entirely necessarily but is added as a safe guard to indicate the bounds of a request and so in
	            // case captureRequestSession is called more than once to prevent double count
	            if (scope) {
	                scope.setRequestSession(undefined);
	            }
	            /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	        }
	    };
	    /**
	     * Increments status bucket in pendingAggregates buffer (internal state) corresponding to status of
	     * the session received
	     */
	    SessionFlusher.prototype._incrementSessionStatusCount = function (status, date) {
	        // Truncate minutes and seconds on Session Started attribute to have one minute bucket keys
	        var sessionStartedTrunc = new Date(date).setSeconds(0, 0);
	        this._pendingAggregates[sessionStartedTrunc] = this._pendingAggregates[sessionStartedTrunc] || {};
	        // corresponds to aggregated sessions in one specific minute bucket
	        // for example, {"started":"2021-03-16T08:00:00.000Z","exited":4, "errored": 1}
	        var aggregationCounts = this._pendingAggregates[sessionStartedTrunc];
	        if (!aggregationCounts.started) {
	            aggregationCounts.started = new Date(sessionStartedTrunc).toISOString();
	        }
	        switch (status) {
	            case 'errored':
	                aggregationCounts.errored = (aggregationCounts.errored || 0) + 1;
	                return aggregationCounts.errored;
	            case 'ok':
	                aggregationCounts.exited = (aggregationCounts.exited || 0) + 1;
	                return aggregationCounts.exited;
	            default:
	                aggregationCounts.crashed = (aggregationCounts.crashed || 0) + 1;
	                return aggregationCounts.crashed;
	        }
	    };
	    return SessionFlusher;
	}());
	exports.SessionFlusher = SessionFlusher;
	//# sourceMappingURL=sessionflusher.js.map

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(175);
	var scope_1 = __webpack_require__(139);
	var session_1 = __webpack_require__(173);
	/**
	 * API compatibility version of this hub.
	 *
	 * WARNING: This number should only be increased when the global interface
	 * changes and new methods are introduced.
	 *
	 * @hidden
	 */
	exports.API_VERSION = 4;
	/**
	 * Default maximum number of breadcrumbs added to an event. Can be overwritten
	 * with {@link Options.maxBreadcrumbs}.
	 */
	var DEFAULT_BREADCRUMBS = 100;
	/**
	 * @inheritDoc
	 */
	var Hub = /** @class */ (function () {
	    /**
	     * Creates a new instance of the hub, will push one {@link Layer} into the
	     * internal stack on creation.
	     *
	     * @param client bound to the hub.
	     * @param scope bound to the hub.
	     * @param version number, higher number means higher priority.
	     */
	    function Hub(client, scope, _version) {
	        if (scope === void 0) { scope = new scope_1.Scope(); }
	        if (_version === void 0) { _version = exports.API_VERSION; }
	        this._version = _version;
	        /** Is a {@link Layer}[] containing the client and scope */
	        this._stack = [{}];
	        this.getStackTop().scope = scope;
	        if (client) {
	            this.bindClient(client);
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.isOlderThan = function (version) {
	        return this._version < version;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.bindClient = function (client) {
	        var top = this.getStackTop();
	        top.client = client;
	        if (client && client.setupIntegrations) {
	            client.setupIntegrations();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.pushScope = function () {
	        // We want to clone the content of prev scope
	        var scope = scope_1.Scope.clone(this.getScope());
	        this.getStack().push({
	            client: this.getClient(),
	            scope: scope,
	        });
	        return scope;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.popScope = function () {
	        if (this.getStack().length <= 1)
	            return false;
	        return !!this.getStack().pop();
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.withScope = function (callback) {
	        var scope = this.pushScope();
	        try {
	            callback(scope);
	        }
	        finally {
	            this.popScope();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getClient = function () {
	        return this.getStackTop().client;
	    };
	    /** Returns the scope of the top stack. */
	    Hub.prototype.getScope = function () {
	        return this.getStackTop().scope;
	    };
	    /** Returns the scope stack for domains or the process. */
	    Hub.prototype.getStack = function () {
	        return this._stack;
	    };
	    /** Returns the topmost scope layer in the order domain > local > process. */
	    Hub.prototype.getStackTop = function () {
	        return this._stack[this._stack.length - 1];
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Hub.prototype.captureException = function (exception, hint) {
	        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimic the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error('Sentry syntheticException');
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: exception,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureException', exception, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureMessage = function (message, level, hint) {
	        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimic the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error(message);
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: message,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureMessage', message, level, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureEvent = function (event, hint) {
	        var eventId = hint && hint.event_id ? hint.event_id : utils_1.uuid4();
	        if (event.type !== 'transaction') {
	            this._lastEventId = eventId;
	        }
	        this._invokeClient('captureEvent', event, tslib_1.__assign(tslib_1.__assign({}, hint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.lastEventId = function () {
	        return this._lastEventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope || !client)
	            return;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
	        if (maxBreadcrumbs <= 0)
	            return;
	        var timestamp = utils_1.dateTimestampInSeconds();
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: timestamp }, breadcrumb);
	        var finalBreadcrumb = beforeBreadcrumb
	            ? utils_1.consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
	            : mergedBreadcrumb;
	        if (finalBreadcrumb === null)
	            return;
	        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setUser = function (user) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setUser(user);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTags = function (tags) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTags(tags);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtras = function (extras) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtras(extras);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTag = function (key, value) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTag(key, value);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtra = function (key, extra) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtra(key, extra);
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype.setContext = function (name, context) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setContext(name, context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.configureScope = function (callback) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (scope && client) {
	            callback(scope);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.run = function (callback) {
	        var oldHub = makeMain(this);
	        try {
	            callback(this);
	        }
	        finally {
	            makeMain(oldHub);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getIntegration = function (integration) {
	        var client = this.getClient();
	        if (!client)
	            return null;
	        try {
	            return client.getIntegration(integration);
	        }
	        catch (_oO) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSpan = function (context) {
	        return this._callExtensionMethod('startSpan', context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startTransaction = function (context, customSamplingContext) {
	        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.traceHeaders = function () {
	        return this._callExtensionMethod('traceHeaders');
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureSession = function (endSession) {
	        if (endSession === void 0) { endSession = false; }
	        // both send the update and pull the session from the scope
	        if (endSession) {
	            return this.endSession();
	        }
	        // only send the update
	        this._sendSessionUpdate();
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.endSession = function () {
	        var layer = this.getStackTop();
	        var scope = layer && layer.scope;
	        var session = scope && scope.getSession();
	        if (session) {
	            session.close();
	        }
	        this._sendSessionUpdate();
	        // the session is over; take it off of the scope
	        if (scope) {
	            scope.setSession();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSession = function (context) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
	        // Will fetch userAgent if called from browser sdk
	        var global = utils_1.getGlobalObject();
	        var userAgent = (global.navigator || {}).userAgent;
	        var session = new session_1.Session(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ release: release,
	            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
	        if (scope) {
	            // End existing session if there's one
	            var currentSession = scope.getSession && scope.getSession();
	            if (currentSession && currentSession.status === 'ok') {
	                currentSession.update({ status: 'exited' });
	            }
	            this.endSession();
	            // Afterwards we set the new session on the scope
	            scope.setSession(session);
	        }
	        return session;
	    };
	    /**
	     * Sends the current Session on the scope
	     */
	    Hub.prototype._sendSessionUpdate = function () {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope)
	            return;
	        var session = scope.getSession && scope.getSession();
	        if (session) {
	            if (client && client.captureSession) {
	                client.captureSession(session);
	            }
	        }
	    };
	    /**
	     * Internal helper function to call a method on the top client if it exists.
	     *
	     * @param method The method to call on the client.
	     * @param args Arguments to pass to the client function.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._invokeClient = function (method) {
	        var _a;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
	        if (client && client[method]) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	            (_a = client)[method].apply(_a, tslib_1.__spread(args, [scope]));
	        }
	    };
	    /**
	     * Calls global extension method and binding current instance to the function call
	     */
	    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._callExtensionMethod = function (method) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var carrier = getMainCarrier();
	        var sentry = carrier.__SENTRY__;
	        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
	            return sentry.extensions[method].apply(this, args);
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
	    };
	    return Hub;
	}());
	exports.Hub = Hub;
	/**
	 * Returns the global shim registry.
	 *
	 * FIXME: This function is problematic, because despite always returning a valid Carrier,
	 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
	 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
	 **/
	function getMainCarrier() {
	    var carrier = utils_1.getGlobalObject();
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {
	        extensions: {},
	        hub: undefined,
	    };
	    return carrier;
	}
	exports.getMainCarrier = getMainCarrier;
	/**
	 * Replaces the current main hub with the passed one on the global object
	 *
	 * @returns The old replaced hub
	 */
	function makeMain(hub) {
	    var registry = getMainCarrier();
	    var oldHub = getHubFromCarrier(registry);
	    setHubOnCarrier(registry, hub);
	    return oldHub;
	}
	exports.makeMain = makeMain;
	/**
	 * Returns the default hub instance.
	 *
	 * If a hub is already registered in the global carrier but this module
	 * contains a more recent version, it replaces the registered version.
	 * Otherwise, the currently registered hub will be returned.
	 */
	function getCurrentHub() {
	    // Get main carrier (global for every environment)
	    var registry = getMainCarrier();
	    // If there's no hub, or its an old API, assign a new one
	    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(exports.API_VERSION)) {
	        setHubOnCarrier(registry, new Hub());
	    }
	    // Prefer domains over global if they are there (applicable only to Node environment)
	    if (utils_1.isNodeEnv()) {
	        return getHubFromActiveDomain(registry);
	    }
	    // Return hub that lives on a global object
	    return getHubFromCarrier(registry);
	}
	exports.getCurrentHub = getCurrentHub;
	/**
	 * Returns the active domain, if one exists
	 * @deprecated No longer used; remove in v7
	 * @returns The domain, or undefined if there is no active domain
	 */
	// eslint-disable-next-line deprecation/deprecation
	function getActiveDomain() {
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
	    var sentry = getMainCarrier().__SENTRY__;
	    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
	}
	exports.getActiveDomain = getActiveDomain;
	/**
	 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
	 * @returns discovered hub
	 */
	function getHubFromActiveDomain(registry) {
	    try {
	        var sentry = getMainCarrier().__SENTRY__;
	        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
	        // If there's no active domain, just return global hub
	        if (!activeDomain) {
	            return getHubFromCarrier(registry);
	        }
	        // If there's no hub on current domain, or it's an old API, assign a new one
	        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(exports.API_VERSION)) {
	            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
	            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, scope_1.Scope.clone(registryHubTopStack.scope)));
	        }
	        // Return hub that lives on a domain
	        return getHubFromCarrier(activeDomain);
	    }
	    catch (_Oo) {
	        // Return hub that lives on a global object
	        return getHubFromCarrier(registry);
	    }
	}
	/**
	 * This will tell whether a carrier has a hub on it or not
	 * @param carrier object
	 */
	function hasHubOnCarrier(carrier) {
	    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
	}
	/**
	 * This will create a new {@link Hub} and add to the passed object on
	 * __SENTRY__.hub.
	 * @param carrier object
	 * @hidden
	 */
	function getHubFromCarrier(carrier) {
	    return utils_1.getGlobalSingleton('hub', function () { return new Hub(); }, carrier);
	}
	exports.getHubFromCarrier = getHubFromCarrier;
	/**
	 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
	 * @param carrier object
	 * @param hub Hub
	 * @returns A boolean indicating success or failure
	 */
	function setHubOnCarrier(carrier, hub) {
	    if (!carrier)
	        return false;
	    var __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
	    __SENTRY__.hub = hub;
	    return true;
	}
	exports.setHubOnCarrier = setHubOnCarrier;
	//# sourceMappingURL=hub.js.map

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var SENTRY_API_VERSION = '7';
	/**
	 * Helper class to provide urls, headers and metadata that can be used to form
	 * different types of requests to Sentry endpoints.
	 * Supports both envelopes and regular event requests.
	 *
	 * @deprecated Please use APIDetails
	 **/
	var API = /** @class */ (function () {
	    /** Create a new instance of API */
	    function API(dsn, metadata, tunnel) {
	        if (metadata === void 0) { metadata = {}; }
	        this.dsn = dsn;
	        this._dsnObject = utils_1.makeDsn(dsn);
	        this.metadata = metadata;
	        this._tunnel = tunnel;
	    }
	    /** Returns the Dsn object. */
	    API.prototype.getDsn = function () {
	        return this._dsnObject;
	    };
	    /** Does this transport force envelopes? */
	    API.prototype.forceEnvelope = function () {
	        return !!this._tunnel;
	    };
	    /** Returns the prefix to construct Sentry ingestion API endpoints. */
	    API.prototype.getBaseApiEndpoint = function () {
	        return getBaseApiEndpoint(this._dsnObject);
	    };
	    /** Returns the store endpoint URL. */
	    API.prototype.getStoreEndpoint = function () {
	        return getStoreEndpoint(this._dsnObject);
	    };
	    /**
	     * Returns the store endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
	        return getStoreEndpointWithUrlEncodedAuth(this._dsnObject);
	    };
	    /**
	     * Returns the envelope endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
	        return getEnvelopeEndpointWithUrlEncodedAuth(this._dsnObject, this._tunnel);
	    };
	    return API;
	}());
	exports.API = API;
	/** Initializes API Details */
	function initAPIDetails(dsn, metadata, tunnel) {
	    return {
	        initDsn: dsn,
	        metadata: metadata || {},
	        dsn: utils_1.makeDsn(dsn),
	        tunnel: tunnel,
	    };
	}
	exports.initAPIDetails = initAPIDetails;
	/** Returns the prefix to construct Sentry ingestion API endpoints. */
	function getBaseApiEndpoint(dsn) {
	    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
	    var port = dsn.port ? ":" + dsn.port : '';
	    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
	}
	/** Returns the ingest API endpoint for target. */
	function _getIngestEndpoint(dsn, target) {
	    return "" + getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
	}
	/** Returns a URL-encoded string with auth config suitable for a query string. */
	function _encodedAuth(dsn) {
	    return utils_1.urlEncode({
	        // We send only the minimum set of required information. See
	        // https://github.com/getsentry/sentry-javascript/issues/2572.
	        sentry_key: dsn.publicKey,
	        sentry_version: SENTRY_API_VERSION,
	    });
	}
	/** Returns the store endpoint URL. */
	function getStoreEndpoint(dsn) {
	    return _getIngestEndpoint(dsn, 'store');
	}
	/**
	 * Returns the store endpoint URL with auth in the query string.
	 *
	 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	 */
	function getStoreEndpointWithUrlEncodedAuth(dsn) {
	    return getStoreEndpoint(dsn) + "?" + _encodedAuth(dsn);
	}
	exports.getStoreEndpointWithUrlEncodedAuth = getStoreEndpointWithUrlEncodedAuth;
	/** Returns the envelope endpoint URL. */
	function _getEnvelopeEndpoint(dsn) {
	    return _getIngestEndpoint(dsn, 'envelope');
	}
	/**
	 * Returns the envelope endpoint URL with auth in the query string.
	 *
	 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	 */
	function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel) {
	    return tunnel ? tunnel : _getEnvelopeEndpoint(dsn) + "?" + _encodedAuth(dsn);
	}
	exports.getEnvelopeEndpointWithUrlEncodedAuth = getEnvelopeEndpointWithUrlEncodedAuth;
	/**
	 * Returns an object that can be used in request headers.
	 * This is needed for node and the old /store endpoint in sentry
	 */
	function getRequestHeaders(dsn, clientName, clientVersion) {
	    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
	    var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
	    header.push("sentry_client=" + clientName + "/" + clientVersion);
	    header.push("sentry_key=" + dsn.publicKey);
	    if (dsn.pass) {
	        header.push("sentry_secret=" + dsn.pass);
	    }
	    return {
	        'Content-Type': 'application/json',
	        'X-Sentry-Auth': header.join(', '),
	    };
	}
	exports.getRequestHeaders = getRequestHeaders;
	/** Returns the url to the report dialog endpoint. */
	function getReportDialogEndpoint(dsnLike, dialogOptions) {
	    var dsn = utils_1.makeDsn(dsnLike);
	    var endpoint = getBaseApiEndpoint(dsn) + "embed/error-page/";
	    var encodedOptions = "dsn=" + utils_1.dsnToString(dsn);
	    for (var key in dialogOptions) {
	        if (key === 'dsn') {
	            continue;
	        }
	        if (key === 'user') {
	            if (!dialogOptions.user) {
	                continue;
	            }
	            if (dialogOptions.user.name) {
	                encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
	            }
	            if (dialogOptions.user.email) {
	                encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
	            }
	        }
	        else {
	            encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
	        }
	    }
	    return endpoint + "?" + encodedOptions;
	}
	exports.getReportDialogEndpoint = getReportDialogEndpoint;
	//# sourceMappingURL=api.js.map

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	/* eslint-disable max-lines */
	var hub_1 = __webpack_require__(138);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(179);
	var integration_1 = __webpack_require__(180);
	var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
	/**
	 * Base implementation for all JavaScript SDK clients.
	 *
	 * Call the constructor with the corresponding backend constructor and options
	 * specific to the client subclass. To access these options later, use
	 * {@link Client.getOptions}. Also, the Backend instance is available via
	 * {@link Client.getBackend}.
	 *
	 * If a Dsn is specified in the options, it will be parsed and stored. Use
	 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
	 * invalid, the constructor will throw a {@link SentryException}. Note that
	 * without a valid Dsn, the SDK will not send any events to Sentry.
	 *
	 * Before sending an event via the backend, it is passed through
	 * {@link BaseClient._prepareEvent} to add SDK information and scope data
	 * (breadcrumbs and context). To add more custom information, override this
	 * method and extend the resulting prepared event.
	 *
	 * To issue automatically created events (e.g. via instrumentation), use
	 * {@link Client.captureEvent}. It will prepare the event and pass it through
	 * the callback lifecycle. To issue auto-breadcrumbs, use
	 * {@link Client.addBreadcrumb}.
	 *
	 * @example
	 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
	 *   public constructor(options: NodeOptions) {
	 *     super(NodeBackend, options);
	 *   }
	 *
	 *   // ...
	 * }
	 */
	var BaseClient = /** @class */ (function () {
	    /**
	     * Initializes this client instance.
	     *
	     * @param backendClass A constructor function to create the backend.
	     * @param options Options for the client.
	     */
	    function BaseClient(backendClass, options) {
	        /** Array of used integrations. */
	        this._integrations = {};
	        /** Number of calls being processed */
	        this._numProcessing = 0;
	        this._backend = new backendClass(options);
	        this._options = options;
	        if (options.dsn) {
	            this._dsn = utils_1.makeDsn(options.dsn);
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseClient.prototype.captureException = function (exception, hint, scope) {
	        var _this = this;
	        // ensure we haven't captured this very object before
	        if (utils_1.checkOrSetAlreadyCaught(exception)) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log(ALREADY_SEEN_ERROR);
	            return;
	        }
	        var eventId = hint && hint.event_id;
	        this._process(this._getBackend()
	            .eventFromException(exception, hint)
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
	        var _this = this;
	        var eventId = hint && hint.event_id;
	        var promisedEvent = utils_1.isPrimitive(message)
	            ? this._getBackend().eventFromMessage(String(message), level, hint)
	            : this._getBackend().eventFromException(message, hint);
	        this._process(promisedEvent
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureEvent = function (event, hint, scope) {
	        // ensure we haven't captured this very object before
	        if (hint && hint.originalException && utils_1.checkOrSetAlreadyCaught(hint.originalException)) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log(ALREADY_SEEN_ERROR);
	            return;
	        }
	        var eventId = hint && hint.event_id;
	        this._process(this._captureEvent(event, hint, scope).then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureSession = function (session) {
	        if (!this._isEnabled()) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('SDK not enabled, will not capture session.');
	            return;
	        }
	        if (!(typeof session.release === 'string')) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Discarded session because of missing or non-string release');
	        }
	        else {
	            this._sendSession(session);
	            // After sending, we set init false to indicate it's not the first occurrence
	            session.update({ init: false });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getDsn = function () {
	        return this._dsn;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getOptions = function () {
	        return this._options;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getTransport = function () {
	        return this._getBackend().getTransport();
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.flush = function (timeout) {
	        var _this = this;
	        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
	            return _this.getTransport()
	                .close(timeout)
	                .then(function (transportFlushed) { return clientFinished && transportFlushed; });
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.close = function (timeout) {
	        var _this = this;
	        return this.flush(timeout).then(function (result) {
	            _this.getOptions().enabled = false;
	            return result;
	        });
	    };
	    /**
	     * Sets up the integrations
	     */
	    BaseClient.prototype.setupIntegrations = function () {
	        if (this._isEnabled() && !this._integrations.initialized) {
	            this._integrations = integration_1.setupIntegrations(this._options);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getIntegration = function (integration) {
	        try {
	            return this._integrations[integration.id] || null;
	        }
	        catch (_oO) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
	            return null;
	        }
	    };
	    /** Updates existing session based on the provided event */
	    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
	        var e_1, _a;
	        var crashed = false;
	        var errored = false;
	        var exceptions = event.exception && event.exception.values;
	        if (exceptions) {
	            errored = true;
	            try {
	                for (var exceptions_1 = tslib_1.__values(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
	                    var ex = exceptions_1_1.value;
	                    var mechanism = ex.mechanism;
	                    if (mechanism && mechanism.handled === false) {
	                        crashed = true;
	                        break;
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        // A session is updated and that session update is sent in only one of the two following scenarios:
	        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
	        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
	        var sessionNonTerminal = session.status === 'ok';
	        var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);
	        if (shouldUpdateAndSend) {
	            session.update(tslib_1.__assign(tslib_1.__assign({}, (crashed && { status: 'crashed' })), { errors: session.errors || Number(errored || crashed) }));
	            this.captureSession(session);
	        }
	    };
	    /** Deliver captured session to Sentry */
	    BaseClient.prototype._sendSession = function (session) {
	        this._getBackend().sendSession(session);
	    };
	    /**
	     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
	     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
	     *
	     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
	     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
	     * `true`.
	     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
	     * `false` otherwise
	     */
	    BaseClient.prototype._isClientDoneProcessing = function (timeout) {
	        var _this = this;
	        return new utils_1.SyncPromise(function (resolve) {
	            var ticked = 0;
	            var tick = 1;
	            var interval = setInterval(function () {
	                if (_this._numProcessing == 0) {
	                    clearInterval(interval);
	                    resolve(true);
	                }
	                else {
	                    ticked += tick;
	                    if (timeout && ticked >= timeout) {
	                        clearInterval(interval);
	                        resolve(false);
	                    }
	                }
	            }, tick);
	        });
	    };
	    /** Returns the current backend. */
	    BaseClient.prototype._getBackend = function () {
	        return this._backend;
	    };
	    /** Determines whether this SDK is enabled and a valid Dsn is present. */
	    BaseClient.prototype._isEnabled = function () {
	        return this.getOptions().enabled !== false && this._dsn !== undefined;
	    };
	    /**
	     * Adds common information to events.
	     *
	     * The information includes release and environment from `options`,
	     * breadcrumbs and context (extra, tags and user) from the scope.
	     *
	     * Information that is already present in the event is never overwritten. For
	     * nested objects, such as the context, keys are merged.
	     *
	     * @param event The original event.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A new event with more information.
	     */
	    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
	        var _this = this;
	        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
	        var prepared = tslib_1.__assign(tslib_1.__assign({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : utils_1.uuid4()), timestamp: event.timestamp || utils_1.dateTimestampInSeconds() });
	        this._applyClientOptions(prepared);
	        this._applyIntegrationsMetadata(prepared);
	        // If we have scope given to us, use it as the base for further modifications.
	        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
	        var finalScope = scope;
	        if (hint && hint.captureContext) {
	            finalScope = hub_1.Scope.clone(finalScope).update(hint.captureContext);
	        }
	        // We prepare the result here with a resolved Event.
	        var result = utils_1.resolvedSyncPromise(prepared);
	        // This should be the last thing called, since we want that
	        // {@link Hub.addEventProcessor} gets the finished prepared event.
	        if (finalScope) {
	            // In case we have a hub we reassign it.
	            result = finalScope.applyToEvent(prepared, hint);
	        }
	        return result.then(function (evt) {
	            if (evt) {
	                // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
	                // it is only attached as extra data to the event if the event somehow skips being normalized
	                evt.sdkProcessingMetadata = tslib_1.__assign(tslib_1.__assign({}, evt.sdkProcessingMetadata), { normalizeDepth: utils_1.normalize(normalizeDepth) + " (" + typeof normalizeDepth + ")" });
	            }
	            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
	                return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
	            }
	            return evt;
	        });
	    };
	    /**
	     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
	     * Normalized keys:
	     * - `breadcrumbs.data`
	     * - `user`
	     * - `contexts`
	     * - `extra`
	     * @param event Event
	     * @returns Normalized event
	     */
	    BaseClient.prototype._normalizeEvent = function (event, depth, maxBreadth) {
	        if (!event) {
	            return null;
	        }
	        var normalized = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, event), (event.breadcrumbs && {
	            breadcrumbs: event.breadcrumbs.map(function (b) { return (tslib_1.__assign(tslib_1.__assign({}, b), (b.data && {
	                data: utils_1.normalize(b.data, depth, maxBreadth),
	            }))); }),
	        })), (event.user && {
	            user: utils_1.normalize(event.user, depth, maxBreadth),
	        })), (event.contexts && {
	            contexts: utils_1.normalize(event.contexts, depth, maxBreadth),
	        })), (event.extra && {
	            extra: utils_1.normalize(event.extra, depth, maxBreadth),
	        }));
	        // event.contexts.trace stores information about a Transaction. Similarly,
	        // event.spans[] stores information about child Spans. Given that a
	        // Transaction is conceptually a Span, normalization should apply to both
	        // Transactions and Spans consistently.
	        // For now the decision is to skip normalization of Transactions and Spans,
	        // so this block overwrites the normalized event to add back the original
	        // Transaction information prior to normalization.
	        if (event.contexts && event.contexts.trace) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            normalized.contexts.trace = event.contexts.trace;
	        }
	        normalized.sdkProcessingMetadata = tslib_1.__assign(tslib_1.__assign({}, normalized.sdkProcessingMetadata), { baseClientNormalized: true });
	        return normalized;
	    };
	    /**
	     *  Enhances event using the client configuration.
	     *  It takes care of all "static" values like environment, release and `dist`,
	     *  as well as truncating overly long values.
	     * @param event event instance to be enhanced
	     */
	    BaseClient.prototype._applyClientOptions = function (event) {
	        var options = this.getOptions();
	        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
	        if (!('environment' in event)) {
	            event.environment = 'environment' in options ? environment : 'production';
	        }
	        if (event.release === undefined && release !== undefined) {
	            event.release = release;
	        }
	        if (event.dist === undefined && dist !== undefined) {
	            event.dist = dist;
	        }
	        if (event.message) {
	            event.message = utils_1.truncate(event.message, maxValueLength);
	        }
	        var exception = event.exception && event.exception.values && event.exception.values[0];
	        if (exception && exception.value) {
	            exception.value = utils_1.truncate(exception.value, maxValueLength);
	        }
	        var request = event.request;
	        if (request && request.url) {
	            request.url = utils_1.truncate(request.url, maxValueLength);
	        }
	    };
	    /**
	     * This function adds all used integrations to the SDK info in the event.
	     * @param event The event that will be filled with all integrations.
	     */
	    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
	        var integrationsArray = Object.keys(this._integrations);
	        if (integrationsArray.length > 0) {
	            event.sdk = event.sdk || {};
	            event.sdk.integrations = tslib_1.__spread((event.sdk.integrations || []), integrationsArray);
	        }
	    };
	    /**
	     * Tells the backend to send this event
	     * @param event The Sentry event to send
	     */
	    BaseClient.prototype._sendEvent = function (event) {
	        this._getBackend().sendEvent(event);
	    };
	    /**
	     * Processes the event and logs an error in case of rejection
	     * @param event
	     * @param hint
	     * @param scope
	     */
	    BaseClient.prototype._captureEvent = function (event, hint, scope) {
	        return this._processEvent(event, hint, scope).then(function (finalEvent) {
	            return finalEvent.event_id;
	        }, function (reason) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error(reason);
	            return undefined;
	        });
	    };
	    /**
	     * Processes an event (either error or message) and sends it to Sentry.
	     *
	     * This also adds breadcrumbs and context information to the event. However,
	     * platform specific meta data (such as the User's IP address) must be added
	     * by the SDK implementor.
	     *
	     *
	     * @param event The event to send to Sentry.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
	     */
	    BaseClient.prototype._processEvent = function (event, hint, scope) {
	        var _this = this;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
	        var transport = this.getTransport();
	        function recordLostEvent(outcome, category) {
	            if (transport.recordLostEvent) {
	                transport.recordLostEvent(outcome, category);
	            }
	        }
	        if (!this._isEnabled()) {
	            return utils_1.rejectedSyncPromise(new utils_1.SentryError('SDK not enabled, will not capture event.'));
	        }
	        var isTransaction = event.type === 'transaction';
	        // 1.0 === 100% events are sent
	        // 0.0 === 0% events are sent
	        // Sampling for transaction happens somewhere else
	        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
	            recordLostEvent('sample_rate', 'event');
	            return utils_1.rejectedSyncPromise(new utils_1.SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
	        }
	        return this._prepareEvent(event, scope, hint)
	            .then(function (prepared) {
	            if (prepared === null) {
	                recordLostEvent('event_processor', event.type || 'event');
	                throw new utils_1.SentryError('An event processor returned null, will not send event.');
	            }
	            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
	            if (isInternalException || isTransaction || !beforeSend) {
	                return prepared;
	            }
	            var beforeSendResult = beforeSend(prepared, hint);
	            return _ensureBeforeSendRv(beforeSendResult);
	        })
	            .then(function (processedEvent) {
	            if (processedEvent === null) {
	                recordLostEvent('before_send', event.type || 'event');
	                throw new utils_1.SentryError('`beforeSend` returned `null`, will not send event.');
	            }
	            var session = scope && scope.getSession && scope.getSession();
	            if (!isTransaction && session) {
	                _this._updateSessionFromEvent(session, processedEvent);
	            }
	            _this._sendEvent(processedEvent);
	            return processedEvent;
	        })
	            .then(null, function (reason) {
	            if (reason instanceof utils_1.SentryError) {
	                throw reason;
	            }
	            _this.captureException(reason, {
	                data: {
	                    __sentry__: true,
	                },
	                originalException: reason,
	            });
	            throw new utils_1.SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
	        });
	    };
	    /**
	     * Occupies the client with processing and event
	     */
	    BaseClient.prototype._process = function (promise) {
	        var _this = this;
	        this._numProcessing += 1;
	        void promise.then(function (value) {
	            _this._numProcessing -= 1;
	            return value;
	        }, function (reason) {
	            _this._numProcessing -= 1;
	            return reason;
	        });
	    };
	    return BaseClient;
	}());
	exports.BaseClient = BaseClient;
	/**
	 * Verifies that return value of configured `beforeSend` is of expected type.
	 */
	function _ensureBeforeSendRv(rv) {
	    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
	    if (utils_1.isThenable(rv)) {
	        return rv.then(function (event) {
	            if (!(utils_1.isPlainObject(event) || event === null)) {
	                throw new utils_1.SentryError(nullErr);
	            }
	            return event;
	        }, function (e) {
	            throw new utils_1.SentryError("beforeSend rejected with " + e);
	        });
	    }
	    else if (!(utils_1.isPlainObject(rv) || rv === null)) {
	        throw new utils_1.SentryError(nullErr);
	    }
	    return rv;
	}
	//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var hub_1 = __webpack_require__(138);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(179);
	exports.installedIntegrations = [];
	/**
	 * @private
	 */
	function filterDuplicates(integrations) {
	    return integrations.reduce(function (acc, integrations) {
	        if (acc.every(function (accIntegration) { return integrations.name !== accIntegration.name; })) {
	            acc.push(integrations);
	        }
	        return acc;
	    }, []);
	}
	/** Gets integration to install */
	function getIntegrationsToSetup(options) {
	    var defaultIntegrations = (options.defaultIntegrations && tslib_1.__spread(options.defaultIntegrations)) || [];
	    var userIntegrations = options.integrations;
	    var integrations = tslib_1.__spread(filterDuplicates(defaultIntegrations));
	    if (Array.isArray(userIntegrations)) {
	        // Filter out integrations that are also included in user options
	        integrations = tslib_1.__spread(integrations.filter(function (integrations) {
	            return userIntegrations.every(function (userIntegration) { return userIntegration.name !== integrations.name; });
	        }), filterDuplicates(userIntegrations));
	    }
	    else if (typeof userIntegrations === 'function') {
	        integrations = userIntegrations(integrations);
	        integrations = Array.isArray(integrations) ? integrations : [integrations];
	    }
	    // Make sure that if present, `Debug` integration will always run last
	    var integrationsNames = integrations.map(function (i) { return i.name; });
	    var alwaysLastToRun = 'Debug';
	    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
	        integrations.push.apply(integrations, tslib_1.__spread(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
	    }
	    return integrations;
	}
	exports.getIntegrationsToSetup = getIntegrationsToSetup;
	/** Setup given integration */
	function setupIntegration(integration) {
	    if (exports.installedIntegrations.indexOf(integration.name) !== -1) {
	        return;
	    }
	    integration.setupOnce(hub_1.addGlobalEventProcessor, hub_1.getCurrentHub);
	    exports.installedIntegrations.push(integration.name);
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.log("Integration installed: " + integration.name);
	}
	exports.setupIntegration = setupIntegration;
	/**
	 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
	 * integrations are added unless they were already provided before.
	 * @param integrations array of integration instances
	 * @param withDefault should enable default integrations
	 */
	function setupIntegrations(options) {
	    var integrations = {};
	    getIntegrationsToSetup(options).forEach(function (integration) {
	        integrations[integration.name] = integration;
	        setupIntegration(integration);
	    });
	    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
	    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
	    // considered a member of the index the way the actual integrations are
	    utils_1.addNonEnumerableProperty(integrations, 'initialized', true);
	    return integrations;
	}
	exports.setupIntegrations = setupIntegrations;
	//# sourceMappingURL=integration.js.map

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var api_1 = __webpack_require__(177);
	var flags_1 = __webpack_require__(179);
	var request_1 = __webpack_require__(182);
	var noop_1 = __webpack_require__(183);
	/**
	 * This is the base implemention of a Backend.
	 * @hidden
	 */
	var BaseBackend = /** @class */ (function () {
	    /** Creates a new backend instance. */
	    function BaseBackend(options) {
	        this._options = options;
	        if (!this._options.dsn) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('No DSN provided, backend will not do anything.');
	        }
	        this._transport = this._setupTransport();
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromException` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromMessage` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendEvent = function (event) {
	        // TODO(v7): Remove the if-else
	        if (this._newTransport &&
	            this._options.dsn &&
	            this._options._experiments &&
	            this._options._experiments.newTransport) {
	            var api = api_1.initAPIDetails(this._options.dsn, this._options._metadata, this._options.tunnel);
	            var env = request_1.createEventEnvelope(event, api);
	            void this._newTransport.send(env).then(null, function (reason) {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Error while sending event:', reason);
	            });
	        }
	        else {
	            void this._transport.sendEvent(event).then(null, function (reason) {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Error while sending event:', reason);
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendSession = function (session) {
	        if (!this._transport.sendSession) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
	            return;
	        }
	        // TODO(v7): Remove the if-else
	        if (this._newTransport &&
	            this._options.dsn &&
	            this._options._experiments &&
	            this._options._experiments.newTransport) {
	            var api = api_1.initAPIDetails(this._options.dsn, this._options._metadata, this._options.tunnel);
	            var _a = tslib_1.__read(request_1.createSessionEnvelope(session, api), 1), env = _a[0];
	            void this._newTransport.send(env).then(null, function (reason) {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Error while sending session:', reason);
	            });
	        }
	        else {
	            void this._transport.sendSession(session).then(null, function (reason) {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Error while sending session:', reason);
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.getTransport = function () {
	        return this._transport;
	    };
	    /**
	     * Sets up the transport so it can be used later to send requests.
	     */
	    BaseBackend.prototype._setupTransport = function () {
	        return new noop_1.NoopTransport();
	    };
	    return BaseBackend;
	}());
	exports.BaseBackend = BaseBackend;
	//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var api_1 = __webpack_require__(177);
	/** Extract sdk info from from the API metadata */
	function getSdkMetadataForEnvelopeHeader(api) {
	    if (!api.metadata || !api.metadata.sdk) {
	        return;
	    }
	    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
	    return { name: name, version: version };
	}
	/**
	 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
	 * Merge with existing data if any.
	 **/
	function enhanceEventWithSdkInfo(event, sdkInfo) {
	    if (!sdkInfo) {
	        return event;
	    }
	    event.sdk = event.sdk || {};
	    event.sdk.name = event.sdk.name || sdkInfo.name;
	    event.sdk.version = event.sdk.version || sdkInfo.version;
	    event.sdk.integrations = tslib_1.__spread((event.sdk.integrations || []), (sdkInfo.integrations || []));
	    event.sdk.packages = tslib_1.__spread((event.sdk.packages || []), (sdkInfo.packages || []));
	    return event;
	}
	/** Creates an envelope from a Session */
	function createSessionEnvelope(session, api) {
	    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
	    var envelopeHeaders = tslib_1.__assign(tslib_1.__assign({ sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: utils_1.dsnToString(api.dsn) }));
	    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
	    var type = 'aggregates' in session ? 'sessions' : 'session';
	    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
	    var envelopeItem = [{ type: type }, session];
	    var envelope = utils_1.createEnvelope(envelopeHeaders, [envelopeItem]);
	    return [envelope, type];
	}
	exports.createSessionEnvelope = createSessionEnvelope;
	/** Creates a SentryRequest from a Session. */
	function sessionToSentryRequest(session, api) {
	    var _a = tslib_1.__read(createSessionEnvelope(session, api), 2), envelope = _a[0], type = _a[1];
	    return {
	        body: utils_1.serializeEnvelope(envelope),
	        type: type,
	        url: api_1.getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel),
	    };
	}
	exports.sessionToSentryRequest = sessionToSentryRequest;
	/**
	 * Create an Envelope from an event. Note that this is duplicated from below,
	 * but on purpose as this will be refactored in v7.
	 */
	function createEventEnvelope(event, api) {
	    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
	    var eventType = event.type || 'event';
	    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
	    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
	    // TODO: Below is a temporary hack in order to debug a serialization error - see
	    // https://github.com/getsentry/sentry-javascript/issues/2809,
	    // https://github.com/getsentry/sentry-javascript/pull/4425, and
	    // https://github.com/getsentry/sentry-javascript/pull/4574.
	    //
	    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
	    // throw a circular reference error.
	    //
	    // When it's time to remove it:
	    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
	    //    `sdkProcessingMetadata`
	    // 2. Restore the original version of the request body, which is commented out
	    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
	    //    baseClient tests in this package
	    enhanceEventWithSdkInfo(event, api.metadata.sdk);
	    event.tags = event.tags || {};
	    event.extra = event.extra || {};
	    // In theory, all events should be marked as having gone through normalization and so
	    // we should never set this tag/extra data
	    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
	        event.tags.skippedNormalization = true;
	        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
	    }
	    // prevent this data from being sent to sentry
	    // TODO: This is NOT part of the hack - DO NOT DELETE
	    delete event.sdkProcessingMetadata;
	    var envelopeHeaders = tslib_1.__assign(tslib_1.__assign({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: utils_1.dsnToString(api.dsn) }));
	    var eventItem = [
	        {
	            type: eventType,
	            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
	        },
	        event,
	    ];
	    return utils_1.createEnvelope(envelopeHeaders, [eventItem]);
	}
	exports.createEventEnvelope = createEventEnvelope;
	/** Creates a SentryRequest from an event. */
	function eventToSentryRequest(event, api) {
	    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
	    var eventType = event.type || 'event';
	    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
	    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
	    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
	    // TODO: Below is a temporary hack in order to debug a serialization error - see
	    // https://github.com/getsentry/sentry-javascript/issues/2809,
	    // https://github.com/getsentry/sentry-javascript/pull/4425, and
	    // https://github.com/getsentry/sentry-javascript/pull/4574.
	    //
	    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
	    // throw a circular reference error.
	    //
	    // When it's time to remove it:
	    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
	    //    `sdkProcessingMetadata`
	    // 2. Restore the original version of the request body, which is commented out
	    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
	    //    baseClient tests in this package
	    enhanceEventWithSdkInfo(event, api.metadata.sdk);
	    event.tags = event.tags || {};
	    event.extra = event.extra || {};
	    // In theory, all events should be marked as having gone through normalization and so
	    // we should never set this tag/extra data
	    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
	        event.tags.skippedNormalization = true;
	        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
	    }
	    // prevent this data from being sent to sentry
	    // TODO: This is NOT part of the hack - DO NOT DELETE
	    delete event.sdkProcessingMetadata;
	    var body;
	    try {
	        // 99.9% of events should get through just fine - no change in behavior for them
	        body = JSON.stringify(event);
	    }
	    catch (err) {
	        // Record data about the error without replacing original event data, then force renormalization
	        event.tags.JSONStringifyError = true;
	        event.extra.JSONStringifyError = err;
	        try {
	            body = JSON.stringify(utils_1.normalize(event));
	        }
	        catch (newErr) {
	            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
	            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
	            // debug with this hack, we won't ever land here.
	            var innerErr = newErr;
	            body = JSON.stringify({
	                message: 'JSON.stringify error after renormalization',
	                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
	                extra: { message: innerErr.message, stack: innerErr.stack },
	            });
	        }
	    }
	    var req = {
	        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
	        // the mystery
	        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
	        body: body,
	        type: eventType,
	        url: useEnvelope
	            ? api_1.getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel)
	            : api_1.getStoreEndpointWithUrlEncodedAuth(api.dsn),
	    };
	    // https://develop.sentry.dev/sdk/envelopes/
	    // Since we don't need to manipulate envelopes nor store them, there is no
	    // exported concept of an Envelope with operations including serialization and
	    // deserialization. Instead, we only implement a minimal subset of the spec to
	    // serialize events inline here.
	    if (useEnvelope) {
	        var envelopeHeaders = tslib_1.__assign(tslib_1.__assign({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: utils_1.dsnToString(api.dsn) }));
	        var eventItem = [
	            {
	                type: eventType,
	                sample_rates: [{ id: samplingMethod, rate: sampleRate }],
	            },
	            req.body,
	        ];
	        var envelope = utils_1.createEnvelope(envelopeHeaders, [eventItem]);
	        req.body = utils_1.serializeEnvelope(envelope);
	    }
	    return req;
	}
	exports.eventToSentryRequest = eventToSentryRequest;
	//# sourceMappingURL=request.js.map

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	/** Noop transport */
	var NoopTransport = /** @class */ (function () {
	    function NoopTransport() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.sendEvent = function (_) {
	        return utils_1.resolvedSyncPromise({
	            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
	            status: 'skipped',
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.close = function (_) {
	        return utils_1.resolvedSyncPromise(true);
	    };
	    return NoopTransport;
	}());
	exports.NoopTransport = NoopTransport;
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(138);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(179);
	/**
	 * Internal function to create a new SDK client instance. The client is
	 * installed and then bound to the current scope.
	 *
	 * @param clientClass The client class to instantiate.
	 * @param options Options to pass to the client.
	 */
	function initAndBind(clientClass, options) {
	    if (options.debug === true) {
	        if (flags_1.IS_DEBUG_BUILD) {
	            utils_1.logger.enable();
	        }
	        else {
	            // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
	            // eslint-disable-next-line no-console
	            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
	        }
	    }
	    var hub = hub_1.getCurrentHub();
	    var scope = hub.getScope();
	    if (scope) {
	        scope.update(options.initialScope);
	    }
	    var client = new clientClass(options);
	    hub.bindClient(client);
	}
	exports.initAndBind = initAndBind;
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	exports.ERROR_TRANSPORT_CATEGORY = 'error';
	exports.TRANSACTION_TRANSPORT_CATEGORY = 'transaction';
	exports.ATTACHMENT_TRANSPORT_CATEGORY = 'attachment';
	exports.SESSION_TRANSPORT_CATEGORY = 'session';
	exports.DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
	/**
	 * Creates a `NewTransport`
	 *
	 * @param options
	 * @param makeRequest
	 */
	function createTransport(options, makeRequest, buffer) {
	    if (buffer === void 0) { buffer = utils_1.makePromiseBuffer(options.bufferSize || exports.DEFAULT_TRANSPORT_BUFFER_SIZE); }
	    var rateLimits = {};
	    var flush = function (timeout) { return buffer.drain(timeout); };
	    function send(envelope) {
	        var envCategory = utils_1.getEnvelopeType(envelope);
	        var category = envCategory === 'event' ? 'error' : envCategory;
	        var request = {
	            category: category,
	            body: utils_1.serializeEnvelope(envelope),
	        };
	        // Don't add to buffer if transport is already rate-limited
	        if (utils_1.isRateLimited(rateLimits, category)) {
	            return utils_1.rejectedSyncPromise({
	                status: 'rate_limit',
	                reason: getRateLimitReason(rateLimits, category),
	            });
	        }
	        var requestTask = function () {
	            return makeRequest(request).then(function (_a) {
	                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
	                var status = utils_1.eventStatusFromHttpCode(statusCode);
	                if (headers) {
	                    rateLimits = utils_1.updateRateLimits(rateLimits, headers);
	                }
	                if (status === 'success') {
	                    return utils_1.resolvedSyncPromise({ status: status, reason: reason });
	                }
	                return utils_1.rejectedSyncPromise({
	                    status: status,
	                    reason: reason ||
	                        body ||
	                        (status === 'rate_limit' ? getRateLimitReason(rateLimits, category) : 'Unknown transport error'),
	                });
	            });
	        };
	        return buffer.add(requestTask);
	    }
	    return {
	        send: send,
	        flush: flush,
	    };
	}
	exports.createTransport = createTransport;
	function getRateLimitReason(rateLimits, category) {
	    return "Too many " + category + " requests, backing off until: " + new Date(utils_1.disabledUntil(rateLimits, category)).toISOString();
	}
	//# sourceMappingURL=base.js.map

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SDK_VERSION = '6.19.7';
	//# sourceMappingURL=version.js.map

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var functiontostring_1 = __webpack_require__(188);
	exports.FunctionToString = functiontostring_1.FunctionToString;
	var inboundfilters_1 = __webpack_require__(189);
	exports.InboundFilters = inboundfilters_1.InboundFilters;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var originalFunctionToString;
	/** Patch toString calls to return proper name for wrapped functions */
	var FunctionToString = /** @class */ (function () {
	    function FunctionToString() {
	        /**
	         * @inheritDoc
	         */
	        this.name = FunctionToString.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.prototype.setupOnce = function () {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        originalFunctionToString = Function.prototype.toString;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Function.prototype.toString = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var context = utils_1.getOriginalFunction(this) || this;
	            return originalFunctionToString.apply(context, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.id = 'FunctionToString';
	    return FunctionToString;
	}());
	exports.FunctionToString = FunctionToString;
	//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(179);
	// "Script error." is hard coded into browsers for errors that it can't read.
	// this is the result of a script being pulled in from an external domain and CORS.
	var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
	/** Inbound filters configurable by the user */
	var InboundFilters = /** @class */ (function () {
	    function InboundFilters(_options) {
	        if (_options === void 0) { _options = {}; }
	        this._options = _options;
	        /**
	         * @inheritDoc
	         */
	        this.name = InboundFilters.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event) {
	            var hub = getCurrentHub();
	            if (hub) {
	                var self_1 = hub.getIntegration(InboundFilters);
	                if (self_1) {
	                    var client = hub.getClient();
	                    var clientOptions = client ? client.getOptions() : {};
	                    var options = _mergeOptions(self_1._options, clientOptions);
	                    return _shouldDropEvent(event, options) ? null : event;
	                }
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.id = 'InboundFilters';
	    return InboundFilters;
	}());
	exports.InboundFilters = InboundFilters;
	/** JSDoc */
	function _mergeOptions(internalOptions, clientOptions) {
	    if (internalOptions === void 0) { internalOptions = {}; }
	    if (clientOptions === void 0) { clientOptions = {}; }
	    return {
	        allowUrls: tslib_1.__spread((internalOptions.whitelistUrls || []), (internalOptions.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
	        denyUrls: tslib_1.__spread((internalOptions.blacklistUrls || []), (internalOptions.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
	        ignoreErrors: tslib_1.__spread((internalOptions.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
	        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
	    };
	}
	exports._mergeOptions = _mergeOptions;
	/** JSDoc */
	function _shouldDropEvent(event, options) {
	    if (options.ignoreInternal && _isSentryError(event)) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + utils_1.getEventDescription(event));
	        return true;
	    }
	    if (_isIgnoredError(event, options.ignoreErrors)) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + utils_1.getEventDescription(event));
	        return true;
	    }
	    if (_isDeniedUrl(event, options.denyUrls)) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + _getEventFilterUrl(event));
	        return true;
	    }
	    if (!_isAllowedUrl(event, options.allowUrls)) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + _getEventFilterUrl(event));
	        return true;
	    }
	    return false;
	}
	exports._shouldDropEvent = _shouldDropEvent;
	function _isIgnoredError(event, ignoreErrors) {
	    if (!ignoreErrors || !ignoreErrors.length) {
	        return false;
	    }
	    return _getPossibleEventMessages(event).some(function (message) {
	        return ignoreErrors.some(function (pattern) { return utils_1.isMatchingPattern(message, pattern); });
	    });
	}
	function _isDeniedUrl(event, denyUrls) {
	    // TODO: Use Glob instead?
	    if (!denyUrls || !denyUrls.length) {
	        return false;
	    }
	    var url = _getEventFilterUrl(event);
	    return !url ? false : denyUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	}
	function _isAllowedUrl(event, allowUrls) {
	    // TODO: Use Glob instead?
	    if (!allowUrls || !allowUrls.length) {
	        return true;
	    }
	    var url = _getEventFilterUrl(event);
	    return !url ? true : allowUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	}
	function _getPossibleEventMessages(event) {
	    if (event.message) {
	        return [event.message];
	    }
	    if (event.exception) {
	        try {
	            var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
	            return ["" + value, type + ": " + value];
	        }
	        catch (oO) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error("Cannot extract message for event " + utils_1.getEventDescription(event));
	            return [];
	        }
	    }
	    return [];
	}
	function _isSentryError(event) {
	    try {
	        // @ts-ignore can't be a sentry error if undefined
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        return event.exception.values[0].type === 'SentryError';
	    }
	    catch (e) {
	        // ignore
	    }
	    return false;
	}
	function _getLastValidUrl(frames) {
	    if (frames === void 0) { frames = []; }
	    for (var i = frames.length - 1; i >= 0; i--) {
	        var frame = frames[i];
	        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
	            return frame.filename || null;
	        }
	    }
	    return null;
	}
	function _getEventFilterUrl(event) {
	    try {
	        if (event.stacktrace) {
	            return _getLastValidUrl(event.stacktrace.frames);
	        }
	        var frames_1;
	        try {
	            // @ts-ignore we only care about frames if the whole thing here is defined
	            frames_1 = event.exception.values[0].stacktrace.frames;
	        }
	        catch (e) {
	            // ignore
	        }
	        return frames_1 ? _getLastValidUrl(frames_1) : null;
	    }
	    catch (oO) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.error("Cannot extract url for event " + utils_1.getEventDescription(event));
	        return null;
	    }
	}
	//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(140);
	var backend_1 = __webpack_require__(191);
	var flags_1 = __webpack_require__(196);
	var helpers_1 = __webpack_require__(202);
	var integrations_1 = __webpack_require__(203);
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * @see BrowserOptions for documentation on configuration options.
	 * @see SentryClient for usage documentation.
	 */
	var BrowserClient = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserClient, _super);
	    /**
	     * Creates a new Browser SDK instance.
	     *
	     * @param options Configuration options for this SDK.
	     */
	    function BrowserClient(options) {
	        if (options === void 0) { options = {}; }
	        var _this = this;
	        options._metadata = options._metadata || {};
	        options._metadata.sdk = options._metadata.sdk || {
	            name: 'sentry.javascript.browser',
	            packages: [
	                {
	                    name: 'npm:@sentry/browser',
	                    version: core_1.SDK_VERSION,
	                },
	            ],
	            version: core_1.SDK_VERSION,
	        };
	        _this = _super.call(this, backend_1.BrowserBackend, options) || this;
	        return _this;
	    }
	    /**
	     * Show a report dialog to the user to send feedback to a specific event.
	     *
	     * @param options Set individual options for the dialog
	     */
	    BrowserClient.prototype.showReportDialog = function (options) {
	        if (options === void 0) { options = {}; }
	        // doesn't work without a document (React Native)
	        var document = utils_1.getGlobalObject().document;
	        if (!document) {
	            return;
	        }
	        if (!this._isEnabled()) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Trying to call showReportDialog with Sentry Client disabled');
	            return;
	        }
	        helpers_1.injectReportDialog(tslib_1.__assign(tslib_1.__assign({}, options), { dsn: options.dsn || this.getDsn() }));
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
	        event.platform = event.platform || 'javascript';
	        return _super.prototype._prepareEvent.call(this, event, scope, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._sendEvent = function (event) {
	        var integration = this.getIntegration(integrations_1.Breadcrumbs);
	        if (integration) {
	            integration.addSentryBreadcrumb(event);
	        }
	        _super.prototype._sendEvent.call(this, event);
	    };
	    return BrowserClient;
	}(core_1.BaseClient));
	exports.BrowserClient = BrowserClient;
	//# sourceMappingURL=client.js.map

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(136);
	var types_1 = __webpack_require__(134);
	var utils_1 = __webpack_require__(140);
	var eventbuilder_1 = __webpack_require__(192);
	var transports_1 = __webpack_require__(194);
	/**
	 * The Sentry Browser SDK Backend.
	 * @hidden
	 */
	var BrowserBackend = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserBackend, _super);
	    function BrowserBackend() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromException = function (exception, hint) {
	        return eventbuilder_1.eventFromException(exception, hint, this._options.attachStacktrace);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
	        if (level === void 0) { level = types_1.Severity.Info; }
	        return eventbuilder_1.eventFromMessage(message, level, hint, this._options.attachStacktrace);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype._setupTransport = function () {
	        if (!this._options.dsn) {
	            // We return the noop transport here in case there is no Dsn.
	            return _super.prototype._setupTransport.call(this);
	        }
	        var transportOptions = tslib_1.__assign(tslib_1.__assign({}, this._options.transportOptions), { dsn: this._options.dsn, tunnel: this._options.tunnel, sendClientReports: this._options.sendClientReports, _metadata: this._options._metadata });
	        var api = core_1.initAPIDetails(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
	        var url = core_1.getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel);
	        if (this._options.transport) {
	            return new this._options.transport(transportOptions);
	        }
	        if (utils_1.supportsFetch()) {
	            var requestOptions = tslib_1.__assign({}, transportOptions.fetchParameters);
	            this._newTransport = transports_1.makeNewFetchTransport({ requestOptions: requestOptions, url: url });
	            return new transports_1.FetchTransport(transportOptions);
	        }
	        this._newTransport = transports_1.makeNewXHRTransport({
	            url: url,
	            headers: transportOptions.headers,
	        });
	        return new transports_1.XHRTransport(transportOptions);
	    };
	    return BrowserBackend;
	}(core_1.BaseBackend));
	exports.BrowserBackend = BrowserBackend;
	//# sourceMappingURL=backend.js.map

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var types_1 = __webpack_require__(134);
	var utils_1 = __webpack_require__(140);
	var stack_parsers_1 = __webpack_require__(193);
	/**
	 * This function creates an exception from an TraceKitStackTrace
	 * @param stacktrace TraceKitStackTrace that will be converted to an exception
	 * @hidden
	 */
	function exceptionFromError(ex) {
	    // Get the frames first since Opera can lose the stack if we touch anything else first
	    var frames = parseStackFrames(ex);
	    var exception = {
	        type: ex && ex.name,
	        value: extractMessage(ex),
	    };
	    if (frames.length) {
	        exception.stacktrace = { frames: frames };
	    }
	    if (exception.type === undefined && exception.value === '') {
	        exception.value = 'Unrecoverable error caught';
	    }
	    return exception;
	}
	exports.exceptionFromError = exceptionFromError;
	/**
	 * @hidden
	 */
	function eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
	    var event = {
	        exception: {
	            values: [
	                {
	                    type: utils_1.isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
	                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + utils_1.extractExceptionKeysForMessage(exception),
	                },
	            ],
	        },
	        extra: {
	            __serialized__: utils_1.normalizeToSize(exception),
	        },
	    };
	    if (syntheticException) {
	        var frames_1 = parseStackFrames(syntheticException);
	        if (frames_1.length) {
	            event.stacktrace = { frames: frames_1 };
	        }
	    }
	    return event;
	}
	exports.eventFromPlainObject = eventFromPlainObject;
	/**
	 * @hidden
	 */
	function eventFromError(ex) {
	    return {
	        exception: {
	            values: [exceptionFromError(ex)],
	        },
	    };
	}
	exports.eventFromError = eventFromError;
	/** Parses stack frames from an error */
	function parseStackFrames(ex) {
	    // Access and store the stacktrace property before doing ANYTHING
	    // else to it because Opera is not very good at providing it
	    // reliably in other circumstances.
	    var stacktrace = ex.stacktrace || ex.stack || '';
	    var popSize = getPopSize(ex);
	    try {
	        return utils_1.createStackParser(stack_parsers_1.opera10StackParser, stack_parsers_1.opera11StackParser, stack_parsers_1.chromeStackParser, stack_parsers_1.winjsStackParser, stack_parsers_1.geckoStackParser)(stacktrace, popSize);
	    }
	    catch (e) {
	        // no-empty
	    }
	    return [];
	}
	exports.parseStackFrames = parseStackFrames;
	// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
	var reactMinifiedRegexp = /Minified React error #\d+;/i;
	function getPopSize(ex) {
	    if (ex) {
	        if (typeof ex.framesToPop === 'number') {
	            return ex.framesToPop;
	        }
	        if (reactMinifiedRegexp.test(ex.message)) {
	            return 1;
	        }
	    }
	    return 0;
	}
	/**
	 * There are cases where stacktrace.message is an Event object
	 * https://github.com/getsentry/sentry-javascript/issues/1949
	 * In this specific case we try to extract stacktrace.message.error.message
	 */
	function extractMessage(ex) {
	    var message = ex && ex.message;
	    if (!message) {
	        return 'No error message';
	    }
	    if (message.error && typeof message.error.message === 'string') {
	        return message.error.message;
	    }
	    return message;
	}
	/**
	 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
	 * @hidden
	 */
	function eventFromException(exception, hint, attachStacktrace) {
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromUnknownInput(exception, syntheticException, attachStacktrace);
	    utils_1.addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
	    event.level = types_1.Severity.Error;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.resolvedSyncPromise(event);
	}
	exports.eventFromException = eventFromException;
	/**
	 * Builds and Event from a Message
	 * @hidden
	 */
	function eventFromMessage(message, level, hint, attachStacktrace) {
	    if (level === void 0) { level = types_1.Severity.Info; }
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromString(message, syntheticException, attachStacktrace);
	    event.level = level;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.resolvedSyncPromise(event);
	}
	exports.eventFromMessage = eventFromMessage;
	/**
	 * @hidden
	 */
	function eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
	    var event;
	    if (utils_1.isErrorEvent(exception) && exception.error) {
	        // If it is an ErrorEvent with `error` property, extract it to get actual Error
	        var errorEvent = exception;
	        return eventFromError(errorEvent.error);
	    }
	    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
	    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
	    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
	    //
	    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
	    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
	    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
	    if (utils_1.isDOMError(exception) || utils_1.isDOMException(exception)) {
	        var domException = exception;
	        if ('stack' in exception) {
	            event = eventFromError(exception);
	        }
	        else {
	            var name_1 = domException.name || (utils_1.isDOMError(domException) ? 'DOMError' : 'DOMException');
	            var message = domException.message ? name_1 + ": " + domException.message : name_1;
	            event = eventFromString(message, syntheticException, attachStacktrace);
	            utils_1.addExceptionTypeValue(event, message);
	        }
	        if ('code' in domException) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, event.tags), { 'DOMException.code': "" + domException.code });
	        }
	        return event;
	    }
	    if (utils_1.isError(exception)) {
	        // we have a real Error object, do nothing
	        return eventFromError(exception);
	    }
	    if (utils_1.isPlainObject(exception) || utils_1.isEvent(exception)) {
	        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
	        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
	        // group on any key/value change.
	        var objectException = exception;
	        event = eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
	        utils_1.addExceptionMechanism(event, {
	            synthetic: true,
	        });
	        return event;
	    }
	    // If none of previous checks were valid, then it means that it's not:
	    // - an instance of DOMError
	    // - an instance of DOMException
	    // - an instance of Event
	    // - an instance of Error
	    // - a valid ErrorEvent (one with an error property)
	    // - a plain Object
	    //
	    // So bail out and capture it as a simple message:
	    event = eventFromString(exception, syntheticException, attachStacktrace);
	    utils_1.addExceptionTypeValue(event, "" + exception, undefined);
	    utils_1.addExceptionMechanism(event, {
	        synthetic: true,
	    });
	    return event;
	}
	exports.eventFromUnknownInput = eventFromUnknownInput;
	/**
	 * @hidden
	 */
	function eventFromString(input, syntheticException, attachStacktrace) {
	    var event = {
	        message: input,
	    };
	    if (attachStacktrace && syntheticException) {
	        var frames_2 = parseStackFrames(syntheticException);
	        if (frames_2.length) {
	            event.stacktrace = { frames: frames_2 };
	        }
	    }
	    return event;
	}
	exports.eventFromString = eventFromString;
	//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	// global reference to slice
	var UNKNOWN_FUNCTION = '?';
	var OPERA10_PRIORITY = 10;
	var OPERA11_PRIORITY = 20;
	var CHROME_PRIORITY = 30;
	var WINJS_PRIORITY = 40;
	var GECKO_PRIORITY = 50;
	function createFrame(filename, func, lineno, colno) {
	    var frame = {
	        filename: filename,
	        function: func,
	        // All browser frames are considered in_app
	        in_app: true,
	    };
	    if (lineno !== undefined) {
	        frame.lineno = lineno;
	    }
	    if (colno !== undefined) {
	        frame.colno = colno;
	    }
	    return frame;
	}
	// Chromium based browsers: Chrome, Brave, new Opera, new Edge
	var chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	var chrome = function (line) {
	    var parts = chromeRegex.exec(line);
	    if (parts) {
	        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	        if (isEval) {
	            var subMatch = chromeEvalRegex.exec(parts[2]);
	            if (subMatch) {
	                // throw out eval line/column and use top-most line/column number
	                parts[2] = subMatch[1]; // url
	                parts[3] = subMatch[2]; // line
	                parts[4] = subMatch[3]; // column
	            }
	        }
	        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
	        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
	        var _a = tslib_1.__read(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
	        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
	    }
	    return;
	};
	exports.chromeStackParser = [CHROME_PRIORITY, chrome];
	// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
	// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
	// We need this specific case for now because we want no other regex to match.
	var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
	var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	var gecko = function (line) {
	    var _a;
	    var parts = geckoREgex.exec(line);
	    if (parts) {
	        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	        if (isEval) {
	            var subMatch = geckoEvalRegex.exec(parts[3]);
	            if (subMatch) {
	                // throw out eval line/column and use top-most line number
	                parts[1] = parts[1] || 'eval';
	                parts[3] = subMatch[1];
	                parts[4] = subMatch[2];
	                parts[5] = ''; // no column when eval
	            }
	        }
	        var filename = parts[3];
	        var func = parts[1] || UNKNOWN_FUNCTION;
	        _a = tslib_1.__read(extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
	        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
	    }
	    return;
	};
	exports.geckoStackParser = [GECKO_PRIORITY, gecko];
	var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	var winjs = function (line) {
	    var parts = winjsRegex.exec(line);
	    return parts
	        ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
	        : undefined;
	};
	exports.winjsStackParser = [WINJS_PRIORITY, winjs];
	var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
	var opera10 = function (line) {
	    var parts = opera10Regex.exec(line);
	    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
	};
	exports.opera10StackParser = [OPERA10_PRIORITY, opera10];
	var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
	var opera11 = function (line) {
	    var parts = opera11Regex.exec(line);
	    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
	};
	exports.opera11StackParser = [OPERA11_PRIORITY, opera11];
	/**
	 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
	 * What it means, is that instead of format like:
	 *
	 * Error: wat
	 *   at function@url:row:col
	 *   at function@url:row:col
	 *   at function@url:row:col
	 *
	 * it produces something like:
	 *
	 *   function@url:row:col
	 *   function@url:row:col
	 *   function@url:row:col
	 *
	 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
	 * This function is extracted so that we can use it in both places without duplicating the logic.
	 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
	 * and fix this case seems like an impossible, or at least way too time-consuming task.
	 */
	var extractSafariExtensionDetails = function (func, filename) {
	    var isSafariExtension = func.indexOf('safari-extension') !== -1;
	    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
	    return isSafariExtension || isSafariWebExtension
	        ? [
	            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
	            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename,
	        ]
	        : [func, filename];
	};
	//# sourceMappingURL=stack-parsers.js.map

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var base_1 = __webpack_require__(195);
	exports.BaseTransport = base_1.BaseTransport;
	var fetch_1 = __webpack_require__(198);
	exports.FetchTransport = fetch_1.FetchTransport;
	var xhr_1 = __webpack_require__(199);
	exports.XHRTransport = xhr_1.XHRTransport;
	var new_fetch_1 = __webpack_require__(200);
	exports.makeNewFetchTransport = new_fetch_1.makeNewFetchTransport;
	var new_xhr_1 = __webpack_require__(201);
	exports.makeNewXHRTransport = new_xhr_1.makeNewXHRTransport;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(196);
	var utils_2 = __webpack_require__(197);
	function requestTypeToCategory(ty) {
	    var tyStr = ty;
	    return tyStr === 'event' ? 'error' : tyStr;
	}
	var global = utils_1.getGlobalObject();
	/** Base Transport class implementation */
	var BaseTransport = /** @class */ (function () {
	    function BaseTransport(options) {
	        var _this = this;
	        this.options = options;
	        /** A simple buffer holding all requests. */
	        this._buffer = utils_1.makePromiseBuffer(30);
	        /** Locks transport after receiving rate limits in a response */
	        this._rateLimits = {};
	        this._outcomes = {};
	        this._api = core_1.initAPIDetails(options.dsn, options._metadata, options.tunnel);
	        // eslint-disable-next-line deprecation/deprecation
	        this.url = core_1.getStoreEndpointWithUrlEncodedAuth(this._api.dsn);
	        if (this.options.sendClientReports && global.document) {
	            global.document.addEventListener('visibilitychange', function () {
	                if (global.document.visibilityState === 'hidden') {
	                    _this._flushOutcomes();
	                }
	            });
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.close = function (timeout) {
	        return this._buffer.drain(timeout);
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.recordLostEvent = function (reason, category) {
	        var _a;
	        if (!this.options.sendClientReports) {
	            return;
	        }
	        // We want to track each category (event, transaction, session) separately
	        // but still keep the distinction between different type of outcomes.
	        // We could use nested maps, but it's much easier to read and type this way.
	        // A correct type for map-based implementation if we want to go that route
	        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
	        var key = requestTypeToCategory(category) + ":" + reason;
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("Adding outcome: " + key);
	        this._outcomes[key] = (_a = this._outcomes[key], (_a !== null && _a !== void 0 ? _a : 0)) + 1;
	    };
	    /**
	     * Send outcomes as an envelope
	     */
	    BaseTransport.prototype._flushOutcomes = function () {
	        if (!this.options.sendClientReports) {
	            return;
	        }
	        var outcomes = this._outcomes;
	        this._outcomes = {};
	        // Nothing to send
	        if (!Object.keys(outcomes).length) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('No outcomes to flush');
	            return;
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
	        var url = core_1.getEnvelopeEndpointWithUrlEncodedAuth(this._api.dsn, this._api.tunnel);
	        var discardedEvents = Object.keys(outcomes).map(function (key) {
	            var _a = tslib_1.__read(key.split(':'), 2), category = _a[0], reason = _a[1];
	            return {
	                reason: reason,
	                category: category,
	                quantity: outcomes[key],
	            };
	            // TODO: Improve types on discarded_events to get rid of cast
	        });
	        var envelope = utils_1.createClientReportEnvelope(discardedEvents, this._api.tunnel && utils_1.dsnToString(this._api.dsn));
	        try {
	            utils_2.sendReport(url, utils_1.serializeEnvelope(envelope));
	        }
	        catch (e) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error(e);
	        }
	    };
	    /**
	     * Handle Sentry repsonse for promise-based transports.
	     */
	    BaseTransport.prototype._handleResponse = function (_a) {
	        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
	        var status = utils_1.eventStatusFromHttpCode(response.status);
	        this._rateLimits = utils_1.updateRateLimits(this._rateLimits, headers);
	        // eslint-disable-next-line deprecation/deprecation
	        if (this._isRateLimited(requestType)) {
	            flags_1.IS_DEBUG_BUILD &&
	                // eslint-disable-next-line deprecation/deprecation
	                utils_1.logger.warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
	        }
	        if (status === 'success') {
	            resolve({ status: status });
	            return;
	        }
	        reject(response);
	    };
	    /**
	     * Gets the time that given category is disabled until for rate limiting
	     *
	     * @deprecated Please use `disabledUntil` from @sentry/utils
	     */
	    BaseTransport.prototype._disabledUntil = function (requestType) {
	        var category = requestTypeToCategory(requestType);
	        return new Date(utils_1.disabledUntil(this._rateLimits, category));
	    };
	    /**
	     * Checks if a category is rate limited
	     *
	     * @deprecated Please use `isRateLimited` from @sentry/utils
	     */
	    BaseTransport.prototype._isRateLimited = function (requestType) {
	        var category = requestTypeToCategory(requestType);
	        return utils_1.isRateLimited(this._rateLimits, category);
	    };
	    return BaseTransport;
	}());
	exports.BaseTransport = BaseTransport;
	//# sourceMappingURL=base.js.map

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(196);
	var global = utils_1.getGlobalObject();
	var cachedFetchImpl;
	/**
	 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
	 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
	 * this chain becomes orphaned and there is no possible way to capture it's rejections
	 * other than allowing it bubble up to this very handler. eg.
	 *
	 * const f = window.fetch;
	 * window.fetch = function () {
	 *   const p = f.apply(this, arguments);
	 *
	 *   p.then(function() {
	 *     console.log('hi.');
	 *   });
	 *
	 *   return p;
	 * }
	 *
	 * `p.then(function () { ... })` is producing a completely separate promise chain,
	 * however, what's returned is `p` - the result of original `fetch` call.
	 *
	 * This mean, that whenever we use the Fetch API to send our own requests, _and_
	 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
	 * effectively causing another event to be captured.
	 * This makes a whole process become an infinite loop, which we need to somehow
	 * deal with, and break it in one way or another.
	 *
	 * To deal with this issue, we are making sure that we _always_ use the real
	 * browser Fetch API, instead of relying on what `window.fetch` exposes.
	 * The only downside to this would be missing our own requests as breadcrumbs,
	 * but because we are already not doing this, it should be just fine.
	 *
	 * Possible failed fetch error messages per-browser:
	 *
	 * Chrome:  Failed to fetch
	 * Edge:    Failed to Fetch
	 * Firefox: NetworkError when attempting to fetch resource
	 * Safari:  resource blocked by content blocker
	 */
	function getNativeFetchImplementation() {
	    if (cachedFetchImpl) {
	        return cachedFetchImpl;
	    }
	    /* eslint-disable @typescript-eslint/unbound-method */
	    // Fast path to avoid DOM I/O
	    if (utils_1.isNativeFetch(global.fetch)) {
	        return (cachedFetchImpl = global.fetch.bind(global));
	    }
	    var document = global.document;
	    var fetchImpl = global.fetch;
	    // eslint-disable-next-line deprecation/deprecation
	    if (document && typeof document.createElement === 'function') {
	        try {
	            var sandbox = document.createElement('iframe');
	            sandbox.hidden = true;
	            document.head.appendChild(sandbox);
	            var contentWindow = sandbox.contentWindow;
	            if (contentWindow && contentWindow.fetch) {
	                fetchImpl = contentWindow.fetch;
	            }
	            document.head.removeChild(sandbox);
	        }
	        catch (e) {
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
	        }
	    }
	    return (cachedFetchImpl = fetchImpl.bind(global));
	    /* eslint-enable @typescript-eslint/unbound-method */
	}
	exports.getNativeFetchImplementation = getNativeFetchImplementation;
	/**
	 * Sends sdk client report using sendBeacon or fetch as a fallback if available
	 *
	 * @param url report endpoint
	 * @param body report payload
	 */
	function sendReport(url, body) {
	    var isRealNavigator = Object.prototype.toString.call(global && global.navigator) === '[object Navigator]';
	    var hasSendBeacon = isRealNavigator && typeof global.navigator.sendBeacon === 'function';
	    if (hasSendBeacon) {
	        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
	        var sendBeacon = global.navigator.sendBeacon.bind(global.navigator);
	        return sendBeacon(url, body);
	    }
	    if (utils_1.supportsFetch()) {
	        var fetch_1 = getNativeFetchImplementation();
	        return utils_1.forget(fetch_1(url, {
	            body: body,
	            method: 'POST',
	            credentials: 'omit',
	            keepalive: true,
	        }));
	    }
	}
	exports.sendReport = sendReport;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var base_1 = __webpack_require__(195);
	var utils_2 = __webpack_require__(197);
	/** `fetch` based transport */
	var FetchTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(FetchTransport, _super);
	    function FetchTransport(options, fetchImpl) {
	        if (fetchImpl === void 0) { fetchImpl = utils_2.getNativeFetchImplementation(); }
	        var _this = _super.call(this, options) || this;
	        _this._fetch = fetchImpl;
	        return _this;
	    }
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        // eslint-disable-next-line deprecation/deprecation
	        if (this._isRateLimited(sentryRequest.type)) {
	            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                // eslint-disable-next-line deprecation/deprecation
	                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        var options = {
	            body: sentryRequest.body,
	            method: 'POST',
	            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
	            // (see https://caniuse.com/#feat=referrer-policy),
	            // it doesn't. And it throws an exception instead of ignoring this parameter...
	            // REF: https://github.com/getsentry/raven-js/issues/1233
	            referrerPolicy: (utils_1.supportsReferrerPolicy() ? 'origin' : ''),
	        };
	        if (this.options.fetchParameters !== undefined) {
	            Object.assign(options, this.options.fetchParameters);
	        }
	        if (this.options.headers !== undefined) {
	            options.headers = this.options.headers;
	        }
	        return this._buffer
	            .add(function () {
	            return new utils_1.SyncPromise(function (resolve, reject) {
	                void _this._fetch(sentryRequest.url, options)
	                    .then(function (response) {
	                    var headers = {
	                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
	                        'retry-after': response.headers.get('Retry-After'),
	                    };
	                    _this._handleResponse({
	                        requestType: sentryRequest.type,
	                        response: response,
	                        headers: headers,
	                        resolve: resolve,
	                        reject: reject,
	                    });
	                })
	                    .catch(reject);
	            });
	        })
	            .then(undefined, function (reason) {
	            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
	            if (reason instanceof utils_1.SentryError) {
	                _this.recordLostEvent('queue_overflow', sentryRequest.type);
	            }
	            else {
	                _this.recordLostEvent('network_error', sentryRequest.type);
	            }
	            throw reason;
	        });
	    };
	    return FetchTransport;
	}(base_1.BaseTransport));
	exports.FetchTransport = FetchTransport;
	//# sourceMappingURL=fetch.js.map

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var base_1 = __webpack_require__(195);
	/** `XHR` based transport */
	var XHRTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(XHRTransport, _super);
	    function XHRTransport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        // eslint-disable-next-line deprecation/deprecation
	        if (this._isRateLimited(sentryRequest.type)) {
	            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                // eslint-disable-next-line deprecation/deprecation
	                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        return this._buffer
	            .add(function () {
	            return new utils_1.SyncPromise(function (resolve, reject) {
	                var request = new XMLHttpRequest();
	                request.onreadystatechange = function () {
	                    if (request.readyState === 4) {
	                        var headers = {
	                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
	                            'retry-after': request.getResponseHeader('Retry-After'),
	                        };
	                        _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
	                    }
	                };
	                request.open('POST', sentryRequest.url);
	                for (var header in _this.options.headers) {
	                    if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) {
	                        request.setRequestHeader(header, _this.options.headers[header]);
	                    }
	                }
	                request.send(sentryRequest.body);
	            });
	        })
	            .then(undefined, function (reason) {
	            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
	            if (reason instanceof utils_1.SentryError) {
	                _this.recordLostEvent('queue_overflow', sentryRequest.type);
	            }
	            else {
	                _this.recordLostEvent('network_error', sentryRequest.type);
	            }
	            throw reason;
	        });
	    };
	    return XHRTransport;
	}(base_1.BaseTransport));
	exports.XHRTransport = XHRTransport;
	//# sourceMappingURL=xhr.js.map

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(197);
	/**
	 * Creates a Transport that uses the Fetch API to send events to Sentry.
	 */
	function makeNewFetchTransport(options, nativeFetch) {
	    if (nativeFetch === void 0) { nativeFetch = utils_1.getNativeFetchImplementation(); }
	    function makeRequest(request) {
	        var requestOptions = tslib_1.__assign({ body: request.body, method: 'POST', referrerPolicy: 'origin' }, options.requestOptions);
	        return nativeFetch(options.url, requestOptions).then(function (response) {
	            return response.text().then(function (body) { return ({
	                body: body,
	                headers: {
	                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
	                    'retry-after': response.headers.get('Retry-After'),
	                },
	                reason: response.statusText,
	                statusCode: response.status,
	            }); });
	        });
	    }
	    return core_1.createTransport({ bufferSize: options.bufferSize }, makeRequest);
	}
	exports.makeNewFetchTransport = makeNewFetchTransport;
	//# sourceMappingURL=new-fetch.js.map

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(140);
	/**
	 * The DONE ready state for XmlHttpRequest
	 *
	 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
	 * (e.g. during testing, it is `undefined`)
	 *
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
	 */
	var XHR_READYSTATE_DONE = 4;
	/**
	 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
	 */
	function makeNewXHRTransport(options) {
	    function makeRequest(request) {
	        return new utils_1.SyncPromise(function (resolve, _reject) {
	            var xhr = new XMLHttpRequest();
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === XHR_READYSTATE_DONE) {
	                    var response = {
	                        body: xhr.response,
	                        headers: {
	                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
	                            'retry-after': xhr.getResponseHeader('Retry-After'),
	                        },
	                        reason: xhr.statusText,
	                        statusCode: xhr.status,
	                    };
	                    resolve(response);
	                }
	            };
	            xhr.open('POST', options.url);
	            for (var header in options.headers) {
	                if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
	                    xhr.setRequestHeader(header, options.headers[header]);
	                }
	            }
	            xhr.send(request.body);
	        });
	    }
	    return core_1.createTransport({ bufferSize: options.bufferSize }, makeRequest);
	}
	exports.makeNewXHRTransport = makeNewXHRTransport;
	//# sourceMappingURL=new-xhr.js.map

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(196);
	var global = utils_1.getGlobalObject();
	var ignoreOnError = 0;
	/**
	 * @hidden
	 */
	function shouldIgnoreOnError() {
	    return ignoreOnError > 0;
	}
	exports.shouldIgnoreOnError = shouldIgnoreOnError;
	/**
	 * @hidden
	 */
	function ignoreNextOnError() {
	    // onerror should trigger before setTimeout
	    ignoreOnError += 1;
	    setTimeout(function () {
	        ignoreOnError -= 1;
	    });
	}
	exports.ignoreNextOnError = ignoreNextOnError;
	/**
	 * Instruments the given function and sends an event to Sentry every time the
	 * function throws an exception.
	 *
	 * @param fn A function to wrap.
	 * @returns The wrapped function.
	 * @hidden
	 */
	function wrap(fn, options, before) {
	    // for future readers what this does is wrap a function and then create
	    // a bi-directional wrapping between them.
	    //
	    // example: wrapped = wrap(original);
	    //  original.__sentry_wrapped__ -> wrapped
	    //  wrapped.__sentry_original__ -> original
	    if (options === void 0) { options = {}; }
	    if (typeof fn !== 'function') {
	        return fn;
	    }
	    try {
	        // if we're dealing with a function that was previously wrapped, return
	        // the original wrapper.
	        var wrapper = fn.__sentry_wrapped__;
	        if (wrapper) {
	            return wrapper;
	        }
	        // We don't wanna wrap it twice
	        if (utils_1.getOriginalFunction(fn)) {
	            return fn;
	        }
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return fn;
	    }
	    /* eslint-disable prefer-rest-params */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var sentryWrapped = function () {
	        var args = Array.prototype.slice.call(arguments);
	        try {
	            if (before && typeof before === 'function') {
	                before.apply(this, arguments);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
	            // Attempt to invoke user-land function
	            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	            //       means the sentry.javascript SDK caught an error invoking your application code. This
	            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	            return fn.apply(this, wrappedArguments);
	        }
	        catch (ex) {
	            ignoreNextOnError();
	            core_1.withScope(function (scope) {
	                scope.addEventProcessor(function (event) {
	                    if (options.mechanism) {
	                        utils_1.addExceptionTypeValue(event, undefined, undefined);
	                        utils_1.addExceptionMechanism(event, options.mechanism);
	                    }
	                    event.extra = tslib_1.__assign(tslib_1.__assign({}, event.extra), { arguments: args });
	                    return event;
	                });
	                core_1.captureException(ex);
	            });
	            throw ex;
	        }
	    };
	    /* eslint-enable prefer-rest-params */
	    // Accessing some objects may throw
	    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
	    try {
	        for (var property in fn) {
	            if (Object.prototype.hasOwnProperty.call(fn, property)) {
	                sentryWrapped[property] = fn[property];
	            }
	        }
	    }
	    catch (_oO) { } // eslint-disable-line no-empty
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    utils_1.markFunctionWrapped(sentryWrapped, fn);
	    utils_1.addNonEnumerableProperty(fn, '__sentry_wrapped__', sentryWrapped);
	    // Restore original function name (not all browsers allow that)
	    try {
	        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
	        if (descriptor.configurable) {
	            Object.defineProperty(sentryWrapped, 'name', {
	                get: function () {
	                    return fn.name;
	                },
	            });
	        }
	        // eslint-disable-next-line no-empty
	    }
	    catch (_oO) { }
	    return sentryWrapped;
	}
	exports.wrap = wrap;
	/**
	 * Injects the Report Dialog script
	 * @hidden
	 */
	function injectReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    if (!global.document) {
	        return;
	    }
	    if (!options.eventId) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Missing eventId option in showReportDialog call');
	        return;
	    }
	    if (!options.dsn) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Missing dsn option in showReportDialog call');
	        return;
	    }
	    var script = global.document.createElement('script');
	    script.async = true;
	    script.src = core_1.getReportDialogEndpoint(options.dsn, options);
	    if (options.onLoad) {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        script.onload = options.onLoad;
	    }
	    var injectionPoint = global.document.head || global.document.body;
	    if (injectionPoint) {
	        injectionPoint.appendChild(script);
	    }
	}
	exports.injectReportDialog = injectReportDialog;
	//# sourceMappingURL=helpers.js.map

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var globalhandlers_1 = __webpack_require__(204);
	exports.GlobalHandlers = globalhandlers_1.GlobalHandlers;
	var trycatch_1 = __webpack_require__(205);
	exports.TryCatch = trycatch_1.TryCatch;
	var breadcrumbs_1 = __webpack_require__(206);
	exports.Breadcrumbs = breadcrumbs_1.Breadcrumbs;
	var linkederrors_1 = __webpack_require__(207);
	exports.LinkedErrors = linkederrors_1.LinkedErrors;
	var useragent_1 = __webpack_require__(208);
	exports.UserAgent = useragent_1.UserAgent;
	var dedupe_1 = __webpack_require__(209);
	exports.Dedupe = dedupe_1.Dedupe;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	var core_1 = __webpack_require__(136);
	var types_1 = __webpack_require__(134);
	var utils_1 = __webpack_require__(140);
	var eventbuilder_1 = __webpack_require__(192);
	var flags_1 = __webpack_require__(196);
	var helpers_1 = __webpack_require__(202);
	/** Global handlers */
	var GlobalHandlers = /** @class */ (function () {
	    /** JSDoc */
	    function GlobalHandlers(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = GlobalHandlers.id;
	        /**
	         * Stores references functions to installing handlers. Will set to undefined
	         * after they have been run so that they are not used twice.
	         */
	        this._installFunc = {
	            onerror: _installGlobalOnErrorHandler,
	            onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
	        };
	        this._options = tslib_1.__assign({ onerror: true, onunhandledrejection: true }, options);
	    }
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.prototype.setupOnce = function () {
	        Error.stackTraceLimit = 50;
	        var options = this._options;
	        // We can disable guard-for-in as we construct the options object above + do checks against
	        // `this._installFunc` for the property.
	        // eslint-disable-next-line guard-for-in
	        for (var key in options) {
	            var installFunc = this._installFunc[key];
	            if (installFunc && options[key]) {
	                globalHandlerLog(key);
	                installFunc();
	                this._installFunc[key] = undefined;
	            }
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.id = 'GlobalHandlers';
	    return GlobalHandlers;
	}());
	exports.GlobalHandlers = GlobalHandlers;
	/** JSDoc */
	function _installGlobalOnErrorHandler() {
	    utils_1.addInstrumentationHandler('error', 
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function (data) {
	        var _a = tslib_1.__read(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
	        if (!hub.getIntegration(GlobalHandlers)) {
	            return;
	        }
	        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
	        if (helpers_1.shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
	            return;
	        }
	        var event = error === undefined && utils_1.isString(msg)
	            ? _eventFromIncompleteOnError(msg, url, line, column)
	            : _enhanceEventWithInitialFrame(eventbuilder_1.eventFromUnknownInput(error || msg, undefined, attachStacktrace, false), url, line, column);
	        event.level = types_1.Severity.Error;
	        addMechanismAndCapture(hub, error, event, 'onerror');
	    });
	}
	/** JSDoc */
	function _installGlobalOnUnhandledRejectionHandler() {
	    utils_1.addInstrumentationHandler('unhandledrejection', 
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function (e) {
	        var _a = tslib_1.__read(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
	        if (!hub.getIntegration(GlobalHandlers)) {
	            return;
	        }
	        var error = e;
	        // dig the object of the rejection out of known event types
	        try {
	            // PromiseRejectionEvents store the object of the rejection under 'reason'
	            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
	            if ('reason' in e) {
	                error = e.reason;
	            }
	            // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
	            // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
	            // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
	            // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
	            // https://github.com/getsentry/sentry-javascript/issues/2380
	            else if ('detail' in e && 'reason' in e.detail) {
	                error = e.detail.reason;
	            }
	        }
	        catch (_oO) {
	            // no-empty
	        }
	        if (helpers_1.shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
	            return true;
	        }
	        var event = utils_1.isPrimitive(error)
	            ? _eventFromRejectionWithPrimitive(error)
	            : eventbuilder_1.eventFromUnknownInput(error, undefined, attachStacktrace, true);
	        event.level = types_1.Severity.Error;
	        addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
	        return;
	    });
	}
	/**
	 * Create an event from a promise rejection where the `reason` is a primitive.
	 *
	 * @param reason: The `reason` property of the promise rejection
	 * @returns An Event object with an appropriate `exception` value
	 */
	function _eventFromRejectionWithPrimitive(reason) {
	    return {
	        exception: {
	            values: [
	                {
	                    type: 'UnhandledRejection',
	                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
	                    value: "Non-Error promise rejection captured with value: " + String(reason),
	                },
	            ],
	        },
	    };
	}
	/**
	 * This function creates a stack from an old, error-less onerror handler.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _eventFromIncompleteOnError(msg, url, line, column) {
	    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
	    // If 'message' is ErrorEvent, get real message from inside
	    var message = utils_1.isErrorEvent(msg) ? msg.message : msg;
	    var name = 'Error';
	    var groups = message.match(ERROR_TYPES_RE);
	    if (groups) {
	        name = groups[1];
	        message = groups[2];
	    }
	    var event = {
	        exception: {
	            values: [
	                {
	                    type: name,
	                    value: message,
	                },
	            ],
	        },
	    };
	    return _enhanceEventWithInitialFrame(event, url, line, column);
	}
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _enhanceEventWithInitialFrame(event, url, line, column) {
	    // event.exception
	    var e = (event.exception = event.exception || {});
	    // event.exception.values
	    var ev = (e.values = e.values || []);
	    // event.exception.values[0]
	    var ev0 = (ev[0] = ev[0] || {});
	    // event.exception.values[0].stacktrace
	    var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
	    // event.exception.values[0].stacktrace.frames
	    var ev0sf = (ev0s.frames = ev0s.frames || []);
	    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
	    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
	    var filename = utils_1.isString(url) && url.length > 0 ? url : utils_1.getLocationHref();
	    // event.exception.values[0].stacktrace.frames
	    if (ev0sf.length === 0) {
	        ev0sf.push({
	            colno: colno,
	            filename: filename,
	            function: '?',
	            in_app: true,
	            lineno: lineno,
	        });
	    }
	    return event;
	}
	function globalHandlerLog(type) {
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.log("Global Handler attached: " + type);
	}
	function addMechanismAndCapture(hub, error, event, type) {
	    utils_1.addExceptionMechanism(event, {
	        handled: false,
	        type: type,
	    });
	    hub.captureEvent(event, {
	        originalException: error,
	    });
	}
	function getHubAndAttachStacktrace() {
	    var hub = core_1.getCurrentHub();
	    var client = hub.getClient();
	    var attachStacktrace = client && client.getOptions().attachStacktrace;
	    return [hub, attachStacktrace];
	}
	//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var helpers_1 = __webpack_require__(202);
	var DEFAULT_EVENT_TARGET = [
	    'EventTarget',
	    'Window',
	    'Node',
	    'ApplicationCache',
	    'AudioTrackList',
	    'ChannelMergerNode',
	    'CryptoOperation',
	    'EventSource',
	    'FileReader',
	    'HTMLUnknownElement',
	    'IDBDatabase',
	    'IDBRequest',
	    'IDBTransaction',
	    'KeyOperation',
	    'MediaController',
	    'MessagePort',
	    'ModalWindow',
	    'Notification',
	    'SVGElementInstance',
	    'Screen',
	    'TextTrack',
	    'TextTrackCue',
	    'TextTrackList',
	    'WebSocket',
	    'WebSocketWorker',
	    'Worker',
	    'XMLHttpRequest',
	    'XMLHttpRequestEventTarget',
	    'XMLHttpRequestUpload',
	];
	/** Wrap timer functions and event targets to catch errors and provide better meta data */
	var TryCatch = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function TryCatch(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = TryCatch.id;
	        this._options = tslib_1.__assign({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
	    }
	    /**
	     * Wrap timer functions and event targets to catch errors
	     * and provide better metadata.
	     */
	    TryCatch.prototype.setupOnce = function () {
	        var global = utils_1.getGlobalObject();
	        if (this._options.setTimeout) {
	            utils_1.fill(global, 'setTimeout', _wrapTimeFunction);
	        }
	        if (this._options.setInterval) {
	            utils_1.fill(global, 'setInterval', _wrapTimeFunction);
	        }
	        if (this._options.requestAnimationFrame) {
	            utils_1.fill(global, 'requestAnimationFrame', _wrapRAF);
	        }
	        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
	            utils_1.fill(XMLHttpRequest.prototype, 'send', _wrapXHR);
	        }
	        var eventTargetOption = this._options.eventTarget;
	        if (eventTargetOption) {
	            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
	            eventTarget.forEach(_wrapEventTarget);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    TryCatch.id = 'TryCatch';
	    return TryCatch;
	}());
	exports.TryCatch = TryCatch;
	/** JSDoc */
	function _wrapTimeFunction(original) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var originalCallback = args[0];
	        args[0] = helpers_1.wrap(originalCallback, {
	            mechanism: {
	                data: { function: utils_1.getFunctionName(original) },
	                handled: true,
	                type: 'instrument',
	            },
	        });
	        return original.apply(this, args);
	    };
	}
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _wrapRAF(original) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return function (callback) {
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        return original.apply(this, [
	            helpers_1.wrap(callback, {
	                mechanism: {
	                    data: {
	                        function: 'requestAnimationFrame',
	                        handler: utils_1.getFunctionName(original),
	                    },
	                    handled: true,
	                    type: 'instrument',
	                },
	            }),
	        ]);
	    };
	}
	/** JSDoc */
	function _wrapXHR(originalSend) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        // eslint-disable-next-line @typescript-eslint/no-this-alias
	        var xhr = this;
	        var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
	        xmlHttpRequestProps.forEach(function (prop) {
	            if (prop in xhr && typeof xhr[prop] === 'function') {
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                utils_1.fill(xhr, prop, function (original) {
	                    var wrapOptions = {
	                        mechanism: {
	                            data: {
	                                function: prop,
	                                handler: utils_1.getFunctionName(original),
	                            },
	                            handled: true,
	                            type: 'instrument',
	                        },
	                    };
	                    // If Instrument integration has been called before TryCatch, get the name of original function
	                    var originalFunction = utils_1.getOriginalFunction(original);
	                    if (originalFunction) {
	                        wrapOptions.mechanism.data.handler = utils_1.getFunctionName(originalFunction);
	                    }
	                    // Otherwise wrap directly
	                    return helpers_1.wrap(original, wrapOptions);
	                });
	            }
	        });
	        return originalSend.apply(this, args);
	    };
	}
	/** JSDoc */
	function _wrapEventTarget(target) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var global = utils_1.getGlobalObject();
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    var proto = global[target] && global[target].prototype;
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
	    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	        return;
	    }
	    utils_1.fill(proto, 'addEventListener', function (original) {
	        return function (eventName, fn, options) {
	            try {
	                if (typeof fn.handleEvent === 'function') {
	                    fn.handleEvent = helpers_1.wrap(fn.handleEvent.bind(fn), {
	                        mechanism: {
	                            data: {
	                                function: 'handleEvent',
	                                handler: utils_1.getFunctionName(fn),
	                                target: target,
	                            },
	                            handled: true,
	                            type: 'instrument',
	                        },
	                    });
	                }
	            }
	            catch (err) {
	                // can sometimes get 'Permission denied to access property "handle Event'
	            }
	            return original.apply(this, [
	                eventName,
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                helpers_1.wrap(fn, {
	                    mechanism: {
	                        data: {
	                            function: 'addEventListener',
	                            handler: utils_1.getFunctionName(fn),
	                            target: target,
	                        },
	                        handled: true,
	                        type: 'instrument',
	                    },
	                }),
	                options,
	            ]);
	        };
	    });
	    utils_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
	        return function (eventName, fn, options) {
	            /**
	             * There are 2 possible scenarios here:
	             *
	             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
	             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
	             * as a pass-through, and call original `removeEventListener` with it.
	             *
	             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
	             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
	             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
	             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
	             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
	             *
	             * When someone adds a handler prior to initialization, and then do it again, but after,
	             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
	             * to get rid of the initial handler and it'd stick there forever.
	             */
	            var wrappedEventHandler = fn;
	            try {
	                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
	                if (originalEventHandler) {
	                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
	                }
	            }
	            catch (e) {
	                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
	            }
	            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
	        };
	    });
	}
	//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable max-lines */
	var core_1 = __webpack_require__(136);
	var types_1 = __webpack_require__(134);
	var utils_1 = __webpack_require__(140);
	/**
	 * Default Breadcrumbs instrumentations
	 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
	 */
	var Breadcrumbs = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Breadcrumbs(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = Breadcrumbs.id;
	        this._options = tslib_1.__assign({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
	    }
	    /**
	     * Create a breadcrumb of `sentry` from the events themselves
	     */
	    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
	        if (!this._options.sentry) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
	            event_id: event.event_id,
	            level: event.level,
	            message: utils_1.getEventDescription(event),
	        }, {
	            event: event,
	        });
	    };
	    /**
	     * Instrument browser built-ins w/ breadcrumb capturing
	     *  - Console API
	     *  - DOM API (click/typing)
	     *  - XMLHttpRequest API
	     *  - Fetch API
	     *  - History API
	     */
	    Breadcrumbs.prototype.setupOnce = function () {
	        if (this._options.console) {
	            utils_1.addInstrumentationHandler('console', _consoleBreadcrumb);
	        }
	        if (this._options.dom) {
	            utils_1.addInstrumentationHandler('dom', _domBreadcrumb(this._options.dom));
	        }
	        if (this._options.xhr) {
	            utils_1.addInstrumentationHandler('xhr', _xhrBreadcrumb);
	        }
	        if (this._options.fetch) {
	            utils_1.addInstrumentationHandler('fetch', _fetchBreadcrumb);
	        }
	        if (this._options.history) {
	            utils_1.addInstrumentationHandler('history', _historyBreadcrumb);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Breadcrumbs.id = 'Breadcrumbs';
	    return Breadcrumbs;
	}());
	exports.Breadcrumbs = Breadcrumbs;
	/**
	 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
	 * This is a HOC so that we get access to dom options in the closure.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _domBreadcrumb(dom) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function _innerDomBreadcrumb(handlerData) {
	        var target;
	        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
	        if (typeof keyAttrs === 'string') {
	            keyAttrs = [keyAttrs];
	        }
	        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
	        try {
	            target = handlerData.event.target
	                ? utils_1.htmlTreeAsString(handlerData.event.target, keyAttrs)
	                : utils_1.htmlTreeAsString(handlerData.event, keyAttrs);
	        }
	        catch (e) {
	            target = '<unknown>';
	        }
	        if (target.length === 0) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "ui." + handlerData.name,
	            message: target,
	        }, {
	            event: handlerData.event,
	            name: handlerData.name,
	            global: handlerData.global,
	        });
	    }
	    return _innerDomBreadcrumb;
	}
	/**
	 * Creates breadcrumbs from console API calls
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _consoleBreadcrumb(handlerData) {
	    var breadcrumb = {
	        category: 'console',
	        data: {
	            arguments: handlerData.args,
	            logger: 'console',
	        },
	        level: utils_1.severityFromString(handlerData.level),
	        message: utils_1.safeJoin(handlerData.args, ' '),
	    };
	    if (handlerData.level === 'assert') {
	        if (handlerData.args[0] === false) {
	            breadcrumb.message = "Assertion failed: " + (utils_1.safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
	            breadcrumb.data.arguments = handlerData.args.slice(1);
	        }
	        else {
	            // Don't capture a breadcrumb for passed assertions
	            return;
	        }
	    }
	    core_1.getCurrentHub().addBreadcrumb(breadcrumb, {
	        input: handlerData.args,
	        level: handlerData.level,
	    });
	}
	/**
	 * Creates breadcrumbs from XHR API calls
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _xhrBreadcrumb(handlerData) {
	    if (handlerData.endTimestamp) {
	        // We only capture complete, non-sentry requests
	        if (handlerData.xhr.__sentry_own_request__) {
	            return;
	        }
	        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
	        core_1.getCurrentHub().addBreadcrumb({
	            category: 'xhr',
	            data: {
	                method: method,
	                url: url,
	                status_code: status_code,
	            },
	            type: 'http',
	        }, {
	            xhr: handlerData.xhr,
	            input: body,
	        });
	        return;
	    }
	}
	/**
	 * Creates breadcrumbs from fetch API calls
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _fetchBreadcrumb(handlerData) {
	    // We only capture complete fetch requests
	    if (!handlerData.endTimestamp) {
	        return;
	    }
	    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
	        // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
	        return;
	    }
	    if (handlerData.error) {
	        core_1.getCurrentHub().addBreadcrumb({
	            category: 'fetch',
	            data: handlerData.fetchData,
	            level: types_1.Severity.Error,
	            type: 'http',
	        }, {
	            data: handlerData.error,
	            input: handlerData.args,
	        });
	    }
	    else {
	        core_1.getCurrentHub().addBreadcrumb({
	            category: 'fetch',
	            data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { status_code: handlerData.response.status }),
	            type: 'http',
	        }, {
	            input: handlerData.args,
	            response: handlerData.response,
	        });
	    }
	}
	/**
	 * Creates breadcrumbs from history API calls
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _historyBreadcrumb(handlerData) {
	    var global = utils_1.getGlobalObject();
	    var from = handlerData.from;
	    var to = handlerData.to;
	    var parsedLoc = utils_1.parseUrl(global.location.href);
	    var parsedFrom = utils_1.parseUrl(from);
	    var parsedTo = utils_1.parseUrl(to);
	    // Initial pushState doesn't provide `from` information
	    if (!parsedFrom.path) {
	        parsedFrom = parsedLoc;
	    }
	    // Use only the path component of the URL if the URL matches the current
	    // document (almost all the time when using pushState)
	    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
	        to = parsedTo.relative;
	    }
	    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
	        from = parsedFrom.relative;
	    }
	    core_1.getCurrentHub().addBreadcrumb({
	        category: 'navigation',
	        data: {
	            from: from,
	            to: to,
	        },
	    });
	}
	//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(140);
	var eventbuilder_1 = __webpack_require__(192);
	var DEFAULT_KEY = 'cause';
	var DEFAULT_LIMIT = 5;
	/** Adds SDK info to an event. */
	var LinkedErrors = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function LinkedErrors(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = LinkedErrors.id;
	        this._key = options.key || DEFAULT_KEY;
	        this._limit = options.limit || DEFAULT_LIMIT;
	    }
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event, hint) {
	            var self = core_1.getCurrentHub().getIntegration(LinkedErrors);
	            return self ? _handler(self._key, self._limit, event, hint) : event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.id = 'LinkedErrors';
	    return LinkedErrors;
	}());
	exports.LinkedErrors = LinkedErrors;
	/**
	 * @inheritDoc
	 */
	function _handler(key, limit, event, hint) {
	    if (!event.exception || !event.exception.values || !hint || !utils_1.isInstanceOf(hint.originalException, Error)) {
	        return event;
	    }
	    var linkedErrors = _walkErrorTree(limit, hint.originalException, key);
	    event.exception.values = tslib_1.__spread(linkedErrors, event.exception.values);
	    return event;
	}
	exports._handler = _handler;
	/**
	 * JSDOC
	 */
	function _walkErrorTree(limit, error, key, stack) {
	    if (stack === void 0) { stack = []; }
	    if (!utils_1.isInstanceOf(error[key], Error) || stack.length + 1 >= limit) {
	        return stack;
	    }
	    var exception = eventbuilder_1.exceptionFromError(error[key]);
	    return _walkErrorTree(limit, error[key], key, tslib_1.__spread([exception], stack));
	}
	exports._walkErrorTree = _walkErrorTree;
	//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(140);
	var global = utils_1.getGlobalObject();
	/** UserAgent */
	var UserAgent = /** @class */ (function () {
	    function UserAgent() {
	        /**
	         * @inheritDoc
	         */
	        this.name = UserAgent.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    UserAgent.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event) {
	            if (core_1.getCurrentHub().getIntegration(UserAgent)) {
	                // if none of the information we want exists, don't bother
	                if (!global.navigator && !global.location && !global.document) {
	                    return event;
	                }
	                // grab as much info as exists and add it to the event
	                var url = (event.request && event.request.url) || (global.location && global.location.href);
	                var referrer = (global.document || {}).referrer;
	                var userAgent = (global.navigator || {}).userAgent;
	                var headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (event.request && event.request.headers)), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
	                var request = tslib_1.__assign(tslib_1.__assign({}, (url && { url: url })), { headers: headers });
	                return tslib_1.__assign(tslib_1.__assign({}, event), { request: request });
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    UserAgent.id = 'UserAgent';
	    return UserAgent;
	}());
	exports.UserAgent = UserAgent;
	//# sourceMappingURL=useragent.js.map

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(196);
	/** Deduplication filter */
	var Dedupe = /** @class */ (function () {
	    function Dedupe() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Dedupe.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (currentEvent) {
	            var self = getCurrentHub().getIntegration(Dedupe);
	            if (self) {
	                // Juuust in case something goes wrong
	                try {
	                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Event dropped due to being a duplicate of previously captured event.');
	                        return null;
	                    }
	                }
	                catch (_oO) {
	                    return (self._previousEvent = currentEvent);
	                }
	                return (self._previousEvent = currentEvent);
	            }
	            return currentEvent;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Dedupe.id = 'Dedupe';
	    return Dedupe;
	}());
	exports.Dedupe = Dedupe;
	/** JSDoc */
	function _shouldDropEvent(currentEvent, previousEvent) {
	    if (!previousEvent) {
	        return false;
	    }
	    if (_isSameMessageEvent(currentEvent, previousEvent)) {
	        return true;
	    }
	    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
	        return true;
	    }
	    return false;
	}
	/** JSDoc */
	function _isSameMessageEvent(currentEvent, previousEvent) {
	    var currentMessage = currentEvent.message;
	    var previousMessage = previousEvent.message;
	    // If neither event has a message property, they were both exceptions, so bail out
	    if (!currentMessage && !previousMessage) {
	        return false;
	    }
	    // If only one event has a stacktrace, but not the other one, they are not the same
	    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
	        return false;
	    }
	    if (currentMessage !== previousMessage) {
	        return false;
	    }
	    if (!_isSameFingerprint(currentEvent, previousEvent)) {
	        return false;
	    }
	    if (!_isSameStacktrace(currentEvent, previousEvent)) {
	        return false;
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameExceptionEvent(currentEvent, previousEvent) {
	    var previousException = _getExceptionFromEvent(previousEvent);
	    var currentException = _getExceptionFromEvent(currentEvent);
	    if (!previousException || !currentException) {
	        return false;
	    }
	    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
	        return false;
	    }
	    if (!_isSameFingerprint(currentEvent, previousEvent)) {
	        return false;
	    }
	    if (!_isSameStacktrace(currentEvent, previousEvent)) {
	        return false;
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameStacktrace(currentEvent, previousEvent) {
	    var currentFrames = _getFramesFromEvent(currentEvent);
	    var previousFrames = _getFramesFromEvent(previousEvent);
	    // If neither event has a stacktrace, they are assumed to be the same
	    if (!currentFrames && !previousFrames) {
	        return true;
	    }
	    // If only one event has a stacktrace, but not the other one, they are not the same
	    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
	        return false;
	    }
	    currentFrames = currentFrames;
	    previousFrames = previousFrames;
	    // If number of frames differ, they are not the same
	    if (previousFrames.length !== currentFrames.length) {
	        return false;
	    }
	    // Otherwise, compare the two
	    for (var i = 0; i < previousFrames.length; i++) {
	        var frameA = previousFrames[i];
	        var frameB = currentFrames[i];
	        if (frameA.filename !== frameB.filename ||
	            frameA.lineno !== frameB.lineno ||
	            frameA.colno !== frameB.colno ||
	            frameA.function !== frameB.function) {
	            return false;
	        }
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameFingerprint(currentEvent, previousEvent) {
	    var currentFingerprint = currentEvent.fingerprint;
	    var previousFingerprint = previousEvent.fingerprint;
	    // If neither event has a fingerprint, they are assumed to be the same
	    if (!currentFingerprint && !previousFingerprint) {
	        return true;
	    }
	    // If only one event has a fingerprint, but not the other one, they are not the same
	    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
	        return false;
	    }
	    currentFingerprint = currentFingerprint;
	    previousFingerprint = previousFingerprint;
	    // Otherwise, compare the two
	    try {
	        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
	    }
	    catch (_oO) {
	        return false;
	    }
	}
	/** JSDoc */
	function _getExceptionFromEvent(event) {
	    return event.exception && event.exception.values && event.exception.values[0];
	}
	/** JSDoc */
	function _getFramesFromEvent(event) {
	    var exception = event.exception;
	    if (exception) {
	        try {
	            // @ts-ignore Object could be undefined
	            return exception.values[0].stacktrace.frames;
	        }
	        catch (_oO) {
	            return undefined;
	        }
	    }
	    else if (event.stacktrace) {
	        return event.stacktrace.frames;
	    }
	    return undefined;
	}
	//# sourceMappingURL=dedupe.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var core_1 = __webpack_require__(136);
	var utils_1 = __webpack_require__(140);
	var client_1 = __webpack_require__(190);
	var flags_1 = __webpack_require__(196);
	var helpers_1 = __webpack_require__(202);
	var integrations_1 = __webpack_require__(203);
	exports.defaultIntegrations = [
	    new core_1.Integrations.InboundFilters(),
	    new core_1.Integrations.FunctionToString(),
	    new integrations_1.TryCatch(),
	    new integrations_1.Breadcrumbs(),
	    new integrations_1.GlobalHandlers(),
	    new integrations_1.LinkedErrors(),
	    new integrations_1.Dedupe(),
	    new integrations_1.UserAgent(),
	];
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * To use this SDK, call the {@link init} function as early as possible when
	 * loading the web page. To set context information or send manual events, use
	 * the provided methods.
	 *
	 * @example
	 *
	 * ```
	 *
	 * import { init } from '@sentry/browser';
	 *
	 * init({
	 *   dsn: '__DSN__',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { configureScope } from '@sentry/browser';
	 * configureScope((scope: Scope) => {
	 *   scope.setExtra({ battery: 0.7 });
	 *   scope.setTag({ user_mode: 'admin' });
	 *   scope.setUser({ id: '4711' });
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { addBreadcrumb } from '@sentry/browser';
	 * addBreadcrumb({
	 *   message: 'My Breadcrumb',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 *
	 * ```
	 *
	 * import * as Sentry from '@sentry/browser';
	 * Sentry.captureMessage('Hello, world!');
	 * Sentry.captureException(new Error('Good bye'));
	 * Sentry.captureEvent({
	 *   message: 'Manual',
	 *   stacktrace: [
	 *     // ...
	 *   ],
	 * });
	 * ```
	 *
	 * @see {@link BrowserOptions} for documentation on configuration options.
	 */
	function init(options) {
	    if (options === void 0) { options = {}; }
	    if (options.defaultIntegrations === undefined) {
	        options.defaultIntegrations = exports.defaultIntegrations;
	    }
	    if (options.release === undefined) {
	        var window_1 = utils_1.getGlobalObject();
	        // This supports the variable that sentry-webpack-plugin injects
	        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
	            options.release = window_1.SENTRY_RELEASE.id;
	        }
	    }
	    if (options.autoSessionTracking === undefined) {
	        options.autoSessionTracking = true;
	    }
	    if (options.sendClientReports === undefined) {
	        options.sendClientReports = true;
	    }
	    core_1.initAndBind(client_1.BrowserClient, options);
	    if (options.autoSessionTracking) {
	        startSessionTracking();
	    }
	}
	exports.init = init;
	/**
	 * Present the user with a report dialog.
	 *
	 * @param options Everything is optional, we try to fetch all info need from the global scope.
	 */
	function showReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    var hub = core_1.getCurrentHub();
	    var scope = hub.getScope();
	    if (scope) {
	        options.user = tslib_1.__assign(tslib_1.__assign({}, scope.getUser()), options.user);
	    }
	    if (!options.eventId) {
	        options.eventId = hub.lastEventId();
	    }
	    var client = hub.getClient();
	    if (client) {
	        client.showReportDialog(options);
	    }
	}
	exports.showReportDialog = showReportDialog;
	/**
	 * This is the getter for lastEventId.
	 *
	 * @returns The last event id of a captured event.
	 */
	function lastEventId() {
	    return core_1.getCurrentHub().lastEventId();
	}
	exports.lastEventId = lastEventId;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function forceLoad() {
	    // Noop
	}
	exports.forceLoad = forceLoad;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function onLoad(callback) {
	    callback();
	}
	exports.onLoad = onLoad;
	/**
	 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
	 *
	 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
	 * the client to wait until all events are sent before resolving the promise.
	 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
	 * doesn't (or if there's no client defined).
	 */
	function flush(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.flush(timeout);
	    }
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Cannot flush events. No client defined.');
	    return utils_1.resolvedSyncPromise(false);
	}
	exports.flush = flush;
	/**
	 * Call `close()` on the current client, if there is one. See {@link Client.close}.
	 *
	 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
	 * parameter will cause the client to wait until all events are sent before disabling itself.
	 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
	 * doesn't (or if there's no client defined).
	 */
	function close(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.close(timeout);
	    }
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Cannot flush events and disable SDK. No client defined.');
	    return utils_1.resolvedSyncPromise(false);
	}
	exports.close = close;
	/**
	 * Wrap code within a try/catch block so the SDK is able to capture errors.
	 *
	 * @param fn A function to wrap.
	 *
	 * @returns The result of wrapped function call.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function wrap(fn) {
	    return helpers_1.wrap(fn)();
	}
	exports.wrap = wrap;
	function startSessionOnHub(hub) {
	    hub.startSession({ ignoreDuration: true });
	    hub.captureSession();
	}
	/**
	 * Enable automatic Session Tracking for the initial page load.
	 */
	function startSessionTracking() {
	    var window = utils_1.getGlobalObject();
	    var document = window.document;
	    if (typeof document === 'undefined') {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
	        return;
	    }
	    var hub = core_1.getCurrentHub();
	    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
	    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
	    // pinned at the same version in package.json, but there are edge cases where it's possible. See
	    // https://github.com/getsentry/sentry-javascript/issues/3207 and
	    // https://github.com/getsentry/sentry-javascript/issues/3234 and
	    // https://github.com/getsentry/sentry-javascript/issues/3278.
	    if (!hub.captureSession) {
	        return;
	    }
	    // The session duration for browser sessions does not track a meaningful
	    // concept that can be used as a metric.
	    // Automatically captured sessions are akin to page views, and thus we
	    // discard their duration.
	    startSessionOnHub(hub);
	    // We want to create a session for every navigation as well
	    utils_1.addInstrumentationHandler('history', function (_a) {
	        var from = _a.from, to = _a.to;
	        // Don't create an additional session for the initial route or if the location did not change
	        if (!(from === undefined || from === to)) {
	            startSessionOnHub(core_1.getCurrentHub());
	        }
	    });
	}
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
	exports.SDK_NAME = 'sentry.javascript.browser';
	//# sourceMappingURL=version.js.map

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hubextensions_1 = __webpack_require__(213);
	exports.addExtensionMethods = hubextensions_1.addExtensionMethods;
	var Integrations = __webpack_require__(221);
	exports.Integrations = Integrations;
	// This is already exported as part of `Integrations` above (and for the moment will remain so for
	// backwards compatibility), but that interferes with treeshaking, so we also export it separately
	// here.
	//
	// Previously we expected users to import tracing integrations like
	//
	// import { Integrations } from '@sentry/tracing';
	// const instance = new Integrations.BrowserTracing();
	//
	// This makes the integrations unable to be treeshaken though. To address this, we now have
	// this individual export. We now expect users to consume BrowserTracing like so:
	//
	// import { BrowserTracing } from '@sentry/tracing';
	// const instance = new BrowserTracing();
	//
	// For an example of of the new usage of BrowserTracing, see @sentry/nextjs index.client.ts
	var browser_1 = __webpack_require__(226);
	exports.BrowserTracing = browser_1.BrowserTracing;
	var span_1 = __webpack_require__(219);
	exports.Span = span_1.Span;
	exports.spanStatusfromHttpCode = span_1.spanStatusfromHttpCode;
	// eslint-disable-next-line deprecation/deprecation
	var spanstatus_1 = __webpack_require__(241);
	exports.SpanStatus = spanstatus_1.SpanStatus;
	var transaction_1 = __webpack_require__(220);
	exports.Transaction = transaction_1.Transaction;
	var browser_2 = __webpack_require__(226);
	// TODO deprecate old name in v7
	exports.registerRequestInstrumentation = browser_2.instrumentOutgoingRequests;
	exports.defaultRequestInstrumentationOptions = browser_2.defaultRequestInstrumentationOptions;
	var idletransaction_1 = __webpack_require__(217);
	exports.IdleTransaction = idletransaction_1.IdleTransaction;
	var hubextensions_2 = __webpack_require__(213);
	exports.startIdleTransaction = hubextensions_2.startIdleTransaction;
	// We are patching the global object with our hub extension methods
	hubextensions_1.addExtensionMethods();
	var utils_1 = __webpack_require__(216);
	exports.extractTraceparentData = utils_1.extractTraceparentData;
	exports.getActiveTransaction = utils_1.getActiveTransaction;
	exports.hasTracingEnabled = utils_1.hasTracingEnabled;
	exports.stripUrlQueryAndFragment = utils_1.stripUrlQueryAndFragment;
	exports.TRACEPARENT_REGEXP = utils_1.TRACEPARENT_REGEXP;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var hub_1 = __webpack_require__(138);
	var utils_1 = __webpack_require__(140);
	var errors_1 = __webpack_require__(214);
	var flags_1 = __webpack_require__(215);
	var idletransaction_1 = __webpack_require__(217);
	var transaction_1 = __webpack_require__(220);
	var utils_2 = __webpack_require__(216);
	/** Returns all trace headers that are currently on the top scope. */
	function traceHeaders() {
	    var scope = this.getScope();
	    if (scope) {
	        var span = scope.getSpan();
	        if (span) {
	            return {
	                'sentry-trace': span.toTraceparent(),
	            };
	        }
	    }
	    return {};
	}
	/**
	 * Makes a sampling decision for the given transaction and stores it on the transaction.
	 *
	 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
	 * sent to Sentry.
	 *
	 * @param transaction: The transaction needing a sampling decision
	 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
	 * @param samplingContext: Default and user-provided data which may be used to help make the decision
	 *
	 * @returns The given transaction with its `sampled` value set
	 */
	function sample(transaction, options, samplingContext) {
	    // nothing to do if tracing is not enabled
	    if (!utils_2.hasTracingEnabled(options)) {
	        transaction.sampled = false;
	        return transaction;
	    }
	    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
	    if (transaction.sampled !== undefined) {
	        transaction.setMetadata({
	            transactionSampling: { method: 'explicitly_set' },
	        });
	        return transaction;
	    }
	    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
	    // work; prefer the hook if so
	    var sampleRate;
	    if (typeof options.tracesSampler === 'function') {
	        sampleRate = options.tracesSampler(samplingContext);
	        transaction.setMetadata({
	            transactionSampling: {
	                method: 'client_sampler',
	                // cast to number in case it's a boolean
	                rate: Number(sampleRate),
	            },
	        });
	    }
	    else if (samplingContext.parentSampled !== undefined) {
	        sampleRate = samplingContext.parentSampled;
	        transaction.setMetadata({
	            transactionSampling: { method: 'inheritance' },
	        });
	    }
	    else {
	        sampleRate = options.tracesSampleRate;
	        transaction.setMetadata({
	            transactionSampling: {
	                method: 'client_rate',
	                // cast to number in case it's a boolean
	                rate: Number(sampleRate),
	            },
	        });
	    }
	    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
	    // only valid values are booleans or numbers between 0 and 1.)
	    if (!isValidSampleRate(sampleRate)) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('[Tracing] Discarding transaction because of invalid sample rate.');
	        transaction.sampled = false;
	        return transaction;
	    }
	    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
	    if (!sampleRate) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
	                ? 'tracesSampler returned 0 or false'
	                : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
	        transaction.sampled = false;
	        return transaction;
	    }
	    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
	    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
	    transaction.sampled = Math.random() < sampleRate;
	    // if we're not going to keep it, we're done
	    if (!transaction.sampled) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
	        return transaction;
	    }
	    flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
	    return transaction;
	}
	/**
	 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
	 */
	function isValidSampleRate(rate) {
	    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    if (utils_1.isNaN(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
	        return false;
	    }
	    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
	    if (rate < 0 || rate > 1) {
	        flags_1.IS_DEBUG_BUILD &&
	            utils_1.logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
	        return false;
	    }
	    return true;
	}
	/**
	 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
	 *
	 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
	 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
	 * "extension method."
	 *
	 * @param this: The Hub starting the transaction
	 * @param transactionContext: Data used to configure the transaction
	 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
	 *
	 * @returns The new transaction
	 *
	 * @see {@link Hub.startTransaction}
	 */
	function _startTransaction(transactionContext, customSamplingContext) {
	    var client = this.getClient();
	    var options = (client && client.getOptions()) || {};
	    var transaction = new transaction_1.Transaction(transactionContext, this);
	    transaction = sample(transaction, options, tslib_1.__assign({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
	    if (transaction.sampled) {
	        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
	    }
	    return transaction;
	}
	/**
	 * Create new idle transaction.
	 */
	function startIdleTransaction(hub, transactionContext, idleTimeout, onScope, customSamplingContext) {
	    var client = hub.getClient();
	    var options = (client && client.getOptions()) || {};
	    var transaction = new idletransaction_1.IdleTransaction(transactionContext, hub, idleTimeout, onScope);
	    transaction = sample(transaction, options, tslib_1.__assign({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
	    if (transaction.sampled) {
	        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
	    }
	    return transaction;
	}
	exports.startIdleTransaction = startIdleTransaction;
	/**
	 * @private
	 */
	function _addTracingExtensions() {
	    var carrier = hub_1.getMainCarrier();
	    if (!carrier.__SENTRY__) {
	        return;
	    }
	    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
	    if (!carrier.__SENTRY__.extensions.startTransaction) {
	        carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
	    }
	    if (!carrier.__SENTRY__.extensions.traceHeaders) {
	        carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
	    }
	}
	exports._addTracingExtensions = _addTracingExtensions;
	/**
	 * @private
	 */
	function _autoloadDatabaseIntegrations() {
	    var carrier = hub_1.getMainCarrier();
	    if (!carrier.__SENTRY__) {
	        return;
	    }
	    var packageToIntegrationMapping = {
	        mongodb: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/mongo');
	            return new integration.Mongo();
	        },
	        mongoose: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/mongo');
	            return new integration.Mongo({ mongoose: true });
	        },
	        mysql: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/mysql');
	            return new integration.Mysql();
	        },
	        pg: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/postgres');
	            return new integration.Postgres();
	        },
	    };
	    var mappedPackages = Object.keys(packageToIntegrationMapping)
	        .filter(function (moduleName) { return !!utils_1.loadModule(moduleName); })
	        .map(function (pkg) {
	        try {
	            return packageToIntegrationMapping[pkg]();
	        }
	        catch (e) {
	            return undefined;
	        }
	    })
	        .filter(function (p) { return p; });
	    if (mappedPackages.length > 0) {
	        carrier.__SENTRY__.integrations = tslib_1.__spread((carrier.__SENTRY__.integrations || []), mappedPackages);
	    }
	}
	/**
	 * This patches the global object and injects the Tracing extensions methods
	 */
	function addExtensionMethods() {
	    _addTracingExtensions();
	    // Detect and automatically load specified integrations.
	    if (utils_1.isNodeEnv()) {
	        _autoloadDatabaseIntegrations();
	    }
	    // If an error happens globally, we should make sure transaction status is set to error.
	    errors_1.registerErrorInstrumentation();
	}
	exports.addExtensionMethods = addExtensionMethods;
	//# sourceMappingURL=hubextensions.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(215);
	var utils_2 = __webpack_require__(216);
	/**
	 * Configures global error listeners
	 */
	function registerErrorInstrumentation() {
	    utils_1.addInstrumentationHandler('error', errorCallback);
	    utils_1.addInstrumentationHandler('unhandledrejection', errorCallback);
	}
	exports.registerErrorInstrumentation = registerErrorInstrumentation;
	/**
	 * If an error or unhandled promise occurs, we mark the active transaction as failed
	 */
	function errorCallback() {
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var status_1 = 'internal_error';
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] Transaction: " + status_1 + " -> Global error occured");
	        activeTransaction.setStatus(status_1);
	    }
	}
	//# sourceMappingURL=errors.js.map

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(138);
	/**
	 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
	 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
	 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
	 * is the only tracing function used by `@sentry/node`).
	 *
	 * These exports are kept here for backwards compatability's sake.
	 *
	 * TODO(v7): Reorganize these exports
	 *
	 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
	 */
	var utils_1 = __webpack_require__(140);
	exports.TRACEPARENT_REGEXP = utils_1.TRACEPARENT_REGEXP;
	exports.extractTraceparentData = utils_1.extractTraceparentData;
	/**
	 * Determines if tracing is currently enabled.
	 *
	 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
	 */
	function hasTracingEnabled(maybeOptions) {
	    var client = hub_1.getCurrentHub().getClient();
	    var options = maybeOptions || (client && client.getOptions());
	    return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
	}
	exports.hasTracingEnabled = hasTracingEnabled;
	/** Grabs active transaction off scope, if any */
	function getActiveTransaction(maybeHub) {
	    var hub = maybeHub || hub_1.getCurrentHub();
	    var scope = hub.getScope();
	    return scope && scope.getTransaction();
	}
	exports.getActiveTransaction = getActiveTransaction;
	/**
	 * Converts from milliseconds to seconds
	 * @param time time in ms
	 */
	function msToSec(time) {
	    return time / 1000;
	}
	exports.msToSec = msToSec;
	/**
	 * Converts from seconds to milliseconds
	 * @param time time in seconds
	 */
	function secToMs(time) {
	    return time * 1000;
	}
	exports.secToMs = secToMs;
	// so it can be used in manual instrumentation without necessitating a hard dependency on @sentry/utils
	var utils_2 = __webpack_require__(140);
	exports.stripUrlQueryAndFragment = utils_2.stripUrlQueryAndFragment;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var constants_1 = __webpack_require__(218);
	var flags_1 = __webpack_require__(215);
	var span_1 = __webpack_require__(219);
	var transaction_1 = __webpack_require__(220);
	exports.DEFAULT_IDLE_TIMEOUT = 1000;
	exports.HEARTBEAT_INTERVAL = 5000;
	/**
	 * @inheritDoc
	 */
	var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
	    tslib_1.__extends(IdleTransactionSpanRecorder, _super);
	    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
	        if (transactionSpanId === void 0) { transactionSpanId = ''; }
	        var _this = _super.call(this, maxlen) || this;
	        _this._pushActivity = _pushActivity;
	        _this._popActivity = _popActivity;
	        _this.transactionSpanId = transactionSpanId;
	        return _this;
	    }
	    /**
	     * @inheritDoc
	     */
	    IdleTransactionSpanRecorder.prototype.add = function (span) {
	        var _this = this;
	        // We should make sure we do not push and pop activities for
	        // the transaction that this span recorder belongs to.
	        if (span.spanId !== this.transactionSpanId) {
	            // We patch span.finish() to pop an activity after setting an endTimestamp.
	            span.finish = function (endTimestamp) {
	                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : utils_1.timestampWithMs();
	                _this._popActivity(span.spanId);
	            };
	            // We should only push new activities if the span does not have an end timestamp.
	            if (span.endTimestamp === undefined) {
	                this._pushActivity(span.spanId);
	            }
	        }
	        _super.prototype.add.call(this, span);
	    };
	    return IdleTransactionSpanRecorder;
	}(span_1.SpanRecorder));
	exports.IdleTransactionSpanRecorder = IdleTransactionSpanRecorder;
	/**
	 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
	 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
	 * put itself on the scope on creation.
	 */
	var IdleTransaction = /** @class */ (function (_super) {
	    tslib_1.__extends(IdleTransaction, _super);
	    function IdleTransaction(transactionContext, _idleHub, 
	    /**
	     * The time to wait in ms until the idle transaction will be finished.
	     * @default 1000
	     */
	    _idleTimeout, 
	    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
	    _onScope) {
	        if (_idleTimeout === void 0) { _idleTimeout = exports.DEFAULT_IDLE_TIMEOUT; }
	        if (_onScope === void 0) { _onScope = false; }
	        var _this = _super.call(this, transactionContext, _idleHub) || this;
	        _this._idleHub = _idleHub;
	        _this._idleTimeout = _idleTimeout;
	        _this._onScope = _onScope;
	        // Activities store a list of active spans
	        _this.activities = {};
	        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
	        _this._heartbeatCounter = 0;
	        // We should not use heartbeat if we finished a transaction
	        _this._finished = false;
	        _this._beforeFinishCallbacks = [];
	        if (_idleHub && _onScope) {
	            // There should only be one active transaction on the scope
	            clearActiveTransaction(_idleHub);
	            // We set the transaction here on the scope so error events pick up the trace
	            // context and attach it to the error.
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log("Setting idle transaction on scope. Span ID: " + _this.spanId);
	            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
	        }
	        _this._initTimeout = setTimeout(function () {
	            if (!_this._finished) {
	                _this.finish();
	            }
	        }, _this._idleTimeout);
	        return _this;
	    }
	    /** {@inheritDoc} */
	    IdleTransaction.prototype.finish = function (endTimestamp) {
	        var e_1, _a;
	        var _this = this;
	        if (endTimestamp === void 0) { endTimestamp = utils_1.timestampWithMs(); }
	        this._finished = true;
	        this.activities = {};
	        if (this.spanRecorder) {
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
	            try {
	                for (var _b = tslib_1.__values(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var callback = _c.value;
	                    callback(this, endTimestamp);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
	                // If we are dealing with the transaction itself, we just return it
	                if (span.spanId === _this.spanId) {
	                    return true;
	                }
	                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
	                if (!span.endTimestamp) {
	                    span.endTimestamp = endTimestamp;
	                    span.setStatus('cancelled');
	                    flags_1.IS_DEBUG_BUILD &&
	                        utils_1.logger.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
	                }
	                var keepSpan = span.startTimestamp < endTimestamp;
	                if (!keepSpan) {
	                    flags_1.IS_DEBUG_BUILD &&
	                        utils_1.logger.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
	                }
	                return keepSpan;
	            });
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] flushing IdleTransaction');
	        }
	        else {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] No active IdleTransaction');
	        }
	        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
	        if (this._onScope) {
	            clearActiveTransaction(this._idleHub);
	        }
	        return _super.prototype.finish.call(this, endTimestamp);
	    };
	    /**
	     * Register a callback function that gets excecuted before the transaction finishes.
	     * Useful for cleanup or if you want to add any additional spans based on current context.
	     *
	     * This is exposed because users have no other way of running something before an idle transaction
	     * finishes.
	     */
	    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
	        this._beforeFinishCallbacks.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
	        var _this = this;
	        if (!this.spanRecorder) {
	            var pushActivity = function (id) {
	                if (_this._finished) {
	                    return;
	                }
	                _this._pushActivity(id);
	            };
	            var popActivity = function (id) {
	                if (_this._finished) {
	                    return;
	                }
	                _this._popActivity(id);
	            };
	            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
	            // Start heartbeat so that transactions do not run forever.
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('Starting heartbeat');
	            this._pingHeartbeat();
	        }
	        this.spanRecorder.add(this);
	    };
	    /**
	     * Start tracking a specific activity.
	     * @param spanId The span id that represents the activity
	     */
	    IdleTransaction.prototype._pushActivity = function (spanId) {
	        if (this._initTimeout) {
	            clearTimeout(this._initTimeout);
	            this._initTimeout = undefined;
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] pushActivity: " + spanId);
	        this.activities[spanId] = true;
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
	    };
	    /**
	     * Remove an activity from usage
	     * @param spanId The span id that represents the activity
	     */
	    IdleTransaction.prototype._popActivity = function (spanId) {
	        var _this = this;
	        if (this.activities[spanId]) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] popActivity " + spanId);
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this.activities[spanId];
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
	        }
	        if (Object.keys(this.activities).length === 0) {
	            var timeout = this._idleTimeout;
	            // We need to add the timeout here to have the real endtimestamp of the transaction
	            // Remember timestampWithMs is in seconds, timeout is in ms
	            var end_1 = utils_1.timestampWithMs() + timeout / 1000;
	            setTimeout(function () {
	                if (!_this._finished) {
	                    _this.setTag(constants_1.FINISH_REASON_TAG, constants_1.IDLE_TRANSACTION_FINISH_REASONS[1]);
	                    _this.finish(end_1);
	                }
	            }, timeout);
	        }
	    };
	    /**
	     * Checks when entries of this.activities are not changing for 3 beats.
	     * If this occurs we finish the transaction.
	     */
	    IdleTransaction.prototype._beat = function () {
	        // We should not be running heartbeat if the idle transaction is finished.
	        if (this._finished) {
	            return;
	        }
	        var heartbeatString = Object.keys(this.activities).join('');
	        if (heartbeatString === this._prevHeartbeatString) {
	            this._heartbeatCounter += 1;
	        }
	        else {
	            this._heartbeatCounter = 1;
	        }
	        this._prevHeartbeatString = heartbeatString;
	        if (this._heartbeatCounter >= 3) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] Transaction finished because of no change for 3 heart beats');
	            this.setStatus('deadline_exceeded');
	            this.setTag(constants_1.FINISH_REASON_TAG, constants_1.IDLE_TRANSACTION_FINISH_REASONS[0]);
	            this.finish();
	        }
	        else {
	            this._pingHeartbeat();
	        }
	    };
	    /**
	     * Pings the heartbeat
	     */
	    IdleTransaction.prototype._pingHeartbeat = function () {
	        var _this = this;
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
	        setTimeout(function () {
	            _this._beat();
	        }, exports.HEARTBEAT_INTERVAL);
	    };
	    return IdleTransaction;
	}(transaction_1.Transaction));
	exports.IdleTransaction = IdleTransaction;
	/**
	 * Reset transaction on scope to `undefined`
	 */
	function clearActiveTransaction(hub) {
	    if (hub) {
	        var scope = hub.getScope();
	        if (scope) {
	            var transaction = scope.getTransaction();
	            if (transaction) {
	                scope.setSpan(undefined);
	            }
	        }
	    }
	}
	//# sourceMappingURL=idletransaction.js.map

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	// Store finish reasons in tuple to save on bundle size
	// Readonly type should enforce that this is not mutated.
	exports.FINISH_REASON_TAG = 'finishReason';
	exports.IDLE_TRANSACTION_FINISH_REASONS = ['heartbeatFailed', 'idleTimeout', 'documentHidden'];
	//# sourceMappingURL=constants.js.map

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	/**
	 * Keeps track of finished spans for a given transaction
	 * @internal
	 * @hideconstructor
	 * @hidden
	 */
	var SpanRecorder = /** @class */ (function () {
	    function SpanRecorder(maxlen) {
	        if (maxlen === void 0) { maxlen = 1000; }
	        this.spans = [];
	        this._maxlen = maxlen;
	    }
	    /**
	     * This is just so that we don't run out of memory while recording a lot
	     * of spans. At some point we just stop and flush out the start of the
	     * trace tree (i.e.the first n spans with the smallest
	     * start_timestamp).
	     */
	    SpanRecorder.prototype.add = function (span) {
	        if (this.spans.length > this._maxlen) {
	            span.spanRecorder = undefined;
	        }
	        else {
	            this.spans.push(span);
	        }
	    };
	    return SpanRecorder;
	}());
	exports.SpanRecorder = SpanRecorder;
	/**
	 * Span contains all data about a span
	 */
	var Span = /** @class */ (function () {
	    /**
	     * You should never call the constructor manually, always use `Sentry.startTransaction()`
	     * or call `startChild()` on an existing span.
	     * @internal
	     * @hideconstructor
	     * @hidden
	     */
	    function Span(spanContext) {
	        /**
	         * @inheritDoc
	         */
	        this.traceId = utils_1.uuid4();
	        /**
	         * @inheritDoc
	         */
	        this.spanId = utils_1.uuid4().substring(16);
	        /**
	         * Timestamp in seconds when the span was created.
	         */
	        this.startTimestamp = utils_1.timestampWithMs();
	        /**
	         * @inheritDoc
	         */
	        this.tags = {};
	        /**
	         * @inheritDoc
	         */
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this.data = {};
	        if (!spanContext) {
	            return this;
	        }
	        if (spanContext.traceId) {
	            this.traceId = spanContext.traceId;
	        }
	        if (spanContext.spanId) {
	            this.spanId = spanContext.spanId;
	        }
	        if (spanContext.parentSpanId) {
	            this.parentSpanId = spanContext.parentSpanId;
	        }
	        // We want to include booleans as well here
	        if ('sampled' in spanContext) {
	            this.sampled = spanContext.sampled;
	        }
	        if (spanContext.op) {
	            this.op = spanContext.op;
	        }
	        if (spanContext.description) {
	            this.description = spanContext.description;
	        }
	        if (spanContext.data) {
	            this.data = spanContext.data;
	        }
	        if (spanContext.tags) {
	            this.tags = spanContext.tags;
	        }
	        if (spanContext.status) {
	            this.status = spanContext.status;
	        }
	        if (spanContext.startTimestamp) {
	            this.startTimestamp = spanContext.startTimestamp;
	        }
	        if (spanContext.endTimestamp) {
	            this.endTimestamp = spanContext.endTimestamp;
	        }
	    }
	    /**
	     * @inheritDoc
	     * @deprecated
	     */
	    Span.prototype.child = function (spanContext) {
	        return this.startChild(spanContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.startChild = function (spanContext) {
	        var childSpan = new Span(tslib_1.__assign(tslib_1.__assign({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
	        childSpan.spanRecorder = this.spanRecorder;
	        if (childSpan.spanRecorder) {
	            childSpan.spanRecorder.add(childSpan);
	        }
	        childSpan.transaction = this.transaction;
	        return childSpan;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setTag = function (key, value) {
	        var _a;
	        this.tags = tslib_1.__assign(tslib_1.__assign({}, this.tags), (_a = {}, _a[key] = value, _a));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Span.prototype.setData = function (key, value) {
	        var _a;
	        this.data = tslib_1.__assign(tslib_1.__assign({}, this.data), (_a = {}, _a[key] = value, _a));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setStatus = function (value) {
	        this.status = value;
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setHttpStatus = function (httpStatus) {
	        this.setTag('http.status_code', String(httpStatus));
	        var spanStatus = spanStatusfromHttpCode(httpStatus);
	        if (spanStatus !== 'unknown_error') {
	            this.setStatus(spanStatus);
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.isSuccess = function () {
	        return this.status === 'ok';
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.finish = function (endTimestamp) {
	        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : utils_1.timestampWithMs();
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toTraceparent = function () {
	        var sampledString = '';
	        if (this.sampled !== undefined) {
	            sampledString = this.sampled ? '-1' : '-0';
	        }
	        return this.traceId + "-" + this.spanId + sampledString;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toContext = function () {
	        return utils_1.dropUndefinedKeys({
	            data: this.data,
	            description: this.description,
	            endTimestamp: this.endTimestamp,
	            op: this.op,
	            parentSpanId: this.parentSpanId,
	            sampled: this.sampled,
	            spanId: this.spanId,
	            startTimestamp: this.startTimestamp,
	            status: this.status,
	            tags: this.tags,
	            traceId: this.traceId,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.updateWithContext = function (spanContext) {
	        var _a, _b, _c, _d, _e;
	        this.data = (_a = spanContext.data, (_a !== null && _a !== void 0 ? _a : {}));
	        this.description = spanContext.description;
	        this.endTimestamp = spanContext.endTimestamp;
	        this.op = spanContext.op;
	        this.parentSpanId = spanContext.parentSpanId;
	        this.sampled = spanContext.sampled;
	        this.spanId = (_b = spanContext.spanId, (_b !== null && _b !== void 0 ? _b : this.spanId));
	        this.startTimestamp = (_c = spanContext.startTimestamp, (_c !== null && _c !== void 0 ? _c : this.startTimestamp));
	        this.status = spanContext.status;
	        this.tags = (_d = spanContext.tags, (_d !== null && _d !== void 0 ? _d : {}));
	        this.traceId = (_e = spanContext.traceId, (_e !== null && _e !== void 0 ? _e : this.traceId));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.getTraceContext = function () {
	        return utils_1.dropUndefinedKeys({
	            data: Object.keys(this.data).length > 0 ? this.data : undefined,
	            description: this.description,
	            op: this.op,
	            parent_span_id: this.parentSpanId,
	            span_id: this.spanId,
	            status: this.status,
	            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
	            trace_id: this.traceId,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            data: Object.keys(this.data).length > 0 ? this.data : undefined,
	            description: this.description,
	            op: this.op,
	            parent_span_id: this.parentSpanId,
	            span_id: this.spanId,
	            start_timestamp: this.startTimestamp,
	            status: this.status,
	            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
	            timestamp: this.endTimestamp,
	            trace_id: this.traceId,
	        });
	    };
	    return Span;
	}());
	exports.Span = Span;
	/**
	 * Converts a HTTP status code into a {@link SpanStatusType}.
	 *
	 * @param httpStatus The HTTP response status code.
	 * @returns The span status or unknown_error.
	 */
	function spanStatusfromHttpCode(httpStatus) {
	    if (httpStatus < 400 && httpStatus >= 100) {
	        return 'ok';
	    }
	    if (httpStatus >= 400 && httpStatus < 500) {
	        switch (httpStatus) {
	            case 401:
	                return 'unauthenticated';
	            case 403:
	                return 'permission_denied';
	            case 404:
	                return 'not_found';
	            case 409:
	                return 'already_exists';
	            case 413:
	                return 'failed_precondition';
	            case 429:
	                return 'resource_exhausted';
	            default:
	                return 'invalid_argument';
	        }
	    }
	    if (httpStatus >= 500 && httpStatus < 600) {
	        switch (httpStatus) {
	            case 501:
	                return 'unimplemented';
	            case 503:
	                return 'unavailable';
	            case 504:
	                return 'deadline_exceeded';
	            default:
	                return 'internal_error';
	        }
	    }
	    return 'unknown_error';
	}
	exports.spanStatusfromHttpCode = spanStatusfromHttpCode;
	//# sourceMappingURL=span.js.map

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var hub_1 = __webpack_require__(138);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(215);
	var span_1 = __webpack_require__(219);
	/** JSDoc */
	var Transaction = /** @class */ (function (_super) {
	    tslib_1.__extends(Transaction, _super);
	    /**
	     * This constructor should never be called manually. Those instrumenting tracing should use
	     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
	     * @internal
	     * @hideconstructor
	     * @hidden
	     */
	    function Transaction(transactionContext, hub) {
	        var _this = _super.call(this, transactionContext) || this;
	        _this._measurements = {};
	        /**
	         * The reference to the current hub.
	         */
	        _this._hub = hub_1.getCurrentHub();
	        if (utils_1.isInstanceOf(hub, hub_1.Hub)) {
	            _this._hub = hub;
	        }
	        _this.name = transactionContext.name || '';
	        _this.metadata = transactionContext.metadata || {};
	        _this._trimEnd = transactionContext.trimEnd;
	        // this is because transactions are also spans, and spans have a transaction pointer
	        _this.transaction = _this;
	        return _this;
	    }
	    /**
	     * JSDoc
	     */
	    Transaction.prototype.setName = function (name) {
	        this.name = name;
	    };
	    /**
	     * Attaches SpanRecorder to the span itself
	     * @param maxlen maximum number of spans that can be recorded
	     */
	    Transaction.prototype.initSpanRecorder = function (maxlen) {
	        if (maxlen === void 0) { maxlen = 1000; }
	        if (!this.spanRecorder) {
	            this.spanRecorder = new span_1.SpanRecorder(maxlen);
	        }
	        this.spanRecorder.add(this);
	    };
	    /**
	     * Set observed measurements for this transaction.
	     * @hidden
	     */
	    Transaction.prototype.setMeasurements = function (measurements) {
	        this._measurements = tslib_1.__assign({}, measurements);
	    };
	    /**
	     * Set metadata for this transaction.
	     * @hidden
	     */
	    Transaction.prototype.setMetadata = function (newMetadata) {
	        this.metadata = tslib_1.__assign(tslib_1.__assign({}, this.metadata), newMetadata);
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.finish = function (endTimestamp) {
	        var _this = this;
	        // This transaction is already finished, so we should not flush it again.
	        if (this.endTimestamp !== undefined) {
	            return undefined;
	        }
	        if (!this.name) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
	            this.name = '<unlabeled transaction>';
	        }
	        // just sets the end timestamp
	        _super.prototype.finish.call(this, endTimestamp);
	        if (this.sampled !== true) {
	            // At this point if `sampled !== true` we want to discard the transaction.
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
	            var client = this._hub.getClient();
	            var transport = client && client.getTransport && client.getTransport();
	            if (transport && transport.recordLostEvent) {
	                transport.recordLostEvent('sample_rate', 'transaction');
	            }
	            return undefined;
	        }
	        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
	        if (this._trimEnd && finishedSpans.length > 0) {
	            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
	                if (prev.endTimestamp && current.endTimestamp) {
	                    return prev.endTimestamp > current.endTimestamp ? prev : current;
	                }
	                return prev;
	            }).endTimestamp;
	        }
	        var transaction = {
	            contexts: {
	                trace: this.getTraceContext(),
	            },
	            spans: finishedSpans,
	            start_timestamp: this.startTimestamp,
	            tags: this.tags,
	            timestamp: this.endTimestamp,
	            transaction: this.name,
	            type: 'transaction',
	            sdkProcessingMetadata: this.metadata,
	        };
	        var hasMeasurements = Object.keys(this._measurements).length > 0;
	        if (hasMeasurements) {
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
	            transaction.measurements = this._measurements;
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] Finishing " + this.op + " transaction: " + this.name + ".");
	        return this._hub.captureEvent(transaction);
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.toContext = function () {
	        var spanContext = _super.prototype.toContext.call(this);
	        return utils_1.dropUndefinedKeys(tslib_1.__assign(tslib_1.__assign({}, spanContext), { name: this.name, trimEnd: this._trimEnd }));
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.updateWithContext = function (transactionContext) {
	        var _a;
	        _super.prototype.updateWithContext.call(this, transactionContext);
	        this.name = (_a = transactionContext.name, (_a !== null && _a !== void 0 ? _a : ''));
	        this._trimEnd = transactionContext.trimEnd;
	        return this;
	    };
	    return Transaction;
	}(span_1.Span));
	exports.Transaction = Transaction;
	//# sourceMappingURL=transaction.js.map

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var express_1 = __webpack_require__(222);
	exports.Express = express_1.Express;
	var postgres_1 = __webpack_require__(223);
	exports.Postgres = postgres_1.Postgres;
	var mysql_1 = __webpack_require__(224);
	exports.Mysql = mysql_1.Mysql;
	var mongo_1 = __webpack_require__(225);
	exports.Mongo = mongo_1.Mongo;
	// TODO(v7): Remove this export
	// Please see `src/index.ts` for more details.
	var browser_1 = __webpack_require__(226);
	exports.BrowserTracing = browser_1.BrowserTracing;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(215);
	/**
	 * Express integration
	 *
	 * Provides an request and error handler for Express framework as well as tracing capabilities
	 */
	var Express = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Express(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Express.id;
	        this._router = options.router || options.app;
	        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
	    }
	    /**
	     * @inheritDoc
	     */
	    Express.prototype.setupOnce = function () {
	        if (!this._router) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('ExpressIntegration is missing an Express instance');
	            return;
	        }
	        instrumentMiddlewares(this._router, this._methods);
	    };
	    /**
	     * @inheritDoc
	     */
	    Express.id = 'Express';
	    return Express;
	}());
	exports.Express = Express;
	/**
	 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
	 * and finishes it once the middleware is done invoking.
	 *
	 * Express middlewares have 3 various forms, thus we have to take care of all of them:
	 * // sync
	 * app.use(function (req, res) { ... })
	 * // async
	 * app.use(function (req, res, next) { ... })
	 * // error handler
	 * app.use(function (err, req, res, next) { ... })
	 *
	 * They all internally delegate to the `router[method]` of the given application instance.
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
	function wrap(fn, method) {
	    var arity = fn.length;
	    switch (arity) {
	        case 2: {
	            return function (req, res) {
	                var transaction = res.__sentry_transaction;
	                if (transaction) {
	                    var span_1 = transaction.startChild({
	                        description: fn.name,
	                        op: "express.middleware." + method,
	                    });
	                    res.once('finish', function () {
	                        span_1.finish();
	                    });
	                }
	                return fn.call(this, req, res);
	            };
	        }
	        case 3: {
	            return function (req, res, next) {
	                var _a;
	                var transaction = res.__sentry_transaction;
	                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
	                    description: fn.name,
	                    op: "express.middleware." + method,
	                });
	                fn.call(this, req, res, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    next.call.apply(next, tslib_1.__spread([this], args));
	                });
	            };
	        }
	        case 4: {
	            return function (err, req, res, next) {
	                var _a;
	                var transaction = res.__sentry_transaction;
	                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
	                    description: fn.name,
	                    op: "express.middleware." + method,
	                });
	                fn.call(this, err, req, res, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    next.call.apply(next, tslib_1.__spread([this], args));
	                });
	            };
	        }
	        default: {
	            throw new Error("Express middleware takes 2-4 arguments. Got: " + arity);
	        }
	    }
	}
	/**
	 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
	 * and wraps every function, as well as array of functions with a call to our `wrap` method.
	 * We have to take care of the arrays as well as iterate over all of the arguments,
	 * as `app.use` can accept middlewares in few various forms.
	 *
	 * app.use([<path>], <fn>)
	 * app.use([<path>], <fn>, ...<fn>)
	 * app.use([<path>], ...<fn>[])
	 */
	function wrapMiddlewareArgs(args, method) {
	    return args.map(function (arg) {
	        if (typeof arg === 'function') {
	            return wrap(arg, method);
	        }
	        if (Array.isArray(arg)) {
	            return arg.map(function (a) {
	                if (typeof a === 'function') {
	                    return wrap(a, method);
	                }
	                return a;
	            });
	        }
	        return arg;
	    });
	}
	/**
	 * Patches original router to utilize our tracing functionality
	 */
	function patchMiddleware(router, method) {
	    var originalCallback = router[method];
	    router[method] = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return originalCallback.call.apply(originalCallback, tslib_1.__spread([this], wrapMiddlewareArgs(args, method)));
	    };
	    return router;
	}
	/**
	 * Patches original router methods
	 */
	function instrumentMiddlewares(router, methods) {
	    if (methods === void 0) { methods = []; }
	    methods.forEach(function (method) { return patchMiddleware(router, method); });
	}
	//# sourceMappingURL=express.js.map

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(215);
	/** Tracing integration for node-postgres package */
	var Postgres = /** @class */ (function () {
	    function Postgres(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Postgres.id;
	        this._usePgNative = !!options.usePgNative;
	    }
	    /**
	     * @inheritDoc
	     */
	    Postgres.prototype.setupOnce = function (_, getCurrentHub) {
	        var _a;
	        var pkg = utils_1.loadModule('pg');
	        if (!pkg) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Postgres Integration was unable to require `pg` package.');
	            return;
	        }
	        if (this._usePgNative && !((_a = pkg.native) === null || _a === void 0 ? void 0 : _a.Client)) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error("Postgres Integration was unable to access 'pg-native' bindings.");
	            return;
	        }
	        var Client = (this._usePgNative ? pkg.native : pkg).Client;
	        /**
	         * function (query, callback) => void
	         * function (query, params, callback) => void
	         * function (query) => Promise
	         * function (query, params) => Promise
	         * function (pg.Cursor) => pg.Cursor
	         */
	        utils_1.fill(Client.prototype, 'query', function (orig) {
	            return function (config, values, callback) {
	                var _a, _b, _c;
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
	                    description: typeof config === 'string' ? config : config.text,
	                    op: 'db',
	                });
	                if (typeof callback === 'function') {
	                    return orig.call(this, config, values, function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        callback(err, result);
	                    });
	                }
	                if (typeof values === 'function') {
	                    return orig.call(this, config, function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        values(err, result);
	                    });
	                }
	                var rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
	                if (utils_1.isThenable(rv)) {
	                    return rv.then(function (res) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        return res;
	                    });
	                }
	                (_c = span) === null || _c === void 0 ? void 0 : _c.finish();
	                return rv;
	            };
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Postgres.id = 'Postgres';
	    return Postgres;
	}());
	exports.Postgres = Postgres;
	//# sourceMappingURL=postgres.js.map

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(215);
	/** Tracing integration for node-mysql package */
	var Mysql = /** @class */ (function () {
	    function Mysql() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Mysql.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Mysql.prototype.setupOnce = function (_, getCurrentHub) {
	        var pkg = utils_1.loadModule('mysql/lib/Connection.js');
	        if (!pkg) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Mysql Integration was unable to require `mysql` package.');
	            return;
	        }
	        // The original function will have one of these signatures:
	        //    function (callback) => void
	        //    function (options, callback) => void
	        //    function (options, values, callback) => void
	        utils_1.fill(pkg, 'createQuery', function (orig) {
	            return function (options, values, callback) {
	                var _a, _b;
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
	                    description: typeof options === 'string' ? options : options.sql,
	                    op: 'db',
	                });
	                if (typeof callback === 'function') {
	                    return orig.call(this, options, values, function (err, result, fields) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        callback(err, result, fields);
	                    });
	                }
	                if (typeof values === 'function') {
	                    return orig.call(this, options, function (err, result, fields) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        values(err, result, fields);
	                    });
	                }
	                return orig.call(this, options, values, callback);
	            };
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Mysql.id = 'Mysql';
	    return Mysql;
	}());
	exports.Mysql = Mysql;
	//# sourceMappingURL=mysql.js.map

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(215);
	var OPERATIONS = [
	    'aggregate',
	    'bulkWrite',
	    'countDocuments',
	    'createIndex',
	    'createIndexes',
	    'deleteMany',
	    'deleteOne',
	    'distinct',
	    'drop',
	    'dropIndex',
	    'dropIndexes',
	    'estimatedDocumentCount',
	    'find',
	    'findOne',
	    'findOneAndDelete',
	    'findOneAndReplace',
	    'findOneAndUpdate',
	    'indexes',
	    'indexExists',
	    'indexInformation',
	    'initializeOrderedBulkOp',
	    'insertMany',
	    'insertOne',
	    'isCapped',
	    'mapReduce',
	    'options',
	    'parallelCollectionScan',
	    'rename',
	    'replaceOne',
	    'stats',
	    'updateMany',
	    'updateOne',
	];
	// All of the operations above take `options` and `callback` as their final parameters, but some of them
	// take additional parameters as well. For those operations, this is a map of
	// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
	// positional arguments when we add them to the span's `data` object later
	var OPERATION_SIGNATURES = {
	    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
	    // see https://github.com/getsentry/sentry-javascript/pull/3102
	    bulkWrite: ['operations'],
	    countDocuments: ['query'],
	    createIndex: ['fieldOrSpec'],
	    createIndexes: ['indexSpecs'],
	    deleteMany: ['filter'],
	    deleteOne: ['filter'],
	    distinct: ['key', 'query'],
	    dropIndex: ['indexName'],
	    find: ['query'],
	    findOne: ['query'],
	    findOneAndDelete: ['filter'],
	    findOneAndReplace: ['filter', 'replacement'],
	    findOneAndUpdate: ['filter', 'update'],
	    indexExists: ['indexes'],
	    insertMany: ['docs'],
	    insertOne: ['doc'],
	    mapReduce: ['map', 'reduce'],
	    rename: ['newName'],
	    replaceOne: ['filter', 'doc'],
	    updateMany: ['filter', 'update'],
	    updateOne: ['filter', 'update'],
	};
	/** Tracing integration for mongo package */
	var Mongo = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Mongo(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Mongo.id;
	        this._operations = Array.isArray(options.operations) ? options.operations : OPERATIONS;
	        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
	        this._useMongoose = !!options.useMongoose;
	    }
	    /**
	     * @inheritDoc
	     */
	    Mongo.prototype.setupOnce = function (_, getCurrentHub) {
	        var moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
	        var pkg = utils_1.loadModule(moduleName);
	        if (!pkg) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error("Mongo Integration was unable to require `" + moduleName + "` package.");
	            return;
	        }
	        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
	    };
	    /**
	     * Patches original collection methods
	     */
	    Mongo.prototype._instrumentOperations = function (collection, operations, getCurrentHub) {
	        var _this = this;
	        operations.forEach(function (operation) { return _this._patchOperation(collection, operation, getCurrentHub); });
	    };
	    /**
	     * Patches original collection to utilize our tracing functionality
	     */
	    Mongo.prototype._patchOperation = function (collection, operation, getCurrentHub) {
	        if (!(operation in collection.prototype))
	            return;
	        var getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
	        utils_1.fill(collection.prototype, operation, function (orig) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var _a, _b, _c, _d;
	                var lastArg = args[args.length - 1];
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                // Check if the operation was passed a callback. (mapReduce requires a different check, as
	                // its (non-callback) arguments can also be functions.)
	                if (typeof lastArg !== 'function' || (operation === 'mapReduce' && args.length === 2)) {
	                    var span_1 = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild(getSpanContext(this, operation, args));
	                    var maybePromise = orig.call.apply(orig, tslib_1.__spread([this], args));
	                    if (utils_1.isThenable(maybePromise)) {
	                        return maybePromise.then(function (res) {
	                            var _a;
	                            (_a = span_1) === null || _a === void 0 ? void 0 : _a.finish();
	                            return res;
	                        });
	                    }
	                    else {
	                        (_c = span_1) === null || _c === void 0 ? void 0 : _c.finish();
	                        return maybePromise;
	                    }
	                }
	                var span = (_d = parentSpan) === null || _d === void 0 ? void 0 : _d.startChild(getSpanContext(this, operation, args.slice(0, -1)));
	                return orig.call.apply(orig, tslib_1.__spread([this], args.slice(0, -1), [function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        lastArg(err, result);
	                    }]));
	            };
	        });
	    };
	    /**
	     * Form a SpanContext based on the user input to a given operation.
	     */
	    Mongo.prototype._getSpanContextFromOperationArguments = function (collection, operation, args) {
	        var data = {
	            collectionName: collection.collectionName,
	            dbName: collection.dbName,
	            namespace: collection.namespace,
	        };
	        var spanContext = {
	            op: 'db',
	            description: operation,
	            data: data,
	        };
	        // If the operation takes no arguments besides `options` and `callback`, or if argument
	        // collection is disabled for this operation, just return early.
	        var signature = OPERATION_SIGNATURES[operation];
	        var shouldDescribe = Array.isArray(this._describeOperations)
	            ? this._describeOperations.includes(operation)
	            : this._describeOperations;
	        if (!signature || !shouldDescribe) {
	            return spanContext;
	        }
	        try {
	            // Special case for `mapReduce`, as the only one accepting functions as arguments.
	            if (operation === 'mapReduce') {
	                var _a = tslib_1.__read(args, 2), map = _a[0], reduce = _a[1];
	                data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
	                data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
	            }
	            else {
	                for (var i = 0; i < signature.length; i++) {
	                    data[signature[i]] = JSON.stringify(args[i]);
	                }
	            }
	        }
	        catch (_oO) {
	            // no-empty
	        }
	        return spanContext;
	    };
	    /**
	     * @inheritDoc
	     */
	    Mongo.id = 'Mongo';
	    return Mongo;
	}());
	exports.Mongo = Mongo;
	//# sourceMappingURL=mongo.js.map

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var browsertracing_1 = __webpack_require__(227);
	exports.BrowserTracing = browsertracing_1.BrowserTracing;
	var request_1 = __webpack_require__(239);
	exports.instrumentOutgoingRequests = request_1.instrumentOutgoingRequests;
	exports.defaultRequestInstrumentationOptions = request_1.defaultRequestInstrumentationOptions;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(215);
	var hubextensions_1 = __webpack_require__(213);
	var idletransaction_1 = __webpack_require__(217);
	var utils_2 = __webpack_require__(216);
	var backgroundtab_1 = __webpack_require__(228);
	var metrics_1 = __webpack_require__(229);
	var request_1 = __webpack_require__(239);
	var router_1 = __webpack_require__(240);
	exports.DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
	var DEFAULT_BROWSER_TRACING_OPTIONS = tslib_1.__assign({ idleTimeout: idletransaction_1.DEFAULT_IDLE_TIMEOUT, markBackgroundTransactions: true, maxTransactionDuration: exports.DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: router_1.instrumentRoutingWithDefaults, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, request_1.defaultRequestInstrumentationOptions);
	/**
	 * The Browser Tracing integration automatically instruments browser pageload/navigation
	 * actions as transactions, and captures requests, metrics and errors as spans.
	 *
	 * The integration can be configured with a variety of options, and can be extended to use
	 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
	 */
	var BrowserTracing = /** @class */ (function () {
	    function BrowserTracing(_options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = BrowserTracing.id;
	        /** Store configured idle timeout so that it can be added as a tag to transactions */
	        this._configuredIdleTimeout = undefined;
	        var tracingOrigins = request_1.defaultRequestInstrumentationOptions.tracingOrigins;
	        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
	        if (_options) {
	            this._configuredIdleTimeout = _options.idleTimeout;
	            if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) {
	                tracingOrigins = _options.tracingOrigins;
	            }
	            else {
	                flags_1.IS_DEBUG_BUILD && (this._emitOptionsWarning = true);
	            }
	        }
	        this.options = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
	        var _metricOptions = this.options._metricOptions;
	        this._metrics = new metrics_1.MetricsInstrumentation(_metricOptions && _metricOptions._reportAllChanges);
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
	        var _this = this;
	        this._getCurrentHub = getCurrentHub;
	        if (this._emitOptionsWarning) {
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.warn("[Tracing] We added a reasonable default for you: " + request_1.defaultRequestInstrumentationOptions.tracingOrigins);
	        }
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.options, instrumentRouting = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
	        instrumentRouting(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
	        if (markBackgroundTransactions) {
	            backgroundtab_1.registerBackgroundTabDetection();
	        }
	        request_1.instrumentOutgoingRequests({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
	    };
	    /** Create routing idle transaction. */
	    BrowserTracing.prototype._createRouteTransaction = function (context) {
	        var _this = this;
	        if (!this._getCurrentHub) {
	            flags_1.IS_DEBUG_BUILD &&
	                utils_1.logger.warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
	            return undefined;
	        }
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
	        var parentContextFromHeader = context.op === 'pageload' ? getHeaderContext() : undefined;
	        var expandedContext = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, context), parentContextFromHeader), { trimEnd: true });
	        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
	        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
	        // from being sent to Sentry).
	        var finalContext = modifiedContext === undefined ? tslib_1.__assign(tslib_1.__assign({}, expandedContext), { sampled: false }) : modifiedContext;
	        if (finalContext.sampled === false) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] Starting " + finalContext.op + " transaction on scope");
	        var hub = this._getCurrentHub();
	        var location = utils_1.getGlobalObject().location;
	        var idleTransaction = hubextensions_1.startIdleTransaction(hub, finalContext, idleTimeout, true, { location: location });
	        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
	            _this._metrics.addPerformanceEntries(transaction);
	            adjustTransactionDuration(utils_2.secToMs(maxTransactionDuration), transaction, endTimestamp);
	        });
	        idleTransaction.setTag('idleTimeout', this._configuredIdleTimeout);
	        return idleTransaction;
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserTracing.id = 'BrowserTracing';
	    return BrowserTracing;
	}());
	exports.BrowserTracing = BrowserTracing;
	/**
	 * Gets transaction context from a sentry-trace meta.
	 *
	 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
	 */
	function getHeaderContext() {
	    var header = getMetaContent('sentry-trace');
	    if (header) {
	        return utils_2.extractTraceparentData(header);
	    }
	    return undefined;
	}
	exports.getHeaderContext = getHeaderContext;
	/** Returns the value of a meta tag */
	function getMetaContent(metaName) {
	    var el = utils_1.getGlobalObject().document.querySelector("meta[name=" + metaName + "]");
	    return el ? el.getAttribute('content') : null;
	}
	exports.getMetaContent = getMetaContent;
	/** Adjusts transaction value based on max transaction duration */
	function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
	    var diff = endTimestamp - transaction.startTimestamp;
	    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
	    if (isOutdatedTransaction) {
	        transaction.setStatus('deadline_exceeded');
	        transaction.setTag('maxTransactionDurationExceeded', 'true');
	    }
	}
	//# sourceMappingURL=browsertracing.js.map

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var constants_1 = __webpack_require__(218);
	var flags_1 = __webpack_require__(215);
	var utils_2 = __webpack_require__(216);
	var global = utils_1.getGlobalObject();
	/**
	 * Add a listener that cancels and finishes a transaction when the global
	 * document is hidden.
	 */
	function registerBackgroundTabDetection() {
	    if (global && global.document) {
	        global.document.addEventListener('visibilitychange', function () {
	            var activeTransaction = utils_2.getActiveTransaction();
	            if (global.document.hidden && activeTransaction) {
	                var statusType = 'cancelled';
	                flags_1.IS_DEBUG_BUILD &&
	                    utils_1.logger.log("[Tracing] Transaction: " + statusType + " -> since tab moved to the background, op: " + activeTransaction.op);
	                // We should not set status if it is already set, this prevent important statuses like
	                // error or data loss from being overwritten on transaction.
	                if (!activeTransaction.status) {
	                    activeTransaction.setStatus(statusType);
	                }
	                activeTransaction.setTag('visibilitychange', 'document.hidden');
	                activeTransaction.setTag(constants_1.FINISH_REASON_TAG, constants_1.IDLE_TRANSACTION_FINISH_REASONS[2]);
	                activeTransaction.finish();
	            }
	        });
	    }
	    else {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('[Tracing] Could not set up background tab detection due to lack of global document');
	    }
	}
	exports.registerBackgroundTabDetection = registerBackgroundTabDetection;
	//# sourceMappingURL=backgroundtab.js.map

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(215);
	var utils_2 = __webpack_require__(216);
	var getCLS_1 = __webpack_require__(230);
	var getFID_1 = __webpack_require__(236);
	var getLCP_1 = __webpack_require__(238);
	var getVisibilityWatcher_1 = __webpack_require__(237);
	var global = utils_1.getGlobalObject();
	/** Class tracking metrics  */
	var MetricsInstrumentation = /** @class */ (function () {
	    function MetricsInstrumentation(_reportAllChanges) {
	        if (_reportAllChanges === void 0) { _reportAllChanges = false; }
	        this._reportAllChanges = _reportAllChanges;
	        this._measurements = {};
	        this._performanceCursor = 0;
	        if (!utils_1.isNodeEnv() && global && global.performance && global.document) {
	            if (global.performance.mark) {
	                global.performance.mark('sentry-tracing-init');
	            }
	            this._trackCLS();
	            this._trackLCP();
	            this._trackFID();
	        }
	    }
	    /** Add performance related spans to a transaction */
	    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
	        var _this = this;
	        if (!global || !global.performance || !global.performance.getEntries || !utils_1.browserPerformanceTimeOrigin) {
	            // Gatekeeper if performance API not available
	            return;
	        }
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Tracing] Adding & adjusting spans using Performance API');
	        var timeOrigin = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	        var responseStartTimestamp;
	        var requestStartTimestamp;
	        global.performance
	            .getEntries()
	            .slice(this._performanceCursor)
	            .forEach(function (entry) {
	            var startTime = utils_2.msToSec(entry.startTime);
	            var duration = utils_2.msToSec(entry.duration);
	            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
	                return;
	            }
	            switch (entry.entryType) {
	                case 'navigation': {
	                    addNavigationSpans(transaction, entry, timeOrigin);
	                    responseStartTimestamp = timeOrigin + utils_2.msToSec(entry.responseStart);
	                    requestStartTimestamp = timeOrigin + utils_2.msToSec(entry.requestStart);
	                    break;
	                }
	                case 'mark':
	                case 'paint':
	                case 'measure': {
	                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
	                    // capture web vitals
	                    var firstHidden = getVisibilityWatcher_1.getVisibilityWatcher();
	                    // Only report if the page wasn't hidden prior to the web vital.
	                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
	                    if (entry.name === 'first-paint' && shouldRecord) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding FP');
	                        _this._measurements['fp'] = { value: entry.startTime };
	                        _this._measurements['mark.fp'] = { value: startTimestamp };
	                    }
	                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding FCP');
	                        _this._measurements['fcp'] = { value: entry.startTime };
	                        _this._measurements['mark.fcp'] = { value: startTimestamp };
	                    }
	                    break;
	                }
	                case 'resource': {
	                    var resourceName = entry.name.replace(global.location.origin, '');
	                    addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
	                    break;
	                }
	                default:
	                // Ignore other entry types.
	            }
	        });
	        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
	        this._trackNavigator(transaction);
	        // Measurements are only available for pageload transactions
	        if (transaction.op === 'pageload') {
	            // normalize applicable web vital values to be relative to transaction.startTimestamp
	            var timeOrigin_1 = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	            // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
	            // start of the response in milliseconds
	            if (typeof responseStartTimestamp === 'number') {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding TTFB');
	                this._measurements['ttfb'] = { value: (responseStartTimestamp - transaction.startTimestamp) * 1000 };
	                if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
	                    // Capture the time spent making the request and receiving the first byte of the response.
	                    // This is the time between the start of the request and the start of the response in milliseconds.
	                    this._measurements['ttfb.requestTime'] = { value: (responseStartTimestamp - requestStartTimestamp) * 1000 };
	                }
	            }
	            ['fcp', 'fp', 'lcp'].forEach(function (name) {
	                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) {
	                    return;
	                }
	                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
	                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
	                // to be adjusted to be relative to transaction.startTimestamp.
	                var oldValue = _this._measurements[name].value;
	                var measurementTimestamp = timeOrigin_1 + utils_2.msToSec(oldValue);
	                // normalizedValue should be in milliseconds
	                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
	                var delta = normalizedValue - oldValue;
	                flags_1.IS_DEBUG_BUILD &&
	                    utils_1.logger.log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
	                _this._measurements[name].value = normalizedValue;
	            });
	            if (this._measurements['mark.fid'] && this._measurements['fid']) {
	                // create span for FID
	                _startChild(transaction, {
	                    description: 'first input delay',
	                    endTimestamp: this._measurements['mark.fid'].value + utils_2.msToSec(this._measurements['fid'].value),
	                    op: 'web.vitals',
	                    startTimestamp: this._measurements['mark.fid'].value,
	                });
	            }
	            // If FCP is not recorded we should not record the cls value
	            // according to the new definition of CLS.
	            if (!('fcp' in this._measurements)) {
	                delete this._measurements.cls;
	            }
	            transaction.setMeasurements(this._measurements);
	            tagMetricInfo(transaction, this._lcpEntry, this._clsEntry);
	            transaction.setTag('sentry_reportAllChanges', this._reportAllChanges);
	        }
	    };
	    /**
	     * Capture the information of the user agent.
	     */
	    MetricsInstrumentation.prototype._trackNavigator = function (transaction) {
	        var navigator = global.navigator;
	        if (!navigator) {
	            return;
	        }
	        // track network connectivity
	        var connection = navigator.connection;
	        if (connection) {
	            if (connection.effectiveType) {
	                transaction.setTag('effectiveConnectionType', connection.effectiveType);
	            }
	            if (connection.type) {
	                transaction.setTag('connectionType', connection.type);
	            }
	            if (isMeasurementValue(connection.rtt)) {
	                this._measurements['connection.rtt'] = { value: connection.rtt };
	            }
	            if (isMeasurementValue(connection.downlink)) {
	                this._measurements['connection.downlink'] = { value: connection.downlink };
	            }
	        }
	        if (isMeasurementValue(navigator.deviceMemory)) {
	            transaction.setTag('deviceMemory', String(navigator.deviceMemory));
	        }
	        if (isMeasurementValue(navigator.hardwareConcurrency)) {
	            transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
	        }
	    };
	    /** Starts tracking the Cumulative Layout Shift on the current page. */
	    MetricsInstrumentation.prototype._trackCLS = function () {
	        var _this = this;
	        // See:
	        // https://web.dev/evolving-cls/
	        // https://web.dev/cls-web-tooling/
	        getCLS_1.getCLS(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding CLS');
	            _this._measurements['cls'] = { value: metric.value };
	            _this._clsEntry = entry;
	        });
	    };
	    /** Starts tracking the Largest Contentful Paint on the current page. */
	    MetricsInstrumentation.prototype._trackLCP = function () {
	        var _this = this;
	        getLCP_1.getLCP(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            var timeOrigin = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	            var startTime = utils_2.msToSec(entry.startTime);
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding LCP');
	            _this._measurements['lcp'] = { value: metric.value };
	            _this._measurements['mark.lcp'] = { value: timeOrigin + startTime };
	            _this._lcpEntry = entry;
	        }, this._reportAllChanges);
	    };
	    /** Starts tracking the First Input Delay on the current page. */
	    MetricsInstrumentation.prototype._trackFID = function () {
	        var _this = this;
	        getFID_1.getFID(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            var timeOrigin = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	            var startTime = utils_2.msToSec(entry.startTime);
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding FID');
	            _this._measurements['fid'] = { value: metric.value };
	            _this._measurements['mark.fid'] = { value: timeOrigin + startTime };
	        });
	    };
	    return MetricsInstrumentation;
	}());
	exports.MetricsInstrumentation = MetricsInstrumentation;
	/** Instrument navigation entries */
	function addNavigationSpans(transaction, entry, timeOrigin) {
	    ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(function (event) {
	        addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
	    });
	    addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
	    addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
	    addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
	    addRequest(transaction, entry, timeOrigin);
	}
	/** Create measure related spans */
	function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
	    var measureStartTimestamp = timeOrigin + startTime;
	    var measureEndTimestamp = measureStartTimestamp + duration;
	    _startChild(transaction, {
	        description: entry.name,
	        endTimestamp: measureEndTimestamp,
	        op: entry.entryType,
	        startTimestamp: measureStartTimestamp,
	    });
	    return measureStartTimestamp;
	}
	/** Create resource-related spans */
	function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
	    // we already instrument based on fetch and xhr, so we don't need to
	    // duplicate spans here.
	    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
	        return;
	    }
	    var data = {};
	    if ('transferSize' in entry) {
	        data['Transfer Size'] = entry.transferSize;
	    }
	    if ('encodedBodySize' in entry) {
	        data['Encoded Body Size'] = entry.encodedBodySize;
	    }
	    if ('decodedBodySize' in entry) {
	        data['Decoded Body Size'] = entry.decodedBodySize;
	    }
	    var startTimestamp = timeOrigin + startTime;
	    var endTimestamp = startTimestamp + duration;
	    _startChild(transaction, {
	        description: resourceName,
	        endTimestamp: endTimestamp,
	        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
	        startTimestamp: startTimestamp,
	        data: data,
	    });
	}
	exports.addResourceSpans = addResourceSpans;
	/** Create performance navigation related spans */
	function addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, description, eventEnd) {
	    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
	    var start = entry[event + "Start"];
	    if (!start || !end) {
	        return;
	    }
	    _startChild(transaction, {
	        op: 'browser',
	        description: (description !== null && description !== void 0 ? description : event),
	        startTimestamp: timeOrigin + utils_2.msToSec(start),
	        endTimestamp: timeOrigin + utils_2.msToSec(end),
	    });
	}
	/** Create request and response related spans */
	function addRequest(transaction, entry, timeOrigin) {
	    _startChild(transaction, {
	        op: 'browser',
	        description: 'request',
	        startTimestamp: timeOrigin + utils_2.msToSec(entry.requestStart),
	        endTimestamp: timeOrigin + utils_2.msToSec(entry.responseEnd),
	    });
	    _startChild(transaction, {
	        op: 'browser',
	        description: 'response',
	        startTimestamp: timeOrigin + utils_2.msToSec(entry.responseStart),
	        endTimestamp: timeOrigin + utils_2.msToSec(entry.responseEnd),
	    });
	}
	/**
	 * Helper function to start child on transactions. This function will make sure that the transaction will
	 * use the start timestamp of the created child span if it is earlier than the transactions actual
	 * start timestamp.
	 */
	function _startChild(transaction, _a) {
	    var startTimestamp = _a.startTimestamp, ctx = tslib_1.__rest(_a, ["startTimestamp"]);
	    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
	        transaction.startTimestamp = startTimestamp;
	    }
	    return transaction.startChild(tslib_1.__assign({ startTimestamp: startTimestamp }, ctx));
	}
	exports._startChild = _startChild;
	/**
	 * Checks if a given value is a valid measurement value.
	 */
	function isMeasurementValue(value) {
	    return typeof value === 'number' && isFinite(value);
	}
	/** Add LCP / CLS data to transaction to allow debugging */
	function tagMetricInfo(transaction, lcpEntry, clsEntry) {
	    if (lcpEntry) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding LCP Data');
	        // Capture Properties of the LCP element that contributes to the LCP.
	        if (lcpEntry.element) {
	            transaction.setTag('lcp.element', utils_1.htmlTreeAsString(lcpEntry.element));
	        }
	        if (lcpEntry.id) {
	            transaction.setTag('lcp.id', lcpEntry.id);
	        }
	        if (lcpEntry.url) {
	            // Trim URL to the first 200 characters.
	            transaction.setTag('lcp.url', lcpEntry.url.trim().slice(0, 200));
	        }
	        transaction.setTag('lcp.size', lcpEntry.size);
	    }
	    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
	    if (clsEntry && clsEntry.sources) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('[Measurements] Adding CLS Data');
	        clsEntry.sources.forEach(function (source, index) {
	            return transaction.setTag("cls.source." + (index + 1), utils_1.htmlTreeAsString(source.node));
	        });
	    }
	}
	//# sourceMappingURL=metrics.js.map

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(231);
	var initMetric_1 = __webpack_require__(232);
	var observe_1 = __webpack_require__(234);
	var onHidden_1 = __webpack_require__(235);
	exports.getCLS = function (onReport, reportAllChanges) {
	    var metric = initMetric_1.initMetric('CLS', 0);
	    var report;
	    var sessionValue = 0;
	    var sessionEntries = [];
	    var entryHandler = function (entry) {
	        // Only count layout shifts without recent user input.
	        // TODO: Figure out why entry can be undefined
	        if (entry && !entry.hadRecentInput) {
	            var firstSessionEntry = sessionEntries[0];
	            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
	            // If the entry occurred less than 1 second after the previous entry and
	            // less than 5 seconds after the first entry in the session, include the
	            // entry in the current session. Otherwise, start a new session.
	            if (sessionValue &&
	                sessionEntries.length !== 0 &&
	                entry.startTime - lastSessionEntry.startTime < 1000 &&
	                entry.startTime - firstSessionEntry.startTime < 5000) {
	                sessionValue += entry.value;
	                sessionEntries.push(entry);
	            }
	            else {
	                sessionValue = entry.value;
	                sessionEntries = [entry];
	            }
	            // If the current session value is larger than the current CLS value,
	            // update CLS and the entries contributing to it.
	            if (sessionValue > metric.value) {
	                metric.value = sessionValue;
	                metric.entries = sessionEntries;
	                if (report) {
	                    report();
	                }
	            }
	        }
	    };
	    var po = observe_1.observe('layout-shift', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, reportAllChanges);
	        onHidden_1.onHidden(function () {
	            po.takeRecords().map(entryHandler);
	            report(true);
	        });
	    }
	};
	//# sourceMappingURL=getCLS.js.map

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bindReporter = function (callback, metric, reportAllChanges) {
	    var prevValue;
	    return function (forceReport) {
	        if (metric.value >= 0) {
	            if (forceReport || reportAllChanges) {
	                metric.delta = metric.value - (prevValue || 0);
	                // Report the metric if there's a non-zero delta or if no previous
	                // value exists (which can happen in the case of the document becoming
	                // hidden when the metric value is 0).
	                // See: https://github.com/GoogleChrome/web-vitals/issues/14
	                if (metric.delta || prevValue === undefined) {
	                    prevValue = metric.value;
	                    callback(metric);
	                }
	            }
	        }
	    };
	};
	//# sourceMappingURL=bindReporter.js.map

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var generateUniqueID_1 = __webpack_require__(233);
	exports.initMetric = function (name, value) {
	    return {
	        name: name,
	        value: (value !== null && value !== void 0 ? value : -1),
	        delta: 0,
	        entries: [],
	        id: generateUniqueID_1.generateUniqueID(),
	    };
	};
	//# sourceMappingURL=initMetric.js.map

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Performantly generate a unique, 30-char string by combining a version
	 * number, the current timestamp with a 13-digit number integer.
	 * @return {string}
	 */
	exports.generateUniqueID = function () {
	    return "v2-" + Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
	};
	//# sourceMappingURL=generateUniqueID.js.map

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Takes a performance entry type and a callback function, and creates a
	 * `PerformanceObserver` instance that will observe the specified entry type
	 * with buffering enabled and call the callback _for each entry_.
	 *
	 * This function also feature-detects entry support and wraps the logic in a
	 * try/catch to avoid errors in unsupporting browsers.
	 */
	exports.observe = function (type, callback) {
	    try {
	        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
	            // More extensive feature detect needed for Firefox due to:
	            // https://github.com/GoogleChrome/web-vitals/issues/142
	            if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
	                return;
	            }
	            var po = new PerformanceObserver(function (l) { return l.getEntries().map(callback); });
	            po.observe({ type: type, buffered: true });
	            return po;
	        }
	    }
	    catch (e) {
	        // Do nothing.
	    }
	    return;
	};
	//# sourceMappingURL=observe.js.map

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	exports.onHidden = function (cb, once) {
	    var onHiddenOrPageHide = function (event) {
	        if (event.type === 'pagehide' || utils_1.getGlobalObject().document.visibilityState === 'hidden') {
	            cb(event);
	            if (once) {
	                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
	                removeEventListener('pagehide', onHiddenOrPageHide, true);
	            }
	        }
	    };
	    addEventListener('visibilitychange', onHiddenOrPageHide, true);
	    // Some browsers have buggy implementations of visibilitychange,
	    // so we use pagehide in addition, just to be safe.
	    addEventListener('pagehide', onHiddenOrPageHide, true);
	};
	//# sourceMappingURL=onHidden.js.map

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(231);
	var getVisibilityWatcher_1 = __webpack_require__(237);
	var initMetric_1 = __webpack_require__(232);
	var observe_1 = __webpack_require__(234);
	var onHidden_1 = __webpack_require__(235);
	exports.getFID = function (onReport, reportAllChanges) {
	    var visibilityWatcher = getVisibilityWatcher_1.getVisibilityWatcher();
	    var metric = initMetric_1.initMetric('FID');
	    var report;
	    var entryHandler = function (entry) {
	        // Only report if the page wasn't hidden prior to the first input.
	        if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
	            metric.value = entry.processingStart - entry.startTime;
	            metric.entries.push(entry);
	            report(true);
	        }
	    };
	    var po = observe_1.observe('first-input', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, reportAllChanges);
	        onHidden_1.onHidden(function () {
	            po.takeRecords().map(entryHandler);
	            po.disconnect();
	        }, true);
	    }
	};
	//# sourceMappingURL=getFID.js.map

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var onHidden_1 = __webpack_require__(235);
	var firstHiddenTime = -1;
	var initHiddenTime = function () {
	    return utils_1.getGlobalObject().document.visibilityState === 'hidden' ? 0 : Infinity;
	};
	var trackChanges = function () {
	    // Update the time if/when the document becomes hidden.
	    onHidden_1.onHidden(function (_a) {
	        var timeStamp = _a.timeStamp;
	        firstHiddenTime = timeStamp;
	    }, true);
	};
	exports.getVisibilityWatcher = function () {
	    if (firstHiddenTime < 0) {
	        // If the document is hidden when this code runs, assume it was hidden
	        // since navigation start. This isn't a perfect heuristic, but it's the
	        // best we can do until an API is available to support querying past
	        // visibilityState.
	        firstHiddenTime = initHiddenTime();
	        trackChanges();
	    }
	    return {
	        get firstHiddenTime() {
	            return firstHiddenTime;
	        },
	    };
	};
	//# sourceMappingURL=getVisibilityWatcher.js.map

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(231);
	var getVisibilityWatcher_1 = __webpack_require__(237);
	var initMetric_1 = __webpack_require__(232);
	var observe_1 = __webpack_require__(234);
	var onHidden_1 = __webpack_require__(235);
	var reportedMetricIDs = {};
	exports.getLCP = function (onReport, reportAllChanges) {
	    var visibilityWatcher = getVisibilityWatcher_1.getVisibilityWatcher();
	    var metric = initMetric_1.initMetric('LCP');
	    var report;
	    var entryHandler = function (entry) {
	        // The startTime attribute returns the value of the renderTime if it is not 0,
	        // and the value of the loadTime otherwise.
	        var value = entry.startTime;
	        // If the page was hidden prior to paint time of the entry,
	        // ignore it and mark the metric as final, otherwise add the entry.
	        if (value < visibilityWatcher.firstHiddenTime) {
	            metric.value = value;
	            metric.entries.push(entry);
	        }
	        if (report) {
	            report();
	        }
	    };
	    var po = observe_1.observe('largest-contentful-paint', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, reportAllChanges);
	        var stopListening_1 = function () {
	            if (!reportedMetricIDs[metric.id]) {
	                po.takeRecords().map(entryHandler);
	                po.disconnect();
	                reportedMetricIDs[metric.id] = true;
	                report(true);
	            }
	        };
	        // Stop listening after input. Note: while scrolling is an input that
	        // stop LCP observation, it's unreliable since it can be programmatically
	        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
	        ['keydown', 'click'].forEach(function (type) {
	            addEventListener(type, stopListening_1, { once: true, capture: true });
	        });
	        onHidden_1.onHidden(stopListening_1, true);
	    }
	};
	//# sourceMappingURL=getLCP.js.map

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var utils_2 = __webpack_require__(216);
	exports.DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
	exports.defaultRequestInstrumentationOptions = {
	    traceFetch: true,
	    traceXHR: true,
	    tracingOrigins: exports.DEFAULT_TRACING_ORIGINS,
	};
	/** Registers span creators for xhr and fetch requests  */
	function instrumentOutgoingRequests(_options) {
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    var _a = tslib_1.__assign(tslib_1.__assign({}, exports.defaultRequestInstrumentationOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
	    // We should cache url -> decision so that we don't have to compute
	    // regexp everytime we create a request.
	    var urlMap = {};
	    var defaultShouldCreateSpan = function (url) {
	        if (urlMap[url]) {
	            return urlMap[url];
	        }
	        var origins = tracingOrigins;
	        urlMap[url] =
	            origins.some(function (origin) { return utils_1.isMatchingPattern(url, origin); }) &&
	                !utils_1.isMatchingPattern(url, 'sentry_key');
	        return urlMap[url];
	    };
	    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
	    // That's why we filter out already unwanted Spans from tracingOrigins
	    var shouldCreateSpan = defaultShouldCreateSpan;
	    if (typeof shouldCreateSpanForRequest === 'function') {
	        shouldCreateSpan = function (url) {
	            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
	        };
	    }
	    var spans = {};
	    if (traceFetch) {
	        utils_1.addInstrumentationHandler('fetch', function (handlerData) {
	            fetchCallback(handlerData, shouldCreateSpan, spans);
	        });
	    }
	    if (traceXHR) {
	        utils_1.addInstrumentationHandler('xhr', function (handlerData) {
	            xhrCallback(handlerData, shouldCreateSpan, spans);
	        });
	    }
	}
	exports.instrumentOutgoingRequests = instrumentOutgoingRequests;
	/**
	 * Create and track fetch request spans
	 */
	function fetchCallback(handlerData, shouldCreateSpan, spans) {
	    if (!utils_2.hasTracingEnabled() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
	        return;
	    }
	    if (handlerData.endTimestamp) {
	        var spanId = handlerData.fetchData.__span;
	        if (!spanId)
	            return;
	        var span = spans[spanId];
	        if (span) {
	            if (handlerData.response) {
	                // TODO (kmclb) remove this once types PR goes through
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                span.setHttpStatus(handlerData.response.status);
	            }
	            else if (handlerData.error) {
	                span.setStatus('internal_error');
	            }
	            span.finish();
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete spans[spanId];
	        }
	        return;
	    }
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var span = activeTransaction.startChild({
	            data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { type: 'fetch' }),
	            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
	            op: 'http.client',
	        });
	        handlerData.fetchData.__span = span.spanId;
	        spans[span.spanId] = span;
	        var request = (handlerData.args[0] = handlerData.args[0]);
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var options = (handlerData.args[1] = handlerData.args[1] || {});
	        var headers = options.headers;
	        if (utils_1.isInstanceOf(request, Request)) {
	            headers = request.headers;
	        }
	        if (headers) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (typeof headers.append === 'function') {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                headers.append('sentry-trace', span.toTraceparent());
	            }
	            else if (Array.isArray(headers)) {
	                headers = tslib_1.__spread(headers, [['sentry-trace', span.toTraceparent()]]);
	            }
	            else {
	                headers = tslib_1.__assign(tslib_1.__assign({}, headers), { 'sentry-trace': span.toTraceparent() });
	            }
	        }
	        else {
	            headers = { 'sentry-trace': span.toTraceparent() };
	        }
	        options.headers = headers;
	    }
	}
	exports.fetchCallback = fetchCallback;
	/**
	 * Create and track xhr request spans
	 */
	function xhrCallback(handlerData, shouldCreateSpan, spans) {
	    if (!utils_2.hasTracingEnabled() ||
	        (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
	        !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) {
	        return;
	    }
	    var xhr = handlerData.xhr.__sentry_xhr__;
	    // check first if the request has finished and is tracked by an existing span which should now end
	    if (handlerData.endTimestamp) {
	        var spanId = handlerData.xhr.__sentry_xhr_span_id__;
	        if (!spanId)
	            return;
	        var span = spans[spanId];
	        if (span) {
	            span.setHttpStatus(xhr.status_code);
	            span.finish();
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete spans[spanId];
	        }
	        return;
	    }
	    // if not, create a new span to track it
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var span = activeTransaction.startChild({
	            data: tslib_1.__assign(tslib_1.__assign({}, xhr.data), { type: 'xhr', method: xhr.method, url: xhr.url }),
	            description: xhr.method + " " + xhr.url,
	            op: 'http.client',
	        });
	        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
	        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
	        if (handlerData.xhr.setRequestHeader) {
	            try {
	                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
	            }
	            catch (_) {
	                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
	            }
	        }
	    }
	}
	exports.xhrCallback = xhrCallback;
	//# sourceMappingURL=request.js.map

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(215);
	var global = utils_1.getGlobalObject();
	/**
	 * Default function implementing pageload and navigation transactions
	 */
	function instrumentRoutingWithDefaults(customStartTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
	    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
	    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
	    if (!global || !global.location) {
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Could not initialize routing instrumentation due to invalid location');
	        return;
	    }
	    var startingUrl = global.location.href;
	    var activeTransaction;
	    if (startTransactionOnPageLoad) {
	        activeTransaction = customStartTransaction({ name: global.location.pathname, op: 'pageload' });
	    }
	    if (startTransactionOnLocationChange) {
	        utils_1.addInstrumentationHandler('history', function (_a) {
	            var to = _a.to, from = _a.from;
	            /**
	             * This early return is there to account for some cases where a navigation transaction starts right after
	             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
	             * create an uneccessary navigation transaction.
	             *
	             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
	             * only be caused in certain development environments where the usage of a hot module reloader is causing
	             * errors.
	             */
	            if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
	                startingUrl = undefined;
	                return;
	            }
	            if (from !== to) {
	                startingUrl = undefined;
	                if (activeTransaction) {
	                    flags_1.IS_DEBUG_BUILD && utils_1.logger.log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
	                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
	                    activeTransaction.finish();
	                }
	                activeTransaction = customStartTransaction({ name: global.location.pathname, op: 'navigation' });
	            }
	        });
	    }
	}
	exports.instrumentRoutingWithDefaults = instrumentRoutingWithDefaults;
	//# sourceMappingURL=router.js.map

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** The status of an Span.
	 *
	 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
	 */
	// eslint-disable-next-line import/export
	var SpanStatus;
	(function (SpanStatus) {
	    /** The operation completed successfully. */
	    SpanStatus["Ok"] = "ok";
	    /** Deadline expired before operation could complete. */
	    SpanStatus["DeadlineExceeded"] = "deadline_exceeded";
	    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */
	    SpanStatus["Unauthenticated"] = "unauthenticated";
	    /** 403 Forbidden */
	    SpanStatus["PermissionDenied"] = "permission_denied";
	    /** 404 Not Found. Some requested entity (file or directory) was not found. */
	    SpanStatus["NotFound"] = "not_found";
	    /** 429 Too Many Requests */
	    SpanStatus["ResourceExhausted"] = "resource_exhausted";
	    /** Client specified an invalid argument. 4xx. */
	    SpanStatus["InvalidArgument"] = "invalid_argument";
	    /** 501 Not Implemented */
	    SpanStatus["Unimplemented"] = "unimplemented";
	    /** 503 Service Unavailable */
	    SpanStatus["Unavailable"] = "unavailable";
	    /** Other/generic 5xx. */
	    SpanStatus["InternalError"] = "internal_error";
	    /** Unknown. Any non-standard HTTP status code. */
	    SpanStatus["UnknownError"] = "unknown_error";
	    /** The operation was cancelled (typically by the user). */
	    SpanStatus["Cancelled"] = "cancelled";
	    /** Already exists (409) */
	    SpanStatus["AlreadyExists"] = "already_exists";
	    /** Operation was rejected because the system is not in a state required for the operation's */
	    SpanStatus["FailedPrecondition"] = "failed_precondition";
	    /** The operation was aborted, typically due to a concurrency issue. */
	    SpanStatus["Aborted"] = "aborted";
	    /** Operation was attempted past the valid range. */
	    SpanStatus["OutOfRange"] = "out_of_range";
	    /** Unrecoverable data loss or corruption */
	    SpanStatus["DataLoss"] = "data_loss";
	})(SpanStatus = exports.SpanStatus || (exports.SpanStatus = {}));
	//# sourceMappingURL=spanstatus.js.map

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var angular_1 = __webpack_require__(243);
	exports.Angular = angular_1.Angular;
	var captureconsole_1 = __webpack_require__(245);
	exports.CaptureConsole = captureconsole_1.CaptureConsole;
	var debug_1 = __webpack_require__(246);
	exports.Debug = debug_1.Debug;
	var dedupe_1 = __webpack_require__(247);
	exports.Dedupe = dedupe_1.Dedupe;
	var ember_1 = __webpack_require__(248);
	exports.Ember = ember_1.Ember;
	var extraerrordata_1 = __webpack_require__(249);
	exports.ExtraErrorData = extraerrordata_1.ExtraErrorData;
	var offline_1 = __webpack_require__(250);
	exports.Offline = offline_1.Offline;
	var reportingobserver_1 = __webpack_require__(252);
	exports.ReportingObserver = reportingobserver_1.ReportingObserver;
	var rewriteframes_1 = __webpack_require__(253);
	exports.RewriteFrames = rewriteframes_1.RewriteFrames;
	var sessiontiming_1 = __webpack_require__(254);
	exports.SessionTiming = sessiontiming_1.SessionTiming;
	var transaction_1 = __webpack_require__(255);
	exports.Transaction = transaction_1.Transaction;
	var vue_1 = __webpack_require__(256);
	exports.Vue = vue_1.Vue;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(244);
	// See https://github.com/angular/angular.js/blob/v1.4.7/src/minErr.js
	var angularPattern = /^\[((?:[$a-zA-Z0-9]+:)?(?:[$a-zA-Z0-9]+))\] (.*?)\n?(\S+)$/;
	/**
	 * AngularJS integration
	 *
	 * Provides an $exceptionHandler for AngularJS
	 */
	var Angular = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function Angular(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Angular.id;
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('You are still using the Angular integration, consider moving to @sentry/angular');
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	        this._angular = options.angular || utils_1.getGlobalObject().angular;
	        if (!this._angular) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('AngularIntegration is missing an Angular instance');
	            return;
	        }
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        this._module = this._angular.module(Angular.moduleName, []);
	    }
	    /**
	     * @inheritDoc
	     */
	    Angular.prototype.setupOnce = function (_, getCurrentHub) {
	        var _this = this;
	        if (!this._module) {
	            return;
	        }
	        this._getCurrentHub = getCurrentHub;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        this._module.config([
	            '$provide',
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            function ($provide) {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                $provide.decorator('$exceptionHandler', ['$delegate', _this._$exceptionHandlerDecorator.bind(_this)]);
	            },
	        ]);
	    };
	    /**
	     * Angular's exceptionHandler for Sentry integration
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Angular.prototype._$exceptionHandlerDecorator = function ($delegate) {
	        var _this = this;
	        return function (exception, cause) {
	            var hub = _this._getCurrentHub && _this._getCurrentHub();
	            if (hub && hub.getIntegration(Angular)) {
	                hub.withScope(function (scope) {
	                    if (cause) {
	                        scope.setExtra('cause', cause);
	                    }
	                    scope.addEventProcessor(function (event) {
	                        var ex = event.exception && event.exception.values && event.exception.values[0];
	                        if (ex) {
	                            var matches = angularPattern.exec(ex.value || '');
	                            if (matches) {
	                                // This type now becomes something like: $rootScope:inprog
	                                ex.type = matches[1];
	                                ex.value = matches[2];
	                                event.message = ex.type + ": " + ex.value;
	                                // auto set a new tag specifically for the angular error url
	                                event.extra = tslib_1.__assign(tslib_1.__assign({}, event.extra), { angularDocs: matches[3].substr(0, 250) });
	                            }
	                        }
	                        return event;
	                    });
	                    hub.captureException(exception);
	                });
	            }
	            $delegate(exception, cause);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    Angular.id = 'AngularJS';
	    /**
	     * moduleName used in Angular's DI resolution algorithm
	     */
	    Angular.moduleName = 'ngSentry';
	    return Angular;
	}());
	exports.Angular = Angular;
	//# sourceMappingURL=angular.js.map

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	/*
	 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
	 * for users.
	 *
	 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
	 * because some build tools have trouble tree-shaking imported guards.
	 *
	 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
	 *
	 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
	 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
	 * replaced.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Flag that is true for debug builds, false otherwise. */
	exports.IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
	//# sourceMappingURL=flags.js.map

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var global = utils_1.getGlobalObject();
	/** Send Console API calls as Sentry Events */
	var CaptureConsole = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function CaptureConsole(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = CaptureConsole.id;
	        /**
	         * @inheritDoc
	         */
	        this._levels = utils_1.CONSOLE_LEVELS;
	        if (options.levels) {
	            this._levels = options.levels;
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    CaptureConsole.prototype.setupOnce = function (_, getCurrentHub) {
	        if (!('console' in global)) {
	            return;
	        }
	        this._levels.forEach(function (level) {
	            if (!(level in global.console)) {
	                return;
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            utils_1.fill(global.console, level, function (originalConsoleMethod) { return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var hub = getCurrentHub();
	                if (hub.getIntegration(CaptureConsole)) {
	                    hub.withScope(function (scope) {
	                        scope.setLevel(utils_1.severityFromString(level));
	                        scope.setExtra('arguments', args);
	                        scope.addEventProcessor(function (event) {
	                            event.logger = 'console';
	                            return event;
	                        });
	                        var message = utils_1.safeJoin(args, ' ');
	                        if (level === 'assert') {
	                            if (args[0] === false) {
	                                message = "Assertion failed: " + (utils_1.safeJoin(args.slice(1), ' ') || 'console.assert');
	                                scope.setExtra('arguments', args.slice(1));
	                                hub.captureMessage(message);
	                            }
	                        }
	                        else if (level === 'error' && args[0] instanceof Error) {
	                            hub.captureException(args[0]);
	                        }
	                        else {
	                            hub.captureMessage(message);
	                        }
	                    });
	                }
	                // this fails for some browsers. :(
	                if (originalConsoleMethod) {
	                    originalConsoleMethod.apply(global.console, args);
	                }
	            }; });
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    CaptureConsole.id = 'CaptureConsole';
	    return CaptureConsole;
	}());
	exports.CaptureConsole = CaptureConsole;
	//# sourceMappingURL=captureconsole.js.map

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	/**
	 * Integration to debug sent Sentry events.
	 * This integration should not be used in production
	 */
	var Debug = /** @class */ (function () {
	    function Debug(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = Debug.id;
	        this._options = tslib_1.__assign({ debugger: false, stringify: false }, options);
	    }
	    /**
	     * @inheritDoc
	     */
	    Debug.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event, hint) {
	            var self = getCurrentHub().getIntegration(Debug);
	            if (self) {
	                if (self._options.debugger) {
	                    // eslint-disable-next-line no-debugger
	                    debugger;
	                }
	                /* eslint-disable no-console */
	                utils_1.consoleSandbox(function () {
	                    if (self._options.stringify) {
	                        console.log(JSON.stringify(event, null, 2));
	                        if (hint) {
	                            console.log(JSON.stringify(hint, null, 2));
	                        }
	                    }
	                    else {
	                        console.log(event);
	                        if (hint) {
	                            console.log(hint);
	                        }
	                    }
	                });
	                /* eslint-enable no-console */
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Debug.id = 'Debug';
	    return Debug;
	}());
	exports.Debug = Debug;
	//# sourceMappingURL=debug.js.map

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(244);
	/** Deduplication filter */
	var Dedupe = /** @class */ (function () {
	    function Dedupe() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Dedupe.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (currentEvent) {
	            var self = getCurrentHub().getIntegration(Dedupe);
	            if (self) {
	                // Juuust in case something goes wrong
	                try {
	                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Event dropped due to being a duplicate of previously captured event.');
	                        return null;
	                    }
	                }
	                catch (_oO) {
	                    return (self._previousEvent = currentEvent);
	                }
	                return (self._previousEvent = currentEvent);
	            }
	            return currentEvent;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Dedupe.id = 'Dedupe';
	    return Dedupe;
	}());
	exports.Dedupe = Dedupe;
	/** JSDoc */
	function _shouldDropEvent(currentEvent, previousEvent) {
	    if (!previousEvent) {
	        return false;
	    }
	    if (_isSameMessageEvent(currentEvent, previousEvent)) {
	        return true;
	    }
	    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
	        return true;
	    }
	    return false;
	}
	exports._shouldDropEvent = _shouldDropEvent;
	/** JSDoc */
	function _isSameMessageEvent(currentEvent, previousEvent) {
	    var currentMessage = currentEvent.message;
	    var previousMessage = previousEvent.message;
	    // If neither event has a message property, they were both exceptions, so bail out
	    if (!currentMessage && !previousMessage) {
	        return false;
	    }
	    // If only one event has a stacktrace, but not the other one, they are not the same
	    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
	        return false;
	    }
	    if (currentMessage !== previousMessage) {
	        return false;
	    }
	    if (!_isSameFingerprint(currentEvent, previousEvent)) {
	        return false;
	    }
	    if (!_isSameStacktrace(currentEvent, previousEvent)) {
	        return false;
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameExceptionEvent(currentEvent, previousEvent) {
	    var previousException = _getExceptionFromEvent(previousEvent);
	    var currentException = _getExceptionFromEvent(currentEvent);
	    if (!previousException || !currentException) {
	        return false;
	    }
	    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
	        return false;
	    }
	    if (!_isSameFingerprint(currentEvent, previousEvent)) {
	        return false;
	    }
	    if (!_isSameStacktrace(currentEvent, previousEvent)) {
	        return false;
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameStacktrace(currentEvent, previousEvent) {
	    var currentFrames = _getFramesFromEvent(currentEvent);
	    var previousFrames = _getFramesFromEvent(previousEvent);
	    // If neither event has a stacktrace, they are assumed to be the same
	    if (!currentFrames && !previousFrames) {
	        return true;
	    }
	    // If only one event has a stacktrace, but not the other one, they are not the same
	    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
	        return false;
	    }
	    currentFrames = currentFrames;
	    previousFrames = previousFrames;
	    // If number of frames differ, they are not the same
	    if (previousFrames.length !== currentFrames.length) {
	        return false;
	    }
	    // Otherwise, compare the two
	    for (var i = 0; i < previousFrames.length; i++) {
	        var frameA = previousFrames[i];
	        var frameB = currentFrames[i];
	        if (frameA.filename !== frameB.filename ||
	            frameA.lineno !== frameB.lineno ||
	            frameA.colno !== frameB.colno ||
	            frameA.function !== frameB.function) {
	            return false;
	        }
	    }
	    return true;
	}
	/** JSDoc */
	function _isSameFingerprint(currentEvent, previousEvent) {
	    var currentFingerprint = currentEvent.fingerprint;
	    var previousFingerprint = previousEvent.fingerprint;
	    // If neither event has a fingerprint, they are assumed to be the same
	    if (!currentFingerprint && !previousFingerprint) {
	        return true;
	    }
	    // If only one event has a fingerprint, but not the other one, they are not the same
	    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
	        return false;
	    }
	    currentFingerprint = currentFingerprint;
	    previousFingerprint = previousFingerprint;
	    // Otherwise, compare the two
	    try {
	        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
	    }
	    catch (_oO) {
	        return false;
	    }
	}
	/** JSDoc */
	function _getExceptionFromEvent(event) {
	    return event.exception && event.exception.values && event.exception.values[0];
	}
	/** JSDoc */
	function _getFramesFromEvent(event) {
	    var exception = event.exception;
	    if (exception) {
	        try {
	            // @ts-ignore Object could be undefined
	            return exception.values[0].stacktrace.frames;
	        }
	        catch (_oO) {
	            return undefined;
	        }
	    }
	    else if (event.stacktrace) {
	        return event.stacktrace.frames;
	    }
	    return undefined;
	}
	//# sourceMappingURL=dedupe.js.map

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(244);
	/** JSDoc */
	var Ember = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function Ember(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Ember.id;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	        this._Ember = options.Ember || utils_1.getGlobalObject().Ember;
	    }
	    /**
	     * @inheritDoc
	     */
	    Ember.prototype.setupOnce = function (_, getCurrentHub) {
	        var _this = this;
	        if (!this._Ember) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('EmberIntegration is missing an Ember instance');
	            return;
	        }
	        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	        var oldOnError = this._Ember.onerror;
	        this._Ember.onerror = function (error) {
	            if (getCurrentHub().getIntegration(Ember)) {
	                getCurrentHub().captureException(error, { originalException: error });
	            }
	            if (typeof oldOnError === 'function') {
	                oldOnError.call(_this._Ember, error);
	            }
	            else if (_this._Ember.testing) {
	                throw error;
	            }
	        };
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this._Ember.RSVP.on('error', function (reason) {
	            if (getCurrentHub().getIntegration(Ember)) {
	                getCurrentHub().withScope(function (scope) {
	                    if (utils_1.isInstanceOf(reason, Error)) {
	                        scope.setExtra('context', 'Unhandled Promise error detected');
	                        getCurrentHub().captureException(reason, { originalException: reason });
	                    }
	                    else {
	                        scope.setExtra('reason', reason);
	                        getCurrentHub().captureMessage('Unhandled Promise error detected');
	                    }
	                });
	            }
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Ember.id = 'Ember';
	    return Ember;
	}());
	exports.Ember = Ember;
	//# sourceMappingURL=ember.js.map

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(244);
	/** Patch toString calls to return proper name for wrapped functions */
	var ExtraErrorData = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function ExtraErrorData(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = ExtraErrorData.id;
	        this._options = tslib_1.__assign({ depth: 3 }, options);
	    }
	    /**
	     * @inheritDoc
	     */
	    ExtraErrorData.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event, hint) {
	            var self = getCurrentHub().getIntegration(ExtraErrorData);
	            if (!self) {
	                return event;
	            }
	            return self.enhanceEventWithErrorData(event, hint);
	        });
	    };
	    /**
	     * Attaches extracted information from the Error object to extra field in the Event
	     */
	    ExtraErrorData.prototype.enhanceEventWithErrorData = function (event, hint) {
	        var _a;
	        if (!hint || !hint.originalException || !utils_1.isError(hint.originalException)) {
	            return event;
	        }
	        var name = hint.originalException.name || hint.originalException.constructor.name;
	        var errorData = this._extractErrorData(hint.originalException);
	        if (errorData) {
	            var contexts = tslib_1.__assign({}, event.contexts);
	            var normalizedErrorData = utils_1.normalize(errorData, this._options.depth);
	            if (utils_1.isPlainObject(normalizedErrorData)) {
	                contexts = tslib_1.__assign(tslib_1.__assign({}, event.contexts), (_a = {}, _a[name] = tslib_1.__assign({}, normalizedErrorData), _a));
	            }
	            return tslib_1.__assign(tslib_1.__assign({}, event), { contexts: contexts });
	        }
	        return event;
	    };
	    /**
	     * Extract extra information from the Error object
	     */
	    ExtraErrorData.prototype._extractErrorData = function (error) {
	        var e_1, _a, e_2, _b;
	        // We are trying to enhance already existing event, so no harm done if it won't succeed
	        try {
	            var nativeKeys = [
	                'name',
	                'message',
	                'stack',
	                'line',
	                'column',
	                'fileName',
	                'lineNumber',
	                'columnNumber',
	                'toJSON',
	            ];
	            var extraErrorInfo = {};
	            try {
	                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
	                for (var _c = tslib_1.__values(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                    var key = _d.value;
	                    if (nativeKeys.indexOf(key) !== -1) {
	                        continue;
	                    }
	                    var value = error[key];
	                    extraErrorInfo[key] = utils_1.isError(value) ? value.toString() : value;
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
	            if (typeof error.toJSON === 'function') {
	                var serializedError = error.toJSON();
	                try {
	                    for (var _e = tslib_1.__values(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()) {
	                        var key = _f.value;
	                        var value = serializedError[key];
	                        extraErrorInfo[key] = utils_1.isError(value) ? value.toString() : value;
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	            return extraErrorInfo;
	        }
	        catch (oO) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Unable to extract extra data from the Error object:', oO);
	        }
	        return null;
	    };
	    /**
	     * @inheritDoc
	     */
	    ExtraErrorData.id = 'ExtraErrorData';
	    return ExtraErrorData;
	}());
	exports.ExtraErrorData = ExtraErrorData;
	//# sourceMappingURL=extraerrordata.js.map

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var localforage_1 = tslib_1.__importDefault(__webpack_require__(251));
	var flags_1 = __webpack_require__(244);
	/**
	 * cache offline errors and send when connected
	 */
	var Offline = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Offline(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Offline.id;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this.global = utils_1.getGlobalObject();
	        this.maxStoredEvents = options.maxStoredEvents || 30; // set a reasonable default
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        this.offlineEventStore = localforage_1.default.createInstance({
	            name: 'sentry/offlineEventStore',
	        });
	    }
	    /**
	     * @inheritDoc
	     */
	    Offline.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        var _this = this;
	        this.hub = getCurrentHub();
	        if ('addEventListener' in this.global) {
	            this.global.addEventListener('online', function () {
	                void _this._sendEvents().catch(function () {
	                    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('could not send cached events');
	                });
	            });
	        }
	        addGlobalEventProcessor(function (event) {
	            if (_this.hub && _this.hub.getIntegration(Offline)) {
	                // cache if we are positively offline
	                if ('navigator' in _this.global && 'onLine' in _this.global.navigator && !_this.global.navigator.onLine) {
	                    void _this._cacheEvent(event)
	                        .then(function (_event) { return _this._enforceMaxEvents(); })
	                        .catch(function (_error) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('could not cache event while offline');
	                    });
	                    // return null on success or failure, because being offline will still result in an error
	                    return null;
	                }
	            }
	            return event;
	        });
	        // if online now, send any events stored in a previous offline session
	        if ('navigator' in this.global && 'onLine' in this.global.navigator && this.global.navigator.onLine) {
	            void this._sendEvents().catch(function () {
	                flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('could not send cached events');
	            });
	        }
	    };
	    /**
	     * cache an event to send later
	     * @param event an event
	     */
	    Offline.prototype._cacheEvent = function (event) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                return [2 /*return*/, this.offlineEventStore.setItem(utils_1.uuid4(), utils_1.normalize(event))];
	            });
	        });
	    };
	    /**
	     * purge excess events if necessary
	     */
	    Offline.prototype._enforceMaxEvents = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var events;
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                events = [];
	                return [2 /*return*/, this.offlineEventStore
	                        .iterate(function (event, cacheKey, _index) {
	                        // aggregate events
	                        events.push({ cacheKey: cacheKey, event: event });
	                    })
	                        .then(function () {
	                        // this promise resolves when the iteration is finished
	                        return _this._purgeEvents(
	                        // purge all events past maxStoredEvents in reverse chronological order
	                        events
	                            .sort(function (a, b) { return (b.event.timestamp || 0) - (a.event.timestamp || 0); })
	                            .slice(_this.maxStoredEvents < events.length ? _this.maxStoredEvents : events.length)
	                            .map(function (event) { return event.cacheKey; }));
	                    })
	                        .catch(function (_error) {
	                        flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('could not enforce max events');
	                    })];
	            });
	        });
	    };
	    /**
	     * purge event from cache
	     */
	    Offline.prototype._purgeEvent = function (cacheKey) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            return tslib_1.__generator(this, function (_a) {
	                return [2 /*return*/, this.offlineEventStore.removeItem(cacheKey)];
	            });
	        });
	    };
	    /**
	     * purge events from cache
	     */
	    Offline.prototype._purgeEvents = function (cacheKeys) {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                // trail with .then to ensure the return type as void and not void|void[]
	                return [2 /*return*/, Promise.all(cacheKeys.map(function (cacheKey) { return _this._purgeEvent(cacheKey); })).then()];
	            });
	        });
	    };
	    /**
	     * send all events
	     */
	    Offline.prototype._sendEvents = function () {
	        return tslib_1.__awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return tslib_1.__generator(this, function (_a) {
	                return [2 /*return*/, this.offlineEventStore.iterate(function (event, cacheKey, _index) {
	                        if (_this.hub) {
	                            _this.hub.captureEvent(event);
	                            void _this._purgeEvent(cacheKey).catch(function (_error) {
	                                flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('could not purge event from cache');
	                            });
	                        }
	                        else {
	                            flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('no hub found - could not send cached event');
	                        }
	                    })];
	            });
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Offline.id = 'Offline';
	    return Offline;
	}());
	exports.Offline = Offline;
	//# sourceMappingURL=offline.js.map

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(global) {/*!
	    localForage -- Offline Storage, Improved
	    Version 1.10.0
	    https://localforage.github.io/localForage
	    (c) 2013-2017 Mozilla, Apache License 2.0
	*/
	(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	(function (global){
	'use strict';
	var Mutation = global.MutationObserver || global.WebKitMutationObserver;

	var scheduleDrain;

	{
	  if (Mutation) {
	    var called = 0;
	    var observer = new Mutation(nextTick);
	    var element = global.document.createTextNode('');
	    observer.observe(element, {
	      characterData: true
	    });
	    scheduleDrain = function () {
	      element.data = (called = ++called % 2);
	    };
	  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
	    var channel = new global.MessageChannel();
	    channel.port1.onmessage = nextTick;
	    scheduleDrain = function () {
	      channel.port2.postMessage(0);
	    };
	  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
	    scheduleDrain = function () {

	      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	      var scriptEl = global.document.createElement('script');
	      scriptEl.onreadystatechange = function () {
	        nextTick();

	        scriptEl.onreadystatechange = null;
	        scriptEl.parentNode.removeChild(scriptEl);
	        scriptEl = null;
	      };
	      global.document.documentElement.appendChild(scriptEl);
	    };
	  } else {
	    scheduleDrain = function () {
	      setTimeout(nextTick, 0);
	    };
	  }
	}

	var draining;
	var queue = [];
	//named nextTick for less confusing stack traces
	function nextTick() {
	  draining = true;
	  var i, oldQueue;
	  var len = queue.length;
	  while (len) {
	    oldQueue = queue;
	    queue = [];
	    i = -1;
	    while (++i < len) {
	      oldQueue[i]();
	    }
	    len = queue.length;
	  }
	  draining = false;
	}

	module.exports = immediate;
	function immediate(task) {
	  if (queue.push(task) === 1 && !draining) {
	    scheduleDrain();
	  }
	}

	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],2:[function(_dereq_,module,exports){
	'use strict';
	var immediate = _dereq_(1);

	/* istanbul ignore next */
	function INTERNAL() {}

	var handlers = {};

	var REJECTED = ['REJECTED'];
	var FULFILLED = ['FULFILLED'];
	var PENDING = ['PENDING'];

	module.exports = Promise;

	function Promise(resolver) {
	  if (typeof resolver !== 'function') {
	    throw new TypeError('resolver must be a function');
	  }
	  this.state = PENDING;
	  this.queue = [];
	  this.outcome = void 0;
	  if (resolver !== INTERNAL) {
	    safelyResolveThenable(this, resolver);
	  }
	}

	Promise.prototype["catch"] = function (onRejected) {
	  return this.then(null, onRejected);
	};
	Promise.prototype.then = function (onFulfilled, onRejected) {
	  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
	    typeof onRejected !== 'function' && this.state === REJECTED) {
	    return this;
	  }
	  var promise = new this.constructor(INTERNAL);
	  if (this.state !== PENDING) {
	    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
	    unwrap(promise, resolver, this.outcome);
	  } else {
	    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
	  }

	  return promise;
	};
	function QueueItem(promise, onFulfilled, onRejected) {
	  this.promise = promise;
	  if (typeof onFulfilled === 'function') {
	    this.onFulfilled = onFulfilled;
	    this.callFulfilled = this.otherCallFulfilled;
	  }
	  if (typeof onRejected === 'function') {
	    this.onRejected = onRejected;
	    this.callRejected = this.otherCallRejected;
	  }
	}
	QueueItem.prototype.callFulfilled = function (value) {
	  handlers.resolve(this.promise, value);
	};
	QueueItem.prototype.otherCallFulfilled = function (value) {
	  unwrap(this.promise, this.onFulfilled, value);
	};
	QueueItem.prototype.callRejected = function (value) {
	  handlers.reject(this.promise, value);
	};
	QueueItem.prototype.otherCallRejected = function (value) {
	  unwrap(this.promise, this.onRejected, value);
	};

	function unwrap(promise, func, value) {
	  immediate(function () {
	    var returnValue;
	    try {
	      returnValue = func(value);
	    } catch (e) {
	      return handlers.reject(promise, e);
	    }
	    if (returnValue === promise) {
	      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
	    } else {
	      handlers.resolve(promise, returnValue);
	    }
	  });
	}

	handlers.resolve = function (self, value) {
	  var result = tryCatch(getThen, value);
	  if (result.status === 'error') {
	    return handlers.reject(self, result.value);
	  }
	  var thenable = result.value;

	  if (thenable) {
	    safelyResolveThenable(self, thenable);
	  } else {
	    self.state = FULFILLED;
	    self.outcome = value;
	    var i = -1;
	    var len = self.queue.length;
	    while (++i < len) {
	      self.queue[i].callFulfilled(value);
	    }
	  }
	  return self;
	};
	handlers.reject = function (self, error) {
	  self.state = REJECTED;
	  self.outcome = error;
	  var i = -1;
	  var len = self.queue.length;
	  while (++i < len) {
	    self.queue[i].callRejected(error);
	  }
	  return self;
	};

	function getThen(obj) {
	  // Make sure we only access the accessor once as required by the spec
	  var then = obj && obj.then;
	  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
	    return function appyThen() {
	      then.apply(obj, arguments);
	    };
	  }
	}

	function safelyResolveThenable(self, thenable) {
	  // Either fulfill, reject or reject with error
	  var called = false;
	  function onError(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.reject(self, value);
	  }

	  function onSuccess(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.resolve(self, value);
	  }

	  function tryToUnwrap() {
	    thenable(onSuccess, onError);
	  }

	  var result = tryCatch(tryToUnwrap);
	  if (result.status === 'error') {
	    onError(result.value);
	  }
	}

	function tryCatch(func, value) {
	  var out = {};
	  try {
	    out.value = func(value);
	    out.status = 'success';
	  } catch (e) {
	    out.status = 'error';
	    out.value = e;
	  }
	  return out;
	}

	Promise.resolve = resolve;
	function resolve(value) {
	  if (value instanceof this) {
	    return value;
	  }
	  return handlers.resolve(new this(INTERNAL), value);
	}

	Promise.reject = reject;
	function reject(reason) {
	  var promise = new this(INTERNAL);
	  return handlers.reject(promise, reason);
	}

	Promise.all = all;
	function all(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }

	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }

	  var values = new Array(len);
	  var resolved = 0;
	  var i = -1;
	  var promise = new this(INTERNAL);

	  while (++i < len) {
	    allResolver(iterable[i], i);
	  }
	  return promise;
	  function allResolver(value, i) {
	    self.resolve(value).then(resolveFromAll, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	    function resolveFromAll(outValue) {
	      values[i] = outValue;
	      if (++resolved === len && !called) {
	        called = true;
	        handlers.resolve(promise, values);
	      }
	    }
	  }
	}

	Promise.race = race;
	function race(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }

	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }

	  var i = -1;
	  var promise = new this(INTERNAL);

	  while (++i < len) {
	    resolver(iterable[i]);
	  }
	  return promise;
	  function resolver(value) {
	    self.resolve(value).then(function (response) {
	      if (!called) {
	        called = true;
	        handlers.resolve(promise, response);
	      }
	    }, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	  }
	}

	},{"1":1}],3:[function(_dereq_,module,exports){
	(function (global){
	'use strict';
	if (typeof global.Promise !== 'function') {
	  global.Promise = _dereq_(2);
	}

	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"2":2}],4:[function(_dereq_,module,exports){
	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function getIDB() {
	    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
	    try {
	        if (typeof indexedDB !== 'undefined') {
	            return indexedDB;
	        }
	        if (typeof webkitIndexedDB !== 'undefined') {
	            return webkitIndexedDB;
	        }
	        if (typeof mozIndexedDB !== 'undefined') {
	            return mozIndexedDB;
	        }
	        if (typeof OIndexedDB !== 'undefined') {
	            return OIndexedDB;
	        }
	        if (typeof msIndexedDB !== 'undefined') {
	            return msIndexedDB;
	        }
	    } catch (e) {
	        return;
	    }
	}

	var idb = getIDB();

	function isIndexedDBValid() {
	    try {
	        // Initialize IndexedDB; fall back to vendor-prefixed versions
	        // if needed.
	        if (!idb || !idb.open) {
	            return false;
	        }
	        // We mimic PouchDB here;
	        //
	        // We test for openDatabase because IE Mobile identifies itself
	        // as Safari. Oh the lulz...
	        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

	        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

	        // Safari <10.1 does not meet our requirements for IDB support
	        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
	        // Safari 10.1 shipped with fetch, we can use that to detect it.
	        // Note: this creates issues with `window.fetch` polyfills and
	        // overrides; see:
	        // https://github.com/localForage/localForage/issues/856
	        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
	        // some outdated implementations of IDB that appear on Samsung
	        // and HTC Android devices <4.4 are missing IDBKeyRange
	        // See: https://github.com/mozilla/localForage/issues/128
	        // See: https://github.com/mozilla/localForage/issues/272
	        typeof IDBKeyRange !== 'undefined';
	    } catch (e) {
	        return false;
	    }
	}

	// Abstracts constructing a Blob object, so it also works in older
	// browsers that don't support the native Blob constructor. (i.e.
	// old QtWebKit versions, at least).
	// Abstracts constructing a Blob object, so it also works in older
	// browsers that don't support the native Blob constructor. (i.e.
	// old QtWebKit versions, at least).
	function createBlob(parts, properties) {
	    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
	    parts = parts || [];
	    properties = properties || {};
	    try {
	        return new Blob(parts, properties);
	    } catch (e) {
	        if (e.name !== 'TypeError') {
	            throw e;
	        }
	        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
	        var builder = new Builder();
	        for (var i = 0; i < parts.length; i += 1) {
	            builder.append(parts[i]);
	        }
	        return builder.getBlob(properties.type);
	    }
	}

	// This is CommonJS because lie is an external dependency, so Rollup
	// can just ignore it.
	if (typeof Promise === 'undefined') {
	    // In the "nopromises" build this will just throw if you don't have
	    // a global promise object, but it would throw anyway later.
	    _dereq_(3);
	}
	var Promise$1 = Promise;

	function executeCallback(promise, callback) {
	    if (callback) {
	        promise.then(function (result) {
	            callback(null, result);
	        }, function (error) {
	            callback(error);
	        });
	    }
	}

	function executeTwoCallbacks(promise, callback, errorCallback) {
	    if (typeof callback === 'function') {
	        promise.then(callback);
	    }

	    if (typeof errorCallback === 'function') {
	        promise["catch"](errorCallback);
	    }
	}

	function normalizeKey(key) {
	    // Cast the key to a string, as that's all we can set as a key.
	    if (typeof key !== 'string') {
	        console.warn(key + ' used as a key, but it is not a string.');
	        key = String(key);
	    }

	    return key;
	}

	function getCallback() {
	    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
	        return arguments[arguments.length - 1];
	    }
	}

	// Some code originally from async_storage.js in
	// [Gaia](https://github.com/mozilla-b2g/gaia).

	var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
	var supportsBlobs = void 0;
	var dbContexts = {};
	var toString = Object.prototype.toString;

	// Transaction Modes
	var READ_ONLY = 'readonly';
	var READ_WRITE = 'readwrite';

	// Transform a binary string to an array buffer, because otherwise
	// weird stuff happens when you try to work with the binary string directly.
	// It is known.
	// From http://stackoverflow.com/questions/14967647/ (continues on next line)
	// encode-decode-image-with-base64-breaks-image (2013-04-21)
	function _binStringToArrayBuffer(bin) {
	    var length = bin.length;
	    var buf = new ArrayBuffer(length);
	    var arr = new Uint8Array(buf);
	    for (var i = 0; i < length; i++) {
	        arr[i] = bin.charCodeAt(i);
	    }
	    return buf;
	}

	//
	// Blobs are not supported in all versions of IndexedDB, notably
	// Chrome <37 and Android <5. In those versions, storing a blob will throw.
	//
	// Various other blob bugs exist in Chrome v37-42 (inclusive).
	// Detecting them is expensive and confusing to users, and Chrome 37-42
	// is at very low usage worldwide, so we do a hacky userAgent check instead.
	//
	// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
	// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
	// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
	//
	// Code borrowed from PouchDB. See:
	// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
	//
	function _checkBlobSupportWithoutCaching(idb) {
	    return new Promise$1(function (resolve) {
	        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
	        var blob = createBlob(['']);
	        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

	        txn.onabort = function (e) {
	            // If the transaction aborts now its due to not being able to
	            // write to the database, likely due to the disk being full
	            e.preventDefault();
	            e.stopPropagation();
	            resolve(false);
	        };

	        txn.oncomplete = function () {
	            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
	            var matchedEdge = navigator.userAgent.match(/Edge\//);
	            // MS Edge pretends to be Chrome 42:
	            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
	            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
	        };
	    })["catch"](function () {
	        return false; // error, so assume unsupported
	    });
	}

	function _checkBlobSupport(idb) {
	    if (typeof supportsBlobs === 'boolean') {
	        return Promise$1.resolve(supportsBlobs);
	    }
	    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
	        supportsBlobs = value;
	        return supportsBlobs;
	    });
	}

	function _deferReadiness(dbInfo) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Create a deferred object representing the current database operation.
	    var deferredOperation = {};

	    deferredOperation.promise = new Promise$1(function (resolve, reject) {
	        deferredOperation.resolve = resolve;
	        deferredOperation.reject = reject;
	    });

	    // Enqueue the deferred operation.
	    dbContext.deferredOperations.push(deferredOperation);

	    // Chain its promise to the database readiness.
	    if (!dbContext.dbReady) {
	        dbContext.dbReady = deferredOperation.promise;
	    } else {
	        dbContext.dbReady = dbContext.dbReady.then(function () {
	            return deferredOperation.promise;
	        });
	    }
	}

	function _advanceReadiness(dbInfo) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Dequeue a deferred operation.
	    var deferredOperation = dbContext.deferredOperations.pop();

	    // Resolve its promise (which is part of the database readiness
	    // chain of promises).
	    if (deferredOperation) {
	        deferredOperation.resolve();
	        return deferredOperation.promise;
	    }
	}

	function _rejectReadiness(dbInfo, err) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Dequeue a deferred operation.
	    var deferredOperation = dbContext.deferredOperations.pop();

	    // Reject its promise (which is part of the database readiness
	    // chain of promises).
	    if (deferredOperation) {
	        deferredOperation.reject(err);
	        return deferredOperation.promise;
	    }
	}

	function _getConnection(dbInfo, upgradeNeeded) {
	    return new Promise$1(function (resolve, reject) {
	        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

	        if (dbInfo.db) {
	            if (upgradeNeeded) {
	                _deferReadiness(dbInfo);
	                dbInfo.db.close();
	            } else {
	                return resolve(dbInfo.db);
	            }
	        }

	        var dbArgs = [dbInfo.name];

	        if (upgradeNeeded) {
	            dbArgs.push(dbInfo.version);
	        }

	        var openreq = idb.open.apply(idb, dbArgs);

	        if (upgradeNeeded) {
	            openreq.onupgradeneeded = function (e) {
	                var db = openreq.result;
	                try {
	                    db.createObjectStore(dbInfo.storeName);
	                    if (e.oldVersion <= 1) {
	                        // Added when support for blob shims was added
	                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
	                    }
	                } catch (ex) {
	                    if (ex.name === 'ConstraintError') {
	                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
	                    } else {
	                        throw ex;
	                    }
	                }
	            };
	        }

	        openreq.onerror = function (e) {
	            e.preventDefault();
	            reject(openreq.error);
	        };

	        openreq.onsuccess = function () {
	            var db = openreq.result;
	            db.onversionchange = function (e) {
	                // Triggered when the database is modified (e.g. adding an objectStore) or
	                // deleted (even when initiated by other sessions in different tabs).
	                // Closing the connection here prevents those operations from being blocked.
	                // If the database is accessed again later by this instance, the connection
	                // will be reopened or the database recreated as needed.
	                e.target.close();
	            };
	            resolve(db);
	            _advanceReadiness(dbInfo);
	        };
	    });
	}

	function _getOriginalConnection(dbInfo) {
	    return _getConnection(dbInfo, false);
	}

	function _getUpgradedConnection(dbInfo) {
	    return _getConnection(dbInfo, true);
	}

	function _isUpgradeNeeded(dbInfo, defaultVersion) {
	    if (!dbInfo.db) {
	        return true;
	    }

	    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
	    var isDowngrade = dbInfo.version < dbInfo.db.version;
	    var isUpgrade = dbInfo.version > dbInfo.db.version;

	    if (isDowngrade) {
	        // If the version is not the default one
	        // then warn for impossible downgrade.
	        if (dbInfo.version !== defaultVersion) {
	            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
	        }
	        // Align the versions to prevent errors.
	        dbInfo.version = dbInfo.db.version;
	    }

	    if (isUpgrade || isNewStore) {
	        // If the store is new then increment the version (if needed).
	        // This will trigger an "upgradeneeded" event which is required
	        // for creating a store.
	        if (isNewStore) {
	            var incVersion = dbInfo.db.version + 1;
	            if (incVersion > dbInfo.version) {
	                dbInfo.version = incVersion;
	            }
	        }

	        return true;
	    }

	    return false;
	}

	// encode a blob for indexeddb engines that don't support blobs
	function _encodeBlob(blob) {
	    return new Promise$1(function (resolve, reject) {
	        var reader = new FileReader();
	        reader.onerror = reject;
	        reader.onloadend = function (e) {
	            var base64 = btoa(e.target.result || '');
	            resolve({
	                __local_forage_encoded_blob: true,
	                data: base64,
	                type: blob.type
	            });
	        };
	        reader.readAsBinaryString(blob);
	    });
	}

	// decode an encoded blob
	function _decodeBlob(encodedBlob) {
	    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
	    return createBlob([arrayBuff], { type: encodedBlob.type });
	}

	// is this one of our fancy encoded blobs?
	function _isEncodedBlob(value) {
	    return value && value.__local_forage_encoded_blob;
	}

	// Specialize the default `ready()` function by making it dependent
	// on the current database operations. Thus, the driver will be actually
	// ready when it's been initialized (default) *and* there are no pending
	// operations on the database (initiated by some other instances).
	function _fullyReady(callback) {
	    var self = this;

	    var promise = self._initReady().then(function () {
	        var dbContext = dbContexts[self._dbInfo.name];

	        if (dbContext && dbContext.dbReady) {
	            return dbContext.dbReady;
	        }
	    });

	    executeTwoCallbacks(promise, callback, callback);
	    return promise;
	}

	// Try to establish a new db connection to replace the
	// current one which is broken (i.e. experiencing
	// InvalidStateError while creating a transaction).
	function _tryReconnect(dbInfo) {
	    _deferReadiness(dbInfo);

	    var dbContext = dbContexts[dbInfo.name];
	    var forages = dbContext.forages;

	    for (var i = 0; i < forages.length; i++) {
	        var forage = forages[i];
	        if (forage._dbInfo.db) {
	            forage._dbInfo.db.close();
	            forage._dbInfo.db = null;
	        }
	    }
	    dbInfo.db = null;

	    return _getOriginalConnection(dbInfo).then(function (db) {
	        dbInfo.db = db;
	        if (_isUpgradeNeeded(dbInfo)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	        }
	        return db;
	    }).then(function (db) {
	        // store the latest db reference
	        // in case the db was upgraded
	        dbInfo.db = dbContext.db = db;
	        for (var i = 0; i < forages.length; i++) {
	            forages[i]._dbInfo.db = db;
	        }
	    })["catch"](function (err) {
	        _rejectReadiness(dbInfo, err);
	        throw err;
	    });
	}

	// FF doesn't like Promises (micro-tasks) and IDDB store operations,
	// so we have to do it with callbacks
	function createTransaction(dbInfo, mode, callback, retries) {
	    if (retries === undefined) {
	        retries = 1;
	    }

	    try {
	        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
	        callback(null, tx);
	    } catch (err) {
	        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
	            return Promise$1.resolve().then(function () {
	                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
	                    // increase the db version, to create the new ObjectStore
	                    if (dbInfo.db) {
	                        dbInfo.version = dbInfo.db.version + 1;
	                    }
	                    // Reopen the database for upgrading.
	                    return _getUpgradedConnection(dbInfo);
	                }
	            }).then(function () {
	                return _tryReconnect(dbInfo).then(function () {
	                    createTransaction(dbInfo, mode, callback, retries - 1);
	                });
	            })["catch"](callback);
	        }

	        callback(err);
	    }
	}

	function createDbContext() {
	    return {
	        // Running localForages sharing a database.
	        forages: [],
	        // Shared database.
	        db: null,
	        // Database readiness (promise).
	        dbReady: null,
	        // Deferred operations on the database.
	        deferredOperations: []
	    };
	}

	// Open the IndexedDB database (automatically creates one if one didn't
	// previously exist), using any options set in the config.
	function _initStorage(options) {
	    var self = this;
	    var dbInfo = {
	        db: null
	    };

	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = options[i];
	        }
	    }

	    // Get the current context of the database;
	    var dbContext = dbContexts[dbInfo.name];

	    // ...or create a new context.
	    if (!dbContext) {
	        dbContext = createDbContext();
	        // Register the new context in the global container.
	        dbContexts[dbInfo.name] = dbContext;
	    }

	    // Register itself as a running localForage in the current context.
	    dbContext.forages.push(self);

	    // Replace the default `ready()` function with the specialized one.
	    if (!self._initReady) {
	        self._initReady = self.ready;
	        self.ready = _fullyReady;
	    }

	    // Create an array of initialization states of the related localForages.
	    var initPromises = [];

	    function ignoreErrors() {
	        // Don't handle errors here,
	        // just makes sure related localForages aren't pending.
	        return Promise$1.resolve();
	    }

	    for (var j = 0; j < dbContext.forages.length; j++) {
	        var forage = dbContext.forages[j];
	        if (forage !== self) {
	            // Don't wait for itself...
	            initPromises.push(forage._initReady()["catch"](ignoreErrors));
	        }
	    }

	    // Take a snapshot of the related localForages.
	    var forages = dbContext.forages.slice(0);

	    // Initialize the connection process only when
	    // all the related localForages aren't pending.
	    return Promise$1.all(initPromises).then(function () {
	        dbInfo.db = dbContext.db;
	        // Get the connection or open a new one without upgrade.
	        return _getOriginalConnection(dbInfo);
	    }).then(function (db) {
	        dbInfo.db = db;
	        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	        }
	        return db;
	    }).then(function (db) {
	        dbInfo.db = dbContext.db = db;
	        self._dbInfo = dbInfo;
	        // Share the final connection amongst related localForages.
	        for (var k = 0; k < forages.length; k++) {
	            var forage = forages[k];
	            if (forage !== self) {
	                // Self is already up-to-date.
	                forage._dbInfo.db = dbInfo.db;
	                forage._dbInfo.version = dbInfo.version;
	            }
	        }
	    });
	}

	function getItem(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.get(key);

	                    req.onsuccess = function () {
	                        var value = req.result;
	                        if (value === undefined) {
	                            value = null;
	                        }
	                        if (_isEncodedBlob(value)) {
	                            value = _decodeBlob(value);
	                        }
	                        resolve(value);
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Iterate over all items stored in database.
	function iterate(iterator, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.openCursor();
	                    var iterationNumber = 1;

	                    req.onsuccess = function () {
	                        var cursor = req.result;

	                        if (cursor) {
	                            var value = cursor.value;
	                            if (_isEncodedBlob(value)) {
	                                value = _decodeBlob(value);
	                            }
	                            var result = iterator(value, cursor.key, iterationNumber++);

	                            // when the iterator callback returns any
	                            // (non-`undefined`) value, then we stop
	                            // the iteration immediately
	                            if (result !== void 0) {
	                                resolve(result);
	                            } else {
	                                cursor["continue"]();
	                            }
	                        } else {
	                            resolve();
	                        }
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);

	    return promise;
	}

	function setItem(key, value, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        var dbInfo;
	        self.ready().then(function () {
	            dbInfo = self._dbInfo;
	            if (toString.call(value) === '[object Blob]') {
	                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
	                    if (blobSupport) {
	                        return value;
	                    }
	                    return _encodeBlob(value);
	                });
	            }
	            return value;
	        }).then(function (value) {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);

	                    // The reason we don't _save_ null is because IE 10 does
	                    // not support saving the `null` type in IndexedDB. How
	                    // ironic, given the bug below!
	                    // See: https://github.com/mozilla/localForage/issues/161
	                    if (value === null) {
	                        value = undefined;
	                    }

	                    var req = store.put(value, key);

	                    transaction.oncomplete = function () {
	                        // Cast to undefined so the value passed to
	                        // callback/promise is the same as what one would get out
	                        // of `getItem()` later. This leads to some weirdness
	                        // (setItem('foo', undefined) will return `null`), but
	                        // it's not my fault localStorage is our baseline and that
	                        // it's weird.
	                        if (value === undefined) {
	                            value = null;
	                        }

	                        resolve(value);
	                    };
	                    transaction.onabort = transaction.onerror = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function removeItem(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    // We use a Grunt task to make this safe for IE and some
	                    // versions of Android (including those used by Cordova).
	                    // Normally IE won't like `.delete()` and will insist on
	                    // using `['delete']()`, but we have a build step that
	                    // fixes this for us now.
	                    var req = store["delete"](key);
	                    transaction.oncomplete = function () {
	                        resolve();
	                    };

	                    transaction.onerror = function () {
	                        reject(req.error);
	                    };

	                    // The request will be also be aborted if we've exceeded our storage
	                    // space.
	                    transaction.onabort = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function clear(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.clear();

	                    transaction.oncomplete = function () {
	                        resolve();
	                    };

	                    transaction.onabort = transaction.onerror = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function length(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.count();

	                    req.onsuccess = function () {
	                        resolve(req.result);
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function key(n, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        if (n < 0) {
	            resolve(null);

	            return;
	        }

	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var advanced = false;
	                    var req = store.openKeyCursor();

	                    req.onsuccess = function () {
	                        var cursor = req.result;
	                        if (!cursor) {
	                            // this means there weren't enough keys
	                            resolve(null);

	                            return;
	                        }

	                        if (n === 0) {
	                            // We have the first key, return it if that's what they
	                            // wanted.
	                            resolve(cursor.key);
	                        } else {
	                            if (!advanced) {
	                                // Otherwise, ask the cursor to skip ahead n
	                                // records.
	                                advanced = true;
	                                cursor.advance(n);
	                            } else {
	                                // When we get here, we've got the nth key.
	                                resolve(cursor.key);
	                            }
	                        }
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.openKeyCursor();
	                    var keys = [];

	                    req.onsuccess = function () {
	                        var cursor = req.result;

	                        if (!cursor) {
	                            resolve(keys);
	                            return;
	                        }

	                        keys.push(cursor.key);
	                        cursor["continue"]();
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function dropInstance(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    var currentConfig = this.config();
	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

	        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
	            var dbContext = dbContexts[options.name];
	            var forages = dbContext.forages;
	            dbContext.db = db;
	            for (var i = 0; i < forages.length; i++) {
	                forages[i]._dbInfo.db = db;
	            }
	            return db;
	        });

	        if (!options.storeName) {
	            promise = dbPromise.then(function (db) {
	                _deferReadiness(options);

	                var dbContext = dbContexts[options.name];
	                var forages = dbContext.forages;

	                db.close();
	                for (var i = 0; i < forages.length; i++) {
	                    var forage = forages[i];
	                    forage._dbInfo.db = null;
	                }

	                var dropDBPromise = new Promise$1(function (resolve, reject) {
	                    var req = idb.deleteDatabase(options.name);

	                    req.onerror = function () {
	                        var db = req.result;
	                        if (db) {
	                            db.close();
	                        }
	                        reject(req.error);
	                    };

	                    req.onblocked = function () {
	                        // Closing all open connections in onversionchange handler should prevent this situation, but if
	                        // we do get here, it just means the request remains pending - eventually it will succeed or error
	                        console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
	                    };

	                    req.onsuccess = function () {
	                        var db = req.result;
	                        if (db) {
	                            db.close();
	                        }
	                        resolve(db);
	                    };
	                });

	                return dropDBPromise.then(function (db) {
	                    dbContext.db = db;
	                    for (var i = 0; i < forages.length; i++) {
	                        var _forage = forages[i];
	                        _advanceReadiness(_forage._dbInfo);
	                    }
	                })["catch"](function (err) {
	                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                    throw err;
	                });
	            });
	        } else {
	            promise = dbPromise.then(function (db) {
	                if (!db.objectStoreNames.contains(options.storeName)) {
	                    return;
	                }

	                var newVersion = db.version + 1;

	                _deferReadiness(options);

	                var dbContext = dbContexts[options.name];
	                var forages = dbContext.forages;

	                db.close();
	                for (var i = 0; i < forages.length; i++) {
	                    var forage = forages[i];
	                    forage._dbInfo.db = null;
	                    forage._dbInfo.version = newVersion;
	                }

	                var dropObjectPromise = new Promise$1(function (resolve, reject) {
	                    var req = idb.open(options.name, newVersion);

	                    req.onerror = function (err) {
	                        var db = req.result;
	                        db.close();
	                        reject(err);
	                    };

	                    req.onupgradeneeded = function () {
	                        var db = req.result;
	                        db.deleteObjectStore(options.storeName);
	                    };

	                    req.onsuccess = function () {
	                        var db = req.result;
	                        db.close();
	                        resolve(db);
	                    };
	                });

	                return dropObjectPromise.then(function (db) {
	                    dbContext.db = db;
	                    for (var j = 0; j < forages.length; j++) {
	                        var _forage2 = forages[j];
	                        _forage2._dbInfo.db = db;
	                        _advanceReadiness(_forage2._dbInfo);
	                    }
	                })["catch"](function (err) {
	                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                    throw err;
	                });
	            });
	        }
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var asyncStorage = {
	    _driver: 'asyncStorage',
	    _initStorage: _initStorage,
	    _support: isIndexedDBValid(),
	    iterate: iterate,
	    getItem: getItem,
	    setItem: setItem,
	    removeItem: removeItem,
	    clear: clear,
	    length: length,
	    key: key,
	    keys: keys,
	    dropInstance: dropInstance
	};

	function isWebSQLValid() {
	    return typeof openDatabase === 'function';
	}

	// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
	// it to Base64, so this is how we store it to prevent very strange errors with less
	// verbose ways of binary <-> string data storage.
	var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

	var BLOB_TYPE_PREFIX = '~~local_forage_type~';
	var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

	var SERIALIZED_MARKER = '__lfsc__:';
	var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

	// OMG the serializations!
	var TYPE_ARRAYBUFFER = 'arbf';
	var TYPE_BLOB = 'blob';
	var TYPE_INT8ARRAY = 'si08';
	var TYPE_UINT8ARRAY = 'ui08';
	var TYPE_UINT8CLAMPEDARRAY = 'uic8';
	var TYPE_INT16ARRAY = 'si16';
	var TYPE_INT32ARRAY = 'si32';
	var TYPE_UINT16ARRAY = 'ur16';
	var TYPE_UINT32ARRAY = 'ui32';
	var TYPE_FLOAT32ARRAY = 'fl32';
	var TYPE_FLOAT64ARRAY = 'fl64';
	var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

	var toString$1 = Object.prototype.toString;

	function stringToBuffer(serializedString) {
	    // Fill the string into a ArrayBuffer.
	    var bufferLength = serializedString.length * 0.75;
	    var len = serializedString.length;
	    var i;
	    var p = 0;
	    var encoded1, encoded2, encoded3, encoded4;

	    if (serializedString[serializedString.length - 1] === '=') {
	        bufferLength--;
	        if (serializedString[serializedString.length - 2] === '=') {
	            bufferLength--;
	        }
	    }

	    var buffer = new ArrayBuffer(bufferLength);
	    var bytes = new Uint8Array(buffer);

	    for (i = 0; i < len; i += 4) {
	        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
	        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
	        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
	        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

	        /*jslint bitwise: true */
	        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
	        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
	        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
	    }
	    return buffer;
	}

	// Converts a buffer to a string to store, serialized, in the backend
	// storage library.
	function bufferToString(buffer) {
	    // base64-arraybuffer
	    var bytes = new Uint8Array(buffer);
	    var base64String = '';
	    var i;

	    for (i = 0; i < bytes.length; i += 3) {
	        /*jslint bitwise: true */
	        base64String += BASE_CHARS[bytes[i] >> 2];
	        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
	        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
	        base64String += BASE_CHARS[bytes[i + 2] & 63];
	    }

	    if (bytes.length % 3 === 2) {
	        base64String = base64String.substring(0, base64String.length - 1) + '=';
	    } else if (bytes.length % 3 === 1) {
	        base64String = base64String.substring(0, base64String.length - 2) + '==';
	    }

	    return base64String;
	}

	// Serialize a value, afterwards executing a callback (which usually
	// instructs the `setItem()` callback/promise to be executed). This is how
	// we store binary data with localStorage.
	function serialize(value, callback) {
	    var valueType = '';
	    if (value) {
	        valueType = toString$1.call(value);
	    }

	    // Cannot use `value instanceof ArrayBuffer` or such here, as these
	    // checks fail when running the tests using casper.js...
	    //
	    // TODO: See why those tests fail and use a better solution.
	    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
	        // Convert binary arrays to a string and prefix the string with
	        // a special marker.
	        var buffer;
	        var marker = SERIALIZED_MARKER;

	        if (value instanceof ArrayBuffer) {
	            buffer = value;
	            marker += TYPE_ARRAYBUFFER;
	        } else {
	            buffer = value.buffer;

	            if (valueType === '[object Int8Array]') {
	                marker += TYPE_INT8ARRAY;
	            } else if (valueType === '[object Uint8Array]') {
	                marker += TYPE_UINT8ARRAY;
	            } else if (valueType === '[object Uint8ClampedArray]') {
	                marker += TYPE_UINT8CLAMPEDARRAY;
	            } else if (valueType === '[object Int16Array]') {
	                marker += TYPE_INT16ARRAY;
	            } else if (valueType === '[object Uint16Array]') {
	                marker += TYPE_UINT16ARRAY;
	            } else if (valueType === '[object Int32Array]') {
	                marker += TYPE_INT32ARRAY;
	            } else if (valueType === '[object Uint32Array]') {
	                marker += TYPE_UINT32ARRAY;
	            } else if (valueType === '[object Float32Array]') {
	                marker += TYPE_FLOAT32ARRAY;
	            } else if (valueType === '[object Float64Array]') {
	                marker += TYPE_FLOAT64ARRAY;
	            } else {
	                callback(new Error('Failed to get type for BinaryArray'));
	            }
	        }

	        callback(marker + bufferToString(buffer));
	    } else if (valueType === '[object Blob]') {
	        // Conver the blob to a binaryArray and then to a string.
	        var fileReader = new FileReader();

	        fileReader.onload = function () {
	            // Backwards-compatible prefix for the blob type.
	            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

	            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
	        };

	        fileReader.readAsArrayBuffer(value);
	    } else {
	        try {
	            callback(JSON.stringify(value));
	        } catch (e) {
	            console.error("Couldn't convert value into a JSON string: ", value);

	            callback(null, e);
	        }
	    }
	}

	// Deserialize data we've inserted into a value column/field. We place
	// special markers into our strings to mark them as encoded; this isn't
	// as nice as a meta field, but it's the only sane thing we can do whilst
	// keeping localStorage support intact.
	//
	// Oftentimes this will just deserialize JSON content, but if we have a
	// special marker (SERIALIZED_MARKER, defined above), we will extract
	// some kind of arraybuffer/binary data/typed array out of the string.
	function deserialize(value) {
	    // If we haven't marked this string as being specially serialized (i.e.
	    // something other than serialized JSON), we can just return it and be
	    // done with it.
	    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
	        return JSON.parse(value);
	    }

	    // The following code deals with deserializing some kind of Blob or
	    // TypedArray. First we separate out the type of data we're dealing
	    // with from the data itself.
	    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
	    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

	    var blobType;
	    // Backwards-compatible blob type serialization strategy.
	    // DBs created with older versions of localForage will simply not have the blob type.
	    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
	        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
	        blobType = matcher[1];
	        serializedString = serializedString.substring(matcher[0].length);
	    }
	    var buffer = stringToBuffer(serializedString);

	    // Return the right type based on the code/type set during
	    // serialization.
	    switch (type) {
	        case TYPE_ARRAYBUFFER:
	            return buffer;
	        case TYPE_BLOB:
	            return createBlob([buffer], { type: blobType });
	        case TYPE_INT8ARRAY:
	            return new Int8Array(buffer);
	        case TYPE_UINT8ARRAY:
	            return new Uint8Array(buffer);
	        case TYPE_UINT8CLAMPEDARRAY:
	            return new Uint8ClampedArray(buffer);
	        case TYPE_INT16ARRAY:
	            return new Int16Array(buffer);
	        case TYPE_UINT16ARRAY:
	            return new Uint16Array(buffer);
	        case TYPE_INT32ARRAY:
	            return new Int32Array(buffer);
	        case TYPE_UINT32ARRAY:
	            return new Uint32Array(buffer);
	        case TYPE_FLOAT32ARRAY:
	            return new Float32Array(buffer);
	        case TYPE_FLOAT64ARRAY:
	            return new Float64Array(buffer);
	        default:
	            throw new Error('Unkown type: ' + type);
	    }
	}

	var localforageSerializer = {
	    serialize: serialize,
	    deserialize: deserialize,
	    stringToBuffer: stringToBuffer,
	    bufferToString: bufferToString
	};

	/*
	 * Includes code from:
	 *
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */

	function createDbTable(t, dbInfo, callback, errorCallback) {
	    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
	}

	// Open the WebSQL database (automatically creates one if one didn't
	// previously exist), using any options set in the config.
	function _initStorage$1(options) {
	    var self = this;
	    var dbInfo = {
	        db: null
	    };

	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
	        }
	    }

	    var dbInfoPromise = new Promise$1(function (resolve, reject) {
	        // Open the database; the openDatabase API will automatically
	        // create it for us if it doesn't exist.
	        try {
	            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
	        } catch (e) {
	            return reject(e);
	        }

	        // Create our key/value table if it doesn't exist.
	        dbInfo.db.transaction(function (t) {
	            createDbTable(t, dbInfo, function () {
	                self._dbInfo = dbInfo;
	                resolve();
	            }, function (t, error) {
	                reject(error);
	            });
	        }, reject);
	    });

	    dbInfo.serializer = localforageSerializer;
	    return dbInfoPromise;
	}

	function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
	    t.executeSql(sqlStatement, args, callback, function (t, error) {
	        if (error.code === error.SYNTAX_ERR) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
	                if (!results.rows.length) {
	                    // if the table is missing (was deleted)
	                    // re-create it table and retry
	                    createDbTable(t, dbInfo, function () {
	                        t.executeSql(sqlStatement, args, callback, errorCallback);
	                    }, errorCallback);
	                } else {
	                    errorCallback(t, error);
	                }
	            }, errorCallback);
	        } else {
	            errorCallback(t, error);
	        }
	    }, errorCallback);
	}

	function getItem$1(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
	                    var result = results.rows.length ? results.rows.item(0).value : null;

	                    // Check to see if this is serialized content we need to
	                    // unpack.
	                    if (result) {
	                        result = dbInfo.serializer.deserialize(result);
	                    }

	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function iterate$1(iterator, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;

	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var rows = results.rows;
	                    var length = rows.length;

	                    for (var i = 0; i < length; i++) {
	                        var item = rows.item(i);
	                        var result = item.value;

	                        // Check to see if this is serialized content
	                        // we need to unpack.
	                        if (result) {
	                            result = dbInfo.serializer.deserialize(result);
	                        }

	                        result = iterator(result, item.key, i + 1);

	                        // void(0) prevents problems with redefinition
	                        // of `undefined`.
	                        if (result !== void 0) {
	                            resolve(result);
	                            return;
	                        }
	                    }

	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function _setItem(key, value, callback, retriesLeft) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            // The localStorage API doesn't return undefined values in an
	            // "expected" way, so undefined is always cast to null in all
	            // drivers. See: https://github.com/mozilla/localForage/pull/42
	            if (value === undefined) {
	                value = null;
	            }

	            // Save the original value to pass to the callback.
	            var originalValue = value;

	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	                if (error) {
	                    reject(error);
	                } else {
	                    dbInfo.db.transaction(function (t) {
	                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
	                            resolve(originalValue);
	                        }, function (t, error) {
	                            reject(error);
	                        });
	                    }, function (sqlError) {
	                        // The transaction failed; check
	                        // to see if it's a quota error.
	                        if (sqlError.code === sqlError.QUOTA_ERR) {
	                            // We reject the callback outright for now, but
	                            // it's worth trying to re-run the transaction.
	                            // Even if the user accepts the prompt to use
	                            // more storage on Safari, this error will
	                            // be called.
	                            //
	                            // Try to re-run the transaction.
	                            if (retriesLeft > 0) {
	                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
	                                return;
	                            }
	                            reject(sqlError);
	                        }
	                    });
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function setItem$1(key, value, callback) {
	    return _setItem.apply(this, [key, value, callback, 1]);
	}

	function removeItem$1(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Deletes every item in the table.
	// TODO: Find out if this resets the AUTO_INCREMENT number.
	function clear$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Does a simple `COUNT(key)` to get the number of items stored in
	// localForage.
	function length$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                // Ahhh, SQL makes this one soooooo easy.
	                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var result = results.rows.item(0).c;
	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Return the key located at key index X; essentially gets the key from a
	// `WHERE id = ?`. This is the most efficient way I can think to implement
	// this rarely-used (in my experience) part of the API, but it can seem
	// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
	// the ID of each key will change every time it's updated. Perhaps a stored
	// procedure for the `setItem()` SQL would solve this problem?
	// TODO: Don't change ID on `setItem()`.
	function key$1(n, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
	                    var result = results.rows.length ? results.rows.item(0).key : null;
	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var keys = [];

	                    for (var i = 0; i < results.rows.length; i++) {
	                        keys.push(results.rows.item(i).key);
	                    }

	                    resolve(keys);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// https://www.w3.org/TR/webdatabase/#databases
	// > There is no way to enumerate or delete the databases available for an origin from this API.
	function getAllStoreNames(db) {
	    return new Promise$1(function (resolve, reject) {
	        db.transaction(function (t) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
	                var storeNames = [];

	                for (var i = 0; i < results.rows.length; i++) {
	                    storeNames.push(results.rows.item(i).name);
	                }

	                resolve({
	                    db: db,
	                    storeNames: storeNames
	                });
	            }, function (t, error) {
	                reject(error);
	            });
	        }, function (sqlError) {
	            reject(sqlError);
	        });
	    });
	}

	function dropInstance$1(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    var currentConfig = this.config();
	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        promise = new Promise$1(function (resolve) {
	            var db;
	            if (options.name === currentConfig.name) {
	                // use the db reference of the current instance
	                db = self._dbInfo.db;
	            } else {
	                db = openDatabase(options.name, '', '', 0);
	            }

	            if (!options.storeName) {
	                // drop all database tables
	                resolve(getAllStoreNames(db));
	            } else {
	                resolve({
	                    db: db,
	                    storeNames: [options.storeName]
	                });
	            }
	        }).then(function (operationInfo) {
	            return new Promise$1(function (resolve, reject) {
	                operationInfo.db.transaction(function (t) {
	                    function dropTable(storeName) {
	                        return new Promise$1(function (resolve, reject) {
	                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
	                                resolve();
	                            }, function (t, error) {
	                                reject(error);
	                            });
	                        });
	                    }

	                    var operations = [];
	                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
	                        operations.push(dropTable(operationInfo.storeNames[i]));
	                    }

	                    Promise$1.all(operations).then(function () {
	                        resolve();
	                    })["catch"](function (e) {
	                        reject(e);
	                    });
	                }, function (sqlError) {
	                    reject(sqlError);
	                });
	            });
	        });
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var webSQLStorage = {
	    _driver: 'webSQLStorage',
	    _initStorage: _initStorage$1,
	    _support: isWebSQLValid(),
	    iterate: iterate$1,
	    getItem: getItem$1,
	    setItem: setItem$1,
	    removeItem: removeItem$1,
	    clear: clear$1,
	    length: length$1,
	    key: key$1,
	    keys: keys$1,
	    dropInstance: dropInstance$1
	};

	function isLocalStorageValid() {
	    try {
	        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
	        // in IE8 typeof localStorage.setItem === 'object'
	        !!localStorage.setItem;
	    } catch (e) {
	        return false;
	    }
	}

	function _getKeyPrefix(options, defaultConfig) {
	    var keyPrefix = options.name + '/';

	    if (options.storeName !== defaultConfig.storeName) {
	        keyPrefix += options.storeName + '/';
	    }
	    return keyPrefix;
	}

	// Check if localStorage throws when saving an item
	function checkIfLocalStorageThrows() {
	    var localStorageTestKey = '_localforage_support_test';

	    try {
	        localStorage.setItem(localStorageTestKey, true);
	        localStorage.removeItem(localStorageTestKey);

	        return false;
	    } catch (e) {
	        return true;
	    }
	}

	// Check if localStorage is usable and allows to save an item
	// This method checks if localStorage is usable in Safari Private Browsing
	// mode, or in any other case where the available quota for localStorage
	// is 0 and there wasn't any saved items yet.
	function _isLocalStorageUsable() {
	    return !checkIfLocalStorageThrows() || localStorage.length > 0;
	}

	// Config the localStorage backend, using options set in the config.
	function _initStorage$2(options) {
	    var self = this;
	    var dbInfo = {};
	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = options[i];
	        }
	    }

	    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

	    if (!_isLocalStorageUsable()) {
	        return Promise$1.reject();
	    }

	    self._dbInfo = dbInfo;
	    dbInfo.serializer = localforageSerializer;

	    return Promise$1.resolve();
	}

	// Remove all keys from the datastore, effectively destroying all data in
	// the app's key/value store!
	function clear$2(callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var keyPrefix = self._dbInfo.keyPrefix;

	        for (var i = localStorage.length - 1; i >= 0; i--) {
	            var key = localStorage.key(i);

	            if (key.indexOf(keyPrefix) === 0) {
	                localStorage.removeItem(key);
	            }
	        }
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Retrieve an item from the store. Unlike the original async_storage
	// library in Gaia, we don't modify return values at all. If a key's value
	// is `undefined`, we pass that value to the callback function.
	function getItem$2(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var result = localStorage.getItem(dbInfo.keyPrefix + key);

	        // If a result was found, parse it from the serialized
	        // string into a JS object. If result isn't truthy, the key
	        // is likely undefined and we'll pass it straight to the
	        // callback.
	        if (result) {
	            result = dbInfo.serializer.deserialize(result);
	        }

	        return result;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Iterate over all items in the store.
	function iterate$2(iterator, callback) {
	    var self = this;

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var keyPrefix = dbInfo.keyPrefix;
	        var keyPrefixLength = keyPrefix.length;
	        var length = localStorage.length;

	        // We use a dedicated iterator instead of the `i` variable below
	        // so other keys we fetch in localStorage aren't counted in
	        // the `iterationNumber` argument passed to the `iterate()`
	        // callback.
	        //
	        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
	        var iterationNumber = 1;

	        for (var i = 0; i < length; i++) {
	            var key = localStorage.key(i);
	            if (key.indexOf(keyPrefix) !== 0) {
	                continue;
	            }
	            var value = localStorage.getItem(key);

	            // If a result was found, parse it from the serialized
	            // string into a JS object. If result isn't truthy, the
	            // key is likely undefined and we'll pass it straight
	            // to the iterator.
	            if (value) {
	                value = dbInfo.serializer.deserialize(value);
	            }

	            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

	            if (value !== void 0) {
	                return value;
	            }
	        }
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Same as localStorage's key() method, except takes a callback.
	function key$2(n, callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var result;
	        try {
	            result = localStorage.key(n);
	        } catch (error) {
	            result = null;
	        }

	        // Remove the prefix from the key, if a key is found.
	        if (result) {
	            result = result.substring(dbInfo.keyPrefix.length);
	        }

	        return result;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys$2(callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var length = localStorage.length;
	        var keys = [];

	        for (var i = 0; i < length; i++) {
	            var itemKey = localStorage.key(i);
	            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
	                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
	            }
	        }

	        return keys;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Supply the number of keys in the datastore to the callback function.
	function length$2(callback) {
	    var self = this;
	    var promise = self.keys().then(function (keys) {
	        return keys.length;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Remove an item from the store, nice and simple.
	function removeItem$2(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        localStorage.removeItem(dbInfo.keyPrefix + key);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Set a key's value and run an optional callback once the value is set.
	// Unlike Gaia's implementation, the callback function is passed the value,
	// in case you want to operate on that value only after you're sure it
	// saved, or something like that.
	function setItem$2(key, value, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        // Convert undefined values to null.
	        // https://github.com/mozilla/localForage/pull/42
	        if (value === undefined) {
	            value = null;
	        }

	        // Save the original value to pass to the callback.
	        var originalValue = value;

	        return new Promise$1(function (resolve, reject) {
	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	                if (error) {
	                    reject(error);
	                } else {
	                    try {
	                        localStorage.setItem(dbInfo.keyPrefix + key, value);
	                        resolve(originalValue);
	                    } catch (e) {
	                        // localStorage capacity exceeded.
	                        // TODO: Make this a specific error/event.
	                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
	                            reject(e);
	                        }
	                        reject(e);
	                    }
	                }
	            });
	        });
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function dropInstance$2(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        var currentConfig = this.config();
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        promise = new Promise$1(function (resolve) {
	            if (!options.storeName) {
	                resolve(options.name + '/');
	            } else {
	                resolve(_getKeyPrefix(options, self._defaultConfig));
	            }
	        }).then(function (keyPrefix) {
	            for (var i = localStorage.length - 1; i >= 0; i--) {
	                var key = localStorage.key(i);

	                if (key.indexOf(keyPrefix) === 0) {
	                    localStorage.removeItem(key);
	                }
	            }
	        });
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var localStorageWrapper = {
	    _driver: 'localStorageWrapper',
	    _initStorage: _initStorage$2,
	    _support: isLocalStorageValid(),
	    iterate: iterate$2,
	    getItem: getItem$2,
	    setItem: setItem$2,
	    removeItem: removeItem$2,
	    clear: clear$2,
	    length: length$2,
	    key: key$2,
	    keys: keys$2,
	    dropInstance: dropInstance$2
	};

	var sameValue = function sameValue(x, y) {
	    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
	};

	var includes = function includes(array, searchElement) {
	    var len = array.length;
	    var i = 0;
	    while (i < len) {
	        if (sameValue(array[i], searchElement)) {
	            return true;
	        }
	        i++;
	    }

	    return false;
	};

	var isArray = Array.isArray || function (arg) {
	    return Object.prototype.toString.call(arg) === '[object Array]';
	};

	// Drivers are stored here when `defineDriver()` is called.
	// They are shared across all instances of localForage.
	var DefinedDrivers = {};

	var DriverSupport = {};

	var DefaultDrivers = {
	    INDEXEDDB: asyncStorage,
	    WEBSQL: webSQLStorage,
	    LOCALSTORAGE: localStorageWrapper
	};

	var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

	var OptionalDriverMethods = ['dropInstance'];

	var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

	var DefaultConfig = {
	    description: '',
	    driver: DefaultDriverOrder.slice(),
	    name: 'localforage',
	    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
	    // we can use without a prompt.
	    size: 4980736,
	    storeName: 'keyvaluepairs',
	    version: 1.0
	};

	function callWhenReady(localForageInstance, libraryMethod) {
	    localForageInstance[libraryMethod] = function () {
	        var _args = arguments;
	        return localForageInstance.ready().then(function () {
	            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
	        });
	    };
	}

	function extend() {
	    for (var i = 1; i < arguments.length; i++) {
	        var arg = arguments[i];

	        if (arg) {
	            for (var _key in arg) {
	                if (arg.hasOwnProperty(_key)) {
	                    if (isArray(arg[_key])) {
	                        arguments[0][_key] = arg[_key].slice();
	                    } else {
	                        arguments[0][_key] = arg[_key];
	                    }
	                }
	            }
	        }
	    }

	    return arguments[0];
	}

	var LocalForage = function () {
	    function LocalForage(options) {
	        _classCallCheck(this, LocalForage);

	        for (var driverTypeKey in DefaultDrivers) {
	            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
	                var driver = DefaultDrivers[driverTypeKey];
	                var driverName = driver._driver;
	                this[driverTypeKey] = driverName;

	                if (!DefinedDrivers[driverName]) {
	                    // we don't need to wait for the promise,
	                    // since the default drivers can be defined
	                    // in a blocking manner
	                    this.defineDriver(driver);
	                }
	            }
	        }

	        this._defaultConfig = extend({}, DefaultConfig);
	        this._config = extend({}, this._defaultConfig, options);
	        this._driverSet = null;
	        this._initDriver = null;
	        this._ready = false;
	        this._dbInfo = null;

	        this._wrapLibraryMethodsWithReady();
	        this.setDriver(this._config.driver)["catch"](function () {});
	    }

	    // Set any config values for localForage; can be called anytime before
	    // the first API call (e.g. `getItem`, `setItem`).
	    // We loop through options so we don't overwrite existing config
	    // values.


	    LocalForage.prototype.config = function config(options) {
	        // If the options argument is an object, we use it to set values.
	        // Otherwise, we return either a specified config value or all
	        // config values.
	        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            // If localforage is ready and fully initialized, we can't set
	            // any new configuration values. Instead, we return an error.
	            if (this._ready) {
	                return new Error("Can't call config() after localforage " + 'has been used.');
	            }

	            for (var i in options) {
	                if (i === 'storeName') {
	                    options[i] = options[i].replace(/\W/g, '_');
	                }

	                if (i === 'version' && typeof options[i] !== 'number') {
	                    return new Error('Database version must be a number.');
	                }

	                this._config[i] = options[i];
	            }

	            // after all config options are set and
	            // the driver option is used, try setting it
	            if ('driver' in options && options.driver) {
	                return this.setDriver(this._config.driver);
	            }

	            return true;
	        } else if (typeof options === 'string') {
	            return this._config[options];
	        } else {
	            return this._config;
	        }
	    };

	    // Used to define a custom driver, shared across all instances of
	    // localForage.


	    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
	        var promise = new Promise$1(function (resolve, reject) {
	            try {
	                var driverName = driverObject._driver;
	                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

	                // A driver name should be defined and not overlap with the
	                // library-defined, default drivers.
	                if (!driverObject._driver) {
	                    reject(complianceError);
	                    return;
	                }

	                var driverMethods = LibraryMethods.concat('_initStorage');
	                for (var i = 0, len = driverMethods.length; i < len; i++) {
	                    var driverMethodName = driverMethods[i];

	                    // when the property is there,
	                    // it should be a method even when optional
	                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
	                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
	                        reject(complianceError);
	                        return;
	                    }
	                }

	                var configureMissingMethods = function configureMissingMethods() {
	                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
	                        return function () {
	                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
	                            var promise = Promise$1.reject(error);
	                            executeCallback(promise, arguments[arguments.length - 1]);
	                            return promise;
	                        };
	                    };

	                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
	                        var optionalDriverMethod = OptionalDriverMethods[_i];
	                        if (!driverObject[optionalDriverMethod]) {
	                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
	                        }
	                    }
	                };

	                configureMissingMethods();

	                var setDriverSupport = function setDriverSupport(support) {
	                    if (DefinedDrivers[driverName]) {
	                        console.info('Redefining LocalForage driver: ' + driverName);
	                    }
	                    DefinedDrivers[driverName] = driverObject;
	                    DriverSupport[driverName] = support;
	                    // don't use a then, so that we can define
	                    // drivers that have simple _support methods
	                    // in a blocking manner
	                    resolve();
	                };

	                if ('_support' in driverObject) {
	                    if (driverObject._support && typeof driverObject._support === 'function') {
	                        driverObject._support().then(setDriverSupport, reject);
	                    } else {
	                        setDriverSupport(!!driverObject._support);
	                    }
	                } else {
	                    setDriverSupport(true);
	                }
	            } catch (e) {
	                reject(e);
	            }
	        });

	        executeTwoCallbacks(promise, callback, errorCallback);
	        return promise;
	    };

	    LocalForage.prototype.driver = function driver() {
	        return this._driver || null;
	    };

	    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
	        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

	        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
	        return getDriverPromise;
	    };

	    LocalForage.prototype.getSerializer = function getSerializer(callback) {
	        var serializerPromise = Promise$1.resolve(localforageSerializer);
	        executeTwoCallbacks(serializerPromise, callback);
	        return serializerPromise;
	    };

	    LocalForage.prototype.ready = function ready(callback) {
	        var self = this;

	        var promise = self._driverSet.then(function () {
	            if (self._ready === null) {
	                self._ready = self._initDriver();
	            }

	            return self._ready;
	        });

	        executeTwoCallbacks(promise, callback, callback);
	        return promise;
	    };

	    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
	        var self = this;

	        if (!isArray(drivers)) {
	            drivers = [drivers];
	        }

	        var supportedDrivers = this._getSupportedDrivers(drivers);

	        function setDriverToConfig() {
	            self._config.driver = self.driver();
	        }

	        function extendSelfWithDriver(driver) {
	            self._extend(driver);
	            setDriverToConfig();

	            self._ready = self._initStorage(self._config);
	            return self._ready;
	        }

	        function initDriver(supportedDrivers) {
	            return function () {
	                var currentDriverIndex = 0;

	                function driverPromiseLoop() {
	                    while (currentDriverIndex < supportedDrivers.length) {
	                        var driverName = supportedDrivers[currentDriverIndex];
	                        currentDriverIndex++;

	                        self._dbInfo = null;
	                        self._ready = null;

	                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
	                    }

	                    setDriverToConfig();
	                    var error = new Error('No available storage method found.');
	                    self._driverSet = Promise$1.reject(error);
	                    return self._driverSet;
	                }

	                return driverPromiseLoop();
	            };
	        }

	        // There might be a driver initialization in progress
	        // so wait for it to finish in order to avoid a possible
	        // race condition to set _dbInfo
	        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
	            return Promise$1.resolve();
	        }) : Promise$1.resolve();

	        this._driverSet = oldDriverSetDone.then(function () {
	            var driverName = supportedDrivers[0];
	            self._dbInfo = null;
	            self._ready = null;

	            return self.getDriver(driverName).then(function (driver) {
	                self._driver = driver._driver;
	                setDriverToConfig();
	                self._wrapLibraryMethodsWithReady();
	                self._initDriver = initDriver(supportedDrivers);
	            });
	        })["catch"](function () {
	            setDriverToConfig();
	            var error = new Error('No available storage method found.');
	            self._driverSet = Promise$1.reject(error);
	            return self._driverSet;
	        });

	        executeTwoCallbacks(this._driverSet, callback, errorCallback);
	        return this._driverSet;
	    };

	    LocalForage.prototype.supports = function supports(driverName) {
	        return !!DriverSupport[driverName];
	    };

	    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
	        extend(this, libraryMethodsAndProperties);
	    };

	    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
	        var supportedDrivers = [];
	        for (var i = 0, len = drivers.length; i < len; i++) {
	            var driverName = drivers[i];
	            if (this.supports(driverName)) {
	                supportedDrivers.push(driverName);
	            }
	        }
	        return supportedDrivers;
	    };

	    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
	        // Add a stub for each driver API method that delays the call to the
	        // corresponding driver method until localForage is ready. These stubs
	        // will be replaced by the driver methods as soon as the driver is
	        // loaded, so there is no performance impact.
	        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
	            callWhenReady(this, LibraryMethods[i]);
	        }
	    };

	    LocalForage.prototype.createInstance = function createInstance(options) {
	        return new LocalForage(options);
	    };

	    return LocalForage;
	}();

	// The actual localForage object that we expose as a module or via a
	// global. It's extended by pulling in one of our other libraries.


	var localforage_js = new LocalForage();

	module.exports = localforage_js;

	},{"3":3}]},{},[4])(4)
	});

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	/** Reporting API integration - https://w3c.github.io/reporting/ */
	var ReportingObserver = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function ReportingObserver(_options) {
	        if (_options === void 0) { _options = {
	            types: ['crash', 'deprecation', 'intervention'],
	        }; }
	        this._options = _options;
	        /**
	         * @inheritDoc
	         */
	        this.name = ReportingObserver.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    ReportingObserver.prototype.setupOnce = function (_, getCurrentHub) {
	        if (!utils_1.supportsReportingObserver()) {
	            return;
	        }
	        this._getCurrentHub = getCurrentHub;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	        var observer = new (utils_1.getGlobalObject().ReportingObserver)(this.handler.bind(this), {
	            buffered: true,
	            types: this._options.types,
	        });
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        observer.observe();
	    };
	    /**
	     * @inheritDoc
	     */
	    ReportingObserver.prototype.handler = function (reports) {
	        var e_1, _a;
	        var hub = this._getCurrentHub && this._getCurrentHub();
	        if (!hub || !hub.getIntegration(ReportingObserver)) {
	            return;
	        }
	        var _loop_1 = function (report) {
	            hub.withScope(function (scope) {
	                scope.setExtra('url', report.url);
	                var label = "ReportingObserver [" + report.type + "]";
	                var details = 'No details available';
	                if (report.body) {
	                    // Object.keys doesn't work on ReportBody, as all properties are inheirted
	                    var plainBody = {};
	                    // eslint-disable-next-line guard-for-in
	                    for (var prop in report.body) {
	                        plainBody[prop] = report.body[prop];
	                    }
	                    scope.setExtra('body', plainBody);
	                    if (report.type === 'crash') {
	                        var body = report.body;
	                        // A fancy way to create a message out of crashId OR reason OR both OR fallback
	                        details = [body.crashId || '', body.reason || ''].join(' ').trim() || details;
	                    }
	                    else {
	                        var body = report.body;
	                        details = body.message || details;
	                    }
	                }
	                hub.captureMessage(label + ": " + details);
	            });
	        };
	        try {
	            for (var reports_1 = tslib_1.__values(reports), reports_1_1 = reports_1.next(); !reports_1_1.done; reports_1_1 = reports_1.next()) {
	                var report = reports_1_1.value;
	                _loop_1(report);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (reports_1_1 && !reports_1_1.done && (_a = reports_1.return)) _a.call(reports_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ReportingObserver.id = 'ReportingObserver';
	    return ReportingObserver;
	}());
	exports.ReportingObserver = ReportingObserver;
	//# sourceMappingURL=reportingobserver.js.map

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	/** Rewrite event frames paths */
	var RewriteFrames = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function RewriteFrames(options) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = RewriteFrames.id;
	        /**
	         * @inheritDoc
	         */
	        this._prefix = 'app:///';
	        /**
	         * @inheritDoc
	         */
	        this._iteratee = function (frame) {
	            if (!frame.filename) {
	                return frame;
	            }
	            // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
	            var isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
	            var startsWithSlash = /^\//.test(frame.filename);
	            if (isWindowsFrame || startsWithSlash) {
	                var filename = isWindowsFrame
	                    ? frame.filename
	                        .replace(/^[A-Z]:/, '') // remove Windows-style prefix
	                        .replace(/\\/g, '/') // replace all `\\` instances with `/`
	                    : frame.filename;
	                var base = _this._root ? utils_1.relative(_this._root, filename) : utils_1.basename(filename);
	                frame.filename = "" + _this._prefix + base;
	            }
	            return frame;
	        };
	        if (options.root) {
	            this._root = options.root;
	        }
	        if (options.prefix) {
	            this._prefix = options.prefix;
	        }
	        if (options.iteratee) {
	            this._iteratee = options.iteratee;
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    RewriteFrames.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event) {
	            var self = getCurrentHub().getIntegration(RewriteFrames);
	            if (self) {
	                return self.process(event);
	            }
	            return event;
	        });
	    };
	    /** JSDoc */
	    RewriteFrames.prototype.process = function (originalEvent) {
	        var processedEvent = originalEvent;
	        if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
	            processedEvent = this._processExceptionsEvent(processedEvent);
	        }
	        if (originalEvent.stacktrace) {
	            processedEvent = this._processStacktraceEvent(processedEvent);
	        }
	        return processedEvent;
	    };
	    /** JSDoc */
	    RewriteFrames.prototype._processExceptionsEvent = function (event) {
	        var _this = this;
	        try {
	            return tslib_1.__assign(tslib_1.__assign({}, event), { exception: tslib_1.__assign(tslib_1.__assign({}, event.exception), { 
	                    // The check for this is performed inside `process` call itself, safe to skip here
	                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	                    values: event.exception.values.map(function (value) { return (tslib_1.__assign(tslib_1.__assign({}, value), { stacktrace: _this._processStacktrace(value.stacktrace) })); }) }) });
	        }
	        catch (_oO) {
	            return event;
	        }
	    };
	    /** JSDoc */
	    RewriteFrames.prototype._processStacktraceEvent = function (event) {
	        try {
	            return tslib_1.__assign(tslib_1.__assign({}, event), { stacktrace: this._processStacktrace(event.stacktrace) });
	        }
	        catch (_oO) {
	            return event;
	        }
	    };
	    /** JSDoc */
	    RewriteFrames.prototype._processStacktrace = function (stacktrace) {
	        var _this = this;
	        return tslib_1.__assign(tslib_1.__assign({}, stacktrace), { frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function (f) { return _this._iteratee(f); }) });
	    };
	    /**
	     * @inheritDoc
	     */
	    RewriteFrames.id = 'RewriteFrames';
	    return RewriteFrames;
	}());
	exports.RewriteFrames = RewriteFrames;
	//# sourceMappingURL=rewriteframes.js.map

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	/** This function adds duration since Sentry was initialized till the time event was sent */
	var SessionTiming = /** @class */ (function () {
	    function SessionTiming() {
	        /**
	         * @inheritDoc
	         */
	        this.name = SessionTiming.id;
	        /** Exact time Client was initialized expressed in milliseconds since Unix Epoch. */
	        this._startTime = Date.now();
	    }
	    /**
	     * @inheritDoc
	     */
	    SessionTiming.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event) {
	            var self = getCurrentHub().getIntegration(SessionTiming);
	            if (self) {
	                return self.process(event);
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    SessionTiming.prototype.process = function (event) {
	        var _a;
	        var now = Date.now();
	        return tslib_1.__assign(tslib_1.__assign({}, event), { extra: tslib_1.__assign(tslib_1.__assign({}, event.extra), (_a = {}, _a['session:start'] = this._startTime, _a['session:duration'] = now - this._startTime, _a['session:end'] = now, _a)) });
	    };
	    /**
	     * @inheritDoc
	     */
	    SessionTiming.id = 'SessionTiming';
	    return SessionTiming;
	}());
	exports.SessionTiming = SessionTiming;
	//# sourceMappingURL=sessiontiming.js.map

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** Add node transaction to the event */
	var Transaction = /** @class */ (function () {
	    function Transaction() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Transaction.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (event) {
	            var self = getCurrentHub().getIntegration(Transaction);
	            if (self) {
	                return self.process(event);
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.process = function (event) {
	        var frames = this._getFramesFromEvent(event);
	        // use for loop so we don't have to reverse whole frames array
	        for (var i = frames.length - 1; i >= 0; i--) {
	            var frame = frames[i];
	            if (frame.in_app === true) {
	                event.transaction = this._getTransaction(frame);
	                break;
	            }
	        }
	        return event;
	    };
	    /** JSDoc */
	    Transaction.prototype._getFramesFromEvent = function (event) {
	        var exception = event.exception && event.exception.values && event.exception.values[0];
	        return (exception && exception.stacktrace && exception.stacktrace.frames) || [];
	    };
	    /** JSDoc */
	    Transaction.prototype._getTransaction = function (frame) {
	        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.id = 'Transaction';
	    return Transaction;
	}());
	exports.Transaction = Transaction;
	//# sourceMappingURL=transaction.js.map

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(132);
	var utils_1 = __webpack_require__(140);
	var flags_1 = __webpack_require__(244);
	/**
	 * Used to extract Tracing integration from the current client,
	 * without the need to import `Tracing` itself from the @sentry/apm package.
	 * @deprecated as @sentry/tracing should be used over @sentry/apm.
	 */
	var TRACING_GETTER = {
	    id: 'Tracing',
	};
	/**
	 * Used to extract BrowserTracing integration from @sentry/tracing
	 */
	var BROWSER_TRACING_GETTER = {
	    id: 'BrowserTracing',
	};
	var VUE_OP = 'ui.vue';
	// Mappings from operation to corresponding lifecycle hook.
	var HOOKS = {
	    activate: ['activated', 'deactivated'],
	    create: ['beforeCreate', 'created'],
	    destroy: ['beforeDestroy', 'destroyed'],
	    mount: ['beforeMount', 'mounted'],
	    update: ['beforeUpdate', 'updated'],
	};
	var COMPONENT_NAME_REGEXP = /(?:^|[-_/])(\w)/g;
	var ROOT_COMPONENT_NAME = 'root';
	var ANONYMOUS_COMPONENT_NAME = 'anonymous component';
	/** JSDoc */
	var Vue = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Vue(options) {
	        var _this = this;
	        /**
	         * @inheritDoc
	         */
	        this.name = Vue.id;
	        /**
	         * Cache holding already processed component names
	         */
	        this._componentsCache = {};
	        /** Keep it as attribute function, to keep correct `this` binding inside the hooks callbacks  */
	        // eslint-disable-next-line @typescript-eslint/typedef
	        this._applyTracingHooks = function (vm, getCurrentHub) {
	            // Don't attach twice, just in case
	            if (vm.$options.$_sentryPerfHook) {
	                return;
	            }
	            vm.$options.$_sentryPerfHook = true;
	            var name = _this._getComponentName(vm);
	            var rootMount = name === ROOT_COMPONENT_NAME;
	            var spans = {};
	            // Render hook starts after once event is emitted,
	            // but it ends before the second event of the same type.
	            //
	            // Because of this, we start measuring inside the first event,
	            // but finish it before it triggers, to skip the event emitter timing itself.
	            var rootHandler = function (hook) {
	                var now = utils_1.timestampWithMs();
	                // On the first handler call (before), it'll be undefined, as `$once` will add it in the future.
	                // However, on the second call (after), it'll be already in place.
	                if (_this._rootSpan) {
	                    _this._finishRootSpan(now, getCurrentHub);
	                }
	                else {
	                    vm.$once("hook:" + hook, function () {
	                        // Create an activity on the first event call. There'll be no second call, as rootSpan will be in place,
	                        // thus new event handler won't be attached.
	                        // We do this whole dance with `TRACING_GETTER` to prevent `@sentry/apm` from becoming a peerDependency.
	                        // We also need to ask for the `.constructor`, as `pushActivity` and `popActivity` are static, not instance methods.
	                        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	                        // eslint-disable-next-line deprecation/deprecation
	                        var tracingIntegration = getCurrentHub().getIntegration(TRACING_GETTER);
	                        if (tracingIntegration) {
	                            _this._tracingActivity = tracingIntegration.constructor.pushActivity('Vue Application Render');
	                            var transaction = tracingIntegration.constructor.getTransaction();
	                            if (transaction) {
	                                _this._rootSpan = transaction.startChild({
	                                    description: 'Application Render',
	                                    op: VUE_OP,
	                                });
	                            }
	                            // Use functionality from @sentry/tracing
	                        }
	                        else {
	                            var activeTransaction = getActiveTransaction(getCurrentHub());
	                            if (activeTransaction) {
	                                _this._rootSpan = activeTransaction.startChild({
	                                    description: 'Application Render',
	                                    op: VUE_OP,
	                                });
	                            }
	                        }
	                        /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	                    });
	                }
	            };
	            var childHandler = function (hook, operation) {
	                // Skip components that we don't want to track to minimize the noise and give a more granular control to the user
	                var shouldTrack = Array.isArray(_this._options.tracingOptions.trackComponents)
	                    ? _this._options.tracingOptions.trackComponents.indexOf(name) > -1
	                    : _this._options.tracingOptions.trackComponents;
	                if (!_this._rootSpan || !shouldTrack) {
	                    return;
	                }
	                var now = utils_1.timestampWithMs();
	                var span = spans[operation];
	                // On the first handler call (before), it'll be undefined, as `$once` will add it in the future.
	                // However, on the second call (after), it'll be already in place.
	                if (span) {
	                    span.finish();
	                    _this._finishRootSpan(now, getCurrentHub);
	                }
	                else {
	                    vm.$once("hook:" + hook, function () {
	                        if (_this._rootSpan) {
	                            spans[operation] = _this._rootSpan.startChild({
	                                description: "Vue <" + name + ">",
	                                op: VUE_OP + "." + operation,
	                            });
	                        }
	                    });
	                }
	            };
	            // Each component has it's own scope, so all activities are only related to one of them
	            _this._options.tracingOptions.hooks.forEach(function (operation) {
	                // Retrieve corresponding hooks from Vue lifecycle.
	                // eg. mount => ['beforeMount', 'mounted']
	                var internalHooks = HOOKS[operation];
	                if (!internalHooks) {
	                    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn("Unknown hook: " + operation);
	                    return;
	                }
	                internalHooks.forEach(function (internalHook) {
	                    var handler = rootMount
	                        ? rootHandler.bind(_this, internalHook)
	                        : childHandler.bind(_this, internalHook, operation);
	                    var currentValue = vm.$options[internalHook];
	                    if (Array.isArray(currentValue)) {
	                        vm.$options[internalHook] = tslib_1.__spread([handler], currentValue);
	                    }
	                    else if (typeof currentValue === 'function') {
	                        vm.$options[internalHook] = [handler, currentValue];
	                    }
	                    else {
	                        vm.$options[internalHook] = [handler];
	                    }
	                });
	            });
	        };
	        flags_1.IS_DEBUG_BUILD && utils_1.logger.log('You are still using the Vue.js integration, consider moving to @sentry/vue');
	        this._options = tslib_1.__assign(tslib_1.__assign({ 
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            Vue: utils_1.getGlobalObject().Vue, attachProps: true, logErrors: false, tracing: false }, options), { tracingOptions: tslib_1.__assign({ hooks: ['mount', 'update'], timeout: 2000, trackComponents: false }, options.tracingOptions) });
	    }
	    /**
	     * @inheritDoc
	     */
	    Vue.prototype.setupOnce = function (_, getCurrentHub) {
	        if (!this._options.Vue) {
	            flags_1.IS_DEBUG_BUILD && utils_1.logger.error('Vue integration is missing a Vue instance');
	            return;
	        }
	        this._attachErrorHandler(getCurrentHub);
	        if (this._options.tracing) {
	            this._startTracing(getCurrentHub);
	        }
	    };
	    /**
	     * Extract component name from the ViewModel
	     */
	    Vue.prototype._getComponentName = function (vm) {
	        // Such level of granularity is most likely not necessary, but better safe than sorry. — Kamil
	        if (!vm) {
	            return ANONYMOUS_COMPONENT_NAME;
	        }
	        if (vm.$root === vm) {
	            return ROOT_COMPONENT_NAME;
	        }
	        if (!vm.$options) {
	            return ANONYMOUS_COMPONENT_NAME;
	        }
	        if (vm.$options.name) {
	            return vm.$options.name;
	        }
	        if (vm.$options._componentTag) {
	            return vm.$options._componentTag;
	        }
	        // injected by vue-loader
	        if (vm.$options.__file) {
	            var unifiedFile = vm.$options.__file.replace(/^[a-zA-Z]:/, '').replace(/\\/g, '/');
	            var filename = utils_1.basename(unifiedFile, '.vue');
	            return (this._componentsCache[filename] ||
	                (this._componentsCache[filename] = filename.replace(COMPONENT_NAME_REGEXP, function (_, c) {
	                    return c ? c.toUpperCase() : '';
	                })));
	        }
	        return ANONYMOUS_COMPONENT_NAME;
	    };
	    /** Finish top-level span and activity with a debounce configured using `timeout` option */
	    Vue.prototype._finishRootSpan = function (timestamp, getCurrentHub) {
	        var _this = this;
	        if (this._rootSpanTimer) {
	            clearTimeout(this._rootSpanTimer);
	        }
	        this._rootSpanTimer = setTimeout(function () {
	            if (_this._tracingActivity) {
	                // We do this whole dance with `TRACING_GETTER` to prevent `@sentry/apm` from becoming a peerDependency.
	                // We also need to ask for the `.constructor`, as `pushActivity` and `popActivity` are static, not instance methods.
	                // eslint-disable-next-line deprecation/deprecation
	                var tracingIntegration = getCurrentHub().getIntegration(TRACING_GETTER);
	                if (tracingIntegration) {
	                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                    tracingIntegration.constructor.popActivity(_this._tracingActivity);
	                }
	            }
	            // We should always finish the span, only should pop activity if using @sentry/apm
	            if (_this._rootSpan) {
	                _this._rootSpan.finish(timestamp);
	            }
	        }, this._options.tracingOptions.timeout);
	    };
	    /** Inject configured tracing hooks into Vue's component lifecycles */
	    Vue.prototype._startTracing = function (getCurrentHub) {
	        var applyTracingHooks = this._applyTracingHooks;
	        this._options.Vue.mixin({
	            beforeCreate: function () {
	                // eslint-disable-next-line deprecation/deprecation
	                if (getCurrentHub().getIntegration(TRACING_GETTER) || getCurrentHub().getIntegration(BROWSER_TRACING_GETTER)) {
	                    // `this` points to currently rendered component
	                    applyTracingHooks(this, getCurrentHub);
	                }
	                else {
	                    flags_1.IS_DEBUG_BUILD &&
	                        utils_1.logger.error('Vue integration has tracing enabled, but Tracing integration is not configured');
	                }
	            },
	        });
	    };
	    /** Inject Sentry's handler into owns Vue's error handler  */
	    Vue.prototype._attachErrorHandler = function (getCurrentHub) {
	        var _this = this;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var currentErrorHandler = this._options.Vue.config.errorHandler;
	        this._options.Vue.config.errorHandler = function (error, vm, info) {
	            var metadata = {};
	            if (vm) {
	                try {
	                    metadata.componentName = _this._getComponentName(vm);
	                    if (_this._options.attachProps) {
	                        metadata.propsData = vm.$options.propsData;
	                    }
	                }
	                catch (_oO) {
	                    flags_1.IS_DEBUG_BUILD && utils_1.logger.warn('Unable to extract metadata from Vue component.');
	                }
	            }
	            if (info) {
	                metadata.lifecycleHook = info;
	            }
	            if (getCurrentHub().getIntegration(Vue)) {
	                // Capture exception in the next event loop, to make sure that all breadcrumbs are recorded in time.
	                setTimeout(function () {
	                    getCurrentHub().withScope(function (scope) {
	                        scope.setContext('vue', metadata);
	                        getCurrentHub().captureException(error);
	                    });
	                });
	            }
	            if (typeof currentErrorHandler === 'function') {
	                currentErrorHandler.call(_this._options.Vue, error, vm, info);
	            }
	            if (_this._options.logErrors) {
	                if (_this._options.Vue.util) {
	                    _this._options.Vue.util.warn("Error in " + info + ": \"" + (error && error.toString()) + "\"", vm);
	                }
	                // eslint-disable-next-line no-console
	                console.error(error);
	            }
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    Vue.id = 'Vue';
	    return Vue;
	}());
	exports.Vue = Vue;
	/** Grabs active transaction off scope */
	function getActiveTransaction(hub) {
	    if (hub && hub.getScope) {
	        var scope = hub.getScope();
	        if (scope) {
	            return scope.getTransaction();
	        }
	    }
	    return undefined;
	}
	exports.getActiveTransaction = getActiveTransaction;
	//# sourceMappingURL=vue.js.map

/***/ })
/******/ ]);
angular.module('queue-manager').run(['$templateCache', function($templateCache) {$templateCache.put('app/modules/auth/pages/policy.html','<h1>Pol\xEDtica de privacidad</h1><p>Fecha efectiva: November 19, 2018</p><p>Waima Technologies ("nosotros", "a nosotros", "nuestro") opera el sitio web https://waima.es (en adelante, el "Servicio").</p><p>Esta p\xE1gina le informa de nuestras pol\xEDticas en materia de recopilaci\xF3n, uso y divulgaci\xF3n de datos personales cuando utiliza nuestro Servicio y de las opciones de las que dispone en relaci\xF3n con esos datos. <a href=https://www.freeprivacypolicy.com/free-privacy-policy-generator.php>Pol\xEDtica de privacidad via Free Privacy Policy Website</a>.</p><p>Utilizamos sus datos para prestarle el Servicio y mejorarlo. Al utilizar el Servicio, usted acepta la recopilaci\xF3n y el uso de informaci\xF3n de conformidad con esta pol\xEDtica. A menos que esta Pol\xEDtica de privacidad defina lo contrario, los t\xE9rminos utilizados en ella tienen los mismos significados que nuestros T\xE9rminos y Condiciones, disponibles en el https://waima.es</p><h2>Definiciones</h2><ul><li><p><strong>Servicio</strong></p><p>Servicio es el sitio web https://waima.es operado por Waima Technologies</p></li><li><p><strong>Datos personales</strong></p><p>Datos personales significa los datos sobre una persona f\xEDsica viva que puede ser identificada a partir de esos datos (o con esos datos y otra informaci\xF3n de la que dispongamos o probablemente podamos disponer).</p></li><li><p><strong>Datos de uso</strong></p><p>Datos de uso son los datos recopilados autom\xE1ticamente, generados por el uso del Servicio o por la propia infraestructura del Servicio (por ejemplo, la duraci\xF3n de la visita a una p\xE1gina).</p></li><li><p><strong>Cookies</strong></p><p>Las cookies son peque\xF1os archivos ialmacenados en su dispositivo (ordenador o dispositivo m\xF3vil).</p></li></ul><h2>Recopilaci\xF3n y uso de la informaci\xF3n</h2><p>Recopilamos diferentes tipos de informaci\xF3n con diversas finalidades para prestarle el Servicio y mejorarlo.</p><h3>Tipos de datos recopilados</h3><h4>Datos personales</h4><p>Cuando utilice nuestro Servicio, es posible que le pidamos que nos proporcione determinada informaci\xF3n personalmente identificable que podr\xE1 ser utilizada para contactar con usted o para identificarle ("Datos personales"). La informaci\xF3n personalmente identificable puede incluir, entre otras, la siguiente:</p><ul><li>Cookies y datos de uso</li></ul><h4>Datos de uso</h4><p>Tambi\xE9n recopilamos informaci\xF3n sobre la forma en la que se accede y utiliza el Servicio (\xABDatos de uso\xBB). Estos Datos de uso pueden incluir informaci\xF3n como la direcci\xF3n del protocolo de Internet de su ordenador (por ejemplo, direcci\xF3n IP), tipo de navegador, versi\xF3n del navegador, las p\xE1ginas que visita de nuestro Servicio, la hora y la fecha de su visita, el tiempo que pasa en esas p\xE1ginas, identificadores exclusivos de dispositivos y otros datos de diagn\xF3stico.</p><h4>Datos de cookies y seguimiento</h4><p>Utilizamos cookies y tecnolog\xEDas de seguimiento similares para rastrear la actividad de nuestro Servicio y mantener determinada informaci\xF3n.</p><p>Las cookies son archivos con una peque\xF1a cantidad de datos que pueden incluir un identificador exclusivo an\xF3nimo. Las cookies son enviadas a su navegador desde un sitio web y se almacenan en su dispositivo. Otras tecnolog\xEDas de seguimiento tambi\xE9n utilizadas son balizas, etiquetas y scripts para recopilar y rastrear la informaci\xF3n, as\xED como para mejorar y analizar nuestro Servicio.</p><p>Usted puede ordenar a su navegador que rechace todas las cookies o que le avise cuando se env\xEDa una cookie. Sin embargo, si no acepta cookies, es posible que no pueda utilizar algunas partes de nuestro Servicio.</p><p>Ejemplos de Cookies que utilizamos:</p><ul><li><strong>Cookies de sesi\xF3n.</strong> Utilizamos Cookies de sesi\xF3n para operar nuestro Servicio.</li><li><strong>Cookies de preferencia.</strong> Utilizamos Cookies de preferencia para recordar sus preferencias y diversos ajustes.</li><li><strong>Cookies de seguridad.</strong> Utilizamos Cookies de seguridad para fines de seguridad.</li></ul><h2>Uso de datos</h2><p>Waima Technologies utiliza los datos recopilados con diversas finalidades:</p><ul><li>Suministrar y mantener nuestro Servicio</li><li>Notificarle cambios en nuestro Servicio</li><li>Permitirle participar en funciones interactivas de nuestro Servicio cuando decida hacerlo</li><li>Prestar asistencia al cliente</li><li>Recopilar an\xE1lisis o informaci\xF3n valiosa que nos permitan mejorar nuestro Servicio</li><li>Controlar el uso de nuestro Servicio</li><li>Detectar, evitar y abordar problemas t\xE9cnicos</li></ul><h2>Transferencia de datos</h2><p>Su informaci\xF3n, incluyendo Datos personales, puede ser transferida a \u2014y mantenida en\u2014 ordenadores localizados fuera de su estado, provincia, pa\xEDs u otra jurisdicci\xF3n gubernamental donde las leyes de protecci\xF3n de datos pueden diferir de las de su jurisdicci\xF3n.</p><p>Si usted se encuentra fuera de Spain y decide facilitarnos informaci\xF3n, tenga en cuenta que nosotros transferimos los datos, incluyendo Datos personales, a Spain y que los tratamos all\xED.</p><p>Su aceptaci\xF3n de esta Pol\xEDtica de privacidad seguida de su env\xEDo de esta informaci\xF3n representa que est\xE1 de acuerdo con dicha transferencia.</p><p>Waima Technologies emprender\xE1 todas las medidas razonables necesarias para garantizar que sus datos sean tratados de forma segura y de conformidad con esta Pol\xEDtica de privacidad y no se realizar\xE1 ninguna transferencia de sus Datos personales a una organizaci\xF3n o pa\xEDs, salvo que existan unos controles adecuados establecidos incluyendo la seguridad de sus datos y otra informaci\xF3n personal.</p><h2>Divulgaci\xF3n de datos</h2><h3>Requisitos legales</h3><p>Waima Technologies puede divulgar sus Datos personales de buena fe cuando considere que esta acci\xF3n es necesaria para lo siguiente:</p><ul><li>Cumplir una obligaci\xF3n legal</li><li>Proteger y defender los derechos o bienes de Waima Technologies</li><li>Prevenir o investigar posibles infracciones en relaci\xF3n con el Servicio</li><li>Proteger la seguridad personal de usuarios del Servicio o del p\xFAblico</li><li>Protegerse frente a consecuencias legales</li></ul><h2>Seguridad de los datos</h2><p>La seguridad de sus datos es importante para nosotros, pero recuerde que ning\xFAn m\xE9todo de transmisi\xF3n por Internet o m\xE9todo de almacenamiento electr\xF3nico resulta 100% seguro. A pesar de que nos esforzamos por utilizar medios comercialmente aceptables para proteger sus Datos personales, no podemos garantizar su seguridad absoluta.</p><h2>Proveedores de servicios</h2><p>Podemos contratar a personas f\xEDsicas y jur\xEDdicas terceras para facilitar nuestro Servicio ("Proveedores de servicios"), para que presten el Servicio en nuestro nombre, para que suministren servicios relacionados con el Servicio o para que nos ayuden a analizar c\xF3mo se utiliza nuestro Servicio.</p><p>Estos terceros tienen acceso a sus Datos personales \xFAnicamente para realizar estas tareas en nuestro nombre y est\xE1n obligados a no divulgarlos ni utilizarlos con ning\xFAn otro fin.</p><h2>Enlaces a otros sitios</h2><p>Nuestro Servicio puede contener enlaces a otros sitios no operados por nosotros. Si hace clic en el enlace de un tercero, ser\xE1 dirigido al sitio de ese tercero. Le recomendamos encarecidamente que revise la Pol\xEDtica de privacidad de todos los sitios que visite.</p><p>No tenemos ning\xFAn control ni asumimos responsabilidad alguna con respecto al contenido, las pol\xEDticas o pr\xE1cticas de privacidad de sitios o servicios de terceros.</p><h2>Privacidad del menor</h2><p>Nuestro servicio no est\xE1 dirigido a ning\xFAn menor de 18 a\xF1os (en adelante, "Menor").</p><p>No recopilamos de forma consciente informaci\xF3n personalmente identificable de menores de 18 a\xF1os. Si es usted un padre/madre o tutor y tiene conocimiento de que su hijo nos ha facilitado Datos personales, contacte con nosotros. Si tenemos conocimiento de que hemos recopilado Datos personales de menores sin verificaci\xF3n del consentimiento parental, tomamos medidas para eliminar esa informaci\xF3n de nuestros servidores.</p><h2>Cambios en esta Pol\xEDtica de privacidad</h2><p>Podemos actualizar nuestra Pol\xEDtica de privacidad peri\xF3dicamente. Le notificaremos cualquier cambio publicando la nueva Pol\xEDtica de privacidad en esta p\xE1gina.</p><p>Le informaremos a trav\xE9s del e-mail y/o de un aviso destacado sobre nuestro Servicio antes de que el cambio entre en vigor y actualizaremos la \xABfecha efectiva\xBB en la parte superior de esta Pol\xEDtica de privacidad.</p><p>Le recomendamos que revise esta Pol\xEDtica de privacidad peri\xF3dicamente para comprobar si se ha introducido alg\xFAn cambio. Los cambios en esta Pol\xEDtica de privacidad entran en vigor cuando se publican en esta p\xE1gina.</p><h2>Contacte con nosotros</h2><p>Si tiene alguna pregunta sobre esta Pol\xEDtica de privacidad, contacte con nosotros:</p><ul><li>Por e-mail: contacto@waima.es</li></ul>');
$templateCache.put('app/modules/auth/pages/unauthorized.html','#error-page.pad-top-20 h1 Unauthorized //- .container-fluid //- // Jumbotron //- .jumbotron.text-center //- h1 //- i.fa.fa-user-secret.text-danger //- | {{error.status}} {{error.error}} //- p.lead //- | You are not authorized to access for this application. //- p.pad-top //- a.btn.btn-default.btn-lg(ui-sref="app.dashboard") Go to dashboard //- //- small //- //- | Automatic redirect in {{vm.counter}} seconds... //- //- .container-fluid //- .row //- .col-md-12 //- h4 What happened? //- p.lead //- | A {{error.status}} error status implies {{error.message | lowercase}}. //- hr //- //- img(src=\'assets/images/preloader-empty.png\', alt=\'Catenon\' style="float:right") //- //- p &copy; Catenon 2016');
$templateCache.put('app/components/app/app.html','<app-navbar></app-navbar><ui-view id=app-container flex layout></ui-view><!--app-footer-->');
$templateCache.put('app/components/footer/footer.html','<footer style="background-color: rgba(255, 148, 78, 1);color: #fff;height:47px;width:100%"><div style="display: flex;flex-direction: row;padding: 0px 70px;align-items: center"><img class=md-card-image style="width: 207px!important" ng-src=/assets/images/book_the_city_logol.png alt="{{\'app.TITLE\'|translate}}" title="{{\'app.TITLE\'|translate}}"><div style="margin-left: 30px"><p class=footer-text><span class=footer-text-terms><a href=https://bookthecity.app/politica-de-privacidad>{{ \'app.footer.TERMS_CONDITIONS\' | translate }}</a></span> <span class=footer-text-privacy><a href=https://bookthecity.app/terminos-de-uso>{{ \'app.footer.PRIVACY_POLICY\' | translate }}</a></span> <span class=footer-text-cookies><a href=https://bookthecity.app/aviso-legal>{{ \'app.footer.COOKIES_POLICY\' | translate }}</a></span></p></div></div></footer>');
$templateCache.put('app/components/navbar/navbar.html','<md-toolbar class="app-navbar custom-nav" layout=row layout-align="center center" style="width: 100%!important"><div class=md-toolbar-tools><img class=md-card-image style="width: 207px!important" ng-src=/assets/images/book_the_city_logol.png ng-if=!$ctrl.is_kiosk alt="{{\'app.TITLE\'|translate}}" title="{{\'app.TITLE\'|translate}}"><span flex=""></span><md-button href=/administration/users ng-show=!$ctrl.$rootScope.isStatistic><span ng-class="{\'active\' : $ctrl.$rootScope.currentMainPage == \'ADMINISTRATION\'}">Inicio</span></md-button><md-button href=/panels ng-show=!$ctrl.$rootScope.isStatistic ng-click=$ctrl.goPanel()><span ng-class="{\'active\' : $ctrl.$rootScope.currentMainPage == \'ADMINISTRATION\'}">{{\'app.administration.ADMINISTRATION_VIEW\'|translate}}</span></md-button><md-button ui-sref=app.supervisor ng-show=$ctrl.$rootScope.isAdmin ng-if=$ctrl.allowCompare(4)><span ng-class="{\'active\' : $ctrl.$rootScope.currentMainPage == \'SUPERVISOR\'}">{{\'app.supervisor.SUPERVISOR_VIEW\'|translate}}</span></md-button><!-- User role can\xB4t compare--><md-menu md-position-mode="target-right target" ng-if=!$ctrl.allowCompare(3)><md-button aria-label=Statistics ng-click="$ctrl.openMenu($mdOpenMenu, $event)"><span ng-class="{\'active\' : $ctrl.$rootScope.currentMainPage == \'STATISTICS\'}">{{\'app.statistics.STATISTICS_VIEW\'|translate}}</span><md-icon>keyboard_arrow_down</md-icon></md-button><md-menu-content width=3><md-menu-item class=statistics_items layout=column><md-button ui-sref=app.statistics.center ng-show="$ctrl.$rootScope.isAdmin || $ctrl.$rootScope.isStatistic"><span>{{\'app.statistics.STATISTICS_VIEW_CENTER\'|translate}}</span></md-button><md-button ui-sref=app.statistics.comparative ng-show=$ctrl.$rootScope.isStatistic><span>{{\'app.statistics.STATISTICS_VIEW_COMPARE\'|translate}}</span></md-button><md-button ui-sref=app.statistics.new ng-show=$ctrl.$rootScope.isStatistic><span>{{\'app.administration.ORGANIZATION\'|translate}}</span></md-button></md-menu-item></md-menu-content></md-menu><!-- User rola can compare--><md-menu md-position-mode="target-right target" ng-if=$ctrl.allowCompare(3)><md-button aria-label=Statistics ng-click="$ctrl.openMenu($mdOpenMenu, $event)"><span ng-class="{\'active\' : $ctrl.$rootScope.currentMainPage == \'STATISTICS\'}">{{\'app.statistics.STATISTICS_VIEW\'|translate}}</span><md-icon>keyboard_arrow_down</md-icon></md-button><md-menu-content width=3><md-menu-item class=statistics_items layout=column><md-button ui-sref=app.statistics.center ng-show=$ctrl.$rootScope.isAdmin><span>{{\'app.statistics.STATISTICS_VIEW_CENTER\'|translate}}</span></md-button><md-button ui-sref=app.statistics.comparative ng-show=$ctrl.$rootScope.isAdmin><span>{{\'app.statistics.STATISTICS_VIEW_COMPARE\'|translate}}</span></md-button><md-button ui-sref=app.statistics.new ng-show=$ctrl.$rootScope.isAdmin><span>{{\'app.administration.ORGANIZATION\'|translate}}</span></md-button></md-menu-item></md-menu-content></md-menu><md-button href=/administration/support ng-show=$ctrl.$rootScope.isAdmin><span ng-class="{\'active\' : $ctrl.$rootScope.currentMainPage == \'ADMINISTRATION\'}">{{\'app.administration.SUPPORT\'|translate}}</span></md-button><md-button href=/code ng-show=!$ctrl.$rootScope.isStatistic><span ng-class="{\'active\' : $ctrl.$rootScope.currentMainPage == \'ADMINISTRATION\'}">{{\'app.administration.DEVELOPER\'|translate}} |</span><md-tooltip md-direction=center>{{\'app.widget.TOOLTIP_NAVBAR\'|translate}}</md-tooltip></md-button><md-input-container><md-select ng-model=$ctrl.selectedLocationId ng-change=$ctrl.selectLocation($ctrl.selectedLocationId)><md-option ng-repeat="location in $ctrl.allLocations" ng-value=location.id>{{ location.name }}</md-option></md-select></md-input-container><md-menu md-position-mode="target-right target"><md-button class=md-icon-button aria-label=Language ng-click="$ctrl.openMenu($mdOpenMenu, $event)"><md-icon>language</md-icon><md-tooltip md-direction=left>{{\'app.language.LANG_TOOLTIP\' |translate}}</md-tooltip></md-button><md-menu-content width=3><md-menu-item><md-button ng-click="$ctrl.selectLanguage(\'en\')">{{\'app.language.ENGLISH\'|translate}}</md-button></md-menu-item><md-menu-item><md-button ng-click="$ctrl.selectLanguage(\'es\')">{{\'app.language.SPANISH\'|translate}}</md-button></md-menu-item><md-menu-item><md-button ng-click="$ctrl.selectLanguage(\'fr\')">{{\'app.language.FRENCH\'|translate}}</md-button></md-menu-item></md-menu-content></md-menu><md-button class=username href=/administration/profile>{{ $ctrl.$rootScope.currentUser.username }}<md-tooltip md-direction=left>{{\'app.users.PROFILE\' |translate}}</md-tooltip></md-button><md-button class=md-icon-button aria-label="Exit to App" ng-click=$ctrl.logout() ng-if="$ctrl.$rootScope.isAdmin || $ctrl.$rootScope.isStatistic"><md-tooltip md-direction=bottom>{{\'app.login.LOGOUT\' |translate}}</md-tooltip><md-icon>exit_to_app</md-icon></md-button></div></md-toolbar>');
$templateCache.put('app/components/preloader/preloader.html','<div class=preloader-container ng-hide=$ctrl.isLoaded layout=row layout-align="center center" layout-fill><md-progress-circular md-mode=indeterminate></md-progress-circular></div>');
$templateCache.put('app/components/sidebar/sidebar.html','<md-sidenav class="app-sidebar md-whiteframe" md-component-id=sidebarLeft md-is-locked-open=true ng-if=!$ctrl.isStatistic><md-content class=sidebar-content><md-button class=md-no-ink ng-if=$ctrl.isRoot aria-label=Organizaciones ui-sref=app.administration.organizations ng-class="{active : $ctrl.$rootScope.currentPage === \'ORGANIZATIONS\'}"><md-tooltip ng-if=$ctrl.isCollapsed md-direction=right>{{\'app.administration.ORGANIZATIONS\'|translate}}</md-tooltip><md-icon>vpn_lock</md-icon><span>{{\'app.administration.ORGANIZATIONS\'|translate}}</span></md-button><md-button class=md-no-ink ng-if="$ctrl.isRoot || $ctrl.isSuperAdmin" aria-label=Establecimientos ui-sref=app.administration.establishments ng-class="{active : $ctrl.$rootScope.currentPage === \'ESTABLISHMENTS\'}"><md-tooltip ng-if=$ctrl.isCollapsed md-direction=right>{{\'app.administration.ESTABLISHMENTS\'|translate}}</md-tooltip><md-icon>location_city</md-icon><span>{{\'app.administration.ESTABLISHMENTS\'|translate}}</span></md-button><md-button class=md-no-ink aria-label=Usuarios ui-sref=app.administration.users ng-class="{active : $ctrl.$rootScope.currentPage === \'USERS\'}"><md-tooltip ng-if=$ctrl.isCollapsed md-direction=right>{{\'app.administration.USERS\'|translate}}</md-tooltip><md-icon>people</md-icon><span>{{\'app.administration.USERS\'|translate}}</span></md-button><md-button class=md-no-ink ng-if=$ctrl.isRoot aria-label="Usuarios no validados" ui-sref=app.administration.validateUsers ng-class="{active : $ctrl.$rootScope.currentPage === \'VALIDATEUSERS\'}"><md-icon>check_box</md-icon><md-tooltip ng-if=$ctrl.isCollapsed md-direction=right>{{\'app.administration.NOT_VALIDATED_USERS\'|translate}}</md-tooltip><span>{{\'app.administration.NOT_VALIDATED_USERS\'|translate}}</span></md-button><md-button class=md-no-ink ng-if="$ctrl.isRoot || $ctrl.isSuperAdmin" aria-label=Servicios ui-sref=app.administration.services ng-class="{active : $ctrl.$rootScope.currentPage === \'SERVICES\'}"><md-tooltip ng-if=$ctrl.isCollapsed md-direction=right>{{\'app.administration.SERVICES\'|translate}}</md-tooltip><md-icon>business_center</md-icon><span>{{\'app.administration.SERVICES\'|translate}}</span></md-button><md-button class=md-no-ink aria-label=Kioskos ui-sref=app.administration.kiosks ng-class="{active : $ctrl.$rootScope.currentPage === \'KIOSKS\'}"><md-tooltip ng-if=$ctrl.isCollapsed md-direction=right>{{\'app.administration.KIOSKS\'|translate}}</md-tooltip><md-icon class=avatar>video_label</md-icon><span>{{\'app.administration.KIOSKS\'|translate}}</span></md-button><md-button class=md-no-ink aria-label=Salas ui-sref=app.administration.waitingareas ng-class="{active : $ctrl.$rootScope.currentPage === \'WAITINGAREAS\'}"><md-tooltip ng-if=$ctrl.isCollapsed md-direction=right>{{\'app.administration.WAITING_AREAS\'|translate}}</md-tooltip><md-icon>format_list_numbered</md-icon><span>{{\'app.administration.WAITING_AREAS\'|translate}}</span></md-button><md-button class=md-no-ink aria-label=Puestos ui-sref=app.administration.consumers ng-class="{active : $ctrl.$rootScope.currentPage === \'CONSUMERS\'}"><md-tooltip ng-if=$ctrl.isCollapsed md-direction=right>{{\'app.administration.CONSUMERS\'|translate}}</md-tooltip><md-icon>account_box</md-icon><span>{{\'app.administration.CONSUMERS\'|translate}}</span></md-button><md-button class=md-no-ink ng-if="$ctrl.isRoot || $ctrl.isAdmin || $ctrl.isSuperAdmin" aria-label=Prioridades ui-sref=app.administration.priorities ng-class="{active : $ctrl.$rootScope.currentPage === \'PRIORITIES\'}"><md-tooltip ng-if=$ctrl.isCollapsed md-direction=right>{{\'app.administration.PRIORITIES\'|translate}}</md-tooltip><md-icon>store</md-icon><span>{{\'app.administration.PRIORITIES\'|translate}}</span></md-button><md-button class=md-no-ink aria-label=Pantallas ui-sref=app.administration.screens ng-class="{active : $ctrl.$rootScope.currentPage === \'SCREENS\'}"><md-tooltip ng-if=$ctrl.isCollapsed md-direction=right>{{\'app.administration.SCREENS\'|translate}}</md-tooltip><md-icon>desktop_windows</md-icon><span>{{\'app.administration.SCREENS\'|translate}}</span></md-button><md-button class=md-no-ink aria-label=Agendas ui-sref=app.administration.journal ng-class="{active : $ctrl.$rootScope.currentPage === \'AGENDAS\'}"><md-tooltip ng-if=$ctrl.isCollapsed md-direction=right>{{\'app.administration.AGENDAS\'|translate}}</md-tooltip><md-icon>date_range</md-icon><span>{{\'app.administration.AGENDAS\'|translate}}</span></md-button><md-button class=toggle-left ng-click=$ctrl.toggleLeft()><md-icon ng-if=$ctrl.isCollapsed>chevron_right</md-icon><md-icon ng-if=!$ctrl.isCollapsed>chevron_left</md-icon><span style="text-transform: none; color:rgba(0,0,0,0.3) !important; font-size:12px">{{\'app.administration.HIDE_MENU\'|translate}}</span></md-button><!--md-button.md-no-ink(ng-if="$ctrl.isRoot" aria-label="Booking" ui-sref="app.administration.booking" ng-class="{active : $ctrl.$rootScope.currentPage === \'BOOKING\'}")\n    md-tooltip(ng-if="$ctrl.isCollapsed" md-direction="right") {{\'app.administration.BOOKING\'|translate}}\n    md-icon event\n    span {{\'app.administration.BOOKING\'|translate}}\n    \n    --><!-- md-button.md-no-ink(aria-label="Campa\xF1as" ui-sref="app.administration.campaignes" ng-class="{active : $ctrl.$rootScope.currentPage === \'CAMPAIGNES\'}")\n    md-tooltip(ng-if="$ctrl.isCollapsed" md-direction="right") {{\'app.administration.CAMPAIGNES\'|translate}}\n    md-icon panorama\n    span {{\'app.administration.CAMPAIGNES\'|translate}}\n    --></md-content></md-sidenav>');
$templateCache.put('app/modules/admin/admin.html','<!--#admin-container--><!--\t// Navbar--><!--\t#turn-consumer-navbar--><!--\t\tmd-toolbar--><!--\t\t\t.md-toolbar-tools--><!--\t\t\t\th2--><!--\t\t\t\t\tspan {{\'app.TITLE\'|translate}}--><!--\t\t\t\tspan.options-right(flex)--><!--\t\t\t\t\tmd-button(aria-label="Help")--><!--\t\t\t\t\t\ta(href="/adimistration")--><!--\t\t\t\tspan(style="padding:6px;") {{ $ctrl.user_name }}--><!--\t\t\t\ta.md-icon-button(aria-label="Exit to App" href="/login" ng-if="$ctrl.isEmployee")--><!--\t\t\t\t\tmd-tooltip(md-direction="bottom") {{\'app.login.LOGOUT\' |translate}}--><!--\t\t\t\t\tmd-icon exit_to_app--><!--\t\t\t\tmd-button.md-fab.md-mini.help-color(aria-label="Help" ng-click="$ctrl.helpMode()"  ng-if="!$ctrl.isEmployee")--><!--\t\t\t\t\ti.material-icons.help-color help_outline--><!----><!---->');
$templateCache.put('app/modules/admin/recover-password/recover-password.html','<div class=full-height layout=column ng-class="{\'layout-align-center-center\' : !vm.isDesk}" layout-fill><div class="loginBox resetBox" ng-class="{\'md-whiteframe-z1\' : !vm.isDesk, \'desk\' : vm.isDesk}" style="width:500px; background: white; border-radius: 13px; padding-top: 20px"><a href=/login><img class=md-card-image ng-src=/assets/images/logo_book_the_city.png alt="Logo Bookthecity"></a><md-toolbar ng-if=!vm.isDesk style=background-color:transparent><h2 class=md-toolbar-tools><span style="width:100%; text-align: center; color: black">Recuperar contrase\xF1a.</span></h2></md-toolbar><md-content class=white ng-class="{\'md-padding\' : !vm.isDesk, \'md-padding-left\' : vm.isDesk}" style=width:100%><form ng-class="{\'layout-column\' : !vm.isDesk, \'layout-row isDesk\' : vm.isDesk}" name=vm.resetForm ng-submit=vm._resetPass(vm.resetForm) role=form novalidate autocomplete=off style=width:100%><md-input-container class=pass><label>{{ \'app.users.USEREMAIL\'|translate }}</label><input class=username ng-model=vm.reset.email type=text name=email autocomplete=nope placeholder="{{ \'app.users.USEREMAIL\'|translate }}" ng-change="vm._validateInputsEmail(vm.reset.email, vm.resetForm)"><p ng-if=vm.errMail style=color:red>{{ \'app.login.CONFIRM_PASSWORD\'|translate }}</p><div ng-messages=loginForm.userName.$error><div ng-message=required>{{ \'app.login.USERNAME_REQUIRED\'|translate }}</div></div></md-input-container><div ng-class="{\'content-hidden\' : vm.isDesk}" layout=row><md-button class="md-button md-primary md-raised" type=submit ng-disabled=vm.resetForm.$invalid style="background-color:#ff914d; color:#ffffff; width:100%">{{ \'app.rooms.SEND_INFORMATION\'|translate }}</md-button><!--div(flex)--><!--  a.md-body-2(href="", md-no-ink) {{ \'app.login.PASSWORD_FORGOT\'|translate }}--></div><div class=deskBoxButton ng-class="{\'content-hidden\' : !vm.isDesk}" layout=row layout-align="center center" ng-show=vm.isDesk><md-button class="md-button md-primary md-raised" type=submit ng-disabled=vm.resetForm.$invalid><md-icon>send</md-icon></md-button></div></form></md-content></div></div>');
$templateCache.put('app/modules/admin/administration/administration.html','<div id=administration-container layout=column></div><app-sidebar></app-sidebar><md-content flex style=padding-bottom:47px><ui-view></ui-view></md-content><app-footer></app-footer>');
$templateCache.put('app/modules/admin/statistics/statistics.html','<md-content flex><ui-view></ui-view></md-content>');
$templateCache.put('app/modules/admin/supervisor/supervisor.html','<div id=statistics-container><div class=selectEstablishment ng-if=$ctrl.allowSelectRoles(3)><h2>{{\'app.statistics.SELECT_CENTER\'|translate}}<form name=selectEstablishmentForm><md-input-container md-no-float><md-select id=center name=center ng-model=$ctrl.establishmentSelected ng-change=$ctrl.establishmentChanged()><md-option value="{{ establishment }}" ng-repeat="establishment in $ctrl.establishments">{{ establishment.name }} {{ establishment.addressFirstLine }}</md-option></md-select></md-input-container></form></h2></div><div layout-gt-sm=row layout=row layout-wrap ng-hide=!$ctrl.establishmentId><div flex=100><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.WORKSTATIONS\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><p ng-if=!$ctrl.workstationsInUse>{{\'app.statistics.NO_WORKSTATIONS\'|translate}}</p><md-progress-circular md-mode=indeterminate ng-show=$ctrl.waitingTurnsSupervisor></md-progress-circular></div><div class=workstationInUse layout=row layout-align=space-around ng-if=$ctrl.workstationsInUse><md-card ng-repeat="workstationInUse in $ctrl.workstationsInUse | orderBy: \'index\'"><md-card-title><md-card-title-text><span class=md-headline>{{workstationInUse.workstationName}}</span></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-subhead>{{\'app.statistics.WORKSTATIONS_USER\'|translate}}: <span class=md-body-2>{{workstationInUse.userName}}</span></p><p class=md-subhead>{{\'app.statistics.WORKSTATIONS_LOGIN\'|translate}}: <span class=md-body-2>{{workstationInUse.loginAt | date:\'h:mm a\'}}</span></p><p class=md-subhead>{{\'app.statistics.WORKSTATIONS_FIRST_CALL\'|translate}}: <span class=md-body-2 ng-if=workstationInUse.firstCall>{{workstationInUse.firstCall | date:\'h:mm a\'}}</span><span class=md-body-2 ng-if=!workstationInUse.firstCall>--</span></p><p class=md-subhead>{{\'app.statistics.WORKSTATIONS_LAST_CALL\'|translate}}:<span class=md-body-2 ng-if=workstationInUse.lastCall>{{workstationInUse.lastCall | date:\'h:mm a\'}}</span><span class=md-body-2 ng-if=!workstationInUse.lastCall>--</span></p></md-card-content-text></md-card-content></md-card></div></md-card-content></md-card></div></div><div layout-gt-sm=row layout=row layout-wrap ng-hide=!$ctrl.establishmentId><div flex=100><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.TURNS\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.attending_time.activated></md-progress-circular></div><div class=turnsSupervisor layout=row layout-align=space-around><md-card><md-card-title><md-card-title-text><p class=md-headline>{{\'app.statistics.TURNS\'|translate}}</p></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-headline>{{$ctrl.allTurns}}</p></md-card-content-text></md-card-content></md-card><md-card><md-card-title><md-card-title-text><p class=md-headline>{{\'app.statistics.ATTENDED_TURNS\'|translate}}</p></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-headline>{{$ctrl.attendedTurns}}</p></md-card-content-text></md-card-content></md-card><md-card><md-card-title><md-card-title-text><p class=md-headline>{{\'app.statistics.WAITING_TURNS\'|translate}}</p></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-headline>{{$ctrl.waitingTurns}}</p></md-card-content-text></md-card-content></md-card><md-card><md-card-title><md-card-title-text><p class=md-headline>{{\'app.statistics.MISSING_TURNS\'|translate}}</p></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-headline>{{$ctrl.missingTurns}}</p></md-card-content-text></md-card-content></md-card><md-card><md-card-title><md-card-title-text><p class=md-headline>{{\'app.statistics.MANUAL_TURNS\'|translate}}</p></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-headline>{{$ctrl.manualTurns}}</p></md-card-content-text></md-card-content></md-card></div></md-card-content></md-card></div></div><div class=statistics layout-gt-sm=row layout=row layout-wrap ng-hide=!$ctrl.establishmentId><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.ATTENDING_TIME\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.attending_time.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.attending_time.data chart-labels=$ctrl.attending_time.labels chart-series=$ctrl.attending_time.series chart-click="onClick " chart-options=$ctrl.time_options></canvas><div class=message ng-show="(!$ctrl.attending_time.activated &amp;&amp; $ctrl.attending_time.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.attending_time.activated &amp;&amp; $ctrl.attending_time.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.attending_time.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.WAITING_TIME\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.waiting.activated></md-progress-circular></div><canvas class="chart chart-line" ng-show="!$ctrl.waiting.no_data &amp;&amp; !$ctrl._showMessageError" chart-data=$ctrl.waiting.data chart-labels=$ctrl.waiting.labels chart-series=$ctrl.waiting.series chart-click="onClick " chart-options=$ctrl.time_options></canvas><p ng-show="!$ctrl.waiting.activated &amp;&amp; $ctrl.waiting.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.waiting.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.QUEUES_USER\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.queues_user.activated></md-progress-circular></div><canvas class="chart chart-bar" chart-data=$ctrl.queues_user.data chart-labels=$ctrl.queues_user.labels chart-series=$ctrl.queues_user.series chart-click=onClick chart-colors=$ctrl.colors chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.queues_user.activated &amp;&amp; $ctrl.queues_user.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.queues_user.activated &amp;&amp; $ctrl.queues_user.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.queues_user.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_USER\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.clients_user.activated></md-progress-circular></div><canvas class="chart chart-bar" chart-data=$ctrl.clients_user.data chart-labels=$ctrl.clients_user.labels chart-series=$ctrl.clients_user.series chart-click=onClick chart-colors=$ctrl.colors chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.clients_user.activated &amp;&amp; $ctrl.clients_user.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.clients_user.activated &amp;&amp; $ctrl.clients_user.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.clients_user.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_ATTENDED\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.clients_attended.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.clients_attended.data chart-labels=$ctrl.clients_attended.labels chart-series=$ctrl.clients_attended.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.clients_attended.activated &amp;&amp; $ctrl.clients_attended.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.clients_attended.activated &amp;&amp; $ctrl.clients_attended.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.clients_attended.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_ABSENT\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.clients_absent.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.clients_absent.data chart-labels=$ctrl.clients_absent.labels chart-series=$ctrl.clients_absent.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.clients_absent.activated &amp;&amp; $ctrl.clients_absent.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.clients_absent.activated &amp;&amp; $ctrl.clients_absent.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.clients_absent.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_SPECIAL\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.clients_special.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.clients_special.data chart-labels=$ctrl.clients_special.labels chart-series=$ctrl.clients_special.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.clients_special.activated &amp;&amp; $ctrl.clients_special.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.clients_special.activated &amp;&amp; $ctrl.clients_special.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.clients_special.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div></div></div>');
$templateCache.put('app/modules/auth/pages/code.html','<app-navbar></app-navbar><div id=panel-container><div class=boxes><div class=w35><h1 class=header-panel style="padding-top: 20px; padding-bottom: 19px; color: #ff914d; text-align: start;margin-bottom: 10px;margin-top: 33px;font-size: 40px">{{\'app.widget.DESCRIPTION\'|translate}}</h1><div class=wrapper><div class=container><div class=tabs-container><div class=tabs><div class=tab-button ng-class="{\'active\': vm.activeTab === tab.value}" ng-repeat="tab in vm.tabs" ng-click=vm.setActiveTab(tab.value)>{{tab.title}}</div><div class=slider ng-style="{\'left\': vm.getSliderPosition()}"></div></div></div></div></div><div class=citas-content ng-show="vm.activeTab !== \'citas\'"><div style="padding-bottom: 22px"><div class=selectEstablishment2 layout=column ng-hide=vm.isAdmin><form name=selectEstablishmentForm><md-input-container md-no-float style="width:100% !important"><label style=margin-bottom:3px>{{\'app.administration.CENTER\'|translate}}</label><md-select id=center name=center ng-model=vm.establishmentSelected ng-change=vm.establishmentChanged()><md-option value="{{ establishment }}" ng-repeat="establishment in vm.establishments">{{ establishment.name }} {{ establishment.addressFirstLine }}</md-option></md-select></md-input-container></form></div></div></div><div style="padding-bottom: 23px" ng-show="vm.activeTab !== \'citas\'"><div class=selectEstablishment2 layout=column><form name=selectEstablishmentForm><md-input-container md-no-float style="width:100% !important"><label style=margin-bottom:3px>{{\'app.administration.KIOSKS\'|translate}}</label><md-select id=center name=center ng-model=vm.kioskSelected ng-change=vm.kioskChanged()><md-option value="{{ kiosk }}" ng-repeat="kiosk in vm.kiosks">{{ kiosk.name }} {{ kiosk.direction }}</md-option></md-select></md-input-container></form></div></div><div style="display: flex; flex-direction: column; width: 100%" ng-show="vm.activeTab !== \'citas\'"><div style="display: flex; flex-direction: row; width: 100%; align-items: center"><md-icon style="color: #FF914D; margin:0; font-size: 14px; line-height:14px; align-items: center; height: 14px;width: 14px;min-height: 14px;min-width: 14px">content_copy</md-icon><p class=copyCode ng-click=vm.copyCode() style="margin-right:auto; margin-left:5.5px; align-items: center">{{\'app.widget.TEXT_COPY\'|translate}}</p></div><div style=position:relative><div style=position:relative><p style="color: #616569; opacity:0.75;font-size: 10px;line-height: 12px;margin-left: 10px; position:absolute;background:#fff;top:-5px">html</p><div class=code id=code>{{vm.script}}</div></div></div></div></div><div class=w65 ng-show="vm.activeTab !== \'citas\'"><div style="text-align: center"><h2 style="padding-top: 20px; padding-bottom: 19px; color: #616569 !important; text-align: center;margin-bottom: 3px;margin-top: 38px;font-size: 30px;line-height: 40px; opacity:0.75">{{\'app.widget.PREVIEW\'|translate}}</h2><!--div#script--><div class=queues style=background-color:#{{vm.bkg}}><div class=queue style=background-color:#{{vm.bkgService}}><h2 class=h2Title ng-if=vm.queuetypes[0].name>{{vm.queuetypes[0].name}}</h2><h2 class=h2Title ng-if=!vm.queuetypes[0].name>{{\'app.widget.QUEUE_TITLE_PREVIEW\'|translate}}</h2><p class=pTitle><span style="margin:10px 10px; padding:1px 3px; background: #fff; color:#{{vm.bkgService}}; border-radius:50%; align-items:center">{{\'app.widget.QUEUE_NUM_PREVIEW\'|translate}}</span><span style="display: inline-block">{{\'app.widget.QUEUE_TEXT_PREVIEW\'|translate}}</span></p></div><img class=captchaPreview src=assets/images/captcha_preview.jpg></div></div><div><div class=actions><div><p style=color:#91979d>{{\'app.widget.TEXT_SELECT_COLOR\'|translate}}</p><input class=color style="border-radius:4px; background-color:#{{vm.bkg}}" colorpicker type=text ng-model=vm.bkg ng-change="vm.changeColor(vm.bkg, vm.bkgService)"> <input class=color style="border-radius:4px; background-color:#{{vm.bkgService}}" colorpicker type=text ng-model=vm.bkgService ng-change=vm.changeColor(vm.bkg,vm.bkgService)></div><div><p style=color:#91979d>{{\'app.widget.HEIGHT\'|translate}}</p><md-input-container><input class=md-input type=number ng-model=vm.height ng-change="vm.changeColor(vm.bkg, vm.bkgService, vm.width, vm.height)"></md-input-container></div><div><p style=color:#91979d>{{\'app.widget.WIDTH\'|translate}}</p><md-input-container><input type=number ng-model=vm.width ng-change="vm.changeColor(vm.bkg, vm.bkgService, vm.width, vm.height)"></md-input-container></div></div></div></div></div></div><div class=citas-content ng-show="vm.activeTab === \'citas\'" style="margin-top: 20px"><div class=thumbnail-container-booking style=width:100%><div class=thumbnail-booking><iframe src={{vm.setUrlBooking()}} id=frame frameborder=0 onload="this.style.opacity = 1"></iframe></div></div></div>');
$templateCache.put('app/modules/auth/pages/expired.html','<div id=error-page><h1>Expired</h1></div>');
$templateCache.put('app/modules/auth/pages/login-e.html','<div class="full-height orange" id=login-container layout=column ng-class="{\'layout-align-center-center\' : !vm.isDesk}" layout-fill><div class=loginBox ng-class="{\'md-whiteframe-z1\' : !vm.isDesk, \'desk\' : vm.isDesk}"><md-toolbar class=orange ng-if=!vm.isDesk><h2 class=md-toolbar-tools><span>Yo pido turno desde casa - Dashboard</span><span flex=""></span><md-button aria-label=Home ng-href=/ ><img class=md-card-image ng-src=/assets/images/queue-manager-logo.png alt="Logo Queue Manager"></md-button></h2></md-toolbar><md-content class=white ng-class="{\'md-padding\' : !vm.isDesk, \'md-padding-left\' : vm.isDesk}"><form ng-class="{\'layout-column\' : !vm.isDesk, \'layout-row isDesk\' : vm.isDesk}" name=loginForm ng-submit=vm.loginE(loginForm) role=form novalidate><md-input-container><label>{{ \'app.login.USERNAME\'|translate }}</label><input ng-model=vm.credentials.username name=userName type=text ng-required=true><div ng-messages=loginForm.userName.$error><div ng-message=required>{{ \'app.login.USERNAME_REQUIRED\'|translate }}</div><div ng-message=email>Your full name is</div></div></md-input-container><md-input-container class=pass><label>{{ \'app.login.PASSWORD\'|translate }}</label><input ng-model=vm.credentials.password type=password ng-required=true name=userPassword><div ng-messages=loginForm.userPassword.$error><div ng-message=required>{{ \'app.login.PASSWORD_REQUIRED\'|translate }}</div></div></md-input-container><div ng-class="{\'content-hidden\' : vm.isDesk}" layout=row><md-button class="md-button md-primary md-raised" type=submit ng-disabled=loginForm.$invalid style="background-color:#ff914d; color:#ffffff">{{ \'app.login.LOGIN\'|translate }}</md-button><!--div(flex)--><!--  a.md-body-2(href="", md-no-ink) {{ \'app.login.PASSWORD_FORGOT\'|translate }}--></div><div class=deskBoxButton ng-class="{\'content-hidden\' : !vm.isDesk}" layout=row layout-align="center center" ng-show=vm.isDesk><md-button class="md-button md-primary md-raised" type=submit ng-disabled=loginForm.$invalid><md-icon>send</md-icon></md-button></div></form></md-content></div></div>');
$templateCache.put('app/modules/auth/pages/login.html','<div class=back><md-content class=info><h1 style="margin-bottom: 50px">\xBFPor qu\xE9 elegir BookTheCity?</h1><p>Herramienta de gesti\xF3n automatizada</p><p>Kiosco online, contactles y f\xEDsico</p><p>App de petici\xF3n de turno</p><p>Preaviso por diferentes canales</p><p>Marketing en turnos</p></md-content><div class=full-height id=login-container layout=column ng-class="{\'layout-align-center-center\' : !vm.isDesk}" layout-fill><div class=loginBox ng-class="{\'\' : !vm.isDesk, \'desk\' : vm.isDesk}"><img class=md-card-image ng-src=/assets/images/logo_book_the_city.png alt="Logo Book The City"><div class=contents><p>Iniciar sesi\xF3n</p><a style="cursor: pointer" ng-click=vm.registerNav()>Crear Cuenta</a></div><md-content ng-class="{\'md-padding\' : !vm.isDesk, \'md-padding-left\' : vm.isDesk}"><form ng-class="{\'layout-column\' : !vm.isDesk, \'layout-row isDesk\' : vm.isDesk}" name=loginForm ng-submit=vm.onSubmit() role=form novalidate autocomplete=off><md-input-container><label>{{ \'app.login.USERNAME\'|translate }}</label><input class=username ng-class=input_b ng-model=vm.credentials.username name=userName type=text ng-required=true autocomplete=nope placeholder="{{ \'app.login.USERNAME\'|translate }}"><div ng-messages=loginForm.userName.$error><div ng-message=required>{{ \'app.login.USERNAME_REQUIRED\'|translate }}</div><div ng-message=email>Your full name is</div></div></md-input-container><md-input-container class=pass><label>{{ \'app.login.PASSWORD\'|translate }}</label><input class=password ng-class=input_b ng-model=vm.credentials.password type="{{ vm.show ? \'text\' : \'password\' }}" ng-required=true name=userPassword autocomplete=nope placeholder="{{ \'app.login.PASSWORD\'|translate }}"><md-button ng-click=vm._showPass() style="position: absolute; right: -6px!important; top: -9px"><md-icon>remove_red_eye</md-icon></md-button><div ng-messages=loginForm.userPassword.$error><div ng-message=required>{{ \'app.login.PASSWORD_REQUIRED\'|translate }}</div></div></md-input-container><div ng-class="{\'content-hidden\' : vm.isDesk}" layout=row><a class="md-body-2 link_recovery" href=/recover-password md-no-ink>\xBFOlvidaste tu contrase\xF1a?</a></div><div ng-class="{\'content-hidden\' : vm.isDesk}" layout=row><md-button class="md-button md-primary md-raised" type=submit ng-disabled=loginForm.$invalid style="background-color:#ff914d; color:#ffffff">{{ \'app.login.LOGIN\'|translate }}</md-button><!--div(flex)--><!--  a.md-body-2(href="", md-no-ink) {{ \'app.login.PASSWORD_FORGOT\'|translate }}--></div><div class=deskBoxButton ng-class="{\'content-hidden\' : !vm.isDesk}" layout=row layout-align="center center" ng-show=vm.isDesk><md-button class="md-button md-primary md-raised" type=submit ng-disabled=loginForm.$invalid><md-icon>send</md-icon></md-button></div></form></md-content></div></div></div>');
$templateCache.put('app/modules/auth/pages/notfound.html','<div class=pad-top-20 id=error-page><h1>Not Found</h1></div>');
$templateCache.put('app/modules/auth/pages/panels.html','<app-navbar></app-navbar><div id=panel-container><div class=logo><img class=md-card-image ng-src=/assets/images/logo_book_the_city.png alt="Logo Queue Manager" style="width: 400px"></div><div class=boxes><a ng-click=vm.showModal2()><div class=box><h1>Puestos</h1><span>Configura los puestos de espera</span></div></a><a ng-click=vm.showModal3()><div class=box><h1>Servicios</h1><span>Obt\xE9n las urls de los kioscos, para poder utilizar el kiosco online, web, f\xEDsico..</span></div></a><a ng-click=vm.Screen()><div class=box><h1>Resumen de turnos</h1><span>Obt\xE9n las urls de las pantallas, para poder ponerlo en cualquier pantalla</span></div></a><a href=/statistics/center><div class=box><h1>Administraci\xF3n</h1><span>Administra toda la informaci\xF3n, obt\xE9n estad\xEDsticas</span></div></a></div></div><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=myDialog><md-dialog arial-label=list><md-toolbar><div class=md-toolbar-tools><h2>Tus pantallas por area</h2></div></md-toolbar><md-dialog-content style="justify-content: flex-end"><div class=md-dialog-content flex style="justify-content: space-between"><div ng-repeat="kiosko in vm.kioskos"><div class=thumbnail-container style="width:360px; height:225px"><div class=thumbnail><iframe src="{{vm.setUrl(kiosko.id) | trustUrl}}" id=frame frameborder=0 onload="this.style.opacity = 1"></iframe></div></div><label><p>Nombre de la pantalla: {{ kiosko.name }}</p></label><p ng-click=vm.copyText(kiosko.id) style="cursor: pointer">Copiar URL</p><a style="text-decoration: none; color: black" href={{vm.BASE_URL_SCREEN}}/counter/screen/{{kiosko.id}}/column target=_blank>Ir a pantalla</a><md-content id=preview style="padding: 10px; width: 100%; height: 200px"><p ng-click=vm.copyText(kiosko.id) style="cursor: pointer">Copiar URL</p><a style="text-decoration: none; color: black" href={{vm.BASE_URL_SCREEN}}/counter/screen/{{kiosko.id}}/column target=_blank>Ir a pantalla</a></md-content></div></div></md-dialog-content></md-dialog></div></div><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=myDialog2><md-dialog class="backModal md-dialog-content__puestos" arial-label=list><md-toolbar><div class=md-toolbar-tools><h2>Puestos</h2></div></md-toolbar><md-dialog-content class=puestos__content><label><a style="cursor: pointer" ng-click=vm.WorkStation()>Ir a puestos</a></label></md-dialog-content></md-dialog></div></div><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=myDialog3><md-dialog class="backModal md-dialog-content__puestos" arial-label=list><md-toolbar><div class=md-toolbar-tools><h2>Servicios</h2></div></md-toolbar><md-dialog-content class=puestos__content><div class=md-dialog-content flex style="justify-content: space-between"><a style="cursor: pointer" ng-click=vm.backOffice()>Ir a Servicios</a></div></md-dialog-content></md-dialog></div></div>');
$templateCache.put('app/modules/auth/pages/redirect.html','<h1>Redirect...</h1>');
$templateCache.put('app/modules/auth/pages/reset-password.html','<div class=full-height layout=column ng-class="{\'layout-align-center-center\' : !vm.isDesk}" layout-fill><div class=loginBox ng-class="{\'md-whiteframe-z1\' : !vm.isDesk, \'desk\' : vm.isDesk}" style="width:460px; min-width:230px; margin:auto"><md-toolbar ng-if=!vm.isDesk><h2 class=md-toolbar-tools><span>Ingrese su nueva contrase\xF1a.</span><span flex=""></span><md-button aria-label=Home ng-href=/ ></md-button></h2></md-toolbar><md-content class=white ng-class="{\'md-padding\' : !vm.isDesk, \'md-padding-left\' : vm.isDesk}"><form ng-class="{\'layout-column\' : !vm.isDesk, \'layout-row isDesk\' : vm.isDesk}" name=vm.resetForm ng-submit=vm._sendPass(vm.resetForm) role=form novalidate autocomplete=off><md-input-container class=pass><label>{{ \'app.login.PASSWORD\'|translate }}</label><input class=password ng-model=vm.reset.password type="{{ vm.show ? \'text\' : \'password\' }}" name=password autocomplete=nope placeholder="{{ \'app.login.PASSWORD\'|translate }}" ng-change="vm._validateInputs(vm.reset.password, \'password\', vm.resetForm)" ng-trim=false><md-button ng-click=vm._showPass() style="position: absolute; right: -6px!important; top: -12px"><md-icon>remove_red_eye</md-icon></md-button><p ng-if=vm.errSpace style=color:red>{{ \'app.login.NO_SPACES_ALLOWED\'|translate }}</p><p ng-if="vm.errPass &amp;&amp; !vm.errSpace" style=color:red>{{ \'app.login.CONFIRM_PASSWORD\'|translate }}</p><div ng-messages=loginForm.userPassword.$error><div ng-message=required>{{ \'app.login.PASSWORD_REQUIRED\'|translate }}</div></div></md-input-container><md-input-container class=pass><label>{{ \'app.users.CONF_PASSWORD\'|translate }}</label><input class=password ng-model=vm.reset.conf_password type="{{ vm.show ? \'text\' : \'password\' }}" name=resPassword autocomplete=nope placeholder="{{ \'app.login.PASSWORD\'|translate }}" ng-change="vm._validateInputs(vm.reset.conf_password, \'resPassword\', vm.resetForm)" ng-trim=false><md-button ng-click=vm._showPass() style="position: absolute; right: -6px!important; top: -12px"><md-icon>remove_red_eye</md-icon></md-button><p ng-if="vm.confirmPassword || vm.errSpaceConfirm" style=color:red>{{ \'app.login.VALID_PASSWORD\'|translate }}</p></md-input-container><div ng-class="{\'content-hidden\' : vm.isDesk}" layout=row><md-button class="md-button md-primary md-raised" type=submit ng-disabled="vm.errPass || vm.errSpace || vm.confirmPassword || !vm.reset.password || !vm.reset.conf_password" style="background-color:#ff914d; color:#ffffff">{{ \'app.rooms.SEND_INFORMATION\'|translate }}</md-button><!--div(flex)--><!--  a.md-body-2(href="", md-no-ink) {{ \'app.login.PASSWORD_FORGOT\'|translate }}--></div><div class=deskBoxButton ng-class="{\'content-hidden\' : !vm.isDesk}" layout=row layout-align="center center" ng-show=vm.isDesk><md-button class="md-button md-primary md-raised" type=submit ng-disabled=vm.resetForm.$invalid><md-icon>send</md-icon></md-button></div></form></md-content></div></div>');
$templateCache.put('app/modules/auth/pages/unauthorized.html','<div class=pad-top-20 id=error-page><h1>Unauthorized</h1></div>');
$templateCache.put('app/modules/auth/pages/verify.html','<div class=content-verify id=panel-container><div class=logo><img class=md-card-image ng-src=/assets/images/logo_book_the_city.png alt="Logo Queue Manager"></div><div class=verify><h2>Gracias por activar tu cuenta, <span style=display:block>ahora ya puedes iniciar sesi\xF3n desde la aplicaci\xF3n</span></h2><md-button class=md-raised ng-href=/ target=_blank><span>Ir a la aplicaci\xF3n</span></md-button></div></div>');
$templateCache.put('app/modules/admin/administration/booking/booking.html','<div id=booking-container><div class="services-container float-container" flex><div class=selectOrganization layout-gt-sm=row layout=column ng-hide="$ctrl.currentRole != \'ROOT\'"><h2>{{\'app.administration.SELECT_CENTER\'|translate}}<form name=selectEstablishmentForm><md-input-container md-no-float style=width:100%><label>{{\'app.administration.CENTER\'|translate}}</label><md-select id=center name=center ng-model=$ctrl.establishmentSelected ng-change=$ctrl.establishmentChanged()><md-option value="{{ establishment }}" ng-repeat="establishment in $ctrl.establishments">{{ establishment.name }} {{ establishment.addressFirstLine }}</md-option></md-select></md-input-container></form></h2></div><h1 class=main-pannel>{{\'app.administration.BOOKING\'|translate}} - {{ $ctrl.establishmentInUse }}</h1><br><div class="content content-grid" ng-if="$ctrl.services.length &gt; 0" ng-repeat="service in $ctrl.services"><div class=grid-row><label>{{\'app.services.DISPLAY\'|translate}}</label><input class="editable-input form-control input-sm" type=text name=display ng-model=service.display><label>{{\'app.administration.STATUS\'|translate}}</label><span class="editable-text isActive" ng-if="service.status == true || service.status == \'true\'">{{\'app.administration.STATUS_ENABLED\'|translate}}</span><span class="editable-text isInactive" ng-if="service.status == \'false\' || !service.status">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div><br><div class=grid-row><label>{{\'app.services.TIME_BEFORE\'|translate}}</label><input class="bookingTime editable-input form-control input-sm" type=number name=timeBefore ng-model=service.timeBefore><label>{{\'app.services.TIME_AFTER\'|translate}}</label><input class="bookingTime editable-input form-control input-sm" type=number name=timeAfter ng-model=service.timeAfter></div><br><div class=grid-row><label>{{\'app.services.PROMOS\'|translate}}</label><div class=thumb-box><img class=thumb ng-if=service.promo_link ng-src={{service.promo_link}}><span ng-if=!service.promo_link>{{\'app.services.NO_PROMO\'|translate}}<div class=controls><input class="editable-input form-control input-sm" type=file name=promo ng-model=service.promo maxsize=100 base-sixty-four-input></div></span></div></div><div class=grid-row><md-button class="btn btn-primary btn-lg" ng-click=$ctrl.save(service)>{{\'app.common.UPDATE\'|translate}}<md-icon class=white>save</md-icon></md-button></div></div><p class=no_list ng-if=$ctrl.noData>{{\'app.NO_DATA\'|translate}}</p></div></div>');
$templateCache.put('app/modules/admin/administration/agendas/agendas.html','<div id=users-container><div class="users-container float-container" flex><div class=users-container-header><h1 class=main-pannel>{{\'Agendas\'|translate}} {{ $ctrl.organizationInUse ? \' - \' + $ctrl.organizationInUse : \'\' }}</h1><div class="brn-group add_element" ng-if="$ctrl.currentRole == \'ROOT\' || $ctrl.currentRole == \'SUPERADMIN\'"><div class=selectOrganization layout-gt-sm=row layout=column style=margin-top:5px><md-autocomplete md-no-cache=true md-selected-item=$ctrl.organizationSelected md-search-text=ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(organization) md-items="organization in $ctrl.querySearchSelect(ctrl.searchText)" md-item-text=organization.name md-min-length=0 placeholder="{{\'app.administration.SELECT_ORGANIZATION\'|translate}}"><md-item-template><span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{ organization.name }}</span></md-item-template><md-not-found>No se encontraron organizaciones.</md-not-found></md-autocomplete></div><md-button class="md-raised md-primary" ng-click=$ctrl._showZoneForm() style="background-color:#ff914d; color:#ffffff"><span>+ {{\'Nueva Agenda\'|translate}}</span></md-button></div></div><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParams disable-filter=$ctrl.isAdding demo-tracked-table=$ctrl.tableTracker><tr ng-repeat="establishment in $data" ng-form=rowForm demo-tracked-table-row=row><td class=has_dialog ng-attr-title=Organization title="\'Organizaci\xF3n\'|translate" filter="{ organization_name: \'text\'}" sortable ng-switch=establishment.isEditing ng-class="organization_name.$dirty ? \'bg-warning\' : \'\'" ng-form=organization_name demo-tracked-table-cell ng-click=$ctrl._detailIntegrationBookitit(establishment)><span class=editable-text ng-switch-default>{{establishment.organization_name}}</span><div class=controls ng-class="organization_name.$invalid &amp;&amp; organization_name.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-apis form-control input-sm" type=text name=organization_name ng-model=establishment.organization_name required></div></td><td class="has_dialog hasAPI" ng-attr-title=APIPublicKey title="\'APIPublicKey\'|translate" filter="{ apiPublicKey: \'text\'}" sortable ng-switch=establishment.isEditing ng-class="apiPublicKey.$dirty ? \'bg-warning\' : \'\'" ng-form=apiPublicKey demo-tracked-table-cell ng-click=$ctrl._detailIntegrationBookitit(establishment)><span class=editable-text ng-switch-default>{{establishment.apiPublicKey}}</span><div class=controls ng-class="apiPublicKey.$invalid &amp;&amp; apiPublicKey.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-apis form-control input-sm" type=text name=apiPublicKey ng-model=establishment.apiPublicKey required ng-change="$ctrl._validateInputs(establishment.apiPublicKey, \'apiPublicKey\', rowForm)"><p style=display:none id=err_apiPublicKey>El campo no admite s\xEDmbolos</p></div></td><td class="has_dialog hasAPI" ng-attr-title="{{\'apiPrivateKey\'|translate}}" title="\'apiPrivateKey\'|translate" filter="{ apiPrivateKey: \'text\'}" sortable ng-switch=establishment.isEditing ng-class="apiPrivateKey.$dirty ? \'bg-warning\' : \'\'" ng-form=apiPrivateKey demo-tracked-table-cell ng-click=$ctrl._detailIntegrationBookitit(establishment)><span class=editable-text ng-switch-default>{{establishment.apiPrivateKey}}</span><div class=controls ng-class="apiPrivateKey.$invalid &amp;&amp; apiPrivateKey.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-apis form-control input-sm" type=text name=apiPrivateKey ng-model=establishment.apiPrivateKey required ng-change="$ctrl._validateInputs(establishment.apiPrivateKey, \'apiPrivateKey\', rowForm)"><p style=display:none id=err_apiPrivateKey>El campo no admite s\xEDmbolos</p></div></td><td class="has_dialog hasURL" ng-attr-title="{{\'Reserva online\'|translate}}" title="\'Reserva online\'|translate" filter="{ urlWidget: \'text\'}" sortable ng-switch=establishment.isEditing ng-class="establishment.$dirty ? \'bg-warning\' : \'\'" ng-form=reserva demo-tracked-table-cell ng-click=$ctrl._detailIntegrationBookitit(establishment)><span class=editable-text ng-switch-default>{{establishment.urlWidget}}</span><div class=controls ng-class="urlWidget.$invalid &amp;&amp; urlWidget.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-apis form-control input-sm" type=text name=urlWidget ng-model=establishment.urlWidget required></div></td><td class="has_dialog has_status" ng-attr-title="{{\'app.administration.STATUS\'|translate}}" title="\'app.administration.STATUS\'|translate" filter="{ status: \'text\'}" sortable ng-switch=establishment.isEditing ng-class="establishment.$dirty ? \'bg-warning\' : \'\'" ng-form=status demo-tracked-table-cell ng-click=$ctrl._detailIntegrationBookitit(establishment)><div style="margin-left:15px; width:78px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-switch-default ng-if="establishment.status == \'true\' || establishment.status == true">fiber_manual_record</md-icon><p class="editable-text-span active" ng-switch-default ng-if="establishment.status === true || establishment.status == \'true\'">{{\'app.administration.STATUS_ENABLED\'|translate}}</p></div><div style="margin-left:15px; width:105px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-switch-default ng-if="establishment.status == \'false\' || establishment.status == false">fiber_manual_record</md-icon><p class="editable-text-span inactive" ng-switch-default ng-if="establishment.status === false || establishment.status == \'false\'">{{\'app.administration.STATUS_DISABLED\'|translate}}</p></div><div class=controls ng-class="status.$invalid &amp;&amp; status.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=status ng-model=establishment.status required><md-option value=true ng-selected="establishment.status == \'true\' || establishment.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="establishment.status == \'false\' || establishment.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div></td><td class="button-box align-center has_options" ng-if="$ctrl.currentRole == \'ROOT\' || $ctrl.currentRole == \'SUPERADMIN\'"><md-button class="optionsbtn btn btn-default btn-sm" style="border-radius: 6px" ng-click=$ctrl._editOptionsButton(establishment.id) ng-if=!establishment.isEditing><md-icon>more_horiz</md-icon></md-button><div class=activate-option id={{establishment.id}} style="right:25px; display:none"><md-button class="button-activate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl._showZoneForm(establishment) ng-if=!establishment.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">edit_not</md-icon><span class=span-activate-option style="padding: 4px 4px 4px">{{\'app.organizations.EDIT\'|translate}}</span></md-button><md-button class="button-deactivate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl.showDeleteConfirm(establishment) ng-if=!establishment.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">delete</md-icon><span class=span-desactivate-option style="padding: 4px 4px 4px">{{\'app.organizations.DELETE\'|translate}}</span></md-button><md-button class="button-deactivate-option btn-default" ng-if="establishment.interna === \'true\' || establishment.interna" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl.showConfig(establishment)><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">edit_not</md-icon><span class=span-desactivate-option style="padding: 4px 4px 4px">{{\'app.organizations.CONFIG\'|translate}}</span></md-button></div><md-button class="btn btn-primary btn-sm" ng-click=$ctrl.save(establishment) ng-if=establishment.isEditing ng-disabled=rowForm.$pristine><md-icon class=green>save</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click=$ctrl.cancel(establishment) ng-if=establishment.isEditing><md-icon class=red>cancel</md-icon></md-button></td></tr><tr ng-if="$data.length === 0"><td colspan=12><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if="$data.length &gt; 0"><td class=paginator-items colspan=12><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=5 ng-init="pageSize = 5"></select></div></td></tr></table></div><!-- DIALOG NEW INTEGRATION WITH BOKITIT--><div style="visibility: hidden"><div class=md-dialog-container id=myDialog><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'Agendas\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><form name=$ctrl.establishmentForm style=width:100%><div style=width:100%><md-input-container class=two_columns md-no-float><label>Nombre</label><input class="md-input no-spin" type=text id=name name=name ng-model=$ctrl.new_establishment.name ng-change="$ctrl._validateInputs($ctrl.new_establishment.name, \'name\', $ctrl.establishmentForm)" autocomplete=off required></md-input-container><p style=display:none id=err_name>El campo no admite s\xEDmbolos</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>Descripci\xF3n</label><input class="md-input no-spin" type=text id=description name=description ng-model=$ctrl.new_establishment.description autocomplete=off required></md-input-container><p style=display:none id=err_apiPublicKey>El campo no admite s\xEDmbolos</p></div><div style=width:100%><div flex layout=row layout-align="start center"><input class="selectCheck has_dialog" type=checkbox ng-model=$ctrl.new_establishment.interna style="width:18px; height:18px; margin-left:12px" ng-change="$ctrl._checkCitas($ctrl.new_establishment.interna, \'interna\')"><span class=editable-text style=margin-left:4px>Interna</span> <input class="selectCheck has_dialog" type=checkbox ng-model=$ctrl.new_establishment.externa style="width:18px; height:18px; margin-left:12px" ng-change="$ctrl._checkCitas($ctrl.new_establishment.externa, \'externa\')"><span class=editable-text style=margin-left:4px>Externa</span></div></div><div ng-if="$ctrl.showExterna === \'true\'" style=width:100%><md-input-container class=two_columns md-no-float><label>Bookitit</label><md-select id=status name=status ng-model=$ctrl.new_establishment.bookitit required><md-option value=true>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container><p style=display:none id=err_status>Indique el estado de la agenda</p></div><div ng-if="$ctrl.showExterna === \'true\'" style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'apiPublicKey\'|translate}}</label><input class="md-input no-spin" type=text id=apiPublicKey name=apiPublicKey ng-model=$ctrl.new_establishment.apiPublicKey ng-change="$ctrl._validateInputs($ctrl.new_establishment.apiPublicKey, \'apiPublicKey\', $ctrl.establishmentForm)" autocomplete=off></md-input-container><p style=display:none id=err_apiPublicKey>El campo no admite s\xEDmbolos</p><!--p(style="display:none" id="err2_apiPublicKey") Ingrese una ApiPublicKey--></div><div ng-if="$ctrl.showExterna === \'true\'" style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'apiPrivateKey\'|translate}}</label><input class="md-input no-spin" type=text id=apiPrivateKey name=apiPrivateKey ng-model=$ctrl.new_establishment.apiPrivateKey ng-change="$ctrl._validateInputs($ctrl.new_establishment.apiPrivateKey, \'apiPrivateKey\', $ctrl.establishmentForm)" autocomplete=off></md-input-container><p style=display:none id=err_apiPrivateKey>El campo no admite s\xEDmbolos</p><!--p(style="display:none" id="err2_apiPrivateKey") Ingrese una ApiPrivateKey--></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.administration.STATUS\'|translate}}</label><md-select id=status name=status ng-model=$ctrl.new_establishment.status required><md-option value=true>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container><p style=display:none id=err_status>Indique el estado de la agenda</p></div><div style=width:100%><md-input-container class=two_columns md-no-float ng-if=!$ctrl.editAgenda><label>{{\'app.administration.ORGANIZATION\'|translate}}</label><md-select id=center name=center ng-model=$ctrl.new_establishment.organizationId required><md-option value="{{ organization }}" ng-repeat="organization in $ctrl.organizations">{{ organization.name }}</md-option></md-select><p style=display:none id=err_center>Ingrese una organizaci\xF3n</p></md-input-container></div><md-input-container class=two_columns md-no-float><label>{{\'Reserva online\'|translate}}</label><input class="md-input no-spin" type=text id=urlWidget name=urlWidget ng-model=$ctrl.new_establishment.urlWidget autocomplete=off></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=!$ctrl.isAsking><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._sendEstablishment($ctrl.new_establishment) ng-disabled=establishmentForm.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><div style="visibility: hidden"><div class=md-dialog-container id=configDialog><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.organizations.CONFIG\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content style="padding: 0px" flex><div id=schedule ng-if="$ctrl.idBooked !== null"><div class=thumbnail-container-daries style=width:100%><div class=thumbnail-daries><iframe src="{{$ctrl.setUrl() | trustUrl}}" id=frame frameborder=0 onload="this.style.opacity = 1"></iframe></div></div></div></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=!$ctrl.isAsking><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._sendEstablishment($ctrl.new_establishment) ng-disabled=establishmentForm.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG SHOW DETAIL--><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=dialog_detail_establishment><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ \'Detalles\' }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><div><label><strong>{{\'Organizacion\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.organization_name }}</p></div><div><label><strong>{{\'Public Key\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.apiPublicKey }}</p></div><div><label><strong>{{\'Private Key\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.apiPrivateKey }}</p></div><div><label><strong>{{\'Estado\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_establishment.status == \'true\' || $ctrl.current_establishment.status == true">fiber_manual_record</md-icon><p class="editable-text-span active" ng-if="$ctrl.current_establishment.status === true">{{\'app.administration.STATUS_ENABLED\'|translate}}</p></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_establishment.status == \'false\' || $ctrl.current_establishment.status == false">fiber_manual_record</md-icon><p class="editable-text-span inactive" ng-if="$ctrl.current_establishment.status === false">{{\'app.administration.STATUS_DISABLED\'|translate}}</p></div></div><div><label><strong>{{\'Reserva online\'|translate}}:</strong></label><p class=text-margin style="overflow:auto;word-break: break-word">{{ $ctrl.current_establishment.urlWidget }}</p></div></div></md-dialog-content></md-dialog></div></div></div>');
$templateCache.put('app/modules/admin/administration/calendar/calendar.html','<div class=container><div class=contHeader><h1>Mi Perfil</h1></div><div class=profile style="margin-bottom: 5px; width: 100%"><div class=content><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Nombre del comercio</label><input ng-model=$ctrl.profileData.commerceName name=commerceName type=text autocomplete=nope placeholder="Nombre del comercio"><div ng-messages=loginForm.commerceName.$error><div ng-message=required>Nombre del comercio requerido</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><label>{{\'app.organizations.PHONE\'|translate}}</label><div style="width:100%; display: flex; justify-content: flex-start"><md-input-container><md-select name=country ng-model=$ctrl.countryCodes.country required style="width: 100px" ng-change=$ctrl.ngSelect($ctrl.countryCodes.country)><md-option ng-repeat="country in $ctrl.countries" value={{country.dial_code}}>{{country.nombre}}</md-option></md-select></md-input-container><md-input-container><label>{{\'app.organizations.PHONE\'|translate}}</label><input class="md-input no-spin" type=text id=phone name=phone ng-model=$ctrl.profileData.phone autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.profileData.phone, \'phone\')" ng-keypress="$ctrl._validateSpaces($event, $ctrl.organizationForms)"><p style=display:none id=err_phone></p></md-input-container></div></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Categor\xEDa</label><md-select name=categories ng-model=$ctrl.profileData.category required ng-change=$ctrl.ngSelectCat($ctrl.profileData.category)><md-option ng-repeat="categorie in $ctrl.categories" value={{categorie.id}}>{{categorie.name}}</md-option></md-select><div ng-messages=loginForm.category.$error><div ng-message=required>Categor\xEDa requerida</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Descripci\xF3n del comercio</label><input ng-model=$ctrl.profileData.description name=description type=text autocomplete=nope placeholder="Descripci\xF3n del comercio"><div ng-messages=loginForm.description.$error><div ng-message=required>Descripci\xF3n del comercio requerida</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Direcci\xF3n</label><input ng-model=$ctrl.profileData.address name=address type=text autocomplete=nope placeholder=Direcci\xF3n><div ng-messages=loginForm.address.$error><div ng-message=required>Direcci\xF3n requerida</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><div class=profileImage><md-tooltip md-direction=bottom>Cambiar Logo</md-tooltip><label style="height: 100%; cursor pointer" for=avatar><img class=avatarP ng-src="{{$ctrl.previewImg.logo || $ctrl.profileData.avatar || \'https://www.w3schools.com/howto/img_avatar.png\' }}" alt=Avatar> <input id=avatar type=file accept=image/* ng-model=$ctrl.profileData.avatar name=file ng-change="$ctrl._validateImages($ctrl.profileData.avatar, \'logo\')" style="display: none"></label></div></div></div><md-button class="md-raised md-primary btn_submit" ng-click=$ctrl._sendProfileDataUsr()>{{\'app.common.UPDATE\'|translate}}</md-button><h2>Datos personales</h2><div class=content><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Nombre</label><input ng-model=$ctrl.profileData.name name=name type=text autocomplete=nope placeholder=Nombre><div ng-messages=loginForm.name.$error><div ng-message=required>Nombre requerido</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Primer apellido</label><input ng-model=$ctrl.profileData.lastName name=lastName type=text autocomplete=nope placeholder="Primer apellido"><div ng-messages=loginForm.lastName.$error><div ng-message=required>Primer apellido requerido</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Segundo apellido</label><input ng-model=$ctrl.profileData.secondLastName name=secondLastName type=text autocomplete=nope placeholder="Segundo apellido"><div ng-messages=loginForm.secondLastName.$error><div ng-message=required>Segundo apellido requerido</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Email</label><input ng-model=$ctrl.profileData.email name=email type=text autocomplete=nope placeholder=Email><div ng-messages=loginForm.email.$error><div ng-message=required>Email requerido</div></div></md-input-container></md-content></div></div><md-button class="md-raised md-primary btn_submit" ng-click=$ctrl._sendProfileData()>{{\'app.common.UPDATE\'|translate}}</md-button><h2>Datos de usuario</h2><div class=content><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Nombre de usuario</label><input ng-model=$ctrl.profileData.username name=userName type=text autocomplete=nope placeholder="Nombre de usuario"><div ng-messages=loginForm.userName.$error><div ng-message=required>Nombre de usuario requerido</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Password</label><input ng-model=$ctrl.profileData.password id=password name=password type=password ng-change="$ctrl._validateInputs($ctrl.profileData.password, \'password\')" autocomplete=nope placeholder=Password><div ng-messages=loginForm.userName.$error><div ng-message=required>Password requerido</div><p ng-if=$ctrl.errPass style=color:red>Ingresa al menos una may\xFAscula, un n\xFAmero y un caracter especial</p></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Confirmar password</label><input ng-model=$ctrl.profileData.confirmPassword id=confirmPassword name=confirmPassword type=password ng-change="$ctrl._validateInputs($ctrl.profileData.confirmPassword, \'confirmPassword\')" placeholder="Confirmar password"><div ng-messages=loginForm.confirmPassword.$error><div ng-message=required>Confirmar password requerido</div><p ng-if=$ctrl.confirmPassword style=color:red>Las contrase\xF1as no coinciden</p></div></md-input-container></md-content></div></div><md-button class="md-raised md-primary btn_submit" ng-click=$ctrl._sendProfileUsr()>{{\'app.common.UPDATE\'|translate}}</md-button></div></div>');
$templateCache.put('app/modules/admin/administration/campaignes/campaignes.html','<div class=container id=campaignes-container><div class="campaignes-container float-container" flex><div class=users-container-header><h1 class=main-pannel>{{\'app.administration.CAMPAIGNES\'|translate}}</h1><div class="brn-group add_element large"><md-button class="md-raised md-primary" ng-show=$ctrl.isSuperAdmin ng-click=$ctrl._showCampaignForm()><span>{{\'app.campaignes.NEW_CAMPAIGN\'|translate}}</span></md-button><md-button class="md-raised md-primary" ng-click=$ctrl._showAsignCampaignForm() ng-disabled="$ctrl.fail || !$ctrl.hasCampaignesSelected"><span>{{\'app.campaignes.ASIGN_CAMPAIGN\'|translate}}</span></md-button></div></div><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParams disable-filter=$ctrl.isAdding demo-tracked-table=$ctrl.tableTracker><tr ng-repeat="campaign in $data" ng-form=rowForm demo-tracked-table-row=row><td><input class="selectCheck has_dialog" type=checkbox ng-model=campaign.Selected ng-click=$ctrl._selectCampaign(campaign._id)></td><td class=has_dialog ng-attr-title="{{\'app.campaignes.NAME\'|translate}}" title="\'app.campaignes.NAME\'|translate" filter="{ identifier: \'text\'}" sortable ng-switch=campaign.isEditing ng-class="identifier.$dirty ? \'bg-warning\' : \'\'" ng-form=identifier demo-tracked-table-cell ng-click=$ctrl._detailCampaign(campaign)><span class=editable-text ng-switch-default>{{campaign.identifier}}</span><div class=controls ng-class="identifier.$invalid &amp;&amp; identifier.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text name=identifier ng-model=campaign.identifier required></div></td><td class=has_dialog ng-attr-title="{{\'app.campaignes.DESCRIPTION\'|translate}}" title="\'app.campaignes.DESCRIPTION\'|translate" filter="{ description: \'text\'}" sortable ng-switch=campaign.isEditing ng-class="description.$dirty ? \'bg-warning\' : \'\'" ng-form=description demo-tracked-table-cell ng-click=$ctrl._detailCampaign(campaign)><span class=editable-text ng-switch-default>{{campaign.description}}</span><div class=controls ng-class="description.$invalid &amp;&amp; description.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text name=description ng-model=campaign.description required></div></td><td class=has_dialog ng-attr-title="{{\'app.campaignes.TYPESECTION\'|translate}}" title="\'app.campaignes.TYPESECTION\'|translate" filter="{ typesection: \'text\'}" sortable ng-switch=campaign.isEditing ng-class="typesection.$dirty ? \'bg-warning\' : \'\'" ng-form=typesection demo-tracked-table-cell ng-click=$ctrl._detailCampaign(campaign)><span class=editable-text ng-switch-default>{{campaign.typesection}}</span><div class=controls ng-class="typesection.$invalid &amp;&amp; typesection.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text name=typesection ng-model=campaign.typesection required></div></td><td class=has_dialog ng-attr-title="{{\'app.campaignes.URL\'|translate}}" title="\'app.campaignes.URL\'|translate" filter="{ url: \'text\'}" sortable ng-switch=campaign.isEditing ng-class="url.$dirty ? \'bg-warning\' : \'\'" ng-form=url demo-tracked-table-cell ng-click=$ctrl._detailCampaign(campaign)><span class=editable-text ng-switch-default>{{campaign.url}}</span><div class=controls ng-class="url.$invalid &amp;&amp; url.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text name=url ng-model=campaign.url required></div></td><td class=has_dialog ng-attr-title="{{\'app.campaignes.DEVICE\'|translate}}" title="\'app.campaignes.DEVICE\'|translate" filter="{ device: \'text\'}" sortable ng-switch=campaign.isEditing ng-class="device.$dirty ? \'bg-warning\' : \'\'" ng-form=device demo-tracked-table-cell ng-click=$ctrl._detailCampaign(campaign)><span class=editable-text ng-switch-default>{{ \'app.campaignes.\' + campaign.device + \' \'|translate }}</span><div class=controls ng-class="device.$invalid &amp;&amp; device.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=status ng-model=campaign.device required><md-option value=SCREEN ng-selected="campaign.device == \'SCREEN\'">{{\'app.campaignes.SCREEN\'|translate}}</md-option><md-option value=MOBILE ng-selected="campaign.device == \'MOBILE\'">{{\'app.campaignes.MOBILE\'|translate}}</md-option></md-select></div></td><td ng-attr-title="{{\'app.campaignes.ASIGNED\'|translate}}" title="\'app.campaignes.ASIGNED\'|translate" filter="{ asigned: \'text\'}" sortable ng-switch=campaign.isEditing ng-class="campaign.$dirty ? \'bg-warning\' : \'\'" ng-form=asigned demo-tracked-table-cell><span class=editable-text ng-switch-default ng-class="{\'active\' : campaign.asigned == \'ASIGNED_ENABLED\', \'inactive\' : campaign.asigned == \'ASIGNED_DISABLED\' }">{{ \'app.campaignes.\' + campaign.asigned + \' \'|translate }}</span><div class=controls ng-class="asigned.$invalid &amp;&amp; asigned.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=asigned ng-model=campaign.asigned required><md-option value=ASIGNED_ENABLED ng-selected="campaign.asigned == \'ASIGNED_ENABLED\'">{{\'app.campaignes.ASIGNED_ENABLED\'|translate}}</md-option><md-option value=ASIGNED_DISABLED ng-selected="campaign.asigned == \'ASIGNED_DISABLED\'">{{\'app.campaignes.ASIGNED_DISABLED\'|translate}}</md-option></md-select></div></td><td class="function_button button-box align-center"><md-button class="btn btn-primary btn-sm" ng-click="$ctrl.save(campaign, rowForm)" ng-if=campaign.isEditing ng-disabled="rowForm.$pristine || rowForm.$invalid"><md-icon class=green>save</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl.cancel(campaign, rowForm)" ng-if=campaign.isEditing><md-icon class=red>cancel</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="campaign.isEditing = true" ng-if=!campaign.isEditing><md-icon class=blue>edit</md-icon></md-button><md-button class="btn btn-sm" ng-click=$ctrl.showDeleteConfirm(campaign) ng-if=!campaign.isEditing><md-icon class=red>delete</md-icon></md-button></td></tr></table></div><!-- DIALOG NEW CAMPAIGN--><div style="visibility: hidden" aria-label="Fullscreen custom dialog"><div class=md-dialog-container id=myDialog><md-dialog><md-toolbar><div class=md-toolbar-tools><h2>{{\'app.campaignes.NEW_CAMPAIGN\'|translate}}</h2></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><form name=newCampaignForm><md-input-container class=two_columns md-no-float><label>{{\'app.campaignes.NAME\'|translate}}</label><input class="md-input no-spin" type=text id=identifier name=identifier ng-model=new_campaign.identifier required></md-input-container><md-input-container class="two_columns margin_left margin_top" md-no-float><label>{{\'app.administration.STATUS\'|translate}}</label><md-select id=status name=status ng-model=new_campaign.status required><md-option value=true selected>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container><md-input-container class=two_columns md-no-float><label>{{\'app.campaignes.DESCRIPTION\'|translate}}</label><input class="md-input no-spin" type=text id=description name=description ng-model=new_campaign.description required></md-input-container><md-input-container class="two_columns margin_left margin_top" md-no-float><label>{{\'app.campaignes.DEVICE\'|translate}}</label><md-select id=status name=status ng-model=new_campaign.device required><md-option value=SCREEN selected>{{\'app.campaignes.SCREEN\'|translate}}</md-option><md-option value=MOBILE>{{\'app.campaignes.MOBILE\'|translate}}</md-option></md-select></md-input-container><md-input-container class=two_columns md-no-float><label>{{\'app.campaignes.URL\'|translate}}</label><input class="md-input no-spin" type=text id=url name=url ng-model=new_campaign.url required></md-input-container><md-input-container class="two_columns margin_left margin_top" md-no-float><label>{{\'app.campaignes.TYPESECTION\'|translate}}</label><md-select id=status name=typesection ng-model=new_campaign.typesection required><md-option value=YOUTUBE>{{\'app.campaignes.YOUTUBE\'|translate}}</md-option><md-option value=VIDEO>{{\'app.campaignes.VIDEO\'|translate}}</md-option><md-option value=IMAGE>{{\'app.campaignes.IMG\'|translate}}</md-option></md-select></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-primary" ng-click=$ctrl._sendCampaign(new_campaign) ng-disabled=newCampaignForm.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG ASIGN CAMPAIGN--><div style="visibility: hidden" aria-label="Fullscreen ASIGN dialog"><div class=md-dialog-container id=asignDialog><md-dialog><md-toolbar><div class=md-toolbar-tools><h2>{{\'app.campaignes.ASIGN_CAMPAIGN\'|translate}}</h2></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><form name=asignCampaignForm><md-input-container md-no-float style=width:100%><label>{{\'app.administration.CENTER\'|translate}}</label><md-select id=center name=center ng-model=new_campaign.center multiple required><md-option value="{{ establishment._id }}" ng-repeat="establishment in $ctrl.establishments">{{ establishment.name }} {{ establishment.addressFirstLine }}</md-option></md-select></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-primary" ng-click=$ctrl._asignCampaign(new_campaign) ng-disabled=asignCampaignForm.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG SHOW DETAIL--><div style="visibility: hidden" aria-label="Fullscreen custom dialog"><div class=md-dialog-container id=dialog_detail_campaign><md-dialog><md-toolbar><div class=md-toolbar-tools><h2>{{ $ctrl.current_campaign.identifier }}</h2></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><label><strong>{{\'app.campaignes.NAME\'|translate}}:</strong></label><p>{{ $ctrl.current_campaign.identifier }}</p><label><strong>{{\'app.campaignes.DESCRIPTION\'|translate}}:</strong></label><p>{{ $ctrl.current_campaign.description }}</p><label><strong>{{\'app.campaignes.URL\'|translate}}:</strong></label><p>{{ $ctrl.current_campaign.url }}</p><label><strong>{{\'app.campaignes.TYPESECTION\'|translate}}:</strong></label><p>{{ $ctrl.current_campaign.typesection }}</p><label><strong>{{ \'app.campaignes.ASIGNED\'|translate }}:</strong></label><p class=has_dialog ng-class="{\'active\' : $ctrl.current_campaign.asigned == \'ASIGNED_ENABLED\', \'inactive\' : $ctrl.current_campaign.asigned == \'ASIGNED_DISABLED\' }" ng-click=$ctrl._detailAsignedCampaign($ctrl.current_campaign)>{{ \'app.campaignes.\' + $ctrl.current_campaign.asigned + \' \'|translate }}<span ng-if="$ctrl.current_campaign.asigned == \'ASIGNED_ENABLED\'" style=color:#777>{{ \'app.administration.CLICK_TO_SEE\'|translate }}</span></p></div></md-dialog-content></md-dialog></div></div><!-- DIALOG SHOW DETAIL CENTERS ASIGNED--><div style="visibility: hidden" aria-label="Fullscreen custom dialog"><div class=md-dialog-container id=dialog_detail_asigned_campaign><md-dialog><md-toolbar><div class=md-toolbar-tools><h1>{{\'app.administration.CAMPAIGN\'|translate}}: {{ $ctrl.current_campaign.identifier }}</h1></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><p ng-repeat="establishment in $ctrl.current_campaign.establishments"><strong>{{ establishment.name }}:</strong><span>{{ establishment.addressFirstLine }}</span></p></div></md-dialog-content></md-dialog></div></div></div>');
$templateCache.put('app/modules/admin/administration/establishments/establishments.html','<div id=users-container><div class="users-container float-container" flex><div class=users-container-header><h1 class=main-pannel ng-if="$ctrl.currentRole == \'ROOT\' || $ctrl.currentRole == \'SUPERADMIN\'">{{\'app.administration.ESTABLISHMENTS\'|translate}} {{ $ctrl.organizationInUse ? \' - \' + $ctrl.organizationInUse : \'\' }}</h1><h1 class=main-pannel ng-if="$ctrl.currentRole != \'ROOT\' &amp;&amp; $ctrl.currentRole != \'SUPERADMIN\'">{{\'app.administration.ESTABLISHMENTS\'|translate}}</h1><div class="brn-group add_element"><div class="selectOrganization add_element" layout-gt-sm=row layout=column style=margin-top:5px ng-if=$ctrl.isRoot><md-autocomplete ng-disabled="!$ctrl.organizations || !$ctrl.organizations.length" md-no-cache=true md-selected-item=$ctrl.organizationSelected md-search-text=ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(organization) md-items="organization in $ctrl.querySearchSelect(ctrl.searchText)" md-item-text=organization.name md-min-length=0 placeholder="{{\'app.administration.SELECT_ORGANIZATION\'|translate}}"><md-item-template><span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{ organization.name }}</span></md-item-template><md-not-found>No se encontraron organizaciones.</md-not-found></md-autocomplete></div><md-button class="md-raised md-primary" ng-click=$ctrl._showZoneForm() style="background-color:#ff914d; color:#ffffff" ng-if="$ctrl.currentRole == \'ROOT\' || $ctrl.currentRole == \'SUPERADMIN\'"><span>+ {{\'app.establishments.NEW_ESTABLISHMENT\'|translate}}</span></md-button></div></div><table class="table-striped table table-bordered table-hover table-condensed editable-table" id=establishment-table ng-table=$ctrl.tableParams disable-filter=$ctrl.isAdding demo-tracked-table=$ctrl.tableTracker><tr ng-if="establishment.isVisible != false" ng-repeat="establishment in $data" ng-form=rowForm demo-tracked-table-row=row><td class="has_dialog has_name" ng-attr-title="{{\'app.establishments.NAME\'|translate}}" title="\'app.establishments.NAME\'|translate" filter="{ name: \'text\' }" ng-switch=establishment.isEditing ng-class="name.$dirty ? \'bg-warning\' : \'\'" ng-form=name demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class=editable-text ng-switch-default>{{establishment.name}}</span><div class=controls ng-class="name.$invalid &amp;&amp; name.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text id=name name=name ng-model=establishment.name required ng-change="$ctrl._validateInputs(establishment.name, \'name\', rowForm)"><p style=display:none id=err_name></p></div></td><td class="has_dialog has_dir" ng-attr-title="{{\'app.establishments.FIRSTLINE\'|translate}}" title="\'app.establishments.FIRSTLINE\'|translate" filter="{ address: \'text\' }" ng-switch=establishment.isEditing ng-class="address.$dirty ? \'bg-warning\' : \'\'" ng-form=address demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class=editable-text ng-switch-default>{{establishment.address}}</span><div class=controls ng-class="address.$invalid &amp;&amp; address.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-dir form-control input-sm" type=text id=address name=address ng-model=establishment.address required ng-change="$ctrl._validateInputs(establishment.address, \'address\', rowForm)"><p style=display:none id=err_address></p></div></td><td class="has_dialog has_city" ng-attr-title="{{\'app.establishments.CITY\'|translate}}" title="\'app.establishments.CITY\'|translate" filter="{ city: \'text\' }" ng-switch=establishment.isEditing ng-class="city.$dirty ? \'bg-warning\' : \'\'" ng-form=city demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class=editable-text ng-switch-default>{{establishment.city}}</span><div class=controls ng-class="city.$invalid &amp;&amp; city.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text id=center name=center ng-model=establishment.city required ng-change="$ctrl._validateInputs(establishment.city, \'center\', rowForm)"><p style=display:none id=err_center></p></div></td><td class="has_dialog has_postal_code" ng-attr-title="{{\'app.establishments.POSTCODE\'|translate}}" title="\'app.establishments.POSTCODE\'|translate" filter="{ postCode: \'text\' }" ng-switch=establishment.isEditing ng-class="postCode.$dirty ? \'bg-warning\' : \'\'" ng-form=postCode demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class=editable-text ng-switch-default>{{establishment.postCode}}</span><div class=controls ng-class="postCode.$invalid &amp;&amp; postCode.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text id=postCode name=postCode ng-model=establishment.postCode maxlength=10 required ng-change="$ctrl._validateInputs(establishment.postCode, \'postCode\', rowForm)"><p style=display:none id=err_postCode></p></div></td><td class="has_dialog has_telephone" ng-attr-title="{{\'app.establishments.TIME_ZONE\'|translate}}" title="\'app.establishments.TIME_ZONE\'|translate" filter="{ timeZoneName: \'text\' }" ng-switch=establishment.isEditing ng-class="timeZoneName.$dirty ? \'bg-warning\' : \'\'" ng-form=timeZoneName demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class=editable-text ng-switch-default>{{ $ctrl.getTimeZoneName(establishment.timeZonesId) ? $ctrl.getTimeZoneName(establishment.timeZonesId) : \'No disponible\' }}</span><div class=controls ng-class="timeZonesId.$invalid &amp;&amp; timeZonesId.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=center name=timeZonesId ng-model=establishment.timeZonesId required><md-option value="{{ timezone.id }}" ng-repeat="timezone in $ctrl.timeZones">{{ timezone.name }}</md-option></md-select></div></td><td class="has_dialog has_telephone" ng-attr-title="{{\'app.establishments.PHONE\'|translate}}" title="\'app.establishments.PHONE\'|translate" filter="{ phone: \'text\' }" ng-switch=establishment.isEditing ng-class="phone.$dirty ? \'bg-warning\' : \'\'" ng-form=phone demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class=editable-text ng-switch-default>{{establishment.phone}}</span><div class=controls ng-class="phone.$invalid &amp;&amp; phone.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="input-phone editable-input form-control input-sm" type=text id=phone name=phone ng-model=establishment.phone maxlength=10 ng-change="$ctrl._validateInputs(establishment.phone, \'phone\', rowForm)"><p style=display:none id=err_phone></p></div></td><td class="has_dialog has_ticket" ng-attr-title="{{\'app.establishments.TEXT_TICKET\'|translate}}" title="\'app.establishments.TEXT_TICKET\'|translate" filter="{ ticketText: \'text\' }" ng-switch=establishment.isEditing ng-class="ticketText.$dirty ? \'bg-warning\' : \'\'" ng-form=ticketText demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class=editable-text ng-switch-default>{{establishment.ticketText}}</span><div class=controls ng-class="ticketText.$invalid &amp;&amp; ticketText.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text id=ticketText name=ticketText ng-model=establishment.ticketText ng-change="$ctrl._validateInputs(establishment.ticketText, \'ticketText\', rowForm)"><p style=display:none id=err_ticketText></p></div></td><td class="has_dialog has_status" ng-attr-title="{{\'app.administration.STATUS\'|translate}}" title="\'app.administration.STATUS\'|translate" ng-switch=establishment.isEditing ng-class="establishment.$dirty ? \'bg-warning\' : \'\'" ng-form=status demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class="editable-text active" ng-if="establishment.status == \'true\' || establishment.status == true" ng-switch-default></span><span class="editable-text inactive" ng-if="establishment.status == \'false\' || !establishment.status" ng-switch-default></span><div class=controls ng-class="status.$invalid &amp;&amp; status.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=status ng-model=establishment.status required><md-option value=true ng-selected="establishment.status == \'true\' || establishment.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="establishment.status == \'false\' || establishment.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div></td><td class="has_dialog has_turn_counter" ng-attr-title="{{\'app.establishments.TURN_LIMIT\'|translate}}" title="\'app.establishments.TURN_LIMIT\'|translate" ng-switch=establishment.isEditing ng-class="turnLimit.$dirty ? \'bg-warning\' : \'\'" ng-form=turnLimit demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class=editable-text ng-switch-default>{{ establishment.turnLimit }}</span><div class=controls ng-class="turnLimit.$invalid &amp;&amp; turnLimit.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-letter form-control input-sm" type=number id=turnLimit name=turnLimit ng-model=establishment.turnLimit value=100 ng-change="$ctrl._validateInputs(establishment.turnLimit, \'turnLimit\', rowForm)"><p style=display:none id=err_turn_limit></p></div></td><td class="has_dialog has_turn_counter" ng-attr-title="{{\'app.establishments.PREVIOUS_NOTIFICATION\'|translate}}" title="\'app.establishments.PREVIOUS_NOTIFICATION\'|translate" ng-switch=establishment.isEditing ng-class="previousNotificationLimit.$dirty ? \'bg-warning\' : \'\'" ng-form=previousNotificationLimit demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class=editable-text ng-switch-default>{{ establishment.previousNotificationLimit }}</span><div class=controls ng-class="previousNotificationLimit.$invalid &amp;&amp; previousNotificationLimit.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-letter form-control input-sm" type=number id=previousNotificationLimit name=previousNotificationLimit ng-model=establishment.previousNotificationLimit value=100 ng-change="$ctrl._validateInputs(establishment.previousNotificationLimit, \'previousNotificationLimit\', rowForm)"><p style=display:none id=err_turn_limit></p></div></td><td class="has_dialog has_sms_counter" ng-attr-title="{{\'app.establishments.SMS_COUNT\'|translate}}" title="\'app.establishments.SMS_COUNT\'|translate" ng-switch=establishment.isEditing ng-class="smsCount.$dirty ? \'bg-warning\' : \'\'" ng-form=smsCount demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class=editable-text ng-switch-default>{{ establishment.smsCount }}</span></td><td class="has_dialog has_sms_counter" ng-attr-title="{{\'app.establishments.SMS_LIMIT\'|translate}}" title="\'app.establishments.SMS_LIMIT\'|translate" ng-switch=establishment.isEditing ng-class="smsLimit.$dirty ? \'bg-warning\' : \'\'" ng-form=smsLimit demo-tracked-table-cell ng-click=$ctrl._detailEstablishment(establishment)><span class=editable-text ng-switch-default>{{ establishment.smsLimit }}</span><div class=controls ng-class="smsLimit.$invalid &amp;&amp; smsLimit.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-letter form-control input-sm" type=number id=smsLimit name=smsLimit ng-model=establishment.smsLimit value=2500 ng-change="$ctrl._validateInputs(establishment.smsLimit, \'smsLimit\', rowForm)"><p style=display:none id=err_sms_limit></p></div></td><td class="has_dialog has_checkbox" style="text-align: center" ng-attr-title="{{\'app.establishments.ASKING_NAME\'|translate}}" ng-switch=establishment.isEditing ng-class="askingName.$dirty ? \'bg-warning\' : \'\'" ng-form=askingName demo-tracked-table-cell><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(establishment.id,\'a\')" ng-if="establishment.askingName == \'true\' || establishment.askingName ===true"><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.establishments.ASKING_NAME\'|translate}}</md-tooltip><md-icon class=orange style="position: static">description</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(establishment.id,\'a\')" ng-if="!establishment.askingName || establishment.askingName == \'false\' || establishment.askingName ===false"><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.establishments.ASKING_NAME\'|translate}}</md-tooltip><md-icon class=gray-disabled style="position: static">description</md-icon></md-button><div class=controls ng-class="askingName.$invalid &amp;&amp; askingName.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=askingName ng-model=establishment.askingName required><md-option value=true ng-selected="establishment.askingName == \'true\' || establishment.askingName == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="establishment.askingName == \'false\' || establishment.askingName == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div><div class=activate-option id={{establishment.id}}a style=display:none><md-button class="button-activate-option btn-default" style="opacity: 1;margin:0px" value=true ng-click="$ctrl.updateIcons(establishment, rowForm, true, \'askingName\')">{{\'app.ACTIVE\'|translate}}</md-button><md-button class="button-deactivate-option btn-default" style="opacity: 1;margin:0px" value=false ng-click="$ctrl.updateIcons(establishment, rowForm, false, \'askingName\')">{{\'app.NO_ACTIVE\'|translate}}</md-button></div></td><td class="has_dialog has_checkbox" style="text-align: center" ng-attr-title="{{\'app.establishments.ASKING_DNI\'|translate}}" ng-switch=establishment.isEditing ng-class="askingDNI.$dirty ? \'bg-warning\' : \'\'" ng-form=askingDNI demo-tracked-table-cell><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(establishment.id,\'c\')" ng-if="establishment.askingDNI == \'true\' || establishment.askingDNI ===true"><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.establishments.ASKING_DNI\'|translate}}</md-tooltip><md-icon class=orange style="position: static">contacts</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(establishment.id,\'c\')" ng-if="!establishment.askingDNI || establishment.askingDNI == \'false\' || establishment.askingDNI ===false"><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.establishments.ASKING_DNI\'|translate}}</md-tooltip><md-icon class=gray-disabled style="position: static">contacts</md-icon></md-button><div class=controls ng-class="askingDNI.$invalid &amp;&amp; askingDNI.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=askingDNI ng-model=establishment.askingDNI required><md-option value=true ng-selected="establishment.askingDNI == \'true\' || establishment.askingDNI == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="!establishment.askingDNI || establishment.askingDNI == \'false\'">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div><div class=activate-option id={{establishment.id}}c style=display:none><md-button class="button-activate-option btn-default" style="opacity: 1;margin:0px" value=true ng-click="$ctrl.updateIcons(establishment, rowForm, true, \'askingDNI\')">{{\'app.ACTIVE\'|translate}}</md-button><md-button class="button-deactivate-option btn-default" style="opacity: 1;margin:0px" value=false ng-click="$ctrl.updateIcons(establishment, rowForm, false, \'askingDNI\')">{{\'app.NO_ACTIVE\'|translate}}</md-button></div></td><td class="has_dialog has_checkbox" style="text-align: center" ng-attr-title="{{\'app.establishments.ASKING_PHONE\'|translate}}" ng-switch=establishment.isEditing ng-class="asking_phone.$dirty ? \'bg-warning\' : \'\'" ng-form=asking_phone demo-tracked-table-cell><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(establishment.id,\'b\')" ng-if="establishment.asking_phone == \'true\' || establishment.asking_phone ===true"><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.establishments.ASKING_PHONE\'|translate}}</md-tooltip><md-icon class=orange style="position: static">phone</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(establishment.id,\'b\')" ng-if="!establishment.asking_phone || establishment.asking_phone == \'false\' || establishment.asking_phone ===false"><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.establishments.ASKING_PHONE\'|translate}}</md-tooltip><md-icon class=gray-disabled style="position: static">phone</md-icon></md-button><div class=controls ng-class="asking_phone.$invalid &amp;&amp; asking_phone.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=asking_phone ng-model=establishment.asking_phone required><md-option value=true ng-selected="establishment.asking_phone == \'true\' || establishment.asking_phone ===true">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="!establishment.asking_phone || establishment.asking_phone == \'false\' || establishment.asking_phone ===false">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div><div class=activate-option id={{establishment.id}}b style=display:none><md-button class="button-activate-option btn-default" style="opacity: 1;margin:0px" value=true ng-click="$ctrl.updateIcons(establishment, rowForm, \'true\', \'asking_phone\')">{{\'app.ACTIVE\'|translate}}</md-button><md-button class="button-deactivate-option btn-default" style="opacity: 1;margin:0px" value=false ng-click="$ctrl.updateIcons(establishment, rowForm, \'false\', \'asking_phone\')">{{\'app.NO_ACTIVE\'|translate}}</md-button></div></td><td class="has_dialog has_checkbox" style="text-align: center" ng-attr-title="{{\'app.establishments.SINGLE_QUEUE\'|translate}}" ng-switch=establishment.isEditing ng-class="singleQueue.$dirty ? \'bg-warning\' : \'\'" ng-form=singleQueue demo-tracked-table-cell><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(establishment.id,\'d\')" ng-if="establishment.singleQueue == \'true\' || establishment.singleQueue ===true"><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.establishments.SINGLE_QUEUE\'|translate}}</md-tooltip><md-icon class="orange call-split-thick" style="position: static">call_split</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(establishment.id,\'d\')" ng-if="!establishment.singleQueue || establishment.singleQueue == \'false\' || establishment.singleQueue ===false"><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.establishments.SINGLE_QUEUE\'|translate}}</md-tooltip><md-icon class="gray-disabled call-split-thick" style="position: static">call_split</md-icon></md-button><div class=controls ng-class="singleQueue.$invalid &amp;&amp; singleQueue.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=singleQueue ng-model=establishment.singleQueue required><md-option value=true ng-selected="establishment.singleQueue == \'true\' || establishment.singleQueue ===true">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="!establishment.singleQueue || establishment.singleQueue == \'false\' || establishment.singleQueue === false">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div><div class=activate-option id={{establishment.id}}d style=display:none><md-button class="button-activate-option btn-default" style="opacity: 1;margin:0px" value=true ng-click="$ctrl.updateIcons(establishment, rowForm, \'true\', \'singleQueue\')">{{\'app.ACTIVE\'|translate}}</md-button><md-button class="button-deactivate-option btn-default" style="opacity: 1;margin:0px" value=false ng-click="$ctrl.updateIcons(establishment, rowForm, \'false\', \'singleQueue\')">{{\'app.NO_ACTIVE\'|translate}}</md-button></div></td><td class="button-box align-center has_options"><md-button class="optionsbtn btn btn-default btn-sm" style="border-radius: 6px" ng-click=$ctrl._editOptionsButton(establishment.id) ng-if=!establishment.isEditing><md-icon>more_horiz</md-icon></md-button><div class=activate-option id={{establishment.id}} style="right:25px; display:none"><md-button class="button-activate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl._showZoneForm(establishment) ng-if=!establishment.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">edit_not</md-icon><span class=span-activate-option style="padding: 4px 4px 4px">{{\'app.organizations.EDIT\'|translate}}</span></md-button><md-button class="button-deactivate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl.showDeleteConfirm(establishment) ng-if=!establishment.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">delete</md-icon><span class=span-desactivate-option style="padding: 4px 4px 4px">{{\'app.organizations.DELETE\'|translate}}</span></md-button></div><md-button class="btn btn-primary btn-sm" ng-click=$ctrl.save(establishment) ng-if=establishment.isEditing ng-disabled=rowForm.$pristine><md-icon class=green>save</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl.cancel(establishment, rowForm)" ng-if=establishment.isEditing><md-icon class=red>cancel</md-icon></md-button></td></tr><tr ng-if=$ctrl.noData><td colspan=17><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if=!$ctrl.noData><td class=paginator-items colspan=17><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=5 ng-init="pageSize = 5"></select></div></td></tr></table></div><!-- DIALOG NEW ESTABLISHMENT--><div style="visibility: hidden"><div class=md-dialog-container id=myDialog><md-dialog style=min-height:790px><md-toolbar style=height:85px><div class="md-toolbar-tools closeModals"><h2 ng-if=!$ctrl.editEstablishment>{{\'app.establishments.NEW_ESTABLISHMENT\'|translate}}</h2><h2 ng-if=$ctrl.editEstablishment>{{\'app.establishments.EDIT_ESTABLISHMENT\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex style="padding-bottom: 0"><form name=$ctrl.establishmentForm style="width:100%; row-gap: 12px"><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.establishments.NAME\'|translate}}</label><input class="md-input no-spin" type=text id=name name=name ng-model=$ctrl.new_establishment.name autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_establishment.name, \'name\', $ctrl.establishmentForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.establishmentForm)"></md-input-container><p style=display:none id=err_name>Ingrese el nombre un nombre v\xE1lido</p></div><div style=width:100%><md-input-container md-no-float style=width:100%><label>{{\'app.establishments.FIRSTLINE\'|translate}}</label><input class="md-input no-spin" type=text id=addressFirstLine name=addressFirstLine ng-model=$ctrl.new_establishment.address autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_establishment.address, \'addressFirstLine\', $ctrl.establishmentForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.establishmentForm)"></md-input-container><p style=display:none id=err_address>Ingrese una direcci\xF3n v\xE1lida</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.establishments.CITY\'|translate}}</label><input class="md-input no-spin" type=text id=city name=city ng-model=$ctrl.new_establishment.city autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_establishment.city, \'city\', $ctrl.establishmentForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.establishmentForm)"></md-input-container><p style=display:none id=err_city>Ingrese una ciudad v\xE1lida</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.establishments.POSTCODE\'|translate}}</label><input class="md-input no-spin" type=text id=postCode name=postCode ng-model=$ctrl.new_establishment.postCode autocomplete=off maxlength=10 required ng-change="$ctrl._validateInputs($ctrl.new_establishment.postCode, \'postCode\', $ctrl.establishmentForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.establishmentForm)"></md-input-container><p style=display:none id=err_postCode>Ingrese un c\xF3digo postal v\xE1lido</p></div><div style="width:100%; display: flex; justify-content: flex-start; gap: 8px"><div style="display: flex; flex-direction: column"><md-input-container><md-select id=country name=country ng-model=$ctrl.countryCodes.country required style="width: 100px" ng-change=$ctrl.ngSelect($ctrl.countryCodes.country)><md-option ng-repeat="country in $ctrl.countries" value={{country.dial_code}}>{{country.nombre}}</md-option></md-select></md-input-container></div><div style="display: flex; flex-direction: column; flex-grow: 1"><md-input-container><label>{{\'app.establishments.PHONE\'|translate}}</label><input class="md-input no-spin" ng-blur=$ctrl.onInputBlur() type=text id=phone name=phone ng-model=$ctrl.new_establishment.phone autocomplete=off maxlength=10 required ng-change="$ctrl._validateInputs($ctrl.new_establishment.phone, \'phone\', $ctrl.establishmentForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.establishmentForm, \'phone\')"></md-input-container><p style=display:none id=err_phone>Ingrese un n\xFAmero de tel\xE9fono v\xE1lido</p></div></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.establishments.STATE_REGION\'|translate}}</label><input class="md-input no-spin" type=text id=stateRegion name=stateRegion ng-model=$ctrl.new_establishment.stateRegion autocomplete=off maxlength=100 required ng-change="$ctrl._validateInputs($ctrl.new_establishment.stateRegion, \'stateRegion\', $ctrl.establishmentForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.establishmentForm)"></md-input-container><p style=display:none id=err_stateRegion>Ingrese un estado o regi\xF3n v\xE1lida</p></div><!-- Select Time Zones--><md-input-container class=two_columns ng-if="$ctrl.currentRole == \'ROOT\'" md-no-float><label>{{\'app.administration.TIME_ZONE\'|translate}}</label><md-select id=center name=center ng-model=$ctrl.new_establishment.timeZonesId required><md-option value="{{ timeZone.id }}" ng-repeat="timeZone in $ctrl.timeZones">{{ timeZone.name }}</md-option></md-select></md-input-container><md-input-container class=two_columns ng-if="$ctrl.currentRole == \'ROOT\'" md-no-float><label>{{\'app.administration.ORGANIZATION\'|translate}}</label><md-select id=center name=center ng-model=$ctrl.new_establishment.organizationId required><md-option value="{{ organization.id }}" ng-repeat="organization in $ctrl.organizations">{{ organization.name }}</md-option></md-select></md-input-container><div style=width:100%><md-input-container md-no-float style="width:100%; grid-column-start: 1; grid-column-end: 3"><label>{{\'app.establishments.DESCRIPTION\'|translate}}</label><input class="md-input no-spin" type=text id=description name=description ng-model=$ctrl.new_establishment.description autocomplete=off maxlength=100 required ng-change="$ctrl._validateInputs($ctrl.new_establishment.description, \'description\', $ctrl.establishmentForm )" ng-keypress="$ctrl._validateSpaces($event, $ctrl.establishmentForm)"></md-input-container><p style=display:none id=err_description>Ingrese una descripci\xF3n v\xE1lida</p></div><div style=width:100%><md-input-container md-no-float style="width:100%; grid-column-start: 1; grid-column-end: 3"><label>{{\'app.establishments.DELEGATION\'|translate}}</label><input class="md-input no-spin" type=text id=delegation name=delegation ng-model=$ctrl.new_establishment.delegation autocomplete=off maxlength=100 required ng-change="$ctrl._validateInputs($ctrl.new_establishment.delegation, \'delegation\', $ctrl.establishmentForm )" ng-keypress="$ctrl._validateSpaces($event, $ctrl.establishmentForm)"></md-input-container><p style=display:none id=err_delegation>Ingrese una descripci\xF3n v\xE1lida</p></div><hr style="width:100%; visibility:hidden"><hr style="width:100%; visibility:hidden"><md-input-container class=two_columns md-no-float><label>{{\'app.establishments.ASKING_NAME\'|translate}}</label><md-select id=status name=askingName ng-model=$ctrl.new_establishment.askingName required><md-option value=true>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false selected>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container><md-input-container class=two_columns md-no-float><label>{{\'app.establishments.ASKING_PHONE\'|translate}}</label><md-select id=status name=asking_phone ng-model=$ctrl.new_establishment.asking_phone required><md-option value=true>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false selected>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container><md-input-container class=two_columns md-no-float><label>{{\'app.establishments.ASKING_DNI\'|translate}}</label><md-select id=status name=askingDNI ng-model=$ctrl.new_establishment.askingDNI required><md-option value=true>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false selected>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.administration.INS\'|translate}}</label><md-select id=status name=showInstrucciones ng-model=$ctrl.new_establishment.showInstrucciones required><md-option value=true>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false selected>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select><p style=display:none id=err_status>Seleccione una opci\xF3n del listado</p></md-input-container></div><div style=width:100%><md-input-container md-no-float style=width:100%><label>{{\'app.establishments.SINGLE_QUEUE\'|translate}}</label><md-select id=status name=singleQueue ng-model=$ctrl.new_establishment.singleQueue required><md-option value=true>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false selected>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.establishments.SMS_LIMIT\'|translate}}</label><input class="md-input no-spin" type=number id=smsLimit name=smsLimit ng-model=$ctrl.new_establishment.smsLimit autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_establishment.smsLimit, \'smsLimit\', $ctrl.establishmentForm)" ng-disabled="$ctrl.currentRole != \'ROOT\'"></md-input-container><p style=display:none id=err_smsLimit>Ingrese un n\xFAmero v\xE1lido</p></div><div style=width:100%><md-input-container md-no-float style=width:100%><label>{{\'app.establishments.TURN_LIMIT\'|translate}}</label><input class="md-input no-spin" type=number id=turnLimit name=turnLimit ng-model=$ctrl.new_establishment.turnLimit autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_establishment.turnLimit, \'turnLimit\', $ctrl.establishmentForm)" ng-disabled="$ctrl.currentRole != \'ROOT\'"></md-input-container><p style=display:none id=err_turnLimit>Ingrese un n\xFAmero v\xE1lido</p></div><div style=width:100%><md-input-container md-no-float style=width:100%><label>{{\'app.establishments.PREVIOUS_NOTIFICATION\'|translate}}</label><input class="md-input no-spin" type=number id=previousNotificationLimit name=previousNotificationLimit ng-model=$ctrl.new_establishment.previousNotificationLimit autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_establishment.previousNotificationLimit, \'previousNotificationLimit\', $ctrl.establishmentForm)" ng-disabled="$ctrl.currentRole != \'ROOT\'"></md-input-container><p style=display:none id=err_previousNotificationLimit>Ingrese un n\xFAmero v\xE1lido</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.administration.STATUS\'|translate}}</label><md-select id=status name=status ng-model=$ctrl.new_establishment.status required><md-option value=true selected>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container></div></form></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=!$ctrl.isAsking><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._sendEstablishment($ctrl.new_establishment) ng-disabled=establishmentForm.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG SHOW DETAIL--><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=dialog_detail_establishment><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ $ctrl.current_establishment.name }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><div><label><strong>{{\'app.establishments.DESCRIPTION\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.description ? $ctrl.current_establishment.description : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.FIRSTLINE\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.address ? $ctrl.current_establishment.address : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.CITY\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.city ? $ctrl.current_establishment.city : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.POSTCODE\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.postCode ? $ctrl.current_establishment.postCode : \'No disponible\'}}</p></div><div><label><strong>{{\'app.administration.TIME_ZONE\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.getTimeZoneName($ctrl.current_establishment.timeZonesId) ? $ctrl.getTimeZoneName($ctrl.current_establishment.timeZonesId) : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.PHONE\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.phone ? $ctrl.current_establishment.phone : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.TEXT_TICKET\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.ticketText ? $ctrl.current_establishment.ticketText : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.STATE_REGION\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.stateRegion ? $ctrl.current_establishment.stateRegion : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.TURN_COUNT\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.ticketCount ? $ctrl.current_establishment.ticketCount : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.TURN_LIMIT\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.turnLimit ? $ctrl.current_establishment.turnLimit : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.SMS_COUNT\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.smsCount ? $ctrl.current_establishment.smsCount : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.SMS_LIMIT\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.smsLimit ? $ctrl.current_establishment.smsLimit : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.PREVIOUS_NOTIFICATION\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_establishment.previousNotificationLimit ? $ctrl.current_establishment.previousNotificationLimit : \'No disponible\'}}</p></div><div><label><strong>{{\'app.administration.STATUS\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_establishment.status == \'true\' || $ctrl.current_establishment.status == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_establishment.status == \'true\' || $ctrl.current_establishment.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_establishment.status == \'false\' || $ctrl.current_establishment.status == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_establishment.status == \'false\' || $ctrl.current_establishment.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div></div><div><label><strong>{{\'app.establishments.ASKING_NAME\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_establishment.askingName == \'true\' || $ctrl.current_establishment.askingName == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_establishment.askingName == \'true\' || $ctrl.current_establishment.askingName == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_establishment.askingName == \'false\' || $ctrl.current_establishment.askingName == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_establishment.askingName == \'false\' || $ctrl.current_establishment.askingName == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div><p class=text-margin ng-if="$ctrl.current_establishment.askingName === undefined">{{ $ctrl.current_establishment.askingName ? $ctrl.current_establishment.askingName : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.ASKING_DNI\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_establishment.askingDNI == \'true\' || $ctrl.current_establishment.askingDNI == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_establishment.askingDNI == \'true\' || $ctrl.current_establishment.askingDNI == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_establishment.askingDNI == \'false\' || $ctrl.current_establishment.askingDNI == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_establishment.askingDNI == \'false\' || $ctrl.current_establishment.askingDNI == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div><p class=text-margin ng-if="$ctrl.current_establishment.askingDNI === undefined">{{ $ctrl.current_establishment.askingDNI ? $ctrl.current_establishment.askingDNI : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.ASKING_PHONE\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_establishment.asking_phone == \'true\' || $ctrl.current_establishment.asking_phone == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_establishment.asking_phone == \'true\' || $ctrl.current_establishment.asking_phone == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_establishment.asking_phone == \'false\' || $ctrl.current_establishment.asking_phone == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_establishment.asking_phone == \'false\' || $ctrl.current_establishment.asking_phone == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div><p class=text-margin ng-if="$ctrl.current_establishment.asking_phone === undefined">{{ $ctrl.current_establishment.asking_phone ? $ctrl.current_establishment.asking_phone : \'No disponible\'}}</p></div><div><label><strong>{{\'app.establishments.SINGLE_QUEUE\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_establishment.singleQueue == \'true\' || $ctrl.current_establishment.singleQueue == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_establishment.singleQueue == \'true\' || $ctrl.current_establishment.singleQueue == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_establishment.singleQueue == \'false\' || $ctrl.current_establishment.singleQueue == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_establishment.singleQueue == \'false\' || $ctrl.current_establishment.singleQueue == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div><p class=text-margin ng-if="$ctrl.current_establishment.singleQueue === undefined">{{ $ctrl.current_establishment.singleQueue ? $ctrl.current_establishment.singleQueue : \'No disponible\'}}</p></div></div></md-dialog-content></md-dialog></div></div></div>');
$templateCache.put('app/modules/admin/administration/consumers/consumers.html','<div id=users-container><div class="services-container float-container" flex><div class=users-container-header><h1 class=main-pannel ng-if="$ctrl.isRoot || $ctrl.isSuperAdmin">{{\'app.administration.CONSUMERS\'|translate}} {{ $ctrl.establishmentInUse ? \' - \' + $ctrl.establishmentInUse : \'\' }}</h1><h1 class=main-pannel ng-if="!($ctrl.isRoot || $ctrl.isSuperAdmin)">{{\'app.administration.CONSUMERS\'|translate}}</h1><div class="brn-group add_element medium"><div class="brn_group add_element"><div class=selectOrganization style="margin-top: 5px" layout-gt-sm=row layout=column ng-hide=!($ctrl.isRoot)><md-autocomplete md-no-cache=true md-selected-item=$ctrl.organizationSelected md-search-text=$ctrl.searchTextOrganization md-selected-item-change=$ctrl.getEstablismentByOrganization(organization.id) md-items="organization in $ctrl.querySearchSelectOrganizations($ctrl.searchTextOrganization)" md-item-text=organization.name md-min-length=0 placeholder="{{\'app.administration.SELECT_ORGANIZATION\'|translate}}"><md-item-template><span md-highlight-text=$ctrl.searchTextOrganization md-highlight-flags=^i>{{ organization.name }}</span></md-item-template><md-not-found>No se encontraron organizaciones.</md-not-found></md-autocomplete></div><div class=selectOrganization layout-gt-sm=row layout=column ng-hide=$ctrl.isAdmin style=margin-top:5px><md-autocomplete md-no-cache=true md-selected-item=$ctrl.establishmentSelected md-search-text=$ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(establishment) md-items="establishment in $ctrl.querySearchSelect($ctrl.searchText)" md-item-text=establishment.name md-min-length=0 placeholder="{{\'app.statistics.SELECT_CENTER\'|translate}}"><md-item-template><span md-highlight-text=$ctrl.searchText md-highlight-flags=^i>{{ establishment.name }}</span></md-item-template><md-not-found>No se encontraron centros.</md-not-found></md-autocomplete></div></div><div style=display:flex><md-button class="md-raised md-primary" ng-click=$ctrl._showConsumerForm() style="background-color:#ff914d; color:#ffffff;margin-right: 17px"><span>+ {{\'app.consumers.NEW_CONSUMER\'|translate}}</span></md-button><md-button class="md-raised md-primary" ng-click=$ctrl._showAsignServiceForm() ng-disabled="$ctrl.fail || !$ctrl.hasConsumersSelected"><span>{{\'app.kiosks.ASIGN_QUEUES\'|translate}}</span></md-button></div></div></div><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParams disable-filter=$ctrl.isAdding demo-tracked-table=$ctrl.tableTracker><tr ng-repeat="consumer in $data" ng-form=rowForm demo-tracked-table-row=row><td class=has_dialog ng-attr-title="{{\'app.consumers.NAME\'|translate}}" title="\'app.consumers.NAME\'|translate" filter="{ name: \'text\'}" ng-switch=consumer.isEditing ng-class="name.$dirty ? \'bg-warning\' : \'\'" ng-form=name demo-tracked-table-cell><div flex layout=row layout-align="start center"><input class="selectCheck has_dialog" type=checkbox ng-model=consumer.Selected ng-click=$ctrl._selectConsumer(consumer) ng-if=!consumer.isEditing><span class=editable-text style=margin-left:4px ng-switch-default>{{consumer.name}}</span><div class=controls ng-class="name.$invalid &amp;&amp; name.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text id=name name=name ng-model=consumer.name required ng-change="$ctrl._validateDescription(consumer.name, \'name\', rowForm)"><p style=display:none id=err_name></p></div></div></td><!--td.has_dialog(title="\'app.consumers.DESCRIPTION\'|translate" filter="{ description: \'text\'}" sortable="\'description\'" ng-switch="consumer.isEditing" ng-class="description.$dirty ? \'bg-warning\' : \'\'" ng-form="description" demo-tracked-table-cell ng-click="$ctrl._detailConsumer(consumer)")\n        span.editable-text(ng-switch-default) {{consumer.description}}\n        div.controls(ng-class="description.$invalid && description.$dirty ? \'has-error\' : \'\'" ng-switch-when="true")\n        \tinput(type="text" name="description" ng-model="consumer.description" class="editable-input form-control input-sm" required)\n        \n        --><td class=has_dialog ng-attr-title="{{\'app.consumers.PLACE\'|translate}}" title="\'app.consumers.PLACE\'|translate" filter="{ place: \'text\'}" ng-switch=consumer.isEditing ng-class="place.$dirty ? \'bg-warning\' : \'\'" ng-form=place demo-tracked-table-cell ng-click=$ctrl._detailConsumer(consumer)><span class=editable-text ng-switch-default>{{consumer.place}}</span><div class=controls ng-class="place.$invalid &amp;&amp; place.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text id=place name=place ng-model=consumer.place required ng-change="$ctrl._validateDescription(consumer.place, \'place\', rowForm)"><p style=display:none id=err_place></p></div></td><td class=has_dialog ng-attr-title="{{\'app.consumers.WAITING_AREA\'|translate}}" title="\'app.consumers.WAITING_AREA\'|translate" filter="{ \'area.name\': \'text\'}" ng-switch=consumer.isEditing ng-class="waiting_area.$dirty ? \'bg-warning\' : \'\'" ng-form=waiting_area demo-tracked-table-cell ng-click=$ctrl._detailConsumer(consumer)><span class=editable-text ng-switch-default>{{ consumer.area.name }}</span><div class=controls ng-class="waiting_area.$invalid &amp;&amp; waiting_area.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=center name=waiting_area ng-model=consumer.areaId required><md-option value="{{ area.id }}" ng-repeat="area in $ctrl.areas">{{ area.name }}</md-option></md-select></div></td><td class="has_dialog has_status" ng-attr-title="{{\'app.administration.STATUS\'|translate}}" title="\'app.administration.STATUS\'|translate" filter="{ status: \'text\'}" ng-switch=consumer.isEditing ng-class="consumer.$dirty ? \'bg-warning\' : \'\'" ng-form=status demo-tracked-table-cell ng-click=$ctrl._detailConsumer(consumer)><div style="margin-left:15px; width:78px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-switch-default ng-if="consumer.status == \'true\' || consumer.status == true">fiber_manual_record</md-icon><p class="editable-text-span active" ng-switch-default ng-if="consumer.status === true">{{\'app.administration.STATUS_ENABLED\'|translate}}</p></div><div style="margin-left:15px; width:105px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-switch-default ng-if="consumer.status == \'false\' || consumer.status == false">fiber_manual_record</md-icon><p class="editable-text-span inactive" ng-switch-default ng-if="consumer.status === false">{{\'app.administration.STATUS_DISABLED\'|translate}}</p></div><div class=controls ng-class="status.$invalid &amp;&amp; status.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=status ng-model=consumer.status required><md-option value=true ng-selected="consumer.status == \'true\' || consumer.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="consumer.status == \'false\' || consumer.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div></td><td class="has_dialog has_checkbox" ng-attr-title="{{\'app.administration.ENABLE_BUTTONS\'|translate}}" ng-switch=consumer.isEditing ng-class="consumer.$dirty ? \'bg-warning\' : \'\'" ng-form=statusButtons demo-tracked-table-cell><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(consumer.id,\'b\')" ng-if=!consumer.statusButtons><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.administration.ENABLE_BUTTONS\'|translate}}</md-tooltip><md-icon class=gray-disabled style="position: static">check_circle</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(consumer.id,\'b\')" ng-if=consumer.statusButtons><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.administration.ENABLE_BUTTONS\'|translate}}</md-tooltip><md-icon class=orange style="position: static">check_circle</md-icon></md-button><div class=activate-option id={{consumer.id}}b style=display:none><md-button class="button-activate-option btn-default" style="opacity: 1;margin:0px" value=true ng-click="$ctrl.updateIcons(consumer, rowForm, true, \'statusButtons\')">{{\'app.ACTIVE\'|translate}}</md-button><md-button class="button-deactivate-option btn-default" style="opacity: 1;margin:0px" value=false ng-click="$ctrl.updateIcons(consumer, rowForm, false, \'statusButtons\')">{{\'app.NO_ACTIVE\'|translate}}</md-button></div></td><td class="has_dialog has_checkbox" ng-attr-title="{{\'app.services.ASIGNED\'|translate}}" ng-switch=consumer.isEditing ng-class="consumer.$dirty ? \'bg-warning\' : \'\'" ng-form=asigned demo-tracked-table-cell><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(consumer.id,\'a\')" ng-if=!consumer.asigned><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.services.ASIGNED\'|translate}}</md-tooltip><md-icon class=gray-disabled style="position: static">perm_contact_calendar</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(consumer.id,\'a\')" ng-if=consumer.asigned><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.services.ASIGNED\'|translate}}</md-tooltip><md-icon class=orange style="position: static">perm_contact_calendar</md-icon></md-button><div class=activate-option id={{consumer.id}}a style=display:none><md-button class="button-activate-option btn-default" style="opacity: 1;margin:0px" value=true ng-click="$ctrl.updateIcons(consumer, rowForm, true, \'asigned\')">{{\'app.ACTIVE\'|translate}}</md-button><md-button class="button-deactivate-option btn-default" style="opacity: 1;margin:0px" value=false ng-click="$ctrl.updateIcons(consumer, rowForm, false, \'asigned\')">{{\'app.NO_ACTIVE\'|translate}}</md-button></div></td><td class="button-box align-center has_options"><md-button class="optionsbtn btn btn-default btn-sm" style="border-radius: 6px" ng-click=$ctrl._editOptionsButton(consumer.id) ng-if=!consumer.isEditing><md-icon>more_horiz</md-icon></md-button><div class=activate-option id={{consumer.id}} style="right:25px; display:none"><md-button class="button-activate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl._showConsumerForm(consumer) ng-if=!consumer.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">edit_not</md-icon><span class=span-activate-option style="padding: 4px 4px 4px">{{\'app.organizations.EDIT\'|translate}}</span></md-button><md-button class="button-deactivate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl.showDeleteConfirm(consumer) ng-if=!consumer.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">delete</md-icon><span class=span-desactivate-option style="padding: 4px 4px 4px">{{\'app.organizations.DELETE\'|translate}}</span></md-button></div><md-button class="btn btn-primary btn-sm" ng-click="$ctrl.save(consumer, rowForm)" ng-if=consumer.isEditing ng-disabled=rowForm.$pristine><md-icon class=green>save</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click=$ctrl.cancel(consumer) ng-if=consumer.isEditing><md-icon class=red>cancel</md-icon></md-button></td></tr><tr ng-if=$ctrl.noData><td colspan=12><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if=!$ctrl.noData><td class=paginator-items colspan=12><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=10 ng-init="pageSize = 10"></select></div></td></tr></table></div><!-- DIALOG NEW CONSUMER--><div style="visibility: hidden"><div class=md-dialog-container id=myDialog><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2 ng-if=!$ctrl.editConsumer>{{\'app.consumers.NEW_CONSUMER\'|translate}}</h2><h2 ng-if=$ctrl.editConsumer>{{\'app.consumers.EDIT_CONSUMER\'|translate}} - {{ $ctrl.currentEstablishment.name }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><form name=$ctrl.consumerForm><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.consumers.NAME\'|translate}}</label><input class="md-input no-spin" type=text id=name name=name ng-model=$ctrl.new_consumer.name autocomplete=off required ng-change="$ctrl._validateDescription($ctrl.new_consumer.name, \'name\')"></md-input-container><p style=display:none id=err_name>Ingrese un nombre v\xE1lido</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.consumers.WAITING_AREA\'|translate}}</label><md-select id=center name=waiting_area ng-model=$ctrl.new_consumer.areaId required><md-option value="{{ area.id }}" ng-repeat="area in $ctrl.areas">{{ area.name }}</md-option></md-select></md-input-container></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.consumers.PLACE\'|translate}}</label><input class="md-input no-spin" type=text id=place name=place ng-model=$ctrl.new_consumer.place autocomplete=off required ng-change="$ctrl._validateDescription($ctrl.new_consumer.place, \'place\')"></md-input-container><p style=display:none id=err_place>Ingrese un nombre v\xE1lido</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.administration.STATUS\'|translate}}</label><md-select id=status name=status ng-model=$ctrl.new_consumer.status required><md-option value=true selected>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container></div><div style=width:100%><md-input-container style=display:none><label>{{\'app.administration.CENTER\'|translate}}</label><input class="md-input no-spin" type=text id=center name=center ng-model=$ctrl.currentEstablishment.name autocomplete=off disabled></md-input-container></div></form></div><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click="$ctrl._sendConsumer($ctrl.new_consumer, consumerForm)" ng-disabled=consumerForm.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog-content></md-dialog></div></div><!-- DIALOG ASIGN SERVICE--><div style="visibility: hidden" aria-label="Asign service custom dialog"><div class=md-dialog-container id=asignDialog><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.services.ASIGN_SERVICE\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><h2 ng-if="$ctrl.services.length &gt; 0">{{\'app.services.ASIGN_SERVICE\'|translate}}</h2><h2 ng-if="$ctrl.services.length == 0">{{\'app.services.NO_ASIGN_SERVICE\'|translate}}</h2><form name=$ctrl.asignServiceForm ng-if="$ctrl.services.length &gt; 0"><md-input-container md-no-float style=width:100%><label>{{\'app.administration.SERVICES\'|translate}}</label><md-select id=center name=service ng-model=$ctrl.new_service.queue multiple required><md-option value="{{ service.id }}" ng-repeat="service in $ctrl.services">{{ service.name }}</md-option></md-select></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._asignService($ctrl.new_service) ng-disabled="asignQueueForm.$invalid || $ctrl.services.length == 0">{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG SHOW DETAIL--><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=dialog_detail_consumer><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ $ctrl.current_consumer.name }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><div><label><strong>{{\'app.consumers.NAME\'|translate}}:</strong></label><p>{{ $ctrl.current_consumer.name ? $ctrl.current_consumer.name : \'No disponible\'}}</p></div><div><label><strong>{{\'app.consumers.PLACE\'|translate}}:</strong></label><p>{{ $ctrl.current_consumer.place ? $ctrl.current_consumer.place : \'No disponible\'}}</p></div><div><label><strong>{{\'app.administration.CENTER\'|translate}}:</strong></label><p>{{$ctrl.getEstablishmentName($ctrl.current_consumer.locationId) ? $ctrl.getEstablishmentName($ctrl.current_consumer.locationId) : \'No disponible\'}}</p></div><div><label><strong>{{\'app.consumers.WAITING_AREA\'|translate}}:</strong></label><p>{{$ctrl.getAreaName($ctrl.current_consumer.areaId) ? $ctrl.getAreaName($ctrl.current_consumer.areaId) : \'No disponible\'}}</p></div><div><label><strong>{{\'app.administration.STATUS\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_consumer.status == \'true\' || $ctrl.current_consumer.status == true">fiber_manual_record</md-icon><p class="editable-text-span active" ng-if="$ctrl.current_consumer.status === true">{{\'app.administration.STATUS_ENABLED\'|translate}}</p></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_consumer.status == \'false\' || $ctrl.current_consumer.status == false">fiber_manual_record</md-icon><p class="editable-text-span inactive" ng-if="$ctrl.current_consumer.status === false">{{\'app.administration.STATUS_DISABLED\'|translate}}</p></div></div><div><label><strong>{{ \'app.consumers.ASIGNED\'|translate }}:</strong></label><p class=has_dialog ng-if="$ctrl.current_consumer.asigned == true || $ctrl.current_consumer.asigned == \'true\'" style=color:limegreen ng-click=$ctrl._detailAsignedService($ctrl.current_consumer)>{{ \'app.consumers.ASIGNED_ENABLED\'|translate }}<span style=color:#777>{{ \'app.administration.CLICK_TO_SEE\'|translate }}</span></p><p ng-if="$ctrl.current_consumer.asigned == false || $ctrl.current_consumer.asigned == \'false\'" style=color:red>{{ \'app.consumers.ASIGNED_DISABLED\'|translate }}</p></div></div></md-dialog-content></md-dialog></div></div><!-- DIALOG SHOW DETAIL SERVICES ASIGNED--><div style="visibility: hidden" aria-label="Info services asigned custom dialog"><div class=md-dialog-container id=dialog_detail_asigned_services><md-dialog><md-toolbar><div class=md-toolbar-tools><h1>{{\'app.administration.SERVICES\'|translate}}</h1></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><table class="table table-borderless"><tbody><tr ng-repeat="service in $ctrl.current_consumer.services"><td><strong>{{ service.name }}</strong></td><td style="text-align: right; padding-right: 10px"><md-button class="btn btn-danger btn-sm" ng-click=$ctrl.deleteServiceDirectly(service)><md-icon class=red>delete</md-icon></md-button></td></tr></tbody></table></div></md-dialog-content></md-dialog></div></div></div>');
$templateCache.put('app/modules/admin/administration/kiosks/kiosks.html','<div id=users-container><div class="users-container float-container"><div class=users-container-header><h1 class=main-pannel ng-if="$ctrl.isRoot || $ctrl.isSuperAdmin">{{\'app.administration.KIOSKS\'|translate}} {{ $ctrl.establishmentInUse ? \' - \' + $ctrl.establishmentInUse : \'\' }}</h1><h1 class=main-pannel ng-if="!($ctrl.isRoot || $ctrl.isSuperAdmin)">{{\'app.administration.KIOSKS\'|translate}}</h1><div class="brn-group add_element medium"><div class=selectOrganization style="margin-top: 5px" layout-gt-sm=row layout=column ng-hide=!($ctrl.isRoot)><md-autocomplete md-no-cache=true md-selected-item=$ctrl.organizationSelected md-search-text=$ctrl.searchTextOrganization md-selected-item-change=$ctrl.getEstablismentByOrganization(organization.id) md-items="organization in $ctrl.querySearchSelectOrganizations($ctrl.searchTextOrganization)" md-item-text=organization.name md-min-length=0 placeholder="{{\'app.administration.SELECT_ORGANIZATION\'|translate}}"><md-item-template><span md-highlight-text=$ctrl.searchTextOrganization md-highlight-flags=^i>{{ organization.name }}</span></md-item-template><md-not-found>No se encontraron organizaciones.</md-not-found></md-autocomplete></div><div class=selectOrganization layout-gt-sm=row layout=column ng-hide=$ctrl.isAdmin style=margin-top:5px><md-autocomplete md-no-cache=true md-selected-item=$ctrl.establishmentSelected md-search-text=$ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(establishment) md-items="establishment in $ctrl.querySearchSelect($ctrl.searchText)" md-item-text=establishment.name md-min-length=0 placeholder="{{\'app.statistics.SELECT_CENTER\'|translate}}"><md-item-template><span md-highlight-text=$ctrl.searchText md-highlight-flags=^i>{{ establishment.name }}</span></md-item-template><md-not-found>No se encontraron centros.</md-not-found></md-autocomplete></div><div class="add_element display_end"><md-button class="md-raised md-primary" ng-click=$ctrl._showKioskForm() style="background-color:#ff914d; color:#ffffff;margin-right: 17px"><span>+ {{\'app.kiosks.NEW_KIOSK\'|translate}}</span></md-button><md-button class="md-raised md-primary" ng-click=$ctrl._showAsignServiceForm() ng-disabled="$ctrl.fail || !$ctrl.hasKiosksSelected" style="margin-right: 17px"><span>{{\'app.kiosks.ASIGN_QUEUES\'|translate}}</span></md-button></div></div></div><div class=table-container style="overflow-x: auto"><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParams disable-filter=$ctrl.isAdding demo-tracked-table=$ctrl.tableTracker><tr ng-repeat="kiosk in $data" ng-form=rowForm demo-tracked-table-row=row><td class=has_dialog ng-attr-title="{{\'app.kiosks.NAME\'|translate}}" title="\'app.kiosks.NAME\'|translate" filter="{ name: \'text\'}" sortable ng-switch=kiosk.isEditing ng-class="identifier.$dirty ? \'bg-warning\' : \'\'" ng-form=identifier demo-tracked-table-cell><div flex layout=row layout-align="start center"><input class="selectCheck has_dialog" type=checkbox ng-model=kiosk.Selected ng-click=$ctrl._selectKiosk(kiosk)><span class=editable-text style=margin-left:4px ng-switch-default>{{kiosk.name}}</span><div class=controls ng-class="identifier.$invalid &amp;&amp; identifier.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text name=identifier id=identifier ng-model=kiosk.name required ng-change="$ctrl._validateInputs(kiosk.name, \'identifier\', rowForm)"><p style=display:none id=err_identifier></p></div></div></td><td class=has_dialog ng-attr-title="{{\'app.kiosks.PLACE\'|translate}}" title="\'app.kiosks.PLACE\'|translate" filter="{ description: \'text\'}" sortable ng-switch=kiosk.isEditing ng-class="place.$dirty ? \'bg-warning\' : \'\'" ng-form=place demo-tracked-table-cell ng-click=$ctrl._detailKiosk(kiosk)><span class="editable-text text-custom" ng-switch-default>{{kiosk.description}}</span><div class=controls ng-class="place.$invalid &amp;&amp; place.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text name=place id=place ng-model=kiosk.description required ng-change="$ctrl._validateInputs(kiosk.description, \'place\', rowForm)"><p style=display:none id=err_place></p></div></td><td class=has_dialog ng-attr-title="{{\'app.kiosks.KIOSK_BACKGROUND\'|translate}}" title="\'app.kiosks.KIOSK_BACKGROUND\'|translate" ng-switch=kiosk.isEditing filter="{ background: \'text\'}" sortable ng-class="{\'bg-warning\': background.$dirty, \'has_image\': kiosk.img_link}" ng-form=background demo-tracked-table-cell><span class=editable-text ng-switch-default><img class=thumb ng-if=kiosk.img_link ng-src={{kiosk.img_link}}><span ng-if=!kiosk.img_link>{{\'app.kiosks.NOT_LOCAL_BACKGROUND\'|translate}}</span></span><div class=controls ng-class="background.$invalid &amp;&amp; background.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-button class="editImageButton md-primary" ng-click="$ctrl._changeImageDialog(kiosk, rowForm, \'img_link\')">Cambiar<md-icon>update</md-icon></md-button><md-button class="editImageButton md-warn" ng-click="$ctrl.deleteImage(kiosk, rowForm, \'img_link\')">Eliminar<md-icon>delete_forever</md-icon></md-button></div></td><td class=has_dialog ng-attr-title="{{\'app.administration.TYPE\'|translate}}" title="\'app.administration.TYPE\'|translate" filter="{ isOnline: \'text\'}" sortable ng-switch=kiosk.isEditing ng-class="kiosk.$dirty ? \'bg-warning\' : \'\'" ng-form=status demo-tracked-table-cell ng-click=$ctrl._detailKiosk(kiosk)><span class=editable-text ng-switch-default ng-if="kiosk.isOnline == \'true\' || kiosk.isOnline == true">{{\'app.administration.TYPE_ENABLED\'|translate}}</span><span class=editable-text ng-switch-default ng-if="kiosk.isOnline == \'false\' || kiosk.isOnline == false">{{\'app.administration.TYPE_DISABLED\'|translate}}</span><div class=controls ng-class="isOnline.$invalid &amp;&amp; isOnline.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=isOnline ng-model=kiosk.isOnline required aria-label=select-type-enabled><md-option value=true ng-selected="kiosk.isOnline == \'true\' || kiosk.isOnline == true">{{\'app.administration.TYPE_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="kiosk.isOnline == \'false\' || kiosk.isOnline == false">{{\'app.administration.TYPE_DISABLED\'|translate}}</md-option></md-select></div></td><td class="has_dialog has_status" ng-attr-title="{{\'app.administration.STATUS\'|translate}}" title="\'app.administration.STATUS\'|translate" filter="{ status: \'text\'}" sortable ng-switch=kiosk.isEditing ng-class="kiosk.$dirty ? \'bg-warning\' : \'\'" ng-form=status demo-tracked-table-cell ng-click=$ctrl._detailKiosk(kiosk)><div style="margin-left:15px; width:78px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-switch-default ng-if="kiosk.status == \'true\' || kiosk.status == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-switch-default ng-if="kiosk.status == \'true\' || kiosk.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="margin-left:15px; width:105px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-switch-default ng-if="kiosk.status == \'false\' || kiosk.status == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-switch-default ng-if="kiosk.status == \'false\' || kiosk.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div><div class=controls ng-class="status.$invalid &amp;&amp; status.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=status ng-model=kiosk.status required aria-label=select-status><md-option value=true ng-selected="kiosk.status == \'true\' || kiosk.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="kiosk.status == \'false\' || kiosk.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div></td><td class=has_dialog ng-attr-title="{{\'app.kiosks.OPEN\'|translate}}" title="\'app.kiosks.OPEN\'|translate" filter="{ open: \'text\'}" sortable ng-switch=kiosk.isEditing ng-class="open.$dirty ? \'bg-warning\' : \'\'" ng-form=open demo-tracked-table-cell ng-click=$ctrl._detailKiosk(kiosk)><span class=editable-text ng-switch-default>{{kiosk.open | date : \'shortTime\' }}</span><div class=controls ng-class="open.$invalid &amp;&amp; open.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" date-input type=time name=open ng-model=kiosk.open required></div></td><td class=has_dialog ng-attr-title="{{\'app.kiosks.CLOSE\'|translate}}" title="\'app.kiosks.CLOSE\'|translate" filter="{ close: \'text\'}" sortable ng-switch=kiosk.isEditing ng-class="close.$dirty ? \'bg-warning\' : \'\'" ng-form=close demo-tracked-table-cell ng-click=$ctrl._detailKiosk(kiosk)><span class=editable-text ng-switch-default>{{kiosk.close | date : \'shortTime\' }}</span><div class=controls ng-class="close.$invalid &amp;&amp; close.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" date-input type=time name=close ng-model=kiosk.close required></div></td><td class="has_dialog has_status" ng-attr-title="{{\'app.administration.QR\'|translate}}" title="\'app.administration.QR\'|translate" filter="{ activeQR: \'text\'}" sortable ng-switch=kiosk.isEditing ng-class="kiosk.$dirty ? \'bg-warning\' : \'\'" ng-form=activeQR demo-tracked-table-cell ng-click=$ctrl._detailKiosk(kiosk)><div style="margin-left:15px; width:78px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-switch-default ng-if="kiosk.activeQR == \'true\' || kiosk.activeQR == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-switch-default ng-if="kiosk.activeQR == \'true\' || kiosk.activeQR == true">{{\'app.administration.QR_ENABLED\'|translate}}</span></div><div style="margin-left:15px; width:105px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-switch-default ng-if="kiosk.activeQR == \'false\' || kiosk.activeQR == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-switch-default ng-if="kiosk.activeQR == \'false\' || kiosk.activeQR == false">{{\'app.administration.QR_DISABLED\'|translate}}</span></div><div class=controls ng-class="activeQR.$invalid &amp;&amp; activeQR.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=activeQR ng-model=kiosk.activeQR required aria-label=select-active-qr><md-option value=true ng-selected="kiosk.activeQR == \'true\' || kiosk.activeQR == true">{{\'app.administration.QR_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="kiosk.activeQR == \'false\' || kiosk.activeQR == false">{{\'app.administration.QR_DISABLED\'|translate}}</md-option></md-select></div></td><td class="has_dialog has_checkbox" ng-attr-title="{{\'app.services.ASIGNED\'|translate}}" ng-switch=kiosk.isEditing ng-class="kiosk.$dirty ? \'bg-warning\' : \'\'" ng-form=asigned demo-tracked-table-cell><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(kiosk.id,\'a\')" ng-if=kiosk.asigned aria-label=kiosk-asigned></md-button><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.services.ASIGNED\'|translate}}</md-tooltip><md-icon style="color: #FF914D">perm_contact_calendar</md-icon><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(kiosk.id,\'a\')" ng-if=!kiosk.asigned aria-label=kiosk-asigned-disabled></md-button><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.services.ASIGNED_DISABLED\'|translate}}</md-tooltip><md-icon style="color: #C2C9D1">perm_contact_calendar<div class=controls ng-class="status.$invalid &amp;&amp; status.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=status ng-model=kiosk.asigned required aria-label=select-status><md-option value=true ng-selected="kiosk.asigned == true || kiosk.asigned == \'true\'">{{\'app.services.ASIGNED_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="kiosk.asigned == \'false\' || !kiosk.asigned">{{\'app.services.ASIGNED_DISABLED\'|translate}}</md-option></md-select></div><div class=activate-option id={{kiosk.id}}a style=display:none><md-button class="button-activate-option btn-default" style="opacity: 1;margin:0px" value=true ng-click="$ctrl.updateIcons(kiosk, rowForm, true, \'asigned\')">Activa</md-button><md-button class="button-deactivate-option btn-default" style="opacity: 1;margin:0px" value=false ng-click="$ctrl.updateIcons(kiosk, rowForm, false, \'asigned\')">No Activa</md-button></div></md-icon></td><td class="button-box align-center has_options"><md-button class="optionsbtn btn btn-default btn-sm" style="border-radius: 6px" ng-click=$ctrl._editOptionsButton(kiosk.id) ng-if=!kiosk.isEditing><md-icon>more_horiz</md-icon></md-button><div class=activate-option id={{kiosk.id}} style="right:25px; display:none"><md-button class="button-activate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click="kiosk.isEditing = true" ng-if=!kiosk.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">edit_not</md-icon><span class=span-activate-option style="padding: 4px 4px 4px">{{\'app.organizations.EDIT\'|translate}}</span></md-button><md-button class="button-deactivate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl.showDeleteConfirm(kiosk) ng-if=!kiosk.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">delete</md-icon><span class=span-desactivate-option style="padding: 4px 4px 4px">{{\'app.organizations.DELETE\'|translate}}</span></md-button></div><md-button class="btn btn-primary btn-sm" ng-click="$ctrl.save(kiosk, rowForm)" ng-if=kiosk.isEditing ng-disabled=rowForm.$pristine><md-icon class=green>save</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl.cancel(kiosk, rowForm)" ng-if=kiosk.isEditing><md-icon class=red>cancel</md-icon></md-button></td></tr><tr ng-if=$ctrl.noData><td colspan=12><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if=!$ctrl.noData><td class=paginator-items colspan=12><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=10 ng-init="pageSize = 10"></select></div></td></tr></table></div></div><!-- DIALOG NEW KIOSK--><div style="visibility: hidden"><div class=md-dialog-container id=myDialog><md-dialog style="width: 685px"><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.kiosks.NEW_KIOSK\'|translate}} - {{ $ctrl.currentEstablishment.name }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content style="padding: 0px"><form name=$ctrl.kioskForms style="width:100%; padding: 20px 20px"><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.kiosks.NAME\'|translate}}</label><input class="md-input no-spin" type=text id=identifier name=identifier ng-model=$ctrl.new_kiosk.name autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_kiosk.name, \'identifier\')"></md-input-container><p style=display:none id=err_identifier>{{\'app.kiosks.identifier\'|translate}}</p><p style=display:none id=err_identifier_2>{{\'app.kiosks.identifier_2\'|translate}}</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.administration.STATUS\'|translate}}</label><md-select id=status name=status ng-model=$ctrl.new_kiosk.status required><md-option value=true selected>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.administration.QR\'|translate}}</label><md-select id=status name=activeQR ng-model=$ctrl.new_kiosk.activeQR required><md-option value=true selected>{{\'app.administration.QR_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.QR_DISABLED\'|translate}}</md-option></md-select></md-input-container></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.kiosks.PLACE\'|translate}}</label><input class="md-input no-spin" type=text id=place name=place ng-model=$ctrl.new_kiosk.description autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_kiosk.description, \'place\')"></md-input-container><p style=display:none id=err_place>{{\'app.kiosks.place\'|translate}}</p><p style=display:none id=err_place_2>{{\'app.kiosks.place_2\'|translate}}</p><md-input-container style=display:none><label>{{\'app.administration.CENTER\'|translate}}</label><input class="md-input no-spin" type=text id=center name=center ng-model=$ctrl.currentEstablishment.name autocomplete=off disabled></md-input-container></div></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._sendKiosk($ctrl.new_kiosk) ng-disabled=kioskForm.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG ASIGN SERVICE--><div style="visibility: hidden" aria-label="Asign service custom dialog"><div class=md-dialog-container id=asignDialog><md-dialog style="width: 630px"><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.services.ASIGN_SERVICE\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><h2 ng-if="$ctrl.services.length === 0 &amp;&amp; $ctrl.loadCenter === false">{{\'Servicios no disponibles.\'|translate}}</h2><h2 ng-if=$ctrl.loadCenter>{{\'Cargando.\'|translate}}</h2><form name=$ctrl.asignServiceForm ng-if="$ctrl.services.length &gt; 0"><md-input-container md-no-float style=width:100%><label>{{\'app.administration.SERVICES\'|translate}}</label><md-select id=center name=service ng-model=$ctrl.new_service.queue><md-option value="{{ service }}" ng-repeat="service in $ctrl.services">{{ service.name }}</md-option></md-select></md-input-container><div style="width:100%; margin-top: 20px"><md-input-container md-no-float style=width:100% id=description-container><label>{{\'app.organizations.INSTRUCTIONS\'|translate}}</label><input class="md-input no-spin" type=text id=instrucciones name=description ng-model=$ctrl.new_service.instrucciones autocomplete=off ng-change="$ctrl._validateInputs($ctrl.new_service.instrucciones, \'instrucciones\', $ctrl.asignServiceForm)"></md-input-container><p style=display:none id=err_instrucciones>Ingrese una instrucci\xF3n v\xE1lida.</p></div></form><md-dialog-actions style=width:30% flex layout=row><md-button class="md-raised md-primary" ng-if="$ctrl.services.length !== 0" style="color: #ffff; padding: 10px 20px" ng-click=$ctrl._addInstructions($ctrl.new_service)>{{\'app.administration.ADD\'|translate}}</md-button></md-dialog-actions></div><div style="width:100%; margin-top: 20px; padding: 0px 50px"><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParam><tr ng-repeat="service in $ctrl.arrIns" demo-tracked-table-row=row><td class=has_dialog ng-attr-title="{{\'app.administration.SERVICES\'|translate}}" title="\'app.administration.SERVICES\'|translate" ng-switch=service.isEditing demo-tracked-table-cell><span class=editable-text ng-switch-default>{{service.queue}}</span></td><td class=has_dialog ng-attr-title=Instrucciones title="\'app.administration.INSTRUCTIONS\'|translate" ng-switch=service.isEditing demo-tracked-table-cell><span class=editable-text ng-switch-default>{{service.instructions ? service.instructions : \'No hay instrucciones\'}}</span></td><td class=has_dialog ng-attr-title="" demo-tracked-table-cell><md-button class="btn btn-danger btn-sm" ng-click=$ctrl._deleteServ(service)><md-icon class=red>delete</md-icon></md-button></td></tr></table></div><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._asignService($ctrl.new_service) ng-disabled="$ctrl.services.length === 0 &amp;&amp; $ctrl.arrIns.length === 0">{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog-content></md-dialog></div></div><!-- DIALOG SHOW DETAIL--><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=dialog_detail_kiosk><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ $ctrl.current_kiosk.name }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><div><label><strong>{{\'app.kiosks.NAME\'|translate}}:</strong></label><p>{{ $ctrl.current_kiosk.name ? $ctrl.current_kiosk.name : \'No disponible\' }}</p></div><div><label><strong>{{\'app.kiosks.PLACE\'|translate}}:</strong></label><p>{{ $ctrl.current_kiosk.description ? $ctrl.current_kiosk.description : \'No disponible\' }}</p></div><div><label><strong>{{\'app.administration.CENTER\'|translate}}:</strong></label><p>{{$ctrl.getEstablishmentName($ctrl.current_kiosk.locationId) ? $ctrl.getEstablishmentName($ctrl.current_kiosk.locationId) : \'No disponible\'}}</p></div><div><label><strong>{{\'app.kiosks.KIOSK_BACKGROUND\'|translate}}:</strong></label><img style="object-fit: contain; width:15%; height:15%; display:flex" ng-if=$ctrl.current_kiosk.img_link ng-src={{$ctrl.current_kiosk.img_link}}><p ng-if=!$ctrl.current_kiosk.img_link>{{\'app.kiosks.NOT_LOCAL_BACKGROUND\'|translate}}</p></div><div><label><strong>{{\'app.administration.TYPE\'|translate}}:</strong></label><p ng-if="$ctrl.current_kiosk.isOnline == \'true\' || $ctrl.current_kiosk.isOnline == true">{{\'app.administration.TYPE_ENABLED\'|translate}}</p><p ng-if="$ctrl.current_kiosk.isOnline == \'false\' || $ctrl.current_kiosk.isOnline == false">{{\'app.administration.TYPE_DISABLED\'|translate}}</p><p ng-if="$ctrl.current_kiosk.isOnline == \'undefined\' || $ctrl.current_kiosk.isOnline == undefined">No disponible</p></div><div><label><strong>{{\'app.administration.STATUS\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_kiosk.status == \'true\' || $ctrl.current_kiosk.status == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_kiosk.status == \'true\' || $ctrl.current_kiosk.status == true">{{\'app.administration.QR_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_kiosk.status == \'false\' || $ctrl.current_kiosk.status == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_kiosk.actstatusiveQR == \'false\' || $ctrl.current_kiosk.status == false">{{\'app.administration.QR_DISABLED\'|translate}}</span></div></div><div><label><strong>{{\'app.kiosks.OPEN\'|translate}}:</strong></label><p ng-if="$ctrl.current_kiosk.open != \'undefined\' || $ctrl.current_kiosk.open != undefined">{{$ctrl.current_kiosk.open | date : \'shortTime\'}}</p><p ng-if="$ctrl.current_kiosk.open == \'undefined\' || $ctrl.current_kiosk.open == undefined">No disponible</p></div><div><label><strong>{{\'app.kiosks.CLOSE\'|translate}}:</strong></label><p ng-if="$ctrl.current_kiosk.close != \'undefined\' || $ctrl.current_kiosk.close != undefined">{{$ctrl.current_kiosk.close | date : \'shortTime\'}}</p><p ng-if="$ctrl.current_kiosk.close == \'undefined\' || $ctrl.current_kiosk.close == undefined">No disponible</p></div><div><label><strong>{{ \'app.services.ASIGNED\'|translate }}:</strong></label><p class=has_dialog ng-if="($ctrl.current_kiosk.asigned == true || $ctrl.current_kiosk.asigned == \'true\') &amp;&amp; $ctrl.current_kiosk.services.length &gt; 0 " style=color:limegreen ng-click=$ctrl._detailAsignedService($ctrl.current_kiosk)>{{ \'app.services.ASIGNED_ENABLED\'|translate }}<span style=color:#777>{{ \'app.administration.CLICK_TO_SEE\'|translate }}</span></p><p ng-if="$ctrl.current_kiosk.asigned == false || $ctrl.current_kiosk.asigned == \'false\' || $ctrl.current_kiosk.services.length === 0" style=color:red>{{ \'app.services.ASIGNED_DISABLED\'|translate }}</p></div><div><label><strong>{{\'app.administration.QR\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_kiosk.activeQR == \'true\' || $ctrl.current_kiosk.activeQR == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_kiosk.activeQR == \'true\' || $ctrl.current_kiosk.activeQR == true">{{\'app.administration.QR_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_kiosk.activeQR == \'false\' || $ctrl.current_kiosk.activeQR == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_kiosk.activeQR == \'false\' || $ctrl.current_kiosk.activeQR == false">{{\'app.administration.QR_DISABLED\'|translate}}</span></div></div></div></md-dialog-content></md-dialog></div></div><!-- DIALOG SHOW DETAIL SERVICES ASIGNED--><div style="visibility: hidden"><div class=md-dialog-container id=dialog_detail_asigned_services><md-dialog style="border-radius: 15px; width: 800px" aria-label="Info services asigned custom dialog"><md-toolbar><div class=md-toolbar-tools><h1>{{\'app.administration.KIOSKS\'|translate}}: {{ $ctrl.current_kiosk.name }}</h1></div></md-toolbar><md-dialog style="max-width: 100%!important"><div style="padding: 20px" flex><h2 ng-if="$ctrl.current_kiosk.services.length === 0">Sin servicios asignados</h2><div style="width: 100%; display: flex; flex-direction: row; justify-content: space-evenly; padding: 0 20px 0 20px; margin-bottom: 20px"><p>{{\'app.administration.SERVICE\'|translate}}</p><p>{{\'app.administration.INSTRUCTIONS\'|translate}}</p></div><div ng-if="$ctrl.loadInstructions === false" style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; padding: 0 20px 0 20px" ng-repeat="service in $ctrl.current_kiosk.services"><md-button class="btn btn-danger btn-sm" ng-click=$ctrl.showDisassignConfirm(service) ng-if=!service.isEditing><md-icon class=red>delete</md-icon></md-button><div style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start; width: 50%"><strong>{{ service.name }}:&nbsp;</strong></div><div ng-if="$ctrl.showInstructions !== false" style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 50%"><p>{{service.instruction ? service.instruction : \'No hay instrucciones\'}}</p></div></div><div ng-if="$ctrl.loadInstructions !== false" style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; padding: 0 20px 0 20px" ng-repeat="service in $ctrl.current_kiosk.services"><p>Cargando</p></div></div></md-dialog></md-dialog></div></div><!--UPDATE IMAGE MODAL--><div style="visibility: hidden"><div class=md-dialog-container id=changeImageDialog><md-dialog style="width: 440px;min-height: 200px"><md-toolbar><div class="md-toolbar-tools closeModals"><h2>Actualizar kiosco</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><form name=$ctrl.kioskForm><div class=md-dialog-content flex style="padding: 40px 49px 35px"><input class="editable-input input-img form-control input-sm" type=file name=background ng-model=kiosk.background ng-change=$ctrl.updateImages(kiosk.background) maxsize=100 base-sixty-four-input accept=image/*></div></form></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.CANCEL\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl.saveUpdatedImage()>{{\'app.common.UPDATE\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div></div>');
$templateCache.put('app/modules/admin/administration/new-agendas/new-agendas.html','<div id=users-container><iframe src={{$ctrl.new_front}} id=myIframe width=100% style="height: 100vh; border:none"></iframe></div>');
$templateCache.put('app/modules/admin/administration/organizations/organizations.html','<div id=users-container><div class="users-container float-container" flex><div class=users-container-header><h1 class=main-pannel>{{\'app.administration.ORGANIZATIONS\'|translate}}</h1><div class="brn-group add_element"><div class="selectOrganization add_element" layout-gt-sm=row layout=column style=margin-top:5px><md-autocomplete md-no-cache=true md-selected-item=$ctrl.organizationSelected md-search-text=ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(organization) md-items="organization in $ctrl.querySearchSelect(ctrl.searchText)" md-item-text=organization.name md-min-length=0 placeholder="{{\'app.administration.SELECT_ORGANIZATION\'|translate}}"><md-item-template><span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{ organization.name }}</span></md-item-template><md-not-found>No se encontraron organizaciones.</md-not-found></md-autocomplete></div><md-button class=md-raised ng-click=$ctrl._showZoneForm() style="background-color:#ff914d; color:#ffffff"><span>+ {{\'app.organizations.NEW_ORGANIZATION\'|translate}}</span></md-button></div></div><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParams disable-filter=$ctrl.isAdding demo-tracked-table=$ctrl.tableTracker><tr class=content-top ng-if="organization.isVisible != false" ng-repeat="organization in $data" ng-form=rowForm demo-tracked-table-row=row><td class="has_dialog has_nameOrg" ng-attr-title="{{\'app.organizations.NAME\'|translate}}" title="\'app.organizations.NAME\'|translate" filter="{ name: \'text\'}" ng-switch=organization.isEditing ng-class="name.$dirty ? \'bg-warning\' : \'\'" ng-form=name demo-tracked-table-cell ng-click=$ctrl._detailOrganization(organization)><span class=editable-text ng-switch-default>{{organization.name}}</span><div class=controls ng-class="name.$invalid &amp;&amp; name.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-name form-control input-sm" type=text name=name id=name ng-model=organization.name ng-attr-placeholder="Buscar Nombre" required ng-change="$ctrl._validateInputs(organization.name, \'name\', rowForm)"><p style=display:none id=err_name></p></div></td><td class="has_dialog has_descrip" ng-attr-title="{{\'app.organizations.DESCRIPTION\'|translate}}" title="\'app.organizations.DESCRIPTION\'|translate" filter="{ description: \'text\'}" ng-switch=organization.isEditing ng-class="description.$dirty ? \'bg-warning\' : \'\'" ng-form=description demo-tracked-table-cell ng-click=$ctrl._detailOrganization(organization)><span class=editable-text ng-switch-default>{{organization.description}}</span><div class=controls ng-class="description.$invalid &amp;&amp; description.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-description form-control input-sm" type=text name=description id=description ng-model=organization.description required ng-change="$ctrl._validateInputs(organization.description, \'description\', rowForm)"><p style=display:none id=err_description></p></div></td><td class="has_dialog has_dir" ng-attr-title="{{\'app.organizations.FIRSTLINE\'|translate}}" title="\'app.organizations.FIRSTLINE\'|translate" filter="{ address: \'text\'}" ng-switch=organization.isEditing ng-class="address.$dirty ? \'bg-warning\' : \'\'" ng-form=address demo-tracked-table-cell ng-click=$ctrl._detailOrganization(organization)><span class=editable-text ng-switch-default>{{organization.address}}</span><div class=controls ng-class="address.$invalid &amp;&amp; address.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-dir form-control input-sm" type=text name=address id=address ng-click="$ctrl._showMapDialog(organization, rowForm)" ng-model=organization.address required ng-change="$ctrl._validateInputs(organization.address, \'address\', rowForm)"><p style=display:none id=err_address></p></div></td><td class="has_dialog has_telephone" ng-attr-title="{{\'app.organizations.PHONE\'|translate}}" title="\'app.organizations.PHONE\'|translate" filter="{ phone: \'text\'}" ng-switch=organization.isEditing ng-class="phone.$dirty ? \'bg-warning\' : \'\'" ng-form=phone demo-tracked-table-cell ng-click=$ctrl._detailOrganization(organization)><span class=editable-text ng-switch-default>{{organization.phone}}</span><div class=controls ng-class="phone.$invalid &amp;&amp; phone.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-tooltip class=md-primary md-direction=top>{{\'app.organizations.PHONE_ERROR\'|translate}}</md-tooltip><input class="editable-input input-phone form-control input-sm" type=text name=phone id=phone ng-model=organization.phone required ng-change="$ctrl._validateInputs(organization.phone, \'phone\', rowForm)"><p style=display:none id=err_phone></p></div></td><td class="has_dialog has_status" ng-attr-title="{{\'app.administration.STATUS\'|translate}}" title="\'app.administration.STATUS\'|translate" filter="{ status: \'text\' }" ng-switch=organization.isEditing ng-class="organization.$dirty ? \'bg-warning\' : \'\'" ng-form=status demo-tracked-table-cell ng-click=$ctrl._detailOrganization(organization)><div style="margin-left:15px; width:78px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-switch-default ng-if="organization.status == \'true\' || organization.status == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-switch-default ng-if="organization.status == \'true\' || organization.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="margin-left:15px; width:105px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-switch-default ng-if="organization.status == \'false\' || organization.status == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-switch-default ng-if="organization.status == \'false\' || organization.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div><div class=controls ng-class="status.$invalid &amp;&amp; status.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select class=input-status id=status name=status ng-model=organization.status required><md-option value=true ng-selected="organization.status == \'true\' || organization.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="organization.status == \'false\' || organization.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div></td><td class="has_dialog has_image" ng-attr-title="{{\'app.organizations.KIOSK_BACKGROUND\'|translate}}" title="\'app.organizations.KIOSK_BACKGROUND\'|translate" ng-switch=organization.isEditing ng-class="background.$dirty ? \'bg-warning\' : \'\'" ng-form=background demo-tracked-table-cell><span class=editable-text ng-switch-default><img class=thumb ng-if=organization.img_link ng-src={{organization.img_link}}><span ng-if=!organization.img_link>{{\'app.organizations.NO_BACKGROUND\'|translate}}</span></span><div class=controls ng-class="background.$invalid &amp;&amp; background.$dirty ? \'has-error\' : \'\'" ng-switch-when=true layout=column><md-button class="editImageButton md-primary" ng-click="$ctrl._changeImageDialog(organization, rowForm, \'img_link\')">Cambiar<md-icon>update</md-icon></md-button><md-button class="editImageButton md-warn" ng-click="$ctrl.deleteImage(organization, rowForm, \'img_link\')">Eliminar<md-icon>delete_forever</md-icon></md-button><!--input(type="file" name="background" ng-model="organization.background" class="editable-input input-img form-control input-sm" maxsize="500" base-sixty-four-input)--></div></td><td class="has_dialog has_image" ng-attr-title="{{\'app.organizations.TICKET_LOGO\'|translate}}" title="\'app.organizations.TICKET_LOGO\'|translate" ng-switch=organization.isEditing ng-class="logo_ticket.$dirty ? \'bg-warning\' : \'\'" ng-form=logo_ticket demo-tracked-table-cell><span class=editable-text ng-switch-default><img class=thumb ng-if=organization.logo_link ng-src={{organization.logo_link}}><span ng-if=!organization.logo_link>{{\'app.organizations.NO_LOGO\'|translate}}</span></span><div class="controls has_image" ng-class="logo_ticket.$invalid &amp;&amp; logo.$dirty ? \'has-error\' : \'\'" ng-switch-when=true layout=column><md-button class="editImageButton md-primary" ng-click="$ctrl._changeImageDialog(organization, rowForm, \'logo_link\')">Cambiar<md-icon>update</md-icon></md-button><md-button class="editImageButton md-warn" ng-click="$ctrl.deleteImage(organization, rowForm, \'logo_link\')">Eliminar<md-icon>delete_forever</md-icon></md-button><!--input(type="file" name="logo_ticket" ng-model="organization.logo" class="editable-input input-img form-control input-sm" maxsize="100" base-sixty-four-input accept="image/*")--></div></td><td class="has_dialog has_style" ng-attr-title="{{\'app.organizations.TICKET_STYLE\'|translate}}" title="\'app.organizations.TICKET_STYLE\'|translate" ng-switch=organization.isEditing ng-class="style.$dirty ? \'bg-warning\' : \'\'" ng-form=style demo-tracked-table-cell><span class=editable-text ng-switch-default ng-if=organization.style_link>{{\'app.organizations.TICKET_CSS\'|translate}}</span><span class=editable-text ng-switch-default ng-if=!organization.style_link>{{\'app.organizations.TICKET_NO_CSS\'|translate}}</span><a ng-switch-default ng-if=organization.style_link ng-href={{organization.style_link}} download={{organization.style_link}} target=_blank><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.organizations.cloud_download\'|translate}}</md-tooltip><md-icon>cloud_download</md-icon></a><div class="controls has_image" ng-class="style.$invalid &amp;&amp; style.$dirty ? \'has-error\' : \'\'" ng-switch-when=true layout=column><md-button class="editImageButton md-primary" ng-click="$ctrl._changeImageDialog(organization, rowForm, \'style_link\')">Cambiar<md-icon>update</md-icon></md-button><md-button class="editImageButton md-warn" ng-click="$ctrl.deleteImage(organization, rowForm, \'style_link\')">Eliminar<md-icon>delete_forever</md-icon></md-button><!--input(type="file" name="style" ng-model="organization.style" class="editable-input input-img form-control input-sm" maxsize="100" base-sixty-four-input)--></div></td><td class="has_dialog has_checkbox" ng-attr-title="{{\'app.organizations.WAITING_PEOPLE\'|translate}}"><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(organization.id,\'a\')" ng-if=!organization.waitingPeople><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.organizations.WAITING_PEOPLE\'|translate}}</md-tooltip><md-icon class=gray-disabled style="position: static">person</md-icon><md-icon class=gray-disabled style="position: absolute; border-radius: 50%; bottom: 8px; right: 7px; font-size:10px; min-height: 10px;min-width: 10px; width:10px !important; height:10px !important; background-color:#fff">schedule</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(organization.id,\'a\')" ng-if=organization.waitingPeople><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.organizations.WAITING_PEOPLE\'|translate}}</md-tooltip><md-icon class=orange style="position: static">person</md-icon><md-icon class=orange style="position: absolute; border-radius: 50%; bottom: 8px; right: 7px; font-size:10px; min-height: 10px;min-width: 10px; width:10px !important; height:10px !important; background-color:#fff">schedule</md-icon></md-button><div class=activate-option id={{organization.id}}a style=display:none><md-button class="button-activate-option btn-default" style="opacity: 1;margin:0px" value=true ng-click="$ctrl.updateIcons(organization, rowForm, true, \'waitingPeople\')">{{\'app.ACTIVE\'|translate}}</md-button><md-button class="button-deactivate-option btn-default" style="opacity: 1;margin:0px" value=false ng-click="$ctrl.updateIcons(organization, rowForm, false, \'waitingPeople\')">{{\'app.NO_ACTIVE\'|translate}}</md-button></div></td><td class="button-box align-center has_options"><md-button class="optionsbtn btn btn-default btn-sm" md-ink-ripple=true style="border-radius: 6px" ng-click=$ctrl._editOptionsButton(organization.id) ng-if=!organization.isEditing><md-icon>more_horiz</md-icon></md-button><div id={{organization.id}} style="right:30px; display:none; position: absolute"><div class=active-option-arrow-up></div><div class=activate-option><md-button class="button-activate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl._editOrg(organization) ng-if=!organization.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">edit_not</md-icon><span class=span-activate-option style="padding: 4px 4px 4px">{{\'app.organizations.EDIT\'|translate}}</span></md-button><md-button class="button-deactivate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl.showDeleteConfirm(organization) ng-if=!organization.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">delete</md-icon><span class=span-desactivate-option style="padding: 4px 4px 4px">{{\'app.organizations.DELETE\'|translate}}</span></md-button></div></div><md-button class="btn btn-primary btn-sm" ng-click="$ctrl.save(organization, rowForm)" ng-if=organization.isEditing ng-disabled=rowForm.$pristine><md-icon class=green>save</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl.cancel(organization, rowForm)" ng-if=organization.isEditing><md-icon class=red>cancel</md-icon></md-button></td></tr><tr ng-if=$ctrl.noData><td colspan=13><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if=!$ctrl.noData><td class=paginator-items colspan=13><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=3 ng-init="pageSize = 3"></select></div></td></tr></table></div><!--DIALOG DELETE ORGANIZATION--><div style="visibility: hidden"><div class=md-dialog-container id=deleteDialog><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ \'app.organizations.DELETE_ORGANIZATION\' | translate }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><h2>\xBFSeguro que desea eliminar esta organizaci\xF3n?</h2><p>Al dar click en Eliminar no podr\xE1 recuperar la organizaci\xF3n.</p></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=!$ctrl.isAsking><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.CANCEL\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._deleteEstablishment(organization.id)>{{\'app.common.DELETE\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG NEW ORGANIZATION--><div style="visibility: hidden"><div class=md-dialog-container id=myDialog><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.organizations.NEW_ORGANIZATION\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><form name=$ctrl.organizationForms style=width:100%><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.organizations.NAME\'|translate}}</label><input class="md-input no-spin" type=text id=name name=name ng-model=$ctrl.new_organization.name autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_organization.name, \'name\', $ctrl.organizationForms)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.organizationForms, \'name\')"></md-input-container><p style=display:none id=err_name></p></div><div style="width:100%; display: flex; justify-content: flex-start; gap: 8px"><div style="display: flex; flex-direction: column"><md-tooltip class=md-primary md-direction=top>{{\'app.organizations.PHONE_ERROR\'|translate}}</md-tooltip><md-input-container><md-select id=country name=country ng-model=$ctrl.countryCodes.country style="width: 100px" ng-change=$ctrl.ngSelect($ctrl.countryCodes.country)><md-option ng-repeat="country in $ctrl.countries" value={{country.dial_code}}>{{country.nombre}}</md-option></md-select></md-input-container></div><div style="display: flex; flex-direction: column; flex-grow: 1"><md-input-container><label>{{\'app.organizations.PHONE\'|translate}}</label><input class="md-input no-spin" type=text id=phone name=phone ng-model=$ctrl.new_organization.phone autocomplete=off ng-change="$ctrl._validateInputs($ctrl.new_organization.phone, \'phone\', $ctrl.organizationForms)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.organizationForms)" ng-keydown=$ctrl._preventEmojis($event) ng-paste=$ctrl._handlePaste($event)></md-input-container><p style=display:none id=err_phone></p><p style="color:rgba(219, 72, 73, 1)" ng-if="$ctrl.countryStatus === true &amp;&amp; $ctrl.new_organization.phone.length &gt; 0">{{\'app.organizations.PHONE_ERROR\'|translate}}</p><p style="color:rgba(219, 72, 73, 1)" ng-if=$ctrl.phoneEmojiError></p></div></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.organizations.FIRSTLINE\'|translate}}</label><input class="md-input no-spin" type=text id=address name=address ng-model=$ctrl.new_organization.address autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_organization.address, \'address\', $ctrl.organizationForms)" ng-keydown=$ctrl._preventEmojis($event) ng-paste=$ctrl._handlePaste($event)></md-input-container><p style=display:none id=err_address>La direcci\xF3n es obligatoria</p><p style="color:rgba(219, 72, 73, 1)" ng-if=$ctrl.addressEmojiError></p></div><div style=width:100%><md-input-container md-no-float style=width:100% id=description-container><label>{{\'app.organizations.DESCRIPTION\'|translate}}</label><input class="md-input no-spin" type=text id=description name=description ng-model=$ctrl.new_organization.description autocomplete=off ng-change="$ctrl._validateInputs($ctrl.new_organization.description, \'description\', $ctrl.organizationForms)"></md-input-container><p style=display:none id=err_description></p><p style="color:rgba(219, 72, 73, 1)" ng-if=$ctrl.descriptionEmojiError>La descripci\xF3n no puede contener emojis</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.administration.STATUS\'|translate}}</label><md-select id=status name=status ng-model=$ctrl.new_organization.status required><md-option value=true selected>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select><p style=display:none id=err_status>Seleccione una opci\xF3n del listado</p></md-input-container></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>Categor\xEDa</label><md-select name=categoryId id=categoryId ng-model=$ctrl.new_organization.categoryId required ng-change=$ctrl.ngSelectCat($ctrl.new_organization.categoryId)><md-option ng-repeat="categorie in $ctrl.categories" value={{categorie.id}}>{{categorie.name}}</md-option></md-select></md-input-container></div><div style=width:100%><md-input-container class="two_columns input_file_container"><p style="padding-left: 10px">{{$ctrl.new_organization.background.filename}}</p><label for=background>{{\'app.organizations.KIOSK_BACKGROUND\'|translate}}</label><input class="md-input no-spin custom-file-input" type=file data-style-type={{&quot;app.organizations.BTN_CHOOSE_FILE&quot;|translate}} autocomplete=off id=background name=background base-sixty-four-input ng-model=$ctrl.new_organization.background accept=image/* ng-change="$ctrl._validateInputs($ctrl.new_organization.background, \'background\', $ctrl.organizationForms)" required></md-input-container><p style=display:none id=err_background></p></div><div style=width:100%><md-input-container class="two_columns input_file_container"><p style="padding-left: 10px">{{$ctrl.new_organization.logo.filename}}</p><label for=logo>{{\'app.organizations.TICKET_LOGO\'|translate}}</label><input class="md-input no-spin custom-file-input" type=file data-style-type={{&quot;app.organizations.BTN_CHOOSE_FILE&quot;|translate}} autocomplete=off id=logo name=logo base-sixty-four-input ng-model=$ctrl.new_organization.logo accept=image/* ng-change="$ctrl._validateInputs($ctrl.new_organization.logo, \'logo\', $ctrl.organizationForms)" required></md-input-container><p style=display:none id=err_logo></p></div><div style=width:100% id=img-container><md-input-container md-no-float style=height:200px><div class=img-container><div class="drag&amp;drop drag-drop"><div class=background-box ng-class="!$ctrl.previewImg.background &amp;&amp; !$ctrl.new_organization.background ? \'empty\' : \'\'"><md-button class=delete-image ng-if="$ctrl.previewImg.background || $ctrl.new_organization.background" ng-click="$ctrl.new_organization.background=\'\'"><md-icon>close</md-icon></md-button><p class=upload-btn ng-if="!$ctrl.previewImg.background &amp;&amp; !$ctrl.new_organization.background">No image</p><img class=thumb ng-if="$ctrl.previewImg.background || $ctrl.new_organization.background" ng-src="{{$ctrl.previewImg.background || $ctrl.new_organization.background }}"></div><div class=logo-box ng-class="!$ctrl.previewImg.logo &amp;&amp; !$ctrl.new_organization.logo ? \'empty\' : \'\'"><md-button class=delete-image ng-if="$ctrl.previewImg.logo || $ctrl.new_organization.logo" ng-click="$ctrl.new_organization.logo=\'\'"><md-icon>close</md-icon></md-button><p class=upload-btn ng-if="!$ctrl.previewImg.logo &amp;&amp; !$ctrl.new_organization.logo" ng-click="$ctrl.abrirArchivo(\'logo\')">No image</p><img class=thumb ng-if="$ctrl.previewImg.logo || $ctrl.new_organization.logo" for=logo ng-src="{{ $ctrl.previewImg.logo || $ctrl.new_organization.logo}}"></div></div></div></md-input-container></div><div style=width:100%><p>{{$ctrl.new_organization.style.filename}}<label for=style>{{\'app.organizations.TICKET_STYLE\'|translate}}</label></p><md-input-container md-no-float><div class=input_file_container><md-button class="md-raised md-primary customInput" ng-if=!$ctrl.new_organization.style_link ng-click="$ctrl.abrirArchivo(\'style\')">{{\'app.organizations.BTN_CHOOSE_FILE\'|translate}}</md-button><md-button class="md-raised md-primary customInput" ng-if=$ctrl.new_organization.style_link ng-click="$ctrl.abrirArchivo(\'style\')">{{\'app.organizations.BTN_CHOOSE_EDIT\'|translate}}</md-button><input class="md-input no-spin custom_input_file" type=file autocomplete=off id=style name=style base-sixty-four-input ng-model=$ctrl.new_organization.style accept=.css ng-change="$ctrl._validateInputs($ctrl.new_organization.style, \'style\', $ctrl.organizationForms)"><p style=display:none id=err_style></p></div></md-input-container><div class=two_columns md-no-float style=width:100%><span class=editable-text ng-if="$ctrl.organizationForms.style.$modelValue.filename || $ctrl.new_organization.style_link">{{\'app.organizations.TICKET_CSS\'|translate}}</span><span class=editable-text ng-if="!$ctrl.organizationForms.style.$modelValue.filename &amp;&amp; !$ctrl.new_organization.style_link">{{\'app.organizations.TICKET_NO_CSS\'|translate}}</span><a style=margin-left:20px ng-if=$ctrl.new_organization.style_link ng-href={{$ctrl.new_organization.style_link}} download={{$ctrl.new_organization.style_link}} target=_blank><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.organizations.cloud_download\'|translate}}</md-tooltip><md-icon>cloud_download</md-icon></a></div></div></form></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=!$ctrl.isAsking><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.CANCEL\'|translate}}</md-button><md-button class="md-raised md-primary" ng-if=!$ctrl.editOrgs ng-click="$ctrl._sendOrganization($ctrl.new_organization, $ctrl.organizationForms)">{{\'app.common.ACCEPT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-if=$ctrl.editOrgs ng-click="$ctrl._sendOrganization($ctrl.new_organization, $ctrl.organizationForms)" ng-disabled=$ctrl.organizationForms.$invalid>{{\'app.organizations.BTN_CHOOSE_EDIT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG SHOW DETAIL--><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=dialog_detail_organization><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ $ctrl.current_organization.name }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><div><label><strong>{{\'app.organizations.DESCRIPTION\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_organization.description ? $ctrl.current_organization.description : \'No disponible\' }}</p></div><div><label><strong>{{\'app.organizations.FIRSTLINE\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_organization.address ? $ctrl.current_organization.address : \'No disponible\' }}</p></div><div><label><strong>{{\'app.organizations.CATEGORY\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.getCategoryName($ctrl.current_organization.categoryId) ? $ctrl.getCategoryName($ctrl.current_organization.categoryId) : \'No disponible\' }}</p></div><div><label><strong>{{\'Intervalo de citas\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_organization.timeRange ? $ctrl.current_organization.timeRange : \'No disponible\' }}</p></div><div><label><strong>{{\'app.organizations.PHONE\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_organization.phone ? $ctrl.current_organization.phone : \'No disponible\'}}</p></div><div><label><strong>{{\'app.administration.STATUS\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_organization.status == \'true\' || $ctrl.current_organization.status == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_organization.status == \'true\' || $ctrl.current_organization.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_organization.status == \'false\' || $ctrl.current_organization.status == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_organization.status == \'false\' || $ctrl.current_organization.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div></div><div><label><strong>{{\'app.organizations.KIOSK_BACKGROUND\'|translate}}:</strong></label><img style="object-fit: contain; width:15%; height:15%; display:flex" ng-if=$ctrl.current_organization.img_link ng-src={{$ctrl.current_organization.img_link}}><p ng-if=!$ctrl.current_organization.img_link>{{\'app.organizations.NO_BACKGROUND\'|translate}}</p></div><div><label><strong>{{\'app.organizations.TICKET_LOGO\'|translate}}:</strong></label><img style="object-fit: contain; width:15%; height:15%; display:flex" ng-if=$ctrl.current_organization.logo_link ng-src={{$ctrl.current_organization.logo_link}}><p ng-if=!$ctrl.current_organization.logo_link>{{\'app.organizations.NO_LOGO\'|translate}}</p></div><div><label><strong>{{\'app.organizations.TICKET_STYLE\'|translate}}:</strong></label><p class=text-margin>{{ $ctrl.current_organization.style_link ? "Personalizado" : "Sin personalizar"}}</p></div><div><label><strong>{{\'app.organizations.MOBILE\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_organization.isActiveFromApp == \'true\' || $ctrl.current_organization.isActiveFromApp == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_organization.isActiveFromApp == \'true\' || $ctrl.current_organization.isActiveFromApp == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_organization.isActiveFromApp == \'false\' || $ctrl.current_organization.isActiveFromApp == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_organization.isActiveFromApp == \'false\' || $ctrl.current_organization.isActiveFromApp == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div><p class=text-margin ng-if="$ctrl.current_organization.isActiveFromApp === undefined">{{ $ctrl.current_organization.isActiveFromApp ? $ctrl.current_organization.isActiveFromApp : \'No disponible\'}}</p></div><div><label><strong>{{\'app.organizations.BOOKING\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_organization.hasBooking == \'true\' || $ctrl.current_organization.hasBooking == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_organization.hasBooking == \'true\' || $ctrl.current_organization.hasBooking == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_organization.hasBooking == \'false\' || $ctrl.current_organization.hasBooking == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_organization.hasBooking == \'false\' || $ctrl.current_organization.hasBooking == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div><p class=text-margin ng-if="$ctrl.current_organization.hasBooking === undefined">{{ $ctrl.current_organization.hasBooking ? $ctrl.current_organization.hasBooking : \'No disponible\'}}</p></div><div><label><strong>{{\'app.organizations.WAITING_PEOPLE\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_organization.waitingPeople == \'true\' || $ctrl.current_organization.waitingPeople == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_organization.waitingPeople == \'true\' || $ctrl.current_organization.waitingPeople == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_organization.waitingPeople == \'false\' || $ctrl.current_organization.waitingPeople == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_organization.waitingPeople == \'false\' || $ctrl.current_organization.waitingPeople == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div><p class=text-margin ng-if="$ctrl.current_organization.waitingPeople === undefined">{{ $ctrl.current_organization.waitingPeople ? $ctrl.current_organization.waitingPeople : \'No disponible\'}}</p></div></div></md-dialog-content></md-dialog></div></div><!-- DIALOG EDIT ORGANIZATION--><div style="visibility: hidden"><div class=md-dialog-container id=editDialog><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.organizations.EDIT_ORGANIZATION\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><form name=$ctrl.organizationEditForms style=width:100%><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.organizations.NAME\'|translate}}</label><input class="md-input no-spin" type=text id=edit-name name=name ng-model=$ctrl.organization.name ng-value=$ctrl.organization.name autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.organization.name, \'edit-name\', $ctrl.organizationEditForms)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.organizationEditForms, \'name\')"></md-input-container><p style=display:none id=error_edit-name></p></div><div style="width:100%; display: flex; justify-content: flex-start; gap: 8px"><md-tooltip class=md-primary md-direction=top>{{\'app.organizations.PHONE_ERROR\'|translate}}</md-tooltip><md-input-container><md-select id=country name=country ng-model=$ctrl.countryCodes.country style="width: 100px" ng-change=$ctrl.ngSelect($ctrl.countryCodes.country)><md-option ng-repeat="country in $ctrl.countries" value={{country.dial_code}}>{{country.nombre}}</md-option></md-select></md-input-container><div style="display: flex; flex-direction: column; flex-grow: 1"><md-input-container><label>{{\'app.organizations.PHONE\'|translate}}</label><input class="md-input no-spin" type=text id=edit-phone name=phone ng-model=$ctrl.organization.phone autocomplete=off ng-change="$ctrl._validateInputs($ctrl.organization.phone, \'edit-phone\', $ctrl.organizationEditForms)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.organizationEditForms)" ng-keydown=$ctrl._preventEmojis($event) ng-paste=$ctrl._handlePaste($event)></md-input-container><p style=display:none id=err_edit-phone></p><p style="color:rgba(219, 72, 73, 1)" ng-if="$ctrl.countryStatus === true &amp;&amp; $ctrl.organization.phone.length &gt; 0">{{\'app.organizations.PHONE_ERROR\'|translate}}</p><p style="color:rgba(219, 72, 73, 1)" ng-if=$ctrl.phoneEmojiError></p></div></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.organizations.FIRSTLINE\'|translate}}</label><input class="md-input no-spin" type=text id=edit-address name=address ng-model=$ctrl.organization.address autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.organization.address, \'edit-address\', $ctrl.organizationEditForms)" ng-keydown=$ctrl._preventEmojis($event) ng-paste=$ctrl._handlePaste($event)></md-input-container><p style=display:none id=err_edit-address>Introduzca la direcci\xF3n</p><p style="color:rgba(219, 72, 73, 1)" ng-if=$ctrl.addressEmojiError></p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.administration.STATUS\'|translate}}</label><md-select id=status name=status ng-model=$ctrl.organization.status required><md-option value=true selected>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select><p style=display:none id=err_edit-status>Seleccione una opci\xF3n del listado</p></md-input-container></div><div style=width:100%><md-input-container md-no-float style=width:100% id=description-container><label>{{\'app.organizations.DESCRIPTION\'|translate}}</label><input class="md-input no-spin" type=text id=edit-description name=description ng-model=$ctrl.organization.description autocomplete=off ng-change="$ctrl._validateInputs($ctrl.organization.description, \'edit-description\', $ctrl.organizationEditForms)" ng-keydown=$ctrl._preventEmojis($event) ng-paste=$ctrl._handlePaste($event)></md-input-container><p style=display:none id=err_edit-description></p><p style="color:rgba(219, 72, 73, 1)" ng-if=$ctrl.descriptionEmojiError></p></div><hr style="width:100%; visibility:hidden"><div style=width:100%><md-input-container class="two_columns input_file_container"><p style="padding-left: 10px">{{$ctrl.organization.background.filename}}</p><label for=edit-background>{{\'app.organizations.KIOSK_BACKGROUND\'|translate}}</label><input class="md-input no-spin custom-file-input" type=file data-style-type={{&quot;app.organizations.BTN_CHOOSE_FILE&quot;|translate}} autocomplete=off id=edit-background name=background base-sixty-four-input ng-model=$ctrl.organization.background accept=image/* ng-change="$ctrl._validateInputs($ctrl.organization.background, \'edit-background\', $ctrl.organizationEditForms)"></md-input-container><p style=display:none id=err_edit-background></p></div><div style=width:100%><md-input-container class="two_columns input_file_container"><p style="padding-left: 10px">{{$ctrl.organization.logo.filename}}</p><label for=edit-logo>{{\'app.organizations.TICKET_LOGO\'|translate}}</label><input class="md-input no-spin custom-file-input" type=file data-style-type={{&quot;app.organizations.BTN_CHOOSE_FILE&quot;|translate}} autocomplete=off id=edit-logo name=logo base-sixty-four-input ng-model=$ctrl.organization.logo accept=image/* ng-change="$ctrl._validateInputs($ctrl.organization.logo, \'edit-logo\', $ctrl.organizationEditForms)"></md-input-container><p style=display:none id=err_edit-logo></p></div><div style=width:100% id=img-container><md-input-container md-no-float style=height:200px><div class=img-container><div class="drag&amp;drop drag-drop"><div class=background-box ng-class="!$ctrl.previewImg.background &amp;&amp; !$ctrl.organization.background ? \'empty\' : \'\'"><md-button class=delete-image ng-if="$ctrl.previewImg.background || $ctrl.organization.background || $ctrl.organization.img_link" ng-click="$ctrl.previewImg.background=\'\';$ctrl.organization.background=\'\';$ctrl.organization.img_link = \'\'"><md-icon>close</md-icon></md-button><p class=upload-btn ng-if="!$ctrl.previewImg.background &amp;&amp; !$ctrl.organization.img_link">No image</p><img class=thumb ng-if="$ctrl.previewImg.background || $ctrl.organization.img_link" ng-src="{{$ctrl.previewImg.background || $ctrl.organization.img_link }}"></div><div class=logo-box ng-class="!$ctrl.previewImg.logo &amp;&amp; !$ctrl.organization.logo ? \'empty\' : \'\'"><md-button class=delete-image ng-if="$ctrl.previewImg.logo || $ctrl.organization.logo || $ctrl.organization.logo_link" ng-click="$ctrl.previewImg.logo=\'\';$ctrl.organization.logo=\'\';$ctrl.organization.logo_link=\'\'"><md-icon>close</md-icon></md-button><p class=upload-btn ng-if="!$ctrl.previewImg.logo &amp;&amp; !$ctrl.organization.logo_link" ng-click="$ctrl.abrirArchivo(\'logo\')">No image</p><img class=thumb ng-if="$ctrl.previewImg.logo || $ctrl.organization.logo_link" ng-src="{{ $ctrl.previewImg.logo || $ctrl.organization.logo_link}}"></div></div></div></md-input-container></div><div style=width:100%><p>{{$ctrl.organization.style.filename}}<label for=style>{{\'app.organizations.TICKET_STYLE\'|translate}}</label></p><md-input-container md-no-float><div class=input_file_container><md-button class="md-raised md-primary customInput" ng-if=!$ctrl.organization.style_link ng-click="$ctrl.abrirArchivo(\'edit-style\')">{{\'app.organizations.BTN_CHOOSE_FILE\'|translate}}</md-button><md-button class="md-raised md-primary customInput" ng-if=$ctrl.organization.style_link ng-click="$ctrl.abrirArchivo(\'edit-style\')">{{\'app.organizations.BTN_CHOOSE_EDIT\'|translate}}</md-button><input class="md-input no-spin custom_input_file" type=file autocomplete=off id=edit-style name=style base-sixty-four-input ng-model=$ctrl.organization.style accept=.css ng-change="$ctrl._validateInputs($ctrl.organization.style, \'edit-style\', $ctrl.organizationEditForms)"><p style=display:none id=err_edit-style></p></div></md-input-container><div class=two_columns md-no-float style=width:100%><span class=editable-text ng-if="$ctrl.organizationEditForms.style.$modelValue.filename || $ctrl.organization.style_link">{{\'app.organizations.TICKET_CSS\'|translate}}</span><span class=editable-text ng-if="!$ctrl.organizationEditForms.style.$modelValue.filename &amp;&amp; !$ctrl.organization.style_link">{{\'app.organizations.TICKET_NO_CSS\'|translate}}</span><a style=margin-left:20px ng-if=$ctrl.organization.style_link ng-href={{$ctrl.organization.style_link}} download={{$ctrl.organization.style_link}} target=_blank><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.organizations.cloud_download\'|translate}}</md-tooltip><md-icon>cloud_download</md-icon></a></div></div></form></div></md-dialog-content><md-dialog-actions flex layout=row ng-show=!$ctrl.isAsking><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.CANCEL\'|translate}}</md-button><md-button class="md-raised md-primary" ng-if=!$ctrl.editOrgs ng-click="$ctrl._sendOrganization($ctrl.organization, $ctrl.organizationEditForms)" ng-disabled=$ctrl.organizationEditForms.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-if=$ctrl.editOrgs ng-click="$ctrl._sendOrganization($ctrl.organization, $ctrl.organizationEditForms)" ng-disabled=$ctrl.organizationEditForms.$invalid>{{\'app.organizations.BTN_CHOOSE_EDIT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div></div>');
$templateCache.put('app/modules/admin/administration/priorities/priorities.html','<div id=users-container><div class="services-container float-container" flex><div class=users-container-header><h1 class=main-pannel ng-if=$ctrl.isRoot>{{\'app.administration.SERVICES_STABLISHMENT\'|translate}} {{ $ctrl.establishmentInUse ? \' - \' + $ctrl.establishmentInUse : \'\' }}</h1><h1 class=main-pannel ng-if=!$ctrl.isRoot>{{\'app.administration.SERVICES_STABLISHMENT\'|translate}}</h1><div class="brn-group add_element"><div class=selectOrganization style="margin-top: 5px" layout-gt-sm=row layout=column ng-hide=!($ctrl.isRoot)><md-autocomplete md-no-cache=true md-selected-item=$ctrl.organizationSelected md-search-text=$ctrl.searchTextOrganization md-selected-item-change=$ctrl.getEstablismentByOrganization(organization.id) md-items="organization in $ctrl.querySearchSelectOrganizations($ctrl.searchTextOrganization)" md-item-text=organization.name md-min-length=0 placeholder="{{\'app.administration.SELECT_ORGANIZATION\'|translate}}"><md-item-template><span md-highlight-text=$ctrl.searchTextOrganization md-highlight-flags=^i>{{ organization.name }}</span></md-item-template><md-not-found>No se encontraron organizaciones.</md-not-found></md-autocomplete></div><div class=selectOrganization layout-gt-sm=row layout=column ng-hide=$ctrl.isAdmin style=margin-top:5px><md-autocomplete md-no-cache=true md-selected-item=$ctrl.establishmentSelected md-search-text=$ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(establishment) md-items="establishment in $ctrl.querySearchSelect($ctrl.searchText)" md-item-text=establishment.name md-min-length=0 placeholder="{{\'app.statistics.SELECT_CENTER\'|translate}}"><md-item-template><span md-highlight-text=$ctrl.searchText md-highlight-flags=^i>{{ establishment.name }}</span></md-item-template><md-not-found>No se encontraron centros.</md-not-found></md-autocomplete></div></div></div><div class=table-container style="overflow-x: auto"><table class="table table-bordered tablae-hover table-condensed editable-table" ng-table=$ctrl.tableParams disable-filter=$ctrl.isAdding demo-tracked-table=$ctrl.tableTracker><tr ng-repeat="service in $data" ng-form=rowForm demo-tracked-table-row=row><td class=has_dialog ng-attr-title="{{\'app.services.ORDER\'|translate}}" title="\'app.services.ORDER\'|translate" filter="{ order: \'text\'}" ng-switch=service.isEditing ng-class="order.$dirty ? \'bg-warning\' : \'\'" ng-form=order demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{service.order}}</span><div class=controls ng-class="order.$invalid &amp;&amp; order.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-order form-control input-sm" type=text name=order ng-model=service.order ng-change="$ctrl._validateOrder(service.order, \'order\', rowForm)"><p style=display:none id=err_order></p></div></td><td class=has_dialog ng-attr-title="{{\'app.services.NAME\'|translate}}" title="\'app.services.NAME\'|translate" filter="{ name: \'text\'}" ng-click=$ctrl._detailService(service)><span class=editable-text>{{service.name}}</span></td><td class=has_dialog ng-attr-title="{{\'app.services.DISPLAY\'|translate}}" title="\'app.services.DISPLAY\'|translate" filter="{ display: \'text\'}" ng-switch=service.isEditing ng-class="display.$dirty ? \'bg-warning\' : \'\'" ng-form=display demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{service.display}}</span><div class=controls ng-class="display.$invalid &amp;&amp; display.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-nameshow form-control input-sm" type=text name=display ng-model=service.display required></div></td><td class="has_dialog has_promo" ng-attr-title="{{\'app.services.PROMOS\'|translate}}" title="\'app.services.PROMOS\'|translate" ng-switch=service.isEditing filter="{ promo: \'text\'}" ng-class="promo.$dirty ? \'bg-warning\' : \'\'" ng-form=promo demo-tracked-table-cell><span class=editable-text ng-switch-default><img class=thumb ng-src={{service.local_promo_link}} ng-if=service.local_promo_link><span ng-if=!service.local_promo_link>{{\'app.services.NO_LOCAL_PROMO\'|translate}}</span></span><div class=controls ng-class="promo.$invalid &amp;&amp; promo.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-button class="editImageButton md-primary" ng-click="$ctrl._changeImageDialog(service, rowForm, \'local_promo_link\')">Cambiar<md-icon>update</md-icon></md-button><md-button class="editImageButton md-warn" ng-click="$ctrl.deleteImage(service, rowForm, \'local_promo_link\')">Eliminar<md-icon>delete_forever</md-icon></md-button><!--input(type="file" name="promo" ng-model="service.local_promo" class="editable-input input-img form-control input-sm" maxsize="100" base-sixty-four-input)--></div></td><td class=has_dialog ng-attr-title="{{\'app.services.PRIORITY\'|translate}}" title="\'app.services.PRIORITY\'|translate" filter="{ priority: \'text\'}" ng-switch=service.isEditing ng-class="priority.$dirty ? \'bg-warning\' : \'\'" ng-form=priority demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{service.priority}}</span><div class=controls ng-class="priority.$invalid &amp;&amp; priority.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-letter form-control input-sm" type=text id=priority name=priority ng-model=service.priority required maxlength=1 minlength=1 ng-change="$ctrl._validateInputs(service.priority, \'priority\', rowForm)"><p style=display:none id=err_priority></p></div></td><td class=has_dialog ng-attr-title="{{\'app.services.REMAINING_PEOPLE\'|translate}}" title="\'app.services.REMAINING_PEOPLE\'|translate" filter="{ previousNotificationLimit: \'text\'}" ng-switch=service.isEditing ng-class="previousNotificationLimit.$dirty ? \'bg-warning\' : \'\'" ng-form=previousNotificationLimit demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{ service.previousNotificationLimit }}</span><div class=controls ng-class="previousNotificationLimit.$invalid &amp;&amp; advice_number.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-letter form-control input-sm" type=text id=previousNotificationLimit name=previousNotificationLimit ng-model=service.previousNotificationLimit value=5 maxlength=2 minlength=1 ng-change="$ctrl._validateInputs(service.previousNotificationLimit, \'previousNotificationLimit\', rowForm)"><p style=display:none id=err_previousNotificationLimit></p></div></td><td class=has_dialog ng-attr-title="{{\'app.services.TURNS_LIMIT\'|translate}}" title="\'app.services.TURNS_LIMIT\'|translate" filter="{ turnsLimit: \'text\'}" ng-switch=service.isEditing ng-class="turnsLimit.$dirty ? \'bg-warning\' : \'\'" ng-form=turnsLimit demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{ service.turnsLimit }}</span><div class=controls ng-class="turnsLimit.$invalid &amp;&amp; turnsLimit.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-letter form-control input-sm" type=number name=turnsLimit ng-model=service.turnsLimit value=0></div></td><td class=has_dialog ng-attr-title="{{\'app.services.LIMIT_WAITING_TIME\'|translate}}" title="\'app.services.LIMIT_WAITING_TIME\'|translate" filter="{ timeAlert: \'text\'}" ng-switch=service.isEditing ng-class="timeAlert.$dirty ? \'bg-warning\' : \'\'" ng-form=timeAlert demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{ service.timeAlert }}</span><div class=controls ng-class="timeAlert.$invalid &amp;&amp; timeAlert.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=number name=timeAlert ng-model=service.timeAlert value=0 ng-change="$ctrl._validateInputs(service.timeAlert, \'timeAlert\', rowForm)"><p style=display:none id=err_timeAlert></p></div></td><td class=has_dialog ng-attr-title="{{\'app.kiosks.OPEN\'|translate}}" title="\'app.kiosks.OPEN\'|translate" filter="{ open: \'text\'}" ng-switch=service.isEditing ng-class="open.$dirty ? \'bg-warning\' : \'\'" ng-form=open demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{service.open | date : \'shortTime\' }}</span><div class=controls ng-class="open.$invalid &amp;&amp; open.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" date-input type=time name=open ng-model=service.open></div></td><td class=has_dialog ng-attr-title="{{\'app.kiosks.CLOSE\'|translate}}" title="\'app.kiosks.CLOSE\'|translate" filter="{ close: \'text\'}" ng-switch=service.isEditing ng-class="close.$dirty ? \'bg-warning\' : \'\'" ng-form=close demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{service.close | date : \'shortTime\' }}</span><div class=controls ng-class="close.$invalid &amp;&amp; close.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" date-input type=time name=close ng-model=service.close></div></td><td class="has_dialog has_status" ng-attr-title="{{\'app.administration.STATUS\'|translate}}" title="\'app.administration.STATUS\'|translate" filter="{ status: \'text\'}" ng-switch=service.isEditing ng-class="service.$dirty ? \'bg-warning\' : \'\'" ng-form=status demo-tracked-table-cell><div style="margin-left:15px; width:78px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-switch-default ng-if="service.status == \'true\' || service.status == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-switch-default ng-if="service.status == \'true\' || service.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="margin-left:15px; width:105px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-switch-default ng-if="service.status == \'false\' || service.status == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-switch-default ng-if="service.status == \'false\' || service.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div><div class=controls ng-class="status.$invalid &amp;&amp; status.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=status ng-model=service.status required aria-label=select-status><md-option value=true ng-selected="service.status == true || service.status == \'true\'">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="service.status == \'false\' || !service.status">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div></td><td class="button-box align-center has_options"><md-button class="optionsbtn btn btn-default btn-sm" style="border-radius: 6px" ng-click=$ctrl._editOptionsButton(service.id) ng-if=!service.isEditing><md-icon>more_horiz</md-icon></md-button><div class=activate-option id={{service.id}} style="right:25px; display:none"><md-button class="button-activate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click="service.isEditing = true" ng-if=!service.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">edit_not</md-icon><span class=span-activate-option style="padding: 4px 4px 4px">{{\'app.organizations.EDIT\'|translate}}</span></md-button><!--md-button(style="width:104px; opacity: 1;margin:0px;height:44px !important;" class="button-deactivate-option btn-default" ng-click="$ctrl.showDeleteConfirm(service)" ng-if="!service.isEditing && !$ctrl.isAdmin")\n              md-icon.orange(style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px;") delete\n              span.span-desactivate-option(style="padding: 4px 4px 4px;") {{\'app.organizations.DELETE\'|translate}}\n              \n              --></div><md-button class="btn btn-primary btn-sm" ng-click="$ctrl.save(service, rowForm)" ng-if=service.isEditing ng-disabled=rowForm.$invalid><md-icon class=green>save</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl.cancel(service, rowForm)" ng-if=service.isEditing><md-icon class=red>cancel</md-icon></md-button></td></tr><tr ng-if=$ctrl.noData><td colspan=12><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if=!$ctrl.noData><td class=paginator-items colspan=12><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=10 ng-init="pageSize = 10"></select></div></td></tr></table></div></div><!-- DIALOG SHOW DETAIL--><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=dialog_detail_service><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ $ctrl.current_service.display }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><div><label><strong>{{\'app.services.NAME\'|translate}}:</strong></label><p>{{ $ctrl.current_service.name ? $ctrl.current_service.name : \'No disponible\' }}</p></div><div><label><strong>{{\'app.services.DESCRIPTION\'|translate}}:</strong></label><p>{{ $ctrl.current_service.description ? $ctrl.current_service.description : \'No disponible\'}}</p></div><div><label><strong>{{\'app.services.DISPLAY\'|translate}}:</strong></label><p>{{ $ctrl.current_service.display ? $ctrl.current_service.display : \'No disponible\'}}</p></div><div><label><strong>{{\'app.services.PATTERN\'|translate}}:</strong></label><p>{{ $ctrl.current_service.pattern ? $ctrl.current_service.pattern : \'No disponible\'}}</p></div><div><label><strong>{{\'app.services.PROMOS\'|translate}}:</strong></label><img style="object-fit: contain; width:15%; height:15%; display:flex" ng-if=$ctrl.current_service.local_promo_link ng-src={{$ctrl.current_service.local_promo_link}}><p ng-if=!$ctrl.current_service.local_promo_link>{{\'app.services.NO_LOCAL_PROMO\'|translate}}</p></div><div><label><strong>{{\'app.services.PRIORITY\'|translate}}:</strong></label><p>{{ $ctrl.current_service.priority ? $ctrl.current_service.priority : \'No disponible\'}}</p></div><div><label><strong>{{\'app.services.REMAINING_PEOPLE\'|translate}}:</strong></label><p>{{ $ctrl.current_service.previousNotificationLimit ? $ctrl.current_service.previousNotificationLimit : \'No disponible\'}}</p></div><div><label><strong>{{\'app.services.TURNS_LIMIT\'|translate}}:</strong></label><p>{{ $ctrl.current_service.turnsLimit ? $ctrl.current_service.turnsLimit : \'No disponible\'}}</p></div><div><label><strong>{{\'app.services.LIMIT_WAITING_TIME\'|translate}}:</strong></label><p>{{ $ctrl.current_service.timeAlert ? $ctrl.current_service.timeAlert : \'No disponible\'}}</p></div><div><label><strong>{{\'app.administration.STATUS\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_service.status == \'true\' || $ctrl.current_service.status == true">fiber_manual_record</md-icon><p class="editable-text-span active" ng-if="$ctrl.current_service.status === true">{{\'app.administration.STATUS_ENABLED\'|translate}}</p></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_service.status == \'false\' || $ctrl.current_service.status == false">fiber_manual_record</md-icon><p class="editable-text-span inactive" ng-if="$ctrl.current_service.status === false">{{\'app.administration.STATUS_DISABLED\'|translate}}</p></div></div></div></md-dialog-content></md-dialog></div></div><!-- DIALOG PROGRAMMING QUEUETYPE--><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=dialog_programming_service><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ $ctrl.current_service.display }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content class=dialog-content><div class=radio-box><md-radio-group layout=row ng-model=$ctrl.current_service.programmingType><label>{{\'app.programming.TYPE\'|translate}} :</label><md-radio-button class=md-checked value=isDateSelected>{{\'app.programming.DATE\'|translate}}</md-radio-button><md-radio-button value=isTimeSelected>{{\'app.programming.TIME\'|translate}}</md-radio-button></md-radio-group></div><div class=md-dialog-content flex><div class=date-selected ng-if="$ctrl.current_service.programmingType == \'isDateSelected\'"><form name=dateForm><label>{{\'app.programming.START\'|translate}} :</label><md-datepicker ng-model=$ctrl.current_service.dateStart md-placeholder="Enter date" required ng-change=$ctrl._validateDates($ctrl.current_service)></md-datepicker><label>{{\'app.programming.END\'|translate}} :</label><md-datepicker ng-model=$ctrl.current_service.dateEnd md-placeholder="Enter date" md-min-date=$ctrl.minDateTo required ng-change=$ctrl._validateDates($ctrl.current_service)></md-datepicker><div class=custom-errors style=width:100%><span class=error ng-show="$ctrl.isValidDate == false &amp;&amp; dateForm.$valid">{{\'app.programming.ERROR_VALIDATE_DATES\'|translate}}</span></div><div ng-messages=dateForm.$error><span class=error ng-message=valid>{{\'app.programming.ERROR_FORMAT\'|translate}}</span><span class=error ng-message=required>{{\'app.programming.ERROR_REQUIRED\'|translate}}</span></div></form></div><div class=time-selected ng-if="$ctrl.current_service.programmingType == \'isTimeSelected\'"><form name=timeForm><label class=time-label>{{\'app.programming.TIME_START\'|translate}} :</label><input class="editable-input form-control input-sm" type=time name=timeStart ng-model=$ctrl.current_service.timeStart required placeholder=HH:mm:ss ng-change="$ctrl._validateTime(timeForm, $ctrl.current_service)"><label class=time-label>{{\'app.programming.TIME_END\'|translate}} :</label><input class="editable-input form-control input-sm" type=time name=timeEnd ng-model=$ctrl.current_service.timeEnd required placeholder=HH:mm:ss ng-change="$ctrl._validateTime(timeForm, $ctrl.current_service)"><div class=custom-errors style=width:100%><span class=error ng-show="$ctrl.isValidTime == false &amp;&amp; timeForm.$valid">{{\'app.programming.ERROR_VALIDATE_TIMES\'|translate}}</span></div></form></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=$ctrl._sendProgrammingService($ctrl.current_service) ng-disabled="($ctrl.current_service.programmingType == \'isDateSelected\' &amp;&amp; $ctrl.isValidDate == false) || ($ctrl.current_service.programmingType == \'isTimeSelected\' &amp;&amp; $ctrl.isValidTime == false)">{{\'app.programming.SEND_PROGRAMMING\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!--UPDATE IMAGE MODAL--><div style="visibility: hidden"><div class=md-dialog-container id=changeImageDialog><md-dialog style="width: 440px;min-height: 200px"><md-toolbar><div class="md-toolbar-tools closeModals"><h2>Actualizar servicio</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><form name=$ctrl.newServiceForm><div class=md-dialog-content flex style="padding: 40px 49px 35px"><input class="editable-input input-img form-control input-sm" type=file name=local_promo ng-model=service.local_promo ng-change=$ctrl.updateImages(service.local_promo) maxsize=100 base-sixty-four-input accept=image/*></div></form></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.CANCEL\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl.saveUpdatedImage()>{{\'app.common.UPDATE\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div></div>');
$templateCache.put('app/modules/admin/administration/profile/profile.html','<div class=container><div class=contHeader><h1>{{\'app.common.PROFILE\'|translate}}</h1></div><div class=profile style="margin-bottom: 5px; width: 100%"><div class=content><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>{{\'app.organizations.NAME_CENTER\'|translate}}</label><input ng-model=$ctrl.profileData.commerceName name=commerceName type=text autocomplete=nope placeholder="{{\'app.organizations.NAME_CENTER\'|translate}}" required><div ng-messages=loginForm.commerceName.$error><div ng-message=required>Nombre del comercio requerido</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><label>{{\'app.organizations.PHONE\'|translate}}</label><div style="width:100%; display: flex; justify-content: flex-start"><md-input-container><md-select name=country ng-model=$ctrl.countryCodes.country required style="width: 100px" ng-change=$ctrl.ngSelect($ctrl.countryCodes.country)><md-option ng-repeat="country in $ctrl.countries" value={{country.dial_code}}>{{country.nombre}}</md-option></md-select></md-input-container><md-input-container><label>{{\'app.organizations.PHONE\'|translate}}</label><input ng-model=$ctrl.profileData.phone name=phone id=phone type=text autocomplete=off required><p style=display:none id=err_phone></p></md-input-container></div></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Categor\xEDa</label><md-select name=categories id=category ng-model=$ctrl.profileData.category required ng-change=$ctrl.ngSelectCat($ctrl.profileData.category)><md-option ng-repeat="categorie in $ctrl.categories" value={{categorie.id}}>{{categorie.name}}</md-option></md-select><div ng-messages=loginForm.category.$error><div ng-message=required>Categor\xEDa requerida</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Descripci\xF3n del comercio</label><input ng-model=$ctrl.profileData.description name=description type=text autocomplete=nope placeholder="Descripci\xF3n del comercio"><div ng-messages=loginForm.description.$error><div ng-message=required>Descripci\xF3n del comercio requerida</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Direcci\xF3n</label><input ng-model=$ctrl.profileData.address name=address type=text autocomplete=nope placeholder=Direcci\xF3n><div ng-messages=loginForm.address.$error><div ng-message=required>Direcci\xF3n requerida</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><h3 style="margin-bottom: 5px">Imagen de la organizaci\xF3n</h3><div class=profileImage><md-tooltip md-direction=bottom>Cambiar Logo</md-tooltip><label style="height: 100%; cursor pointer" for=avatar><img class=avatarP ng-src="{{$ctrl.previewImg.logo || $ctrl.profileData.avatar || \'https://www.w3schools.com/howto/img_avatar.png\' }}" alt=Avatar> <input id=avatar type=file accept=image/* ng-model=$ctrl.profileData.avatar name=file ng-change="$ctrl._validateImages($ctrl.profileData.avatar, \'logo\')" style="display: none"></label></div></div></div><md-button class="md-raised md-primary btn_submit" ng-click=$ctrl._sendProfileDataUsr()>{{\'app.common.UPDATE\'|translate}}</md-button><h2>Datos personales</h2><div class=content><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Nombre</label><input ng-model=$ctrl.profileData.name name=name type=text autocomplete=nope placeholder=Nombre required><div ng-messages=loginForm.name.$error><div ng-message=required>Nombre requerido</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Primer apellido</label><input ng-model=$ctrl.profileData.lastName name=lastName type=text autocomplete=nope placeholder="Primer apellido" required><div ng-messages=loginForm.lastName.$error><div ng-message=required>Primer apellido requerido</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Segundo apellido</label><input ng-model=$ctrl.profileData.secondLastName name=secondLastName type=text autocomplete=nope placeholder="Segundo apellido"><div ng-messages=loginForm.secondLastName.$error><div ng-message=required>Segundo apellido requerido</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Email</label><input ng-model=$ctrl.profileData.email name=email type=text autocomplete=nope placeholder=Email required><div ng-messages=loginForm.email.$error><div ng-message=required>Email requerido</div></div></md-input-container></md-content></div></div><md-button class="md-raised md-primary btn_submit" ng-click=$ctrl._sendProfileData()>{{\'app.common.UPDATE\'|translate}}</md-button><h2>Datos de usuario</h2><div class=content><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Nombre de usuario</label><input ng-model=$ctrl.profileData.username name=userName type=text autocomplete=nope placeholder="Nombre de usuario" required><div ng-messages=loginForm.userName.$error><div ng-message=required>Nombre de usuario requerido</div></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Password</label><input ng-model=$ctrl.profileData.password id=password name=password type=password ng-change="$ctrl._validateInputs($ctrl.profileData.password, \'password\')" autocomplete=nope placeholder=Password><div ng-messages=loginForm.userName.$error><div ng-message=required>Password requerido</div><p ng-if=$ctrl.errPass style=color:red>Ingresa al menos una may\xFAscula, un n\xFAmero y un caracter especial</p></div></md-input-container></md-content></div><div style="margin-bottom: 5px; display: inline-block; width: 100%"><md-content class=w-100><md-input-container class=w-100><label>Confirmar password</label><input ng-model=$ctrl.profileData.confirmPassword id=confirmPassword name=confirmPassword type=password ng-change="$ctrl._validateInputs($ctrl.profileData.confirmPassword, \'confirmPassword\')" placeholder="Confirmar password"><div ng-messages=loginForm.confirmPassword.$error><div ng-message=required>Confirmar password requerido</div><p ng-if=$ctrl.confirmPassword style=color:red>Las contrase\xF1as no coinciden</p></div></md-input-container></md-content></div></div><md-button class="md-raised md-primary btn_submit" ng-click=$ctrl._sendProfileUsr()>{{\'app.common.UPDATE\'|translate}}</md-button></div></div>');
$templateCache.put('app/modules/admin/administration/screens/screens.html','<div id=users-container><div class="services-container float-container" flex><div class=users-container-header><h1 class=main-pannel ng-if=$ctrl.isRoot>{{\'app.administration.SCREENS\'|translate}} {{ $ctrl.establishmentInUse ? \' - \' + $ctrl.establishmentInUse : \'\' }}</h1><h1 class=main-pannel ng-if=!$ctrl.isRoot>{{\'app.administration.SCREENS\'|translate}}</h1><div class="brn-group add_element medium"><div class=add_element><div class=selectOrganization style="margin-top: 5px" layout-gt-sm=row layout=column ng-hide=!($ctrl.isRoot)><md-autocomplete md-no-cache=true md-selected-item=$ctrl.organizationSelected md-search-text=$ctrl.searchTextOrganization md-selected-item-change=$ctrl.getEstablismentByOrganization(organization.id) md-items="organization in $ctrl.querySearchSelectOrganizations($ctrl.searchTextOrganization)" md-item-text=organization.name md-min-length=0 placeholder="{{\'app.administration.SELECT_ORGANIZATION\'|translate}}"><md-item-template><span md-highlight-text=$ctrl.searchTextOrganization md-highlight-flags=^i>{{ organization.name }}</span></md-item-template><md-not-found>No se encontraron organizaciones.</md-not-found></md-autocomplete></div><div class=selectOrganization layout-gt-sm=row layout=column ng-hide=$ctrl.isAdmin style=margin-top:5px><md-autocomplete md-no-cache=true md-selected-item=$ctrl.establishmentSelected md-search-text=$ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(establishment) md-items="establishment in $ctrl.querySearchSelect($ctrl.searchText)" md-item-text=establishment.name md-min-length=0 placeholder="{{\'app.statistics.SELECT_CENTER\'|translate}}"><md-item-template><span md-highlight-text=$ctrl.searchText md-highlight-flags=^i>{{ establishment.name }}</span></md-item-template><md-not-found>No se encontraron centros.<md-option value="{{ establishment }}" ng-repeat="establishment in $ctrl.establishments">{{ establishment.name }} {{ establishment.addressFirstLine }}</md-option></md-not-found></md-autocomplete></div></div><div style=display:flex><md-button class="md-raised md-primary" ng-click=$ctrl._showNewScreenForm() ng-disabled="$ctrl.noAreas || $ctrl.noScreens" style="background-color:#ff914d; color:#ffffff;margin-right: 17px"><span>+ {{\'app.screens.NEW_SCREEN\'|translate}}</span></md-button><md-button class="md-raised md-primary" ng-click=$ctrl._showAssignServiceForm() ng-disabled="$ctrl.fail || !$ctrl.hasScreensSelected"><span>{{\'app.kiosks.ASIGN_QUEUES\'|translate}}</span></md-button></div></div></div><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParams disable-filter=$ctrl.isAdding demo-tracked-table=$ctrl.tableTracker><tr ng-repeat="screen in $data" ng-form=rowForm demo-tracked-table-row=row><td class=has_id ng-attr-title="{{\'app.establishments.CODE\'|translate}}" title="\'app.establishments.CODE\'|translate" filter="{ id: \'text\'}" demo-tracked-table-cell><div flex layout=row layout-align="start center"><input class="selectCheck has_dialog" type=checkbox ng-model=screen.Selected ng-click=$ctrl._selectScreen(screen) ng-if=!screen.isEditing><span class=editable-text ng-if="$ctrl.currentRole != \'ROOT\'">{{screen.id}}</span></div></td><td class=has_dialog ng-attr-title="{{\'app.screens.NAME\'|translate}}" title="\'app.screens.NAME\'|translate" filter="{ name: \'text\'}" ng-switch=screen.isEditing ng-class="name.$dirty ? \'bg-warning\' : \'\'" ng-form=name demo-tracked-table-cell ng-click=$ctrl._detailScreen(screen)><span class=editable-text ng-switch-default>{{screen.name}}</span><div class=controls ng-class="name.$invalid &amp;&amp; name.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text name=name ng-model=screen.name required></div></td><td class=has_dialog ng-attr-title="{{\'app.screens.PLACE\'|translate}}" title="\'app.screens.PLACE\'|translate" filter="{ place: \'text\'}" ng-switch=screen.isEditing ng-class="place.$dirty ? \'bg-warning\' : \'\'" ng-form=place demo-tracked-table-cell ng-click=$ctrl._detailScreen(screen)><span class=editable-text ng-switch-default>{{$ctrl.getAreaName(screen.areaId)}}</span><div class=controls ng-class="place.$invalid &amp;&amp; place.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=center name=place ng-model=screen.areaId required><md-option value="{{ area.id }}" ng-repeat="area in $ctrl.areas">{{ area.name }}</md-option></md-select></div></td><td class=has_dialog ng-attr-title="{{\'app.screens.ROWS\'|translate}}" title="\'app.screens.ROWS\'|translate" filter="{ rows: \'text\'}" ng-switch=screen.isEditing ng-class="rows.$dirty ? \'bg-warning\' : \'\'" ng-form=rows demo-tracked-table-cell ng-click=$ctrl._detailScreen(screen)><span class=editable-text ng-switch-default>{{screen.rows}}</span><div class=controls ng-class="rows.$invalid &amp;&amp; rows.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text name=rows ng-model=screen.rows required></div></td><td class=has_dialog ng-attr-title="{{\'app.screens.COLORS\'|translate}}" title="\'app.screens.COLORS\'|translate" filter="{ colors: \'text\'}" ng-switch=screen.isEditing ng-class="colors.$dirty ? \'bg-warning\' : \'\'" ng-form=colors demo-tracked-table-cell><span class=editable-text ng-switch-default>{{ \'app.screens.MAIN_COLOR\' |translate}}: </span><input type=color ng-model=screen.colors[0] disabled ng-switch-default><br><span class=editable-text ng-switch-default>{{ \'app.screens.EVEN\' |translate}}:</span> <input type=color ng-model=screen.colors[1] disabled ng-switch-default><br><span class=editable-text ng-switch-default>{{ \'app.screens.ODD\' |translate}}:</span> <input type=color ng-model=screen.colors[2] disabled ng-switch-default><div class=controls ng-class="colors.$invalid &amp;&amp; colors.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><!--input(type="text" name="colors" ng-model="screen.colors" class="editable-input form-control input-sm" required)--><span class=editable-text ng-switch-default>{{ \'app.screens.MAIN_COLOR\' |translate}}:</span><color-picker ng-model=screen.colors[0]></color-picker><br><span class=editable-text ng-switch-default>{{ \'app.screens.EVEN\' |translate}}:</span><color-picker ng-model=screen.colors[1]></color-picker><br><span class=editable-text ng-switch-default>{{ \'app.screens.ODD\' |translate}}:</span><color-picker ng-model=screen.colors[2]></color-picker></div></td><td class=has_dialog ng-attr-title="{{\'app.screens.SHOW_NAME\'|translate}}" title="\'app.screens.SHOW_NAME\'|translate" filter="{ show_name: \'text\'}" ng-switch=screen.isEditing ng-class="show_name.$dirty ? \'bg-warning\' : \'\'" ng-form=show_name demo-tracked-table-cell><span class=editable-text ng-switch-default><div class=item><md-checkbox type=checkbox ng-checked="$ctrl.is_selected(\'name\', screen)" ng-disabled=true><span>{{ \'app.screens.SHOW\' |translate}}</span></md-checkbox></div></span><div class=controls ng-class="show_name.$invalid &amp;&amp; show_name.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><div class=item><md-checkbox class="editable-input form-control" type=checkbox required ng-model=screen.show_name><span>{{ \'app.screens.SHOW\' |translate}}</span></md-checkbox></div></div></td><td class=has_dialog ng-attr-title="{{\'app.screens.SHOW_WORKSTATION\'|translate}}" title="\'app.screens.SHOW_WORKSTATION\'|translate" filter="{ show_workstation: \'text\'}" ng-switch=screen.isEditing ng-class="show_workstation.$dirty ? \'bg-warning\' : \'\'" ng-form=show_workstation demo-tracked-table-cell><span class=editable-text ng-switch-default><div class=item><md-checkbox type=checkbox ng-checked="$ctrl.is_selected(\'workstation\', screen)" ng-disabled=true><span>{{ \'app.screens.SHOW\' |translate}}</span></md-checkbox></div></span><div class=controls ng-class="show_workstation.$invalid &amp;&amp; show_workstation.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><div class=item><md-checkbox class="editable-input form-control" type=checkbox required ng-model=screen.show_workstation><span>{{ \'app.screens.SHOW\' |translate}}</span></md-checkbox></div></div></td><td class=has_dialog ng-attr-title="{{\'app.screens.VOICE_SERVICE\'|translate}}" title="\'app.screens.VOICE_SERVICE\'|translate" filter="{ has_tts : \'text\'}" ng-switch=screen.isEditing ng-class="has_tts.$dirty ? \'bg-warning\' : \'\'" ng-form=has_tts demo-tracked-table-cell><span class=editable-text ng-switch-default><div class=item><md-checkbox type=checkbox ng-checked="$ctrl.is_selected(\'tts\', screen)" ng-disabled=true><span>{{ \'app.screens.ACTIVATE\' |translate}}</span></md-checkbox></div></span><div class=controls ng-class="has_tts.$invalid &amp;&amp; has_tts.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><div class=item><md-checkbox class="editable-input form-control" type=checkbox required ng-model=screen.has_tts><span>{{ \'app.screens.ACTIVATE\' |translate}}</span></md-checkbox></div></div></td><td class="has_dialog has_style" ng-attr-title="{{\'app.screens.CSS_FILE\'|translate}}" filter="{ css: \'text\'}" title="\'app.screens.CSS_FILE\'|translate" ng-switch=screen.isEditing ng-class="cssFile.$dirty ? \'bg-warning\' : \'\'" ng-form=cssFile demo-tracked-table-cell><span class=editable-text ng-switch-default ng-if=screen.style_link>{{ \'app.screens.CSS_ATTACHED\' | translate }}</span><span class=editable-text ng-switch-default ng-if=!screen.style_link>{{ \'app.screens.NO_CSS_ATTACHED\' | translate }}</span><a ng-switch-default ng-if=screen.style_link ng-href={{screen.style_link}} download={{screen.style_link}} target=_blank><md-tooltip class=md-tooltip-dashboard md-direction=top>{{ \'app.common.DOWNLOAD\' | translate }}</md-tooltip><md-icon>cloud_download</md-icon></a><div class="controls has_image" ng-class="cssFile.$invalid &amp;&amp; cssFile.$dirty ? \'has-error\' : \'\'" ng-switch-when=true layout=column><div class=custom-file-upload><div class=file-buttons-container><label class=file-upload-icon-button for=css-file-{{screen.id}}><md-icon class=file-upload-icon>cloud_upload</md-icon><md-tooltip class=md-tooltip-dashboard md-direction=top>{{ \'app.screens.SELECT_CSS_FILE\' | translate }}</md-tooltip></label><button class=file-delete-button ng-click="screen.style = null; screen.style_link = null; rowForm.$setDirty(); cssFile.$setDirty()" ng-if="screen.style &amp;&amp; screen.style.filename || screen.style_link" type=button><md-icon class=file-delete-icon>delete</md-icon><md-tooltip class=md-tooltip-dashboard md-direction=top>{{ \'app.common.DELETE\' | translate }}</md-tooltip></button></div><span class=file-info-compact ng-class="screen.style &amp;&amp; screen.style.filename ? \'has-file\' : \'no-file\'"><span ng-if="screen.style &amp;&amp; screen.style.filename">{{ screen.style.filename }}</span><span ng-if="!screen.style || !screen.style.filename">{{ \'app.screens.NO_CSS_SELECTED\' | translate }}</span></span></div><!-- Input oculto completamente separado--><div style="position: absolute; left: -99999px; top: -99999px; opacity: 0; visibility: hidden; width: 0; height: 0; z-index: -9999"><input id=css-file-{{screen.id}} type=file base-sixty-four-input ng-model=screen.style accept=.css style="position: absolute !important; left: -99999px !important; opacity: 0 !important; width: 0 !important; height: 0 !important; visibility: hidden !important; display: none !important"></div></div></td><td class=has_dialog ng-attr-title="{{\'app.administration.STATUS\'|translate}}" title="\'app.administration.STATUS\'|translate" filter="{ status: \'text\'}" ng-switch=screen.isEditing ng-class="screen.$dirty ? \'bg-warning\' : \'\'" ng-form=status demo-tracked-table-cell ng-click=$ctrl._detailScreen(screen)><span class="editable-text active" ng-switch-default ng-if="screen.status == \'true\' || screen.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span><span class="editable-text inactive" ng-switch-default ng-if="screen.status == \'false\' || screen.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span><div class=controls ng-class="status.$invalid &amp;&amp; status.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=status ng-model=screen.status required><md-option value=true ng-selected="screen.status == \'true\' || screen.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="screen.status == \'false\' || screen.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div></td><td class="has_dialog has_checkbox" ng-attr-title="{{ screen.assigned ? (\'app.screens.ASSIGNED\' | translate) : (\'app.screens.ASSIGNED_DISABLED\' | translate) }}" ng-switch=screen.isEditing ng-class="screen.$dirty ? \'bg-warning\' : \'\'" demo-tracked-table-cell><md-button ng-if=!screen.assigned style=pointer-events:none><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.screens.ASSIGNED_DISABLED\'|translate}}</md-tooltip><md-icon class=gray-disabled style="position: static">perm_contact_calendar</md-icon></md-button><md-button ng-if=screen.assigned style=pointer-events:none><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.screens.ASSIGNED\'|translate}}</md-tooltip><md-icon class=orange style="position: static">perm_contact_calendar</md-icon></md-button></td><td class="button-box align-center has_options"><md-button class="optionsbtn btn btn-default btn-sm" style="border-radius: 6px" ng-click=$ctrl._editOptionsButton(screen.id) ng-if=!screen.isEditing><md-icon>more_horiz</md-icon></md-button><div class=activate-option id={{screen.id}} style="right:25px; display:none"><md-button class="button-activate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click="screen.isEditing = true" ng-if=!screen.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">edit_not</md-icon><span class=span-activate-option style="padding: 4px 4px 4px">{{\'app.organizations.EDIT\'|translate}}</span></md-button><md-button class="button-deactivate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl.showDeleteConfirm(screen) ng-if=!screen.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">delete</md-icon><span class=span-desactivate-option style="padding: 4px 4px 4px">{{\'app.organizations.DELETE\'|translate}}</span></md-button></div><md-button class="btn btn-primary btn-sm" ng-click="$ctrl.save(screen, rowForm)" ng-if=screen.isEditing ng-disabled=rowForm.$pristine><md-icon class=green>save</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl.cancel(screen, rowForm)" ng-if=screen.isEditing><md-icon class=red>cancel</md-icon></md-button></td></tr><tr ng-if=$ctrl.noData><td colspan=12><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if=!$ctrl.noData><td class=paginator-items colspan=12><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=10 ng-init="pageSize = 10"></select></div></td></tr></table></div><!-- DIALOG NEW SCREEN--><div style="visibility: hidden"><div class=md-dialog-container id=myDialog><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.screens.NEW_SCREEN\'|translate}} - {{ $ctrl.currentEstablishment.name }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content style="padding: 40px 49px 100px !important" flex><form name=$ctrl.screenForm><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.screens.NAME\'|translate}}</label><input class="md-input no-spin" type=text id=name name=name ng-model=$ctrl.new_screen.name autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_screen.name, \'name\', $ctrl.screenForm)"></md-input-container><p style="color:rgba(219, 72, 73, 1)" ng-if="$ctrl.errosInput.name === true &amp;&amp; $ctrl.screenForm.name.$touched">{{\'app.screens.ERROR_NAME\'|translate}}</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.screens.ROWS\'|translate}}</label><input class="md-input no-spin" type=text id=center name=center ng-model=$ctrl.new_screen.rows autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_screen.rows, \'center\', $ctrl.screenForm)"></md-input-container><p style=display:none id=err_center>Ingrese un n\xFAmero v\xE1lido</p><p style="color:rgba(219, 72, 73, 1)" ng-if="$ctrl.errosInput.center === true &amp;&amp; $ctrl.screenForm.center.$touched">{{\'app.screens.ERROR_CENTER\'|translate}}</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.screens.PLACE\'|translate}}</label><md-select id=center name=place ng-model=$ctrl.new_screen.areaId required><md-option value="{{ area.id }}" ng-repeat="area in $ctrl.areas">{{ area.name }}</md-option></md-select></md-input-container></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.administration.STATUS\'|translate}}</label><md-select id=status name=status ng-model=$ctrl.new_screen.status required><md-option value=true selected>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{ \'app.screens.CSS_FILE\' | translate }}</label><div class=custom-file-upload><div class=file-buttons-container><label class=file-upload-icon-button for=new-screen-css-file><md-icon class=file-upload-icon>cloud_upload</md-icon><md-tooltip class=md-tooltip-dashboard md-direction=top>{{ \'app.screens.SELECT_CSS_FILE\' | translate }}</md-tooltip></label><button class=file-delete-button ng-click="$ctrl.new_screen.style = null" ng-if="$ctrl.new_screen.style &amp;&amp; $ctrl.new_screen.style.filename" type=button><md-icon class=file-delete-icon>delete</md-icon><md-tooltip class=md-tooltip-dashboard md-direction=top>{{ \'app.common.DELETE\' | translate }}</md-tooltip></button></div><span class=file-info-compact ng-class="$ctrl.new_screen.style &amp;&amp; $ctrl.new_screen.style.filename ? \'has-file\' : \'no-file\'"><span ng-if="$ctrl.new_screen.style &amp;&amp; $ctrl.new_screen.style.filename">{{ \'app.common.SELECTED_FILE\' | translate }}: {{ $ctrl.new_screen.style.filename }}</span><span ng-if="!$ctrl.new_screen.style || !$ctrl.new_screen.style.filename">{{ \'app.screens.NO_CSS_SELECTED\' | translate }}</span></span></div></md-input-container><!-- Input oculto completamente separado--><div style="position: absolute; left: -99999px; top: -99999px; opacity: 0; visibility: hidden; width: 0; height: 0; z-index: -9999"><input id=new-screen-css-file type=file base-sixty-four-input ng-model=$ctrl.new_screen.style accept=.css style="position: absolute !important; left: -99999px !important; opacity: 0 !important; width: 0 !important; height: 0 !important; visibility: hidden !important; display: none !important"></div></div><div style=width:100%><md-input-container class=text_to_show md-float><p class=label>{{\'app.screens.TEXT_TO_SHOW\'|translate}} <span style=font-size:11px>{{\'app.screens.TEXT_TO_SHOW_INCLUDED\'|translate}}</span></p><div class=text_to_show_container><div class=item_box><div class=item ng-repeat="item in $ctrl.items"><md-checkbox ng-click="$ctrl.toggle(item, $ctrl.selected, true)"><span>{{ item.text |translate}}</span></md-checkbox></div></div></div></md-input-container></div></form></div><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._sendScreen($ctrl.new_screen) ng-disabled=screenForm.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog-content></md-dialog></div></div><!-- DIALOG SHOW DETAIL--><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=dialog_detail_screen><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ $ctrl.current_screen.name }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><div><label><strong>{{\'app.establishments.CODE\'|translate}}:</strong></label><p>{{ $ctrl.current_screen.id }}</p></div><div><label><strong>{{\'app.screens.NAME\'|translate}}:</strong></label><p>{{ $ctrl.current_screen.name }}</p></div><div><label><strong>{{\'app.screens.PLACE\'|translate}}:</strong></label><p>{{$ctrl.getAreaName($ctrl.current_screen.areaId) }}</p></div><div><label><strong>{{\'app.screens.ROWS\'|translate}}:</strong></label><p>{{ $ctrl.current_screen.rows }}</p></div><div><label><strong>{{\'app.administration.CENTER\'|translate}}:</strong></label><p>{{ $ctrl.getEstablishmentName($ctrl.current_screen.locationId) }}</p></div><div><label><strong>{{\'app.administration.STATUS\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_screen.status == \'true\' || $ctrl.current_screen.status == true">fiber_manual_record</md-icon><p class="editable-text-span active" ng-if="$ctrl.current_screen.status === true">{{\'app.administration.STATUS_ENABLED\'|translate}}</p></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_screen.status == \'false\' || $ctrl.current_screen.status == false">fiber_manual_record</md-icon><p class="editable-text-span inactive" ng-if="$ctrl.current_screen.status === false">{{\'app.administration.STATUS_DISABLED\'|translate}}</p></div></div><div><label><strong>{{\'app.screens.COLORS\'|translate}}:</strong></label><p>{{ \'app.screens.MAIN_COLOR\' |translate}}:</p><input type=color ng-model=$ctrl.current_screen.colors[0] disabled><br><p>{{ \'app.screens.EVEN\' |translate}}:</p><input type=color ng-model=$ctrl.current_screen.colors[1] disabled><br><p>{{ \'app.screens.ODD\' |translate}}:</p><input type=color ng-model=$ctrl.current_screen.colors[2] disabled></div><div><label><strong>{{ \'app.screens.ASSIGNED\'|translate }}:</strong></label><p class=has_dialog ng-if="$ctrl.current_screen.assigned == true || $ctrl.current_screen.assigned == \'true\'" style=color:limegreen ng-click=$ctrl._detailAsignedService($ctrl.current_screen)>{{ \'app.screens.ASSIGNED_ENABLED\'|translate }}<span style=color:#777>{{ \'app.administration.CLICK_TO_SEE\'|translate }}</span></p><p ng-if="!$ctrl.current_screen.assigned || $ctrl.current_screen.assigned == false || $ctrl.current_screen.assigned == \'false\'" style=color:red>{{ \'app.screens.ASSIGNED_DISABLED\'|translate }}</p></div></div></md-dialog-content></md-dialog></div></div><!-- DIALOG ASSIGN SERVICE--><div style="visibility: hidden" aria-label="Assign service custom dialog"><div class=md-dialog-container id=assignDialog><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.services.ASIGN_SERVICE\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><h2 ng-if="$ctrl.services.length &gt; 0">{{\'app.services.ASIGN_SERVICE\'|translate}}</h2><h2 ng-if="$ctrl.services.length == 0">{{\'app.services.NO_ASIGN_SERVICE\'|translate}}</h2><form name=$ctrl.assignServiceForm ng-if="$ctrl.services.length &gt; 0"><md-input-container md-no-float style=width:100%><label>{{\'app.administration.SERVICES\'|translate}}</label><md-select id=center name=service ng-model=$ctrl.new_service.queue multiple required><md-option value="{{ service.id }}" ng-repeat="service in $ctrl.services">{{ service.name }}</md-option></md-select></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._assignService($ctrl.new_service) ng-disabled="assignQueueForm.$invalid || $ctrl.services.length == 0">{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG SHOW DETAIL SERVICES ASSIGNED--><div style="visibility: hidden" aria-label="Info services assigned custom dialog"><div class=md-dialog-container id=dialog_detail_asigned_services><md-dialog><md-toolbar><div class=md-toolbar-tools><h1>{{\'app.administration.SERVICES\'|translate}}</h1></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><table class="table table-borderless"><tbody><tr ng-repeat="service in $ctrl.current_screen.services"><td><strong>{{ service.name }}</strong></td><td style="text-align: right; padding-right: 10px"><md-button class="btn btn-danger btn-sm" ng-click=$ctrl.deleteServiceDirectly(service)><md-icon class=red>delete</md-icon></md-button></td></tr></tbody></table></div></md-dialog-content></md-dialog></div></div></div>');
$templateCache.put('app/modules/admin/administration/services/services.html','<div id=services-container><div class="services-container float-container" flex><div class=services-container-header><h1 class=main-pannel ng-if="$ctrl.currentRole == \'ROOT\'">{{\'app.administration.SERVICES\'|translate}} {{ $ctrl.organizationInUse ? \' - \' + $ctrl.organizationInUse : \'\' }}</h1><h1 class=main-pannel ng-if="$ctrl.currentRole != \'ROOT\'">{{\'app.administration.SERVICES\'|translate}}</h1><div class="brn-group add_element"><div class=selectOrganization style="margin-top: 5px" layout-gt-sm=row layout=column ng-hide="$ctrl.currentRole != \'ROOT\'"><md-autocomplete md-no-cache=true md-selected-item=$ctrl.organizationSelected md-search-text=ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(organization) md-items="organization in $ctrl.querySearchSelect(ctrl.searchText)" md-item-text=organization.name md-min-length=0 placeholder="{{\'app.administration.SELECT_ORGANIZATION\'|translate}}"><md-item-template><span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{ organization.name }}</span></md-item-template><md-not-found>No se encontraron organizaciones.</md-not-found></md-autocomplete></div><div><md-button class="md-raised md-primary" ng-show=$ctrl.isSuperAdmin ng-click=$ctrl._showServiceForm() style="background-color:#ff914d; color:#ffffff; margin-right: 17px"><span>+ {{\'app.services.NEW_SERVICE\'|translate}}</span></md-button><md-button class="md-raised md-primary" ng-click=$ctrl._showAsignServiceForm() ng-disabled="$ctrl.fail || !$ctrl.hasServicesSelected" style="margin-right: 17px"><span>{{\'app.services.ASIGN_LOCATION\'|translate}}</span></md-button><!--Asignar Servicios de bokkittit--><md-button class="md-raised md-primary" ng-click=$ctrl._showAsignServiceBokititForm() ng-disabled="$ctrl.fail || !$ctrl.hasServicesSelected" style="margin-right: 17px"><span>{{\'app.services.ENABLE_APPOINTMENT\'|translate}}</span></md-button><md-button class="md-raised md-primary" ng-click=$ctrl._showAsignServiceToService() ng-disabled="$ctrl.fail || !$ctrl.hasServicesSelected"><span>{{\'app.services.ADD_SUBSERVICE\'|translate}}</span></md-button></div></div></div><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParams disable-filter=$ctrl.isAdding demo-tracked-table=$ctrl.tableTracker><tr ng-repeat="service in $data" ng-form=rowForm demo-tracked-table-row=row><td class="has_dialog has_name" ng-attr-title="{{\'app.services.NAME\'|translate}}" title="\'app.services.NAME\'|translate" filter="{ name: \'text\'}" ng-switch=service.isEditing ng-class="name.$dirty ? \'bg-warning\' : \'\'" ng-form=name demo-tracked-table-cell><div flex layout=row layout-align="start center"><input class="selectCheck has_dialog" type=checkbox ng-model=service.Selected ng-click=$ctrl._selectService(service) ng-if=!service.isEditing><span class=editable-text style=margin-left:4px ng-switch-default>{{service.name}}</span><div class=controls ng-class="name.$invalid &amp;&amp; name.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-name form-control input-sm" type=text id=name name=name ng-model=service.name required ng-change="$ctrl._validateDescription(service.name, \'name\', rowForm)"><p style=display:none id=err_name></p></div></div></td><td class="has_dialog has_descrip" ng-attr-title="{{\'app.services.DESCRIPTION\'|translate}}" title="\'app.services.DESCRIPTION\'|translate" filter="{ description: \'text\'}" ng-switch=service.isEditing ng-class="description.$dirty ? \'bg-warning\' : \'\'" ng-form=description demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{service.description}}</span><div class=controls ng-class="description.$invalid &amp;&amp; description.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-description form-control input-sm" type=text id=description name=description ng-model=service.description required ng-change="$ctrl._validateDescription(service.description, \'description\', rowForm)"><p style=display:none id=err_description></p></div></td><td class=has_dialog ng-attr-title="{{\'app.services.DISPLAY\'|translate}}" title="\'app.services.DISPLAY\'|translate" filter="{ display: \'text\'}" ng-switch=service.isEditing ng-class="display.$dirty ? \'bg-warning\' : \'\'" ng-form=display demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{service.display}}</span><div class=controls ng-class="display.$invalid &amp;&amp; display.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-nameshow form-control input-sm" type=text id=display name=display ng-model=service.display required ng-change="$ctrl._validateDescription(service.display, \'display\', rowForm)"><p style=display:none id=err_display></p></div></td><td class=has_dialog ng-attr-title="{{\'app.services.PATTERN\'|translate}}" title="\'app.services.PATTERN\'|translate" filter="{ pattern: \'text\'}" ng-switch=service.isEditing ng-class="pattern.$dirty ? \'bg-warning\' : \'\'" ng-form=pattern demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{ service.pattern }}</span><div class=controls ng-class="pattern.$invalid &amp;&amp; pattern.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-letter form-control input-sm" type=text id=pattern name=pattern ng-model=service.pattern maxlength=3 required ng-change="$ctrl._validateDescription(service.pattern, \'pattern\', rowForm)"><p style=display:none id=err_pattern></p></div></td><td class="has_dialog has_client" ng-attr-title="{{\'app.services.REMAINING_PEOPLE\'|translate}}" title="\'app.services.REMAINING_PEOPLE\'|translate" filter="{ advice_number: \'text\'}" ng-switch=service.isEditing ng-class="advice_number.$dirty ? \'bg-warning\' : \'\'" ng-form=advice_number demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class=editable-text ng-switch-default>{{ service.advice_number }}</span><div class=controls ng-class="advice_number.$invalid &amp;&amp; advice_number.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-letter form-control input-sm" type=number id=advice_number name=advice_number ng-model=service.advice_number value=5 ng-change="$ctrl._validateDescription(service.advice_number, \'advice_number\', rowForm)"><p style=display:none id=err_advice_number></p></div></td><td class="has_dialog has_count" ng-attr-title="{{\'app.services.PROMOS\'|translate}}" title="\'app.services.PROMOS\'|translate" ng-switch=service.isEditing filter="{ promo_search: \'text\'}" ng-class="promo.$dirty ? \'bg-warning\' : \'\'" ng-form=promo demo-tracked-table-cell><span class=editable-text ng-if="service.promo_count &gt; 0" ng-switch-default>{{ service.promo_count + (service.promo_count == 1 ? \' Promo\' : \' Promos\') }}</span><span ng-if="!service.promo_count || service.promo_count &lt;= 0">{{\'app.services.NO_PROMO\'|translate}}</span></td><td class=has_dialog ng-attr-title="{{\'app.administration.STATUS\'|translate}}" title="\'app.administration.STATUS\'|translate" filter="{ status_search: \'text\'}" ng-switch=service.isEditing ng-class="service.$dirty ? \'bg-warning\' : \'\'" ng-form=status demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class="editable-text active" ng-switch-default ng-if="service.status == true || service.status == \'true\'">{{\'app.administration.STATUS_ENABLED\'|translate}}</span><span class="editable-text inactive" ng-switch-default ng-if="service.status == \'false\' || !service.status">{{\'app.administration.STATUS_DISABLED\'|translate}}</span><div class=controls ng-class="status.$invalid &amp;&amp; status.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=status ng-model=service.status required aria-label=select-status><md-option value=true ng-selected="service.status == true || service.status == \'true\'">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="service.status == \'false\' || !service.status">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div></td><td class="has_dialog has_checkbox" ng-attr-title="{{\'app.services.VISIBLE\'|translate}}" title="\'app.services.VISIBLE\'|translate"><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(service.id,\'a\')" ng-if=service.isVisible><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.services.VISIBLE\'|translate}}</md-tooltip><md-icon style="color: #FF914D">visibility</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(service.id,\'a\')" ng-if=!service.isVisible><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.services.VISIBLE\'|translate}}</md-tooltip><md-icon style="color: #C2C9D1">visibility_off</md-icon></md-button><div class=activate-option id={{service.id}}a style=display:none><md-button class="button-activate-option btn-default" style="opacity: 1;margin:0px" ng-click="$ctrl.updateIcons(service, rowForm, true, \'isVisible\')">Activa</md-button><md-button class="button-deactivate-option btn-default" style="opacity: 1;margin:0px" ng-click="$ctrl.updateIcons(service, rowForm, false, \'isVisible\')">No Activa</md-button></div></td><td class="has_dialog has_checkbox" ng-attr-title="{{\'app.services.ASIGNED\'|translate}}"><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(service.id,\'b\')" ng-if=service.asigned><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.services.REQ_ASIGNED\'|translate}}</md-tooltip><md-icon style="color: #FF914D">perm_contact_calendar</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl._activateOptionsButton(service.id,\'b\')" ng-if=!service.asigned><md-tooltip class=md-tooltip-dashboard md-direction=top>{{\'app.services.REQ_ASIGNED\'|translate}}</md-tooltip><md-icon style="color: #C2C9D1">perm_contact_calendar</md-icon></md-button><div class=activate-option id={{service.id}}b style=display:none><md-button class="button-activate-option btn-default" style="opacity: 1;margin:0px" ng-click="$ctrl.updateIcons(service, rowForm, true, \'asigned\')">Activa</md-button><md-button class="button-deactivate-option btn-default" style="opacity: 1;margin:0px" ng-click="$ctrl.updateIcons(service, rowForm, false, \'asigned\')">No Activa</md-button></div></td><td class=has_dialog ng-attr-title="{{\'Bokitit\'|translate}}" title="\'Bokitit\'|translate" filter="{ hasBokititServices: \'text\'}" ng-switch=service.isEditing ng-class="service.$dirty ? \'bg-warning\' : \'\'" ng-form=hasBokititServices demo-tracked-table-cell ng-click=$ctrl._detailService(service)><span class="editable-text active" ng-switch-default ng-if="service.hasBokititServices == true || service.hasBokititServices == \'true\'">{{\'app.administration.STATUS_ENABLED\'|translate}}</span><span class="editable-text inactive" ng-switch-default ng-if="service.hasBokititServices == \'false\' || !service.hasBokititServices">{{\'app.administration.STATUS_DISABLED\'|translate}}</span><div class=controls ng-class="hasBokititServices.$invalid &amp;&amp; hasBokititServices.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=hasBokititServices ng-model=service.hasBokititServices required><md-option value=true ng-selected="service.hasBokititServices == true || service.hasBokititServices == \'true\'">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="service.hasBokititServices == \'false\' || !service.hasBokititServices">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div></td><td class="button-box align-center has_options"><md-button class="optionsbtn btn btn-default btn-sm" ng-click=$ctrl._editOptionsButton(service.id) ng-if=!service.isEditing><md-icon>more_horiz</md-icon></md-button><div class=activate-option id={{service.id}} style="right:25px; display:none"><md-button class="button-activate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important;padding: 0px 20px; display: flex; justify-content: space-around" ng-click=$ctrl._showServiceForm(service) ng-if=!service.isEditing><md-icon class=orange style="font-size:22px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px;margin: 0px">edit_not</md-icon><span class=span-activate-option style="padding: 4px 4px 4px">{{\'app.organizations.EDIT\'|translate}}</span></md-button><!--md-button(style="width:104px; opacity: 1;margin:0px;height:44px !important; padding: 0px 20px; display: flex; justify-content: space-between;" class="button-deactivate-option btn-default" ng-click="$ctrl.showDeleteConfirm(service)" ng-if="!service.isEditing")\n            md-icon.orange(style="font-size:22px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px;margin: 0px;") delete\n            span.span-desactivate-option(style="padding: 4px 4px 4px;") {{\'app.organizations.DELETE\'|translate}}\n            \n            --></div><md-button class="btn btn-primary btn-sm" ng-click=$ctrl.save(service) ng-if=service.isEditing ng-disabled=rowForm.$pristine><md-icon class=green>save</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click=$ctrl.cancel(service) ng-if=service.isEditing><md-icon class=red>cancel</md-icon></md-button></td></tr><tr ng-if=$ctrl.noData><td colspan=12><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if=!$ctrl.noData><td class=paginator-items colspan=12><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=5 ng-init="pageSize = 5"></select></div></td></tr></table></div><!-- DIALOG NEW SERVICE--><div style="visibility: hidden" aria-label="New service custom dialog"><div class=md-dialog-container id=newService><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2 ng-if="$ctrl.editServ === false">{{\'app.services.NEW_SERVICE\'|translate}}</h2><h2 ng-if=$ctrl.editServ>{{\'app.services.EDIT_SERVICE\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog($ctrl.new_service)><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><form name=$ctrl.newServiceForms style=width:100%><div class=grid-columns style=width:100%><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.services.NAME\'|translate}}</label><input class="md-input no-spin" type=text id=name name=name ng-model=$ctrl.new_service.name autocomplete=off required ng-change="$ctrl._validateDescription($ctrl.new_service.name, \'name\', $ctrl.newServiceForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.newServiceForm)"></md-input-container><p style=display:none id=err_name>Ingresa un nombre v\xE1lido</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.services.DISPLAY\'|translate}}</label><input class="md-input no-spin" type=text id=display name=display ng-model=$ctrl.new_service.display autocomplete=off required ng-change="$ctrl._validateDescription($ctrl.new_service.display, \'display\', $ctrl.newServiceForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.newServiceForm)"></md-input-container><p style=display:none id=err_display>Ingresa un nombre para mostrar v\xE1lido</p></div><div style=width:100%><div class=two_columns md-no-float><div flex layout=row layout-align="center center"><span class=editable-text style=margin-left:4px>Citas</span> <input class="selectCheck has_dialog" type=checkbox ng-model=$ctrl.new_service.citas style="width:18px; height:18px; margin-left:12px" ng-change="$ctrl._checkCitas($ctrl.new_service.citas, \'citas\')" aria-label=select-appointment><span class=editable-text style=margin-left:4px>Turnos</span> <input class="selectCheck has_dialog" id=selectTurnos type=checkbox ng-model=$ctrl.new_service.turnos style="width:18px; height:18px; margin-left:12px" ng-change="$ctrl._checkCitas($ctrl.new_service.turnos, \'turnos\')" aria-label=select-turns checked><span class=editable-text style=margin-left:4px>Parking</span> <input class="selectCheck has_dialog" type=checkbox ng-model=$ctrl.new_service.parking style="width:18px; height:18px; margin-left:12px" ng-change="$ctrl._checkCitas($ctrl.new_service.parking, \'parking\')" aria-label=select-parking></div></div></div><div ng-if="$ctrl.showCitas === \'true\'" style=width:100%><md-input-container class=two_columns md-no-float><label>Tiempo m\xE1ximo de duraci\xF3n del servicio</label><input class="md-input no-spin" type=text id=time_max name=time_max ng-model=$ctrl.new_service.time_max autocomplete=off ng-keypress="$ctrl._validateSpaces($event, $ctrl.newServiceForm)"></md-input-container><p style=display:none id=err_display>Ingresa un nombre para mostrar v\xE1lido</p></div><div ng-if="$ctrl.showCitas == \'true\'" style=width:100%><md-input-container class=two_columns md-no-float><label>L\xEDmite de reservas por horario</label><input class="md-input no-spin" type=text id=reservation_limit name=reservation_limit ng-model=$ctrl.new_service.reservation_limit autocomplete=off ng-keypress="$ctrl._validateSpaces($event, $ctrl.newServiceForm)"></md-input-container><p style=display:none id=err_display>Ingresa un nombre para mostrar v\xE1lido</p></div><div ng-if="$ctrl.showCitas == \'true\'" style=width:100%><md-input-container md-no-float style="width:100%; grid-column-start: 1; grid-column-end: 3"><label>{{\'Bokitit\'|translate}}</label><md-select id=language name=hasBokititServices ng-model=$ctrl.new_service.hasBokititServices><md-option value=true>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container></div><div ng-if="$ctrl.showTurnos ==\'true\'" style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.services.REMAINING_PEOPLE\'|translate}}</label><input class="md-input no-spin" type=number id=advice_number name=advice_number ng-model=$ctrl.new_service.advice_number autocomplete=off min=0 minlenght=2 maxlength=10 required ng-change="$ctrl._validateDescription($ctrl.new_service.advice_number, \'advice_number\', $ctrl.newServiceForm)" ng-keypress=$ctrl._preventMinus($event)></md-input-container><p style=display:none id=err_advice_number>Ingresa un n\xFAmero v\xE1lido</p></div><div ng-if="$ctrl.showTurnos ==\'true\'" style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.services.PATTERN\'|translate}}</label><input class="md-input no-spin" style="text-transform: uppercase" type=text id=pattern name=pattern ng-model=$ctrl.new_service.pattern autocomplete=off minlenght=1 maxlength=3 required ng-change="$ctrl._validateDescription($ctrl.new_service.pattern, \'pattern\', $ctrl.newServiceForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.newServiceForm)"></md-input-container><p style=display:none id=err_pattern>Ingrea un patr\xF3n v\xE1lido</p></div><div style=width:100%><md-input-container md-no-float style="width:100%; grid-column-start: 1; grid-column-end: 3"><label>{{\'app.services.DESCRIPTION\'|translate}}</label><input class="md-input no-spin" type=text id=description name=description ng-model=$ctrl.new_service.description autocomplete=off maxlength=150 ng-change="$ctrl._validateDescription($ctrl.new_service.description, \'description\', $ctrl.newServiceForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.newServiceForm)"></md-input-container><p style=display:none id=err_description>Ingresa una descripci\xF3n v\xE1lida</p></div><div style=width:100%><md-input-container md-no-float style="width:100%; grid-column-start: 1; grid-column-end: 3"><label>{{\'app.administration.STATUS\'|translate}}</label><md-select id=language name=status ng-model=$ctrl.new_service.status><md-option value=true selected>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container></div></div><hr style="width:100%; visibility:hidden"><div id=input-file-container><div style=width:100%><md-input-container class="two_columns input_file_container"><p style="padding-left: 10px">{{$ctrl.new_service.btn_img.filename}}</p><label for=btn_img>{{\'app.services.BUTTON_IMAGE\'|translate}}</label><input class="md-input no-spin custom-file-input" data-style-type={{&quot;app.organizations.BTN_CHOOSE_FILE&quot;|translate}} type=file id=btn_img name=btn_img ng-model=$ctrl.new_service.btn_img base-sixty-four-input autocomplete=off accept=image/* ng-change="$ctrl._validateImage($ctrl.new_service.btn_img, \'btn_img\', $ctrl.newServiceForms)"></md-input-container><p style=display:none id=err_btn_img></p><div class=div style=width:100% id=img-container><md-input-container md-no-float style=height:146px><div class=img-container><div class="drag&amp;drop drag-drop"><div class=btn-image-box ng-class="!$ctrl.previewImg.btn_img &amp;&amp; !$ctrl.new_service.btn_img ? \'empty\' : \'\'"><md-button class=delete-image ng-if="$ctrl.previewImg.btn_img || $ctrl.new_service.btn_img" ng-click="$ctrl.previewImg.btn_img=\'\'; $ctrl.new_service.btn_img=\'\'; $ctrl.new_service.btn_img_link=\'\'"><md-icon>close</md-icon></md-button><p class=upload-btn ng-if="!$ctrl.previewImg.btn_img &amp;&amp; !$ctrl.new_service.btn_img" ng-click="$ctrl.abrirArchivo(\'btn_img\')">No image</p><img class=thumb ng-if="$ctrl.previewImg.btn_img || $ctrl.new_service.btn_img" style="width: 90%; height: 100%; margin: auto" ng-src="{{$ctrl.previewImg.btn_img || $ctrl.new_service.btn_img}}" ng-click="$ctrl.abrirArchivo(\'btn_img\')"></div></div></div></md-input-container></div></div><div style=width:100%><div><div style=width:100%><md-input-container md-no-float style="width:100%; grid-column-start: 1; grid-column-end: 3"><label>{{\'app.services.NAME_PROMO\'|translate}}</label><input class="md-input no-spin" type=text id=namePromo name=namePromo ng-model=$ctrl.new_service.promo.namePromo autocomplete=off maxlength=150 ng-change="$ctrl._validateDescription($ctrl.new_service.promo.namePromo, \'namePromo\', $ctrl.newServiceForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.newServiceForm)"></md-input-container><p style=display:none id=err_namePromo>Ingresa una nombre de promoci\xF3n v\xE1lido</p></div><div style="width:100%; margin-top: 10px"><md-input-container md-no-float style="width:100%; grid-column-start: 1; grid-column-end: 3"><label>{{\'app.services.DESCRIPTION_PROMO\'|translate}}</label><input class="md-input no-spin" type=text id=descriptionPromo name=descriptionPromo ng-model=$ctrl.new_service.promo.descriptionPromo autocomplete=off maxlength=150 ng-change="$ctrl._validateDescription($ctrl.new_service.promo.descriptionPromo, \'descriptionPromo\', $ctrl.newServiceForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.newServiceForm)"></md-input-container><p style=display:none id=err_descriptionPromo>Ingresa una descripci\xF3n de promocion v\xE1lida</p></div><div style="width:100%; margin-top: 10px"><md-input-container md-no-float style="width:100%; grid-column-start: 1; grid-column-end: 3"><label>{{\'app.services.FORM_PROMO\'|translate}}</label><input class="md-input no-spin" type=text id=formUrl name=formUrl ng-model=$ctrl.new_service.promo.formUrl autocomplete=off maxlength=150 ng-change="$ctrl._validateDescription($ctrl.new_service.promo.formUrl, \'formUrl\', $ctrl.newServiceForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.newServiceForm)"></md-input-container><p style=display:none id=err_formUrl>Ingresa una url de formulario v\xE1lida</p></div><div style="width:100%; margin-top: 10px"><md-input-container md-no-float style="width:100%; grid-column-start: 1; grid-column-end: 3"><label>{{\'app.services.REDI_PROMO\'|translate}}</label><input class="md-input no-spin" type=text id=rediUrl name=rediUrl ng-model=$ctrl.new_service.promo.rediUrl autocomplete=off maxlength=150 ng-change="$ctrl._validateDescription($ctrl.new_service.promo.rediUrl, \'rediUrl\', $ctrl.newServiceForm)" ng-keypress="$ctrl._validateSpaces($event, $ctrl.newServiceForm)"></md-input-container><p style=display:none id=err_rediUrl>Ingresa una url de promocion v\xE1lida</p></div></div></div></div><div style=width:100%><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.promoTableParams show-filter=false disable-filter=true demo-tracked-table=$ctrl.tableTracker><tr ng-repeat="promo_link_data in $data" ng-form=rowForm demo-tracked-table-row=row><td class="has_dialog has_name" ng-attr-title="{{\'app.services.promo.NAME\'|translate}}" title="\'app.services.promo.NAME\'|translate" filter="{ name: \'text\'}" ng-switch=service.isEditing ng-class="name.$dirty ? \'bg-warning\' : \'\'" ng-form=name demo-tracked-table-cell><div flex layout=row layout-align="start center"><span class=editable-text style=margin-left:4px ng-switch-default>{{promo_link_data.name}}</span></div></td><td class="has_dialog has_name" ng-attr-title="{{\'app.services.promo.DESCRIPTION\'|translate}}" title="\'app.services.promo.DESCRIPTION\'|translate" filter="{ name: \'text\'}" ng-switch=service.isEditing ng-class="name.$dirty ? \'bg-warning\' : \'\'" ng-form=name demo-tracked-table-cell><div flex layout=row layout-align="start center"><span class=editable-text style=margin-left:4px ng-switch-default>{{promo_link_data.description}}</span></div></td><td class="has_dialog has_image" ng-attr-title="{{\'app.services.promo.PROMOQR\'|translate}}" title="\'app.services.promo.PROMOQR\'|translate" ng-switch=service.isEditing filter="{ promo: \'text\'}" ng-class="promo.$dirty ? \'bg-warning\' : \'\'" ng-form=promo demo-tracked-table-cell><div class=qr_promo_image><img style="width: 70%" ng-if=promo_link_data.image_url ng-src={{promo_link_data.image_url}}><span ng-if=!promo_link_data.image_url>{{\'app.services.NO_PROMO\'|translate}}</span></div></td><td class="has_dialog has_name" ng-attr-title="{{\'app.services.promo.PERCENTAGE\'|translate}}" title="\'app.services.promo.PERCENTAGE\'|translate" filter="{ name: \'text\'}" ng-switch=service.isEditing ng-class="name.$dirty ? \'bg-warning\' : \'\'" ng-form=name demo-tracked-table-cell><div flex layout=row layout-align="start center"><md-input-container md-no-float style="width:100%; grid-column-start: 1; grid-column-end: 3"><input class="md-input no-spin" type=number id=formUrl name=formUrl ng-model=promo_link_data.percentage autocomplete=off maxlength=150 ng-change="" ng-keypress="$ctrl._validateSpaces($event, $ctrl.newServiceForm)"></md-input-container></div></td><td class="button-box align-center has_options"><div class=center_content flex layout=row layout-align="start center"><md-button class=md-warn ng-click=$ctrl.deletePromotion(promo_link_data)><md-icon class=promo_delete_icon>delete_forever</md-icon></md-button></div></td></tr><tr ng-if=$ctrl.noData><td colspan=12><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if=!$ctrl.noData><td class=paginator-items colspan=12><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=5 ng-init="pageSize = 5"></select></div></td></tr></table></div></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog($ctrl.new_service)>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click="$ctrl._sendService($ctrl.new_service, newServiceForms)" ng-disabled=$ctrl.newServiceForms.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG ASIGN SERVICE--><div style="visibility: hidden" aria-label="Asign service custom dialog"><div class=md-dialog-container id=asignDialog><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.services.ASIGN_LOCATION\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><h2 ng-if="$ctrl.services.length == 0">{{\'Centros no disponibles.\'|translate}}</h2><form style="width: 100%" name=$ctrl.asignServiceForm ng-if="$ctrl.services.length &gt; 0"><md-input-container md-no-float style=width:100%><label>{{\'app.administration.CENTER\'|translate}}</label><md-select id=center name=center ng-model=$ctrl.new_service.center multiple required><md-option value="{{ service.id }}" ng-repeat="service in $ctrl.services">{{ service.name }} {{ service.address }}</md-option></md-select></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._asignService($ctrl.new_service) ng-disabled="asignServiceForm.$invalid || $ctrl.services.length == 0">{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG ASIGN SERVICE BOKITIT--><div style="visibility: hidden" aria-label="Asign service bokitit custom dialog"><div class=md-dialog-container id=asignDialogBokitit><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.services.ASIGNED_SERVICES_OF_BOKITIT\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><h2 ng-if="$ctrl.servicesBokitit.length == 0">{{\'app.services.NO_SERVICES\'|translate}}</h2><form name=$ctrl.asignServiceFormB ng-if="$ctrl.servicesBokitit.length &gt; 0"><md-input-container md-no-float style=width:100%><label>{{\'app.services.SERVICES_OF_BOKITIT\'|translate}}</label><md-select id=servicesBokititSelect name=servicesBokititSelect ng-model=$ctrl.servicesBokititSelect multiple required><md-option value="{{ service.id }}" ng-repeat="service in $ctrl.servicesBokitit">{{ service.name }}</md-option></md-select></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._asignServiceBokitit($ctrl.servicesBokititSelect) ng-disabled="asignServiceFormB.$invalid || $ctrl.servicesBokitit.length == 0">{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG ASIGN SERVICE--><div style="visibility: hidden" aria-label="Asign service custom dialog"><div class=md-dialog-container id=asignServiceToService><md-dialog style="width: 630px"><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.services.ADD_SUBSERVICE\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><h2 ng-if="$ctrl.servicesSelection.length == 0">{{\'Servicios no disponibles.\'|translate}}</h2><form name=$ctrl.asignServiceToService ng-if="$ctrl.servicesSelection.length &gt; 0"><md-input-container md-no-float style=width:100%><label>{{\'app.administration.SERVICES\'|translate}}</label><md-select id=center name=service ng-model=$ctrl.assigned_service.queue><md-option value="{{ service }}" ng-repeat="service in $ctrl.servicesSelection">{{ service.name }}</md-option></md-select></md-input-container></form><md-dialog-actions style=width:30% flex layout=row><md-button class="md-raised md-primary" ng-if="$ctrl.servicesSelection.length !== 0" style="color: #ffff; padding: 10px 20px" ng-click=$ctrl._addInstructions($ctrl.assigned_service)>{{\'app.administration.ADD\'|translate}}</md-button></md-dialog-actions></div><div style="width:100%; margin-top: 20px; padding: 0px 50px"><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParam><tr ng-repeat="service in $ctrl.arrInsService" demo-tracked-table-row=row><td class=has_dialog ng-attr-title="{{\'app.administration.SERVICES\'|translate}}" title="\'app.administration.SERVICES\'|translate" ng-switch=service.isEditing demo-tracked-table-cell><span class=editable-text ng-switch-default>{{service.name}}</span></td><td class=has_dialog ng-attr-title="" demo-tracked-table-cell><md-button class="btn btn-danger btn-sm" ng-click=$ctrl._deleteServChild(service.queueId)><md-icon class=red>delete</md-icon></md-button></td></tr></table></div><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._asignServiceToService($ctrl.new_service) ng-disabled="$ctrl.servicesSelection.length === 0 &amp;&amp; $ctrl.arrInsService.length === 0">{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog-content></md-dialog></div></div><!-- DIALOG SHOW DETAIL--><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=dialog_detail_service><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ $ctrl.current_service.display }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class="md-dialog-content detail-service" flex><div><div><label><strong>{{\'app.services.NAME\'|translate}}:</strong></label><p>{{ $ctrl.current_service.name }}</p></div><div><label><strong>{{\'app.services.DESCRIPTION\'|translate}}:</strong></label><p>{{ $ctrl.current_service.description }}</p></div><div><label><strong>{{\'app.services.DISPLAY\'|translate}}:</strong></label><p>{{ $ctrl.current_service.display }}</p></div><div><label><strong>{{\'app.services.PATTERN\'|translate}}:</strong></label><p>{{ $ctrl.current_service.pattern }}</p></div><div><label><strong>{{\'app.services.REMAINING_PEOPLE\'|translate}}:</strong></label><p>{{ $ctrl.current_service.advice_number }}</p></div><div><label><strong>{{\'app.administration.STATUS\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_service.status == \'true\' || $ctrl.current_service.status == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_service.status == \'true\' || $ctrl.current_service.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_service.status == \'false\' || $ctrl.current_service.status == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_service.status == \'false\' || $ctrl.current_service.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div></div><div><label><strong>{{\'Solicitud de nombre\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_service.isVisible == \'true\' || $ctrl.current_service.isVisible == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_service.isVisible == \'true\' || $ctrl.current_service.isVisible == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_service.isVisible == \'false\' || $ctrl.current_service.isVisible == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_service.isVisible == \'false\' || $ctrl.current_service.isVisible == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div></div><div><label><strong>{{ \'app.services.ASIGNED_CENTER\'|translate }}:</strong></label><p class=has_dialog ng-if="($ctrl.current_service.asigned == true || $ctrl.current_service.asigned == \'true\') &amp;&amp; $ctrl.current_service.establishments.length &gt; 0 " style=color:limegreen ng-click=$ctrl._detailAsignedService($ctrl.current_service)>{{ \'app.services.ASIGNED_ENABLED\'|translate }}<span style=color:#777>{{ \'app.administration.CLICK_TO_SEE\'|translate }}</span></p><p ng-if="$ctrl.current_service.asigned == false || $ctrl.current_service.asigned == \'false\' || $ctrl.current_service.establishments.length == 0" style=color:red>{{ \'app.services.ASIGNED_DISABLED\'|translate }}</p></div><div><label><strong>{{ \'app.services.BOKITIT_SERVICE\'|translate }}:</strong></label><p class=has_dialog ng-if="($ctrl.current_service.asigned == true || $ctrl.current_service.asigned == \'true\') &amp;&amp; $ctrl.bokititServicebyId.bokititServices.length &gt; 0 " style=color:limegreen ng-click=$ctrl._detailAsignedBokititService($ctrl.current_service)>{{ \'app.services.ASIGNED_ENABLED\'|translate }}<span style=color:#777>{{ \'app.administration.CLICK_TO_SEE\'|translate }}</span></p><p ng-if="$ctrl.current_service.asigned == false || $ctrl.current_service.asigned == \'false\' || $ctrl.bokititServicebyId.bokititServices.length == 0" style=color:red>{{ \'app.services.ASIGNED_DISABLED\'|translate }}</p></div></div><div><div><label><strong>{{\'app.services.PROMOS\'|translate}}:</strong></label><div ng-repeat="data in $ctrl.current_service.promo_links" style="display: flex; flex-direction: row"><div style="padding: 9px"><img style="object-fit: contain; width:50%; display:flex" ng-if=data.image_url ng-src={{data.image_url}}><p ng-if=!data.image_url>{{\'app.services.NO_PROMO\'|translate}}</p><label><strong>{{\'app.services.promo.NAME\'|translate}}:</strong><p>{{data.name}}</p></label><label><strong>{{\'app.services.promo.DESCRIPTION\'|translate}}:</strong><p>{{data.description}}</p></label><label><strong>{{\'app.services.promo.PERCENTAGE\'|translate}}:</strong><p>{{data.percentage}}</p></label></div></div></div></div></div></md-dialog-content></md-dialog></div></div><!-- DIALOG SHOW DETAIL CENTERS ASIGNED--><div style="visibility: hidden" aria-label="Info stablisments asigned custom dialog"><div class=md-dialog-container id=dialog_detail_asigned_service><md-dialog style="border-radius: 15px"><md-toolbar><div class=md-toolbar-tools><h1>{{\'app.administration.SERVICE\'|translate}}: {{ $ctrl.current_service.name }}</h1></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><p style="display: flex; align-items: center" ng-repeat="establishment in $ctrl.current_service.establishments"><md-button class="btn btn-danger btn-sm" ng-click=$ctrl.showDisassignConfirm(establishment.location) ng-if=!service.isEditing><md-icon class=red>delete</md-icon></md-button><strong>{{ establishment.location.name }}:&nbsp;</strong><span>{{ establishment.location.address }}</span></p></div></md-dialog-content></md-dialog></div></div><!--UPDATE IMAGE MODAL--><div style="visibility: hidden"><div class=md-dialog-container id=changeImageDialog><md-dialog style="width: 440px;min-height: 200px"><md-toolbar><div class="md-toolbar-tools closeModals"><h2>Actualizar servicio</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><form name=$ctrl.newServiceForm><div class=md-dialog-content flex style="padding: 40px 49px 35px"><input class="editable-input input-img form-control input-sm" type=file name=promo ng-model=service.promo ng-change=$ctrl.updateImages(service.promo) maxsize=100 base-sixty-four-input accept=image/*></div></form></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.CANCEL\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl.saveUpdatedImage()>{{\'app.common.UPDATE\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG SHOW DETAIL BOOKITIT SERVICES ASIGNED--><div style="visibility: hidden"><div class=md-dialog-container id=dialog_bokitit_asigned_service><md-dialog style="border-radius: 15px" aria-label="Info bokitit service asigned custom dialog"><md-toolbar><div class=md-toolbar-tools><h1>{{\'app.administration.SERVICE\'|translate}}: {{ $ctrl.current_service.name }}</h1></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><p ng-repeat="service in $ctrl.bokititServicesArray" ng-if="$ctrl.bokititServicebyId.bokititServices.length &gt; 0"><md-button class="btn btn-danger btn-sm" ng-click=$ctrl._showDisassignBookititServiceDialog(service.id) ng-if=!service.isEditing><md-icon class=red>delete</md-icon></md-button><span>{{ service.name }}</span></p><h2 ng-if="$ctrl.bokititServicebyId.bokititServices.length === 0">Sin servicios asignados</h2></div></md-dialog-content></md-dialog></div></div></div>');
$templateCache.put('app/modules/admin/administration/support/support.html','<div class=support><div class=support__header></div><h1 class=support__title>Support</h1><div class=support__content><md-card class=rounded md-theme-watch="" style="min-height: 490px"><md-card-content style="width: 100%; display: flex; flex-direction: column; padding: 0px"><md-card-title><md-card-title-text><span class=md-headline>Preguntas frecuentes</span></md-card-title-text></md-card-title><md-card-content style="padding: 0px"><div class=accordion-container><div class=accordion-item><span class="accordion-header md-headline" style="font-size:19px; padding: 0px 10px 16px"><p>\xBFPuedo poner bookthecity en cualquier pantalla?</p><md-icon class=md-toggle-icon-s>expand_more</md-icon></span><div class=accordion-content style="padding: 5px 9px">S\xED, la pantalla de visualizaci\xF3n de turnos es responsive, por lo que se ajusta a cualquier dispositivo.</div></div><div class=accordion-item><span class="accordion-header md-headline" style="font-size:19px; padding: 0px 9px 16px"><p>\xBFC\xF3mo puedo descargarme el toolbar para solicitar turno?</p><md-icon class=md-toggle-icon-s>expand_more</md-icon></span><div class=accordion-content style="padding: 5px 9px">El toolbar est\xE1 disponible en la siguiente url bit.ly/bookthecitytoolbar</div></div><div class=accordion-item><span class="accordion-header md-headline" style="font-size:19px; padding: 0px 9px 16px"><p style="width: 90%">\xBFC\xF3mo puedo configurar el kiosco para que me muestr el qr del servicio?</p><md-icon class=md-toggle-icon-s>expand_more</md-icon></span><div class=accordion-content style="padding: 5px 9px">Dentro de la pantalla de administraci\xF3n, Kioscos, puedes ver un campo que se llama C\xF3digo QR. Edita ese kiosco para activar el QR.</div></div><div class=accordion-item><span class="accordion-header md-headline" style="font-size:19px; padding: 0px 9px 16px"><p>\xBFSe puede tener servicios de citas?</p><md-icon class=md-toggle-icon-s>expand_more</md-icon></span><div class=accordion-content style="padding: 5px 9px">BookTheCity puede tener tanto servicios de turnos como servicios de citas. Para los servicios de citas puedes gestionar las agendas internas o conectarlos con sistemas de citas, como bookitit, gsuite o office365.</div></div><div class=accordion-item><span class="accordion-header md-headline" style="font-size:19px; padding: 0px 9px 16px"><p>\xBFSe puede personalizar los kioscos?</p><md-icon class=md-toggle-icon-s>expand_more</md-icon></span><div class=accordion-content style="padding: 5px 9px">S\xED, se pueden personalizar indicando el fondo. Adem\xE1s, se puede poner un horario de apertura y cierre del mismo.</div></div></div></md-card-content></md-card-content></md-card><md-card class=rounded style="width: 100%; display: flex"><md-card-content style="width: 100%; display: flex; flex-direction: column"><md-card-title><md-card-title-text><span class=md-headline>Contacto</span></md-card-title-text></md-card-title><md-card-content><form class=formSupport name=contactForm ng-submit=$ctrl.sendContact(contactForm) role=form novalidate autocomplete=off style="width: 100%; display: flex; flex-direction: column"><md-input-container><label>Nombre</label><input ng-model=$ctrl.contact.name name=name type=text ng-required=true autocomplete=nope placeholder=Nombre><div ng-messages=contactForm.name.$error><div ng-message=required>El nombre es obligatorio</div></div></md-input-container><md-input-container><label>Email</label><input ng-model=$ctrl.contact.email name=email type=email ng-required=true autocomplete=nope placeholder=Email><div ng-messages=contactForm.email.$error><div ng-message=required>El email es obligatorio</div><div ng-message=email>El email no es v\xE1lido</div></div></md-input-container><md-input-container><label>Mensaje</label><textarea ng-model=$ctrl.contact.message name=message ng-required=true autocomplete=nope placeholder=Mensaje></textarea><div ng-messages=contactForm.message.$error><div ng-message=required>El mensaje es obligatorio</div></div></md-input-container><md-button class="md-button md-primary md-raised" type=submit ng-disabled=contactForm.$invalid>Enviar</md-button></form></md-card-content></md-card-content></md-card></div></div>');
$templateCache.put('app/modules/admin/administration/users/users.html','<div id=users-container><div class="users-container float-container" flex><div class=users-container-header><h1 class=main-pannel ng-if="$ctrl.currentRole == \'ROOT\' || $ctrl.currentRole == \'SUPERADMIN\'">{{\'app.administration.USERS\'|translate}} {{ $ctrl.establishmentInUse ? \' - \' + $ctrl.establishmentInUse : \'\' }}</h1><h1 class=main-pannel ng-if="$ctrl.currentRole != \'ROOT\' &amp;&amp; $ctrl.currentRole != \'SUPERADMIN\'">{{\'app.administration.USERS\'|translate}}</h1><div class="brn-group add_element"><div class=add_element><div class=selectOrganization style="margin-top: 5px" layout-gt-sm=row layout=column ng-hide="$ctrl.currentRole != \'ROOT\' || $ctrl.currentRole == \'SUPERADMIN\'"><md-autocomplete md-no-cache=true md-selected-item=$ctrl.organizationSelected md-search-text=$ctrl.searchTextOrganization md-selected-item-change=$ctrl.onOrganizationChange($ctrl.organizationSelected) md-items="organization in $ctrl.querySearchSelectOrganizations($ctrl.searchTextOrganization)" md-item-text=organization.name md-min-length=0 ng-disabled="!$ctrl.organizations || !$ctrl.organizations.length" placeholder="{{\'app.administration.SELECT_ORGANIZATION\'|translate}}"><md-item-template><span md-highlight-text=$ctrl.searchTextOrganization md-highlight-flags=^i>{{ organization.name }}</span></md-item-template><md-not-found>No se encontraron organizaciones.</md-not-found></md-autocomplete></div><div class=selectEstablishment layout-gt-sm=row layout=column ng-hide=!$ctrl.allowSelectRoles(3) style=margin-top:5px><md-autocomplete md-no-cache=true md-selected-item=$ctrl.establishmentSelected md-search-text=$ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(establishment) md-items="establishment in $ctrl.querySearchSelect($ctrl.searchText)" md-item-text=establishment.name md-min-length=0 ng-disabled="!$ctrl.organizations || !$ctrl.organizations.length" placeholder="{{\'app.statistics.SELECT_CENTER\'|translate}}"><md-item-template><span md-highlight-text=$ctrl.searchText md-highlight-flags=^i>{{ establishment.name }}</span></md-item-template><md-not-found>No se encontraron centros.</md-not-found></md-autocomplete></div></div><md-button class="md-raised md-primary" ng-click=$ctrl._showZoneForm() style="background-color:#ff914d; color:#ffffff"><span>+ {{\'app.users.NEW_USER\'|translate}}</span></md-button></div></div><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParams disable-filter=$ctrl.isAdding demo-tracked-table=$ctrl.tableTracker><tr ng-repeat="user in $ctrl.tableParams.data" ng-form=rowForm demo-tracked-table-row=row><td class="has_dialog has_name" ng-attr-title="{{\'app.users.FIRSTNAME\'|translate}}" title="\'app.users.FIRSTNAME\'|translate" filter="{ firstname: \'text\' }" ng-switch=user.isEditing ng-class="firstname.$dirty ? \'bg-warning\' : \'\'" ng-form=firstname demo-tracked-table-cell ng-click=$ctrl._detailUser(user)><span class="editable-text has_name" ng-switch-default>{{user.firstname}}</span><div class=controls ng-class="firstname.$invalid &amp;&amp; firstname.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-name form-control input-sm" type=text name=firstname id=firstname ng-model=user.firstname required ng-change="$ctrl._validateInputs(user.firstname, \'firstname\', rowForm)"><p style=display:none id=err_firstname></p></div></td><td class="has_dialog has_name" ng-attr-title="{{\'app.users.LASTNAME\'|translate}}" title="\'app.users.LASTNAME\'|translate" filter="{ lastname: \'text\'}" ng-switch=user.isEditing ng-class="lastname.$dirty ? \'bg-warning\' : \'\'" ng-form=lastname demo-tracked-table-cell ng-click=$ctrl._detailUser(user)><span class=editable-text ng-switch-default>{{user.lastname}}</span><div class=controls ng-class="lastname.$invalid &amp;&amp; lastname.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-lastname form-control input-sm" type=text name=lastname id=lastname ng-model=user.lastname required ng-change="$ctrl._validateInputs(user.lastname, \'lastname\', rowForm)"><p id=err_lastname style="display:none;color:#db4849;margin:0 0 0 2px;font-size:12px">{{\'app.users.ERROR_LASTNAME_SPACES\'|translate}}</p></div></td><td class=has_dialog ng-attr-title="{{\'app.users.USERNAME\'|translate}}" title="\'app.users.USERNAME\'|translate" filter="{ username: \'text\' }" ng-switch=user.isEditing ng-class="username.$dirty ? \'bg-warning\' : \'\'" ng-form=username demo-tracked-table-cell ng-click=$ctrl._detailUser(user)><span class="editable-text has_user" ng-switch-default>{{user.username}}</span><div class=controls ng-class="username.$invalid &amp;&amp; username.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input input-name form-control input-sm" type=text name=username id=username ng-model=user.username required ng-change="$ctrl._validateInputs(user.username, \'username\', rowForm)"><p style=display:none id=err_username></p></div></td><td class="has_dialog has_email" ng-attr-title="{{\'app.users.USEREMAIL\'|translate}}" title="\'app.users.USEREMAIL\'|translate" filter="{ email: \'text\' }" ng-switch=user.isEditing ng-class="email.$dirty ? \'bg-warning\' : \'\'" ng-form=email demo-tracked-table-cell ng-click=$ctrl._detailUser(user)><span class="editable-text has_email" ng-switch-default>{{user.email}}</span><div class=controls ng-class="email.$invalid &amp;&amp; email.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input input-email form-control input-sm" type=text name=email id=email ng-model=user.email required ng-change="$ctrl._validateInputs(user.email, \'email\', rowForm)"><p style=display:none id=err_email></p></div></td><td class=has_dialog ng-attr-title="{{\'app.users.ROLE\'|translate}}" title="\'app.users.ROLE\'|translate" filter="{ role: \'text\' }" ng-switch=user.isEditing ng-class="role.$dirty ? \'bg-warning\' : \'\'" ng-form=role demo-tracked-table-cell ng-click=$ctrl._detailUser(user)><span class=editable-text ng-switch-default>{{ \'app.users.ROLE_\' + user.role + \' \'|translate }}</span><div class=controls ng-class="role.$invalid &amp;&amp; role.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=role ng-model=user.role required><md-option ng-if=$ctrl.allowSelectRoles(2) value=SUPERADMIN ng-selected="user.role == \'SUPERADMIN\'">{{\'app.users.ROLE_SUPERADMIN\'|translate}}</md-option><md-option ng-if=$ctrl.allowSelectRoles(3) value=ADMIN ng-selected="user.role == \'ADMIN\'">{{\'app.users.ROLE_ADMIN\'|translate}}</md-option><md-option ng-if=$ctrl.allowSelectRoles(4) value=WORKER ng-selected="user.role == \'WORKER\'">{{\'app.users.ROLE_WORKER\'|translate}}</md-option><md-option ng-if=$ctrl.allowSelectRoles(2) value=KIOSK ng-selected="user.role == \'KIOSK\'">{{\'app.users.ROLE_KIOSK\'|translate}}</md-option><md-option ng-if=$ctrl.allowSelectRoles(2) value=SCREEN ng-selected="user.role == \'SCREEN\'">{{\'app.users.ROLE_SCREEN\'|translate}}</md-option><md-option ng-if=$ctrl.allowSelectRoles(2) value=DEVICE ng-selected="user.role == \'DEVICE\'">{{\'app.users.ROLE_DEVICE\'|translate}}</md-option><md-option ng-if=$ctrl.allowSelectRoles(2) value=STATISTICS ng-selected="user.role == \'STATISTICS\'">{{\'app.users.ROLE_STATISTICS\'|translate}}</md-option><md-option ng-if=$ctrl.allowSelectRoles(2) value=KIOSK_ONLINE ng-selected="user.role == \'KIOSK_ONLINE\'">{{\'app.users.ROLE_KIOSK_ONLINE\'|translate}}</md-option><md-option ng-if=$ctrl.allowSelectRoles(2) value=KIOSK_WIDGET ng-selected="user.role == \'KIOSK_WIDGET\'">{{\'app.users.ROLE_KIOSK_WIDGET\'|translate}}</md-option></md-select></div></td><td class=has_dialog ng-attr-title="{{\'app.administration.LANGUAGE\'|translate}}" title="\'app.administration.LANGUAGE\'|translate" filter="{ language: \'text\' }" ng-switch=user.isEditing ng-class="language.$dirty ? \'bg-warning\' : \'\'" ng-form=language demo-tracked-table-cell ng-click=$ctrl._detailUser(user)><span class=editable-text ng-switch-default>{{ \'app.administration.\' + user.language + \' \'|translate }}</span><div class=controls ng-class="language.$invalid &amp;&amp; language.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=language name=language ng-model=user.language required><md-option value=ES selected>{{\'app.administration.ES\'|translate}}</md-option><md-option value=EN>{{\'app.administration.EN\'|translate}}</md-option></md-select></div></td><td class=has_dialog ng-attr-title="{{\'app.administration.STATUS\'|translate}}" title="\'app.administration.STATUS\'|translate" filter="{ status: \'text\' }" ng-switch=user.isEditing ng-class="user.$dirty ? \'bg-warning\' : \'\'" ng-form=status demo-tracked-table-cell ng-click=$ctrl._detailUser(user)><span class="editable-text active" ng-switch-default ng-if="user.status == \'true\' || user.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span><span class="editable-text inactive" ng-switch-default ng-if="user.status == \'false\' || user.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span><div class=controls ng-class="status.$invalid &amp;&amp; status.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><md-select id=status name=status ng-model=user.status required><md-option value=true ng-selected="user.status == \'true\' || user.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false ng-selected="user.status == \'false\' || user.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></div></td><td class="has_dialog has_password" ng-attr-title="{{\'app.users.PASSWORD\'|translate}}" ng-switch=user.isEditing ng-class="password.$dirty ? \'bg-warning\' : \'\'" ng-form=password demo-tracked-table-cell><md-button class="btn btn-primary btn-sm restore-pass" ng-click=$ctrl.resetPassword(user) ng-if=!user.isEditing><md-icon class=orange>lock_reset</md-icon></md-button></td><td class="button-box align-center has_options"><md-button class="optionsbtn btn btn-default btn-sm" ng-click=$ctrl._editOptionsButton(user.id) ng-if=!user.isEditing><md-icon>more_horiz</md-icon></md-button><div class=activate-option id={{user.id}} style="right:25px; display:none"><md-button class="button-activate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl._showZoneForm(user) ng-if=!user.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">edit_not</md-icon><span class=span-activate-option style="padding: 4px 4px 4px">{{\'app.organizations.EDIT\'|translate}}</span></md-button><md-button class="button-deactivate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl.showDeleteConfirm(user) ng-if=!user.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">delete</md-icon><span class=span-desactivate-option style="padding: 4px 4px 4px">{{\'app.organizations.DELETE\'|translate}}</span></md-button></div><md-button class="btn btn-primary btn-sm" ng-click="$ctrl.save(user, rowForm)" ng-if=user.isEditing ng-disabled="rowForm.$pristine || $ctrl.formErrors.length &gt; 0"><md-icon class=green>save</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click="$ctrl.cancel(user, rowForm)" ng-if=user.isEditing><md-icon class=red>cancel</md-icon></md-button></td></tr><tr ng-if=$ctrl.noData><td colspan=10><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if=!$ctrl.noData><td class=paginator-items colspan=10><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=10 ng-init="pageSize = 10"></select></div></td></tr></table></div><!-- DIALOG NEW USER--><div style="visibility: hidden"><div class=md-dialog-container id=myDialog><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2 ng-if="$ctrl.editUsr == false">{{\'app.users.NEW_USER\'|translate}}</h2><h2 ng-if=$ctrl.editUsr>{{\'app.users.EDIT_USER\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><form name=$ctrl.userForm style=width:100%><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.users.USERNAME\'|translate}}</label><input class="md-input no-spin" type=text id=username name=username ng-model=$ctrl.new_user.username autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_user.username, \'username\', $ctrl.userForm)" ng-keypress=$ctrl.preventSpaces($event)></md-input-container><p style=display:none id=err_username>Ingresa un usuario v\xE1lido</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.users.FIRSTNAME\'|translate}}</label><input class="md-input no-spin" type=text id=firstname name=firstname ng-model=$ctrl.new_user.firstname autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_user.firstname, \'firstname\', $ctrl.userForm)" ng-keypress=$ctrl.preventSpaces($event)></md-input-container><p id=err_firstname style="display:none;color:#db4849;margin:0 0 0 2px;font-size:12px">{{\'app.users.ERROR_FIRSTNAME_SPACES\'|translate}}</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.users.LASTNAME\'|translate}}</label><input class="md-input no-spin" type=text id=lastname name=lastname ng-model=$ctrl.new_user.lastname autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_user.lastname, \'lastname\', $ctrl.userForm)" ng-keypress=$ctrl.preventSpaces($event)></md-input-container><p id=err_lastname style="display:none;color:#db4849;margin:0 0 0 2px;font-size:12px">{{\'app.users.ERROR_LASTNAME_SPACES\'|translate}}</p></div><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.users.USEREMAIL\'|translate}}</label><input class="md-input no-spin" type=text id=email name=email ng-model=$ctrl.new_user.email autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_user.email, \'email\', $ctrl.userForm)"></md-input-container><p style=display:none id=err_email>Ingresa un correo electr\xF3nico v\xE1lido</p></div><div style=width:100% ng-if="$ctrl.editUsr == false"><md-input-container class=two_columns md-no-float><label>{{\'app.users.PASSWORD\'|translate}}</label><input class="md-input no-spin" type="{{ $ctrl.show ? \'text\' : \'password\' }}" id=password name=password ng-model=$ctrl.new_user.password autocomplete=new-password required ng-change="$ctrl._validateInputs($ctrl.new_user.password, \'password\', $ctrl.userForm)"><md-button ng-click=$ctrl._showPass() style="position: absolute; right: -6px!important"><md-icon>remove_red_eye</md-icon></md-button></md-input-container><p style=display:none id=err_password>Ingresa una contrase\xF1a v\xE1lida</p><p style=display:none id=err_password2>Ingresa al menos una may\xFAscula, un n\xFAmero y un caracter especial</p></div><md-input-container class=two_columns md-no-float><label>{{\'app.users.ROLE\'|translate}}</label><md-select id=status name=role ng-model=$ctrl.new_user.role autocomplete=off required><md-option ng-if=$ctrl.allowSelectRoles(role.role_option) value="{{ role.value }}" ng-selected="new_user.role == role.value" ng-repeat="role in $ctrl.roles">{{\'app.users.\' + role.name | translate}}</md-option></md-select></md-input-container><md-input-container class=two_columns md-no-float><label>{{\'app.administration.LANGUAGE\'|translate}}</label><md-select id=language name=language ng-model=$ctrl.new_user.language required><md-option value=ES>{{\'app.administration.ES\'|translate}}</md-option><md-option value=EN>{{\'app.administration.EN\'|translate}}</md-option></md-select></md-input-container><md-input-container class=two_columns ng-if=$ctrl.allowSelectRoles(2) md-no-float><label>{{\'app.administration.ORGANIZATION\'|translate}}</label><md-select id=center name=center ng-model=$ctrl.new_user.organizationId required ng-change=$ctrl.getEstablismentByOrganization($ctrl.new_user.organizationId)><md-option value="{{ organization.id }}" ng-repeat="organization in $ctrl.organizations">{{ organization.name }}</md-option></md-select></md-input-container><md-input-container ng-if="$ctrl.allowSelectRoles(4) &amp;&amp; ($ctrl.new_user.organizationId || ($ctrl.currentOrganizationId &amp;&amp; $ctrl.currentRole != \'ROOT\'))" ng-class="{two_columns: $ctrl.currentRole == \'ROOT\'}" md-no-float><label>{{\'app.administration.CENTER_ASSIGNED_MAIN\'|translate}}</label><md-select id=center name=center ng-model=$ctrl.new_user.locationId required ng-change=$ctrl.handleMainCenterChange()><md-option value="{{ establishment.id }}" ng-repeat="establishment in $ctrl.establishments" ng-disabled="! $ctrl.allowed_location_ids.includes(establishment.id)">{{ establishment.name }}</md-option></md-select></md-input-container><md-input-container ng-if="$ctrl.allowSelectRoles(4) &amp;&amp; ($ctrl.new_user.organizationId || ($ctrl.currentOrganizationId &amp;&amp; $ctrl.currentRole != \'ROOT\'))" ng-class="{two_columns: $ctrl.currentRole == \'ROOT\'}" md-no-float><label>{{\'app.administration.CENTER_ASSIGNED_OTHERS\'|translate}}</label><md-select id=center name=center ng-model=$ctrl.new_user.secondaryLocations ng-disabled="!$ctrl.new_user.locationId || ($ctrl.establishments.length &lt;= 1)" multiple><md-option ng-value=establishment.id ng-repeat="establishment in $ctrl.establishments" ng-if="establishment.id !== $ctrl.new_user.locationId" ng-disabled="! $ctrl.allowed_location_ids.includes(establishment.id)">{{ establishment.name }}</md-option></md-select></md-input-container><md-input-container md-no-float><label>{{\'app.administration.STATUS\'|translate}}</label><md-select id=status name=status ng-model=$ctrl.new_user.status autocomplete=off required><md-option value=true>{{\'app.administration.STATUS_ENABLED\'|translate}}</md-option><md-option value=false>{{\'app.administration.STATUS_DISABLED\'|translate}}</md-option></md-select></md-input-container></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._sendUser($ctrl.new_user) ng-disabled=userForm.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG SHOW DETAIL--><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=dialog_detail_user><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ $ctrl.current_user.firstname }} {{ $ctrl.current_user.lastname }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><div><label><strong>{{\'app.users.FIRSTNAME\'|translate}}:</strong></label><p>{{ $ctrl.current_user.firstname }}</p></div><div><label><strong>{{\'app.users.LASTNAME\'|translate}}:</strong></label><p>{{ $ctrl.current_user.lastname }}</p></div><div><label><strong>{{\'app.users.USERNAME\'|translate}}:</strong></label><p>{{ $ctrl.current_user.username }}</p></div><div><label><strong>{{\'app.users.USEREMAIL\'|translate}}:</strong></label><p>{{ $ctrl.current_user.email }}</p></div><div><label><strong>{{\'app.users.ROLE\'|translate}}:</strong></label><p>{{ \'app.users.ROLE_\' + $ctrl.current_user.role + \' \'|translate }}</p></div><div><label><strong>{{\'app.administration.CENTER_ASSIGNED_MAIN\'|translate}}:</strong></label><p>{{ ($ctrl.establishments | filter:{ id: $ctrl.current_user.locationId })[0].name }}</p></div><div ng-if="$ctrl.current_user.secondaryLocations &amp;&amp; $ctrl.current_user.secondaryLocations.length &gt; 0"><label><strong>{{ \'app.administration.CENTER_ASSIGNED_OTHERS\' | translate }}:</strong></label><ul><li ng-repeat="loc in $ctrl.current_user.secondaryLocations">{{ loc.name }}</li></ul></div><div><label><strong>{{\'app.administration.LANGUAGE\'|translate}}:</strong></label><p>{{ \'app.administration.\' + $ctrl.current_user.language + \' \'|translate }}</p></div><div><label><strong>{{\'app.administration.STATUS\'|translate}}:</strong></label><div style="width:65px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #50B566"><md-icon class="icon-status active" ng-if="$ctrl.current_user.status == \'true\' || $ctrl.current_user.status == true">fiber_manual_record</md-icon><span class="editable-text-span active" ng-if="$ctrl.current_user.status == \'true\' || $ctrl.current_user.status == true">{{\'app.administration.STATUS_ENABLED\'|translate}}</span></div><div style="width:85px;display: flex; justify-content: center; align-items:center;border-radius: 20px; background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #DB4849"><md-icon class="icon-status inactive" ng-if="$ctrl.current_user.status == \'false\' || $ctrl.current_user.status == false">fiber_manual_record</md-icon><span class="editable-text-span inactive" ng-if="$ctrl.current_user.status == \'false\' || $ctrl.current_user.status == false">{{\'app.administration.STATUS_DISABLED\'|translate}}</span></div></div></div></md-dialog-content></md-dialog></div></div><!-- DIALOG RESET PASSWORD--><div style="visibility: hidden"><div class=md-dialog-container id=resetPassDialog><md-dialog style=width:100%><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.users.RESET_PASS\'|translate}}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex style=width:100%><form name=$ctrl.userResetPass style=width:100%><div style=width:100%><md-input-container class=two_columns md-no-float style=width:100%><label>{{\'app.users.PASSWORD\'|translate}}</label><input class="md-input no-spin" type="{{ $ctrl.show1 ? \'text\' : \'password\' }}" ng-model=$ctrl.userResetPass.rePassword autocomplete=new-password required ng-change="$ctrl._validatePass($ctrl.userResetPass.rePassword, \'rePassword\', $ctrl.userResetPass)"><md-button ng-click="$ctrl._showPass(\'show1\')" style="position: absolute; right: -6px!important"><md-icon>remove_red_eye</md-icon></md-button></md-input-container><p ng-if=$ctrl.errPass style=color:red>Ingresa al menos una may\xFAscula, un n\xFAmero y un caracter especial</p></div><div style=width:100%><md-input-container class=two_columns md-no-float style=width:100%><label>{{\'app.users.CONF_PASSWORD\'|translate}}</label><input class="md-input no-spin" type="{{ $ctrl.show2 ? \'text\' : \'password\' }}" ng-model=$ctrl.userResetPass.confirmPassword autocomplete=new-password required ng-change="$ctrl._validatePass($ctrl.userResetPass.confirmPassword, \'confirmPassword\', $ctrl.userResetPass)"><md-button ng-click="$ctrl._showPass(\'show2\')" style="position: absolute; right: -6px!important"><md-icon>remove_red_eye</md-icon></md-button></md-input-container><p ng-if=$ctrl.confirmPassword style=color:red>{{\'app.users.PASSWORD_NOT_MATCH\'|translate}}</p></div></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl.sendResetPass() ng-disabled=userForm.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div></div>');
$templateCache.put('app/modules/admin/administration/validateUsers/users.html','<div id=users-container><div class="users-container float-container" flex><div class=users-container-header><h1 class=main-pannel ng-if="$ctrl.currentRole == \'ROOT\' || $ctrl.currentRole == \'SUPERADMIN\'">{{\'app.administration.USERS\'|translate}} {{ $ctrl.establishmentInUse ? \' - \' + $ctrl.establishmentInUse : \'\' }}</h1><h1 class=main-pannel ng-if="$ctrl.currentRole != \'ROOT\'">{{\'app.administration.USERS\'|translate}}</h1><div class="brn-group add_element"><md-button class="md-raised md-primary" ng-click=$ctrl.showVerifyConfirm() style="background-color:#ff914d; color:#ffffff"><span>{{\'app.users.VERIFY_USER\'|translate}}</span></md-button></div></div><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParams demo-tracked-table=$ctrl.tableTracker><tr ng-repeat="user in $data" ng-form=rowForm demo-tracked-table-row=row ng-hide="(user.role == \'ROOT\' || user.role == \'SCREEN\' || user.role == \'KIOSK\' || user.role == \'DEVICE\' || user.id == $ctrl.currentId || $ctrl.allowShowRoles(user.role) == false) &amp;&amp; $ctrl.currentRole != \'ROOT\'"><td class="has_dialog has_name" ng-attr-title="{{\'app.users.CENTER\'|translate}}" title="\'app.users.CENTER\'|translate" ng-class="location.name.$dirty ? \'bg-warning\' : \'\'" ng-form=loc demo-tracked-table-cell><span class="editable-text has_name">{{user.location.name}}</span></td><td class="has_dialog has_name" ng-attr-title="{{\'app.users.FIRSTNAME\'|translate}}" title="\'app.users.FIRSTNAME\'|translate" ng-class="firstname.$dirty ? \'bg-warning\' : \'\'" ng-form=firstname demo-tracked-table-cell><span class="editable-text has_name">{{user.firstname}}</span></td><td class="has_dialog has_name" ng-attr-title="{{\'app.users.LASTNAME\'|translate}}" title="\'app.users.LASTNAME\'|translate" ng-class="lastname.$dirty ? \'bg-warning\' : \'\'" ng-form=lastname demo-tracked-table-cell><span class=editable-text>{{user.lastname}}</span></td><td class=has_dialog ng-attr-title="{{\'app.users.USERNAME\'|translate}}" title="\'app.users.USERNAME\'|translate" ng-class="username.$dirty ? \'bg-warning\' : \'\'" ng-form=username demo-tracked-table-cell><span class="editable-text has_user">{{user.username}}</span></td><td class="has_dialog has_email" ng-attr-title="{{\'app.users.USEREMAIL\'|translate}}" title="\'app.users.USEREMAIL\'|translate" ng-class="email.$dirty ? \'bg-warning\' : \'\'" ng-form=email demo-tracked-table-cell><span class="editable-text has_email">{{user.email}}</span></td></tr><tr ng-if=$ctrl.noData><td colspan=10><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if=!$ctrl.noData><td class=paginator-items colspan=10><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=5 ng-init="pageSize = 5"></select></div></td></tr></table></div></div>');
$templateCache.put('app/modules/admin/administration/waitingareas/waitingareas.html','<div id=users-container><div class="services-container float-container"><div class=users-container-header><h1 class=main-pannel ng-if="$ctrl.isRoot || $ctrl.isSuperAdmin">{{\'app.administration.WAITING_AREA\'|translate}} {{ $ctrl.establishmentInUse ? \' - \' + $ctrl.establishmentInUse : \'\' }}</h1><h1 class=main-pannel ng-if="!($ctrl.isRoot || $ctrl.isSuperAdmin)">{{\'app.administration.WAITING_AREA\'|translate}}</h1><div class="brn-group add_element"><div class=add_element><div class=selectOrganization style="margin-top: 5px" layout-gt-sm=row layout=column ng-hide=!($ctrl.isRoot)><md-autocomplete md-no-cache=true md-selected-item=$ctrl.organizationSelected md-search-text=$ctrl.searchTextOrganization md-selected-item-change=$ctrl.getEstablismentByOrganization(organization.id) md-items="organization in $ctrl.querySearchSelectOrganizations($ctrl.searchTextOrganization)" md-item-text=organization.name md-min-length=0 placeholder="{{\'app.administration.SELECT_ORGANIZATION\'|translate}}"><md-item-template><span md-highlight-text=$ctrl.searchTextOrganization md-highlight-flags=^i>{{ organization.name }}</span></md-item-template><md-not-found>No se encontraron organizaciones.</md-not-found></md-autocomplete></div><div class=selectEstablishment layout-gt-sm=row layout=column ng-hide=$ctrl.isAdmin style=margin-top:5px><md-autocomplete md-no-cache=true md-selected-item=$ctrl.establishmentSelected md-search-text=$ctrl.searchText md-selected-item-change=$ctrl.selectedItemChange(establishment) md-items="establishment in $ctrl.querySearchSelect($ctrl.searchText)" md-item-text=establishment.name md-min-length=0 placeholder="{{\'app.statistics.SELECT_CENTER\'|translate}}"><md-item-template><span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{ establishment.name }}</span></md-item-template><md-not-found>No se encontraron centros.</md-not-found></md-autocomplete></div></div><md-button class="md-raised md-primary" ng-click=$ctrl._showWaitingareaForm() style="background-color:#ff914d; color:#ffffff; align: right"><span>+ {{\'app.waiting_areas.NEW_WAITING_AREA\'|translate}}</span><!--md-button(class="md-raised md-primary" ng-click="$ctrl._asignDialog()" ng-disabled="$ctrl.fail || !$ctrl.hasPlacesSelected")\n          span {{\'app.services.ASIGN_SERVICE\'|translate}}\n          \n          --></md-button></div></div><table class="table table-bordered table-hover table-condensed editable-table" ng-table=$ctrl.tableParams disable-filter=$ctrl.isAdding demo-tracked-table=$ctrl.tableTracker><tr ng-repeat="waiting_area in $data" ng-form=rowForm demo-tracked-table-row=row><td class=has_dialog ng-attr-title="{{\'app.waiting_areas.NAME\'|translate}}" title="\'app.waiting_areas.NAME\'|translate" filter="{ name: \'text\'}" sortable ng-switch=waiting_area.isEditing ng-class="name.$dirty ? \'bg-warning\' : \'\'" ng-form=name demo-tracked-table-cell><div flex layout=row layout-align="start center"><input class="selectCheck has_dialog" type=checkbox ng-model=waiting_area.Selected ng-click=$ctrl._selectPlace(waiting_area) ng-if=!waiting_area.isEditing><span class=editable-text style=margin-left:4px ng-switch-default>{{waiting_area.name}}</span><div class=controls ng-class="name.$invalid &amp;&amp; name.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text id=name name=name ng-model=waiting_area.name required ng-change="$ctrl._validateInputs(waiting_area.name, \'name\', rowForm)"><p style=display:none id=err_name>Ingrese el nombre un nombre v\xE1lido</p></div></div></td><td class=has_dialog ng-attr-title="{{\'app.waiting_areas.PLACE\'|translate}}" title="\'app.waiting_areas.PLACE\'|translate" filter="{ place: \'text\'}" sortable ng-switch=waiting_area.isEditing ng-class="place.$dirty ? \'bg-warning\' : \'\'" ng-form=place demo-tracked-table-cell ng-click=$ctrl._detailWaitingarea(waiting_area)><span class=editable-text ng-switch-default>{{waiting_area.place}}</span><div class=controls ng-class="place.$invalid &amp;&amp; place.$dirty ? \'has-error\' : \'\'" ng-switch-when=true><input class="editable-input form-control input-sm" type=text id=place name=place ng-model=waiting_area.place required ng-change="$ctrl._validateInputs(waiting_area.place, \'place\', rowForm)"><p style=display:none id=err_place>Ingrese el lugar un lugar v\xE1lido</p></div></td><!--td.has_dialog(title="\'app.waiting_areas.ASIGNED\'|translate" filter="{ asigned: \'text\'}" sortable="\'asigned\'" ng-switch="waiting_area.isEditing" ng-class="waiting_area.$dirty ? \'bg-warning\' : \'\'" ng-form="asigned" demo-tracked-table-cell ng-click="$ctrl._detailWaitingarea(waiting_area)")\n        span.editable-text(ng-switch-default ng-class="{\'active\' : waiting_area.asigned == \'ASIGNED_ENABLED\', \'inactive\' : waiting_area.asigned == \'ASIGNED_DISABLED\' }") {{ \'app.waiting_areas.\' + waiting_area.asigned + \' \'|translate }}\n        div.controls(ng-class="asigned.$invalid && asigned.$dirty ? \'has-error\' : \'\'" ng-switch-when="true")\n        \tmd-select#status(name="asigned" ng-model="waiting_area.asigned" required)\n        \t\tmd-option(value="ASIGNED_ENABLED" ng-selected="waiting_area.asigned == \'ASIGNED_ENABLED\'") {{\'app.waiting_areas.ASIGNED_ENABLED\'|translate}}\n        \t\tmd-option(value="ASIGNED_DISABLED" ng-selected="waiting_area.asigned == \'ASIGNED_DISABLED\'") {{\'app.waiting_areas.ASIGNED_DISABLED\'|translate}}\n        \n        \n        --><td class="button-box align-center has_options"><md-button class="optionsbtn btn btn-default btn-sm" style="border-radius: 6px" ng-click=$ctrl._editOptionsButton(waiting_area.id) ng-if=!waiting_area.isEditing><md-icon>more_horiz</md-icon></md-button><div class=activate-option id={{waiting_area.id}} style="right:25px; display:none"><md-button class="button-activate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl._showWaitingareaForm(waiting_area) ng-if=!waiting_area.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">edit_not</md-icon><span class=span-activate-option style="padding: 4px 4px 4px">{{\'app.organizations.EDIT\'|translate}}</span></md-button><md-button class="button-deactivate-option btn-default" style="width:104px; opacity: 1;margin:0px;height:44px !important" ng-click=$ctrl.showDeleteConfirm(waiting_area) ng-if=!waiting_area.isEditing><md-icon class=orange style="font-size:12px; line-height:8px;min-width:12px;min-height:12px;width:12px;height:12px">delete</md-icon><span class=span-desactivate-option style="padding: 4px 4px 4px">{{\'app.organizations.DELETE\'|translate}}</span></md-button></div><md-button class="btn btn-primary btn-sm" ng-click=$ctrl.save(waiting_area) ng-if=waiting_area.isEditing ng-disabled=rowForm.$pristine><md-icon class=green>save</md-icon></md-button><md-button class="btn btn-default btn-sm" ng-click=$ctrl.cancel(waiting_area) ng-if=waiting_area.isEditing><md-icon class=red>cancel</md-icon></md-button></td></tr><tr ng-if=$ctrl.noData><td colspan=12><div flex layout=row layout-align=center><p class=noData>{{\'app.NO_DATA\'|translate}}</p></div></td></tr><tr class=paginator ng-if=!$ctrl.noData><td class=paginator-items colspan=12><div class=paginator-content flex layout=row layout-align="end center"><span class=span-text>{{\'app.common.PAGINATOR\'|translate}}</span><select class=select-page name=recordsPerPage ng-model=pageSize ng-options="page for page in $ctrl.pageSizeOptions" ng-change=$ctrl.pageSizeChanged(pageSize) placeholder=10 ng-init="pageSize = 10"></select></div></td></tr></table></div><!-- DIALOG NEW AREA--><div style="visibility: hidden" aria-label="New waiting_area custom dialog"><div class=md-dialog-container id=myDialog><md-dialog style="width: 430px"><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{\'app.waiting_areas.NEW_WAITING_AREA\'|translate}} - {{ $ctrl.currentEstablishment.name }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><form name=$ctrl.waitingareaForm style="grid-template-columns: repeat(1, 1fr); width: 100%"><div style=width:100%><md-input-container class=two_columns md-no-float><label>{{\'app.waiting_areas.NAME\'|translate}}</label><input class="md-input no-spin" type=text id=name name=name ng-model=$ctrl.new_waitingarea.name autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_waitingarea.name, \'name\', $ctrl.waitingareaForm)"></md-input-container><p style=display:none id=err_name>Ingrese el nombre un nombre v\xE1lido</p></div><div style=width:100%><md-input-container md-no-float style=width:100%><label>{{\'app.waiting_areas.PLACE\'|translate}}</label><input class="md-input no-spin" type=text id=place name=place ng-model=$ctrl.new_waitingarea.place autocomplete=off required ng-change="$ctrl._validateInputs($ctrl.new_waitingarea.place, \'place\', $ctrl.waitingareaForm)"></md-input-container><p style=display:none id=err_place>Ingrese el lugar un lugar v\xE1lido</p></div></form></div></md-dialog-content><md-dialog-actions flex layout=row><md-button class="md-raised md-warn" ng-click=$ctrl._closeDialog()>{{\'app.common.EXIT\'|translate}}</md-button><md-button class="md-raised md-primary" ng-click=$ctrl._sendWaitingarea($ctrl.new_waitingarea) ng-disabled=waitingareaForm.$invalid>{{\'app.common.ACCEPT\'|translate}}</md-button></md-dialog-actions></md-dialog></div></div><!-- DIALOG SHOW DETAIL--><div style="visibility: hidden" aria-label="Info custom dialog"><div class=md-dialog-container id=dialog_detail_waitingarea><md-dialog><md-toolbar><div class="md-toolbar-tools closeModals"><h2>{{ $ctrl.current_waitingarea.name }}</h2><md-button class=closeButton ng-click=$ctrl._closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><div><label><strong>{{\'app.waiting_areas.NAME\'|translate}}:</strong></label><p>{{ $ctrl.current_waitingarea.name }}</p></div><div><label><strong>{{\'app.waiting_areas.PLACE\'|translate}}:</strong></label><p>{{ $ctrl.current_waitingarea.place }}</p></div><div><label><strong>{{ \'app.services.ASIGNED\'|translate }}:</strong></label><p class=has_dialog ng-if="$ctrl.current_waitingarea.asigned == true || $ctrl.current_waitingarea.asigned == \'true\'" style=color:limegreen ng-click=$ctrl._detailAsignedWaitingarea($ctrl.current_waitingarea)>{{ \'app.waiting_areas.ASIGNED_ENABLED\'|translate }}<span style=color:#777>{{ \'app.administration.CLICK_TO_SEE\'|translate }}</span></p><p ng-if="$ctrl.current_waitingarea.asigned == false || $ctrl.current_waitingarea.asigned == \'false\'" style=color:red>{{ \'app.waiting_areas.ASIGNED_DISABLED\'|translate }}</p></div></div></md-dialog-content></md-dialog></div></div><!-- DIALOG SHOW DETAIL PLACED ASIGNED--><div style="visibility: hidden" aria-label="Info place asigned custom dialog"><div class=md-dialog-container id=dialog_detail_asigned_waitingarea><md-dialog><md-toolbar><div class=md-toolbar-tools><h1>{{\'app.administration.WAITING_AREAS\'|translate}}: {{ $ctrl.current_waitingarea.name }}</h1></div></md-toolbar><md-dialog-content><div class=md-dialog-content flex><h3>{{\'app.administration.CONSUMERS\'|translate}}:</h3><p ng-repeat="workstation in $ctrl.current_waitingarea.workstations"><strong>{{ workstation.name }}:</strong><span>{{ workstation.place }}</span></p></div></md-dialog-content></md-dialog></div></div></div>');
$templateCache.put('app/modules/admin/statistics/center/center.html','<div id=statistics-container><div class=selectors ng-if="$ctrl.currentRole == \'ROOT\' || $ctrl.currentRole == \'SUPERADMIN\' || $ctrl.currentRole == \'STATISTICS\'"><h2>{{\'app.statistics.SELECT_CENTER\'|translate}}</h2><div class=selectEstablishment><form name=selectEstablishmentForm><md-input-container md-no-float style="border: none;margin: 0;padding: 2px 10px 2px 10px;background: #FFFFFF;border: 1px solid #D9D9D9;border-radius: 6px;width: 320px !important;height: 38px; font-size: 16px"><md-select id=center name=center ng-model=$ctrl.establishmentSelected ng-change=$ctrl.establishmentChanged()><md-option value="{{ establishment }}" ng-repeat="establishment in $ctrl.establishments">{{ establishment.name }} {{ establishment.addressFirstLine }}</md-option></md-select></md-input-container></form></div></div><div class=selectDateRange><div><label>{{\'app.statistics.START_DATE\'|translate}}</label><md-datepicker ng-model=$ctrl.fromDate ng-change=$ctrl.updateDateRange() ng-model-options=$ctrl.datePickerModelOptions></md-datepicker></div><div><label>{{\'app.statistics.END_DATE\'|translate}}</label><md-datepicker ng-model=$ctrl.toDate name=dateField md-max-date=$ctrl.rangeMaxDate md-min-date=$ctrl.fromDate></md-datepicker><md-button class="md-fab search" aria-label="Search data" ng-click=$ctrl.search() ng-disabled=$ctrl.isLoading><md-icon>refresh</md-icon></md-button></div><div class=downloadBox><a class=download download="{{ $ctrl.establishmentInUse }}.xls" href=# onclick="return ngTableExcelExport.excel(this, \'datatableXLX\', \'Sheet Name Here\');" ng-class="{\'disabled\': $ctrl.isLoading}">Download data</a></div></div><div layout-gt-sm=row layout=row layout-wrap ng-hide=!$ctrl.establishmentId><div class=statistics-turns flex=100><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.TURNS\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.attending_time.activated></md-progress-circular></div><div class=turnsSupervisor layout=row layout-align=space-around><md-card><md-card-title><md-card-title-text><p class=md-headline>{{\'app.statistics.TURNS\'|translate}}</p></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-headline>{{$ctrl.allTurns}}</p></md-card-content-text></md-card-content></md-card><md-card><md-card-title><md-card-title-text><p class=md-headline>{{\'app.statistics.ATTENDED_TURNS\'|translate}}</p></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-headline>{{$ctrl.attendedTurns}}</p></md-card-content-text></md-card-content></md-card><md-card><md-card-title><md-card-title-text><p class=md-headline>{{\'app.statistics.WAITING_TURNS\'|translate}}</p></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-headline>{{$ctrl.waitingTurns}}</p></md-card-content-text></md-card-content></md-card><md-card><md-card-title><md-card-title-text><p class=md-headline>{{\'app.statistics.MISSING_TURNS\'|translate}}</p></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-headline>{{$ctrl.missingTurns}}</p></md-card-content-text></md-card-content></md-card><md-card><md-card-title><md-card-title-text><p class=md-headline>{{\'app.statistics.MANUAL_TURNS\'|translate}}</p></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-headline>{{$ctrl.manualTurns}}</p></md-card-content-text></md-card-content></md-card><md-card><md-card-title><md-card-title-text><p class=md-headline>{{\'app.statistics.RESENT_TURNS\'|translate}}</p></md-card-title-text></md-card-title><md-card-content><md-card-content-text><p class=md-headline>{{$ctrl.resentTurns}}</p></md-card-content-text></md-card-content></md-card></div></md-card-content></md-card></div></div><div class=statistics-content layout-gt-sm=row layout=row layout-wrap ng-hide=!$ctrl.establishmentId><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.ATTENDING_TIME\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.attending_time.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.attending_time.data chart-labels=$ctrl.attending_time.labels chart-series=$ctrl.attending_time.series chart-click="onClick " chart-options=$ctrl.time_options></canvas><div class=message ng-show="(!$ctrl.attending_time.activated &amp;&amp; $ctrl.attending_time.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.attending_time.activated &amp;&amp; $ctrl.attending_time.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.attending_time.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.WAITING_TIME\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.waiting_time.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.waiting_time.data chart-labels=$ctrl.waiting_time.labels chart-series=$ctrl.waiting_time.series chart-click="onClick " chart-options=$ctrl.time_options></canvas><div class=message ng-show="(!$ctrl.waiting_time.activated &amp;&amp; $ctrl.waiting_time.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.waiting_time.activated &amp;&amp; $ctrl.waiting_time.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.waiting_time.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.QUEUES_USER\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.queues_user.activated></md-progress-circular></div><canvas class="chart chart-bar" chart-data=$ctrl.queues_user.data chart-labels=$ctrl.queues_user.labels chart-series=$ctrl.queues_user.series chart-click=onClick chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.queues_user.activated &amp;&amp; $ctrl.queues_user.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.queues_user.activated &amp;&amp; $ctrl.queues_user.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.queues_user.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_USER\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.clients_user.activated></md-progress-circular></div><canvas class="chart chart-bar" chart-data=$ctrl.clients_user.data chart-labels=$ctrl.clients_user.labels chart-series=$ctrl.clients_user.series chart-click=onClick chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.clients_user.activated &amp;&amp; $ctrl.clients_user.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.clients_user.activated &amp;&amp; $ctrl.clients_user.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.clients_user.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_ATTENDED\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.clients_attended_queue.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.clients_attended_queue.data chart-labels=$ctrl.clients_attended_queue.labels chart-series=$ctrl.clients_attended_queue.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.clients_attended_queue.activated &amp;&amp; $ctrl.clients_attended_queue.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.clients_attended_queue.activated &amp;&amp; $ctrl.clients_attended_queue.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.clients_attended.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_ABSENT\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.clients_absent.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.clients_absent.data chart-labels=$ctrl.clients_absent.labels chart-series=$ctrl.clients_absent.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.clients_absent.activated &amp;&amp; $ctrl.clients_absent.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.clients_absent.activated &amp;&amp; $ctrl.clients_absent.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.clients_absent.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_SPECIAL\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.clients_special.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.clients_special.data chart-labels=$ctrl.clients_special.labels chart-series=$ctrl.clients_special.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.clients_special.activated &amp;&amp; $ctrl.clients_special.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.clients_special.activated &amp;&amp; $ctrl.clients_special.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.clients_special.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=50><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_RESENT\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.clients_resent.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.clients_resent.data chart-labels=$ctrl.clients_resent.labels chart-series=$ctrl.clients_resent.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.clients_resent.activated &amp;&amp; $ctrl.clients_resent.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.clients_resent.activated &amp;&amp; $ctrl.clients_resent.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.clients_resent.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><div flex=100 ng-hide=true><table id=datatableXLX ng-bind-html=$ctrl.table></table></div></div></div>');
$templateCache.put('app/modules/admin/statistics/comparative/comparative.html','<div id=statistics-container><div layout-gt-sm=row layout=row layout-wrap ng-hide=!$ctrl.establishmentId><!-- Date search--><div class=comparative-charts flex=100><div class=selectDateRange><div><label>{{\'app.statistics.START_DATE\'|translate}}</label><md-datepicker ng-model=$ctrl.fromDate name=dateField md-max-date=$ctrl.rangeMaxDate></md-datepicker></div><div><label>{{\'app.statistics.END_DATE\'|translate}}</label><md-datepicker ng-model=$ctrl.toDate name=dateField md-min-date=ctrl.fromDate md-max-date=ctrl.rangeMaxDate></md-datepicker><md-button class="md-fab search" aria-label="Search data" ng-click=$ctrl.search()><md-icon>search</md-icon></md-button></div></div></div><!-- Center 1--><div class=statistics-content flex=50><div class="selectEstablishment first" ng-if=$ctrl.allowSelectRoles(5)><h2><form name=selectEstablishmentForm><md-input-container md-no-float><label>{{\'app.statistics.SELECT_CENTER\'|translate}} - 1</label><md-select id=center name=center ng-model=$ctrl.establishmentSelected_first ng-change="$ctrl.establishmentChanged($ctrl.establishmentSelected_first, \'first\')"><md-option value="{{ establishment }}" ng-repeat="establishment in $ctrl.establishments">{{ establishment.name }} {{ establishment.addressFirstLine }}</md-option></md-select></md-input-container><span ng-show=$ctrl.establishmentInUse>{{ $ctrl.establishmentInUse }}</span></form></h2></div><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.ATTENDING_TIME\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.comparativesWithTypes.first.attending_time.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.comparativesWithTypes.first.attending_time.data chart-labels=$ctrl.comparativesWithTypes.first.attending_time.labels chart-series=$ctrl.comparativesWithTypes.first.attending_time.series chart-click="onClick " chart-options=$ctrl.time_options></canvas><div class=message ng-show="(!$ctrl.comparativesWithTypes.first.attending_time.activated &amp;&amp; $ctrl.comparativesWithTypes.first.attending_time.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.comparativesWithTypes.first.attending_time.activated &amp;&amp; $ctrl.comparativesWithTypes.first.attending_time.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.comparativesWithTypes.first.attending_time.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.WAITING_TIME\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.comparativesWithTypes.first.waiting.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.comparativesWithTypes.first.waiting.data chart-labels=$ctrl.comparativesWithTypes.first.waiting.labels chart-series=$ctrl.comparativesWithTypes.first.waiting.series chart-click="onClick " chart-options=$ctrl.time_options></canvas><div class=message ng-show="(!$ctrl.comparativesWithTypes.first.waiting.activated &amp;&amp; $ctrl.comparativesWithTypes.first.waiting.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.comparativesWithTypes.first.waiting.activated &amp;&amp; $ctrl.comparativesWithTypes.first.waiting.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.comparativesWithTypes.first.waiting.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_ATTENDED\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.comparativesWithTypes.first.clients_attended.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.comparativesWithTypes.first.clients_attended.data chart-labels=$ctrl.comparativesWithTypes.first.clients_attended.labels chart-series=$ctrl.comparativesWithTypes.first.clients_attended.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.comparativesWithTypes.first.clients_attended.activated &amp;&amp; $ctrl.comparativesWithTypes.first.clients_attended.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.comparativesWithTypes.first.clients_attended.activated &amp;&amp; $ctrl.comparativesWithTypes.first.clients_attended.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.comparativesWithTypes.first.clients_attended.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_ABSENT\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.comparativesWithTypes.first.clients_absent.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.comparativesWithTypes.first.clients_absent.data chart-labels=$ctrl.comparativesWithTypes.first.clients_absent.labels chart-series=$ctrl.comparativesWithTypes.first.clients_absent.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.comparativesWithTypes.first.clients_absent.activated &amp;&amp; $ctrl.comparativesWithTypes.first.clients_absent.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.comparativesWithTypes.first.clients_absent.activated &amp;&amp; $ctrl.comparativesWithTypes.first.clients_absent.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.comparativesWithTypes.first.clients_absent.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_SPECIAL\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.comparativesWithTypes.first.clients_special.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.comparativesWithTypes.first.clients_special.data chart-labels=$ctrl.comparativesWithTypes.first.clients_special.labels chart-series=$ctrl.comparativesWithTypes.first.clients_special.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.comparativesWithTypes.first.clients_special.activated &amp;&amp; $ctrl.comparativesWithTypes.first.clients_special.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.comparativesWithTypes.first.clients_special.activated &amp;&amp; $ctrl.comparativesWithTypes.first.clients_special.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.comparativesWithTypes.first.clients_special.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div><!-- Center 2--><div class=statistics-content flex=50><div class="selectEstablishment second" ng-if=$ctrl.allowSelectRoles(5)><h2><form name=selectEstablishmentForm><md-input-container md-no-float><label>{{\'app.statistics.SELECT_CENTER\'|translate}} - 2</label><md-select id=center name=center ng-model=$ctrl.establishmentSelected_second ng-change="$ctrl.establishmentChanged($ctrl.establishmentSelected_second, \'second\')"><md-option value="{{ establishment }}" ng-repeat="establishment in $ctrl.establishments">{{ establishment.name }} {{ establishment.addressFirstLine }}</md-option></md-select></md-input-container><span ng-show=$ctrl.establishmentInCompare>{{ $ctrl.establishmentInCompare }}</span></form></h2></div><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.ATTENDING_TIME\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.comparativesWithTypes.second.attending_time.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.comparativesWithTypes.second.attending_time.data chart-labels=$ctrl.comparativesWithTypes.second.attending_time.labels chart-series=$ctrl.comparativesWithTypes.second.attending_time.series chart-click="onClick " chart-options=$ctrl.time_options></canvas><div class=message ng-show="(!$ctrl.comparativesWithTypes.second.attending_time.activated &amp;&amp; $ctrl.comparativesWithTypes.second.attending_time.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.comparativesWithTypes.second.attending_time.activated &amp;&amp; $ctrl.comparativesWithTypes.second.attending_time.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.comparativesWithTypes.second.attending_time.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.WAITING_TIME\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.comparativesWithTypes.second.waiting.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.comparativesWithTypes.second.waiting.data chart-labels=$ctrl.comparativesWithTypes.second.waiting.labels chart-series=$ctrl.comparativesWithTypes.second.waiting.series chart-click="onClick " chart-options=$ctrl.time_options></canvas><div class=message ng-show="(!$ctrl.comparativesWithTypes.second.waiting.activated &amp;&amp; $ctrl.comparativesWithTypes.second.waiting.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.comparativesWithTypes.second.waiting.activated &amp;&amp; $ctrl.comparativesWithTypes.second.waiting.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.comparativesWithTypes.second.waiting.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_ATTENDED\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.comparativesWithTypes.second.clients_attended.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.comparativesWithTypes.second.clients_attended.data chart-labels=$ctrl.comparativesWithTypes.second.clients_attended.labels chart-series=$ctrl.comparativesWithTypes.second.clients_attended.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.comparativesWithTypes.second.clients_attended.activated &amp;&amp; $ctrl.comparativesWithTypes.second.clients_attended.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.comparativesWithTypes.second.clients_attended.activated &amp;&amp; $ctrl.comparativesWithTypes.second.clients_attended.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.comparativesWithTypes.second.clients_attended.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_ABSENT\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.comparativesWithTypes.second.clients_absent.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.comparativesWithTypes.second.clients_absent.data chart-labels=$ctrl.comparativesWithTypes.second.clients_absent.labels chart-series=$ctrl.comparativesWithTypes.second.clients_absent.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.comparativesWithTypes.second.clients_absent.activated &amp;&amp; $ctrl.comparativesWithTypes.second.clients_absent.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.comparativesWithTypes.second.clients_absent.activated &amp;&amp; $ctrl.comparativesWithTypes.second.clients_absent.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.comparativesWithTypes.second.clients_absent.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><span class=md-headline>{{\'app.statistics.CLIENTS_SPECIAL\'|translate}}</span></md-card-title-text></md-card-title><md-card-content><div layout=row layout-align=space-around><md-progress-circular md-mode=indeterminate ng-show=$ctrl.comparativesWithTypes.second.clients_special.activated></md-progress-circular></div><canvas class="chart chart-line" chart-data=$ctrl.comparativesWithTypes.second.clients_special.data chart-labels=$ctrl.comparativesWithTypes.second.clients_special.labels chart-series=$ctrl.comparativesWithTypes.second.clients_special.series chart-click="onClick " chart-options=$ctrl.number_options></canvas><div class=message ng-show="(!$ctrl.comparativesWithTypes.second.clients_special.activated &amp;&amp; $ctrl.comparativesWithTypes.second.clients_special.no_data) || $ctrl._showMessageError"><p ng-show="!$ctrl.comparativesWithTypes.second.clients_special.activated &amp;&amp; $ctrl.comparativesWithTypes.second.clients_special.no_data">{{\'app.statistics.NO_DATA\'|translate}}</p><p class=chart-error ng-show="!$ctrl.comparativesWithTypes.second.clients_special.activated &amp;&amp; $ctrl._showMessageError">{{\'app.statistics.NO_DATA_ERROR\'|translate}}</p></div></md-card-content></md-card></div></div></div>');
$templateCache.put('app/modules/admin/statistics/new-statistics/new-statistics.html','<div id=statistics-container><iframe src={{$ctrl.new_front}} id=myIframe width=100% style="height: 100vh; border:none"></iframe></div>');}]);